/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 16);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = (window._g && _g.$) || window.$CQ || window.$ || window.jQuery;

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./clientlibs/js/lib/vendor/terrific/config.ts
/**
 * Contains the application base config.
 * The base config can be extended or overwritten either via
 * new Application ($ctx, config) during bootstrapping the application or via
 * overriding the Tc.Config object in your project.
 *
 * @author Remo Brunschwiler
 * @namespace Tc
 * @class Config
 * @static
 */
var config = {
    /**
     * The paths for the different types of dependencies.
     *
     * @property dependencies
     * @type Object
     */
    dependencies: {
        css: '/css/dependencies',
        js: '/js/dependencies',
    },
    debug: false,
};

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(2);

// EXTERNAL MODULE: external "(window._g && _g.$) || window.$CQ || window.$ || window.jQuery"
var external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_ = __webpack_require__(0);
var external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default = /*#__PURE__*/__webpack_require__.n(external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_);

// EXTERNAL MODULE: ./clientlibs/js/lib/vendor/terrific/Sandbox.ts
var Sandbox = __webpack_require__(38);

// CONCATENATED MODULE: ./clientlibs/js/lib/vendor/terrific/Connector.ts
var Connector = /** @class */ (function () {
    /**
     * Initializes the Connector.
     *
     * @method init
     * @constructor
     * @param {String} connectorId
     *      The unique connector ID
     */
    function Connector(connectorId) {
        this.components = {};
        this.connectorId = connectorId;
    }
    /**
     * Registers a component.
     *
     * @method registerComponent
     * @param {Module} component
     *      The module to register
     */
    Connector.prototype.registerComponent = function (component) {
        this.components[component.id] = { component: component };
    };
    /**
     * Unregisters a component.
     *
     * @method unregisterComponent
     * @param {Module} component
     *      The module to unregister
     */
    Connector.prototype.unregisterComponent = function (component) {
        var components = this.components;
        if (components[component.id]) {
            // tslint:disable-next-line:no-dynamic-delete
            delete components[component.id];
        }
    };
    /**
     * Notifies all registered components about a state change
     * This can be be overriden in the specific connectors.
     *
     * @method notify
     * @param {Module} origin
     *      The module that sends the state change
     * @param {String} state
     *      The component's state
     * @param {Object} data
     *      Contains the state relevant data (if any)
     * @return {boolean}
     *      Indicates whether the default action should be excuted or not
     */
    Connector.prototype.notify = function (origin, state, data) {
        /*
         * Gives the components the ability to prevent the default- and
         * after action from the events by returning false in the
         * on {Event}-Handler.
         */
        var proceed = true;
        var components = this.components;
        for (var id in components) {
            var component = components[id].component;
            if (component === origin) {
                continue;
            }
            var callback = component[state];
            if (!callback) {
                continue;
            }
            var result = !!callback.call(component, data);
            if (!result) {
                proceed = false;
            }
        }
        return proceed;
    };
    return Connector;
}());


// EXTERNAL MODULE: ./clientlibs/js/lib/vendor/terrific/utils/string.ts
var string = __webpack_require__(7);

// EXTERNAL MODULE: ./clientlibs/js/lib/vendor/terrific/Module.ts
var Module = __webpack_require__(5);

// CONCATENATED MODULE: ./clientlibs/js/lib/vendor/terrific/utils/extend.ts


var extend = function (moduleDefinition) {
    var SubModule = /** @class */ (function (_super_1) {
        Object(tslib_es6["c" /* __extends */])(SubModule, _super_1);
        function SubModule($ctx, sandbox, id, modName) {
            var _this = _super_1.call(this, $ctx, sandbox, id, modName) || this;
            // Legacy compatibility:
            // Call `init` (the constructor from “Base”)
            _this.init($ctx, sandbox, id);
            return _this;
        }
        SubModule.prototype._super = function (_$ctx, _sandbox, _id) {
            // Make sure a _super call from an overridden `init` does not call the super constructor again
            this.log.info('call to _super ignored on legacy module');
        };
        // tslint:disable-next-line:prefer-function-over-method
        SubModule.prototype.init = function (_$ctx, _sandbox, _id) {
            // May be overridden
        };
        return SubModule;
    }(Module["a" /* Module */]));
    // Extend the new module with the properties and methods from the definition
    Object.assign(SubModule.prototype, moduleDefinition);
    return SubModule;
};
function mergeRegistries(target) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    for (var _a = 0, sources_1 = sources; _a < sources_1.length; _a++) {
        var sourceRegistry = sources_1[_a];
        // Merge two registries
        for (var moduleName in sourceRegistry) {
            var sourceDefinition = sourceRegistry[moduleName];
            if (moduleName in target) {
                var targetDefinition = target[moduleName];
                if (targetDefinition.module &&
                    sourceDefinition.module &&
                    targetDefinition.module !== sourceDefinition.module) {
                    // Module exists in both registries
                    window.debug.error("Tc.Module." + moduleName + " has conflicting implementations. Replacing.", targetDefinition.module, 'with', sourceDefinition.module);
                }
                else if (targetDefinition.module) {
                    // Module is defined only in target, not in source
                    sourceDefinition.module = targetDefinition.module;
                }
                // Merge all skins (ignore duplicates for now)
                // Source has precedence
                sourceDefinition.skins = Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, targetDefinition.skins), sourceDefinition.skins);
            }
            target[moduleName] = sourceDefinition;
        }
    }
    return target;
}

// EXTERNAL MODULE: ./clientlibs/js/lib/util/url.ts + 1 modules
var url = __webpack_require__(4);

// CONCATENATED MODULE: ./clientlibs/js/lib/vendor/terrific/Application.ts








function transformRegistryToFull(registry) {
    var result = {};
    for (var moduleName in registry) {
        var definitionOrModule = registry[moduleName];
        if (typeof definitionOrModule === 'function') {
            result[moduleName] = {
                module: definitionOrModule,
                skins: {},
            };
        }
        else {
            result[moduleName] = {
                module: definitionOrModule.module,
                skins: definitionOrModule.skins || {},
            };
        }
    }
    return result;
}
/**
 * Responsible for application-wide issues such as the creation of modules and establishing connections between them.
 *
 * @author Remo Brunschwiler
 * @namespace Tc
 * @class Application
 */
var Application_Application = /** @class */ (function () {
    /**
     * Initializes the application.
     *
     * @method init
     * @constructor
     * @param {jQuery} $ctx
     *      The jQuery context
     * @param {Object} config
     *      The configuration
     */
    function Application($ctx, cfg, registry, connectorTypes) {
        if (cfg === void 0) { cfg = {}; }
        if (registry === void 0) { registry = {}; }
        if (connectorTypes === void 0) { connectorTypes = {}; }
        /**
         * Contains references to all modules on the page. This can, for
         * example, be useful when there are interactions between Flash
         * objects and Javascript.
         *
         * @property modules
         * @type Array
         */
        this.modules = [];
        /**
         * Associates modules that are hash-capable with their IDs.
         */
        this.hashCapableModules = {};
        /**
         * Contains references to all connectors on the page.
         *
         * @property connectors
         * @type Object
         */
        this.connectors = {};
        this.config = Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, config), cfg);
        this.$ctx = $ctx || external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_('body');
        this.connectors = {};
        this.sandbox = new Sandbox["a" /* Sandbox */](this, this.config);
        this.registry = Object(tslib_es6["a" /* __assign */])({}, transformRegistryToFull(registry));
        this.connectorTypes = Object(tslib_es6["a" /* __assign */])({}, connectorTypes);
    }
    /**
     * Allows to amend the registry of known modules.
     * @param registry The registry to merge into the current one
     */
    // Modified by Swisscom (Raphael Schweikert, taascraa): add ability to register modules after initialization
    Application.prototype.amendRegistry = function (registry) {
        mergeRegistries(this.registry, transformRegistryToFull(registry));
    };
    /**
     * Register modules withing scope
     * Automatically registers all modules within the scope,
     * as long as the modules use the OOCSS naming conventions.
     *
     * @method registerModules
     * @param {jQuery} $ctx
     *      The jQuery context
     * @return {Array}
     *      A list containing the references of the registered modules
     */
    // Modified by Swisscom (Raphael Schweikert, taascraa): add ability to have multiple modules on a single element
    Application.prototype.registerModules = function ($ctx) {
        var _this = this;
        if ($ctx === void 0) { $ctx = this.$ctx; }
        var modules = [];
        // Modified by Swisscom (Dave Talamona, tzhtada2):
        // [1. performance improvement by excluding the NOT from the initial query]
        // [2. descendants of a container with attribute "data-ignore-descendants" are not initialized]
        var $candidates = $ctx.find('.mod')
            .add($ctx.hasClass('mod') ? $ctx : external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_())
            .not('[data-ignore="true"], [data-ignore-descendants="true"] *');
        $candidates.each(function (_, elem) {
            var $elem = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_(elem);
            // Modified by Swisscom (Dave Talamona, tzhtada2):
            // Modules with newlines or tabs in class attribute were not detected as a modules (classes.length was 1)
            var classes = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_["trim"]($elem.attr('class') || '').split(/\s+/);
            /*
             * A module can have several different classes and data attributes.
             * See below for possible values.
             */
            /*
             * @config .mod
             *
             * Indicates that it is a base module, this is the default and
             * no JavaScript needs to be involved. It must occur excactly
             * once.
             */
            /*
             * @config .mod{moduleName} || .mod-{module-name}
             *
             * Indicates that it is a module of type basic, which is
             * derived from the base module. It can occur at most
             * once. Example: .modBasic || .mod-basic
             */
            /*
             * @config .skin{moduleName}{skinName} || .skin-{module-name}-{skin-name}
             *
             * Indicates that the module basic has the submarine skin. It
             * will be decorated by the skin JS (if it exists). It can occur
             * arbitrarily. Example: .skinBasicSubmarine || .skin-basic-submarine
             */
            /*
             * @config data-connectors
             *
             * A module can have a comma-separated list of data connectors.
             * The list contains the IDs of the connectors in the following
             * schema: {connectorType}-{connectorId}
             *
             * {connectorType} is optional. If only the {connectorId} is given, the
             * default connector is instantiated.
             *
             * The example MasterSlave-Navigation decodes to: type =
             * MasterSlave, id = Navigation. This instantiates the MasterSlave
             * connector (as mediator) with the connector id Navigation.
             * The connector id is used to chain the appropriate (the ones with the same id)
             * modules together and to improve the reusability of the connector.
             * It can contain multiple connector ids (e.g. 1,2,MasterSlave-Navigation).
             */
            if (classes.length <= 1) {
                return;
            }
            /*
             * This needs to be done via attr() instead of data().
             * As data() cast a single number-only connector to an integer, the split will fail.
             */
            var connectorParts = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_["trim"]($elem.attr('data-connectors') || '').split(/\s*,\s*/);
            // Do nothing for empty connectors
            var connectors = connectorParts.filter(Boolean);
            var classesNormalized = classes
                .filter(Boolean)
                .map(function (part) {
                if (part.indexOf('-') > -1) {
                    part = Object(string["b" /* toCamel */])(part);
                }
                return part;
            });
            var modNames = classesNormalized
                .filter(function (part) { return part.indexOf('mod') === 0 && part.length > 3; })
                .map(function (part) { return part.substr(3); })
                .filter(function (modName) { return modName in _this.registry; });
            var _loop_1 = function (modName) {
                var definition = _this.registry[modName];
                var skinRegistry = definition.skins;
                // Get skins for module
                var skins = classesNormalized
                    .filter(function (part) {
                    return part.indexOf("skin" + modName) === 0;
                })
                    .map(function (skinClass) { return skinClass.substr('skin'.length + modName.length); })
                    .map(function (skinName) { return skinRegistry[skinName]; })
                    .filter(Boolean);
                var module = _this.registerModule($elem, definition.module, modName, skins, connectors);
                if (module) {
                    modules.push(module);
                }
            };
            for (var _i = 0, modNames_1 = modNames; _i < modNames_1.length; _i++) {
                var modName = modNames_1[_i];
                _loop_1(modName);
            }
        });
        return modules;
    };
    /**
     * Registers a module.
     *
     * @method registerModule
     * @param {jQuery} $node
     *      The module node
     * @param {String} modName
     *      The module name. It must match the class name of the module
     * @param {Array} skins
     *      A list of skin names. Each entry must match a class name of a skin
     * @param {Array} connectors
     *      A list of connectors identifiers (e.g. MasterSlave-Navigation)
     *      Schema: {connectorName}-{connectorId}
     * @return {Module}
     *      The reference to the registered module
     */
    Application.prototype.registerModule = function ($node, module, // Actually typeof T but that would need an extra definition
    modName, skins, connectors) {
        var modules = this.modules;
        skins = skins || [];
        connectors = connectors || [];
        // Generate a unique ID for every module
        var id = modules.length;
        // Modified by Raphael Schweikert (taascraa): add ability to have multiple modules on a single element
        var ids = $node.data('terrific-ids') || {};
        $node.data('terrific-ids', ids);
        // Modified by Dave Talamona (tzhtada2): modules must not be initialized twice
        if (modName in ids) {
            return null;
        }
        ids[modName] = id;
        // Instantiate module
        modules[id] = new module($node, this.sandbox, id, modName);
        // Added by Swisscom (Raphael Schweikert, taascraa)
        modules[id].modName = modName;
        // Decorate it
        for (var _i = 0, skins_1 = skins; _i < skins_1.length; _i++) {
            var skin = skins_1[_i];
            modules[id] = modules[id].getDecoratedModule(skin);
        }
        // Register connections
        for (var i = 0, len = (connectors || []).length; i < len; i++) {
            this.registerConnection(connectors[i], modules[id]);
        }
        return modules[id];
    };
    /**
     * Registers a connection between a module and a connector.
     *
     * @method registerConnection
     * @param {String} connector
     *      The full connector name (e.g. MasterSlave-Navigation)
     * @param {Module} component
     *      The module instance
     */
    Application.prototype.registerConnection = function (connector, component) {
        connector = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_["trim"](connector);
        var parts = connector.split('-');
        var connectorType;
        var connectorId;
        var identifier;
        if (parts.length === 1) {
            // Default connector
            identifier = connectorId = parts[0];
        }
        else if (parts.length === 2) {
            // A specific connector type is given
            connectorType = parts[0];
            connectorId = parts[1];
            identifier = connectorType + connectorId;
        }
        else {
            return;
        }
        if (!identifier) {
            return;
        }
        var connectors = this.connectors;
        if (!connectors[identifier]) {
            var registry = this.connectorTypes;
            var ctor = Connector;
            if (connectorType && connectorType in registry) {
                ctor = registry[connectorType];
            }
            connectors[identifier] = new ctor(connectorId);
        }
        if (!(identifier in connectors)) {
            return;
        }
        /*
         * The connector observes the component and attaches it as
         * an observer.
         */
        component.attachConnector(connectors[identifier]);
        /*
         * The component wants to be informed over state changes.
         * It registers it as connector member.
         */
        connectors[identifier].registerComponent(component);
    };
    /**
     * Unregisters the modules given by the module instances.
     *
     * @method unregisterModules
     * @param {Array} modules
     *      A list containing the module instances to unregister
     */
    Application.prototype.unregisterModules = function (modules) {
        if (modules === void 0) { modules = this.modules; }
        var connectors = this.connectors;
        // Unregister the given modules
        for (var _i = 0, modules_1 = modules; _i < modules_1.length; _i++) {
            var module = modules_1[_i];
            // Delete the references in the connectors
            for (var connectorId in connectors) {
                if (connectors.hasOwnProperty(connectorId)) {
                    connectors[connectorId].unregisterComponent(module);
                }
            }
            // Delete the module instance itself
            var index = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_["inArray"](module, this.modules);
            if (index > -1) {
                try {
                    // Modified by Swisscom (Dave Talamona, tzhtada2):
                    // Clear module id when unregistering it so that it can be initialized again
                    var ids = module.$ctx.data('terrific-ids') || {};
                    // tslint:disable-next-line:no-dynamic-delete
                    delete ids[module.modName];
                }
                catch (e) { }
                // tslint:disable-next-line:no-dynamic-delete
                delete this.modules[index];
                if (module.id in this.hashCapableModules) {
                    this.hashCapableModules[module.id] = undefined;
                }
            }
        }
    };
    /**
     * Registers a hook that is called at the end.
     *
     * @method end
     * @param {Function} hook
     * 		The hook function to be executed
     */
    Application.prototype.end = function (hook) {
        this.sandbox.addCallback('end', hook);
    };
    /**
     * Starts (intializes) the registered modules.
     *
     * @method start
     * @param {Array} modules
     *      A list of the modules to start
     */
    Application.prototype.start = function (modules) {
        if (modules === void 0) { modules = this.modules; }
        // Start the modules
        for (var _i = 0, modules_2 = modules; _i < modules_2.length; _i++) {
            var module = modules_2[_i];
            module.start();
            this.initHashHandlingForModule(module);
        }
        this.initHashHandling();
    };
    /**
     * Stops the registered modules.
     *
     * @method stop
     * @param {Array} modules
     *      A list containing the module instances to stop
     */
    Application.prototype.stop = function (modules) {
        if (modules === void 0) { modules = this.modules; }
        // Stop the modules
        for (var _i = 0, modules_3 = modules; _i < modules_3.length; _i++) {
            var module = modules_3[_i];
            module.stop();
        }
    };
    /**
     * Unregisters a module from a connector.
     *
     * @method unregisterConnection
     * @param {String} connectorId
     *      The connector channel id (e.g. 2)
     * @param {Module} component
     *      The module instance
     */
    Application.prototype.unregisterConnection = function (connectorId, component) {
        var connector = this.connectors[connectorId];
        // Delete the references in the connector and the module
        if (connector) {
            connector.unregisterComponent(component);
            component.detachConnector(connector);
        }
    };
    Application.prototype.initHashHandlingForModule = function (module) {
        var _this = this;
        if (!module.moduleStateChanged) {
            return;
        }
        var hashKeyConfigured = module.hashKey;
        // Make hashKey unique
        var hashKey = hashKeyConfigured;
        var index = 0;
        var existing;
        do {
            existing = Object.keys(this.hashCapableModules)
                .map(function (id) { return _this.hashCapableModules[Number(id)]; })
                .filter(Boolean)
                .map(function (mod) { return mod.hashKey; })
                .find(function (key) { return key === hashKey; });
            if (existing) {
                index++;
                hashKey = hashKeyConfigured + index;
            }
        } while (existing);
        module.hashKey = hashKey;
        this.hashCapableModules[module.id] = module;
    };
    Application.prototype.setModuleStatesFromHash = function () {
        for (var moduleId in this.hashCapableModules) {
            var module = this.hashCapableModules[moduleId];
            if (!module) {
                continue;
            }
            var hashKey = module.hashKey;
            var state = Object(url["readStateFromHash"])(hashKey);
            if (state !== undefined) {
                module.moduleStateChanged(state);
            }
        }
    };
    Application.prototype.initHashHandling = function () {
        if (!Object.keys(this.hashCapableModules).length) {
            return;
        }
        external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_(window).on('hashchange', this.setModuleStatesFromHash.bind(this));
        this.setModuleStatesFromHash();
    };
    return Application;
}());


// CONCATENATED MODULE: ./clientlibs/js/lib/vendor/terrific/utils/bootstrap.ts

function bootstrapTerrific($page, modules, debug, connectors) {
    if (debug === void 0) { debug = false; }
    var app = new Application_Application($page, {
        debug: debug,
    }, modules, connectors);
    return app;
}

// EXTERNAL MODULE: ./clientlibs/js/lib/util/helpers.ts
var helpers = __webpack_require__(3);

// CONCATENATED MODULE: ./clientlibs/js/bootstrap/load-terrific.ts
/* harmony export (immutable) */ __webpack_exports__["legacyRegistryToModern"] = legacyRegistryToModern;
/* harmony export (immutable) */ __webpack_exports__["createLegacyRegistry"] = createLegacyRegistry;
/* harmony export (immutable) */ __webpack_exports__["legacyBootstrapDeferred"] = legacyBootstrapDeferred;
/* harmony export (immutable) */ __webpack_exports__["legacyBootstrapDeferredSingleton"] = legacyBootstrapDeferredSingleton;






function legacyRegistryToModern(legacyRegistry) {
    var registry = {};
    for (var moduleName in legacyRegistry) {
        var mod = legacyRegistry[moduleName];
        var regEntry = {
            module: mod,
            skins: {},
        };
        for (var skinName in mod) {
            var skin = mod[skinName];
            // tslint:disable-next-line:strict-type-predicates
            if (typeof skin !== 'function' || !/^[A-Z0-9]$/.test(skinName[0])) {
                continue;
            }
            // We could use `delete mod[skinName]` here but it might remove too much
            // (if some non-skin functions are exported on the Module constructor)
            // Add the skin to the skin registry
            regEntry.skins[skinName] = skin;
        }
        registry[moduleName] = regEntry;
    }
    return registry;
}
function bootstrapWithLegacy($page, modernRegistry, legacyRegistry, debug) {
    if ($page === void 0) { $page = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_('html'); }
    if (modernRegistry === void 0) { modernRegistry = {}; }
    if (legacyRegistry === void 0) { legacyRegistry = Tc.Module; }
    if (debug === void 0) { debug = !!(window.location.search + window.location.hash).match(/\bdevconsole\b/); }
    // Merge legacy and modern registries
    var registry = mergeRegistries(legacyRegistryToModern(legacyRegistry), transformRegistryToFull(modernRegistry));
    return bootstrapTerrific($page, registry, debug);
}
function createLegacyRegistry() {
    var registry = {
        get extend() {
            return extend;
        },
    };
    Object.defineProperty(registry, 'extend', { enumerable: false });
    return registry;
}
function resetLegacyRegistry(registry) {
    var result = createLegacyRegistry();
    for (var module in registry) {
        result[module] = registry[module];
        // tslint:disable-next-line:no-dynamic-delete
        delete registry[module];
    }
    return result;
}
function amendModulesSinceInit(application, legacyRegistry, initialRegistry) {
    if (application === void 0) { application = window.application; }
    if (legacyRegistry === void 0) { legacyRegistry = Tc.Module; }
    if (initialRegistry === void 0) { initialRegistry = null; }
    application.amendRegistry(legacyRegistryToModern(legacyRegistry));
    if (!initialRegistry) {
        return;
    }
    Object.assign(initialRegistry, resetLegacyRegistry(legacyRegistry));
}
function legacyBootstrapDeferred(modernRegistry, $page, legacyRegistry) {
    if (modernRegistry === void 0) { modernRegistry = {}; }
    if ($page === void 0) { $page = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_('html'); }
    if (legacyRegistry === void 0) { legacyRegistry = Tc.Module; }
    var application = bootstrapWithLegacy($page, modernRegistry, legacyRegistry);
    // Reset the registry for the next round
    var initialRegistry = resetLegacyRegistry(legacyRegistry);
    // Shim addModules to take modules into account that were added to the registry after initialization
    // Previously, these were added automatically because Tc would not clone the registry it was given.
    // tslint:disable-next-line:no-unbound-method
    var origAddModules = application.sandbox.addModules;
    application.sandbox.addModules = function addModules($ctx) {
        amendModulesSinceInit(application, legacyRegistry, initialRegistry);
        return origAddModules.call(this, $ctx);
    };
    external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_(function () {
        application.sandbox.addModules = origAddModules;
        amendModulesSinceInit(application, legacyRegistry, initialRegistry);
        // Put back all modules onto initial registry (probably Tc.Module)
        Object.assign(legacyRegistry, initialRegistry);
        // Initialize the modules.
        Object(helpers["initNewModules"])($page);
    });
    return [application, initialRegistry];
}
// Variant of legacyBootstrapDeferred that only calls legacyBootstrapDeferred once but still adds modules.
var applicationSingleton = null;
var initialRegistrySingleton;
function legacyBootstrapDeferredSingleton(modernRegistry) {
    var _a;
    if (modernRegistry === void 0) { modernRegistry = {}; }
    if (window.application && window.application.sandbox) {
        applicationSingleton = window.application;
    }
    if (applicationSingleton) {
        // Amend the passed modules
        applicationSingleton.amendRegistry(modernRegistry);
        // Amend the modules that have since been registered on Tc.Module
        amendModulesSinceInit(applicationSingleton, Tc.Module, initialRegistrySingleton);
        return applicationSingleton;
    }
    _a = legacyBootstrapDeferred(modernRegistry, undefined, Tc.Module), applicationSingleton = _a[0], initialRegistrySingleton = _a[1];
    window.application = applicationSingleton;
    return applicationSingleton;
}
// tslint:disable-next-line:variable-name
var Tc = {
    $: external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_,
    Application: Application_Application,
    Config: config,
    Module: createLegacyRegistry(),
};
window.Tc = Tc;
/* harmony default export */ var load_terrific = __webpack_exports__["default"] = (Tc);


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __esDecorate */
/* unused harmony export __runInitializers */
/* unused harmony export __propKey */
/* unused harmony export __setFunctionName */
/* unused harmony export __metadata */
/* harmony export (immutable) */ __webpack_exports__["b"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["d"] = __generator;
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* unused harmony export __spreadArrays */
/* harmony export (immutable) */ __webpack_exports__["e"] = __spreadArray;
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/* unused harmony export __classPrivateFieldIn */
/* unused harmony export __addDisposableResource */
/* unused harmony export __disposeResources */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};

function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};

function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({ value: value, dispose: dispose, async: async });
    }
    else if (async) {
        env.stack.push({ async: true });
    }
    return value;
}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while (env.stack.length) {
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
            }
            catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}

/* unused harmony default export */ var _unused_webpack_default_export = ({
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources,
});


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["isMobilePage"] = isMobilePage;
/* harmony export (immutable) */ __webpack_exports__["isEditMode"] = isEditMode;
/* harmony export (immutable) */ __webpack_exports__["zeroFill"] = zeroFill;
/* harmony export (immutable) */ __webpack_exports__["getUniqueIdOfElement"] = getUniqueIdOfElement;
/* harmony export (immutable) */ __webpack_exports__["isNumber"] = isNumber;
/* harmony export (immutable) */ __webpack_exports__["isSwissVisitor"] = isSwissVisitor;
/* harmony export (immutable) */ __webpack_exports__["sanitizePhone"] = sanitizePhone;
/* harmony export (immutable) */ __webpack_exports__["namespace"] = namespace;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initNewModules", function() { return initNewModules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ensure", function() { return ensure; });
/* harmony export (immutable) */ __webpack_exports__["imageLoaded"] = imageLoaded;
/* harmony export (immutable) */ __webpack_exports__["fetcher"] = fetcher;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
// tslint:disable:no-reference
/// <reference path="../../bootstrap/load-terrific.ts" />
// tslint:enable:no-reference


// Cache the result for the page (it never changes)
var pageIsMobile;
var MOBILE_SELECTOR = 'div.mobile, body.is-mobile';
function isMobilePage($ctx) {
    if ($ctx && $ctx.length > 0) {
        return $ctx.find(MOBILE_SELECTOR).length > 0;
    }
    if (!document.body) {
        var e_1 = new Error('isMobilePage called too early, no body yet');
        setTimeout(function () {
            throw e_1;
        }, 0);
        return false;
    }
    if (pageIsMobile === undefined) {
        pageIsMobile = __WEBPACK_IMPORTED_MODULE_1_jquery__(MOBILE_SELECTOR).length > 0;
    }
    return pageIsMobile;
}
function isEditMode() {
    return !!((window.CQ
        && window.CQ.WCM
        && window.CQ.WCM.isEditMode
        && window.CQ.WCM.isEditMode(true)) || document.body.dataset.editMode);
}
function zeroFill(num, length) {
    if (length === void 0) { length = 2; }
    length -= Math.round(num).toString().length;
    return new Array((length > 0 ? length + 1 : 0)).join('0') + num;
}
/**
 * Returns a unique id for the given DOM element. This id does not change if it is set once.
 * @method getUniqueIdOfElement
 * @param {HTMLElement|jQuery} element
 * @returns {String}
 */
var counter = 0;
function getUniqueIdOfElement(element) {
    var $el = __WEBPACK_IMPORTED_MODULE_1_jquery__(element);
    var id = $el.data('unique-element-id');
    if (!id) {
        counter++;
        id = counter;
        $el.data('unique-element-id', id);
    }
    return id;
}
/**
 * @method isNumber
 * @param value
 * @returns {boolean}
 */
function isNumber(value) {
    return !isNaN(parseInt(value, 10));
}
function isSwissVisitor() {
    /* Our test enviorments does not have these option, so always return true in
     case there is no window.geolocation object */
    return !window.geolocation || window.geolocation.swissvisitor;
}
function sanitizePhone(to) {
    if (!to) {
        return '';
    }
    to = to.replace(/[\s*\-?\\?\/?\(?\)?]/g, '');
    if (to.indexOf('+') !== 0) {
        if (to.indexOf('00') === 0) {
            to = to.slice(2);
        }
        if (to.indexOf('0') === 0) {
            to = "41" + to.slice(1);
        }
        to = "+" + to;
    }
    return to;
}
function namespace(ns, curr) {
    if (curr === void 0) { curr = window; }
    ns.split('.').forEach(function (item) {
        if (!(item in curr)) {
            curr[item] = {};
        }
        curr = curr[item];
    });
    return curr;
}
/*
 * Implementation for the SCS.ensure method and the “scs-element-add” event
 * The choice for ensure vs the event is entirely up to you.
 * See below for whether to use these or a Tc.Module.
 *
 * SCS.ensure method: alternative to jQuery(document).ready.
 * “scs-element-add” event: event-based API for the same functionality.
 *
 * Called with static content as well as lazily-loaded elements.
 *
 * There are two ways of using ensure (often you’ll use both in the same component):
 *
 * 1. You’re loading content whose components need to be initialized
 *
 * When developing a lazily-loading component (that does not use the overloaded $(…).load()),
 * just call
 * `SCS.utils.initNewModules(element)` (preferred method because it works on bluewin as well whereas ensure doesn’t)
 * or
 * `SCS.ensure(element)`
 * or
 * `$(element).trigger('scs-element-add')`
 * as soon as the loaded element has been updated,
 * with `element` being the updated/newly-loaded element.
 *
 * 2. You’re developing a component that wants to be initialized
 *
 * Instead of
 * $(document).ready(function($){
 *	$('.some_css_class').each(function () {
 *		// some fancy stuff here
 *	});
 * });
 * use
 * SCS.ensure(function($context, $) {
 *	$context.find('.some_css_class').each(function () {
 *		// some fancy stuff here
 *	});
 * });
 * or, using the events
 * $(document).on('scs-element-add', function(event) {
 *	$context = $(event.target || document);
 *	$context.find('.some_css_class').each(function () {
 *		// some fancy stuff here
 *	});
 * })
 *
 * Note: Do NOT use this function if not strictly necessary (eg. to do stuff that only has to be done
 * once, like binding events to a specific element) because all ensired listeners are called
 * each time a load occures. This leads to performance problems if there are lots of
 * listeners that, when called, search the DOM for elements to process each time.
 *
 * For simple event listerns just use the jQuery "delegate" function (or "on" with newer jQuery versions).
 *
 * To prevent performance problems you can additionally pass a DOM-element or a
 * css-selector-string as second parameter along with your callback-function to make
 * sure the function gets only called when a element is loaded which matches the selector.
 * If you don’t pass this additional parameter your callback-function gets called
 * every time ANY load-event is fired (including the DOM-ready event).
 *
 * An example for the selector could be 'body, .ui-tabs-panel, .ui-dialog-content':
 *
 * SCS.ensure(function($context, $) {
 *	$context.find('.some_css_class').each(function () {
 *		// some fancy stuff here
 *	});
 * }, 'body, .ui-tabs-panel, .ui-dialog-content');
 * or, using the events
 * $(document).on('scs-element-add', 'body, .ui-tabs-panel, .ui-dialog-content', function(event) {
 *	$context = $(event.target || document);
 *	$context.find('.some_css_class').each(function () {
 *		// some fancy stuff here
 *	});
 * })
 *
 * This used to be the only method to reliably initialize widgets on lazily-loaded content.
 * However, now there are Tc.Modules and the 'scs-element-add' events,
 * all of which can be used, depending on use cases.
 *
 * Tc.Modules are applicable for encapsulated widgets,
 * ensure or the 'scs-element-add' event can be used
 * for commonly-used light-weight components with few dependencies.
*/
var SCS = namespace('SCS');
var utils = namespace('utils', SCS);
function initNewModulesImpl(container, scope) {
    if (scope === initNewModulesImpl) {
        // `initNewModules` calls going in circles, stopping now
        return [];
    }
    var $ctx = __WEBPACK_IMPORTED_MODULE_1_jquery__(container);
    // Do jQuery Mobile module initialization (if applicable).
    // Should be done before initializing Tc.Modules because they sometimes rely on the correct DOM being already present.
    if ('enhanceWithin' in __WEBPACK_IMPORTED_MODULE_1_jquery__["fn"]) {
        $ctx.enhanceWithin();
    }
    // Remove the flag on the container which tells Terrific to not initialize the descending modules
    if ($ctx.attr('data-ignore-descendants') === 'true') {
        $ctx.removeAttr('data-ignore-descendants').removeData('ignore-descendants');
    }
    var modules = [];
    // Init all Terrific modules in this container
    if (window.application && window.application.sandbox) {
        modules = window.application.sandbox.addModules($ctx);
    }
    // Init all ensured modules in this container
    ensure($ctx, scope || initNewModulesImpl);
    return modules;
}
var initNewModules = initNewModulesImpl;
if (!('initNewModules' in utils)) {
    utils.initNewModules = initNewModulesImpl;
}
else {
    initNewModules = utils.initNewModules;
}

var handlers = [];
function ensureImpl(handler, scope) {
    if (handler && typeof handler === 'function') {
        /*
            Function given, alias for $(document).on('scs-element-add', function() {
                handler($(event.target), $);
            })
        */
        handlers.push([handler, scope]);
        return undefined;
    }
    if (scope === ensureImpl) {
        // Ensure calls going in circles, stopping now
        return undefined;
    }
    var $el = __WEBPACK_IMPORTED_MODULE_1_jquery__(handler);
    // Check if element is inside the document (some functions e.g. size-measuring do not work otherwise)
    var $elBody = $el.closest('body');
    if ($el[0] !== document.body && $el[0] !== document && (!$elBody.length || $elBody[0] !== document.body)) {
        return true;
    }
    var ignoreScope = scope === false;
    if (ignoreScope) {
        scope = undefined;
    }
    // Call handlers
    var errorStack = [];
    for (var _a = 0, handlers_1 = handlers; _a < handlers_1.length; _a++) {
        var _b = handlers_1[_a], myHandler = _b[0], myScope = _b[1];
        // In a try statement because js-errors in these functions
        // Should not be able to stop execution of all other functions in the queue
        try {
            // `scope === false` is a special case, meaning scoping restrictions should be ignored (for overlays and the like)
            // `!myScope` means the handler was registered for all scopes
            // `myScope === $el[0]` means the scope for the handler is an element
            // `(myScope.length && $el.is(myScope))` for the case where the scope is a selector
            if (ignoreScope || !myScope || myScope === $el[0] || (myScope.length && $el.is(myScope))) {
                myHandler($el, __WEBPACK_IMPORTED_MODULE_1_jquery__);
            }
        }
        catch (err) {
            errorStack.push(err);
        }
    }
    /* debug.log('commons.js > ensure > triggered scs-element-add event', $el.prop('tagName'), $el.attr('class')); */
    if (scope !== addHandler) {
        $el.trigger('scs-element-add', scope || ensureImpl);
    }
    __WEBPACK_IMPORTED_MODULE_1_jquery__["each"](errorStack, function (_i, error) {
        // Set a timeout so the calling method is not affected by the error
        window.setTimeout(function () {
            // Throw error because the user should be able to see the error if it occured
            throw error;
        }, 1);
    });
    return $el;
}
var ensure = ensureImpl;
if (!('ensure' in SCS)) {
    SCS.ensure = ensureImpl;
}
else {
    ensure = SCS.ensure;
}

/**
 * Handle 'scs-element-add' events appropriately.
 *
 * Note that this is added only after triggering the first 'scs-element-add' on DOM ready
 * because Terrific already initializes modules on DOM ready and PIE also kicks in immediately.
 * Only ensure had to be triggered manually, which we did above.
 */
var $doc = __WEBPACK_IMPORTED_MODULE_1_jquery__(document);
function addHandler(event, scope) {
    if (scope === addHandler) {
        // `addHandler` calls going in circles, stopping now
        return;
    }
    var $el = __WEBPACK_IMPORTED_MODULE_1_jquery__(event.target || $doc);
    /**
     * Initialize Tc.Modules on 'scs-element-add' (when elements have been added).
     */
    initNewModules($el, scope || addHandler);
}
/*
 * Trigger 'scs-element-add' on DOM ready.
 *
 * The 'scs-element-add' event is completely compatible with ensure, which acts as a more type-safe synonym:
 *
 * • $el.trigger('scs-element-add') is the same as SCS.ensure($el)
 * • $(document).on('scs-element-add', fn) is the same as SCS.ensure(fn) (with the prepended `event` argument to fn).
 * • $(document).on('scs-element-add', '.selector', fn) is the same as SCS.ensure(fn, '.selector')
 *                                                      (with the prepended `event` argument to fn).
 */
$doc.off('.helpers').on('ready.helpers', function () {
    ensure(document.body);
    $doc.trigger('scs-element-add');
    /**
     * Handle 'scs-element-add' events appropriately.
     *
     * Note that this is added only after triggering the first 'scs-element-add' on DOM ready
     * because Terrific already initializes modules on DOM ready and PIE also kicks in immediately.
     * Only ensure had to be triggered manually, which we did above.
     */
    $doc.on('scs-element-add.helpers', addHandler);
});
/**
 * Wait for image to be loaded. Work around issue when image is loaded from cache.
 */
function imageLoaded(image) {
    return new Promise(function (resolve, reject) {
        if (image.complete) {
            resolve(image);
        }
        function unbind() {
            image.removeEventListener('load', loaded);
            image.removeEventListener('error', rejected);
        }
        var loaded = function () { unbind(); resolve(image); };
        var rejected = function (event) { unbind(); reject(event.error); };
        image.addEventListener('load', loaded);
        image.addEventListener('error', rejected);
    });
}
/**
 * Gets the fetch API.
 * On IE 11, waits until the polyfill is available (provided by Shared Header or SDX webcomponents)
 */
function fetcher() {
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
            if (window.fetch) {
                return [2 /*return*/, window.fetch];
            }
            return [2 /*return*/, new Promise(function (resolve) {
                    var interval = window.setInterval(function () {
                        if (window.fetch) {
                            clearInterval(interval);
                            resolve(window.fetch);
                        }
                    }, 50);
                })];
        });
    });
}


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: external "(window._g && _g.$) || window.$CQ || window.$ || window.jQuery"
var external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_ = __webpack_require__(0);
var external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default = /*#__PURE__*/__webpack_require__.n(external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_);

// EXTERNAL MODULE: ./clientlibs/js/lib/vendor/jquery-deparam-patched.ts
var jquery_deparam_patched = __webpack_require__(10);

// CONCATENATED MODULE: ./clientlibs/js/lib/util/globals.ts
// This helper is mainly needed because with the switch to sdx there
// is a chance that modules get loaded twice. This is specially true
// for all utility functions relying on global caching/data.
function getGlobal(name, defaults) {
    window.scGlobals = window.scGlobals || {};
    if (!(name in window.scGlobals)) {
        window.scGlobals[name] = defaults;
    }
    return window.scGlobals[name];
}

// CONCATENATED MODULE: ./clientlibs/js/lib/util/url.ts
/* harmony export (immutable) */ __webpack_exports__["removeHashParameterFromUrl"] = removeHashParameterFromUrl;
/* harmony export (immutable) */ __webpack_exports__["removeHashParameter"] = removeHashParameter;
/* harmony export (immutable) */ __webpack_exports__["readStateFromHash"] = readStateFromHash;
/* harmony export (immutable) */ __webpack_exports__["saveStateToHash"] = saveStateToHash;
/* harmony export (immutable) */ __webpack_exports__["setHash"] = setHash;
/* harmony export (immutable) */ __webpack_exports__["isImagePath"] = isImagePath;
/* harmony export (immutable) */ __webpack_exports__["isExternalUrl"] = isExternalUrl;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hashDeepLink", function() { return hashDeepLink; });



function removeHashParameterFromUrl(url, parameterName) {
    var regexp = new RegExp("(?:(?!#|&)" + parameterName + "(=.+?)?(&|$))", 'g');
    return url.replace(regexp, '').replace(/(#|&)$/, '');
}
function removeHashParameter(parameterName) {
    window.history.replaceState({}, '', removeHashParameterFromUrl(window.location.href, parameterName));
}
var hashStateCache = getGlobal('hashStateCache', {});
function readStateFromHash(key, always) {
    if (always === void 0) { always = false; }
    var hashIndex = window.location.href.lastIndexOf('#');
    var hash = '';
    if (hashIndex > -1) {
        hash = window.location.href.substring(hashIndex + 1);
    }
    if (!hashStateCache.hasOwnProperty(key)) {
        hashStateCache[key] = '';
    }
    hash = hash.split('&').sort().join('&');
    if (hash === hashStateCache[key] && !always) {
        // No changes detected
        return undefined;
    }
    hashStateCache[key] = hash;
    var hashState = Object(jquery_deparam_patched["default"])(hash);
    if (!hashState || !(key in hashState)) {
        return {};
    }
    return hashState[key] || {};
}
function saveStateToHash(key, state) {
    var url = window.location.href;
    var hashIndex = url.lastIndexOf('#');
    var hash = '';
    if (hashIndex > -1) {
        hash = url.substring(hashIndex + 1);
    }
    var hashState = Object(jquery_deparam_patched["default"])(hash) || {};
    hashState[key] = state;
    var serialized = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_["param"](hashState, false)
        .split('&').sort().join('&');
    setHash(serialized);
    hashStateCache[key] = serialized;
}
function setHash(hash, replaceState) {
    if (replaceState === void 0) { replaceState = true; }
    var deeplink = hash.startsWith('#') ? hash : '#' + hash;
    if (replaceState) {
        if (window.history && window.history.replaceState) {
            window.history.replaceState(undefined, '', deeplink);
        }
        else {
            window.location.replace('#' + deeplink);
        }
    }
    else {
        if (window.history && window.history.pushState) {
            window.history.pushState(undefined, '', deeplink);
        }
        else {
            window.location.hash = deeplink;
        }
    }
}
function isImagePath(path) {
    if (!path) {
        return false;
    }
    return /\.((jpg)|(jpeg)|(gif)|(png)|(bmp))((\?|#).*)?$/i.test(path);
}
/**
 * Checks if a url is external - can be used to check if a url can be loaded via ajax (same domain policy)
 * @method isExternalUrl
 * @param url {string}
 * @returns boolean
 */
var URL_MATCHER = /^([^:\/?#]+:)?(?:\/\/([^\/?#]*))?([^?#]+)?(\?[^#]*)?(#.*)?/;
var CURRENT_PORT = location.protocol === 'http' ? 80 : 443;
function isExternalUrl(url) {
    if (!url) {
        return false;
    }
    var match = url.match(URL_MATCHER);
    if (!match) {
        return false;
    }
    var protocol = (match[1] || '').toLowerCase();
    if (protocol && protocol !== location.protocol) {
        return true;
    }
    var host = (match[2] || '');
    if (host.length > 0 && host.replace(new RegExp(":(" + CURRENT_PORT + ")?$"), '') !== location.host) {
        return true;
    }
    return false;
}
var HashDeepLinkController = /** @class */ (function () {
    function HashDeepLinkController() {
        var _this = this;
        this.deeplinks = [];
        this.callbacks = [];
        this.update();
        window.addEventListener('hashchange', function () { return _this.update(); });
    }
    HashDeepLinkController.prototype.get = function (name) {
        var value;
        for (var _i = 0, _a = this.deeplinks; _i < _a.length; _i++) {
            var link = _a[_i];
            if (link.indexOf(name + '=') === 0) {
                value = decodeURIComponent(link.split('=', 2)[1]);
            }
        }
        return value;
    };
    /**
     * Set a hash parameter or replace it's value.
     *
     * @param name 			The parameter name to set/replace
     * @param value 		The value to set to `name`
     * @param separator 	The separator with which to separate key value pairs
     * @param replaceState 	Set true to omit creating a history entry.
     */
    HashDeepLinkController.prototype.set = function (name, value, separator, replaceState) {
        if (separator === void 0) { separator = ','; }
        if (replaceState === void 0) { replaceState = true; }
        var deeplinkupdated = false;
        var deeplinkValues;
        for (var i = 0; i < this.deeplinks.length; i += 1) {
            if (this.deeplinks[i].indexOf(name + '=') === 0) {
                if (typeof value !== 'undefined') {
                    deeplinkValues = this.deeplinks[i].split('=', 2);
                    deeplinkValues[1] = encodeURIComponent(value);
                    this.deeplinks[i] = deeplinkValues.join('=');
                }
                else {
                    this.deeplinks.splice(i, 1);
                }
                deeplinkupdated = true;
                break;
            }
            if (!this.deeplinks[i]) {
                this.deeplinks.splice(i, 1);
            }
        }
        if (!deeplinkupdated && typeof value !== 'undefined') {
            this.deeplinks.push(name + "=" + encodeURIComponent(value));
        }
        var deeplink = this.deeplinks.join(separator || ',');
        // Add something to avoid jump to top
        if (deeplink === '') {
            deeplink = '!';
        }
        setHash(deeplink, replaceState);
        this.notifySubscribers();
    };
    HashDeepLinkController.prototype.subscribe = function (callback) {
        if (this.callbacks.indexOf(callback) < 0) {
            this.callbacks.push(callback);
        }
    };
    HashDeepLinkController.prototype.update = function () {
        // Use location.href and not hash because window.location.hash returns a urlDecoded value
        var deeplink = window.location.hash
            ? window.location.href.substr(window.location.href.indexOf('#') + 1)
            : '';
        if (deeplink.indexOf(',') > -1) {
            this.deeplinks = deeplink.split(',');
        }
        else {
            this.deeplinks = deeplink.split('&');
        }
        // Remove jump to top preventer
        if (this.deeplinks.length) {
            if (this.deeplinks[0] === '!') {
                this.deeplinks.shift();
            }
        }
    };
    HashDeepLinkController.prototype.notifySubscribers = function () {
        for (var _i = 0, _a = this.callbacks; _i < _a.length; _i++) {
            var callback = _a[_i];
            callback();
        }
    };
    return HashDeepLinkController;
}());
var hashDeepLink = new HashDeepLinkController();


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Module; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_string__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_util_url__ = __webpack_require__(4);



var Module = /** @class */ (function () {
    function Module($ctx, sandbox, id, modName) {
        var _this = this;
        this.$ctx = $ctx;
        this.sandbox = sandbox;
        this.id = id;
        this.modName = modName;
        this.hashKey = modName;
        this.connectors = {};
        this.debugInternal = !!sandbox.config.debug;
        if (!('debug' in this)) {
            this.debug = this.debugInternal;
        }
        /**
         * Shortcut to debug.log, prepends the module name to the output
         */
        // Added by Swisscom (Raphael Schweikert, taascraa)
        var console = window.debug || window.console;
        var log = function (level) {
            var _a;
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            if (!_this.debugInternal) {
                return;
            }
            (_a = console[level]).call.apply(_a, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spreadArray */])([console, "Tc.Module." + _this.modName + " >"], args));
        };
        this.logInternal = log.bind(this, 'log');
        var levels = ['error', 'warn', 'info', 'debug', 'log'];
        for (var _i = 0, levels_1 = levels; _i < levels_1.length; _i++) {
            var level = levels_1[_i];
            this.logInternal[level] = log.bind(this, level);
        }
        if (!('log' in this)) {
            this.log = this.logInternal;
        }
    }
    /**
     * Template method to start (i.e. init) the module.
     * This method provides hook functions which can be overridden
     * by the individual instance.
     *
     * @method start
     */
    Module.prototype.start = function () {
        var _this = this;
        // Call the hook method from the individual instance and provide the appropriate callback
        // Modified by Swisscom (Raphael Schweikert, taascraa): Warn if callback not called after 300ms
        if (this.on) {
            var timeout_1 = null;
            if (this.debugInternal) {
                timeout_1 = window.setTimeout(function () {
                    _this.logInternal.error('Module’s `on` hasn’t called its callback after 300ms');
                }, 300);
            }
            var callAfter = function () {
                if (timeout_1) {
                    window.clearTimeout(timeout_1);
                }
                _this.initAfter();
            };
            this.on(callAfter);
        }
        else {
            this.logInternal.error('Module doesn’t implement `on`');
        }
    };
    /**
     * Template method to stop the module.
     *
     * @method stop
     */
    Module.prototype.stop = function () {
        var $ctx = this.$ctx;
        // Remove all bound events and associated jQuery data
        $('*', $ctx).off().removeData();
        $ctx.off().removeData();
    };
    /**
     * Initialization callback.
     *
     * @method initAfter
     * @protected
     */
    Module.prototype.initAfter = function () {
        var _this = this;
        this.sandbox.ready(function () {
            /*
             * Call the 'after' hook method from the individual instance
             */
            if (_this.after) {
                var hashState = {};
                if (_this.moduleStateChanged) {
                    hashState = Object(__WEBPACK_IMPORTED_MODULE_2_lib_util_url__["readStateFromHash"])(_this.hashKey, true);
                }
                _this.after(hashState);
            }
        });
    };
    Module.prototype.fire = function (state, data, channels, defaultAction) {
        var connectors = this.connectors;
        var shouldBeCalled = true; // Indicates whether the default handler should be called
        // Validate params
        if (!channels && !defaultAction) {
            // Max. 2 params
            if (typeof data === 'function') {
                // (state, defaultAction)
                defaultAction = data;
                data = undefined;
            }
            else if (Array.isArray(data)) {
                // (state, channels)
                channels = data;
                data = undefined;
            }
        }
        else if (!defaultAction) {
            // 2-3 params
            if (typeof channels === 'function') {
                // (state, data, defaultAction)
                defaultAction = channels;
                channels = undefined;
            }
            if (Array.isArray(data)) {
                // (state, channels, defaultAction)
                channels = data;
                data = undefined;
            }
        }
        state = Object(__WEBPACK_IMPORTED_MODULE_1__utils_string__["a" /* capitalize */])(state);
        channels = (channels || Object.keys(connectors));
        for (var i = 0, len = channels.length; i < len; i++) {
            var connectorId = channels[i];
            if (connectors.hasOwnProperty(connectorId)) {
                var connector = connectors[connectorId];
                var proceed = connector.notify(this, 'on' + state, data) || false;
                if (!proceed) {
                    shouldBeCalled = false;
                }
            }
            else {
                throw new Error(
                // tslint:disable:trailing-comma
                "The " + this.modName + " module #" + this.id + " is not connected to connector " + connectorId + ".\n\t\t\t\t\tPlease make sure that your data is an object and not an array."
                // tslint:enable:trailing-comma
                );
            }
        }
        // Execute default action unless a veto is provided
        if (shouldBeCalled) {
            if (typeof defaultAction === 'function') {
                defaultAction(data || {});
            }
        }
    };
    /**
     * Attaches a connector (observer).
     *
     * @method attachConnector
     * @param {Connector} connector
     *      The connector to attach
     */
    Module.prototype.attachConnector = function (connector) {
        this.connectors[connector.connectorId] = connector;
    };
    /**
     * Detaches a connector (observer).
     *
     * @method detachConnector
     * @param {Connector} connector The connector to detach
     */
    Module.prototype.detachConnector = function (connector) {
        // tslint:disable-next-line:no-dynamic-delete
        delete this.connectors[connector.connectorId];
    };
    /**
     * Decorates itself with the given skin.
     *
     * @method getDecoratedModule
     * @param {String} module The name of the module
     * @param {String} skin The name of the skin
     * @return {Module} The decorated module
     */
    Module.prototype.getDecoratedModule = function (skin) {
        /*
            * Sets the prototype object to the module.
            * So the "non-decorated" functions will be called on the module
            * without implementing the whole module interface.
            */
        skin.prototype = this;
        skin.prototype.constructor = this.constructor;
        return new skin(this);
    };
    /**
     * Set a new hash state for this module.
     * Updates the url hash.
     *
     * @param hashState The new hash state record.
     */
    Module.prototype.setModuleState = function (hashState) {
        if (!this.moduleStateChanged) {
            this.log.error('Module is not hash-capable');
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_2_lib_util_url__["saveStateToHash"])(this.hashKey, hashState);
    };
    return Module;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_$) {(function ($, SCS) {
	'use strict';

	SCS.Url = SCS.Url || {};

	/**
	 * Strips protocol from URL
	 * @method stripProtocolFromUrl
	 * @param {String} url
	 * @return {String} url
	 */
	SCS.Url.stripProtocolFromUrl = function(url) {
		if (url && url.length > 0) {
			return(url.replace(/^(https?\:)?\/\//ig, ''));
		}
	};

	/**
	 * Strips content/swisscom path prefixes from URL
	 * @method stripPathPrefixFromUrl
	 * @param {String} url
	 * @return {String} url
	 */
	SCS.Url.stripPathPrefixFromUrl = function(url) {
		if (url && url.length > 0) {
			return(url.replace(/\/content\/swisscom\//ig, '\/'));
		}
	};

	/**
	 * Add or update a query parameter in a URL.
	 *
	 * @method updateQueryStringParameter
	 * @param {String} uri - URL to update
	 * @param {String} key - name of parameter to add/update
	 * @param {String} value - value of parameter to add/update (note: has to be URLencoded!)
	 * @return {String} - URL with added/updated query parameter
	 */
	SCS.Url.updateQueryStringParameter = function (uri, key, value) {
		var re = new RegExp('([?|&])' + key + '=.*?(&|#|$)', 'i'),
			hash = '',
			separator;

		if (!uri) {
			return '';
		}
		else if (uri.match(re)) {
			return uri.replace(re, '$1' + key + '=' + value + '$2');
		}
		else {
			separator = uri.indexOf('?') !== -1 ? uri.indexOf('?') === uri.length - 1 ? '' : '&' : '?';
			if (uri.indexOf('#') !== -1) {
				hash = uri.replace(/.*#/, '#');
				uri = uri.replace(/#.*/, '');
			}
			return uri + separator + key + '=' + value + hash;
		}
	};

	/**
	 * Parse an URL into:
	 *	search:	'?foo=bar' or ''
	 *	hash:	'#foobar' or ''
	 */
	SCS.Url.parse = function (url) {
		var search = '',
			hash = '';

		if (typeof url === 'string') {
			// hash cannot contain #, %, ^, [, ], {, }, \, ", < and >
			var match = url.match(/(\?[^#]+)?(#[^#]+)?$/);
			if (match !== null) {
				search = match[1] || '';
				hash = match[2] || '';
			}
		}

		return {
			search: search,
			hash: hash
		};
	};

	/**
	 * @method parseHash
	 * @param url
	 * @returns {null}
	 */
	SCS.Url.parseHash = function (url) {
		var fragment,
			keyValues = null,
			hashValueFragments,
			hashValue;

		hashValue = SCS.Url.parse(url).hash.substring(1);
		if (hashValue !== '') {
			hashValueFragments = hashValue.split('&');
			keyValues = {};

			for (var i = 0, ii = hashValueFragments.length; i < ii; i += 1) {
				fragment = SCS.Url.parseKeyVal(hashValueFragments[i]);
				keyValues[fragment.key] = fragment.val;
				fragment = null;
			}
		}
		return keyValues;
	};

	/**
	 * queryKeyVal is a string with the following format "key=val" eg. "id=234"
	 *
	 * @method parseKeyVal
	 * @param queryKeyVal
	 */
	SCS.Url.parseKeyVal = function (queryKeyVal) {
		var fragments = queryKeyVal.split('=');

		if (fragments[1] === undefined) {
			fragments[1] = '';
		}

		return {
			'key': fragments[0],
			'val': fragments[1]
		};
	};

	SCS.Url.getValidSelector = function (selector) {
		if (!selector) {
			return '-';
		}

		var selectorCharacterMappings = {
			'ä': 'ae',
			'ö': 'oe',
			'ü': 'ue',
			'ß': 'ss',
			' ': '-',
			'é': 'e',
			'è': 'e',
			'à': 'a',
			'ù': 'u',
			'â': 'a',
			'ê': 'e',
			'î': 'i',
			'ô': 'o',
			'û': 'u',
			'ë': 'e',
			'ï': 'i',
			'ç': 'c',
			'ì': 'i',
			'í': 'i',
			'ò': 'o',
			'ó': 'o',
			'ú': 'u',
			'[^a-z0-9_\\-]': '-'
		};

		for (var expr in selectorCharacterMappings) {
			if (selectorCharacterMappings.hasOwnProperty(expr)) {
				selector = selector.replace(new RegExp(expr, 'gi'), selectorCharacterMappings[expr]);
			}
		}

		return selector;
	};

	// FIXME: It seems this is unused, remove
	SCS.Url.removeHost = function (url) {
		if (!url) {
			return '/';
		}

		url = url.replace(/http\:/, '').replace(/https\:/, '');
		if (url.indexOf('//') !== 0) {
			return url;
		}

		var parts = url.split('/');
		if (parts.length < 4) {
			return '/';
		}
		return '/' + parts.slice(3).join('/');
	};

	SCS.Url.removeHashParameter = __webpack_require__(4).removeHashParameter;

}(__webpack_provided_window_dot_$, window.SCS = window.SCS || {}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = toCamel;
/* harmony export (immutable) */ __webpack_exports__["a"] = capitalize;
function toCamel(str) {
    return str.replace(/(\-[^-])/g, function ($1) {
        return $1.toUpperCase().replace('-', '');
    });
}
function capitalize(str) {
    // Capitalize the first letter
    return str.substr(0, 1).toUpperCase().concat(str.substr(1));
}


/***/ }),
/* 8 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_imports_loader_define_false_jQuery_jquery_qtip2__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_imports_loader_define_false_jQuery_jquery_qtip2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_imports_loader_define_false_jQuery_jquery_qtip2__);
/// <reference types="qtip2" />



/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = deparam;
/// <reference types="jquery" />
var coerceTypes = { true: true, false: false, null: null };
function deparam(params, coerce) {
    if (coerce === void 0) { coerce = false; }
    var obj = {};
    // If params is an empty string or otherwise falsy, return obj.
    if (!params) {
        return obj;
    }
    // Iterate over all name=value pairs.
    params.replace(/\+/g, ' ').split('&').forEach(function (v) {
        var param = v.split('=');
        var key = decodeURIComponent(param[0]);
        var val = null;
        var cur = obj;
        var i = 0;
        // If key is more complex than 'foo', like 'a[]' or 'a[b][c]', split it
        // into its component parts.
        var keys = key.split('][');
        var keysLast = keys.length - 1;
        // If the first keys part contains [ and the last ends with ], then []
        // are correctly balanced.
        if (/\[/.test(keys[0]) && /\]$/.test(keys[keysLast])) {
            // Remove the trailing ] from the last keys part.
            keys[keysLast] = keys[keysLast].replace(/\]$/, '');
            // Split first keys part into two parts on the [ and add them back onto
            // the beginning of the keys array.
            var part = keys.shift();
            if (part !== undefined) {
                keys = part.split('[').concat(keys);
            }
            keysLast = keys.length - 1;
        }
        else {
            // Basic 'foo' style key.
            keysLast = 0;
        }
        // Are we dealing with a name=value pair, or just a name?
        if (param.length === 2) {
            val = decodeURIComponent(param[1]);
            // Coerce values.
            if (coerce) {
                val = val && !isNaN(val) && ((+val + '') === val) ? +val // Isa number
                    : val === 'undefined' ? undefined // Isa undefined
                        : coerceTypes[val] !== undefined ? coerceTypes[val] // Isa true, false, null
                            : val; // Isa string
            }
            if (keysLast) {
                // Complex key, build deep object structure based on a few rules:
                // * The 'cur' pointer starts at the object top-level.
                // * [] = array push (n is set to array length), [n] = array if n is
                //   numeric, otherwise object.
                // * If at the last keys part, set the value.
                // * For each keys part, if the current level is undefined create an
                //   object or array based on the type of the next keys part.
                // * Move the 'cur' pointer to the next level.
                // * Rinse & repeat.
                for (; i <= keysLast; i++) {
                    key = keys[i] === '' ? cur.length : keys[i];
                    if (i < keysLast) {
                        // Patched by taagrmal: must check if property is ours
                        // Otherwise we must not overwrite it by any means!
                        if (Object.prototype.hasOwnProperty.call(cur, key) && cur[key]) {
                            cur = cur[key]; // Re-use existing object
                        }
                        else {
                            cur = cur[key] = keys[i + 1] && isNaN(keys[i + 1]) ? {} : [];
                        }
                    }
                    else {
                        cur[key] = val;
                    }
                }
            }
            else {
                // Simple key, even simpler rules, since only scalars and shallow
                // arrays are allowed.
                if (Object.prototype.toString.call(obj[key]) === '[object Array]') {
                    // Val is already an array, so push on the next value.
                    obj[key].push(val);
                }
                else if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    // Val isn't an array, but since a second value has been specified,
                    // convert val into an array.
                    obj[key] = [obj[key], val];
                }
                else {
                    // Val is a scalar.
                    obj[key] = val;
                }
            }
        }
        else if (key) {
            // No value was defined, so set something meaningful.
            obj[key] = coerce ? undefined : '';
        }
    });
    return obj;
}


/***/ }),
/* 11 */
/***/ (function(module, exports) {

/*
 * JavaScript Debug - v0.4 - 6/22/2010
 * http://benalman.com/projects/javascript-debug-console-log/
 *
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 *
 * With lots of help from Paul Irish!
 * http://paulirish.com/
 */
window.debug = (function () {
	var i = this, b = Array.prototype.slice, d = i.console, h = {}, f, g, m = 9, c = ["error", "warn", "info", "debug", "log"], l = "assert clear count dir dirxml exception group groupCollapsed groupEnd profile profileEnd table time timeEnd trace".split(" "), j = l.length, a = [], r = Function.prototype.apply;
	while (--j >= 0) {
		(function (n) {
			h[n] = function () {
				m !== 0 && d && d[n] && d[n].apply(d, arguments)
			}
		})(l[j])
	}
	j = c.length;
	while (--j >= 0) {
		(function (n, o) {
			h[o] = function () {
				var q = b.call(arguments), p = [o].concat(q);
				a.push(p);
				e(p);
				if (!d || !k(n)) {
					return
				}
				r.call(d[d[o] ? o : 'log'], d, q)
			}
		})(j, c[j])
	}
	function e(n) {
		if (f && (g || !d || !d.log)) {
			f.apply(i, n)
		}
	}

	h.setLevel = function (n) {
		m = typeof n === "number" ? n : 9
	};
	function k(n) {
		return m > 0 ? m > n : c.length + m <= n
	}

	h.setCallback = function () {
		var o = b.call(arguments), n = a.length, p = n;
		f = o.shift() || null;
		g = typeof o[0] === "boolean" ? o.shift() : false;
		p -= typeof o[0] === "number" ? o.shift() : n;
		while (p < n) {
			e(a[p++])
		}
	};
	return h
})();

/**
 * Add 'devconsole=1' to the url to enable debugging. It's enough if "devconsole" is added to the url.
 * @author tjunghans
 */
(function () {
	"use strict";

	var url = document.location.href,
		queryString = 'devconsole';

	if (url.indexOf(queryString, 'http://'.length) < 0) {
		debug.setLevel(0); // Remove to show logs in console
	}
}());

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Module, $, w, SCS) {
	'use strict';
	/*jshint smarttabs:true */

	function uuid() {
		// jshint bitwise: false
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
			var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
			return v.toString(16);
		});
	}

	// IE8 fix
	document.createElement('video');

	/**
	 * BrightcoveVideo module implementation.
	 *
	 * @author Thomas Junghans (refactored by Dave Talamona, Benjamin Berger)
	 * @namespace Tc.Module
	 * @class BrightcoveVideo
	 * @extends Tc.Module
	 */
	Module.BrightcoveVideo = Module.extend({

		/* Runtime properties */
		// The videojs player instance.
		player: null,

		// The current video metadata
		currentVideo: null,

		// The interval for the ugly hack that causes flash to throw an exception when it has died so we know when to reload the player.
		flashHideErrorTriggerInterval: null,

		// The interval that counts down the skip-ad timeout and activates the skip button.
		skipAdTimeoutInterval: null,

		// How many milliseconds of the ad timeout have elapsed.
		skipAdTimeoutElapsed: 0,

		// This video’s id attribute value (generated by the module).
		id: null,

		/* Config attributes */
		// Whether the video starts automatically.
		autostart: false,

		// Whether the video loops.
		loop: false,

		// How long one has to wait before being allowed to skip an ad, in milliseconds.
		skipAdTimeout: 8000,

		// The URL for the VAST tag. Null if not yet initialized or ads are disabled.
		adServerUrl: null,

		// Whether this video is in an overlay
		isInOverlay: false,

		// Whether the player was reloaded because of a technical problem.
		// If this is the case, ads should not be shown again because they might have caused the problem.
		wasReloaded: false,

		// Whether the player is currently showing an ad (playing or paused).
		currentlyShowingAds: false,

		/* Module elements */
		// The container for this video. This element is responsible for creating the correct aspect ratio.
		// If the player is in an overlay, this is the element that gets overlaid.
		$videoContainer: null,

		// The div that contains the video tag.
		$wrapper: null,

		// A div with the same attributes as the video tag, from which the video tag can be generated.
		$dummyVideoTag: null,

		// The actual video tag. Careful, this might not be what you expected (if you expected a <video> tag attached to the document):
		// * null if the video tag has not yet been initialized
		// * a <video> tag not attachted to the document (if it has been replaced by flash)
		$videoTag: null,

		// The button on which to click when skipping an ad.
		$skipAdsButton: null,

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method after
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this;

			mod.$videoContainer = mod.$ctx.find('.video-container');
			mod.$dummyVideoTag = mod.$videoContainer.find('.dummyVideoTag');
			mod.$dummyVideoTag.remove();

			callback();
		},

		after: function () {
			var mod = this;

			// Store calls to the API that were made before the player was ready
			mod.apiCache = {};
			mod.setupAPI();

			// Get attributes
			mod.autostart = mod.$ctx.data('autostart');
			mod.loop = mod.$ctx.data('loop');
			mod.skipAdTimeout = parseInt(mod.$ctx.attr('data-skip-ad-timeout'), 10) * 1000 || mod.skipAdTimeout;
			mod.isInOverlay = mod.$ctx.data('is-in-overlay');

			if (mod.debug) {
				window.modBrightcoveVideo = mod;
			}

			mod.$wrapper = mod.$videoContainer.find('.video-player-wrapper');
			mod.$skipAdsButton = mod.$ctx.find('.skipAdsButton');

			mod.loadBrightcove($.proxy(mod, 'preparePlayer'));

			mod.initVideoPlaybutton();
		},

		setupAPI: function () {
			var mod = this;

			mod.$ctx.on('onPause', function () {
				mod.pause();
				mod.log('on pause API called');
			});

			mod.$ctx.on('onPlay', function () {
				mod.play();
				mod.log('on play API called');
			});

			mod.$ctx.closest('.modVisibilityControlContainer').on('visibilityControl-hide', function () {
				mod.pause();
			});

			mod.$ctx[0].brightcoveapi = {
				play: $.proxy(mod, 'play'),
				pause: $.proxy(mod, 'pause'),
				getPlayer: $.proxy(mod, 'getPlayer'),
				isPlaying: $.proxy(mod, 'isPlaying'),
				dispose: $.proxy(mod, 'dispose'),
				getModule: function getModule() {
					return mod;
				}
			};

			mod.$ctx.data('brightcove-api', mod.$ctx[0].brightcoveapi);
		},

		loadBrightcove: function loadBrightcove(callback) {
			var mod = this;

			if (window.bc && window.videojs) {
				callback();
			} else {
				if (loadBrightcove.loaders) {
					loadBrightcove.loaders.push(callback);
					return;
				}
				loadBrightcove.loaders = [callback];
				var url = mod.$ctx.data('playerScript');
				if (mod.debug) {
					url = url.replace(/\.min\.js$/, '.js');
				}
				mod.log('loading window.bc from ' + url);
				$.ajax({
					url: url,
					cache: true,
					dataType: 'script',
					success: function () {
						mod.log('loaded window.bc', typeof window.bc, typeof window.videojs, loadBrightcove.loaders.length);
						for (var i = 0; i < loadBrightcove.loaders.length; i += 1) {
							loadBrightcove.loaders[i]();
						}
						delete loadBrightcove.loaders;
					}
				});
			}
		},

		preparePlayer: function () {
			var mod = this;
			mod.initPlayer();
		},

		initPlayer: function () {
			var mod = this;

			if (mod.player) {
				mod.log('Player reloaded because of a technical problem');
				mod.wasReloaded = true;
			}

			mod.createVideo();

			var video = mod.$videoTag[0];
			try {
				// this call is very important so Brightcove can mess around with the video tag
				// before we init the real vjs component that we will use
				window.bc(video);
			} catch (e) {
				// If brightcove has already transformed the video tag, we get an error. That’s ok.
			}

			window.videojs(video).ready(function () {
				var player = this;
				mod.log('videojs ready', mod.id, video, player);
				if (player.techName === 'Flash') {
					mod.prepareFlashPlaybackHack(player);
				}
				mod.setupPlayer(player);
			});
		},

		prepareFlashPlaybackHack: function (player) {
			var techCall = player.techCall;
			player.techCall = function (method) {
				if (method === 'play') {
					// Call play twice to combat flash not starting the first time around
					techCall.apply(this, arguments);
				}
				techCall.apply(this, arguments);
			};
		},

		// Create the <video> element that is then used to initialize brightcove
		createVideo: function () {
			var mod = this;

			mod.id = uuid();
			var attrs = {
				poster: mod.$dummyVideoTag.attr('data-poster'),
				'class': mod.$dummyVideoTag.attr('data-class'),
				controls: true,
				id: mod.id
			};
			for (var name in mod.$dummyVideoTag.data()) {
				// jshint forin: false
				// de-camelize name
				name = 'data-' + name.replace(/([a-z\d])([A-Z])/g, '$1' + '-' + '$2').toLowerCase();
				var value = mod.$dummyVideoTag.attr(name);

				attrs[name] = value;
			}

			mod.$videoTag = $(document.createElement('video'));

			if(!mod.$ctx.closest('.stagearea').length) {
				attrs.preload = 'metadata';
			}
			mod.$videoTag.attr(attrs);

			mod.$wrapper.empty();
			mod.$wrapper.append(mod.$videoTag);
		},

		setupPlayer: function (player) {
			var mod = this;

			// Clean up the old player (if any)
			mod.cleanup();
			/* Initialize state */
			// get a reference to the player
			mod.player = player;
			mod.skipAdTimeoutElapsed = 0;

			mod.log('setupPlayer bc video');

			mod.$wrapper.find('.video-js').css('left', '0px');
			mod.$ctx.find('.video-js').css({width: '100%', height: '100%'});

			mod.player.loop(mod.loop);
			//mod.player.autoplay(mod.autostart);
			mod.log('setting autoplay: ' + mod.autostart + ', loop: ' + mod.loop);

			// TODO could be saved in a cookie for next use of player or at least sync with other players on same page
			mod.player.volume(0.5);

			mod.setupPlayerLoad();
			mod.setupPlayerEvents();

			if (mod.videoOnHold){
				mod.onBrightcovePlayVideo(mod.videoOnHold);
				delete mod.videoOnHold;
			}

			try {
				mod.setupPlayerAds();
			} catch (e) {
				mod.log('setting up ads crashed', e);
				mod.setNotShowingAds();
			}

			// Re-run the calls to the API that were made before the player was ready
			for (var api in mod.apiCache) {
				if (!mod.apiCache.hasOwnProperty(api)) {
					continue;
				}
				this[api]();
			}

			mod.$ctx.addClass('scs-setup-and-ready');
		},

		cleanup: function () {
			var mod = this;
			if (mod.skipAdTimeoutInterval) {
				window.clearInterval(mod.skipAdTimeoutInterval);
			}
			if (mod.flashHideErrorTriggerInterval) {
				window.clearInterval(mod.flashHideErrorTriggerInterval);
			}
			if (mod.player) {
				mod.player.dispose();
				mod.player = null;
			}
		},

		setupPlayerLoad: function () {
			var mod = this;

			mod.log('trigger handler for player-loaded');
			// Trigger event for parent modules to react to and re-calculate sizes and stuff.
			mod.$ctx.trigger('brightcove.playerloaded');
		},

		setupPlayerEvents: function () {
			var mod = this;

			var isFirst = true;

			mod.player.on('loadstart', function (event) {
				mod.log('got loadstart event', event);
				var video = mod.player.mediainfo;

				mod.videoChanged(mod, video, isFirst);
				if (isFirst) {
					mod.initialVideoChanged(mod, video);
					isFirst = false;
				}
			});
			mod.player.on('ended', function (event) {
				mod.log('got ended event', event);
				mod.videoFinished(mod.player.mediainfo, mod);
			});
			mod.player.on('error', function (event) {
				mod.log('got error event', event);
				if (mod.player.ads && mod.currentlyShowingAds) {
					// Error was caused by an ad. Re-init the player (no ads will be shown this time).
					mod.initPlayer();
				}
			});
			mod.player.on('bc-catalog-error', function (event) {
				mod.log('got bc-catalog-error event', event);
				// Wait a few seconds, then re-init the player
				window.setTimeout(function () {
					mod.initPlayer();
				}, 2000);
			});

			mod.player.on('pause', function(event) {
				mod.log('got pause event', event);
				mod.$ctx.addClass('is-paused').removeClass('is-playing');
			});
			mod.player.on('play', function(event) {
				mod.log('got play event', event);
				mod.$ctx.removeClass('is-paused').addClass('is-playing');
			});
			mod.player.on('firstplay', function(event) {
				mod.log('got firstplay event', event);
				mod.$ctx.removeClass('is-idle').addClass('has-started');
			});

			var hasLoaded = !!mod.player.mediainfo;
			if (hasLoaded) {
				mod.player.trigger('loadstart');
			}
		},

		getAdVars: function () {
			var mod = this,
				vars = '';

			// window.bwAdVars is set by persad.js
			for (var k in window.bwAdVars) {
				if (k.indexOf('kv') === 0) {
					vars += ';' + k + '=' + window.bwAdVars[k];
				}
			}
			mod.log('getAdVars > vars=' + vars);
			return vars;
		},

		setupPlayerAds: function () {
			var mod = this;
			mod.adServerUrl = null;

			mod.log('setupPlayerAds', mod.player.ima3, mod.wasReloaded);

			if (!mod.player.ima3 || !mod.player.ima3.adrequest) {
				mod.log('ima3 not present');
				return;
			}

			if (mod.wasReloaded) {
				// Do not show ads twice if player was reloaded because of a technical problem.
				mod.wasReloaded = false;
				return;
			}

			// Get the brightcove ad configuration
			mod.adServerUrl = mod.getAdServerUrl();

			// debug ad URL, leave this comment in
			//mod.adServerUrl = "https://cs1.brightcodes.net/gamati/AdServer/AdExampleForTest.xml";
			if (!mod.adServerUrl) {
				return;
			}

			mod.player.ima3.settings.requestMode = 'onplay';
			mod.player.ima3.settings.serverUrl = mod.adServerUrl + mod.getAdVars();

			// 20 vast request redirects: PORTAL-11593
			// see docu https://docs.brightcove.com/en/perform/brightcove-player/guides/ima-plugin.html#methods
			mod.player.ima3.settings.ima3SdkSettings = { numRedirects : 20};

			mod.$wrapper.find('.video-js').append(mod.$skipAdsButton);
			mod.$ctx.find('.skipAdForReal').click($.proxy(mod.skipAd, mod));
			mod.updateSkipAdsButtonState();

			// Register adstart and adend listeners to start skip countdown
			mod.player.on('adstart', function (event) {
				mod.log('got adstart event', event);
				mod.setShowingAds();
			});

			mod.player.on('adend', function (event) {
				mod.log('got adend event', event);
				mod.setNotShowingAds();
			});

			mod.player.on('ima3-ad-error', function (event) {
				mod.log('got ima3-ad-error event', event);
				mod.setNotShowingAds();
				mod.play();
			});

			// Log
			if(mod.debug) {
				[
					'ima3error',
					'ads-request',
					'ads-load',
					'adsready',
					'adtimeout',
					'ads-ad-started',
					'ads-ad-ended',
					'ads-pause',
					'ads-play',
					'ads-first-quartile',
					'ads-midpoint',
					'ads-third-quartile',
					'ads-click',
					'ads-volumechange',
					'ads-pod-started',
					'ads-pod-ended',
					'ads-allpods-completed'
				].forEach(function(type) {
					mod.player.on(type, function (event) {
						mod.log('got '+type+' event', event);
					});
				});
			}
		},

		/*triggerAdRequest: function() {
			var mod = this;
			if(!mod.adServerUrl) {
				// No ads configured on page
				return;
			}
			if(window.google && window.google.ima) {
				mod.log('requesting ads from', mod.adServerUrl);
				mod.player.ima3.adrequest(mod.adServerUrl);
			} else {
				mod.player.on('ima3-ready', function(event) {
					// initialize the ima3 plugin that was registered in ima3.min.js with custom options
					mod.log('got ima3-ready event', event, 'now requesting ads from', mod.adServerUrl);
					mod.player.ima3.adrequest(mod.adServerUrl);
				});
			}
		},*/

		getAdServerUrl: function () {
			var mod = this;

			if (!mod.player.ima3) {
				mod.log('don’t configure ads because they seem to be turned off', mod.player.ima3);
				return;
			}
			if(mod.$ctx.data('ad-pre') && mod.$ctx.data('ad-pre').length) {
				return mod.$ctx.data('ad-pre');
			}
			else if(mod.$ctx.data('ad-post') && mod.$ctx.data('ad-post').length) {
				return mod.$ctx.data('ad-post');
			}

			mod.log('!prerollAds && !postrollAds');
		},

		setShowingAds: function () {
			var mod = this;
			mod.log('setShowingAds', mod.skipAdTimeoutElapsed, mod.skipAdTimeout);

			mod.currentlyShowingAds = true;
			$('.disablePlaylist').css({zIndex: 1}).show();

			if (mod.skipAdTimeoutElapsed >= mod.skipAdTimeout) {
				// Something went wrong: ads were already shown
				return;
			}
			mod.$skipAdsButton.removeClass('hiddenSkip');
			mod.startAdSkipCountdown();
		},

		setNotShowingAds: function () {
			var mod = this;
			mod.log('setNotShowingAds');

			mod.currentlyShowingAds = false;
			$('.disablePlaylist').hide();

			mod.pauseAdSkipCountdown();
			mod.skipAdTimeoutElapsed = 0;
			mod.$skipAdsButton.addClass('hiddenSkip');
		},

		startAdSkipCountdown: function () {
			var mod = this;
			mod.log('startAdSkipCountdown');
			mod.$skipAdsButton.removeClass('hiddenSkip');

			if (mod.skipAdTimeoutInterval) {
				// Already an interval active… do nothing
				// FIXME: Why not clear the old interval and create a new one?
				return;
			}

			// Make sure the buttons have the correct initial state
			mod.updateSkipAdsButtonState();

			if (mod.skipAdTimeoutElapsed >= mod.skipAdTimeout) {
				return;
			}

			var startDate = + new Date();
			// Store the initial time (if it’s not 0)
			var elapsed = mod.skipAdTimeoutElapsed;
			mod.skipAdTimeoutInterval = setInterval(function () {
				mod.skipAdTimeoutElapsed = elapsed + (+new Date()) - startDate;
				mod.updateSkipAdsButtonState();
			}, 500);
		},

		updateSkipAdsButtonState: function () {
			var mod = this;
			var postSkip = mod.skipAdTimeoutElapsed >= mod.skipAdTimeout;
			mod.$skipAdsButton.toggleClass('preSkip', !postSkip);
			mod.$skipAdsButton.toggleClass('postSkip', postSkip);
			if(mod.player && mod.player.ima3 && mod.player.ima3.adsManager) {
				mod.$skipAdsButton.find('.skipAdRest .secTimer').text(Math.ceil(mod.player.ima3.adsManager.getRemainingTime()));
			}
			mod.$skipAdsButton.find('.skipAdCountdown .secTimer').text(Math.ceil((mod.skipAdTimeout - mod.skipAdTimeoutElapsed)/1000));
		},

		pauseAdSkipCountdown: function () {
			var mod = this;
			if (mod.skipAdTimeoutInterval) {
				clearInterval(mod.skipAdTimeoutInterval);
				mod.skipAdTimeoutInterval = null;
			}
		},

		skipAd: function () {
			var mod = this;
			if (mod.player.ads) {
				if (mod.player.ima3.adsManager) {
					mod.player.ads.endLinearAdMode();
					mod.player.ima3.adsManager.pause();
					mod.player.ima3.adsManager.skip();
					mod.log('skipped ad');
				} else {
					mod.log('can’t skip cause this is the ima3', mod.player.ima3);
				}
			}
		},

		detectAndroidPhone: function () {
			var ua = navigator.userAgent.toLowerCase(),
				isAndroid = ua.indexOf('android') > -1;

			return isAndroid ? true : false;
		},

		initVideoPlaybutton: function () {
			var mod = this,
				$ctx = mod.$ctx,
				$videoPlaybutton = $ctx.find('.video-playbutton-container');

			$videoPlaybutton.click(function () {
				mod.play();
			});

			// detect android phones
			if (mod.detectAndroidPhone()) {
				// show play button placeholder
				// set class to hide webkit default controls
				$ctx.addClass('is-android');
			}
		},

		// API
		getPlayer: function () {
			return this.player;
		},

		pause: function () {
			var mod = this;

			if (mod.player) {
				mod.player.pause();
			} else {
				mod.apiCache.pause = true;
			}
		},

		play: function () {
			var mod = this;
			if (mod.player) {
				mod.player.play();
			} else {
				mod.apiCache.play = true;
			}
		},

		isPlaying: function () {
			var mod = this;
			if (mod.player) {
				return !mod.player.paused();
			}
			return mod;
		},

		dispose: function () {
			var mod = this;
			mod.cleanup();
			for (var name in mod) {
				if (mod.hasOwnProperty(name)) {
					mod[name] = null;
				}
			}
		},

		initialVideoChanged: function (mod, video) {
			mod.log('fire brightcoveFirstVideoReady');
			mod.fire('brightcoveFirstVideoReady', {'currentVideoId': parseInt(video.id, 10), 'tags': video.tags, 'thumbnailURL': video.thumbnail, 'name': video.name});
			if (mod.isInOverlay) {
				mod.trackVideoPageCall(mod.createUrl(video.id, video.name));
			}
		},

		videoChanged: function (mod, video, isFirst) {
			mod.updateAspectRatio(video);
			mod.log('videoChanged', mod.$dummyVideoTag.attr('data-video-id'), video.id);
			// Update the video id in case we need to reload the player using initPlayer()
			mod.$dummyVideoTag.attr('data-video-id', video.id);

			// Only update to new video if it is a different video, because this can be called multiple times at startup because of ads, etc.
			if (!isFirst && mod.currentVideo && video.id !== mod.currentVideo.id) {
				var data = {'currentVideoId': video.id, 'name': video.name, 'description': video.description};
				mod.fire('brightcoveChangedVideoReady', data);
				window.setTimeout(function () {
					mod.updateToNewVideo(data);
				}, 10); // keep in separate “thread” so that any IE-errors with the player do not stop the action

				mod.log('fire brightcoveChangedVideo > currentVideoId = ' + video.id);
			}

			/*if(mod.player.paused()) {
				// Register listener for next play
				mod.player.one('play', function initialPlay() {
					mod.log('initial play after video change');
					// Trigger the ad request on first play after loadstart
					mod.triggerAdRequest();
				});
			} else {
				// Already playing: call ad request directly
				mod.triggerAdRequest();
			}*/

			var newUrl = mod.createUrl(video.id, video.name);

			mod.log('fire urlChanged', newUrl);
			mod.sendUrlChangeToModules({
				url: newUrl,
				title: video.name,
				description: video.description
			});

			// save current video for check next time
			mod.currentVideo = video;

			// reset initial timeout for skipping ads
			mod.skipAdTimeoutElapsed = 0;

			if(mod.autostart) {
				setTimeout(function() {mod.play();}, 10);
			}
		},

		videoFinished: function (video, mod) {
			if (video) {
				mod.fire('brightcoveFinishedVideo', {'currentVideoId': video.id});
				mod.log('fire brightcoveFinishedVideo > currentVideoId = ' + video.id);
			}
		},

		updateAspectRatio: function (video) {
			var mod = this;

			var largestSource = null,
				sourcesLength = video.sources ? video.sources.length : 0;
			for (var i = 0; i < sourcesLength; i += 1) {
				var source = video.sources[i];
				if (('width' in source && 'height' in source) && (largestSource === null || largestSource.width < source.width)) {
					largestSource = source;
				}
			}

			var aspectRatio = 4 / 3;
			if (largestSource) {
				aspectRatio = largestSource.width / largestSource.height;
			}

			mod.$wrapper.css({paddingBottom: '' + (100 / aspectRatio) + '%'});
		},

		onBrightcovePlayVideo: function (data) {
			var mod = this;

			if (mod.isPlaying()) {
				mod.pause();
			}

			if (!mod.player){
				mod.log('Player not initialized, storing id: ' + data.currentVideoId);
				mod.videoOnHold = data;
				return;
			}

			mod.player.catalog.getVideo(data.currentVideoId, function (error, video) {
				if (error) {
					mod.log('Loading video mediainfo failed for ' + data.currentVideoId);
					return;
				}
				// This will trigger a “loadstart” event
				try {
					mod.player.catalog.load(video);
				} catch (e) {
					mod.log('Loading video failed for id_' + data.currentVideoId);
					mod.log('Try again, to load video for id_' + data.currentVideoId);
					//try again
					mod.player.catalog.load(video);
				}
			});
		},

		updateToNewVideo: function (data) {
			// update title/url and fire urlupdated
			var mod = this,
				videoId = data.currentVideoId,
				videoTitle = data.name,
				videoDescription = data.description,
				url = mod.createUrl(videoId, videoTitle);

			mod.log('onBrightcoveChangedVideo > currentVideoId = ' + data.currentVideoId);

			if (!mod.isInOverlay && window.history && window.history.pushState) {
				window.history.pushState(null, videoTitle, url);
			}

			if (!mod.isInOverlay) {
				document.title = videoTitle;
				$('.modBrightcoveVideo h1.title').text(videoTitle);
			}
			else {
				$('.sc-overlay-container .modBrightcoveVideo h1.title').text(videoTitle);
			}

			if (videoDescription) {
				mod.$ctx.find('.lead p').text(videoDescription);
			}
			else {
				mod.$ctx.find('.lead p').text('');
			}

			// track video page call
			mod.trackVideoPageCall(url);


		},

		createUrl: function (id, title) {
			var mod = this,
				currentUrl = mod.$ctx.data('video-page-url') || document.location.href;
			if (currentUrl.indexOf('http') !== 0) {
				currentUrl = $('<a />').attr('href', currentUrl)[0].href; // make url absolute
			}

			currentUrl = currentUrl.replace(/\.galleryoverlay\./g, '.');

			var urlParts = currentUrl.split('.');

			var html = urlParts.pop();
			if (html !== 'html') {
				// Not an ordinary page => do nothing
				return currentUrl;
			}

			// Cut off the first “id-” (if found) and everything that follows (should mostly include the title)
			for (var i = 0; i < urlParts.length; i += 1) {
				if (urlParts[i].indexOf('id-') === 0) {
					urlParts = urlParts.slice(0, i);
					break;
				}
			}

			// Add the id to the url
			urlParts.push('id-' + id);

			// Add the (normalized) title to the url
			urlParts.push((!title || title.length < 2) ? 'notitle' : SCS.Url.getValidSelector(title).toLowerCase());

			// Add the html again
			urlParts.push(html);

			return urlParts.join('.')+(document.location.search||'');
		},

		trackVideoPageCall: function () {
			// Net-Metrix
			// jshint camelcase: false
			if (window.NETMX_track) {
				window.NETMX_track();
			}
		},

		sendUrlChangeToModules: function (data) {
			var mod = this;
			if (mod.isInOverlay) {
				$('.sc-overlay-container .mod[data-connectors*=urlchange]').each(function () {
					var tempMod = mod.sandbox.getModuleInstance(this);
					if (tempMod && tempMod.onUrlChanged) {
						tempMod.onUrlChanged(data);
					}
				});
			}
			else {
				mod.fire('urlChanged', data);
			}
		},

		onToggleVisibility: function(data) {
			var mod = this;
			// jshint unused: false
			if (this.$ctx.is(':visible')) {
				mod.log('toggleVisibility event called > player visible');
				if (!this.player) {
					this.initPlayer();
				}
			}
			else {
				mod.log('toggleVisibility event called > player hidden');
				if (this.player) {
					this.cleanup();
				}
			}
		}

	});

}(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$, window, window.SCS = window.SCS || {}));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(2);

// EXTERNAL MODULE: external "(window._g && _g.$) || window.$CQ || window.$ || window.jQuery"
var external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_ = __webpack_require__(0);
var external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default = /*#__PURE__*/__webpack_require__.n(external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/libraries/SCS.Url.js
var SCS_Url = __webpack_require__(6);
var SCS_Url_default = /*#__PURE__*/__webpack_require__.n(SCS_Url);

// CONCATENATED MODULE: ./clientlibs/js/lib/generic/socialmedia/services/Disqus.ts


var COUNT_URL = 'https://swisscomstorys.disqus.com/count-data.js';
function dispatchRequest() {
    var params = [];
    var handlers = [];
    // Data to be used below
    for (var url in callbacks) {
        params.push('2=' + encodeURI(url));
        handlers.push(callbacks[url]);
    }
    // Do request
    external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_["ajax"]({
        // Reject all handlers
        error: function (err) {
            for (var _i = 0, handlers_1 = handlers; _i < handlers_1.length; _i++) {
                var handler = handlers_1[_i];
                handler[2].call(handler[0], err);
            }
        },
        // Just load a script; hardcoded jsonP call
        dataType: 'script',
        // Create url
        url: [
            COUNT_URL, '?',
            params.join('&'),
        ].join(''),
        // Check if handler was called
        success: function (data) {
            if (dispatched) {
                for (var _i = 0, handlers_2 = handlers; _i < handlers_2.length; _i++) {
                    var handler = handlers_2[_i];
                    handler[2].call(handler[0], data);
                }
            }
        },
    });
}
// Set up disqus jsonp
window.DISQUSWIDGETS = {
    displayCount: function (data) {
        dispatched = false;
        if (typeof data === 'object' && typeof data.text === 'object') {
            var counts = data.counts;
            for (var _i = 0, counts_1 = counts; _i < counts_1.length; _i++) {
                var countObj = counts_1[_i];
                var url = countObj.id, comments = countObj.comments;
                var callback = callbacks[url];
                if (!callback) {
                    continue;
                }
                callback[1].call(callback[0], { count: comments, id: url });
            }
        }
        // Dispatch more requests as long as we’re waiting for them
        if (dispatched) {
            dispatchRequest();
        }
        else {
            // Make sure we have no more pending callbacks
            // Resolve them with zero counts, since this happens
            // …whenever disqus is queried for urls it doesn't know
            for (var url in callbacks) {
                callbacks[url][1].call(callbacks[url][0], { id: url, count: 0 });
            }
        }
    },
};
var callbacks = {};
var dispatched = false;
function shareUrl() {
    throw new Error('Disqus does not support sharing');
}
var Disqus = /** @class */ (function () {
    function Disqus() {
        this.name = 'disqus';
        this.category = ['commentCount'];
        this.shareUrl = shareUrl;
    }
    Disqus.prototype.shareCount = function (url) {
        var _this = this;
        url = SCS.Url.stripPathPrefixFromUrl(url);
        // Create the main promise for this getter
        return new Promise(function (resolve, reject) {
            // Add this request to our queued items
            callbacks[url] = [_this, resolve, reject];
            // Register deferred call once to start the requests
            // We have to dispatch requests in sequence
            if (!dispatched) {
                dispatched = window.setTimeout(dispatchRequest, 0);
            }
        });
    };
    return Disqus;
}());


// CONCATENATED MODULE: ./clientlibs/js/lib/generic/socialmedia/services/SCShareCount.ts


// Base url to share something on swisscom
var SHARE_URL = '/portal-app/roamingtool/public/social-media-statistics';
// Base url to query the swisscom API
var SCShareCount_COUNT_URL = '/portal-app/roamingtool/public/social-media-statistics';
function shareCount(url, name) {
    url = SCS.Url.stripPathPrefixFromUrl(url);
    url = SCS.Url.stripProtocolFromUrl(url);
    return new Promise(function (resolve, reject) {
        external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_["ajax"]({
            // Get parameters to pass
            data: { url: encodeURI(url) },
            // Filled in by jquery
            dataType: 'json',
            // Pass through
            error: reject,
            // Extract count from response
            success: function (res) {
                var response = {
                    count: 0,
                };
                if (res && res[0] && res[0].services) {
                    for (var _i = 0, _a = res[0].services; _i < _a.length; _i++) {
                        var service = _a[_i];
                        if (service.service === name) {
                            response.count = service.count;
                            break;
                        }
                    }
                }
                // Call resolve
                resolve(response);
            },
            // Connection type
            type: 'GET',
            // Count url
            url: SCShareCount_COUNT_URL,
        });
    });
}
function SCShareCount_shareUrl(_url) {
    return SHARE_URL;
}
var SCShareCount = /** @class */ (function () {
    function SCShareCount() {
        this.name = 'SCShareCount';
        this.category = ['shareCount'];
        this.shareUrl = SCShareCount_shareUrl;
        this.shareCount = shareCount;
    }
    return SCShareCount;
}());


// CONCATENATED MODULE: ./clientlibs/js/lib/generic/socialmedia/services/Facebook.ts


var Facebook_Facebook = /** @class */ (function (_super) {
    Object(tslib_es6["c" /* __extends */])(Facebook, _super);
    function Facebook() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'facebook';
        return _this;
    }
    return Facebook;
}(SCShareCount));


// CONCATENATED MODULE: ./clientlibs/js/lib/generic/socialmedia/services/LinkedIn.ts


var LinkedIn_LinkedIn = /** @class */ (function (_super) {
    Object(tslib_es6["c" /* __extends */])(LinkedIn, _super);
    function LinkedIn() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'linkedin';
        return _this;
    }
    return LinkedIn;
}(SCShareCount));


// CONCATENATED MODULE: ./clientlibs/js/lib/generic/socialmedia/services/Mail.ts


var Mail_Mail = /** @class */ (function (_super) {
    Object(tslib_es6["c" /* __extends */])(Mail, _super);
    function Mail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'mail';
        return _this;
    }
    return Mail;
}(SCShareCount));


// CONCATENATED MODULE: ./clientlibs/js/lib/generic/socialmedia/services/Twitter.ts


var Twitter_Twitter = /** @class */ (function (_super) {
    Object(tslib_es6["c" /* __extends */])(Twitter, _super);
    function Twitter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'twitter';
        return _this;
    }
    return Twitter;
}(SCShareCount));


// CONCATENATED MODULE: ./clientlibs/js/lib/generic/socialmedia/services/WhatsApp.ts


var WhatsApp_WhatsApp = /** @class */ (function (_super) {
    Object(tslib_es6["c" /* __extends */])(WhatsApp, _super);
    function WhatsApp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'whatsapp';
        return _this;
    }
    return WhatsApp;
}(SCShareCount));


// CONCATENATED MODULE: ./clientlibs/js/lib/generic/socialmedia/services/Xing.ts


var Xing_Xing = /** @class */ (function (_super) {
    Object(tslib_es6["c" /* __extends */])(Xing, _super);
    function Xing() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'xing';
        return _this;
    }
    return Xing;
}(SCShareCount));


// CONCATENATED MODULE: ./clientlibs/js/lib/generic/socialmedia/SocialMedia.ts
/* harmony export (immutable) */ __webpack_exports__["decodeCount"] = decodeCount;
/* harmony export (immutable) */ __webpack_exports__["encodeCount"] = encodeCount;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SocialMedia", function() { return SocialMedia_SocialMedia; });
/* harmony export (immutable) */ __webpack_exports__["getController"] = getController;










function currentPageUrl() {
    // Dereference object once
    var loc = document.location;
    // Build page url
    var canonical = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_('link[rel=canonical]').attr('href');
    if (canonical) {
        return canonical;
    }
    return [
        loc.protocol,
        '//', loc.host,
        loc.pathname,
    ].join('');
}
// Conversion factors/units for counts
var FACTOR = 1000;
var UNITS = ['k', 'm'];
var UNIT_PATTERN = /^(\d)([km])$/;
// Resolve `2k` to `2000`
function decodeCount(count) {
    var parsedCount = String(count).toLowerCase();
    if (!UNIT_PATTERN.test(parsedCount)) {
        return parseInt(count, 10);
    }
    var f = UNITS.indexOf(RegExp.$2) + 1;
    return parseInt(RegExp.$1, 10) * Math.pow(FACTOR, f);
}
function encodeCount(count) {
    var f = 0;
    while (count > FACTOR) {
        count /= FACTOR;
        f += 1;
    }
    count = Math.floor(count);
    var parsedCount = String(count);
    if (f) {
        parsedCount += UNITS[f - 1];
    }
    return parsedCount.toUpperCase();
}
var SocialMedia_SocialMedia = /** @class */ (function () {
    function SocialMedia() {
        this.services = {};
    }
    SocialMedia.prototype.registerService = function (service) {
        // Implement assertions to validate data
        // This always indicates a developer error
        if (!service.name) {
            throw (new Error('SocialMediaService has no name'));
        }
        if (!service.category) {
            throw (new Error('SocialMediaService has no category'));
        }
        // Register service on manager instance
        this.services[service.name] = service;
    };
    SocialMedia.prototype.shareUrl = function (name, url) {
        return this.dispatchCall('shareUrl', name, url);
    };
    SocialMedia.prototype.shareCount = function (names, url) {
        var _this = this;
        url = SCS.Url.stripPathPrefixFromUrl(url);
        if (typeof names === 'string') {
            names = [names];
        }
        if (!Array.isArray(names)) {
            names = Object.keys(names);
        }
        var promises = names.map(function (name) {
            if (typeof name !== 'string') {
                name = name.name;
            }
            return _this
                .dispatchCall('shareCount', name, url)
                .then(function (rv) {
                if (!rv.count) {
                    rv.count = 0;
                }
                rv.count = decodeCount(rv.count);
                rv.fcount = encodeCount(rv.count);
                return rv;
            })
                .catch(function (e) {
                console.error(new Error('Error getting share count'), e);
                // Create fake response object with error
                var response = { count: 0, fcount: '0', error: _this };
                // Upgrade to a resolved promise
                return Promise.resolve(response);
            });
        });
        // Wait until all promises are resolved
        return Promise.all(promises).then(function (rv) {
            var aggregateCount = rv.reduce(function (count, item) {
                return count + (item.count || 0);
            }, 0);
            var aggregateFCount = encodeCount(aggregateCount);
            var result = rv;
            Object.assign(result, {
                count: aggregateCount,
                counts: aggregateCount,
                fcount: aggregateFCount,
                fcounts: aggregateFCount,
            });
            return result;
        });
    };
    SocialMedia.prototype.servicesByCategory = function (category) {
        var _this = this;
        return Object
            .keys(this.services)
            .map(function (name) { return _this.services[name]; })
            .filter(function (service) {
            return service.category.includes(category);
        });
    };
    SocialMedia.prototype.getRegisteredServices = function () {
        return Object(tslib_es6["a" /* __assign */])({}, this.services);
    };
    SocialMedia.prototype.dispatchCall = function (action, name, url) {
        // Get service from manager instance
        if (!(name in this.services)) {
            // Throw an error if service is not known
            // This always indicates a developer error
            throw (new Error('unknown social media service: ' + name));
        }
        var service = this.services[name];
        // Maybe use url of current page
        if (!url) {
            url = currentPageUrl();
        }
        var fn = (service[action]);
        // Dispatch to the given action
        return fn.call(this, url, name);
    };
    return SocialMedia;
}());

var singleton;
function getController() {
    if (!singleton) {
        singleton = new SocialMedia_SocialMedia();
        singleton.registerService(new Disqus());
        singleton.registerService(new Facebook_Facebook());
        singleton.registerService(new LinkedIn_LinkedIn());
        singleton.registerService(new Mail_Mail());
        singleton.registerService(new Twitter_Twitter());
        singleton.registerService(new WhatsApp_WhatsApp());
        singleton.registerService(new Xing_Xing());
    }
    return singleton;
}


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/snabbdom/es/vnode.js
function vnode_vnode(sel, data, children, text, elm) {
    var key = data === undefined ? undefined : data.key;
    return { sel: sel, data: data, children: children,
        text: text, elm: elm, key: key };
}
/* harmony default export */ var es_vnode = (vnode_vnode);
//# sourceMappingURL=vnode.js.map
// CONCATENATED MODULE: ./node_modules/snabbdom/es/is.js
var array = Array.isArray;
function primitive(s) {
    return typeof s === 'string' || typeof s === 'number';
}
//# sourceMappingURL=is.js.map
// CONCATENATED MODULE: ./node_modules/snabbdom/es/htmldomapi.js
function createElement(tagName) {
    return document.createElement(tagName);
}
function createElementNS(namespaceURI, qualifiedName) {
    return document.createElementNS(namespaceURI, qualifiedName);
}
function createTextNode(text) {
    return document.createTextNode(text);
}
function createComment(text) {
    return document.createComment(text);
}
function insertBefore(parentNode, newNode, referenceNode) {
    parentNode.insertBefore(newNode, referenceNode);
}
function removeChild(node, child) {
    node.removeChild(child);
}
function appendChild(node, child) {
    node.appendChild(child);
}
function parentNode(node) {
    return node.parentNode;
}
function nextSibling(node) {
    return node.nextSibling;
}
function tagName(elm) {
    return elm.tagName;
}
function setTextContent(node, text) {
    node.textContent = text;
}
function getTextContent(node) {
    return node.textContent;
}
function isElement(node) {
    return node.nodeType === 1;
}
function isText(node) {
    return node.nodeType === 3;
}
function isComment(node) {
    return node.nodeType === 8;
}
var htmlDomApi = {
    createElement: createElement,
    createElementNS: createElementNS,
    createTextNode: createTextNode,
    createComment: createComment,
    insertBefore: insertBefore,
    removeChild: removeChild,
    appendChild: appendChild,
    parentNode: parentNode,
    nextSibling: nextSibling,
    tagName: tagName,
    setTextContent: setTextContent,
    getTextContent: getTextContent,
    isElement: isElement,
    isText: isText,
    isComment: isComment,
};
/* harmony default export */ var htmldomapi = (htmlDomApi);
//# sourceMappingURL=htmldomapi.js.map
// CONCATENATED MODULE: ./node_modules/snabbdom/es/h.js


function addNS(data, children, sel) {
    data.ns = 'http://www.w3.org/2000/svg';
    if (sel !== 'foreignObject' && children !== undefined) {
        for (var i = 0; i < children.length; ++i) {
            var childData = children[i].data;
            if (childData !== undefined) {
                addNS(childData, children[i].children, children[i].sel);
            }
        }
    }
}
function h(sel, b, c) {
    var data = {}, children, text, i;
    if (c !== undefined) {
        data = b;
        if (array(c)) {
            children = c;
        }
        else if (primitive(c)) {
            text = c;
        }
        else if (c && c.sel) {
            children = [c];
        }
    }
    else if (b !== undefined) {
        if (array(b)) {
            children = b;
        }
        else if (primitive(b)) {
            text = b;
        }
        else if (b && b.sel) {
            children = [b];
        }
        else {
            data = b;
        }
    }
    if (children !== undefined) {
        for (i = 0; i < children.length; ++i) {
            if (primitive(children[i]))
                children[i] = vnode_vnode(undefined, undefined, undefined, children[i], undefined);
        }
    }
    if (sel[0] === 's' && sel[1] === 'v' && sel[2] === 'g' &&
        (sel.length === 3 || sel[3] === '.' || sel[3] === '#')) {
        addNS(data, children, sel);
    }
    return vnode_vnode(sel, data, children, text, undefined);
}
;
/* harmony default export */ var es_h = (h);
//# sourceMappingURL=h.js.map
// CONCATENATED MODULE: ./node_modules/snabbdom/es/thunk.js

function copyToThunk(vnode, thunk) {
    thunk.elm = vnode.elm;
    vnode.data.fn = thunk.data.fn;
    vnode.data.args = thunk.data.args;
    thunk.data = vnode.data;
    thunk.children = vnode.children;
    thunk.text = vnode.text;
    thunk.elm = vnode.elm;
}
function init(thunk) {
    var cur = thunk.data;
    var vnode = cur.fn.apply(undefined, cur.args);
    copyToThunk(vnode, thunk);
}
function prepatch(oldVnode, thunk) {
    var i, old = oldVnode.data, cur = thunk.data;
    var oldArgs = old.args, args = cur.args;
    if (old.fn !== cur.fn || oldArgs.length !== args.length) {
        copyToThunk(cur.fn.apply(undefined, args), thunk);
        return;
    }
    for (i = 0; i < args.length; ++i) {
        if (oldArgs[i] !== args[i]) {
            copyToThunk(cur.fn.apply(undefined, args), thunk);
            return;
        }
    }
    copyToThunk(oldVnode, thunk);
}
var thunk_thunk = function thunk(sel, key, fn, args) {
    if (args === undefined) {
        args = fn;
        fn = key;
        key = undefined;
    }
    return h(sel, {
        key: key,
        hook: { init: init, prepatch: prepatch },
        fn: fn,
        args: args
    });
};
/* harmony default export */ var es_thunk = (thunk_thunk);
//# sourceMappingURL=thunk.js.map
// CONCATENATED MODULE: ./node_modules/snabbdom/es/snabbdom.js



function isUndef(s) { return s === undefined; }
function isDef(s) { return s !== undefined; }
var emptyNode = es_vnode('', {}, [], undefined, undefined);
function sameVnode(vnode1, vnode2) {
    return vnode1.key === vnode2.key && vnode1.sel === vnode2.sel;
}
function isVnode(vnode) {
    return vnode.sel !== undefined;
}
function createKeyToOldIdx(children, beginIdx, endIdx) {
    var i, map = {}, key, ch;
    for (i = beginIdx; i <= endIdx; ++i) {
        ch = children[i];
        if (ch != null) {
            key = ch.key;
            if (key !== undefined)
                map[key] = i;
        }
    }
    return map;
}
var hooks = ['create', 'update', 'remove', 'destroy', 'pre', 'post'];


function snabbdom_init(modules, domApi) {
    var i, j, cbs = {};
    var api = domApi !== undefined ? domApi : htmldomapi;
    for (i = 0; i < hooks.length; ++i) {
        cbs[hooks[i]] = [];
        for (j = 0; j < modules.length; ++j) {
            var hook = modules[j][hooks[i]];
            if (hook !== undefined) {
                cbs[hooks[i]].push(hook);
            }
        }
    }
    function emptyNodeAt(elm) {
        var id = elm.id ? '#' + elm.id : '';
        var c = elm.className ? '.' + elm.className.split(' ').join('.') : '';
        return es_vnode(api.tagName(elm).toLowerCase() + id + c, {}, [], undefined, elm);
    }
    function createRmCb(childElm, listeners) {
        return function rmCb() {
            if (--listeners === 0) {
                var parent_1 = api.parentNode(childElm);
                api.removeChild(parent_1, childElm);
            }
        };
    }
    function createElm(vnode, insertedVnodeQueue) {
        var i, data = vnode.data;
        if (data !== undefined) {
            if (isDef(i = data.hook) && isDef(i = i.init)) {
                i(vnode);
                data = vnode.data;
            }
        }
        var children = vnode.children, sel = vnode.sel;
        if (sel === '!') {
            if (isUndef(vnode.text)) {
                vnode.text = '';
            }
            vnode.elm = api.createComment(vnode.text);
        }
        else if (sel !== undefined) {
            // Parse selector
            var hashIdx = sel.indexOf('#');
            var dotIdx = sel.indexOf('.', hashIdx);
            var hash = hashIdx > 0 ? hashIdx : sel.length;
            var dot = dotIdx > 0 ? dotIdx : sel.length;
            var tag = hashIdx !== -1 || dotIdx !== -1 ? sel.slice(0, Math.min(hash, dot)) : sel;
            var elm = vnode.elm = isDef(data) && isDef(i = data.ns) ? api.createElementNS(i, tag)
                : api.createElement(tag);
            if (hash < dot)
                elm.setAttribute('id', sel.slice(hash + 1, dot));
            if (dotIdx > 0)
                elm.setAttribute('class', sel.slice(dot + 1).replace(/\./g, ' '));
            for (i = 0; i < cbs.create.length; ++i)
                cbs.create[i](emptyNode, vnode);
            if (array(children)) {
                for (i = 0; i < children.length; ++i) {
                    var ch = children[i];
                    if (ch != null) {
                        api.appendChild(elm, createElm(ch, insertedVnodeQueue));
                    }
                }
            }
            else if (primitive(vnode.text)) {
                api.appendChild(elm, api.createTextNode(vnode.text));
            }
            i = vnode.data.hook; // Reuse variable
            if (isDef(i)) {
                if (i.create)
                    i.create(emptyNode, vnode);
                if (i.insert)
                    insertedVnodeQueue.push(vnode);
            }
        }
        else {
            vnode.elm = api.createTextNode(vnode.text);
        }
        return vnode.elm;
    }
    function addVnodes(parentElm, before, vnodes, startIdx, endIdx, insertedVnodeQueue) {
        for (; startIdx <= endIdx; ++startIdx) {
            var ch = vnodes[startIdx];
            if (ch != null) {
                api.insertBefore(parentElm, createElm(ch, insertedVnodeQueue), before);
            }
        }
    }
    function invokeDestroyHook(vnode) {
        var i, j, data = vnode.data;
        if (data !== undefined) {
            if (isDef(i = data.hook) && isDef(i = i.destroy))
                i(vnode);
            for (i = 0; i < cbs.destroy.length; ++i)
                cbs.destroy[i](vnode);
            if (vnode.children !== undefined) {
                for (j = 0; j < vnode.children.length; ++j) {
                    i = vnode.children[j];
                    if (i != null && typeof i !== "string") {
                        invokeDestroyHook(i);
                    }
                }
            }
        }
    }
    function removeVnodes(parentElm, vnodes, startIdx, endIdx) {
        for (; startIdx <= endIdx; ++startIdx) {
            var i_1 = void 0, listeners = void 0, rm = void 0, ch = vnodes[startIdx];
            if (ch != null) {
                if (isDef(ch.sel)) {
                    invokeDestroyHook(ch);
                    listeners = cbs.remove.length + 1;
                    rm = createRmCb(ch.elm, listeners);
                    for (i_1 = 0; i_1 < cbs.remove.length; ++i_1)
                        cbs.remove[i_1](ch, rm);
                    if (isDef(i_1 = ch.data) && isDef(i_1 = i_1.hook) && isDef(i_1 = i_1.remove)) {
                        i_1(ch, rm);
                    }
                    else {
                        rm();
                    }
                }
                else {
                    api.removeChild(parentElm, ch.elm);
                }
            }
        }
    }
    function updateChildren(parentElm, oldCh, newCh, insertedVnodeQueue) {
        var oldStartIdx = 0, newStartIdx = 0;
        var oldEndIdx = oldCh.length - 1;
        var oldStartVnode = oldCh[0];
        var oldEndVnode = oldCh[oldEndIdx];
        var newEndIdx = newCh.length - 1;
        var newStartVnode = newCh[0];
        var newEndVnode = newCh[newEndIdx];
        var oldKeyToIdx;
        var idxInOld;
        var elmToMove;
        var before;
        while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
            if (oldStartVnode == null) {
                oldStartVnode = oldCh[++oldStartIdx]; // Vnode might have been moved left
            }
            else if (oldEndVnode == null) {
                oldEndVnode = oldCh[--oldEndIdx];
            }
            else if (newStartVnode == null) {
                newStartVnode = newCh[++newStartIdx];
            }
            else if (newEndVnode == null) {
                newEndVnode = newCh[--newEndIdx];
            }
            else if (sameVnode(oldStartVnode, newStartVnode)) {
                patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
                oldStartVnode = oldCh[++oldStartIdx];
                newStartVnode = newCh[++newStartIdx];
            }
            else if (sameVnode(oldEndVnode, newEndVnode)) {
                patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
                oldEndVnode = oldCh[--oldEndIdx];
                newEndVnode = newCh[--newEndIdx];
            }
            else if (sameVnode(oldStartVnode, newEndVnode)) {
                patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
                api.insertBefore(parentElm, oldStartVnode.elm, api.nextSibling(oldEndVnode.elm));
                oldStartVnode = oldCh[++oldStartIdx];
                newEndVnode = newCh[--newEndIdx];
            }
            else if (sameVnode(oldEndVnode, newStartVnode)) {
                patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
                api.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
                oldEndVnode = oldCh[--oldEndIdx];
                newStartVnode = newCh[++newStartIdx];
            }
            else {
                if (oldKeyToIdx === undefined) {
                    oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
                }
                idxInOld = oldKeyToIdx[newStartVnode.key];
                if (isUndef(idxInOld)) {
                    api.insertBefore(parentElm, createElm(newStartVnode, insertedVnodeQueue), oldStartVnode.elm);
                    newStartVnode = newCh[++newStartIdx];
                }
                else {
                    elmToMove = oldCh[idxInOld];
                    if (elmToMove.sel !== newStartVnode.sel) {
                        api.insertBefore(parentElm, createElm(newStartVnode, insertedVnodeQueue), oldStartVnode.elm);
                    }
                    else {
                        patchVnode(elmToMove, newStartVnode, insertedVnodeQueue);
                        oldCh[idxInOld] = undefined;
                        api.insertBefore(parentElm, elmToMove.elm, oldStartVnode.elm);
                    }
                    newStartVnode = newCh[++newStartIdx];
                }
            }
        }
        if (oldStartIdx <= oldEndIdx || newStartIdx <= newEndIdx) {
            if (oldStartIdx > oldEndIdx) {
                before = newCh[newEndIdx + 1] == null ? null : newCh[newEndIdx + 1].elm;
                addVnodes(parentElm, before, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
            }
            else {
                removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
            }
        }
    }
    function patchVnode(oldVnode, vnode, insertedVnodeQueue) {
        var i, hook;
        if (isDef(i = vnode.data) && isDef(hook = i.hook) && isDef(i = hook.prepatch)) {
            i(oldVnode, vnode);
        }
        var elm = vnode.elm = oldVnode.elm;
        var oldCh = oldVnode.children;
        var ch = vnode.children;
        if (oldVnode === vnode)
            return;
        if (vnode.data !== undefined) {
            for (i = 0; i < cbs.update.length; ++i)
                cbs.update[i](oldVnode, vnode);
            i = vnode.data.hook;
            if (isDef(i) && isDef(i = i.update))
                i(oldVnode, vnode);
        }
        if (isUndef(vnode.text)) {
            if (isDef(oldCh) && isDef(ch)) {
                if (oldCh !== ch)
                    updateChildren(elm, oldCh, ch, insertedVnodeQueue);
            }
            else if (isDef(ch)) {
                if (isDef(oldVnode.text))
                    api.setTextContent(elm, '');
                addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
            }
            else if (isDef(oldCh)) {
                removeVnodes(elm, oldCh, 0, oldCh.length - 1);
            }
            else if (isDef(oldVnode.text)) {
                api.setTextContent(elm, '');
            }
        }
        else if (oldVnode.text !== vnode.text) {
            if (isDef(oldCh)) {
                removeVnodes(elm, oldCh, 0, oldCh.length - 1);
            }
            api.setTextContent(elm, vnode.text);
        }
        if (isDef(hook) && isDef(i = hook.postpatch)) {
            i(oldVnode, vnode);
        }
    }
    return function patch(oldVnode, vnode) {
        var i, elm, parent;
        var insertedVnodeQueue = [];
        for (i = 0; i < cbs.pre.length; ++i)
            cbs.pre[i]();
        if (!isVnode(oldVnode)) {
            oldVnode = emptyNodeAt(oldVnode);
        }
        if (sameVnode(oldVnode, vnode)) {
            patchVnode(oldVnode, vnode, insertedVnodeQueue);
        }
        else {
            elm = oldVnode.elm;
            parent = api.parentNode(elm);
            createElm(vnode, insertedVnodeQueue);
            if (parent !== null) {
                api.insertBefore(parent, vnode.elm, api.nextSibling(elm));
                removeVnodes(parent, [oldVnode], 0, 0);
            }
        }
        for (i = 0; i < insertedVnodeQueue.length; ++i) {
            insertedVnodeQueue[i].data.hook.insert(insertedVnodeQueue[i]);
        }
        for (i = 0; i < cbs.post.length; ++i)
            cbs.post[i]();
        return vnode;
    };
}
//# sourceMappingURL=snabbdom.js.map
// EXTERNAL MODULE: ./node_modules/snabbdom/modules/attributes.js
var attributes = __webpack_require__(83);
var attributes_default = /*#__PURE__*/__webpack_require__.n(attributes);

// EXTERNAL MODULE: ./node_modules/snabbdom/modules/props.js
var props = __webpack_require__(84);
var props_default = /*#__PURE__*/__webpack_require__.n(props);

// EXTERNAL MODULE: ./node_modules/snabbdom/modules/style.js
var style = __webpack_require__(85);
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./node_modules/snabbdom/modules/eventlisteners.js
var eventlisteners = __webpack_require__(86);
var eventlisteners_default = /*#__PURE__*/__webpack_require__.n(eventlisteners);

// EXTERNAL MODULE: ./node_modules/snabbdom/modules/class.js
var modules_class = __webpack_require__(87);
var class_default = /*#__PURE__*/__webpack_require__.n(modules_class);

// CONCATENATED MODULE: ./clientlibs/js/bootstrap/load-snabbdom.ts
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return patch; });
/* unused concated harmony import h */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return h; });







var patch = snabbdom_init([
    attributes_default.a,
    props_default.a,
    style_default.a,
    eventlisteners_default.a,
    class_default.a,
]);
var snabbdom = {
    h: h,
    // Configure the required modules here,
    patch: patch,
};
window.snabbdom = snabbdom;
/* harmony default export */ var load_snabbdom = (snabbdom);


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(2);

// EXTERNAL MODULE: external "(window._g && _g.$) || window.$CQ || window.$ || window.jQuery"
var external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_ = __webpack_require__(0);
var external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default = /*#__PURE__*/__webpack_require__.n(external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_);

// CONCATENATED MODULE: ./clientlibs/js/lib/util/array.ts
/**
 * For removing duplicate items from an array
 * Guarantees the original order of all non-duplicated items
 * Usage: [1, 2, 1].filter(onlyUnique)
 */
function onlyUnique(value, index, self) {
    return Array.prototype.indexOf.call(self, value) === index;
}
/**
 * Uniquifies an entire array, with no guarantees as to ordering
 * @param arr the array to make unique
 */
var unique = function (arr) {
    return arr.filter(onlyUnique);
};
// Fast-path version for modern browsers
if ('Set' in window && 'from' in Array && (new Set([1])).size) {
    // IE 11 supports set and Array.from but not initializing a set with a pre-existing array.
    unique = function (arr) {
        return Array.from(new Set(arr));
    };
}

function flatten(arr) {
    var _a;
    return (_a = []).concat.apply(_a, arr);
}

// CONCATENATED MODULE: ./clientlibs/js/lib/personalization/profile.ts
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CFU", function() { return CFU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "User", function() { return profile_User; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Profile", function() { return Profile; });
/* harmony export (immutable) */ __webpack_exports__["getProfile"] = getProfile;



var devMode = !!(window.location.search + window.location.hash).match(/\bdevconsole\b/);
var CFU;
(function (CFU) {
    CFU["RES"] = "res";
    CFU["SME"] = "sme";
    CFU["CBU"] = "cbu";
})(CFU || (CFU = {}));
var profile_User = /** @class */ (function () {
    function User(data) {
        this.data = data;
    }
    User.prototype.getId = function () {
        return this.data.cust_scn;
    };
    User.prototype.getFirstName = function () {
        return decodeURIComponent(this.data.cust_fname || '');
    };
    User.prototype.getLastName = function () {
        return decodeURIComponent(this.data.cust_lname || '');
    };
    User.prototype.getAuthLevel = function () {
        return decodeURIComponent(this.data.session_authlevel || '');
    };
    /**
     * Get full name (first and last)
     */
    User.prototype.getFullName = function () {
        if (this.isSegmentSme() || this.isSegmentCbu()) {
            // We only use the last name in this case, which contains the company name.
            return this.getLastName();
        }
        return [
            this.getFirstName(),
            this.getLastName(),
        ]
            .filter(Boolean)
            .filter(onlyUnique)
            .join(' ');
    };
    User.prototype.getSegment = function () {
        return this.data.cust_segment || CFU.RES;
    };
    User.prototype.isSegmentSme = function () {
        return this.getSegment() === CFU.SME;
    };
    User.prototype.isSegmentCbu = function () {
        return this.getSegment() === CFU.CBU;
    };
    User.prototype.isSegmentRes = function () {
        return this.getSegment() === CFU.RES;
    };
    return User;
}());

var Profile = /** @class */ (function () {
    function Profile(user) {
        this.user = user;
    }
    Profile.prototype.getUser = function () {
        return this.user;
    };
    return Profile;
}());

var KEY = 'scsHeader.profile.loginData';
// FIXME: Use OCE MiSe
function fetchProfile() {
    return Object(tslib_es6["b" /* __awaiter */])(this, void 0, void 0, function () {
        var contents, e_1;
        return Object(tslib_es6["d" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, new Promise(function (resolve, reject) {
                            external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.get('/etc/profile.json').done(resolve).fail(reject);
                        })];
                case 1:
                    contents = _a.sent();
                    if (KEY in contents) {
                        // KEY existing means this is a logged-in user
                        return [2 /*return*/, new Profile(new profile_User(contents[KEY]))];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    if (devMode) {
                        console.error('Profile JSON data not in expected format', e_1);
                    }
                    return [2 /*return*/, new Profile()];
                case 3: 
                // User not logged in
                return [2 /*return*/, new Profile()];
            }
        });
    });
}
var profile;
function getProfile() {
    if (!profile) {
        profile = fetchProfile();
    }
    return profile;
}


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/jspolyfill-array.prototype.find/find.js
var find = __webpack_require__(17);
var find_default = /*#__PURE__*/__webpack_require__.n(find);

// EXTERNAL MODULE: ./node_modules/promise-polyfill/src/index.js
var src = __webpack_require__(18);

// EXTERNAL MODULE: ./node_modules/url-polyfill/url-polyfill.js
var url_polyfill = __webpack_require__(22);
var url_polyfill_default = /*#__PURE__*/__webpack_require__.n(url_polyfill);

// CONCATENATED MODULE: ./clientlibs/js/bootstrap/polyfills.ts
/**
 * Polyfills for old browsers.
 *
 * Please remove each polyfill whose market share of browsers needing it drops below 1%
 */
// Array.prototype.find

// Math.sign (used in SDX ProgressFull)
if (!('sign' in Math)) {
    Math.sign = function (x) {
        return ((x > 0) - (x < 0)) || +x;
    };
}
// Number.isNaN for IE11 and older
// From  https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/Number/isNaN#Polyfill
if (!('isNaN' in Number)) {
    Number.isNaN = function (value) {
        // NaN is the only value in javascript which is not equal to itself.
        // tslint:disable-next-line: no-tautology-expression
        return value !== value;
    };
}
// String.startsWith for IE11 and friends
// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith#Polyfill
if (!('startsWith' in String.prototype)) {
    Object.defineProperty(String.prototype, 'startsWith', {
        configurable: true,
        value: function (search, pos) {
            search = String(search);
            var startIndex = (!pos || pos < 0) ? 0 : Number(pos);
            var endIndex = startIndex + search.length;
            return this.substring(startIndex, endIndex) === search;
        },
        writable: true,
    });
}
// Promise/A

// To add to window
if (!('Promise' in window)) {
    window.Promise = src["a" /* default */];
}
// URL and URLSearchParams

/* Some polyfills are explicitly loaded for certain libraries:
 * etc/designs/portal/clientlibs/shared/js/vendor/smooth-scroll.ts
 * // import 'element-closest';
 * // import 'custom-event-polyfill';
 * // import 'request-animation-frame-polyfill';
*/

// EXTERNAL MODULE: ./clientlibs/js/bootstrap/load-qtip.ts
var load_qtip = __webpack_require__(9);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/emagazine/clientlibs/publish/js/libs/jquery.dotdotdot.min.js
var jquery_dotdotdot_min = __webpack_require__(24);
var jquery_dotdotdot_min_default = /*#__PURE__*/__webpack_require__.n(jquery_dotdotdot_min);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/emagazine/clientlibs/publish/js/libs/jquery-ui-1.10.4.custom.min.js
var jquery_ui_1_10_4_custom_min = __webpack_require__(25);
var jquery_ui_1_10_4_custom_min_default = /*#__PURE__*/__webpack_require__.n(jquery_ui_1_10_4_custom_min);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/emagazine/clientlibs/publish/js/libs/jquery.slides.js
var jquery_slides = __webpack_require__(26);
var jquery_slides_default = /*#__PURE__*/__webpack_require__.n(jquery_slides);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/emagazine/clientlibs/publish/js/libs/extensions.js
var extensions = __webpack_require__(27);
var extensions_default = /*#__PURE__*/__webpack_require__.n(extensions);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/emagazine/clientlibs/publish/js/libs/jquery.colorbox.js
var jquery_colorbox = __webpack_require__(28);
var jquery_colorbox_default = /*#__PURE__*/__webpack_require__.n(jquery_colorbox);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/emagazine/clientlibs/publish/js/libs/jquery.selectboxit.js
var jquery_selectboxit = __webpack_require__(29);
var jquery_selectboxit_default = /*#__PURE__*/__webpack_require__.n(jquery_selectboxit);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/emagazine/clientlibs/publish/js/libs/breakpoints.js
var breakpoints = __webpack_require__(30);
var breakpoints_default = /*#__PURE__*/__webpack_require__.n(breakpoints);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/emagazine/clientlibs/publish/js/global.js
var global = __webpack_require__(31);
var global_default = /*#__PURE__*/__webpack_require__.n(global);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/emagazine/clientlibs/publish/js/main.js
var main = __webpack_require__(32);
var main_default = /*#__PURE__*/__webpack_require__.n(main);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/libraries/SCS.utils.js
var SCS_utils = __webpack_require__(33);
var SCS_utils_default = /*#__PURE__*/__webpack_require__.n(SCS_utils);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/vendor/ba-debug.min.js
var ba_debug_min = __webpack_require__(11);
var ba_debug_min_default = /*#__PURE__*/__webpack_require__.n(ba_debug_min);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/libraries/SCS.Captcha.js
var SCS_Captcha = __webpack_require__(36);
var SCS_Captcha_default = /*#__PURE__*/__webpack_require__.n(SCS_Captcha);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.BackgroundContainer.js
var Tc_Module_BackgroundContainer = __webpack_require__(37);
var Tc_Module_BackgroundContainer_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_BackgroundContainer);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/js/modules/Tc.Module.BrightcoveVideo.js
var Tc_Module_BrightcoveVideo = __webpack_require__(12);
var Tc_Module_BrightcoveVideo_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_BrightcoveVideo);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/modules/Tc.Module.Captcha.js
var Tc_Module_Captcha = __webpack_require__(39);
var Tc_Module_Captcha_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_Captcha);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/emagazine/clientlibs/publish/js/modules/Tc.Module.ImagesSlider.js
var Tc_Module_ImagesSlider = __webpack_require__(40);
var Tc_Module_ImagesSlider_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_ImagesSlider);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/emagazine/clientlibs/publish/js/modules/Tc.Module.Linklist.js
var Tc_Module_Linklist = __webpack_require__(41);
var Tc_Module_Linklist_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_Linklist);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/emagazine/clientlibs/publish/js/modules/Tc.Module.Newsitem.js
var Tc_Module_Newsitem = __webpack_require__(42);
var Tc_Module_Newsitem_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_Newsitem);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/emagazine/clientlibs/publish/js/modules/Tc.Module.FileUpload.js
var Tc_Module_FileUpload = __webpack_require__(43);
var Tc_Module_FileUpload_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_FileUpload);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/js/modules/Tc.Module.SocialShare.js
var Tc_Module_SocialShare = __webpack_require__(44);
var Tc_Module_SocialShare_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_SocialShare);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/emagazine/clientlibs/publish/js/modules/Tc.Module.Splashscreen.js
var Tc_Module_Splashscreen = __webpack_require__(45);
var Tc_Module_Splashscreen_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_Splashscreen);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/emagazine/clientlibs/publish/js/modules/Tc.Module.VideoContainer.js
var Tc_Module_VideoContainer = __webpack_require__(46);
var Tc_Module_VideoContainer_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_VideoContainer);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/emagazine/clientlibs/publish/js/modules/Tc.Module.Selectbox.js
var Tc_Module_Selectbox = __webpack_require__(47);
var Tc_Module_Selectbox_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_Selectbox);

// EXTERNAL MODULE: ./clientlibs/js/lib/sdx/Tc.Module.CallOut.ts
var Tc_Module_CallOut = __webpack_require__(48);

// EXTERNAL MODULE: ./clientlibs/js/bootstrap/load-terrific.ts + 5 modules
var load_terrific = __webpack_require__(1);

// CONCATENATED MODULE: ./clientlibs/js/by-category/scs.emag.publish.ts
// # Libraries
// # ------------------------------------------------------------------------------













// # Terrific Modules
// # ------------------------------------------------------------------------------












var modernTcModules = {
    CallOut: Tc_Module_CallOut["a" /* default */],
};
// Tc Bootstrap

Object(load_terrific["legacyBootstrapDeferredSingleton"])(modernTcModules);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/SearchProcessor.js
var SearchProcessor = __webpack_require__(49);
var SearchProcessor_default = /*#__PURE__*/__webpack_require__.n(SearchProcessor);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/util/backends.js
var backends = __webpack_require__(50);
var backends_default = /*#__PURE__*/__webpack_require__.n(backends);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/util/responders.js
var responders = __webpack_require__(51);
var responders_default = /*#__PURE__*/__webpack_require__.n(responders);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/util/shims.js
var shims = __webpack_require__(52);
var shims_default = /*#__PURE__*/__webpack_require__.n(shims);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/plugins/autosuggest.js
var autosuggest = __webpack_require__(53);
var autosuggest_default = /*#__PURE__*/__webpack_require__.n(autosuggest);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/plugins/filtering.js
var filtering = __webpack_require__(54);
var filtering_default = /*#__PURE__*/__webpack_require__.n(filtering);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/plugins/gsa-handling.js
var gsa_handling = __webpack_require__(55);
var gsa_handling_default = /*#__PURE__*/__webpack_require__.n(gsa_handling);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/plugins/keymatch-handling.js
var keymatch_handling = __webpack_require__(56);
var keymatch_handling_default = /*#__PURE__*/__webpack_require__.n(keymatch_handling);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/plugins/session-handling.js
var session_handling = __webpack_require__(57);
var session_handling_default = /*#__PURE__*/__webpack_require__.n(session_handling);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/plugins/spellchecking.js
var spellchecking = __webpack_require__(58);
var spellchecking_default = /*#__PURE__*/__webpack_require__.n(spellchecking);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/plugins/tracking.js
var tracking = __webpack_require__(59);
var tracking_default = /*#__PURE__*/__webpack_require__.n(tracking);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/plugins/url-handling.js
var url_handling = __webpack_require__(60);
var url_handling_default = /*#__PURE__*/__webpack_require__.n(url_handling);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/plugins/web.js
var web = __webpack_require__(61);
var web_default = /*#__PURE__*/__webpack_require__.n(web);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/trackers/gsa.js
var gsa = __webpack_require__(62);
var gsa_default = /*#__PURE__*/__webpack_require__.n(gsa);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/trackers/sc.js
var sc = __webpack_require__(63);
var sc_default = /*#__PURE__*/__webpack_require__.n(sc);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/orchestration.js
var orchestration = __webpack_require__(64);
var orchestration_default = /*#__PURE__*/__webpack_require__.n(orchestration);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.HeaderSearchQueryForm.js
var Tc_Module_HeaderSearchQueryForm = __webpack_require__(65);
var Tc_Module_HeaderSearchQueryForm_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_HeaderSearchQueryForm);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.OftenSearchedLinkBox.js
var Tc_Module_OftenSearchedLinkBox = __webpack_require__(66);
var Tc_Module_OftenSearchedLinkBox_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_OftenSearchedLinkBox);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchClusterSuggestions.js
var Tc_Module_SearchClusterSuggestions = __webpack_require__(67);
var Tc_Module_SearchClusterSuggestions_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_SearchClusterSuggestions);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchPreviewLink.js
var Tc_Module_SearchPreviewLink = __webpack_require__(68);
var Tc_Module_SearchPreviewLink_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_SearchPreviewLink);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchPromoBox.js
var Tc_Module_SearchPromoBox = __webpack_require__(69);
var Tc_Module_SearchPromoBox_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_SearchPromoBox);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchPromoContainer.js
var Tc_Module_SearchPromoContainer = __webpack_require__(70);
var Tc_Module_SearchPromoContainer_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_SearchPromoContainer);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchResultContainer.js
var Tc_Module_SearchResultContainer = __webpack_require__(71);
var Tc_Module_SearchResultContainer_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_SearchResultContainer);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchResultDisplay.js
var Tc_Module_SearchResultDisplay = __webpack_require__(72);
var Tc_Module_SearchResultDisplay_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_SearchResultDisplay);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchResultDisplay.Web.js
var Tc_Module_SearchResultDisplay_Web = __webpack_require__(73);
var Tc_Module_SearchResultDisplay_Web_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_SearchResultDisplay_Web);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchResultFilter.js
var Tc_Module_SearchResultFilter = __webpack_require__(74);
var Tc_Module_SearchResultFilter_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_SearchResultFilter);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchResultQueryBox.js
var Tc_Module_SearchResultQueryBox = __webpack_require__(75);
var Tc_Module_SearchResultQueryBox_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_SearchResultQueryBox);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchResultTitle.js
var Tc_Module_SearchResultTitle = __webpack_require__(76);
var Tc_Module_SearchResultTitle_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_SearchResultTitle);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchTopResults.js
var Tc_Module_SearchTopResults = __webpack_require__(77);
var Tc_Module_SearchTopResults_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_SearchTopResults);

// CONCATENATED MODULE: ./clientlibs/js/by-category/scs.sitesearch.ts
// #base=etc/designs/sitesearch/clientlibs/logic/processing/js
















// #base=etc/designs/sitesearch/clientlibs/logic/gui/js/modules














// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(78);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./clientlibs/js/bootstrap/load-moment.ts

window.moment = moment_default.a;
/* harmony default export */ var load_moment = (moment_default.a);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/vendor/jquery.cookies.2.2.0.min.js
var jquery_cookies_2_2_0_min = __webpack_require__(80);
var jquery_cookies_2_2_0_min_default = /*#__PURE__*/__webpack_require__.n(jquery_cookies_2_2_0_min);

// EXTERNAL MODULE: ./node_modules/@swisscom/bxslider/dist/jquery.bxslider.js
var jquery_bxslider = __webpack_require__(81);
var jquery_bxslider_default = /*#__PURE__*/__webpack_require__.n(jquery_bxslider);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/vendor/yepnope.1.5.4-min.js
var yepnope_1_5_4_min = __webpack_require__(82);
var yepnope_1_5_4_min_default = /*#__PURE__*/__webpack_require__.n(yepnope_1_5_4_min);

// EXTERNAL MODULE: ./clientlibs/js/bootstrap/load-snabbdom.ts + 6 modules
var load_snabbdom = __webpack_require__(14);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/libraries/scCookie.js
var scCookie = __webpack_require__(88);
var scCookie_default = /*#__PURE__*/__webpack_require__.n(scCookie);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/libraries/SCS.hashdeeplink.js
var SCS_hashdeeplink = __webpack_require__(89);
var SCS_hashdeeplink_default = /*#__PURE__*/__webpack_require__.n(SCS_hashdeeplink);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/js/modules/Tc.Module.GoogleMaps.js
var Tc_Module_GoogleMaps = __webpack_require__(90);
var Tc_Module_GoogleMaps_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_GoogleMaps);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/js/modules/Tc.Module.Slider.js
var Tc_Module_Slider = __webpack_require__(91);
var Tc_Module_Slider_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_Slider);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/js/modules/Tc.Module.Slider.RotatingTeaser.js
var Tc_Module_Slider_RotatingTeaser = __webpack_require__(92);
var Tc_Module_Slider_RotatingTeaser_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_Slider_RotatingTeaser);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/js/modules/Tc.Module.Twitter.js
var Tc_Module_Twitter = __webpack_require__(93);
var Tc_Module_Twitter_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_Twitter);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/js/modules/Tc.Module.LinkForwarder.js
var Tc_Module_LinkForwarder = __webpack_require__(94);
var Tc_Module_LinkForwarder_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_LinkForwarder);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/libraries/SCS.Url.js
var SCS_Url = __webpack_require__(6);
var SCS_Url_default = /*#__PURE__*/__webpack_require__.n(SCS_Url);

// EXTERNAL MODULE: ./clientlibs/js/lib/generic/seo-utils.tsx
var seo_utils = __webpack_require__(95);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/base/clientlibs/shared/libraries/tracking/SCS.portal.datalayer.js
var SCS_portal_datalayer = __webpack_require__(98);
var SCS_portal_datalayer_default = /*#__PURE__*/__webpack_require__.n(SCS_portal_datalayer);

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(2);

// EXTERNAL MODULE: external "(window._g && _g.$) || window.$CQ || window.$ || window.jQuery"
var external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_ = __webpack_require__(0);
var external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default = /*#__PURE__*/__webpack_require__.n(external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_);

// EXTERNAL MODULE: ./clientlibs/js/lib/vendor/terrific/Module.ts
var Module = __webpack_require__(5);

// EXTERNAL MODULE: ./clientlibs/js/lib/util/helpers.ts
var helpers = __webpack_require__(3);

// CONCATENATED MODULE: ./clientlibs/js/lib/containers/Tc.Module.IFrame.ts




var MESSAGE_HANDLERS = {
    /**
     * Open dialog
     * @param _mod
     * @param dialogOptions
     */
    dialog: function (_mod, dialogOptions) {
        dialogOptions.classes = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default.a.extend({}, { 'ui-dialog': dialogOptions.dialogClass || 'wide' }, dialogOptions.classes || {});
        dialogOptions.width = dialogOptions.width || (800 - 30);
        var content = dialogOptions.html;
        delete dialogOptions.html;
        delete dialogOptions.dialogClass;
        external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()('<div/>').html(content).dialog(dialogOptions);
    },
    /**
     * Scroll to top
     *
     * @param mod
     * @param top
     */
    top: function (mod, top) {
        if (top.startsWith('iframe')) {
            top = parseInt(top.split('|')[1], 10) || 0;
            top += mod.$iframe.offset().top;
        }
        else {
            top = parseInt(top, 10) || 0;
        }
        window.scrollTo(0, top);
    },
    /**
     * Resize iframe height
     * (only in non-adaptive mode)
     *
     * @param mod
     * @param height
     */
    height: function (mod, height) {
        if (mod.adaptive) {
            return;
        }
        mod.$iframe.attr('height', parseInt(height, 10));
    },
    /**
     * Used for iframes that do not use tracking code but need to track things, so they can post a message
     *
     * @param mod
     * @param trackingData
     */
    trackTealium: function (mod, trackingData) {
        mod.log('trackTealium called with trackingData', trackingData);
        new SCS.portal.datalayer.Interaction()
            .withEvent(trackingData.action, trackingData.label, trackingData.location, trackingData.category, trackingData.friendlyName)
            .withConversion(trackingData.conversionCategory, trackingData.conversionDetail, trackingData.conversionClass)
            .track();
    },
};
// Alias scrollTop to top for www.digitalassessment.ch iframes
MESSAGE_HANDLERS.scrollTop = MESSAGE_HANDLERS.top;
function isVideo(url) {
    return url.indexOf('youtube.com') > -1;
}
// List of allowed domains. Matched against scheme, host and port.
// Be careful when using regular expressions here to not match too little (always anchor at the end!)
var ALLOWED_MESSAGE_SOURCES = [
    /[./](swisscom|bwns)\.ch?$/,
    /\/{2}(www\.)?bluewin\.ch?$/,
    /\/{2}(www\.)?swisscom-learningcenter\.ch$/,
    'https://www.digitalassessment.ch',
    // The current host is always allowed.
    window.location.protocol + "//" + window.location.host,
];
function originAllowed(origin, additionalAllowedSources) {
    if (!origin) {
        return false;
    }
    var checks = ALLOWED_MESSAGE_SOURCES;
    if (additionalAllowedSources) {
        checks = checks.concat(additionalAllowedSources);
    }
    for (var _i = 0, checks_1 = checks; _i < checks_1.length; _i++) {
        var check = checks_1[_i];
        if (check instanceof RegExp) {
            if (check.test(origin)) {
                return true;
            }
        }
        else if (check === origin) {
            return true;
        }
    }
    return false;
}
var Tc_Module_IFrame_IFrame = /** @class */ (function (_super) {
    Object(tslib_es6["c" /* __extends */])(IFrame, _super);
    function IFrame() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Hook function to do all of your module stuff.
     *
     * @method on
     * @param  {Hook} callback Callback function
     * @return void
     */
    IFrame.prototype.on = function (callback) {
        this.readProperties();
        this.$iframe = this.$ctx.find('iframe');
        if (!this.$iframe.length) {
            // Initialize the iframe only if none exists already
            this.initializeIframe();
            this.$iframe = this.$ctx.find('iframe');
        }
        this.addMessageListeners();
        callback();
    };
    /**
     * Initializing properties read from data properties
     * on this context's div tag.
     */
    IFrame.prototype.readProperties = function () {
        this.url = this.$ctx.data('src');
        this.width = this.$ctx.data('width');
        this.height = this.$ctx.data('height');
        this.disallowMessages = this.$ctx.data('disallow-messages');
        this.considerHashParameters = this.$ctx.data('considerhashparameters');
        this.scrollbar = this.$ctx.data('scrollbar');
        this.adaptive = this.$ctx.data('adaptive');
        if (Object(helpers["isMobilePage"])() && isVideo(this.url)) {
            this.adaptive = true;
        }
        var allowedMessageSources = (this.$ctx.attr('data-allowed-message-sources') || '').trim().split(/\s*,\s*/);
        if (allowedMessageSources.length === 1 && !allowedMessageSources[0]) {
            allowedMessageSources = [];
        }
        this.allowedMessageSources = allowedMessageSources;
        this.aspectRatio = parseFloat(this.$ctx.attr('data-aspect-ratio') || '');
        if (isNaN(this.aspectRatio)) {
            this.aspectRatio = 16 / 9;
        }
        this.allowfullscreen = this.$ctx.data('allowfullscreen');
    };
    /**
     * Display Loading Rotator until document ready, then insert iframe
     *
     * @method initializeIframe
     * @return void
     */
    IFrame.prototype.initializeIframe = function () {
        if (this.considerHashParameters) {
            var locationHash = window.location.hash.substr(1);
            var locationParams = new URLSearchParams(locationHash);
            var url_1 = new URL(this.url, window.location.href);
            locationParams.forEach(function (value, key) {
                url_1.searchParams.append(key, value);
            });
            this.url = url_1.href;
        }
        var iframe = external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()('<iframe/>').attr({
            frameborder: 0,
            height: this.height,
            scrolling: this.scrollbar,
            src: this.url,
            width: this.width,
        });
        if (this.allowfullscreen) {
            iframe.attr({
                allowfullscreen: '',
            });
        }
        try {
            this.$ctx.empty().append(iframe);
        }
        catch (e) {
            // IE throws an error because of iFrame security but it works anyway
        }
        if (this.adaptive) {
            iframe.wrap(external___window__g_____g_$_____window_$CQ____window_$____window_jQuery__default()('<div/>').addClass('fixedAspectRatio').css({ paddingBottom: (100 / this.aspectRatio) + "%" }));
        }
    };
    /**
     * Attaching event listener to the window, so the
     * iframe containing content can send messages to this module
     */
    IFrame.prototype.addMessageListeners = function () {
        if (this.disallowMessages) {
            return;
        }
        window.addEventListener('message', this.listenMessage.bind(this));
    };
    /**
     * Handle messages sent from iFrame using postMessage
     */
    IFrame.prototype.listenMessage = function (msg) {
        if (this.disallowMessages) {
            return;
        }
        // Ignore non-JSON messages
        if (!msg || !msg.data || !msg.data.match || !msg.data.match(/^\{/)) {
            return;
        }
        // Ignore messages from other iframes
        if (!msg.source || this.$iframe[0].contentWindow !== msg.source) {
            return;
        }
        // Check the origin
        if (!originAllowed(msg.origin, this.allowedMessageSources)) {
            this.log.error('Got message from unknown origin', msg.origin, msg);
            return;
        }
        var msgData = JSON.parse(msg.data);
        for (var type in MESSAGE_HANDLERS) {
            if (type in msgData) {
                this.log("Got " + type + " message", msgData[type]);
                MESSAGE_HANDLERS[type](this, msgData[type], msg, msgData);
            }
        }
    };
    return IFrame;
}(Module["a" /* Module */]));
/* harmony default export */ var Tc_Module_IFrame = (Tc_Module_IFrame_IFrame);

// CONCATENATED MODULE: ./clientlibs/js/by-category/scs.base.desktop.ts
// base=/etc/designs/base/clientlibs
// # scs.base.desktop
// # ========================
// # Be careful when adding files here.
// # These files are included in the desktop clientlibs on portal, and possibly others.
// # TODO: Remove this from base, because it is already included in portal/clientlibs/libs
// (and fix dependencies to this client lib)
















// Tealium library

// Modern modules (using imports/exports)

var scs_base_desktop_modernTcModules = {
    IFrame: Tc_Module_IFrame,
};
// Tc Bootstrap

Object(load_terrific["legacyBootstrapDeferredSingleton"])(scs_base_desktop_modernTcModules);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/portal/clientlibs/foundation/testandtarget/util/source/init.js
var init = __webpack_require__(100);
var init_default = /*#__PURE__*/__webpack_require__.n(init);

// CONCATENATED MODULE: ./clientlibs/js/by-category/scs.testandtarget.util.ts
// #base=source


// CONCATENATED MODULE: ./clientlibs/js/by-category/scs.emag.aggregated.ts
// Polyfills

// Embeds





// EXTERNAL MODULE: ./clientlibs/js/etc/designs/emagazine/clientlibs/dialogue/js/libs/jquery.jcarousellite.js
var jquery_jcarousellite = __webpack_require__(101);
var jquery_jcarousellite_default = /*#__PURE__*/__webpack_require__.n(jquery_jcarousellite);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/emagazine/clientlibs/dialogue/js/modules/Tc.Module.Menu.js
var Tc_Module_Menu = __webpack_require__(102);
var Tc_Module_Menu_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_Menu);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/emagazine/clientlibs/dialogue/js/modules/Tc.Module.Mainmenu.js
var Tc_Module_Mainmenu = __webpack_require__(103);
var Tc_Module_Mainmenu_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_Mainmenu);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/emagazine/clientlibs/dialogue/js/modules/Tc.Module.Metamenu.js
var Tc_Module_Metamenu = __webpack_require__(104);
var Tc_Module_Metamenu_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_Metamenu);

// EXTERNAL MODULE: ./clientlibs/js/etc/designs/emagazine/clientlibs/dialogue/js/modules/Tc.Module.Editionnavigation.js
var Tc_Module_Editionnavigation = __webpack_require__(105);
var Tc_Module_Editionnavigation_default = /*#__PURE__*/__webpack_require__.n(Tc_Module_Editionnavigation);

// CONCATENATED MODULE: ./clientlibs/js/lib/emag/dialogue/seo-utils.ts

external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_(function () {
    if (external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_('body.cq_isAuthorInstance.h1Warning').length) {
        external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_(document).on('h1-warning-show', function () {
            external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_('.mod-menu, .mod-meta, .mod-article, .meta-datacontainer-emagazinearticle').addClass('h1-warning');
        });
        external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_(document).on('h1-warning-hide', function () {
            external___window__g_____g_$_____window_$CQ____window_$____window_jQuery_('.mod-menu, .mod-meta, .mod-article, .meta-datacontainer-emagazinearticle').removeClass('h1-warning');
        });
    }
});

// CONCATENATED MODULE: ./clientlibs/js/by-category/scs.emag.dialogue.ts
// #libs

// #head






// CONCATENATED MODULE: ./apps/emagazine/ui/src/main/content/jcr_root/etc/designs/emagazine/clientlibs/xtra.ts




/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Array.prototype.find = Array.prototype.find || function(callback) {
  if (this === null) {
    throw new TypeError('Array.prototype.find called on null or undefined');
  } else if (typeof callback !== 'function') {
    throw new TypeError('callback must be a function');
  }
  var list = Object(this);
  // Makes sures is always has an positive integer as length.
  var length = list.length >>> 0;
  var thisArg = arguments[1];
  for (var i = 0; i < length; i++) {
    var element = list[i];
    if ( callback.call(thisArg, element, i, list) ) {
      return element;
    }
  }
};


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(setImmediate) {// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var setTimeoutFunc = setTimeout;

function noop() {}

// Polyfill for Function.prototype.bind
function bind(fn, thisArg) {
  return function() {
    fn.apply(thisArg, arguments);
  };
}

function handle(self, deferred) {
  while (self._state === 3) {
    self = self._value;
  }
  if (self._state === 0) {
    self._deferreds.push(deferred);
    return;
  }
  self._handled = true;
  Promise._immediateFn(function() {
    var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
      return;
    }
    var ret;
    try {
      ret = cb(self._value);
    } catch (e) {
      reject(deferred.promise, e);
      return;
    }
    resolve(deferred.promise, ret);
  });
}

function resolve(self, newValue) {
  try {
    // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
    if (newValue === self)
      throw new TypeError('A promise cannot be resolved with itself.');
    if (
      newValue &&
      (typeof newValue === 'object' || typeof newValue === 'function')
    ) {
      var then = newValue.then;
      if (newValue instanceof Promise) {
        self._state = 3;
        self._value = newValue;
        finale(self);
        return;
      } else if (typeof then === 'function') {
        doResolve(bind(then, newValue), self);
        return;
      }
    }
    self._state = 1;
    self._value = newValue;
    finale(self);
  } catch (e) {
    reject(self, e);
  }
}

function reject(self, newValue) {
  self._state = 2;
  self._value = newValue;
  finale(self);
}

function finale(self) {
  if (self._state === 2 && self._deferreds.length === 0) {
    Promise._immediateFn(function() {
      if (!self._handled) {
        Promise._unhandledRejectionFn(self._value);
      }
    });
  }

  for (var i = 0, len = self._deferreds.length; i < len; i++) {
    handle(self, self._deferreds[i]);
  }
  self._deferreds = null;
}

function Handler(onFulfilled, onRejected, promise) {
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, self) {
  var done = false;
  try {
    fn(
      function(value) {
        if (done) return;
        done = true;
        resolve(self, value);
      },
      function(reason) {
        if (done) return;
        done = true;
        reject(self, reason);
      }
    );
  } catch (ex) {
    if (done) return;
    done = true;
    reject(self, ex);
  }
}

function Promise(fn) {
  if (!(this instanceof Promise))
    throw new TypeError('Promises must be constructed via new');
  if (typeof fn !== 'function') throw new TypeError('not a function');
  this._state = 0;
  this._handled = false;
  this._value = undefined;
  this._deferreds = [];

  doResolve(fn, this);
}

var _proto = Promise.prototype;
_proto.catch = function(onRejected) {
  return this.then(null, onRejected);
};

_proto.then = function(onFulfilled, onRejected) {
  var prom = new this.constructor(noop);

  handle(this, new Handler(onFulfilled, onRejected, prom));
  return prom;
};

Promise.all = function(arr) {
  return new Promise(function(resolve, reject) {
    if (!arr || typeof arr.length === 'undefined')
      throw new TypeError('Promise.all accepts an array');
    var args = Array.prototype.slice.call(arr);
    if (args.length === 0) return resolve([]);
    var remaining = args.length;

    function res(i, val) {
      try {
        if (val && (typeof val === 'object' || typeof val === 'function')) {
          var then = val.then;
          if (typeof then === 'function') {
            then.call(
              val,
              function(val) {
                res(i, val);
              },
              reject
            );
            return;
          }
        }
        args[i] = val;
        if (--remaining === 0) {
          resolve(args);
        }
      } catch (ex) {
        reject(ex);
      }
    }

    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.resolve = function(value) {
  if (value && typeof value === 'object' && value.constructor === Promise) {
    return value;
  }

  return new Promise(function(resolve) {
    resolve(value);
  });
};

Promise.reject = function(value) {
  return new Promise(function(resolve, reject) {
    reject(value);
  });
};

Promise.race = function(values) {
  return new Promise(function(resolve, reject) {
    for (var i = 0, len = values.length; i < len; i++) {
      values[i].then(resolve, reject);
    }
  });
};

// Use polyfill for setImmediate for performance gains
Promise._immediateFn =
  (typeof setImmediate === 'function' &&
    function(fn) {
      setImmediate(fn);
    }) ||
  function(fn) {
    setTimeoutFunc(fn, 0);
  };

Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
  if (typeof console !== 'undefined' && console) {
    console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Promise);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(19).setImmediate))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(20);
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8), __webpack_require__(21)))

/***/ }),
/* 21 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {(function(global) {
  /**
   * Polyfill URLSearchParams
   *
   * Inspired from : https://github.com/WebReflection/url-search-params/blob/master/src/url-search-params.js
   */

  var checkIfIteratorIsSupported = function() {
    try {
      return !!Symbol.iterator;
    } catch (error) {
      return false;
    }
  };


  var iteratorSupported = checkIfIteratorIsSupported();

  var createIterator = function(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return { done: value === void 0, value: value };
      }
    };

    if (iteratorSupported) {
      iterator[Symbol.iterator] = function() {
        return iterator;
      };
    }

    return iterator;
  };

  /**
   * Search param name and values should be encoded according to https://url.spec.whatwg.org/#urlencoded-serializing
   * encodeURIComponent() produces the same result except encoding spaces as `%20` instead of `+`.
   */
  var serializeParam = function(value) {
    return encodeURIComponent(value).replace(/%20/g, '+');
  };

  var deserializeParam = function(value) {
    return decodeURIComponent(String(value).replace(/\+/g, ' '));
  };

  var polyfillURLSearchParams = function() {

    var URLSearchParams = function(searchString) {
      Object.defineProperty(this, '_entries', { writable: true, value: {} });
      var typeofSearchString = typeof searchString;

      if (typeofSearchString === 'undefined') {
        // do nothing
      } else if (typeofSearchString === 'string') {
        if (searchString !== '') {
          this._fromString(searchString);
        }
      } else if (searchString instanceof URLSearchParams) {
        var _this = this;
        searchString.forEach(function(value, name) {
          _this.append(name, value);
        });
      } else if ((searchString !== null) && (typeofSearchString === 'object')) {
        if (Object.prototype.toString.call(searchString) === '[object Array]') {
          for (var i = 0; i < searchString.length; i++) {
            var entry = searchString[i];
            if ((Object.prototype.toString.call(entry) === '[object Array]') || (entry.length !== 2)) {
              this.append(entry[0], entry[1]);
            } else {
              throw new TypeError('Expected [string, any] as entry at index ' + i + ' of URLSearchParams\'s input');
            }
          }
        } else {
          for (var key in searchString) {
            if (searchString.hasOwnProperty(key)) {
              this.append(key, searchString[key]);
            }
          }
        }
      } else {
        throw new TypeError('Unsupported input\'s type for URLSearchParams');
      }
    };

    var proto = URLSearchParams.prototype;

    proto.append = function(name, value) {
      if (name in this._entries) {
        this._entries[name].push(String(value));
      } else {
        this._entries[name] = [String(value)];
      }
    };

    proto.delete = function(name) {
      delete this._entries[name];
    };

    proto.get = function(name) {
      return (name in this._entries) ? this._entries[name][0] : null;
    };

    proto.getAll = function(name) {
      return (name in this._entries) ? this._entries[name].slice(0) : [];
    };

    proto.has = function(name) {
      return (name in this._entries);
    };

    proto.set = function(name, value) {
      this._entries[name] = [String(value)];
    };

    proto.forEach = function(callback, thisArg) {
      var entries;
      for (var name in this._entries) {
        if (this._entries.hasOwnProperty(name)) {
          entries = this._entries[name];
          for (var i = 0; i < entries.length; i++) {
            callback.call(thisArg, entries[i], name, this);
          }
        }
      }
    };

    proto.keys = function() {
      var items = [];
      this.forEach(function(value, name) {
        items.push(name);
      });
      return createIterator(items);
    };

    proto.values = function() {
      var items = [];
      this.forEach(function(value) {
        items.push(value);
      });
      return createIterator(items);
    };

    proto.entries = function() {
      var items = [];
      this.forEach(function(value, name) {
        items.push([name, value]);
      });
      return createIterator(items);
    };

    if (iteratorSupported) {
      proto[Symbol.iterator] = proto.entries;
    }

    proto.toString = function() {
      var searchArray = [];
      this.forEach(function(value, name) {
        searchArray.push(serializeParam(name) + '=' + serializeParam(value));
      });
      return searchArray.join('&');
    };


    global.URLSearchParams = URLSearchParams;
  };

  if (!('URLSearchParams' in global) || (new global.URLSearchParams('?a=1').toString() !== 'a=1')) {
    polyfillURLSearchParams();
  }

  var proto = global.URLSearchParams.prototype;

  if (typeof proto.sort !== 'function') {
    proto.sort = function() {
      var _this = this;
      var items = [];
      this.forEach(function(value, name) {
        items.push([name, value]);
        if (!_this._entries) {
          _this.delete(name);
        }
      });
      items.sort(function(a, b) {
        if (a[0] < b[0]) {
          return -1;
        } else if (a[0] > b[0]) {
          return +1;
        } else {
          return 0;
        }
      });
      if (_this._entries) { // force reset because IE keeps keys index
        _this._entries = {};
      }
      for (var i = 0; i < items.length; i++) {
        this.append(items[i][0], items[i][1]);
      }
    };
  }

  if (typeof proto._fromString !== 'function') {
    Object.defineProperty(proto, '_fromString', {
      enumerable: false,
      configurable: false,
      writable: false,
      value: function(searchString) {
        if (this._entries) {
          this._entries = {};
        } else {
          var keys = [];
          this.forEach(function(value, name) {
            keys.push(name);
          });
          for (var i = 0; i < keys.length; i++) {
            this.delete(keys[i]);
          }
        }

        searchString = searchString.replace(/^\?/, '');
        var attributes = searchString.split('&');
        var attribute;
        for (var i = 0; i < attributes.length; i++) {
          attribute = attributes[i].split('=');
          this.append(
            deserializeParam(attribute[0]),
            (attribute.length > 1) ? deserializeParam(attribute[1]) : ''
          );
        }
      }
    });
  }

  // HTMLAnchorElement

})(
  (typeof global !== 'undefined') ? global
    : ((typeof window !== 'undefined') ? window
    : ((typeof self !== 'undefined') ? self : this))
);

(function(global) {
  /**
   * Polyfill URL
   *
   * Inspired from : https://github.com/arv/DOM-URL-Polyfill/blob/master/src/url.js
   */

  var checkIfURLIsSupported = function() {
    try {
      var u = new global.URL('b', 'http://a');
      u.pathname = 'c%20d';
      return (u.href === 'http://a/c%20d') && u.searchParams;
    } catch (e) {
      return false;
    }
  };


  var polyfillURL = function() {
    var _URL = global.URL;

    var URL = function(url, base) {
      if (typeof url !== 'string') url = String(url);

      // Only create another document if the base is different from current location.
      var doc = document, baseElement;
      if (base && (global.location === void 0 || base !== global.location.href)) {
        doc = document.implementation.createHTMLDocument('');
        baseElement = doc.createElement('base');
        baseElement.href = base;
        doc.head.appendChild(baseElement);
        try {
          if (baseElement.href.indexOf(base) !== 0) throw new Error(baseElement.href);
        } catch (err) {
          throw new Error('URL unable to set base ' + base + ' due to ' + err);
        }
      }

      var anchorElement = doc.createElement('a');
      anchorElement.href = url;
      if (baseElement) {
        doc.body.appendChild(anchorElement);
        anchorElement.href = anchorElement.href; // force href to refresh
      }

      if (anchorElement.protocol === ':' || !/:/.test(anchorElement.href)) {
        throw new TypeError('Invalid URL');
      }

      Object.defineProperty(this, '_anchorElement', {
        value: anchorElement
      });


      // create a linked searchParams which reflect its changes on URL
      var searchParams = new global.URLSearchParams(this.search);
      var enableSearchUpdate = true;
      var enableSearchParamsUpdate = true;
      var _this = this;
      ['append', 'delete', 'set'].forEach(function(methodName) {
        var method = searchParams[methodName];
        searchParams[methodName] = function() {
          method.apply(searchParams, arguments);
          if (enableSearchUpdate) {
            enableSearchParamsUpdate = false;
            _this.search = searchParams.toString();
            enableSearchParamsUpdate = true;
          }
        };
      });

      Object.defineProperty(this, 'searchParams', {
        value: searchParams,
        enumerable: true
      });

      var search = void 0;
      Object.defineProperty(this, '_updateSearchParams', {
        enumerable: false,
        configurable: false,
        writable: false,
        value: function() {
          if (this.search !== search) {
            search = this.search;
            if (enableSearchParamsUpdate) {
              enableSearchUpdate = false;
              this.searchParams._fromString(this.search);
              enableSearchUpdate = true;
            }
          }
        }
      });
    };

    var proto = URL.prototype;

    var linkURLWithAnchorAttribute = function(attributeName) {
      Object.defineProperty(proto, attributeName, {
        get: function() {
          return this._anchorElement[attributeName];
        },
        set: function(value) {
          this._anchorElement[attributeName] = value;
        },
        enumerable: true
      });
    };

    ['hash', 'host', 'hostname', 'port', 'protocol']
      .forEach(function(attributeName) {
        linkURLWithAnchorAttribute(attributeName);
      });

    Object.defineProperty(proto, 'search', {
      get: function() {
        return this._anchorElement['search'];
      },
      set: function(value) {
        this._anchorElement['search'] = value;
        this._updateSearchParams();
      },
      enumerable: true
    });

    Object.defineProperties(proto, {

      'toString': {
        get: function() {
          var _this = this;
          return function() {
            return _this.href;
          };
        }
      },

      'href': {
        get: function() {
          return this._anchorElement.href.replace(/\?$/, '');
        },
        set: function(value) {
          this._anchorElement.href = value;
          this._updateSearchParams();
        },
        enumerable: true
      },

      'pathname': {
        get: function() {
          return this._anchorElement.pathname.replace(/(^\/?)/, '/');
        },
        set: function(value) {
          this._anchorElement.pathname = value;
        },
        enumerable: true
      },

      'origin': {
        get: function() {
          // get expected port from protocol
          var expectedPort = { 'http:': 80, 'https:': 443, 'ftp:': 21 }[this._anchorElement.protocol];
          // add port to origin if, expected port is different than actual port
          // and it is not empty f.e http://foo:8080
          // 8080 != 80 && 8080 != ''
          var addPortToOrigin = this._anchorElement.port != expectedPort &&
            this._anchorElement.port !== '';

          return this._anchorElement.protocol +
            '//' +
            this._anchorElement.hostname +
            (addPortToOrigin ? (':' + this._anchorElement.port) : '');
        },
        enumerable: true
      },

      'password': { // TODO
        get: function() {
          return '';
        },
        set: function(value) {
        },
        enumerable: true
      },

      'username': { // TODO
        get: function() {
          return '';
        },
        set: function(value) {
        },
        enumerable: true
      },
    });

    URL.createObjectURL = function(blob) {
      return _URL.createObjectURL.apply(_URL, arguments);
    };

    URL.revokeObjectURL = function(url) {
      return _URL.revokeObjectURL.apply(_URL, arguments);
    };

    global.URL = URL;

  };

  if (!checkIfURLIsSupported()) {
    polyfillURL();
  }

  if ((global.location !== void 0) && !('origin' in global.location)) {
    var getOrigin = function() {
      return global.location.protocol + '//' + global.location.hostname + (global.location.port ? (':' + global.location.port) : '');
    };

    try {
      Object.defineProperty(global.location, 'origin', {
        get: getOrigin,
        enumerable: true
      });
    } catch (e) {
      setInterval(function() {
        global.location.origin = getOrigin();
      }, 100);
    }
  }

})(
  (typeof global !== 'undefined') ? global
    : ((typeof window !== 'undefined') ? window
    : ((typeof self !== 'undefined') ? self : this))
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var define = false;
var jQuery = __webpack_require__(0);

/*
 * qTip2 - Pretty powerful tooltips - v3.0.3
 * http://qtip2.com
 *
 * Copyright (c) 2016 
 * Released under the MIT licenses
 * http://jquery.org/license
 *
 * Date: Wed May 11 2016 10:31 GMT+0100+0100
 * Plugins: tips modal viewport svg imagemap ie6
 * Styles: core basic css3
 */
/*global window: false, jQuery: false, console: false, define: false */

/* Cache window, document, undefined */
(function( window, document, undefined ) {

// Uses AMD or browser globals to create a jQuery plugin.
(function( factory ) {
	"use strict";
	if(typeof define === 'function' && define.amd) {
		define(['jquery'], factory);
	}
	else if(jQuery && !jQuery.fn.qtip) {
		factory(jQuery);
	}
}
(function($) {
	"use strict"; // Enable ECMAScript "strict" operation for this function. See more: http://ejohn.org/blog/ecmascript-5-strict-mode-json-and-more/
;// Munge the primitives - Paul Irish tip
var TRUE = true,
FALSE = false,
NULL = null,

// Common variables
X = 'x', Y = 'y',
WIDTH = 'width',
HEIGHT = 'height',

// Positioning sides
TOP = 'top',
LEFT = 'left',
BOTTOM = 'bottom',
RIGHT = 'right',
CENTER = 'center',

// Position adjustment types
FLIP = 'flip',
FLIPINVERT = 'flipinvert',
SHIFT = 'shift',

// Shortcut vars
QTIP, PROTOTYPE, CORNER, CHECKS,
PLUGINS = {},
NAMESPACE = 'qtip',
ATTR_HAS = 'data-hasqtip',
ATTR_ID = 'data-qtip-id',
WIDGET = ['ui-widget', 'ui-tooltip'],
SELECTOR = '.'+NAMESPACE,
INACTIVE_EVENTS = 'click dblclick mousedown mouseup mousemove mouseleave mouseenter'.split(' '),

CLASS_FIXED = NAMESPACE+'-fixed',
CLASS_DEFAULT = NAMESPACE + '-default',
CLASS_FOCUS = NAMESPACE + '-focus',
CLASS_HOVER = NAMESPACE + '-hover',
CLASS_DISABLED = NAMESPACE+'-disabled',

replaceSuffix = '_replacedByqTip',
oldtitle = 'oldtitle',
trackingBound,

// Browser detection
BROWSER = {
	/*
	 * IE version detection
	 *
	 * Adapted from: http://ajaxian.com/archives/attack-of-the-ie-conditional-comment
	 * Credit to James Padolsey for the original implemntation!
	 */
	ie: (function() {
		/* eslint-disable no-empty */
		var v, i;
		for (
			v = 4, i = document.createElement('div');
			(i.innerHTML = '<!--[if gt IE ' + v + ']><i></i><![endif]-->') && i.getElementsByTagName('i')[0];
			v+=1
		) {}
		return v > 4 ? v : NaN;
		/* eslint-enable no-empty */
	})(),

	/*
	 * iOS version detection
	 */
	iOS: parseFloat(
		('' + (/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent) || [0,''])[1])
		.replace('undefined', '3_2').replace('_', '.').replace('_', '')
	) || FALSE
};
;function QTip(target, options, id, attr) {
	// Elements and ID
	this.id = id;
	this.target = target;
	this.tooltip = NULL;
	this.elements = { target: target };

	// Internal constructs
	this._id = NAMESPACE + '-' + id;
	this.timers = { img: {} };
	this.options = options;
	this.plugins = {};

	// Cache object
	this.cache = {
		event: {},
		target: $(),
		disabled: FALSE,
		attr: attr,
		onTooltip: FALSE,
		lastClass: ''
	};

	// Set the initial flags
	this.rendered = this.destroyed = this.disabled = this.waiting =
		this.hiddenDuringWait = this.positioning = this.triggering = FALSE;
}
PROTOTYPE = QTip.prototype;

PROTOTYPE._when = function(deferreds) {
	return $.when.apply($, deferreds);
};

PROTOTYPE.render = function(show) {
	if(this.rendered || this.destroyed) { return this; } // If tooltip has already been rendered, exit

	var self = this,
		options = this.options,
		cache = this.cache,
		elements = this.elements,
		text = options.content.text,
		title = options.content.title,
		button = options.content.button,
		posOptions = options.position,
		deferreds = [];

	// Add ARIA attributes to target
	$.attr(this.target[0], 'aria-describedby', this._id);

	// Create public position object that tracks current position corners
	cache.posClass = this._createPosClass(
		(this.position = { my: posOptions.my, at: posOptions.at }).my
	);

	// Create tooltip element
	this.tooltip = elements.tooltip = $('<div/>', {
		'id': this._id,
		'class': [ NAMESPACE, CLASS_DEFAULT, options.style.classes, cache.posClass ].join(' '),
		'width': options.style.width || '',
		'height': options.style.height || '',
		'tracking': posOptions.target === 'mouse' && posOptions.adjust.mouse,

		/* ARIA specific attributes */
		'role': 'alert',
		'aria-live': 'polite',
		'aria-atomic': FALSE,
		'aria-describedby': this._id + '-content',
		'aria-hidden': TRUE
	})
	.toggleClass(CLASS_DISABLED, this.disabled)
	.attr(ATTR_ID, this.id)
	.data(NAMESPACE, this)
	.appendTo(posOptions.container)
	.append(
		// Create content element
		elements.content = $('<div />', {
			'class': NAMESPACE + '-content',
			'id': this._id + '-content',
			'aria-atomic': TRUE
		})
	);

	// Set rendered flag and prevent redundant reposition calls for now
	this.rendered = -1;
	this.positioning = TRUE;

	// Create title...
	if(title) {
		this._createTitle();

		// Update title only if its not a callback (called in toggle if so)
		if(!$.isFunction(title)) {
			deferreds.push( this._updateTitle(title, FALSE) );
		}
	}

	// Create button
	if(button) { this._createButton(); }

	// Set proper rendered flag and update content if not a callback function (called in toggle)
	if(!$.isFunction(text)) {
		deferreds.push( this._updateContent(text, FALSE) );
	}
	this.rendered = TRUE;

	// Setup widget classes
	this._setWidget();

	// Initialize 'render' plugins
	$.each(PLUGINS, function(name) {
		var instance;
		if(this.initialize === 'render' && (instance = this(self))) {
			self.plugins[name] = instance;
		}
	});

	// Unassign initial events and assign proper events
	this._unassignEvents();
	this._assignEvents();

	// When deferreds have completed
	this._when(deferreds).then(function() {
		// tooltiprender event
		self._trigger('render');

		// Reset flags
		self.positioning = FALSE;

		// Show tooltip if not hidden during wait period
		if(!self.hiddenDuringWait && (options.show.ready || show)) {
			self.toggle(TRUE, cache.event, FALSE);
		}
		self.hiddenDuringWait = FALSE;
	});

	// Expose API
	QTIP.api[this.id] = this;

	return this;
};

PROTOTYPE.destroy = function(immediate) {
	// Set flag the signify destroy is taking place to plugins
	// and ensure it only gets destroyed once!
	if(this.destroyed) { return this.target; }

	function process() {
		if(this.destroyed) { return; }
		this.destroyed = TRUE;

		var target = this.target,
			title = target.attr(oldtitle),
			timer;

		// Destroy tooltip if rendered
		if(this.rendered) {
			this.tooltip.stop(1,0).find('*').remove().end().remove();
		}

		// Destroy all plugins
		$.each(this.plugins, function() {
			this.destroy && this.destroy();
		});

		// Clear timers
		for (timer in this.timers) {
			if (this.timers.hasOwnProperty(timer)) {
				clearTimeout(this.timers[timer]);
			}
		}

		// Remove api object and ARIA attributes
		target.removeData(NAMESPACE)
			.removeAttr(ATTR_ID)
			.removeAttr(ATTR_HAS)
			.removeAttr('aria-describedby');

		// Reset old title attribute if removed
		if(this.options.suppress && title) {
			target.attr('title', title).removeAttr(oldtitle);
		}

		// Remove qTip events associated with this API
		this._unassignEvents();

		// Remove ID from used id objects, and delete object references
		// for better garbage collection and leak protection
		this.options = this.elements = this.cache = this.timers =
			this.plugins = this.mouse = NULL;

		// Delete epoxsed API object
		delete QTIP.api[this.id];
	}

	// If an immediate destroy is needed
	if((immediate !== TRUE || this.triggering === 'hide') && this.rendered) {
		this.tooltip.one('tooltiphidden', $.proxy(process, this));
		!this.triggering && this.hide();
	}

	// If we're not in the process of hiding... process
	else { process.call(this); }

	return this.target;
};
;function invalidOpt(a) {
	return a === NULL || $.type(a) !== 'object';
}

function invalidContent(c) {
	return !($.isFunction(c) || 
            c && c.attr || 
            c.length || 
            $.type(c) === 'object' && (c.jquery || c.then));
}

// Option object sanitizer
function sanitizeOptions(opts) {
	var content, text, ajax, once;

	if(invalidOpt(opts)) { return FALSE; }

	if(invalidOpt(opts.metadata)) {
		opts.metadata = { type: opts.metadata };
	}

	if('content' in opts) {
		content = opts.content;

		if(invalidOpt(content) || content.jquery || content.done) {
			text = invalidContent(content) ? FALSE : content;
			content = opts.content = {
				text: text
			};
		}
		else { text = content.text; }

		// DEPRECATED - Old content.ajax plugin functionality
		// Converts it into the proper Deferred syntax
		if('ajax' in content) {
			ajax = content.ajax;
			once = ajax && ajax.once !== FALSE;
			delete content.ajax;

			content.text = function(event, api) {
				var loading = text || $(this).attr(api.options.content.attr) || 'Loading...',

				deferred = $.ajax(
					$.extend({}, ajax, { context: api })
				)
				.then(ajax.success, NULL, ajax.error)
				.then(function(newContent) {
					if(newContent && once) { api.set('content.text', newContent); }
					return newContent;
				},
				function(xhr, status, error) {
					if(api.destroyed || xhr.status === 0) { return; }
					api.set('content.text', status + ': ' + error);
				});

				return !once ? (api.set('content.text', loading), deferred) : loading;
			};
		}

		if('title' in content) {
			if($.isPlainObject(content.title)) {
				content.button = content.title.button;
				content.title = content.title.text;
			}

			if(invalidContent(content.title || FALSE)) {
				content.title = FALSE;
			}
		}
	}

	if('position' in opts && invalidOpt(opts.position)) {
		opts.position = { my: opts.position, at: opts.position };
	}

	if('show' in opts && invalidOpt(opts.show)) {
		opts.show = opts.show.jquery ? { target: opts.show } :
			opts.show === TRUE ? { ready: TRUE } : { event: opts.show };
	}

	if('hide' in opts && invalidOpt(opts.hide)) {
		opts.hide = opts.hide.jquery ? { target: opts.hide } : { event: opts.hide };
	}

	if('style' in opts && invalidOpt(opts.style)) {
		opts.style = { classes: opts.style };
	}

	// Sanitize plugin options
	$.each(PLUGINS, function() {
		this.sanitize && this.sanitize(opts);
	});

	return opts;
}

// Setup builtin .set() option checks
CHECKS = PROTOTYPE.checks = {
	builtin: {
		// Core checks
		'^id$': function(obj, o, v, prev) {
			var id = v === TRUE ? QTIP.nextid : v,
				newId = NAMESPACE + '-' + id;

			if(id !== FALSE && id.length > 0 && !$('#'+newId).length) {
				this._id = newId;

				if(this.rendered) {
					this.tooltip[0].id = this._id;
					this.elements.content[0].id = this._id + '-content';
					this.elements.title[0].id = this._id + '-title';
				}
			}
			else { obj[o] = prev; }
		},
		'^prerender': function(obj, o, v) {
			v && !this.rendered && this.render(this.options.show.ready);
		},

		// Content checks
		'^content.text$': function(obj, o, v) {
			this._updateContent(v);
		},
		'^content.attr$': function(obj, o, v, prev) {
			if(this.options.content.text === this.target.attr(prev)) {
				this._updateContent( this.target.attr(v) );
			}
		},
		'^content.title$': function(obj, o, v) {
			// Remove title if content is null
			if(!v) { return this._removeTitle(); }

			// If title isn't already created, create it now and update
			v && !this.elements.title && this._createTitle();
			this._updateTitle(v);
		},
		'^content.button$': function(obj, o, v) {
			this._updateButton(v);
		},
		'^content.title.(text|button)$': function(obj, o, v) {
			this.set('content.'+o, v); // Backwards title.text/button compat
		},

		// Position checks
		'^position.(my|at)$': function(obj, o, v){
			if('string' === typeof v) {
				this.position[o] = obj[o] = new CORNER(v, o === 'at');
			}
		},
		'^position.container$': function(obj, o, v){
			this.rendered && this.tooltip.appendTo(v);
		},

		// Show checks
		'^show.ready$': function(obj, o, v) {
			v && (!this.rendered && this.render(TRUE) || this.toggle(TRUE));
		},

		// Style checks
		'^style.classes$': function(obj, o, v, p) {
			this.rendered && this.tooltip.removeClass(p).addClass(v);
		},
		'^style.(width|height)': function(obj, o, v) {
			this.rendered && this.tooltip.css(o, v);
		},
		'^style.widget|content.title': function() {
			this.rendered && this._setWidget();
		},
		'^style.def': function(obj, o, v) {
			this.rendered && this.tooltip.toggleClass(CLASS_DEFAULT, !!v);
		},

		// Events check
		'^events.(render|show|move|hide|focus|blur)$': function(obj, o, v) {
			this.rendered && this.tooltip[($.isFunction(v) ? '' : 'un') + 'bind']('tooltip'+o, v);
		},

		// Properties which require event reassignment
		'^(show|hide|position).(event|target|fixed|inactive|leave|distance|viewport|adjust)': function() {
			if(!this.rendered) { return; }

			// Set tracking flag
			var posOptions = this.options.position;
			this.tooltip.attr('tracking', posOptions.target === 'mouse' && posOptions.adjust.mouse);

			// Reassign events
			this._unassignEvents();
			this._assignEvents();
		}
	}
};

// Dot notation converter
function convertNotation(options, notation) {
	var i = 0, obj, option = options,

	// Split notation into array
	levels = notation.split('.');

	// Loop through
	while(option = option[ levels[i++] ]) {
		if(i < levels.length) { obj = option; }
	}

	return [obj || options, levels.pop()];
}

PROTOTYPE.get = function(notation) {
	if(this.destroyed) { return this; }

	var o = convertNotation(this.options, notation.toLowerCase()),
		result = o[0][ o[1] ];

	return result.precedance ? result.string() : result;
};

function setCallback(notation, args) {
	var category, rule, match;

	for(category in this.checks) {
		if (!this.checks.hasOwnProperty(category)) { continue; }

		for(rule in this.checks[category]) {
			if (!this.checks[category].hasOwnProperty(rule)) { continue; }

			if(match = (new RegExp(rule, 'i')).exec(notation)) {
				args.push(match);

				if(category === 'builtin' || this.plugins[category]) {
					this.checks[category][rule].apply(
						this.plugins[category] || this, args
					);
				}
			}
		}
	}
}

var rmove = /^position\.(my|at|adjust|target|container|viewport)|style|content|show\.ready/i,
	rrender = /^prerender|show\.ready/i;

PROTOTYPE.set = function(option, value) {
	if(this.destroyed) { return this; }

	var rendered = this.rendered,
		reposition = FALSE,
		options = this.options,
		name;

	// Convert singular option/value pair into object form
	if('string' === typeof option) {
		name = option; option = {}; option[name] = value;
	}
	else { option = $.extend({}, option); }

	// Set all of the defined options to their new values
	$.each(option, function(notation, val) {
		if(rendered && rrender.test(notation)) {
			delete option[notation]; return;
		}

		// Set new obj value
		var obj = convertNotation(options, notation.toLowerCase()), previous;
		previous = obj[0][ obj[1] ];
		obj[0][ obj[1] ] = val && val.nodeType ? $(val) : val;

		// Also check if we need to reposition
		reposition = rmove.test(notation) || reposition;

		// Set the new params for the callback
		option[notation] = [obj[0], obj[1], val, previous];
	});

	// Re-sanitize options
	sanitizeOptions(options);

	/*
	 * Execute any valid callbacks for the set options
	 * Also set positioning flag so we don't get loads of redundant repositioning calls.
	 */
	this.positioning = TRUE;
	$.each(option, $.proxy(setCallback, this));
	this.positioning = FALSE;

	// Update position if needed
	if(this.rendered && this.tooltip[0].offsetWidth > 0 && reposition) {
		this.reposition( options.position.target === 'mouse' ? NULL : this.cache.event );
	}

	return this;
};
;PROTOTYPE._update = function(content, element) {
	var self = this,
		cache = this.cache;

	// Make sure tooltip is rendered and content is defined. If not return
	if(!this.rendered || !content) { return FALSE; }

	// Use function to parse content
	if($.isFunction(content)) {
		content = content.call(this.elements.target, cache.event, this) || '';
	}

	// Handle deferred content
	if($.isFunction(content.then)) {
		cache.waiting = TRUE;
		return content.then(function(c) {
			cache.waiting = FALSE;
			return self._update(c, element);
		}, NULL, function(e) {
			return self._update(e, element);
		});
	}

	// If content is null... return false
	if(content === FALSE || !content && content !== '') { return FALSE; }

	// Append new content if its a DOM array and show it if hidden
	if(content.jquery && content.length > 0) {
		element.empty().append(
			content.css({ display: 'block', visibility: 'visible' })
		);
	}

	// Content is a regular string, insert the new content
	else { element.html(content); }

	// Wait for content to be loaded, and reposition
	return this._waitForContent(element).then(function(images) {
		if(self.rendered && self.tooltip[0].offsetWidth > 0) {
			self.reposition(cache.event, !images.length);
		}
	});
};

PROTOTYPE._waitForContent = function(element) {
	var cache = this.cache;

	// Set flag
	cache.waiting = TRUE;

	// If imagesLoaded is included, ensure images have loaded and return promise
	return ( $.fn.imagesLoaded ? element.imagesLoaded() : new $.Deferred().resolve([]) )
		.done(function() { cache.waiting = FALSE; })
		.promise();
};

PROTOTYPE._updateContent = function(content, reposition) {
	this._update(content, this.elements.content, reposition);
};

PROTOTYPE._updateTitle = function(content, reposition) {
	if(this._update(content, this.elements.title, reposition) === FALSE) {
		this._removeTitle(FALSE);
	}
};

PROTOTYPE._createTitle = function()
{
	var elements = this.elements,
		id = this._id+'-title';

	// Destroy previous title element, if present
	if(elements.titlebar) { this._removeTitle(); }

	// Create title bar and title elements
	elements.titlebar = $('<div />', {
		'class': NAMESPACE + '-titlebar ' + (this.options.style.widget ? createWidgetClass('header') : '')
	})
	.append(
		elements.title = $('<div />', {
			'id': id,
			'class': NAMESPACE + '-title',
			'aria-atomic': TRUE
		})
	)
	.insertBefore(elements.content)

	// Button-specific events
	.delegate('.qtip-close', 'mousedown keydown mouseup keyup mouseout', function(event) {
		$(this).toggleClass('ui-state-active ui-state-focus', event.type.substr(-4) === 'down');
	})
	.delegate('.qtip-close', 'mouseover mouseout', function(event){
		$(this).toggleClass('ui-state-hover', event.type === 'mouseover');
	});

	// Create button if enabled
	if(this.options.content.button) { this._createButton(); }
};

PROTOTYPE._removeTitle = function(reposition)
{
	var elements = this.elements;

	if(elements.title) {
		elements.titlebar.remove();
		elements.titlebar = elements.title = elements.button = NULL;

		// Reposition if enabled
		if(reposition !== FALSE) { this.reposition(); }
	}
};
;PROTOTYPE._createPosClass = function(my) {
	return NAMESPACE + '-pos-' + (my || this.options.position.my).abbrev();
};

PROTOTYPE.reposition = function(event, effect) {
	if(!this.rendered || this.positioning || this.destroyed) { return this; }

	// Set positioning flag
	this.positioning = TRUE;

	var cache = this.cache,
		tooltip = this.tooltip,
		posOptions = this.options.position,
		target = posOptions.target,
		my = posOptions.my,
		at = posOptions.at,
		viewport = posOptions.viewport,
		container = posOptions.container,
		adjust = posOptions.adjust,
		method = adjust.method.split(' '),
		tooltipWidth = tooltip.outerWidth(FALSE),
		tooltipHeight = tooltip.outerHeight(FALSE),
		targetWidth = 0,
		targetHeight = 0,
		type = tooltip.css('position'),
		position = { left: 0, top: 0 },
		visible = tooltip[0].offsetWidth > 0,
		isScroll = event && event.type === 'scroll',
		win = $(window),
		doc = container[0].ownerDocument,
		mouse = this.mouse,
		pluginCalculations, offset, adjusted, newClass;

	// Check if absolute position was passed
	if($.isArray(target) && target.length === 2) {
		// Force left top and set position
		at = { x: LEFT, y: TOP };
		position = { left: target[0], top: target[1] };
	}

	// Check if mouse was the target
	else if(target === 'mouse') {
		// Force left top to allow flipping
		at = { x: LEFT, y: TOP };

		// Use the mouse origin that caused the show event, if distance hiding is enabled
		if((!adjust.mouse || this.options.hide.distance) && cache.origin && cache.origin.pageX) {
			event =  cache.origin;
		}

		// Use cached event for resize/scroll events
		else if(!event || event && (event.type === 'resize' || event.type === 'scroll')) {
			event = cache.event;
		}

		// Otherwise, use the cached mouse coordinates if available
		else if(mouse && mouse.pageX) {
			event = mouse;
		}

		// Calculate body and container offset and take them into account below
		if(type !== 'static') { position = container.offset(); }
		if(doc.body.offsetWidth !== (window.innerWidth || doc.documentElement.clientWidth)) {
			offset = $(document.body).offset();
		}

		// Use event coordinates for position
		position = {
			left: event.pageX - position.left + (offset && offset.left || 0),
			top: event.pageY - position.top + (offset && offset.top || 0)
		};

		// Scroll events are a pain, some browsers
		if(adjust.mouse && isScroll && mouse) {
			position.left -= (mouse.scrollX || 0) - win.scrollLeft();
			position.top -= (mouse.scrollY || 0) - win.scrollTop();
		}
	}

	// Target wasn't mouse or absolute...
	else {
		// Check if event targetting is being used
		if(target === 'event') {
			if(event && event.target && event.type !== 'scroll' && event.type !== 'resize') {
				cache.target = $(event.target);
			}
			else if(!event.target) {
				cache.target = this.elements.target;
			}
		}
		else if(target !== 'event'){
			cache.target = $(target.jquery ? target : this.elements.target);
		}
		target = cache.target;

		// Parse the target into a jQuery object and make sure there's an element present
		target = $(target).eq(0);
		if(target.length === 0) { return this; }

		// Check if window or document is the target
		else if(target[0] === document || target[0] === window) {
			targetWidth = BROWSER.iOS ? window.innerWidth : target.width();
			targetHeight = BROWSER.iOS ? window.innerHeight : target.height();

			if(target[0] === window) {
				position = {
					top: (viewport || target).scrollTop(),
					left: (viewport || target).scrollLeft()
				};
			}
		}

		// Check if the target is an <AREA> element
		else if(PLUGINS.imagemap && target.is('area')) {
			pluginCalculations = PLUGINS.imagemap(this, target, at, PLUGINS.viewport ? method : FALSE);
		}

		// Check if the target is an SVG element
		else if(PLUGINS.svg && target && target[0].ownerSVGElement) {
			pluginCalculations = PLUGINS.svg(this, target, at, PLUGINS.viewport ? method : FALSE);
		}

		// Otherwise use regular jQuery methods
		else {
			targetWidth = target.outerWidth(FALSE);
			targetHeight = target.outerHeight(FALSE);
			position = target.offset();
		}

		// Parse returned plugin values into proper variables
		if(pluginCalculations) {
			targetWidth = pluginCalculations.width;
			targetHeight = pluginCalculations.height;
			offset = pluginCalculations.offset;
			position = pluginCalculations.position;
		}

		// Adjust position to take into account offset parents
		position = this.reposition.offset(target, position, container);

		// Adjust for position.fixed tooltips (and also iOS scroll bug in v3.2-4.0 & v4.3-4.3.2)
		if(BROWSER.iOS > 3.1 && BROWSER.iOS < 4.1 ||
			BROWSER.iOS >= 4.3 && BROWSER.iOS < 4.33 ||
			!BROWSER.iOS && type === 'fixed'
		){
			position.left -= win.scrollLeft();
			position.top -= win.scrollTop();
		}

		// Adjust position relative to target
		if(!pluginCalculations || pluginCalculations && pluginCalculations.adjustable !== FALSE) {
			position.left += at.x === RIGHT ? targetWidth : at.x === CENTER ? targetWidth / 2 : 0;
			position.top += at.y === BOTTOM ? targetHeight : at.y === CENTER ? targetHeight / 2 : 0;
		}
	}

	// Adjust position relative to tooltip
	position.left += adjust.x + (my.x === RIGHT ? -tooltipWidth : my.x === CENTER ? -tooltipWidth / 2 : 0);
	position.top += adjust.y + (my.y === BOTTOM ? -tooltipHeight : my.y === CENTER ? -tooltipHeight / 2 : 0);

	// Use viewport adjustment plugin if enabled
	if(PLUGINS.viewport) {
		adjusted = position.adjusted = PLUGINS.viewport(
			this, position, posOptions, targetWidth, targetHeight, tooltipWidth, tooltipHeight
		);

		// Apply offsets supplied by positioning plugin (if used)
		if(offset && adjusted.left) { position.left += offset.left; }
		if(offset && adjusted.top) {  position.top += offset.top; }

		// Apply any new 'my' position
		if(adjusted.my) { this.position.my = adjusted.my; }
	}

	// Viewport adjustment is disabled, set values to zero
	else { position.adjusted = { left: 0, top: 0 }; }

	// Set tooltip position class if it's changed
	if(cache.posClass !== (newClass = this._createPosClass(this.position.my))) {
		cache.posClass = newClass;
		tooltip.removeClass(cache.posClass).addClass(newClass);
	}

	// tooltipmove event
	if(!this._trigger('move', [position, viewport.elem || viewport], event)) { return this; }
	delete position.adjusted;

	// If effect is disabled, target it mouse, no animation is defined or positioning gives NaN out, set CSS directly
	if(effect === FALSE || !visible || isNaN(position.left) || isNaN(position.top) || target === 'mouse' || !$.isFunction(posOptions.effect)) {
		tooltip.css(position);
	}

	// Use custom function if provided
	else if($.isFunction(posOptions.effect)) {
		posOptions.effect.call(tooltip, this, $.extend({}, position));
		tooltip.queue(function(next) {
			// Reset attributes to avoid cross-browser rendering bugs
			$(this).css({ opacity: '', height: '' });
			if(BROWSER.ie) { this.style.removeAttribute('filter'); }

			next();
		});
	}

	// Set positioning flag
	this.positioning = FALSE;

	return this;
};

// Custom (more correct for qTip!) offset calculator
PROTOTYPE.reposition.offset = function(elem, pos, container) {
	if(!container[0]) { return pos; }

	var ownerDocument = $(elem[0].ownerDocument),
		quirks = !!BROWSER.ie && document.compatMode !== 'CSS1Compat',
		parent = container[0],
		scrolled, position, parentOffset, overflow;

	function scroll(e, i) {
		pos.left += i * e.scrollLeft();
		pos.top += i * e.scrollTop();
	}

	// Compensate for non-static containers offset
	do {
		if((position = $.css(parent, 'position')) !== 'static') {
			if(position === 'fixed') {
				parentOffset = parent.getBoundingClientRect();
				scroll(ownerDocument, -1);
			}
			else {
				parentOffset = $(parent).position();
				parentOffset.left += parseFloat($.css(parent, 'borderLeftWidth')) || 0;
				parentOffset.top += parseFloat($.css(parent, 'borderTopWidth')) || 0;
			}

			pos.left -= parentOffset.left + (parseFloat($.css(parent, 'marginLeft')) || 0);
			pos.top -= parentOffset.top + (parseFloat($.css(parent, 'marginTop')) || 0);

			// If this is the first parent element with an overflow of "scroll" or "auto", store it
			if(!scrolled && (overflow = $.css(parent, 'overflow')) !== 'hidden' && overflow !== 'visible') { scrolled = $(parent); }
		}
	}
	while(parent = parent.offsetParent);

	// Compensate for containers scroll if it also has an offsetParent (or in IE quirks mode)
	if(scrolled && (scrolled[0] !== ownerDocument[0] || quirks)) {
		scroll(scrolled, 1);
	}

	return pos;
};

// Corner class
var C = (CORNER = PROTOTYPE.reposition.Corner = function(corner, forceY) {
	corner = ('' + corner).replace(/([A-Z])/, ' $1').replace(/middle/gi, CENTER).toLowerCase();
	this.x = (corner.match(/left|right/i) || corner.match(/center/) || ['inherit'])[0].toLowerCase();
	this.y = (corner.match(/top|bottom|center/i) || ['inherit'])[0].toLowerCase();
	this.forceY = !!forceY;

	var f = corner.charAt(0);
	this.precedance = f === 't' || f === 'b' ? Y : X;
}).prototype;

C.invert = function(z, center) {
	this[z] = this[z] === LEFT ? RIGHT : this[z] === RIGHT ? LEFT : center || this[z];
};

C.string = function(join) {
	var x = this.x, y = this.y;

	var result = x !== y ?
		x === 'center' || y !== 'center' && (this.precedance === Y || this.forceY) ? 
			[y,x] : 
			[x,y] :
		[x];

	return join !== false ? result.join(' ') : result;
};

C.abbrev = function() {
	var result = this.string(false);
	return result[0].charAt(0) + (result[1] && result[1].charAt(0) || '');
};

C.clone = function() {
	return new CORNER( this.string(), this.forceY );
};

;
PROTOTYPE.toggle = function(state, event) {
	var cache = this.cache,
		options = this.options,
		tooltip = this.tooltip;

	// Try to prevent flickering when tooltip overlaps show element
	if(event) {
		if((/over|enter/).test(event.type) && cache.event && (/out|leave/).test(cache.event.type) &&
			options.show.target.add(event.target).length === options.show.target.length &&
			tooltip.has(event.relatedTarget).length) {
			return this;
		}

		// Cache event
		cache.event = $.event.fix(event);
	}

	// If we're currently waiting and we've just hidden... stop it
	this.waiting && !state && (this.hiddenDuringWait = TRUE);

	// Render the tooltip if showing and it isn't already
	if(!this.rendered) { return state ? this.render(1) : this; }
	else if(this.destroyed || this.disabled) { return this; }

	var type = state ? 'show' : 'hide',
		opts = this.options[type],
		posOptions = this.options.position,
		contentOptions = this.options.content,
		width = this.tooltip.css('width'),
		visible = this.tooltip.is(':visible'),
		animate = state || opts.target.length === 1,
		sameTarget = !event || opts.target.length < 2 || cache.target[0] === event.target,
		identicalState, allow, after;

	// Detect state if valid one isn't provided
	if((typeof state).search('boolean|number')) { state = !visible; }

	// Check if the tooltip is in an identical state to the new would-be state
	identicalState = !tooltip.is(':animated') && visible === state && sameTarget;

	// Fire tooltip(show/hide) event and check if destroyed
	allow = !identicalState ? !!this._trigger(type, [90]) : NULL;

	// Check to make sure the tooltip wasn't destroyed in the callback
	if(this.destroyed) { return this; }

	// If the user didn't stop the method prematurely and we're showing the tooltip, focus it
	if(allow !== FALSE && state) { this.focus(event); }

	// If the state hasn't changed or the user stopped it, return early
	if(!allow || identicalState) { return this; }

	// Set ARIA hidden attribute
	$.attr(tooltip[0], 'aria-hidden', !!!state);

	// Execute state specific properties
	if(state) {
		// Store show origin coordinates
		this.mouse && (cache.origin = $.event.fix(this.mouse));

		// Update tooltip content & title if it's a dynamic function
		if($.isFunction(contentOptions.text)) { this._updateContent(contentOptions.text, FALSE); }
		if($.isFunction(contentOptions.title)) { this._updateTitle(contentOptions.title, FALSE); }

		// Cache mousemove events for positioning purposes (if not already tracking)
		if(!trackingBound && posOptions.target === 'mouse' && posOptions.adjust.mouse) {
			$(document).bind('mousemove.'+NAMESPACE, this._storeMouse);
			trackingBound = TRUE;
		}

		// Update the tooltip position (set width first to prevent viewport/max-width issues)
		if(!width) { tooltip.css('width', tooltip.outerWidth(FALSE)); }
		this.reposition(event, arguments[2]);
		if(!width) { tooltip.css('width', ''); }

		// Hide other tooltips if tooltip is solo
		if(!!opts.solo) {
			(typeof opts.solo === 'string' ? $(opts.solo) : $(SELECTOR, opts.solo))
				.not(tooltip).not(opts.target).qtip('hide', new $.Event('tooltipsolo'));
		}
	}
	else {
		// Clear show timer if we're hiding
		clearTimeout(this.timers.show);

		// Remove cached origin on hide
		delete cache.origin;

		// Remove mouse tracking event if not needed (all tracking qTips are hidden)
		if(trackingBound && !$(SELECTOR+'[tracking="true"]:visible', opts.solo).not(tooltip).length) {
			$(document).unbind('mousemove.'+NAMESPACE);
			trackingBound = FALSE;
		}

		// Blur the tooltip
		this.blur(event);
	}

	// Define post-animation, state specific properties
	after = $.proxy(function() {
		if(state) {
			// Prevent antialias from disappearing in IE by removing filter
			if(BROWSER.ie) { tooltip[0].style.removeAttribute('filter'); }

			// Remove overflow setting to prevent tip bugs
			tooltip.css('overflow', '');

			// Autofocus elements if enabled
			if('string' === typeof opts.autofocus) {
				$(this.options.show.autofocus, tooltip).focus();
			}

			// If set, hide tooltip when inactive for delay period
			this.options.show.target.trigger('qtip-'+this.id+'-inactive');
		}
		else {
			// Reset CSS states
			tooltip.css({
				display: '',
				visibility: '',
				opacity: '',
				left: '',
				top: ''
			});
		}

		// tooltipvisible/tooltiphidden events
		this._trigger(state ? 'visible' : 'hidden');
	}, this);

	// If no effect type is supplied, use a simple toggle
	if(opts.effect === FALSE || animate === FALSE) {
		tooltip[ type ]();
		after();
	}

	// Use custom function if provided
	else if($.isFunction(opts.effect)) {
		tooltip.stop(1, 1);
		opts.effect.call(tooltip, this);
		tooltip.queue('fx', function(n) {
			after(); n();
		});
	}

	// Use basic fade function by default
	else { tooltip.fadeTo(90, state ? 1 : 0, after); }

	// If inactive hide method is set, active it
	if(state) { opts.target.trigger('qtip-'+this.id+'-inactive'); }

	return this;
};

PROTOTYPE.show = function(event) { return this.toggle(TRUE, event); };

PROTOTYPE.hide = function(event) { return this.toggle(FALSE, event); };
;PROTOTYPE.focus = function(event) {
	if(!this.rendered || this.destroyed) { return this; }

	var qtips = $(SELECTOR),
		tooltip = this.tooltip,
		curIndex = parseInt(tooltip[0].style.zIndex, 10),
		newIndex = QTIP.zindex + qtips.length;

	// Only update the z-index if it has changed and tooltip is not already focused
	if(!tooltip.hasClass(CLASS_FOCUS)) {
		// tooltipfocus event
		if(this._trigger('focus', [newIndex], event)) {
			// Only update z-index's if they've changed
			if(curIndex !== newIndex) {
				// Reduce our z-index's and keep them properly ordered
				qtips.each(function() {
					if(this.style.zIndex > curIndex) {
						this.style.zIndex = this.style.zIndex - 1;
					}
				});

				// Fire blur event for focused tooltip
				qtips.filter('.' + CLASS_FOCUS).qtip('blur', event);
			}

			// Set the new z-index
			tooltip.addClass(CLASS_FOCUS)[0].style.zIndex = newIndex;
		}
	}

	return this;
};

PROTOTYPE.blur = function(event) {
	if(!this.rendered || this.destroyed) { return this; }

	// Set focused status to FALSE
	this.tooltip.removeClass(CLASS_FOCUS);

	// tooltipblur event
	this._trigger('blur', [ this.tooltip.css('zIndex') ], event);

	return this;
};
;PROTOTYPE.disable = function(state) {
	if(this.destroyed) { return this; }

	// If 'toggle' is passed, toggle the current state
	if(state === 'toggle') {
		state = !(this.rendered ? this.tooltip.hasClass(CLASS_DISABLED) : this.disabled);
	}

	// Disable if no state passed
	else if('boolean' !== typeof state) {
		state = TRUE;
	}

	if(this.rendered) {
		this.tooltip.toggleClass(CLASS_DISABLED, state)
			.attr('aria-disabled', state);
	}

	this.disabled = !!state;

	return this;
};

PROTOTYPE.enable = function() { return this.disable(FALSE); };
;PROTOTYPE._createButton = function()
{
	var self = this,
		elements = this.elements,
		tooltip = elements.tooltip,
		button = this.options.content.button,
		isString = typeof button === 'string',
		close = isString ? button : 'Close tooltip';

	if(elements.button) { elements.button.remove(); }

	// Use custom button if one was supplied by user, else use default
	if(button.jquery) {
		elements.button = button;
	}
	else {
		elements.button = $('<a />', {
			'class': 'qtip-close ' + (this.options.style.widget ? '' : NAMESPACE+'-icon'),
			'title': close,
			'aria-label': close
		})
		.prepend(
			$('<span />', {
				'class': 'ui-icon ui-icon-close',
				'html': '&times;'
			})
		);
	}

	// Create button and setup attributes
	elements.button.appendTo(elements.titlebar || tooltip)
		.attr('role', 'button')
		.click(function(event) {
			if(!tooltip.hasClass(CLASS_DISABLED)) { self.hide(event); }
			return FALSE;
		});
};

PROTOTYPE._updateButton = function(button)
{
	// Make sure tooltip is rendered and if not, return
	if(!this.rendered) { return FALSE; }

	var elem = this.elements.button;
	if(button) { this._createButton(); }
	else { elem.remove(); }
};
;// Widget class creator
function createWidgetClass(cls) {
	return WIDGET.concat('').join(cls ? '-'+cls+' ' : ' ');
}

// Widget class setter method
PROTOTYPE._setWidget = function()
{
	var on = this.options.style.widget,
		elements = this.elements,
		tooltip = elements.tooltip,
		disabled = tooltip.hasClass(CLASS_DISABLED);

	tooltip.removeClass(CLASS_DISABLED);
	CLASS_DISABLED = on ? 'ui-state-disabled' : 'qtip-disabled';
	tooltip.toggleClass(CLASS_DISABLED, disabled);

	tooltip.toggleClass('ui-helper-reset '+createWidgetClass(), on).toggleClass(CLASS_DEFAULT, this.options.style.def && !on);

	if(elements.content) {
		elements.content.toggleClass( createWidgetClass('content'), on);
	}
	if(elements.titlebar) {
		elements.titlebar.toggleClass( createWidgetClass('header'), on);
	}
	if(elements.button) {
		elements.button.toggleClass(NAMESPACE+'-icon', !on);
	}
};
;function delay(callback, duration) {
	// If tooltip has displayed, start hide timer
	if(duration > 0) {
		return setTimeout(
			$.proxy(callback, this), duration
		);
	}
	else{ callback.call(this); }
}

function showMethod(event) {
	if(this.tooltip.hasClass(CLASS_DISABLED)) { return; }

	// Clear hide timers
	clearTimeout(this.timers.show);
	clearTimeout(this.timers.hide);

	// Start show timer
	this.timers.show = delay.call(this,
		function() { this.toggle(TRUE, event); },
		this.options.show.delay
	);
}

function hideMethod(event) {
	if(this.tooltip.hasClass(CLASS_DISABLED) || this.destroyed) { return; }

	// Check if new target was actually the tooltip element
	var relatedTarget = $(event.relatedTarget),
		ontoTooltip = relatedTarget.closest(SELECTOR)[0] === this.tooltip[0],
		ontoTarget = relatedTarget[0] === this.options.show.target[0];

	// Clear timers and stop animation queue
	clearTimeout(this.timers.show);
	clearTimeout(this.timers.hide);

	// Prevent hiding if tooltip is fixed and event target is the tooltip.
	// Or if mouse positioning is enabled and cursor momentarily overlaps
	if(this !== relatedTarget[0] &&
		(this.options.position.target === 'mouse' && ontoTooltip) ||
		this.options.hide.fixed && (
			(/mouse(out|leave|move)/).test(event.type) && (ontoTooltip || ontoTarget))
		)
	{
		/* eslint-disable no-empty */
		try {
			event.preventDefault();
			event.stopImmediatePropagation();
		} catch(e) {}
		/* eslint-enable no-empty */

		return;
	}

	// If tooltip has displayed, start hide timer
	this.timers.hide = delay.call(this,
		function() { this.toggle(FALSE, event); },
		this.options.hide.delay,
		this
	);
}

function inactiveMethod(event) {
	if(this.tooltip.hasClass(CLASS_DISABLED) || !this.options.hide.inactive) { return; }

	// Clear timer
	clearTimeout(this.timers.inactive);

	this.timers.inactive = delay.call(this,
		function(){ this.hide(event); },
		this.options.hide.inactive
	);
}

function repositionMethod(event) {
	if(this.rendered && this.tooltip[0].offsetWidth > 0) { this.reposition(event); }
}

// Store mouse coordinates
PROTOTYPE._storeMouse = function(event) {
	(this.mouse = $.event.fix(event)).type = 'mousemove';
	return this;
};

// Bind events
PROTOTYPE._bind = function(targets, events, method, suffix, context) {
	if(!targets || !method || !events.length) { return; }
	var ns = '.' + this._id + (suffix ? '-'+suffix : '');
	$(targets).bind(
		(events.split ? events : events.join(ns + ' ')) + ns,
		$.proxy(method, context || this)
	);
	return this;
};
PROTOTYPE._unbind = function(targets, suffix) {
	targets && $(targets).unbind('.' + this._id + (suffix ? '-'+suffix : ''));
	return this;
};

// Global delegation helper
function delegate(selector, events, method) {
	$(document.body).delegate(selector,
		(events.split ? events : events.join('.'+NAMESPACE + ' ')) + '.'+NAMESPACE,
		function() {
			var api = QTIP.api[ $.attr(this, ATTR_ID) ];
			api && !api.disabled && method.apply(api, arguments);
		}
	);
}
// Event trigger
PROTOTYPE._trigger = function(type, args, event) {
	var callback = new $.Event('tooltip'+type);
	callback.originalEvent = event && $.extend({}, event) || this.cache.event || NULL;

	this.triggering = type;
	this.tooltip.trigger(callback, [this].concat(args || []));
	this.triggering = FALSE;

	return !callback.isDefaultPrevented();
};

PROTOTYPE._bindEvents = function(showEvents, hideEvents, showTargets, hideTargets, showCallback, hideCallback) {
	// Get tasrgets that lye within both
	var similarTargets = showTargets.filter( hideTargets ).add( hideTargets.filter(showTargets) ),
		toggleEvents = [];

	// If hide and show targets are the same...
	if(similarTargets.length) {

		// Filter identical show/hide events
		$.each(hideEvents, function(i, type) {
			var showIndex = $.inArray(type, showEvents);

			// Both events are identical, remove from both hide and show events
			// and append to toggleEvents
			showIndex > -1 && toggleEvents.push( showEvents.splice( showIndex, 1 )[0] );
		});

		// Toggle events are special case of identical show/hide events, which happen in sequence
		if(toggleEvents.length) {
			// Bind toggle events to the similar targets
			this._bind(similarTargets, toggleEvents, function(event) {
				var state = this.rendered ? this.tooltip[0].offsetWidth > 0 : false;
				(state ? hideCallback : showCallback).call(this, event);
			});

			// Remove the similar targets from the regular show/hide bindings
			showTargets = showTargets.not(similarTargets);
			hideTargets = hideTargets.not(similarTargets);
		}
	}

	// Apply show/hide/toggle events
	this._bind(showTargets, showEvents, showCallback);
	this._bind(hideTargets, hideEvents, hideCallback);
};

PROTOTYPE._assignInitialEvents = function(event) {
	var options = this.options,
		showTarget = options.show.target,
		hideTarget = options.hide.target,
		showEvents = options.show.event ? $.trim('' + options.show.event).split(' ') : [],
		hideEvents = options.hide.event ? $.trim('' + options.hide.event).split(' ') : [];

	// Catch remove/removeqtip events on target element to destroy redundant tooltips
	this._bind(this.elements.target, ['remove', 'removeqtip'], function() {
		this.destroy(true);
	}, 'destroy');

	/*
	 * Make sure hoverIntent functions properly by using mouseleave as a hide event if
	 * mouseenter/mouseout is used for show.event, even if it isn't in the users options.
	 */
	if(/mouse(over|enter)/i.test(options.show.event) && !/mouse(out|leave)/i.test(options.hide.event)) {
		hideEvents.push('mouseleave');
	}

	/*
	 * Also make sure initial mouse targetting works correctly by caching mousemove coords
	 * on show targets before the tooltip has rendered. Also set onTarget when triggered to
	 * keep mouse tracking working.
	 */
	this._bind(showTarget, 'mousemove', function(moveEvent) {
		this._storeMouse(moveEvent);
		this.cache.onTarget = TRUE;
	});

	// Define hoverIntent function
	function hoverIntent(hoverEvent) {
		// Only continue if tooltip isn't disabled
		if(this.disabled || this.destroyed) { return FALSE; }

		// Cache the event data
		this.cache.event = hoverEvent && $.event.fix(hoverEvent);
		this.cache.target = hoverEvent && $(hoverEvent.target);

		// Start the event sequence
		clearTimeout(this.timers.show);
		this.timers.show = delay.call(this,
			function() { this.render(typeof hoverEvent === 'object' || options.show.ready); },
			options.prerender ? 0 : options.show.delay
		);
	}

	// Filter and bind events
	this._bindEvents(showEvents, hideEvents, showTarget, hideTarget, hoverIntent, function() {
		if(!this.timers) { return FALSE; }
		clearTimeout(this.timers.show);
	});

	// Prerendering is enabled, create tooltip now
	if(options.show.ready || options.prerender) { hoverIntent.call(this, event); }
};

// Event assignment method
PROTOTYPE._assignEvents = function() {
	var self = this,
		options = this.options,
		posOptions = options.position,

		tooltip = this.tooltip,
		showTarget = options.show.target,
		hideTarget = options.hide.target,
		containerTarget = posOptions.container,
		viewportTarget = posOptions.viewport,
		documentTarget = $(document),
		windowTarget = $(window),

		showEvents = options.show.event ? $.trim('' + options.show.event).split(' ') : [],
		hideEvents = options.hide.event ? $.trim('' + options.hide.event).split(' ') : [];


	// Assign passed event callbacks
	$.each(options.events, function(name, callback) {
		self._bind(tooltip, name === 'toggle' ? ['tooltipshow','tooltiphide'] : ['tooltip'+name], callback, null, tooltip);
	});

	// Hide tooltips when leaving current window/frame (but not select/option elements)
	if(/mouse(out|leave)/i.test(options.hide.event) && options.hide.leave === 'window') {
		this._bind(documentTarget, ['mouseout', 'blur'], function(event) {
			if(!/select|option/.test(event.target.nodeName) && !event.relatedTarget) {
				this.hide(event);
			}
		});
	}

	// Enable hide.fixed by adding appropriate class
	if(options.hide.fixed) {
		hideTarget = hideTarget.add( tooltip.addClass(CLASS_FIXED) );
	}

	/*
	 * Make sure hoverIntent functions properly by using mouseleave to clear show timer if
	 * mouseenter/mouseout is used for show.event, even if it isn't in the users options.
	 */
	else if(/mouse(over|enter)/i.test(options.show.event)) {
		this._bind(hideTarget, 'mouseleave', function() {
			clearTimeout(this.timers.show);
		});
	}

	// Hide tooltip on document mousedown if unfocus events are enabled
	if(('' + options.hide.event).indexOf('unfocus') > -1) {
		this._bind(containerTarget.closest('html'), ['mousedown', 'touchstart'], function(event) {
			var elem = $(event.target),
				enabled = this.rendered && !this.tooltip.hasClass(CLASS_DISABLED) && this.tooltip[0].offsetWidth > 0,
				isAncestor = elem.parents(SELECTOR).filter(this.tooltip[0]).length > 0;

			if(elem[0] !== this.target[0] && elem[0] !== this.tooltip[0] && !isAncestor &&
				!this.target.has(elem[0]).length && enabled
			) {
				this.hide(event);
			}
		});
	}

	// Check if the tooltip hides when inactive
	if('number' === typeof options.hide.inactive) {
		// Bind inactive method to show target(s) as a custom event
		this._bind(showTarget, 'qtip-'+this.id+'-inactive', inactiveMethod, 'inactive');

		// Define events which reset the 'inactive' event handler
		this._bind(hideTarget.add(tooltip), QTIP.inactiveEvents, inactiveMethod);
	}

	// Filter and bind events
	this._bindEvents(showEvents, hideEvents, showTarget, hideTarget, showMethod, hideMethod);

	// Mouse movement bindings
	this._bind(showTarget.add(tooltip), 'mousemove', function(event) {
		// Check if the tooltip hides when mouse is moved a certain distance
		if('number' === typeof options.hide.distance) {
			var origin = this.cache.origin || {},
				limit = this.options.hide.distance,
				abs = Math.abs;

			// Check if the movement has gone beyond the limit, and hide it if so
			if(abs(event.pageX - origin.pageX) >= limit || abs(event.pageY - origin.pageY) >= limit) {
				this.hide(event);
			}
		}

		// Cache mousemove coords on show targets
		this._storeMouse(event);
	});

	// Mouse positioning events
	if(posOptions.target === 'mouse') {
		// If mouse adjustment is on...
		if(posOptions.adjust.mouse) {
			// Apply a mouseleave event so we don't get problems with overlapping
			if(options.hide.event) {
				// Track if we're on the target or not
				this._bind(showTarget, ['mouseenter', 'mouseleave'], function(event) {
					if(!this.cache) {return FALSE; }
					this.cache.onTarget = event.type === 'mouseenter';
				});
			}

			// Update tooltip position on mousemove
			this._bind(documentTarget, 'mousemove', function(event) {
				// Update the tooltip position only if the tooltip is visible and adjustment is enabled
				if(this.rendered && this.cache.onTarget && !this.tooltip.hasClass(CLASS_DISABLED) && this.tooltip[0].offsetWidth > 0) {
					this.reposition(event);
				}
			});
		}
	}

	// Adjust positions of the tooltip on window resize if enabled
	if(posOptions.adjust.resize || viewportTarget.length) {
		this._bind( $.event.special.resize ? viewportTarget : windowTarget, 'resize', repositionMethod );
	}

	// Adjust tooltip position on scroll of the window or viewport element if present
	if(posOptions.adjust.scroll) {
		this._bind( windowTarget.add(posOptions.container), 'scroll', repositionMethod );
	}
};

// Un-assignment method
PROTOTYPE._unassignEvents = function() {
	var options = this.options,
		showTargets = options.show.target,
		hideTargets = options.hide.target,
		targets = $.grep([
			this.elements.target[0],
			this.rendered && this.tooltip[0],
			options.position.container[0],
			options.position.viewport[0],
			options.position.container.closest('html')[0], // unfocus
			window,
			document
		], function(i) {
			return typeof i === 'object';
		});

	// Add show and hide targets if they're valid
	if(showTargets && showTargets.toArray) {
		targets = targets.concat(showTargets.toArray());
	}
	if(hideTargets && hideTargets.toArray) {
		targets = targets.concat(hideTargets.toArray());
	}

	// Unbind the events
	this._unbind(targets)
		._unbind(targets, 'destroy')
		._unbind(targets, 'inactive');
};

// Apply common event handlers using delegate (avoids excessive .bind calls!)
$(function() {
	delegate(SELECTOR, ['mouseenter', 'mouseleave'], function(event) {
		var state = event.type === 'mouseenter',
			tooltip = $(event.currentTarget),
			target = $(event.relatedTarget || event.target),
			options = this.options;

		// On mouseenter...
		if(state) {
			// Focus the tooltip on mouseenter (z-index stacking)
			this.focus(event);

			// Clear hide timer on tooltip hover to prevent it from closing
			tooltip.hasClass(CLASS_FIXED) && !tooltip.hasClass(CLASS_DISABLED) && clearTimeout(this.timers.hide);
		}

		// On mouseleave...
		else {
			// When mouse tracking is enabled, hide when we leave the tooltip and not onto the show target (if a hide event is set)
			if(options.position.target === 'mouse' && options.position.adjust.mouse &&
				options.hide.event && options.show.target && !target.closest(options.show.target[0]).length) {
				this.hide(event);
			}
		}

		// Add hover class
		tooltip.toggleClass(CLASS_HOVER, state);
	});

	// Define events which reset the 'inactive' event handler
	delegate('['+ATTR_ID+']', INACTIVE_EVENTS, inactiveMethod);
});
;// Initialization method
function init(elem, id, opts) {
	var obj, posOptions, attr, config, title,

	// Setup element references
	docBody = $(document.body),

	// Use document body instead of document element if needed
	newTarget = elem[0] === document ? docBody : elem,

	// Grab metadata from element if plugin is present
	metadata = elem.metadata ? elem.metadata(opts.metadata) : NULL,

	// If metadata type if HTML5, grab 'name' from the object instead, or use the regular data object otherwise
	metadata5 = opts.metadata.type === 'html5' && metadata ? metadata[opts.metadata.name] : NULL,

	// Grab data from metadata.name (or data-qtipopts as fallback) using .data() method,
	html5 = elem.data(opts.metadata.name || 'qtipopts');

	// If we don't get an object returned attempt to parse it manualyl without parseJSON
	/* eslint-disable no-empty */
	try { html5 = typeof html5 === 'string' ? $.parseJSON(html5) : html5; }
	catch(e) {}
	/* eslint-enable no-empty */

	// Merge in and sanitize metadata
	config = $.extend(TRUE, {}, QTIP.defaults, opts,
		typeof html5 === 'object' ? sanitizeOptions(html5) : NULL,
		sanitizeOptions(metadata5 || metadata));

	// Re-grab our positioning options now we've merged our metadata and set id to passed value
	posOptions = config.position;
	config.id = id;

	// Setup missing content if none is detected
	if('boolean' === typeof config.content.text) {
		attr = elem.attr(config.content.attr);

		// Grab from supplied attribute if available
		if(config.content.attr !== FALSE && attr) { config.content.text = attr; }

		// No valid content was found, abort render
		else { return FALSE; }
	}

	// Setup target options
	if(!posOptions.container.length) { posOptions.container = docBody; }
	if(posOptions.target === FALSE) { posOptions.target = newTarget; }
	if(config.show.target === FALSE) { config.show.target = newTarget; }
	if(config.show.solo === TRUE) { config.show.solo = posOptions.container.closest('body'); }
	if(config.hide.target === FALSE) { config.hide.target = newTarget; }
	if(config.position.viewport === TRUE) { config.position.viewport = posOptions.container; }

	// Ensure we only use a single container
	posOptions.container = posOptions.container.eq(0);

	// Convert position corner values into x and y strings
	posOptions.at = new CORNER(posOptions.at, TRUE);
	posOptions.my = new CORNER(posOptions.my);

	// Destroy previous tooltip if overwrite is enabled, or skip element if not
	if(elem.data(NAMESPACE)) {
		if(config.overwrite) {
			elem.qtip('destroy', true);
		}
		else if(config.overwrite === FALSE) {
			return FALSE;
		}
	}

	// Add has-qtip attribute
	elem.attr(ATTR_HAS, id);

	// Remove title attribute and store it if present
	if(config.suppress && (title = elem.attr('title'))) {
		// Final attr call fixes event delegatiom and IE default tooltip showing problem
		elem.removeAttr('title').attr(oldtitle, title).attr('title', '');
	}

	// Initialize the tooltip and add API reference
	obj = new QTip(elem, config, id, !!attr);
	elem.data(NAMESPACE, obj);

	return obj;
}

// jQuery $.fn extension method
QTIP = $.fn.qtip = function(options, notation, newValue)
{
	var command = ('' + options).toLowerCase(), // Parse command
		returned = NULL,
		args = $.makeArray(arguments).slice(1),
		event = args[args.length - 1],
		opts = this[0] ? $.data(this[0], NAMESPACE) : NULL;

	// Check for API request
	if(!arguments.length && opts || command === 'api') {
		return opts;
	}

	// Execute API command if present
	else if('string' === typeof options) {
		this.each(function() {
			var api = $.data(this, NAMESPACE);
			if(!api) { return TRUE; }

			// Cache the event if possible
			if(event && event.timeStamp) { api.cache.event = event; }

			// Check for specific API commands
			if(notation && (command === 'option' || command === 'options')) {
				if(newValue !== undefined || $.isPlainObject(notation)) {
					api.set(notation, newValue);
				}
				else {
					returned = api.get(notation);
					return FALSE;
				}
			}

			// Execute API command
			else if(api[command]) {
				api[command].apply(api, args);
			}
		});

		return returned !== NULL ? returned : this;
	}

	// No API commands. validate provided options and setup qTips
	else if('object' === typeof options || !arguments.length) {
		// Sanitize options first
		opts = sanitizeOptions($.extend(TRUE, {}, options));

		return this.each(function(i) {
			var api, id;

			// Find next available ID, or use custom ID if provided
			id = $.isArray(opts.id) ? opts.id[i] : opts.id;
			id = !id || id === FALSE || id.length < 1 || QTIP.api[id] ? QTIP.nextid++ : id;

			// Initialize the qTip and re-grab newly sanitized options
			api = init($(this), id, opts);
			if(api === FALSE) { return TRUE; }
			else { QTIP.api[id] = api; }

			// Initialize plugins
			$.each(PLUGINS, function() {
				if(this.initialize === 'initialize') { this(api); }
			});

			// Assign initial pre-render events
			api._assignInitialEvents(event);
		});
	}
};

// Expose class
$.qtip = QTip;

// Populated in render method
QTIP.api = {};
;$.each({
	/* Allow other plugins to successfully retrieve the title of an element with a qTip applied */
	attr: function(attr, val) {
		if(this.length) {
			var self = this[0],
				title = 'title',
				api = $.data(self, 'qtip');

			if(attr === title && api && api.options && 'object' === typeof api && 'object' === typeof api.options && api.options.suppress) {
				if(arguments.length < 2) {
					return $.attr(self, oldtitle);
				}

				// If qTip is rendered and title was originally used as content, update it
				if(api && api.options.content.attr === title && api.cache.attr) {
					api.set('content.text', val);
				}

				// Use the regular attr method to set, then cache the result
				return this.attr(oldtitle, val);
			}
		}

		return $.fn['attr'+replaceSuffix].apply(this, arguments);
	},

	/* Allow clone to correctly retrieve cached title attributes */
	clone: function(keepData) {
		// Clone our element using the real clone method
		var elems = $.fn['clone'+replaceSuffix].apply(this, arguments);

		// Grab all elements with an oldtitle set, and change it to regular title attribute, if keepData is false
		if(!keepData) {
			elems.filter('['+oldtitle+']').attr('title', function() {
				return $.attr(this, oldtitle);
			})
			.removeAttr(oldtitle);
		}

		return elems;
	}
}, function(name, func) {
	if(!func || $.fn[name+replaceSuffix]) { return TRUE; }

	var old = $.fn[name+replaceSuffix] = $.fn[name];
	$.fn[name] = function() {
		return func.apply(this, arguments) || old.apply(this, arguments);
	};
});

/* Fire off 'removeqtip' handler in $.cleanData if jQuery UI not present (it already does similar).
 * This snippet is taken directly from jQuery UI source code found here:
 *     http://code.jquery.com/ui/jquery-ui-git.js
 */
if(!$.ui) {
	$['cleanData'+replaceSuffix] = $.cleanData;
	$.cleanData = function( elems ) {
		for(var i = 0, elem; (elem = $( elems[i] )).length; i++) {
			if(elem.attr(ATTR_HAS)) {
				/* eslint-disable no-empty */
				try { elem.triggerHandler('removeqtip'); }
				catch( e ) {}
				/* eslint-enable no-empty */
			}
		}
		$['cleanData'+replaceSuffix].apply(this, arguments);
	};
}
;// qTip version
QTIP.version = '3.0.3';

// Base ID for all qTips
QTIP.nextid = 0;

// Inactive events array
QTIP.inactiveEvents = INACTIVE_EVENTS;

// Base z-index for all qTips
QTIP.zindex = 15000;

// Define configuration defaults
QTIP.defaults = {
	prerender: FALSE,
	id: FALSE,
	overwrite: TRUE,
	suppress: TRUE,
	content: {
		text: TRUE,
		attr: 'title',
		title: FALSE,
		button: FALSE
	},
	position: {
		my: 'top left',
		at: 'bottom right',
		target: FALSE,
		container: FALSE,
		viewport: FALSE,
		adjust: {
			x: 0, y: 0,
			mouse: TRUE,
			scroll: TRUE,
			resize: TRUE,
			method: 'flipinvert flipinvert'
		},
		effect: function(api, pos) {
			$(this).animate(pos, {
				duration: 200,
				queue: FALSE
			});
		}
	},
	show: {
		target: FALSE,
		event: 'mouseenter',
		effect: TRUE,
		delay: 90,
		solo: FALSE,
		ready: FALSE,
		autofocus: FALSE
	},
	hide: {
		target: FALSE,
		event: 'mouseleave',
		effect: TRUE,
		delay: 0,
		fixed: FALSE,
		inactive: FALSE,
		leave: 'window',
		distance: FALSE
	},
	style: {
		classes: '',
		widget: FALSE,
		width: FALSE,
		height: FALSE,
		def: TRUE
	},
	events: {
		render: NULL,
		move: NULL,
		show: NULL,
		hide: NULL,
		toggle: NULL,
		visible: NULL,
		hidden: NULL,
		focus: NULL,
		blur: NULL
	}
};
;var TIP,
createVML,
SCALE,
PIXEL_RATIO,
BACKING_STORE_RATIO,

// Common CSS strings
MARGIN = 'margin',
BORDER = 'border',
COLOR = 'color',
BG_COLOR = 'background-color',
TRANSPARENT = 'transparent',
IMPORTANT = ' !important',

// Check if the browser supports <canvas/> elements
HASCANVAS = !!document.createElement('canvas').getContext,

// Invalid colour values used in parseColours()
INVALID = /rgba?\(0, 0, 0(, 0)?\)|transparent|#123456/i;

// Camel-case method, taken from jQuery source
// http://code.jquery.com/jquery-1.8.0.js
function camel(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

/*
 * Modified from Modernizr's testPropsAll()
 * http://modernizr.com/downloads/modernizr-latest.js
 */
var cssProps = {}, cssPrefixes = ['Webkit', 'O', 'Moz', 'ms'];
function vendorCss(elem, prop) {
	var ucProp = prop.charAt(0).toUpperCase() + prop.slice(1),
		props = (prop + ' ' + cssPrefixes.join(ucProp + ' ') + ucProp).split(' '),
		cur, val, i = 0;

	// If the property has already been mapped...
	if(cssProps[prop]) { return elem.css(cssProps[prop]); }

	while(cur = props[i++]) {
		if((val = elem.css(cur)) !== undefined) {
			cssProps[prop] = cur;
			return val;
		}
	}
}

// Parse a given elements CSS property into an int
function intCss(elem, prop) {
	return Math.ceil(parseFloat(vendorCss(elem, prop)));
}


// VML creation (for IE only)
if(!HASCANVAS) {
	createVML = function(tag, props, style) {
		return '<qtipvml:'+tag+' xmlns="urn:schemas-microsoft.com:vml" class="qtip-vml" '+(props||'')+
			' style="behavior: url(#default#VML); '+(style||'')+ '" />';
	};
}

// Canvas only definitions
else {
	PIXEL_RATIO = window.devicePixelRatio || 1;
	BACKING_STORE_RATIO = (function() {
		var context = document.createElement('canvas').getContext('2d');
		return context.backingStorePixelRatio || context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio ||
				context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || 1;
	})();
	SCALE = PIXEL_RATIO / BACKING_STORE_RATIO;
}


function Tip(qtip, options) {
	this._ns = 'tip';
	this.options = options;
	this.offset = options.offset;
	this.size = [ options.width, options.height ];

	// Initialize
	this.qtip = qtip;
	this.init(qtip);
}

$.extend(Tip.prototype, {
	init: function(qtip) {
		var context, tip;

		// Create tip element and prepend to the tooltip
		tip = this.element = qtip.elements.tip = $('<div />', { 'class': NAMESPACE+'-tip' }).prependTo(qtip.tooltip);

		// Create tip drawing element(s)
		if(HASCANVAS) {
			// save() as soon as we create the canvas element so FF2 doesn't bork on our first restore()!
			context = $('<canvas />').appendTo(this.element)[0].getContext('2d');

			// Setup constant parameters
			context.lineJoin = 'miter';
			context.miterLimit = 100000;
			context.save();
		}
		else {
			context = createVML('shape', 'coordorigin="0,0"', 'position:absolute;');
			this.element.html(context + context);

			// Prevent mousing down on the tip since it causes problems with .live() handling in IE due to VML
			qtip._bind( $('*', tip).add(tip), ['click', 'mousedown'], function(event) { event.stopPropagation(); }, this._ns);
		}

		// Bind update events
		qtip._bind(qtip.tooltip, 'tooltipmove', this.reposition, this._ns, this);

		// Create it
		this.create();
	},

	_swapDimensions: function() {
		this.size[0] = this.options.height;
		this.size[1] = this.options.width;
	},
	_resetDimensions: function() {
		this.size[0] = this.options.width;
		this.size[1] = this.options.height;
	},

	_useTitle: function(corner) {
		var titlebar = this.qtip.elements.titlebar;
		return titlebar && (
			corner.y === TOP || corner.y === CENTER && this.element.position().top + this.size[1] / 2 + this.options.offset < titlebar.outerHeight(TRUE)
		);
	},

	_parseCorner: function(corner) {
		var my = this.qtip.options.position.my;

		// Detect corner and mimic properties
		if(corner === FALSE || my === FALSE) {
			corner = FALSE;
		}
		else if(corner === TRUE) {
			corner = new CORNER( my.string() );
		}
		else if(!corner.string) {
			corner = new CORNER(corner);
			corner.fixed = TRUE;
		}

		return corner;
	},

	_parseWidth: function(corner, side, use) {
		var elements = this.qtip.elements,
			prop = BORDER + camel(side) + 'Width';

		return (use ? intCss(use, prop) : 
			intCss(elements.content, prop) ||
			intCss(this._useTitle(corner) && elements.titlebar || elements.content, prop) ||
			intCss(elements.tooltip, prop)
		) || 0;
	},

	_parseRadius: function(corner) {
		var elements = this.qtip.elements,
			prop = BORDER + camel(corner.y) + camel(corner.x) + 'Radius';

		return BROWSER.ie < 9 ? 0 :
			intCss(this._useTitle(corner) && elements.titlebar || elements.content, prop) ||
			intCss(elements.tooltip, prop) || 0;
	},

	_invalidColour: function(elem, prop, compare) {
		var val = elem.css(prop);
		return !val || compare && val === elem.css(compare) || INVALID.test(val) ? FALSE : val;
	},

	_parseColours: function(corner) {
		var elements = this.qtip.elements,
			tip = this.element.css('cssText', ''),
			borderSide = BORDER + camel(corner[ corner.precedance ]) + camel(COLOR),
			colorElem = this._useTitle(corner) && elements.titlebar || elements.content,
			css = this._invalidColour, color = [];

		// Attempt to detect the background colour from various elements, left-to-right precedance
		color[0] = css(tip, BG_COLOR) || css(colorElem, BG_COLOR) || css(elements.content, BG_COLOR) ||
			css(elements.tooltip, BG_COLOR) || tip.css(BG_COLOR);

		// Attempt to detect the correct border side colour from various elements, left-to-right precedance
		color[1] = css(tip, borderSide, COLOR) || css(colorElem, borderSide, COLOR) ||
			css(elements.content, borderSide, COLOR) || css(elements.tooltip, borderSide, COLOR) || elements.tooltip.css(borderSide);

		// Reset background and border colours
		$('*', tip).add(tip).css('cssText', BG_COLOR+':'+TRANSPARENT+IMPORTANT+';'+BORDER+':0'+IMPORTANT+';');

		return color;
	},

	_calculateSize: function(corner) {
		var y = corner.precedance === Y,
			width = this.options.width,
			height = this.options.height,
			isCenter = corner.abbrev() === 'c',
			base = (y ? width: height) * (isCenter ? 0.5 : 1),
			pow = Math.pow,
			round = Math.round,
			bigHyp, ratio, result,

		smallHyp = Math.sqrt( pow(base, 2) + pow(height, 2) ),
		hyp = [
			this.border / base * smallHyp,
			this.border / height * smallHyp
		];

		hyp[2] = Math.sqrt( pow(hyp[0], 2) - pow(this.border, 2) );
		hyp[3] = Math.sqrt( pow(hyp[1], 2) - pow(this.border, 2) );

		bigHyp = smallHyp + hyp[2] + hyp[3] + (isCenter ? 0 : hyp[0]);
		ratio = bigHyp / smallHyp;

		result = [ round(ratio * width), round(ratio * height) ];
		return y ? result : result.reverse();
	},

	// Tip coordinates calculator
	_calculateTip: function(corner, size, scale) {
		scale = scale || 1;
		size = size || this.size;

		var width = size[0] * scale,
			height = size[1] * scale,
			width2 = Math.ceil(width / 2), height2 = Math.ceil(height / 2),

		// Define tip coordinates in terms of height and width values
		tips = {
			br:	[0,0,		width,height,	width,0],
			bl:	[0,0,		width,0,		0,height],
			tr:	[0,height,	width,0,		width,height],
			tl:	[0,0,		0,height,		width,height],
			tc:	[0,height,	width2,0,		width,height],
			bc:	[0,0,		width,0,		width2,height],
			rc:	[0,0,		width,height2,	0,height],
			lc:	[width,0,	width,height,	0,height2]
		};

		// Set common side shapes
		tips.lt = tips.br; tips.rt = tips.bl;
		tips.lb = tips.tr; tips.rb = tips.tl;

		return tips[ corner.abbrev() ];
	},

	// Tip coordinates drawer (canvas)
	_drawCoords: function(context, coords) {
		context.beginPath();
		context.moveTo(coords[0], coords[1]);
		context.lineTo(coords[2], coords[3]);
		context.lineTo(coords[4], coords[5]);
		context.closePath();
	},

	create: function() {
		// Determine tip corner
		var c = this.corner = (HASCANVAS || BROWSER.ie) && this._parseCorner(this.options.corner);

		// If we have a tip corner...
		this.enabled = !!this.corner && this.corner.abbrev() !== 'c';
		if(this.enabled) {
			// Cache it
			this.qtip.cache.corner = c.clone();

			// Create it
			this.update();
		}

		// Toggle tip element
		this.element.toggle(this.enabled);

		return this.corner;
	},

	update: function(corner, position) {
		if(!this.enabled) { return this; }

		var elements = this.qtip.elements,
			tip = this.element,
			inner = tip.children(),
			options = this.options,
			curSize = this.size,
			mimic = options.mimic,
			round = Math.round,
			color, precedance, context,
			coords, bigCoords, translate, newSize, border;

		// Re-determine tip if not already set
		if(!corner) { corner = this.qtip.cache.corner || this.corner; }

		// Use corner property if we detect an invalid mimic value
		if(mimic === FALSE) { mimic = corner; }

		// Otherwise inherit mimic properties from the corner object as necessary
		else {
			mimic = new CORNER(mimic);
			mimic.precedance = corner.precedance;

			if(mimic.x === 'inherit') { mimic.x = corner.x; }
			else if(mimic.y === 'inherit') { mimic.y = corner.y; }
			else if(mimic.x === mimic.y) {
				mimic[ corner.precedance ] = corner[ corner.precedance ];
			}
		}
		precedance = mimic.precedance;

		// Ensure the tip width.height are relative to the tip position
		if(corner.precedance === X) { this._swapDimensions(); }
		else { this._resetDimensions(); }

		// Update our colours
		color = this.color = this._parseColours(corner);

		// Detect border width, taking into account colours
		if(color[1] !== TRANSPARENT) {
			// Grab border width
			border = this.border = this._parseWidth(corner, corner[corner.precedance]);

			// If border width isn't zero, use border color as fill if it's not invalid (1.0 style tips)
			if(options.border && border < 1 && !INVALID.test(color[1])) { color[0] = color[1]; }

			// Set border width (use detected border width if options.border is true)
			this.border = border = options.border !== TRUE ? options.border : border;
		}

		// Border colour was invalid, set border to zero
		else { this.border = border = 0; }

		// Determine tip size
		newSize = this.size = this._calculateSize(corner);
		tip.css({
			width: newSize[0],
			height: newSize[1],
			lineHeight: newSize[1]+'px'
		});

		// Calculate tip translation
		if(corner.precedance === Y) {
			translate = [
				round(mimic.x === LEFT ? border : mimic.x === RIGHT ? newSize[0] - curSize[0] - border : (newSize[0] - curSize[0]) / 2),
				round(mimic.y === TOP ? newSize[1] - curSize[1] : 0)
			];
		}
		else {
			translate = [
				round(mimic.x === LEFT ? newSize[0] - curSize[0] : 0),
				round(mimic.y === TOP ? border : mimic.y === BOTTOM ? newSize[1] - curSize[1] - border : (newSize[1] - curSize[1]) / 2)
			];
		}

		// Canvas drawing implementation
		if(HASCANVAS) {
			// Grab canvas context and clear/save it
			context = inner[0].getContext('2d');
			context.restore(); context.save();
			context.clearRect(0,0,6000,6000);

			// Calculate coordinates
			coords = this._calculateTip(mimic, curSize, SCALE);
			bigCoords = this._calculateTip(mimic, this.size, SCALE);

			// Set the canvas size using calculated size
			inner.attr(WIDTH, newSize[0] * SCALE).attr(HEIGHT, newSize[1] * SCALE);
			inner.css(WIDTH, newSize[0]).css(HEIGHT, newSize[1]);

			// Draw the outer-stroke tip
			this._drawCoords(context, bigCoords);
			context.fillStyle = color[1];
			context.fill();

			// Draw the actual tip
			context.translate(translate[0] * SCALE, translate[1] * SCALE);
			this._drawCoords(context, coords);
			context.fillStyle = color[0];
			context.fill();
		}

		// VML (IE Proprietary implementation)
		else {
			// Calculate coordinates
			coords = this._calculateTip(mimic);

			// Setup coordinates string
			coords = 'm' + coords[0] + ',' + coords[1] + ' l' + coords[2] +
				',' + coords[3] + ' ' + coords[4] + ',' + coords[5] + ' xe';

			// Setup VML-specific offset for pixel-perfection
			translate[2] = border && /^(r|b)/i.test(corner.string()) ?
				BROWSER.ie === 8 ? 2 : 1 : 0;

			// Set initial CSS
			inner.css({
				coordsize: newSize[0]+border + ' ' + newSize[1]+border,
				antialias: ''+(mimic.string().indexOf(CENTER) > -1),
				left: translate[0] - translate[2] * Number(precedance === X),
				top: translate[1] - translate[2] * Number(precedance === Y),
				width: newSize[0] + border,
				height: newSize[1] + border
			})
			.each(function(i) {
				var $this = $(this);

				// Set shape specific attributes
				$this[ $this.prop ? 'prop' : 'attr' ]({
					coordsize: newSize[0]+border + ' ' + newSize[1]+border,
					path: coords,
					fillcolor: color[0],
					filled: !!i,
					stroked: !i
				})
				.toggle(!!(border || i));

				// Check if border is enabled and add stroke element
				!i && $this.html( createVML(
					'stroke', 'weight="'+border*2+'px" color="'+color[1]+'" miterlimit="1000" joinstyle="miter"'
				) );
			});
		}

		// Opera bug #357 - Incorrect tip position
		// https://github.com/Craga89/qTip2/issues/367
		window.opera && setTimeout(function() {
			elements.tip.css({
				display: 'inline-block',
				visibility: 'visible'
			});
		}, 1);

		// Position if needed
		if(position !== FALSE) { this.calculate(corner, newSize); }
	},

	calculate: function(corner, size) {
		if(!this.enabled) { return FALSE; }

		var self = this,
			elements = this.qtip.elements,
			tip = this.element,
			userOffset = this.options.offset,
			position = {},
			precedance, corners;

		// Inherit corner if not provided
		corner = corner || this.corner;
		precedance = corner.precedance;

		// Determine which tip dimension to use for adjustment
		size = size || this._calculateSize(corner);

		// Setup corners and offset array
		corners = [ corner.x, corner.y ];
		if(precedance === X) { corners.reverse(); }

		// Calculate tip position
		$.each(corners, function(i, side) {
			var b, bc, br;

			if(side === CENTER) {
				b = precedance === Y ? LEFT : TOP;
				position[ b ] = '50%';
				position[MARGIN+'-' + b] = -Math.round(size[ precedance === Y ? 0 : 1 ] / 2) + userOffset;
			}
			else {
				b = self._parseWidth(corner, side, elements.tooltip);
				bc = self._parseWidth(corner, side, elements.content);
				br = self._parseRadius(corner);

				position[ side ] = Math.max(-self.border, i ? bc : userOffset + (br > b ? br : -b));
			}
		});

		// Adjust for tip size
		position[ corner[precedance] ] -= size[ precedance === X ? 0 : 1 ];

		// Set and return new position
		tip.css({ margin: '', top: '', bottom: '', left: '', right: '' }).css(position);
		return position;
	},

	reposition: function(event, api, pos) {
		if(!this.enabled) { return; }

		var cache = api.cache,
			newCorner = this.corner.clone(),
			adjust = pos.adjusted,
			method = api.options.position.adjust.method.split(' '),
			horizontal = method[0],
			vertical = method[1] || method[0],
			shift = { left: FALSE, top: FALSE, x: 0, y: 0 },
			offset, css = {}, props;

		function shiftflip(direction, precedance, popposite, side, opposite) {
			// Horizontal - Shift or flip method
			if(direction === SHIFT && newCorner.precedance === precedance && adjust[side] && newCorner[popposite] !== CENTER) {
				newCorner.precedance = newCorner.precedance === X ? Y : X;
			}
			else if(direction !== SHIFT && adjust[side]){
				newCorner[precedance] = newCorner[precedance] === CENTER ?
					adjust[side] > 0 ? side : opposite :
					newCorner[precedance] === side ? opposite : side;
			}
		}

		function shiftonly(xy, side, opposite) {
			if(newCorner[xy] === CENTER) {
				css[MARGIN+'-'+side] = shift[xy] = offset[MARGIN+'-'+side] - adjust[side];
			}
			else {
				props = offset[opposite] !== undefined ?
					[ adjust[side], -offset[side] ] : [ -adjust[side], offset[side] ];

				if( (shift[xy] = Math.max(props[0], props[1])) > props[0] ) {
					pos[side] -= adjust[side];
					shift[side] = FALSE;
				}

				css[ offset[opposite] !== undefined ? opposite : side ] = shift[xy];
			}
		}

		// If our tip position isn't fixed e.g. doesn't adjust with viewport...
		if(this.corner.fixed !== TRUE) {
			// Perform shift/flip adjustments
			shiftflip(horizontal, X, Y, LEFT, RIGHT);
			shiftflip(vertical, Y, X, TOP, BOTTOM);

			// Update and redraw the tip if needed (check cached details of last drawn tip)
			if(newCorner.string() !== cache.corner.string() || cache.cornerTop !== adjust.top || cache.cornerLeft !== adjust.left) {
				this.update(newCorner, FALSE);
			}
		}

		// Setup tip offset properties
		offset = this.calculate(newCorner);

		// Readjust offset object to make it left/top
		if(offset.right !== undefined) { offset.left = -offset.right; }
		if(offset.bottom !== undefined) { offset.top = -offset.bottom; }
		offset.user = this.offset;

		// Perform shift adjustments
		shift.left = horizontal === SHIFT && !!adjust.left;
		if(shift.left) {
			shiftonly(X, LEFT, RIGHT);
		}
		shift.top = vertical === SHIFT && !!adjust.top;
		if(shift.top) {
			shiftonly(Y, TOP, BOTTOM);
		}

		/*
		* If the tip is adjusted in both dimensions, or in a
		* direction that would cause it to be anywhere but the
		* outer border, hide it!
		*/
		this.element.css(css).toggle(
			!(shift.x && shift.y || newCorner.x === CENTER && shift.y || newCorner.y === CENTER && shift.x)
		);

		// Adjust position to accomodate tip dimensions
		pos.left -= offset.left.charAt ? offset.user :
			horizontal !== SHIFT || shift.top || !shift.left && !shift.top ? offset.left + this.border : 0;
		pos.top -= offset.top.charAt ? offset.user :
			vertical !== SHIFT || shift.left || !shift.left && !shift.top ? offset.top + this.border : 0;

		// Cache details
		cache.cornerLeft = adjust.left; cache.cornerTop = adjust.top;
		cache.corner = newCorner.clone();
	},

	destroy: function() {
		// Unbind events
		this.qtip._unbind(this.qtip.tooltip, this._ns);

		// Remove the tip element(s)
		if(this.qtip.elements.tip) {
			this.qtip.elements.tip.find('*')
				.remove().end().remove();
		}
	}
});

TIP = PLUGINS.tip = function(api) {
	return new Tip(api, api.options.style.tip);
};

// Initialize tip on render
TIP.initialize = 'render';

// Setup plugin sanitization options
TIP.sanitize = function(options) {
	if(options.style && 'tip' in options.style) {
		var opts = options.style.tip;
		if(typeof opts !== 'object') { opts = options.style.tip = { corner: opts }; }
		if(!(/string|boolean/i).test(typeof opts.corner)) { opts.corner = TRUE; }
	}
};

// Add new option checks for the plugin
CHECKS.tip = {
	'^position.my|style.tip.(corner|mimic|border)$': function() {
		// Make sure a tip can be drawn
		this.create();

		// Reposition the tooltip
		this.qtip.reposition();
	},
	'^style.tip.(height|width)$': function(obj) {
		// Re-set dimensions and redraw the tip
		this.size = [ obj.width, obj.height ];
		this.update();

		// Reposition the tooltip
		this.qtip.reposition();
	},
	'^content.title|style.(classes|widget)$': function() {
		this.update();
	}
};

// Extend original qTip defaults
$.extend(TRUE, QTIP.defaults, {
	style: {
		tip: {
			corner: TRUE,
			mimic: FALSE,
			width: 6,
			height: 6,
			border: TRUE,
			offset: 0
		}
	}
});
;var MODAL, OVERLAY,
	MODALCLASS = 'qtip-modal',
	MODALSELECTOR = '.'+MODALCLASS;

OVERLAY = function()
{
	var self = this,
		focusableElems = {},
		current,
		prevState,
		elem;

	// Modified code from jQuery UI 1.10.0 source
	// http://code.jquery.com/ui/1.10.0/jquery-ui.js
	function focusable(element) {
		// Use the defined focusable checker when possible
		if($.expr[':'].focusable) { return $.expr[':'].focusable; }

		var isTabIndexNotNaN = !isNaN($.attr(element, 'tabindex')),
			nodeName = element.nodeName && element.nodeName.toLowerCase(),
			map, mapName, img;

		if('area' === nodeName) {
			map = element.parentNode;
			mapName = map.name;
			if(!element.href || !mapName || map.nodeName.toLowerCase() !== 'map') {
				return false;
			}
			img = $('img[usemap=#' + mapName + ']')[0];
			return !!img && img.is(':visible');
		}

		return /input|select|textarea|button|object/.test( nodeName ) ?
			!element.disabled :
			'a' === nodeName ?
				element.href || isTabIndexNotNaN :
				isTabIndexNotNaN
		;
	}

	// Focus inputs using cached focusable elements (see update())
	function focusInputs(blurElems) {
		// Blurring body element in IE causes window.open windows to unfocus!
		if(focusableElems.length < 1 && blurElems.length) { blurElems.not('body').blur(); }

		// Focus the inputs
		else { focusableElems.first().focus(); }
	}

	// Steal focus from elements outside tooltip
	function stealFocus(event) {
		if(!elem.is(':visible')) { return; }

		var target = $(event.target),
			tooltip = current.tooltip,
			container = target.closest(SELECTOR),
			targetOnTop;

		// Determine if input container target is above this
		targetOnTop = container.length < 1 ? FALSE :
			parseInt(container[0].style.zIndex, 10) > parseInt(tooltip[0].style.zIndex, 10);

		// If we're showing a modal, but focus has landed on an input below
		// this modal, divert focus to the first visible input in this modal
		// or if we can't find one... the tooltip itself
		if(!targetOnTop && target.closest(SELECTOR)[0] !== tooltip[0]) {
			focusInputs(target);
		}
	}

	$.extend(self, {
		init: function() {
			// Create document overlay
			elem = self.elem = $('<div />', {
				id: 'qtip-overlay',
				html: '<div></div>',
				mousedown: function() { return FALSE; }
			})
			.hide();

			// Make sure we can't focus anything outside the tooltip
			$(document.body).bind('focusin'+MODALSELECTOR, stealFocus);

			// Apply keyboard "Escape key" close handler
			$(document).bind('keydown'+MODALSELECTOR, function(event) {
				if(current && current.options.show.modal.escape && event.keyCode === 27) {
					current.hide(event);
				}
			});

			// Apply click handler for blur option
			elem.bind('click'+MODALSELECTOR, function(event) {
				if(current && current.options.show.modal.blur) {
					current.hide(event);
				}
			});

			return self;
		},

		update: function(api) {
			// Update current API reference
			current = api;

			// Update focusable elements if enabled
			if(api.options.show.modal.stealfocus !== FALSE) {
				focusableElems = api.tooltip.find('*').filter(function() {
					return focusable(this);
				});
			}
			else { focusableElems = []; }
		},

		toggle: function(api, state, duration) {
			var tooltip = api.tooltip,
				options = api.options.show.modal,
				effect = options.effect,
				type = state ? 'show': 'hide',
				visible = elem.is(':visible'),
				visibleModals = $(MODALSELECTOR).filter(':visible:not(:animated)').not(tooltip);

			// Set active tooltip API reference
			self.update(api);

			// If the modal can steal the focus...
			// Blur the current item and focus anything in the modal we an
			if(state && options.stealfocus !== FALSE) {
				focusInputs( $(':focus') );
			}

			// Toggle backdrop cursor style on show
			elem.toggleClass('blurs', options.blur);

			// Append to body on show
			if(state) {
				elem.appendTo(document.body);
			}

			// Prevent modal from conflicting with show.solo, and don't hide backdrop is other modals are visible
			if(elem.is(':animated') && visible === state && prevState !== FALSE || !state && visibleModals.length) {
				return self;
			}

			// Stop all animations
			elem.stop(TRUE, FALSE);

			// Use custom function if provided
			if($.isFunction(effect)) {
				effect.call(elem, state);
			}

			// If no effect type is supplied, use a simple toggle
			else if(effect === FALSE) {
				elem[ type ]();
			}

			// Use basic fade function
			else {
				elem.fadeTo( parseInt(duration, 10) || 90, state ? 1 : 0, function() {
					if(!state) { elem.hide(); }
				});
			}

			// Reset position and detach from body on hide
			if(!state) {
				elem.queue(function(next) {
					elem.css({ left: '', top: '' });
					if(!$(MODALSELECTOR).length) { elem.detach(); }
					next();
				});
			}

			// Cache the state
			prevState = state;

			// If the tooltip is destroyed, set reference to null
			if(current.destroyed) { current = NULL; }

			return self;
		}
	});

	self.init();
};
OVERLAY = new OVERLAY();

function Modal(api, options) {
	this.options = options;
	this._ns = '-modal';

	this.qtip = api;
	this.init(api);
}

$.extend(Modal.prototype, {
	init: function(qtip) {
		var tooltip = qtip.tooltip;

		// If modal is disabled... return
		if(!this.options.on) { return this; }

		// Set overlay reference
		qtip.elements.overlay = OVERLAY.elem;

		// Add unique attribute so we can grab modal tooltips easily via a SELECTOR, and set z-index
		tooltip.addClass(MODALCLASS).css('z-index', QTIP.modal_zindex + $(MODALSELECTOR).length);

		// Apply our show/hide/focus modal events
		qtip._bind(tooltip, ['tooltipshow', 'tooltiphide'], function(event, api, duration) {
			var oEvent = event.originalEvent;

			// Make sure mouseout doesn't trigger a hide when showing the modal and mousing onto backdrop
			if(event.target === tooltip[0]) {
				if(oEvent && event.type === 'tooltiphide' && /mouse(leave|enter)/.test(oEvent.type) && $(oEvent.relatedTarget).closest(OVERLAY.elem[0]).length) {
					/* eslint-disable no-empty */
					try { event.preventDefault(); }
					catch(e) {}
					/* eslint-enable no-empty */
				}
				else if(!oEvent || oEvent && oEvent.type !== 'tooltipsolo') {
					this.toggle(event, event.type === 'tooltipshow', duration);
				}
			}
		}, this._ns, this);

		// Adjust modal z-index on tooltip focus
		qtip._bind(tooltip, 'tooltipfocus', function(event, api) {
			// If focus was cancelled before it reached us, don't do anything
			if(event.isDefaultPrevented() || event.target !== tooltip[0]) { return; }

			var qtips = $(MODALSELECTOR),

			// Keep the modal's lower than other, regular qtips
			newIndex = QTIP.modal_zindex + qtips.length,
			curIndex = parseInt(tooltip[0].style.zIndex, 10);

			// Set overlay z-index
			OVERLAY.elem[0].style.zIndex = newIndex - 1;

			// Reduce modal z-index's and keep them properly ordered
			qtips.each(function() {
				if(this.style.zIndex > curIndex) {
					this.style.zIndex -= 1;
				}
			});

			// Fire blur event for focused tooltip
			qtips.filter('.' + CLASS_FOCUS).qtip('blur', event.originalEvent);

			// Set the new z-index
			tooltip.addClass(CLASS_FOCUS)[0].style.zIndex = newIndex;

			// Set current
			OVERLAY.update(api);

			// Prevent default handling
			/* eslint-disable no-empty */
			try { event.preventDefault(); }
			catch(e) {}
			/* eslint-enable no-empty */
		}, this._ns, this);

		// Focus any other visible modals when this one hides
		qtip._bind(tooltip, 'tooltiphide', function(event) {
			if(event.target === tooltip[0]) {
				$(MODALSELECTOR).filter(':visible').not(tooltip).last().qtip('focus', event);
			}
		}, this._ns, this);
	},

	toggle: function(event, state, duration) {
		// Make sure default event hasn't been prevented
		if(event && event.isDefaultPrevented()) { return this; }

		// Toggle it
		OVERLAY.toggle(this.qtip, !!state, duration);
	},

	destroy: function() {
		// Remove modal class
		this.qtip.tooltip.removeClass(MODALCLASS);

		// Remove bound events
		this.qtip._unbind(this.qtip.tooltip, this._ns);

		// Delete element reference
		OVERLAY.toggle(this.qtip, FALSE);
		delete this.qtip.elements.overlay;
	}
});


MODAL = PLUGINS.modal = function(api) {
	return new Modal(api, api.options.show.modal);
};

// Setup sanitiztion rules
MODAL.sanitize = function(opts) {
	if(opts.show) {
		if(typeof opts.show.modal !== 'object') { opts.show.modal = { on: !!opts.show.modal }; }
		else if(typeof opts.show.modal.on === 'undefined') { opts.show.modal.on = TRUE; }
	}
};

// Base z-index for all modal tooltips (use qTip core z-index as a base)
/* eslint-disable camelcase */
QTIP.modal_zindex = QTIP.zindex - 200;
/* eslint-enable camelcase */

// Plugin needs to be initialized on render
MODAL.initialize = 'render';

// Setup option set checks
CHECKS.modal = {
	'^show.modal.(on|blur)$': function() {
		// Initialise
		this.destroy();
		this.init();

		// Show the modal if not visible already and tooltip is visible
		this.qtip.elems.overlay.toggle(
			this.qtip.tooltip[0].offsetWidth > 0
		);
	}
};

// Extend original api defaults
$.extend(TRUE, QTIP.defaults, {
	show: {
		modal: {
			on: FALSE,
			effect: TRUE,
			blur: TRUE,
			stealfocus: TRUE,
			escape: TRUE
		}
	}
});
;PLUGINS.viewport = function(api, position, posOptions, targetWidth, targetHeight, elemWidth, elemHeight)
{
	var target = posOptions.target,
		tooltip = api.elements.tooltip,
		my = posOptions.my,
		at = posOptions.at,
		adjust = posOptions.adjust,
		method = adjust.method.split(' '),
		methodX = method[0],
		methodY = method[1] || method[0],
		viewport = posOptions.viewport,
		container = posOptions.container,
		adjusted = { left: 0, top: 0 },
		fixed, newMy, containerOffset, containerStatic,
		viewportWidth, viewportHeight, viewportScroll, viewportOffset;

	// If viewport is not a jQuery element, or it's the window/document, or no adjustment method is used... return
	if(!viewport.jquery || target[0] === window || target[0] === document.body || adjust.method === 'none') {
		return adjusted;
	}

	// Cach container details
	containerOffset = container.offset() || adjusted;
	containerStatic = container.css('position') === 'static';

	// Cache our viewport details
	fixed = tooltip.css('position') === 'fixed';
	viewportWidth = viewport[0] === window ? viewport.width() : viewport.outerWidth(FALSE);
	viewportHeight = viewport[0] === window ? viewport.height() : viewport.outerHeight(FALSE);
	viewportScroll = { left: fixed ? 0 : viewport.scrollLeft(), top: fixed ? 0 : viewport.scrollTop() };
	viewportOffset = viewport.offset() || adjusted;

	// Generic calculation method
	function calculate(side, otherSide, type, adjustment, side1, side2, lengthName, targetLength, elemLength) {
		var initialPos = position[side1],
			mySide = my[side],
			atSide = at[side],
			isShift = type === SHIFT,
			myLength = mySide === side1 ? elemLength : mySide === side2 ? -elemLength : -elemLength / 2,
			atLength = atSide === side1 ? targetLength : atSide === side2 ? -targetLength : -targetLength / 2,
			sideOffset = viewportScroll[side1] + viewportOffset[side1] - (containerStatic ? 0 : containerOffset[side1]),
			overflow1 = sideOffset - initialPos,
			overflow2 = initialPos + elemLength - (lengthName === WIDTH ? viewportWidth : viewportHeight) - sideOffset,
			offset = myLength - (my.precedance === side || mySide === my[otherSide] ? atLength : 0) - (atSide === CENTER ? targetLength / 2 : 0);

		// shift
		if(isShift) {
			offset = (mySide === side1 ? 1 : -1) * myLength;

			// Adjust position but keep it within viewport dimensions
			position[side1] += overflow1 > 0 ? overflow1 : overflow2 > 0 ? -overflow2 : 0;
			position[side1] = Math.max(
				-containerOffset[side1] + viewportOffset[side1],
				initialPos - offset,
				Math.min(
					Math.max(
						-containerOffset[side1] + viewportOffset[side1] + (lengthName === WIDTH ? viewportWidth : viewportHeight),
						initialPos + offset
					),
					position[side1],

					// Make sure we don't adjust complete off the element when using 'center'
					mySide === 'center' ? initialPos - myLength : 1E9
				)
			);

		}

		// flip/flipinvert
		else {
			// Update adjustment amount depending on if using flipinvert or flip
			adjustment *= type === FLIPINVERT ? 2 : 0;

			// Check for overflow on the left/top
			if(overflow1 > 0 && (mySide !== side1 || overflow2 > 0)) {
				position[side1] -= offset + adjustment;
				newMy.invert(side, side1);
			}

			// Check for overflow on the bottom/right
			else if(overflow2 > 0 && (mySide !== side2 || overflow1 > 0)  ) {
				position[side1] -= (mySide === CENTER ? -offset : offset) + adjustment;
				newMy.invert(side, side2);
			}

			// Make sure we haven't made things worse with the adjustment and reset if so
			if(position[side1] < viewportScroll[side1] && -position[side1] > overflow2) {
				position[side1] = initialPos; newMy = my.clone();
			}
		}

		return position[side1] - initialPos;
	}

	// Set newMy if using flip or flipinvert methods
	if(methodX !== 'shift' || methodY !== 'shift') { newMy = my.clone(); }

	// Adjust position based onviewport and adjustment options
	adjusted = {
		left: methodX !== 'none' ? calculate( X, Y, methodX, adjust.x, LEFT, RIGHT, WIDTH, targetWidth, elemWidth ) : 0,
		top: methodY !== 'none' ? calculate( Y, X, methodY, adjust.y, TOP, BOTTOM, HEIGHT, targetHeight, elemHeight ) : 0,
		my: newMy
	};

	return adjusted;
};
;PLUGINS.polys = {
	// POLY area coordinate calculator
	//	Special thanks to Ed Cradock for helping out with this.
	//	Uses a binary search algorithm to find suitable coordinates.
	polygon: function(baseCoords, corner) {
		var result = {
			width: 0, height: 0,
			position: {
				top: 1e10, right: 0,
				bottom: 0, left: 1e10
			},
			adjustable: FALSE
		},
		i = 0, next,
		coords = [],
		compareX = 1, compareY = 1,
		realX = 0, realY = 0,
		newWidth, newHeight;

		// First pass, sanitize coords and determine outer edges
		i = baseCoords.length; 
		while(i--) {
			next = [ parseInt(baseCoords[--i], 10), parseInt(baseCoords[i+1], 10) ];

			if(next[0] > result.position.right){ result.position.right = next[0]; }
			if(next[0] < result.position.left){ result.position.left = next[0]; }
			if(next[1] > result.position.bottom){ result.position.bottom = next[1]; }
			if(next[1] < result.position.top){ result.position.top = next[1]; }

			coords.push(next);
		}

		// Calculate height and width from outer edges
		newWidth = result.width = Math.abs(result.position.right - result.position.left);
		newHeight = result.height = Math.abs(result.position.bottom - result.position.top);

		// If it's the center corner...
		if(corner.abbrev() === 'c') {
			result.position = {
				left: result.position.left + result.width / 2,
				top: result.position.top + result.height / 2
			};
		}
		else {
			// Second pass, use a binary search algorithm to locate most suitable coordinate
			while(newWidth > 0 && newHeight > 0 && compareX > 0 && compareY > 0)
			{
				newWidth = Math.floor(newWidth / 2);
				newHeight = Math.floor(newHeight / 2);

				if(corner.x === LEFT){ compareX = newWidth; }
				else if(corner.x === RIGHT){ compareX = result.width - newWidth; }
				else{ compareX += Math.floor(newWidth / 2); }

				if(corner.y === TOP){ compareY = newHeight; }
				else if(corner.y === BOTTOM){ compareY = result.height - newHeight; }
				else{ compareY += Math.floor(newHeight / 2); }

				i = coords.length;
				while(i--)
				{
					if(coords.length < 2){ break; }

					realX = coords[i][0] - result.position.left;
					realY = coords[i][1] - result.position.top;

					if(
						corner.x === LEFT && realX >= compareX ||
						corner.x === RIGHT && realX <= compareX ||
						corner.x === CENTER && (realX < compareX || realX > result.width - compareX) ||
						corner.y === TOP && realY >= compareY ||
						corner.y === BOTTOM && realY <= compareY ||
						corner.y === CENTER && (realY < compareY || realY > result.height - compareY)) {
						coords.splice(i, 1);
					}
				}
			}
			result.position = { left: coords[0][0], top: coords[0][1] };
		}

		return result;
	},

	rect: function(ax, ay, bx, by) {
		return {
			width: Math.abs(bx - ax),
			height: Math.abs(by - ay),
			position: {
				left: Math.min(ax, bx),
				top: Math.min(ay, by)
			}
		};
	},

	_angles: {
		tc: 3 / 2, tr: 7 / 4, tl: 5 / 4,
		bc: 1 / 2, br: 1 / 4, bl: 3 / 4,
		rc: 2, lc: 1, c: 0
	},
	ellipse: function(cx, cy, rx, ry, corner) {
		var c = PLUGINS.polys._angles[ corner.abbrev() ],
			rxc = c === 0 ? 0 : rx * Math.cos( c * Math.PI ),
			rys = ry * Math.sin( c * Math.PI );

		return {
			width: rx * 2 - Math.abs(rxc),
			height: ry * 2 - Math.abs(rys),
			position: {
				left: cx + rxc,
				top: cy + rys
			},
			adjustable: FALSE
		};
	},
	circle: function(cx, cy, r, corner) {
		return PLUGINS.polys.ellipse(cx, cy, r, r, corner);
	}
};
;PLUGINS.svg = function(api, svg, corner)
{
	var elem = svg[0],
		root = $(elem.ownerSVGElement),
		ownerDocument = elem.ownerDocument,
		strokeWidth2 = (parseInt(svg.css('stroke-width'), 10) || 0) / 2,
		frameOffset, mtx, transformed,
		len, next, i, points,
		result, position;

	// Ascend the parentNode chain until we find an element with getBBox()
	while(!elem.getBBox) { elem = elem.parentNode; }
	if(!elem.getBBox || !elem.parentNode) { return FALSE; }

	// Determine which shape calculation to use
	switch(elem.nodeName) {
		case 'ellipse':
		case 'circle':
			result = PLUGINS.polys.ellipse(
				elem.cx.baseVal.value,
				elem.cy.baseVal.value,
				(elem.rx || elem.r).baseVal.value + strokeWidth2,
				(elem.ry || elem.r).baseVal.value + strokeWidth2,
				corner
			);
		break;

		case 'line':
		case 'polygon':
		case 'polyline':
			// Determine points object (line has none, so mimic using array)
			points = elem.points || [
				{ x: elem.x1.baseVal.value, y: elem.y1.baseVal.value },
				{ x: elem.x2.baseVal.value, y: elem.y2.baseVal.value }
			];

			for(result = [], i = -1, len = points.numberOfItems || points.length; ++i < len;) {
				next = points.getItem ? points.getItem(i) : points[i];
				result.push.apply(result, [next.x, next.y]);
			}

			result = PLUGINS.polys.polygon(result, corner);
		break;

		// Unknown shape or rectangle? Use bounding box
		default:
			result = elem.getBBox();
			result = {
				width: result.width,
				height: result.height,
				position: {
					left: result.x,
					top: result.y
				}
			};
		break;
	}

	// Shortcut assignments
	position = result.position;
	root = root[0];

	// Convert position into a pixel value
	if(root.createSVGPoint) {
		mtx = elem.getScreenCTM();
		points = root.createSVGPoint();

		points.x = position.left;
		points.y = position.top;
		transformed = points.matrixTransform( mtx );
		position.left = transformed.x;
		position.top = transformed.y;
	}

	// Check the element is not in a child document, and if so, adjust for frame elements offset
	if(ownerDocument !== document && api.position.target !== 'mouse') {
		frameOffset = $((ownerDocument.defaultView || ownerDocument.parentWindow).frameElement).offset();
		if(frameOffset) {
			position.left += frameOffset.left;
			position.top += frameOffset.top;
		}
	}

	// Adjust by scroll offset of owner document
	ownerDocument = $(ownerDocument);
	position.left += ownerDocument.scrollLeft();
	position.top += ownerDocument.scrollTop();

	return result;
};
;PLUGINS.imagemap = function(api, area, corner)
{
	if(!area.jquery) { area = $(area); }

	var shape = (area.attr('shape') || 'rect').toLowerCase().replace('poly', 'polygon'),
		image = $('img[usemap="#'+area.parent('map').attr('name')+'"]'),
		coordsString = $.trim(area.attr('coords')),
		coordsArray = coordsString.replace(/,$/, '').split(','),
		imageOffset, coords, i, result, len;

	// If we can't find the image using the map...
	if(!image.length) { return FALSE; }

	// Pass coordinates string if polygon
	if(shape === 'polygon') {
		result = PLUGINS.polys.polygon(coordsArray, corner);
	}

	// Otherwise parse the coordinates and pass them as arguments
	else if(PLUGINS.polys[shape]) {
		for(i = -1, len = coordsArray.length, coords = []; ++i < len;) {
			coords.push( parseInt(coordsArray[i], 10) );
		}

		result = PLUGINS.polys[shape].apply(
			this, coords.concat(corner)
		);
	}

	// If no shapre calculation method was found, return false
	else { return FALSE; }

	// Make sure we account for padding and borders on the image
	imageOffset = image.offset();
	imageOffset.left += Math.ceil((image.outerWidth(FALSE) - image.width()) / 2);
	imageOffset.top += Math.ceil((image.outerHeight(FALSE) - image.height()) / 2);

	// Add image position to offset coordinates
	result.position.left += imageOffset.left;
	result.position.top += imageOffset.top;

	return result;
};
;var IE6,

/*
 * BGIFrame adaption (http://plugins.jquery.com/project/bgiframe)
 * Special thanks to Brandon Aaron
 */
BGIFRAME = '<iframe class="qtip-bgiframe" frameborder="0" tabindex="-1" src="javascript:\'\';" ' +
	' style="display:block; position:absolute; z-index:-1; filter:alpha(opacity=0); ' +
		'-ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";"></iframe>';

function Ie6(api) {
	this._ns = 'ie6';

	this.qtip = api;
	this.init(api);
}

$.extend(Ie6.prototype, {
	_scroll : function() {
		var overlay = this.qtip.elements.overlay;
		overlay && (overlay[0].style.top = $(window).scrollTop() + 'px');
	},

	init: function(qtip) {
		var tooltip = qtip.tooltip;

		// Create the BGIFrame element if needed
		if($('select, object').length < 1) {
			this.bgiframe = qtip.elements.bgiframe = $(BGIFRAME).appendTo(tooltip);

			// Update BGIFrame on tooltip move
			qtip._bind(tooltip, 'tooltipmove', this.adjustBGIFrame, this._ns, this);
		}

		// redraw() container for width/height calculations
		this.redrawContainer = $('<div/>', { id: NAMESPACE+'-rcontainer' })
			.appendTo(document.body);

		// Fixup modal plugin if present too
		if( qtip.elements.overlay && qtip.elements.overlay.addClass('qtipmodal-ie6fix') ) {
			qtip._bind(window, ['scroll', 'resize'], this._scroll, this._ns, this);
			qtip._bind(tooltip, ['tooltipshow'], this._scroll, this._ns, this);
		}

		// Set dimensions
		this.redraw();
	},

	adjustBGIFrame: function() {
		var tooltip = this.qtip.tooltip,
			dimensions = {
				height: tooltip.outerHeight(FALSE),
				width: tooltip.outerWidth(FALSE)
			},
			plugin = this.qtip.plugins.tip,
			tip = this.qtip.elements.tip,
			tipAdjust, offset;

		// Adjust border offset
		offset = parseInt(tooltip.css('borderLeftWidth'), 10) || 0;
		offset = { left: -offset, top: -offset };

		// Adjust for tips plugin
		if(plugin && tip) {
			tipAdjust = plugin.corner.precedance === 'x' ? [WIDTH, LEFT] : [HEIGHT, TOP];
			offset[ tipAdjust[1] ] -= tip[ tipAdjust[0] ]();
		}

		// Update bgiframe
		this.bgiframe.css(offset).css(dimensions);
	},

	// Max/min width simulator function
	redraw: function() {
		if(this.qtip.rendered < 1 || this.drawing) { return this; }

		var tooltip = this.qtip.tooltip,
			style = this.qtip.options.style,
			container = this.qtip.options.position.container,
			perc, width, max, min;

		// Set drawing flag
		this.qtip.drawing = 1;

		// If tooltip has a set height/width, just set it... like a boss!
		if(style.height) { tooltip.css(HEIGHT, style.height); }
		if(style.width) { tooltip.css(WIDTH, style.width); }

		// Simulate max/min width if not set width present...
		else {
			// Reset width and add fluid class
			tooltip.css(WIDTH, '').appendTo(this.redrawContainer);

			// Grab our tooltip width (add 1 if odd so we don't get wrapping problems.. huzzah!)
			width = tooltip.width();
			if(width % 2 < 1) { width += 1; }

			// Grab our max/min properties
			max = tooltip.css('maxWidth') || '';
			min = tooltip.css('minWidth') || '';

			// Parse into proper pixel values
			perc = (max + min).indexOf('%') > -1 ? container.width() / 100 : 0;
			max = (max.indexOf('%') > -1 ? perc : 1 * parseInt(max, 10)) || width;
			min = (min.indexOf('%') > -1 ? perc : 1 * parseInt(min, 10)) || 0;

			// Determine new dimension size based on max/min/current values
			width = max + min ? Math.min(Math.max(width, min), max) : width;

			// Set the newly calculated width and remvoe fluid class
			tooltip.css(WIDTH, Math.round(width)).appendTo(container);
		}

		// Set drawing flag
		this.drawing = 0;

		return this;
	},

	destroy: function() {
		// Remove iframe
		this.bgiframe && this.bgiframe.remove();

		// Remove bound events
		this.qtip._unbind([window, this.qtip.tooltip], this._ns);
	}
});

IE6 = PLUGINS.ie6 = function(api) {
	// Proceed only if the browser is IE6
	return BROWSER.ie === 6 ? new Ie6(api) : FALSE;
};

IE6.initialize = 'render';

CHECKS.ie6 = {
	'^content|style$': function() {
		this.redraw();
	}
};
;}));
}( window, document ));



/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*
 *	jQuery dotdotdot 1.6.13
 *
 *	Copyright (c) Fred Heusschen
 *	www.frebsite.nl
 *
 *	Plugin website:
 *	dotdotdot.frebsite.nl
 *
 *	Dual licensed under the MIT and GPL licenses.
 *	http://en.wikipedia.org/wiki/MIT_License
 *	http://en.wikipedia.org/wiki/GNU_General_Public_License
 */
!function(t,e){function n(t,e,n){var r=t.children(),o=!1;t.empty();for(var i=0,d=r.length;d>i;i++){var l=r.eq(i);if(t.append(l),n&&t.append(n),a(t,e)){l.remove(),o=!0;break}n&&n.detach()}return o}function r(e,n,i,d,l){var s=!1,c="table, thead, tbody, tfoot, tr, col, colgroup, object, embed, param, ol, ul, dl, blockquote, select, optgroup, option, textarea, script, style",u="script";return e.contents().detach().each(function(){var h=this,f=t(h);if("undefined"==typeof h||3==h.nodeType&&0==t.trim(h.data).length)return!0;if(f.is(u))e.append(f);else{if(s)return!0;e.append(f),l&&e[e.is(c)?"after":"append"](l),a(i,d)&&(s=3==h.nodeType?o(f,n,i,d,l):r(f,n,i,d,l),s||(f.detach(),s=!0)),s||l&&l.detach()}}),s}function o(e,n,r,o,d){var c=e[0];if(!c)return!1;var h=s(c),f=-1!==h.indexOf(" ")?" ":"　",p="letter"==o.wrap?"":f,g=h.split(p),v=-1,w=-1,b=0,y=g.length-1;for(o.fallbackToLetter&&0==b&&0==y&&(p="",g=h.split(p),y=g.length-1);y>=b&&(0!=b||0!=y);){var m=Math.floor((b+y)/2);if(m==w)break;w=m,l(c,g.slice(0,w+1).join(p)+o.ellipsis),a(r,o)?(y=w,o.fallbackToLetter&&0==b&&0==y&&(p="",g=g[0].split(p),v=-1,w=-1,b=0,y=g.length-1)):(v=w,b=w)}if(-1==v||1==g.length&&0==g[0].length){var x=e.parent();e.detach();var T=d&&d.closest(x).length?d.length:0;x.contents().length>T?c=u(x.contents().eq(-1-T),n):(c=u(x,n,!0),T||x.detach()),c&&(h=i(s(c),o),l(c,h),T&&d&&t(c).parent().append(d))}else h=i(g.slice(0,v+1).join(p),o),l(c,h);return!0}function a(t,e){return t.innerHeight()>e.maxHeight}function i(e,n){for(;t.inArray(e.slice(-1),n.lastCharacter.remove)>-1;)e=e.slice(0,-1);return t.inArray(e.slice(-1),n.lastCharacter.noEllipsis)<0&&(e+=n.ellipsis),e}function d(t){return{width:t.innerWidth(),height:t.innerHeight()}}function l(t,e){t.innerText?t.innerText=e:t.nodeValue?t.nodeValue=e:t.textContent&&(t.textContent=e)}function s(t){return t.innerText?t.innerText:t.nodeValue?t.nodeValue:t.textContent?t.textContent:""}function c(t){do t=t.previousSibling;while(t&&1!==t.nodeType&&3!==t.nodeType);return t}function u(e,n,r){var o,a=e&&e[0];if(a){if(!r){if(3===a.nodeType)return a;if(t.trim(e.text()))return u(e.contents().last(),n)}for(o=c(a);!o;){if(e=e.parent(),e.is(n)||!e.length)return!1;o=c(e[0])}if(o)return u(t(o),n)}return!1}function h(e,n){return e?"string"==typeof e?(e=t(e,n),e.length?e:!1):e.jquery?e:!1:!1}function f(t){for(var e=t.innerHeight(),n=["paddingTop","paddingBottom"],r=0,o=n.length;o>r;r++){var a=parseInt(t.css(n[r]),10);isNaN(a)&&(a=0),e-=a}return e}if(!t.fn.dotdotdot){t.fn.dotdotdot=function(e){if(0==this.length)return t.fn.dotdotdot.debug('No element found for "'+this.selector+'".'),this;if(this.length>1)return this.each(function(){t(this).dotdotdot(e)});var o=this;o.data("dotdotdot")&&o.trigger("destroy.dot"),o.data("dotdotdot-style",o.attr("style")||""),o.css("word-wrap","break-word"),"nowrap"===o.css("white-space")&&o.css("white-space","normal"),o.bind_events=function(){return o.bind("update.dot",function(e,d){e.preventDefault(),e.stopPropagation(),l.maxHeight="number"==typeof l.height?l.height:f(o),l.maxHeight+=l.tolerance,"undefined"!=typeof d&&(("string"==typeof d||d instanceof HTMLElement)&&(d=t("<div />").append(d).contents()),d instanceof t&&(i=d)),g=o.wrapInner('<div class="dotdotdot" />').children(),g.contents().detach().end().append(i.clone(!0)).find("br").replaceWith("  <br />  ").end().css({height:"auto",width:"auto",border:"none",padding:0,margin:0});var c=!1,u=!1;return s.afterElement&&(c=s.afterElement.clone(!0),c.show(),s.afterElement.detach()),a(g,l)&&(u="children"==l.wrap?n(g,l,c):r(g,o,g,l,c)),g.replaceWith(g.contents()),g=null,t.isFunction(l.callback)&&l.callback.call(o[0],u,i),s.isTruncated=u,u}).bind("isTruncated.dot",function(t,e){return t.preventDefault(),t.stopPropagation(),"function"==typeof e&&e.call(o[0],s.isTruncated),s.isTruncated}).bind("originalContent.dot",function(t,e){return t.preventDefault(),t.stopPropagation(),"function"==typeof e&&e.call(o[0],i),i}).bind("destroy.dot",function(t){t.preventDefault(),t.stopPropagation(),o.unwatch().unbind_events().contents().detach().end().append(i).attr("style",o.data("dotdotdot-style")||"").data("dotdotdot",!1)}),o},o.unbind_events=function(){return o.unbind(".dot"),o},o.watch=function(){if(o.unwatch(),"window"==l.watch){var e=t(window),n=e.width(),r=e.height();e.bind("resize.dot"+s.dotId,function(){n==e.width()&&r==e.height()&&l.windowResizeFix||(n=e.width(),r=e.height(),u&&clearInterval(u),u=setTimeout(function(){o.trigger("update.dot")},10))})}else c=d(o),u=setInterval(function(){var t=d(o);(c.width!=t.width||c.height!=t.height)&&(o.trigger("update.dot"),c=d(o))},100);return o},o.unwatch=function(){return t(window).unbind("resize.dot"+s.dotId),u&&clearInterval(u),o};var i=o.contents(),l=t.extend(!0,{},t.fn.dotdotdot.defaults,e),s={},c={},u=null,g=null;return l.lastCharacter.remove instanceof Array||(l.lastCharacter.remove=t.fn.dotdotdot.defaultArrays.lastCharacter.remove),l.lastCharacter.noEllipsis instanceof Array||(l.lastCharacter.noEllipsis=t.fn.dotdotdot.defaultArrays.lastCharacter.noEllipsis),s.afterElement=h(l.after,o),s.isTruncated=!1,s.dotId=p++,o.data("dotdotdot",!0).bind_events().trigger("update.dot"),l.watch&&o.watch(),o},t.fn.dotdotdot.defaults={ellipsis:"... ",wrap:"word",fallbackToLetter:!0,lastCharacter:{},tolerance:0,callback:null,after:null,height:null,watch:!1,windowResizeFix:!0},t.fn.dotdotdot.defaultArrays={lastCharacter:{remove:[" ","　",",",";",".","!","?"],noEllipsis:[]}},t.fn.dotdotdot.debug=function(){};var p=1,g=t.fn.html;t.fn.html=function(n){return n!=e&&!t.isFunction(n)&&this.data("dotdotdot")?this.trigger("update",[n]):g.apply(this,arguments)};var v=t.fn.text;t.fn.text=function(n){return n!=e&&!t.isFunction(n)&&this.data("dotdotdot")?(n=t("<div />").text(n).html(),this.trigger("update",[n])):v.apply(this,arguments)}}}(jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*! jQuery UI - v1.10.4 - 2014-03-30
* http://jqueryui.com
* Includes: jquery.ui.core.js, jquery.ui.widget.js, jquery.ui.mouse.js, jquery.ui.position.js, jquery.ui.draggable.js, jquery.ui.droppable.js, jquery.ui.resizable.js, jquery.ui.selectable.js, jquery.ui.sortable.js, jquery.ui.accordion.js, jquery.ui.autocomplete.js, jquery.ui.button.js, jquery.ui.datepicker.js, jquery.ui.dialog.js, jquery.ui.menu.js, jquery.ui.progressbar.js, jquery.ui.slider.js, jquery.ui.spinner.js, jquery.ui.tabs.js, jquery.ui.tooltip.js, jquery.ui.effect.js, jquery.ui.effect-blind.js, jquery.ui.effect-bounce.js, jquery.ui.effect-clip.js, jquery.ui.effect-drop.js, jquery.ui.effect-explode.js, jquery.ui.effect-fade.js, jquery.ui.effect-fold.js, jquery.ui.effect-highlight.js, jquery.ui.effect-pulsate.js, jquery.ui.effect-scale.js, jquery.ui.effect-shake.js, jquery.ui.effect-slide.js, jquery.ui.effect-transfer.js
* Copyright 2014 jQuery Foundation and other contributors; Licensed MIT */

(function(e,t){function i(t,i){var s,a,o,r=t.nodeName.toLowerCase();return"area"===r?(s=t.parentNode,a=s.name,t.href&&a&&"map"===s.nodeName.toLowerCase()?(o=e("img[usemap=#"+a+"]")[0],!!o&&n(o)):!1):(/input|select|textarea|button|object/.test(r)?!t.disabled:"a"===r?t.href||i:i)&&n(t)}function n(t){return e.expr.filters.visible(t)&&!e(t).parents().addBack().filter(function(){return"hidden"===e.css(this,"visibility")}).length}var s=0,a=/^ui-id-\d+$/;e.ui=e.ui||{},e.extend(e.ui,{version:"1.10.4",keyCode:{BACKSPACE:8,COMMA:188,DELETE:46,DOWN:40,END:35,ENTER:13,ESCAPE:27,HOME:36,LEFT:37,NUMPAD_ADD:107,NUMPAD_DECIMAL:110,NUMPAD_DIVIDE:111,NUMPAD_ENTER:108,NUMPAD_MULTIPLY:106,NUMPAD_SUBTRACT:109,PAGE_DOWN:34,PAGE_UP:33,PERIOD:190,RIGHT:39,SPACE:32,TAB:9,UP:38}}),e.fn.extend({focus:function(t){return function(i,n){return"number"==typeof i?this.each(function(){var t=this;setTimeout(function(){e(t).focus(),n&&n.call(t)},i)}):t.apply(this,arguments)}}(e.fn.focus),scrollParent:function(){var t;return t=e.ui.ie&&/(static|relative)/.test(this.css("position"))||/absolute/.test(this.css("position"))?this.parents().filter(function(){return/(relative|absolute|fixed)/.test(e.css(this,"position"))&&/(auto|scroll)/.test(e.css(this,"overflow")+e.css(this,"overflow-y")+e.css(this,"overflow-x"))}).eq(0):this.parents().filter(function(){return/(auto|scroll)/.test(e.css(this,"overflow")+e.css(this,"overflow-y")+e.css(this,"overflow-x"))}).eq(0),/fixed/.test(this.css("position"))||!t.length?e(document):t},zIndex:function(i){if(i!==t)return this.css("zIndex",i);if(this.length)for(var n,s,a=e(this[0]);a.length&&a[0]!==document;){if(n=a.css("position"),("absolute"===n||"relative"===n||"fixed"===n)&&(s=parseInt(a.css("zIndex"),10),!isNaN(s)&&0!==s))return s;a=a.parent()}return 0},uniqueId:function(){return this.each(function(){this.id||(this.id="ui-id-"+ ++s)})},removeUniqueId:function(){return this.each(function(){a.test(this.id)&&e(this).removeAttr("id")})}}),e.extend(e.expr[":"],{data:e.expr.createPseudo?e.expr.createPseudo(function(t){return function(i){return!!e.data(i,t)}}):function(t,i,n){return!!e.data(t,n[3])},focusable:function(t){return i(t,!isNaN(e.attr(t,"tabindex")))},tabbable:function(t){var n=e.attr(t,"tabindex"),s=isNaN(n);return(s||n>=0)&&i(t,!s)}}),e("<a>").outerWidth(1).jquery||e.each(["Width","Height"],function(i,n){function s(t,i,n,s){return e.each(a,function(){i-=parseFloat(e.css(t,"padding"+this))||0,n&&(i-=parseFloat(e.css(t,"border"+this+"Width"))||0),s&&(i-=parseFloat(e.css(t,"margin"+this))||0)}),i}var a="Width"===n?["Left","Right"]:["Top","Bottom"],o=n.toLowerCase(),r={innerWidth:e.fn.innerWidth,innerHeight:e.fn.innerHeight,outerWidth:e.fn.outerWidth,outerHeight:e.fn.outerHeight};e.fn["inner"+n]=function(i){return i===t?r["inner"+n].call(this):this.each(function(){e(this).css(o,s(this,i)+"px")})},e.fn["outer"+n]=function(t,i){return arguments.length == 0?r["outer"+n].call(this):("number"!=typeof t?r["outer"+n].call(this,t):this.each(function(){e(this).css(o,s(this,t,!0,i)+"px")}))}}),e.fn.addBack||(e.fn.addBack=function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}),e("<a>").data("a-b","a").removeData("a-b").data("a-b")&&(e.fn.removeData=function(t){return function(i){return arguments.length?t.call(this,e.camelCase(i)):t.call(this)}}(e.fn.removeData)),e.ui.ie=!!/msie [\w.]+/.exec(navigator.userAgent.toLowerCase()),e.support.selectstart="onselectstart"in document.createElement("div"),e.fn.extend({disableSelection:function(){return this.bind((e.support.selectstart?"selectstart":"mousedown")+".ui-disableSelection",function(e){e.preventDefault()})},enableSelection:function(){return this.unbind(".ui-disableSelection")}}),e.extend(e.ui,{plugin:{add:function(t,i,n){var s,a=e.ui[t].prototype;for(s in n)a.plugins[s]=a.plugins[s]||[],a.plugins[s].push([i,n[s]])},call:function(e,t,i){var n,s=e.plugins[t];if(s&&e.element[0].parentNode&&11!==e.element[0].parentNode.nodeType)for(n=0;s.length>n;n++)e.options[s[n][0]]&&s[n][1].apply(e.element,i)}},hasScroll:function(t,i){if("hidden"===e(t).css("overflow"))return!1;var n=i&&"left"===i?"scrollLeft":"scrollTop",s=!1;return t[n]>0?!0:(t[n]=1,s=t[n]>0,t[n]=0,s)}})})(jQuery);(function(t,e){var i=0,s=Array.prototype.slice,n=t.cleanData;t.cleanData=function(e){for(var i,s=0;null!=(i=e[s]);s++)try{t(i).triggerHandler("remove")}catch(o){}n(e)},t.widget=function(i,s,n){var o,a,r,h,l={},c=i.split(".")[0];i=i.split(".")[1],o=c+"-"+i,n||(n=s,s=t.Widget),t.expr[":"][o.toLowerCase()]=function(e){return!!t.data(e,o)},t[c]=t[c]||{},a=t[c][i],r=t[c][i]=function(t,i){return this._createWidget?(arguments.length&&this._createWidget(t,i),e):new r(t,i)},t.extend(r,a,{version:n.version,_proto:t.extend({},n),_childConstructors:[]}),h=new s,h.options=t.widget.extend({},h.options),t.each(n,function(i,n){return t.isFunction(n)?(l[i]=function(){var t=function(){return s.prototype[i].apply(this,arguments)},e=function(t){return s.prototype[i].apply(this,t)};return function(){var i,s=this._super,o=this._superApply;return this._super=t,this._superApply=e,i=n.apply(this,arguments),this._super=s,this._superApply=o,i}}(),e):(l[i]=n,e)}),r.prototype=t.widget.extend(h,{widgetEventPrefix:a?h.widgetEventPrefix||i:i},l,{constructor:r,namespace:c,widgetName:i,widgetFullName:o}),a?(t.each(a._childConstructors,function(e,i){var s=i.prototype;t.widget(s.namespace+"."+s.widgetName,r,i._proto)}),delete a._childConstructors):s._childConstructors.push(r),t.widget.bridge(i,r)},t.widget.extend=function(i){for(var n,o,a=s.call(arguments,1),r=0,h=a.length;h>r;r++)for(n in a[r])o=a[r][n],a[r].hasOwnProperty(n)&&o!==e&&(i[n]=t.isPlainObject(o)?t.isPlainObject(i[n])?t.widget.extend({},i[n],o):t.widget.extend({},o):o);return i},t.widget.bridge=function(i,n){var o=n.prototype.widgetFullName||i;t.fn[i]=function(a){var r="string"==typeof a,h=s.call(arguments,1),l=this;return a=!r&&h.length?t.widget.extend.apply(null,[a].concat(h)):a,r?this.each(function(){var s,n=t.data(this,o);return n?t.isFunction(n[a])&&"_"!==a.charAt(0)?(s=n[a].apply(n,h),s!==n&&s!==e?(l=s&&s.jquery?l.pushStack(s.get()):s,!1):e):t.error("no such method '"+a+"' for "+i+" widget instance"):t.error("cannot call methods on "+i+" prior to initialization; "+"attempted to call method '"+a+"'")}):this.each(function(){var e=t.data(this,o);e?e.option(a||{})._init():t.data(this,o,new n(a,this))}),l}},t.Widget=function(){},t.Widget._childConstructors=[],t.Widget.prototype={widgetName:"widget",widgetEventPrefix:"",defaultElement:"<div>",options:{disabled:!1,create:null},_createWidget:function(e,s){s=t(s||this.defaultElement||this)[0],this.element=t(s),this.uuid=i++,this.eventNamespace="."+this.widgetName+this.uuid,this.options=t.widget.extend({},this.options,this._getCreateOptions(),e),this.bindings=t(),this.hoverable=t(),this.focusable=t(),s!==this&&(t.data(s,this.widgetFullName,this),this._on(!0,this.element,{remove:function(t){t.target===s&&this.destroy()}}),this.document=t(s.style?s.ownerDocument:s.document||s),this.window=t(this.document[0].defaultView||this.document[0].parentWindow)),this._create(),this._trigger("create",null,this._getCreateEventData()),this._init()},_getCreateOptions:t.noop,_getCreateEventData:t.noop,_create:t.noop,_init:t.noop,destroy:function(){this._destroy(),this.element.unbind(this.eventNamespace).removeData(this.widgetName).removeData(this.widgetFullName).removeData(t.camelCase(this.widgetFullName)),this.widget().unbind(this.eventNamespace).removeAttr("aria-disabled").removeClass(this.widgetFullName+"-disabled "+"ui-state-disabled"),this.bindings.unbind(this.eventNamespace),this.hoverable.removeClass("ui-state-hover"),this.focusable.removeClass("ui-state-focus")},_destroy:t.noop,widget:function(){return this.element},option:function(i,s){var n,o,a,r=i;if(0===arguments.length)return t.widget.extend({},this.options);if("string"==typeof i)if(r={},n=i.split("."),i=n.shift(),n.length){for(o=r[i]=t.widget.extend({},this.options[i]),a=0;n.length-1>a;a++)o[n[a]]=o[n[a]]||{},o=o[n[a]];if(i=n.pop(),1===arguments.length)return o[i]===e?null:o[i];o[i]=s}else{if(1===arguments.length)return this.options[i]===e?null:this.options[i];r[i]=s}return this._setOptions(r),this},_setOptions:function(t){var e;for(e in t)this._setOption(e,t[e]);return this},_setOption:function(t,e){return this.options[t]=e,"disabled"===t&&(this.widget().toggleClass(this.widgetFullName+"-disabled ui-state-disabled",!!e).attr("aria-disabled",e),this.hoverable.removeClass("ui-state-hover"),this.focusable.removeClass("ui-state-focus")),this},enable:function(){return this._setOption("disabled",!1)},disable:function(){return this._setOption("disabled",!0)},_on:function(i,s,n){var o,a=this;"boolean"!=typeof i&&(n=s,s=i,i=!1),n?(s=o=t(s),this.bindings=this.bindings.add(s)):(n=s,s=this.element,o=this.widget()),t.each(n,function(n,r){function h(){return i||a.options.disabled!==!0&&!t(this).hasClass("ui-state-disabled")?("string"==typeof r?a[r]:r).apply(a,arguments):e}"string"!=typeof r&&(h.guid=r.guid=r.guid||h.guid||t.guid++);var l=n.match(/^(\w+)\s*(.*)$/),c=l[1]+a.eventNamespace,u=l[2];u?o.delegate(u,c,h):s.bind(c,h)})},_off:function(t,e){e=(e||"").split(" ").join(this.eventNamespace+" ")+this.eventNamespace,t.unbind(e).undelegate(e)},_delay:function(t,e){function i(){return("string"==typeof t?s[t]:t).apply(s,arguments)}var s=this;return setTimeout(i,e||0)},_hoverable:function(e){this.hoverable=this.hoverable.add(e),this._on(e,{mouseenter:function(e){t(e.currentTarget).addClass("ui-state-hover")},mouseleave:function(e){t(e.currentTarget).removeClass("ui-state-hover")}})},_focusable:function(e){this.focusable=this.focusable.add(e),this._on(e,{focusin:function(e){t(e.currentTarget).addClass("ui-state-focus")},focusout:function(e){t(e.currentTarget).removeClass("ui-state-focus")}})},_trigger:function(e,i,s){var n,o,a=this.options[e];if(s=s||{},i=t.Event(i),i.type=(e===this.widgetEventPrefix?e:this.widgetEventPrefix+e).toLowerCase(),i.target=this.element[0],o=i.originalEvent)for(n in o)n in i||(i[n]=o[n]);return this.element.trigger(i,s),!(t.isFunction(a)&&a.apply(this.element[0],[i].concat(s))===!1||i.isDefaultPrevented())}},t.each({show:"fadeIn",hide:"fadeOut"},function(e,i){t.Widget.prototype["_"+e]=function(s,n,o){"string"==typeof n&&(n={effect:n});var a,r=n?n===!0||"number"==typeof n?i:n.effect||i:e;n=n||{},"number"==typeof n&&(n={duration:n}),a=!t.isEmptyObject(n),n.complete=o,n.delay&&s.delay(n.delay),a&&t.effects&&t.effects.effect[r]?s[e](n):r!==e&&s[r]?s[r](n.duration,n.easing,o):s.queue(function(i){t(this)[e](),o&&o.call(s[0]),i()})}})})(jQuery);(function(t){var e=!1;t(document).mouseup(function(){e=!1}),t.widget("ui.mouse",{version:"1.10.4",options:{cancel:"input,textarea,button,select,option",distance:1,delay:0},_mouseInit:function(){var e=this;this.element.bind("mousedown."+this.widgetName,function(t){return e._mouseDown(t)}).bind("click."+this.widgetName,function(i){return!0===t.data(i.target,e.widgetName+".preventClickEvent")?(t.removeData(i.target,e.widgetName+".preventClickEvent"),i.stopImmediatePropagation(),!1):undefined}),this.started=!1},_mouseDestroy:function(){this.element.unbind("."+this.widgetName),this._mouseMoveDelegate&&t(document).unbind("mousemove."+this.widgetName,this._mouseMoveDelegate).unbind("mouseup."+this.widgetName,this._mouseUpDelegate)},_mouseDown:function(i){if(!e){this._mouseStarted&&this._mouseUp(i),this._mouseDownEvent=i;var s=this,n=1===i.which,a="string"==typeof this.options.cancel&&i.target.nodeName?t(i.target).closest(this.options.cancel).length:!1;return n&&!a&&this._mouseCapture(i)?(this.mouseDelayMet=!this.options.delay,this.mouseDelayMet||(this._mouseDelayTimer=setTimeout(function(){s.mouseDelayMet=!0},this.options.delay)),this._mouseDistanceMet(i)&&this._mouseDelayMet(i)&&(this._mouseStarted=this._mouseStart(i)!==!1,!this._mouseStarted)?(i.preventDefault(),!0):(!0===t.data(i.target,this.widgetName+".preventClickEvent")&&t.removeData(i.target,this.widgetName+".preventClickEvent"),this._mouseMoveDelegate=function(t){return s._mouseMove(t)},this._mouseUpDelegate=function(t){return s._mouseUp(t)},t(document).bind("mousemove."+this.widgetName,this._mouseMoveDelegate).bind("mouseup."+this.widgetName,this._mouseUpDelegate),i.preventDefault(),e=!0,!0)):!0}},_mouseMove:function(e){return t.ui.ie&&(!document.documentMode||9>document.documentMode)&&!e.button?this._mouseUp(e):this._mouseStarted?(this._mouseDrag(e),e.preventDefault()):(this._mouseDistanceMet(e)&&this._mouseDelayMet(e)&&(this._mouseStarted=this._mouseStart(this._mouseDownEvent,e)!==!1,this._mouseStarted?this._mouseDrag(e):this._mouseUp(e)),!this._mouseStarted)},_mouseUp:function(e){return t(document).unbind("mousemove."+this.widgetName,this._mouseMoveDelegate).unbind("mouseup."+this.widgetName,this._mouseUpDelegate),this._mouseStarted&&(this._mouseStarted=!1,e.target===this._mouseDownEvent.target&&t.data(e.target,this.widgetName+".preventClickEvent",!0),this._mouseStop(e)),!1},_mouseDistanceMet:function(t){return Math.max(Math.abs(this._mouseDownEvent.pageX-t.pageX),Math.abs(this._mouseDownEvent.pageY-t.pageY))>=this.options.distance},_mouseDelayMet:function(){return this.mouseDelayMet},_mouseStart:function(){},_mouseDrag:function(){},_mouseStop:function(){},_mouseCapture:function(){return!0}})})(jQuery);(function(t,e){function i(t,e,i){return[parseFloat(t[0])*(p.test(t[0])?e/100:1),parseFloat(t[1])*(p.test(t[1])?i/100:1)]}function s(e,i){return parseInt(t.css(e,i),10)||0}function n(e){var i=e[0];return 9===i.nodeType?{width:e.width(),height:e.height(),offset:{top:0,left:0}}:t.isWindow(i)?{width:e.width(),height:e.height(),offset:{top:e.scrollTop(),left:e.scrollLeft()}}:i.preventDefault?{width:0,height:0,offset:{top:i.pageY,left:i.pageX}}:{width:e.outerWidth(),height:e.outerHeight(),offset:e.offset()}}t.ui=t.ui||{};var a,o=Math.max,r=Math.abs,l=Math.round,h=/left|center|right/,c=/top|center|bottom/,u=/[\+\-]\d+(\.[\d]+)?%?/,d=/^\w+/,p=/%$/,f=t.fn.position;t.position={scrollbarWidth:function(){if(a!==e)return a;var i,s,n=t("<div style='display:block;position:absolute;width:50px;height:50px;overflow:hidden;'><div style='height:100px;width:auto;'></div></div>"),o=n.children()[0];return t("body").append(n),i=o.offsetWidth,n.css("overflow","scroll"),s=o.offsetWidth,i===s&&(s=n[0].clientWidth),n.remove(),a=i-s},getScrollInfo:function(e){var i=e.isWindow||e.isDocument?"":e.element.css("overflow-x"),s=e.isWindow||e.isDocument?"":e.element.css("overflow-y"),n="scroll"===i||"auto"===i&&e.width<e.element[0].scrollWidth,a="scroll"===s||"auto"===s&&e.height<e.element[0].scrollHeight;return{width:a?t.position.scrollbarWidth():0,height:n?t.position.scrollbarWidth():0}},getWithinInfo:function(e){var i=t(e||window),s=t.isWindow(i[0]),n=!!i[0]&&9===i[0].nodeType;return{element:i,isWindow:s,isDocument:n,offset:i.offset()||{left:0,top:0},scrollLeft:i.scrollLeft(),scrollTop:i.scrollTop(),width:s?i.width():i.outerWidth(),height:s?i.height():i.outerHeight()}}},t.fn.position=function(e){if(!e||!e.of)return f.apply(this,arguments);e=t.extend({},e);var a,p,g,m,v,_,b=t(e.of),y=t.position.getWithinInfo(e.within),k=t.position.getScrollInfo(y),w=(e.collision||"flip").split(" "),D={};return _=n(b),b[0].preventDefault&&(e.at="left top"),p=_.width,g=_.height,m=_.offset,v=t.extend({},m),t.each(["my","at"],function(){var t,i,s=(e[this]||"").split(" ");1===s.length&&(s=h.test(s[0])?s.concat(["center"]):c.test(s[0])?["center"].concat(s):["center","center"]),s[0]=h.test(s[0])?s[0]:"center",s[1]=c.test(s[1])?s[1]:"center",t=u.exec(s[0]),i=u.exec(s[1]),D[this]=[t?t[0]:0,i?i[0]:0],e[this]=[d.exec(s[0])[0],d.exec(s[1])[0]]}),1===w.length&&(w[1]=w[0]),"right"===e.at[0]?v.left+=p:"center"===e.at[0]&&(v.left+=p/2),"bottom"===e.at[1]?v.top+=g:"center"===e.at[1]&&(v.top+=g/2),a=i(D.at,p,g),v.left+=a[0],v.top+=a[1],this.each(function(){var n,h,c=t(this),u=c.outerWidth(),d=c.outerHeight(),f=s(this,"marginLeft"),_=s(this,"marginTop"),x=u+f+s(this,"marginRight")+k.width,C=d+_+s(this,"marginBottom")+k.height,M=t.extend({},v),T=i(D.my,c.outerWidth(),c.outerHeight());"right"===e.my[0]?M.left-=u:"center"===e.my[0]&&(M.left-=u/2),"bottom"===e.my[1]?M.top-=d:"center"===e.my[1]&&(M.top-=d/2),M.left+=T[0],M.top+=T[1],t.support.offsetFractions||(M.left=l(M.left),M.top=l(M.top)),n={marginLeft:f,marginTop:_},t.each(["left","top"],function(i,s){t.ui.position[w[i]]&&t.ui.position[w[i]][s](M,{targetWidth:p,targetHeight:g,elemWidth:u,elemHeight:d,collisionPosition:n,collisionWidth:x,collisionHeight:C,offset:[a[0]+T[0],a[1]+T[1]],my:e.my,at:e.at,within:y,elem:c})}),e.using&&(h=function(t){var i=m.left-M.left,s=i+p-u,n=m.top-M.top,a=n+g-d,l={target:{element:b,left:m.left,top:m.top,width:p,height:g},element:{element:c,left:M.left,top:M.top,width:u,height:d},horizontal:0>s?"left":i>0?"right":"center",vertical:0>a?"top":n>0?"bottom":"middle"};u>p&&p>r(i+s)&&(l.horizontal="center"),d>g&&g>r(n+a)&&(l.vertical="middle"),l.important=o(r(i),r(s))>o(r(n),r(a))?"horizontal":"vertical",e.using.call(this,t,l)}),c.offset(t.extend(M,{using:h}))})},t.ui.position={fit:{left:function(t,e){var i,s=e.within,n=s.isWindow?s.scrollLeft:s.offset.left,a=s.width,r=t.left-e.collisionPosition.marginLeft,l=n-r,h=r+e.collisionWidth-a-n;e.collisionWidth>a?l>0&&0>=h?(i=t.left+l+e.collisionWidth-a-n,t.left+=l-i):t.left=h>0&&0>=l?n:l>h?n+a-e.collisionWidth:n:l>0?t.left+=l:h>0?t.left-=h:t.left=o(t.left-r,t.left)},top:function(t,e){var i,s=e.within,n=s.isWindow?s.scrollTop:s.offset.top,a=e.within.height,r=t.top-e.collisionPosition.marginTop,l=n-r,h=r+e.collisionHeight-a-n;e.collisionHeight>a?l>0&&0>=h?(i=t.top+l+e.collisionHeight-a-n,t.top+=l-i):t.top=h>0&&0>=l?n:l>h?n+a-e.collisionHeight:n:l>0?t.top+=l:h>0?t.top-=h:t.top=o(t.top-r,t.top)}},flip:{left:function(t,e){var i,s,n=e.within,a=n.offset.left+n.scrollLeft,o=n.width,l=n.isWindow?n.scrollLeft:n.offset.left,h=t.left-e.collisionPosition.marginLeft,c=h-l,u=h+e.collisionWidth-o-l,d="left"===e.my[0]?-e.elemWidth:"right"===e.my[0]?e.elemWidth:0,p="left"===e.at[0]?e.targetWidth:"right"===e.at[0]?-e.targetWidth:0,f=-2*e.offset[0];0>c?(i=t.left+d+p+f+e.collisionWidth-o-a,(0>i||r(c)>i)&&(t.left+=d+p+f)):u>0&&(s=t.left-e.collisionPosition.marginLeft+d+p+f-l,(s>0||u>r(s))&&(t.left+=d+p+f))},top:function(t,e){var i,s,n=e.within,a=n.offset.top+n.scrollTop,o=n.height,l=n.isWindow?n.scrollTop:n.offset.top,h=t.top-e.collisionPosition.marginTop,c=h-l,u=h+e.collisionHeight-o-l,d="top"===e.my[1],p=d?-e.elemHeight:"bottom"===e.my[1]?e.elemHeight:0,f="top"===e.at[1]?e.targetHeight:"bottom"===e.at[1]?-e.targetHeight:0,g=-2*e.offset[1];0>c?(s=t.top+p+f+g+e.collisionHeight-o-a,t.top+p+f+g>c&&(0>s||r(c)>s)&&(t.top+=p+f+g)):u>0&&(i=t.top-e.collisionPosition.marginTop+p+f+g-l,t.top+p+f+g>u&&(i>0||u>r(i))&&(t.top+=p+f+g))}},flipfit:{left:function(){t.ui.position.flip.left.apply(this,arguments),t.ui.position.fit.left.apply(this,arguments)},top:function(){t.ui.position.flip.top.apply(this,arguments),t.ui.position.fit.top.apply(this,arguments)}}},function(){var e,i,s,n,a,o=document.getElementsByTagName("body")[0],r=document.createElement("div");e=document.createElement(o?"div":"body"),s={visibility:"hidden",width:0,height:0,border:0,margin:0,background:"none"},o&&t.extend(s,{position:"absolute",left:"-1000px",top:"-1000px"});for(a in s)e.style[a]=s[a];e.appendChild(r),i=o||document.documentElement,i.insertBefore(e,i.firstChild),r.style.cssText="position: absolute; left: 10.7432222px;",n=t(r).offset().left,t.support.offsetFractions=n>10&&11>n,e.innerHTML="",i.removeChild(e)}()})(jQuery);(function(t){t.widget("ui.draggable",t.ui.mouse,{version:"1.10.4",widgetEventPrefix:"drag",options:{addClasses:!0,appendTo:"parent",axis:!1,connectToSortable:!1,containment:!1,cursor:"auto",cursorAt:!1,grid:!1,handle:!1,helper:"original",iframeFix:!1,opacity:!1,refreshPositions:!1,revert:!1,revertDuration:500,scope:"default",scroll:!0,scrollSensitivity:20,scrollSpeed:20,snap:!1,snapMode:"both",snapTolerance:20,stack:!1,zIndex:!1,drag:null,start:null,stop:null},_create:function(){"original"!==this.options.helper||/^(?:r|a|f)/.test(this.element.css("position"))||(this.element[0].style.position="relative"),this.options.addClasses&&this.element.addClass("ui-draggable"),this.options.disabled&&this.element.addClass("ui-draggable-disabled"),this._mouseInit()},_destroy:function(){this.element.removeClass("ui-draggable ui-draggable-dragging ui-draggable-disabled"),this._mouseDestroy()},_mouseCapture:function(e){var i=this.options;return this.helper||i.disabled||t(e.target).closest(".ui-resizable-handle").length>0?!1:(this.handle=this._getHandle(e),this.handle?(t(i.iframeFix===!0?"iframe":i.iframeFix).each(function(){t("<div class='ui-draggable-iframeFix' style='background: #fff;'></div>").css({width:this.offsetWidth+"px",height:this.offsetHeight+"px",position:"absolute",opacity:"0.001",zIndex:1e3}).css(t(this).offset()).appendTo("body")}),!0):!1)},_mouseStart:function(e){var i=this.options;return this.helper=this._createHelper(e),this.helper.addClass("ui-draggable-dragging"),this._cacheHelperProportions(),t.ui.ddmanager&&(t.ui.ddmanager.current=this),this._cacheMargins(),this.cssPosition=this.helper.css("position"),this.scrollParent=this.helper.scrollParent(),this.offsetParent=this.helper.offsetParent(),this.offsetParentCssPosition=this.offsetParent.css("position"),this.offset=this.positionAbs=this.element.offset(),this.offset={top:this.offset.top-this.margins.top,left:this.offset.left-this.margins.left},this.offset.scroll=!1,t.extend(this.offset,{click:{left:e.pageX-this.offset.left,top:e.pageY-this.offset.top},parent:this._getParentOffset(),relative:this._getRelativeOffset()}),this.originalPosition=this.position=this._generatePosition(e),this.originalPageX=e.pageX,this.originalPageY=e.pageY,i.cursorAt&&this._adjustOffsetFromHelper(i.cursorAt),this._setContainment(),this._trigger("start",e)===!1?(this._clear(),!1):(this._cacheHelperProportions(),t.ui.ddmanager&&!i.dropBehaviour&&t.ui.ddmanager.prepareOffsets(this,e),this._mouseDrag(e,!0),t.ui.ddmanager&&t.ui.ddmanager.dragStart(this,e),!0)},_mouseDrag:function(e,i){if("fixed"===this.offsetParentCssPosition&&(this.offset.parent=this._getParentOffset()),this.position=this._generatePosition(e),this.positionAbs=this._convertPositionTo("absolute"),!i){var s=this._uiHash();if(this._trigger("drag",e,s)===!1)return this._mouseUp({}),!1;this.position=s.position}return this.options.axis&&"y"===this.options.axis||(this.helper[0].style.left=this.position.left+"px"),this.options.axis&&"x"===this.options.axis||(this.helper[0].style.top=this.position.top+"px"),t.ui.ddmanager&&t.ui.ddmanager.drag(this,e),!1},_mouseStop:function(e){var i=this,s=!1;return t.ui.ddmanager&&!this.options.dropBehaviour&&(s=t.ui.ddmanager.drop(this,e)),this.dropped&&(s=this.dropped,this.dropped=!1),"original"!==this.options.helper||t.contains(this.element[0].ownerDocument,this.element[0])?("invalid"===this.options.revert&&!s||"valid"===this.options.revert&&s||this.options.revert===!0||t.isFunction(this.options.revert)&&this.options.revert.call(this.element,s)?t(this.helper).animate(this.originalPosition,parseInt(this.options.revertDuration,10),function(){i._trigger("stop",e)!==!1&&i._clear()}):this._trigger("stop",e)!==!1&&this._clear(),!1):!1},_mouseUp:function(e){return t("div.ui-draggable-iframeFix").each(function(){this.parentNode.removeChild(this)}),t.ui.ddmanager&&t.ui.ddmanager.dragStop(this,e),t.ui.mouse.prototype._mouseUp.call(this,e)},cancel:function(){return this.helper.is(".ui-draggable-dragging")?this._mouseUp({}):this._clear(),this},_getHandle:function(e){return this.options.handle?!!t(e.target).closest(this.element.find(this.options.handle)).length:!0},_createHelper:function(e){var i=this.options,s=t.isFunction(i.helper)?t(i.helper.apply(this.element[0],[e])):"clone"===i.helper?this.element.clone().removeAttr("id"):this.element;return s.parents("body").length||s.appendTo("parent"===i.appendTo?this.element[0].parentNode:i.appendTo),s[0]===this.element[0]||/(fixed|absolute)/.test(s.css("position"))||s.css("position","absolute"),s},_adjustOffsetFromHelper:function(e){"string"==typeof e&&(e=e.split(" ")),t.isArray(e)&&(e={left:+e[0],top:+e[1]||0}),"left"in e&&(this.offset.click.left=e.left+this.margins.left),"right"in e&&(this.offset.click.left=this.helperProportions.width-e.right+this.margins.left),"top"in e&&(this.offset.click.top=e.top+this.margins.top),"bottom"in e&&(this.offset.click.top=this.helperProportions.height-e.bottom+this.margins.top)},_getParentOffset:function(){var e=this.offsetParent.offset();return"absolute"===this.cssPosition&&this.scrollParent[0]!==document&&t.contains(this.scrollParent[0],this.offsetParent[0])&&(e.left+=this.scrollParent.scrollLeft(),e.top+=this.scrollParent.scrollTop()),(this.offsetParent[0]===document.body||this.offsetParent[0].tagName&&"html"===this.offsetParent[0].tagName.toLowerCase()&&t.ui.ie)&&(e={top:0,left:0}),{top:e.top+(parseInt(this.offsetParent.css("borderTopWidth"),10)||0),left:e.left+(parseInt(this.offsetParent.css("borderLeftWidth"),10)||0)}},_getRelativeOffset:function(){if("relative"===this.cssPosition){var t=this.element.position();return{top:t.top-(parseInt(this.helper.css("top"),10)||0)+this.scrollParent.scrollTop(),left:t.left-(parseInt(this.helper.css("left"),10)||0)+this.scrollParent.scrollLeft()}}return{top:0,left:0}},_cacheMargins:function(){this.margins={left:parseInt(this.element.css("marginLeft"),10)||0,top:parseInt(this.element.css("marginTop"),10)||0,right:parseInt(this.element.css("marginRight"),10)||0,bottom:parseInt(this.element.css("marginBottom"),10)||0}},_cacheHelperProportions:function(){this.helperProportions={width:this.helper.outerWidth(),height:this.helper.outerHeight()}},_setContainment:function(){var e,i,s,n=this.options;return n.containment?"window"===n.containment?(this.containment=[t(window).scrollLeft()-this.offset.relative.left-this.offset.parent.left,t(window).scrollTop()-this.offset.relative.top-this.offset.parent.top,t(window).scrollLeft()+t(window).width()-this.helperProportions.width-this.margins.left,t(window).scrollTop()+(t(window).height()||document.body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top],undefined):"document"===n.containment?(this.containment=[0,0,t(document).width()-this.helperProportions.width-this.margins.left,(t(document).height()||document.body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top],undefined):n.containment.constructor===Array?(this.containment=n.containment,undefined):("parent"===n.containment&&(n.containment=this.helper[0].parentNode),i=t(n.containment),s=i[0],s&&(e="hidden"!==i.css("overflow"),this.containment=[(parseInt(i.css("borderLeftWidth"),10)||0)+(parseInt(i.css("paddingLeft"),10)||0),(parseInt(i.css("borderTopWidth"),10)||0)+(parseInt(i.css("paddingTop"),10)||0),(e?Math.max(s.scrollWidth,s.offsetWidth):s.offsetWidth)-(parseInt(i.css("borderRightWidth"),10)||0)-(parseInt(i.css("paddingRight"),10)||0)-this.helperProportions.width-this.margins.left-this.margins.right,(e?Math.max(s.scrollHeight,s.offsetHeight):s.offsetHeight)-(parseInt(i.css("borderBottomWidth"),10)||0)-(parseInt(i.css("paddingBottom"),10)||0)-this.helperProportions.height-this.margins.top-this.margins.bottom],this.relative_container=i),undefined):(this.containment=null,undefined)},_convertPositionTo:function(e,i){i||(i=this.position);var s="absolute"===e?1:-1,n="absolute"!==this.cssPosition||this.scrollParent[0]!==document&&t.contains(this.scrollParent[0],this.offsetParent[0])?this.scrollParent:this.offsetParent;return this.offset.scroll||(this.offset.scroll={top:n.scrollTop(),left:n.scrollLeft()}),{top:i.top+this.offset.relative.top*s+this.offset.parent.top*s-("fixed"===this.cssPosition?-this.scrollParent.scrollTop():this.offset.scroll.top)*s,left:i.left+this.offset.relative.left*s+this.offset.parent.left*s-("fixed"===this.cssPosition?-this.scrollParent.scrollLeft():this.offset.scroll.left)*s}},_generatePosition:function(e){var i,s,n,a,o=this.options,r="absolute"!==this.cssPosition||this.scrollParent[0]!==document&&t.contains(this.scrollParent[0],this.offsetParent[0])?this.scrollParent:this.offsetParent,l=e.pageX,h=e.pageY;return this.offset.scroll||(this.offset.scroll={top:r.scrollTop(),left:r.scrollLeft()}),this.originalPosition&&(this.containment&&(this.relative_container?(s=this.relative_container.offset(),i=[this.containment[0]+s.left,this.containment[1]+s.top,this.containment[2]+s.left,this.containment[3]+s.top]):i=this.containment,e.pageX-this.offset.click.left<i[0]&&(l=i[0]+this.offset.click.left),e.pageY-this.offset.click.top<i[1]&&(h=i[1]+this.offset.click.top),e.pageX-this.offset.click.left>i[2]&&(l=i[2]+this.offset.click.left),e.pageY-this.offset.click.top>i[3]&&(h=i[3]+this.offset.click.top)),o.grid&&(n=o.grid[1]?this.originalPageY+Math.round((h-this.originalPageY)/o.grid[1])*o.grid[1]:this.originalPageY,h=i?n-this.offset.click.top>=i[1]||n-this.offset.click.top>i[3]?n:n-this.offset.click.top>=i[1]?n-o.grid[1]:n+o.grid[1]:n,a=o.grid[0]?this.originalPageX+Math.round((l-this.originalPageX)/o.grid[0])*o.grid[0]:this.originalPageX,l=i?a-this.offset.click.left>=i[0]||a-this.offset.click.left>i[2]?a:a-this.offset.click.left>=i[0]?a-o.grid[0]:a+o.grid[0]:a)),{top:h-this.offset.click.top-this.offset.relative.top-this.offset.parent.top+("fixed"===this.cssPosition?-this.scrollParent.scrollTop():this.offset.scroll.top),left:l-this.offset.click.left-this.offset.relative.left-this.offset.parent.left+("fixed"===this.cssPosition?-this.scrollParent.scrollLeft():this.offset.scroll.left)}},_clear:function(){this.helper.removeClass("ui-draggable-dragging"),this.helper[0]===this.element[0]||this.cancelHelperRemoval||this.helper.remove(),this.helper=null,this.cancelHelperRemoval=!1},_trigger:function(e,i,s){return s=s||this._uiHash(),t.ui.plugin.call(this,e,[i,s]),"drag"===e&&(this.positionAbs=this._convertPositionTo("absolute")),t.Widget.prototype._trigger.call(this,e,i,s)},plugins:{},_uiHash:function(){return{helper:this.helper,position:this.position,originalPosition:this.originalPosition,offset:this.positionAbs}}}),t.ui.plugin.add("draggable","connectToSortable",{start:function(e,i){var s=t(this).data("ui-draggable"),n=s.options,a=t.extend({},i,{item:s.element});s.sortables=[],t(n.connectToSortable).each(function(){var i=t.data(this,"ui-sortable");i&&!i.options.disabled&&(s.sortables.push({instance:i,shouldRevert:i.options.revert}),i.refreshPositions(),i._trigger("activate",e,a))})},stop:function(e,i){var s=t(this).data("ui-draggable"),n=t.extend({},i,{item:s.element});t.each(s.sortables,function(){this.instance.isOver?(this.instance.isOver=0,s.cancelHelperRemoval=!0,this.instance.cancelHelperRemoval=!1,this.shouldRevert&&(this.instance.options.revert=this.shouldRevert),this.instance._mouseStop(e),this.instance.options.helper=this.instance.options._helper,"original"===s.options.helper&&this.instance.currentItem.css({top:"auto",left:"auto"})):(this.instance.cancelHelperRemoval=!1,this.instance._trigger("deactivate",e,n))})},drag:function(e,i){var s=t(this).data("ui-draggable"),n=this;t.each(s.sortables,function(){var a=!1,o=this;this.instance.positionAbs=s.positionAbs,this.instance.helperProportions=s.helperProportions,this.instance.offset.click=s.offset.click,this.instance._intersectsWith(this.instance.containerCache)&&(a=!0,t.each(s.sortables,function(){return this.instance.positionAbs=s.positionAbs,this.instance.helperProportions=s.helperProportions,this.instance.offset.click=s.offset.click,this!==o&&this.instance._intersectsWith(this.instance.containerCache)&&t.contains(o.instance.element[0],this.instance.element[0])&&(a=!1),a})),a?(this.instance.isOver||(this.instance.isOver=1,this.instance.currentItem=t(n).clone().removeAttr("id").appendTo(this.instance.element).data("ui-sortable-item",!0),this.instance.options._helper=this.instance.options.helper,this.instance.options.helper=function(){return i.helper[0]},e.target=this.instance.currentItem[0],this.instance._mouseCapture(e,!0),this.instance._mouseStart(e,!0,!0),this.instance.offset.click.top=s.offset.click.top,this.instance.offset.click.left=s.offset.click.left,this.instance.offset.parent.left-=s.offset.parent.left-this.instance.offset.parent.left,this.instance.offset.parent.top-=s.offset.parent.top-this.instance.offset.parent.top,s._trigger("toSortable",e),s.dropped=this.instance.element,s.currentItem=s.element,this.instance.fromOutside=s),this.instance.currentItem&&this.instance._mouseDrag(e)):this.instance.isOver&&(this.instance.isOver=0,this.instance.cancelHelperRemoval=!0,this.instance.options.revert=!1,this.instance._trigger("out",e,this.instance._uiHash(this.instance)),this.instance._mouseStop(e,!0),this.instance.options.helper=this.instance.options._helper,this.instance.currentItem.remove(),this.instance.placeholder&&this.instance.placeholder.remove(),s._trigger("fromSortable",e),s.dropped=!1)})}}),t.ui.plugin.add("draggable","cursor",{start:function(){var e=t("body"),i=t(this).data("ui-draggable").options;e.css("cursor")&&(i._cursor=e.css("cursor")),e.css("cursor",i.cursor)},stop:function(){var e=t(this).data("ui-draggable").options;e._cursor&&t("body").css("cursor",e._cursor)}}),t.ui.plugin.add("draggable","opacity",{start:function(e,i){var s=t(i.helper),n=t(this).data("ui-draggable").options;s.css("opacity")&&(n._opacity=s.css("opacity")),s.css("opacity",n.opacity)},stop:function(e,i){var s=t(this).data("ui-draggable").options;s._opacity&&t(i.helper).css("opacity",s._opacity)}}),t.ui.plugin.add("draggable","scroll",{start:function(){var e=t(this).data("ui-draggable");e.scrollParent[0]!==document&&"HTML"!==e.scrollParent[0].tagName&&(e.overflowOffset=e.scrollParent.offset())},drag:function(e){var i=t(this).data("ui-draggable"),s=i.options,n=!1;i.scrollParent[0]!==document&&"HTML"!==i.scrollParent[0].tagName?(s.axis&&"x"===s.axis||(i.overflowOffset.top+i.scrollParent[0].offsetHeight-e.pageY<s.scrollSensitivity?i.scrollParent[0].scrollTop=n=i.scrollParent[0].scrollTop+s.scrollSpeed:e.pageY-i.overflowOffset.top<s.scrollSensitivity&&(i.scrollParent[0].scrollTop=n=i.scrollParent[0].scrollTop-s.scrollSpeed)),s.axis&&"y"===s.axis||(i.overflowOffset.left+i.scrollParent[0].offsetWidth-e.pageX<s.scrollSensitivity?i.scrollParent[0].scrollLeft=n=i.scrollParent[0].scrollLeft+s.scrollSpeed:e.pageX-i.overflowOffset.left<s.scrollSensitivity&&(i.scrollParent[0].scrollLeft=n=i.scrollParent[0].scrollLeft-s.scrollSpeed))):(s.axis&&"x"===s.axis||(e.pageY-t(document).scrollTop()<s.scrollSensitivity?n=t(document).scrollTop(t(document).scrollTop()-s.scrollSpeed):t(window).height()-(e.pageY-t(document).scrollTop())<s.scrollSensitivity&&(n=t(document).scrollTop(t(document).scrollTop()+s.scrollSpeed))),s.axis&&"y"===s.axis||(e.pageX-t(document).scrollLeft()<s.scrollSensitivity?n=t(document).scrollLeft(t(document).scrollLeft()-s.scrollSpeed):t(window).width()-(e.pageX-t(document).scrollLeft())<s.scrollSensitivity&&(n=t(document).scrollLeft(t(document).scrollLeft()+s.scrollSpeed)))),n!==!1&&t.ui.ddmanager&&!s.dropBehaviour&&t.ui.ddmanager.prepareOffsets(i,e)}}),t.ui.plugin.add("draggable","snap",{start:function(){var e=t(this).data("ui-draggable"),i=e.options;e.snapElements=[],t(i.snap.constructor!==String?i.snap.items||":data(ui-draggable)":i.snap).each(function(){var i=t(this),s=i.offset();this!==e.element[0]&&e.snapElements.push({item:this,width:i.outerWidth(),height:i.outerHeight(),top:s.top,left:s.left})})},drag:function(e,i){var s,n,a,o,r,l,h,c,u,d,p=t(this).data("ui-draggable"),g=p.options,f=g.snapTolerance,m=i.offset.left,_=m+p.helperProportions.width,v=i.offset.top,b=v+p.helperProportions.height;for(u=p.snapElements.length-1;u>=0;u--)r=p.snapElements[u].left,l=r+p.snapElements[u].width,h=p.snapElements[u].top,c=h+p.snapElements[u].height,r-f>_||m>l+f||h-f>b||v>c+f||!t.contains(p.snapElements[u].item.ownerDocument,p.snapElements[u].item)?(p.snapElements[u].snapping&&p.options.snap.release&&p.options.snap.release.call(p.element,e,t.extend(p._uiHash(),{snapItem:p.snapElements[u].item})),p.snapElements[u].snapping=!1):("inner"!==g.snapMode&&(s=f>=Math.abs(h-b),n=f>=Math.abs(c-v),a=f>=Math.abs(r-_),o=f>=Math.abs(l-m),s&&(i.position.top=p._convertPositionTo("relative",{top:h-p.helperProportions.height,left:0}).top-p.margins.top),n&&(i.position.top=p._convertPositionTo("relative",{top:c,left:0}).top-p.margins.top),a&&(i.position.left=p._convertPositionTo("relative",{top:0,left:r-p.helperProportions.width}).left-p.margins.left),o&&(i.position.left=p._convertPositionTo("relative",{top:0,left:l}).left-p.margins.left)),d=s||n||a||o,"outer"!==g.snapMode&&(s=f>=Math.abs(h-v),n=f>=Math.abs(c-b),a=f>=Math.abs(r-m),o=f>=Math.abs(l-_),s&&(i.position.top=p._convertPositionTo("relative",{top:h,left:0}).top-p.margins.top),n&&(i.position.top=p._convertPositionTo("relative",{top:c-p.helperProportions.height,left:0}).top-p.margins.top),a&&(i.position.left=p._convertPositionTo("relative",{top:0,left:r}).left-p.margins.left),o&&(i.position.left=p._convertPositionTo("relative",{top:0,left:l-p.helperProportions.width}).left-p.margins.left)),!p.snapElements[u].snapping&&(s||n||a||o||d)&&p.options.snap.snap&&p.options.snap.snap.call(p.element,e,t.extend(p._uiHash(),{snapItem:p.snapElements[u].item})),p.snapElements[u].snapping=s||n||a||o||d)}}),t.ui.plugin.add("draggable","stack",{start:function(){var e,i=this.data("ui-draggable").options,s=t.makeArray(t(i.stack)).sort(function(e,i){return(parseInt(t(e).css("zIndex"),10)||0)-(parseInt(t(i).css("zIndex"),10)||0)});s.length&&(e=parseInt(t(s[0]).css("zIndex"),10)||0,t(s).each(function(i){t(this).css("zIndex",e+i)}),this.css("zIndex",e+s.length))}}),t.ui.plugin.add("draggable","zIndex",{start:function(e,i){var s=t(i.helper),n=t(this).data("ui-draggable").options;s.css("zIndex")&&(n._zIndex=s.css("zIndex")),s.css("zIndex",n.zIndex)},stop:function(e,i){var s=t(this).data("ui-draggable").options;s._zIndex&&t(i.helper).css("zIndex",s._zIndex)}})})(jQuery);(function(t){function e(t,e,i){return t>e&&e+i>t}t.widget("ui.droppable",{version:"1.10.4",widgetEventPrefix:"drop",options:{accept:"*",activeClass:!1,addClasses:!0,greedy:!1,hoverClass:!1,scope:"default",tolerance:"intersect",activate:null,deactivate:null,drop:null,out:null,over:null},_create:function(){var e,i=this.options,s=i.accept;this.isover=!1,this.isout=!0,this.accept=t.isFunction(s)?s:function(t){return t.is(s)},this.proportions=function(){return arguments.length?(e=arguments[0],undefined):e?e:e={width:this.element[0].offsetWidth,height:this.element[0].offsetHeight}},t.ui.ddmanager.droppables[i.scope]=t.ui.ddmanager.droppables[i.scope]||[],t.ui.ddmanager.droppables[i.scope].push(this),i.addClasses&&this.element.addClass("ui-droppable")},_destroy:function(){for(var e=0,i=t.ui.ddmanager.droppables[this.options.scope];i.length>e;e++)i[e]===this&&i.splice(e,1);this.element.removeClass("ui-droppable ui-droppable-disabled")},_setOption:function(e,i){"accept"===e&&(this.accept=t.isFunction(i)?i:function(t){return t.is(i)}),t.Widget.prototype._setOption.apply(this,arguments)},_activate:function(e){var i=t.ui.ddmanager.current;this.options.activeClass&&this.element.addClass(this.options.activeClass),i&&this._trigger("activate",e,this.ui(i))},_deactivate:function(e){var i=t.ui.ddmanager.current;this.options.activeClass&&this.element.removeClass(this.options.activeClass),i&&this._trigger("deactivate",e,this.ui(i))},_over:function(e){var i=t.ui.ddmanager.current;i&&(i.currentItem||i.element)[0]!==this.element[0]&&this.accept.call(this.element[0],i.currentItem||i.element)&&(this.options.hoverClass&&this.element.addClass(this.options.hoverClass),this._trigger("over",e,this.ui(i)))},_out:function(e){var i=t.ui.ddmanager.current;i&&(i.currentItem||i.element)[0]!==this.element[0]&&this.accept.call(this.element[0],i.currentItem||i.element)&&(this.options.hoverClass&&this.element.removeClass(this.options.hoverClass),this._trigger("out",e,this.ui(i)))},_drop:function(e,i){var s=i||t.ui.ddmanager.current,n=!1;return s&&(s.currentItem||s.element)[0]!==this.element[0]?(this.element.find(":data(ui-droppable)").not(".ui-draggable-dragging").each(function(){var e=t.data(this,"ui-droppable");return e.options.greedy&&!e.options.disabled&&e.options.scope===s.options.scope&&e.accept.call(e.element[0],s.currentItem||s.element)&&t.ui.intersect(s,t.extend(e,{offset:e.element.offset()}),e.options.tolerance)?(n=!0,!1):undefined}),n?!1:this.accept.call(this.element[0],s.currentItem||s.element)?(this.options.activeClass&&this.element.removeClass(this.options.activeClass),this.options.hoverClass&&this.element.removeClass(this.options.hoverClass),this._trigger("drop",e,this.ui(s)),this.element):!1):!1},ui:function(t){return{draggable:t.currentItem||t.element,helper:t.helper,position:t.position,offset:t.positionAbs}}}),t.ui.intersect=function(t,i,s){if(!i.offset)return!1;var n,a,o=(t.positionAbs||t.position.absolute).left,r=(t.positionAbs||t.position.absolute).top,l=o+t.helperProportions.width,h=r+t.helperProportions.height,c=i.offset.left,u=i.offset.top,d=c+i.proportions().width,p=u+i.proportions().height;switch(s){case"fit":return o>=c&&d>=l&&r>=u&&p>=h;case"intersect":return o+t.helperProportions.width/2>c&&d>l-t.helperProportions.width/2&&r+t.helperProportions.height/2>u&&p>h-t.helperProportions.height/2;case"pointer":return n=(t.positionAbs||t.position.absolute).left+(t.clickOffset||t.offset.click).left,a=(t.positionAbs||t.position.absolute).top+(t.clickOffset||t.offset.click).top,e(a,u,i.proportions().height)&&e(n,c,i.proportions().width);case"touch":return(r>=u&&p>=r||h>=u&&p>=h||u>r&&h>p)&&(o>=c&&d>=o||l>=c&&d>=l||c>o&&l>d);default:return!1}},t.ui.ddmanager={current:null,droppables:{"default":[]},prepareOffsets:function(e,i){var s,n,a=t.ui.ddmanager.droppables[e.options.scope]||[],o=i?i.type:null,r=(e.currentItem||e.element).find(":data(ui-droppable)").addBack();t:for(s=0;a.length>s;s++)if(!(a[s].options.disabled||e&&!a[s].accept.call(a[s].element[0],e.currentItem||e.element))){for(n=0;r.length>n;n++)if(r[n]===a[s].element[0]){a[s].proportions().height=0;continue t}a[s].visible="none"!==a[s].element.css("display"),a[s].visible&&("mousedown"===o&&a[s]._activate.call(a[s],i),a[s].offset=a[s].element.offset(),a[s].proportions({width:a[s].element[0].offsetWidth,height:a[s].element[0].offsetHeight}))}},drop:function(e,i){var s=!1;return t.each((t.ui.ddmanager.droppables[e.options.scope]||[]).slice(),function(){this.options&&(!this.options.disabled&&this.visible&&t.ui.intersect(e,this,this.options.tolerance)&&(s=this._drop.call(this,i)||s),!this.options.disabled&&this.visible&&this.accept.call(this.element[0],e.currentItem||e.element)&&(this.isout=!0,this.isover=!1,this._deactivate.call(this,i)))}),s},dragStart:function(e,i){e.element.parentsUntil("body").bind("scroll.droppable",function(){e.options.refreshPositions||t.ui.ddmanager.prepareOffsets(e,i)})},drag:function(e,i){e.options.refreshPositions&&t.ui.ddmanager.prepareOffsets(e,i),t.each(t.ui.ddmanager.droppables[e.options.scope]||[],function(){if(!this.options.disabled&&!this.greedyChild&&this.visible){var s,n,a,o=t.ui.intersect(e,this,this.options.tolerance),r=!o&&this.isover?"isout":o&&!this.isover?"isover":null;r&&(this.options.greedy&&(n=this.options.scope,a=this.element.parents(":data(ui-droppable)").filter(function(){return t.data(this,"ui-droppable").options.scope===n}),a.length&&(s=t.data(a[0],"ui-droppable"),s.greedyChild="isover"===r)),s&&"isover"===r&&(s.isover=!1,s.isout=!0,s._out.call(s,i)),this[r]=!0,this["isout"===r?"isover":"isout"]=!1,this["isover"===r?"_over":"_out"].call(this,i),s&&"isout"===r&&(s.isout=!1,s.isover=!0,s._over.call(s,i)))}})},dragStop:function(e,i){e.element.parentsUntil("body").unbind("scroll.droppable"),e.options.refreshPositions||t.ui.ddmanager.prepareOffsets(e,i)}}})(jQuery);(function(t){function e(t){return parseInt(t,10)||0}function i(t){return!isNaN(parseInt(t,10))}t.widget("ui.resizable",t.ui.mouse,{version:"1.10.4",widgetEventPrefix:"resize",options:{alsoResize:!1,animate:!1,animateDuration:"slow",animateEasing:"swing",aspectRatio:!1,autoHide:!1,containment:!1,ghost:!1,grid:!1,handles:"e,s,se",helper:!1,maxHeight:null,maxWidth:null,minHeight:10,minWidth:10,zIndex:90,resize:null,start:null,stop:null},_create:function(){var e,i,s,n,a,o=this,r=this.options;if(this.element.addClass("ui-resizable"),t.extend(this,{_aspectRatio:!!r.aspectRatio,aspectRatio:r.aspectRatio,originalElement:this.element,_proportionallyResizeElements:[],_helper:r.helper||r.ghost||r.animate?r.helper||"ui-resizable-helper":null}),this.element[0].nodeName.match(/canvas|textarea|input|select|button|img/i)&&(this.element.wrap(t("<div class='ui-wrapper' style='overflow: hidden;'></div>").css({position:this.element.css("position"),width:this.element.outerWidth(),height:this.element.outerHeight(),top:this.element.css("top"),left:this.element.css("left")})),this.element=this.element.parent().data("ui-resizable",this.element.data("ui-resizable")),this.elementIsWrapper=!0,this.element.css({marginLeft:this.originalElement.css("marginLeft"),marginTop:this.originalElement.css("marginTop"),marginRight:this.originalElement.css("marginRight"),marginBottom:this.originalElement.css("marginBottom")}),this.originalElement.css({marginLeft:0,marginTop:0,marginRight:0,marginBottom:0}),this.originalResizeStyle=this.originalElement.css("resize"),this.originalElement.css("resize","none"),this._proportionallyResizeElements.push(this.originalElement.css({position:"static",zoom:1,display:"block"})),this.originalElement.css({margin:this.originalElement.css("margin")}),this._proportionallyResize()),this.handles=r.handles||(t(".ui-resizable-handle",this.element).length?{n:".ui-resizable-n",e:".ui-resizable-e",s:".ui-resizable-s",w:".ui-resizable-w",se:".ui-resizable-se",sw:".ui-resizable-sw",ne:".ui-resizable-ne",nw:".ui-resizable-nw"}:"e,s,se"),this.handles.constructor===String)for("all"===this.handles&&(this.handles="n,e,s,w,se,sw,ne,nw"),e=this.handles.split(","),this.handles={},i=0;e.length>i;i++)s=t.trim(e[i]),a="ui-resizable-"+s,n=t("<div class='ui-resizable-handle "+a+"'></div>"),n.css({zIndex:r.zIndex}),"se"===s&&n.addClass("ui-icon ui-icon-gripsmall-diagonal-se"),this.handles[s]=".ui-resizable-"+s,this.element.append(n);this._renderAxis=function(e){var i,s,n,a;e=e||this.element;for(i in this.handles)this.handles[i].constructor===String&&(this.handles[i]=t(this.handles[i],this.element).show()),this.elementIsWrapper&&this.originalElement[0].nodeName.match(/textarea|input|select|button/i)&&(s=t(this.handles[i],this.element),a=/sw|ne|nw|se|n|s/.test(i)?s.outerHeight():s.outerWidth(),n=["padding",/ne|nw|n/.test(i)?"Top":/se|sw|s/.test(i)?"Bottom":/^e$/.test(i)?"Right":"Left"].join(""),e.css(n,a),this._proportionallyResize()),t(this.handles[i]).length},this._renderAxis(this.element),this._handles=t(".ui-resizable-handle",this.element).disableSelection(),this._handles.mouseover(function(){o.resizing||(this.className&&(n=this.className.match(/ui-resizable-(se|sw|ne|nw|n|e|s|w)/i)),o.axis=n&&n[1]?n[1]:"se")}),r.autoHide&&(this._handles.hide(),t(this.element).addClass("ui-resizable-autohide").mouseenter(function(){r.disabled||(t(this).removeClass("ui-resizable-autohide"),o._handles.show())}).mouseleave(function(){r.disabled||o.resizing||(t(this).addClass("ui-resizable-autohide"),o._handles.hide())})),this._mouseInit()},_destroy:function(){this._mouseDestroy();var e,i=function(e){t(e).removeClass("ui-resizable ui-resizable-disabled ui-resizable-resizing").removeData("resizable").removeData("ui-resizable").unbind(".resizable").find(".ui-resizable-handle").remove()};return this.elementIsWrapper&&(i(this.element),e=this.element,this.originalElement.css({position:e.css("position"),width:e.outerWidth(),height:e.outerHeight(),top:e.css("top"),left:e.css("left")}).insertAfter(e),e.remove()),this.originalElement.css("resize",this.originalResizeStyle),i(this.originalElement),this},_mouseCapture:function(e){var i,s,n=!1;for(i in this.handles)s=t(this.handles[i])[0],(s===e.target||t.contains(s,e.target))&&(n=!0);return!this.options.disabled&&n},_mouseStart:function(i){var s,n,a,o=this.options,r=this.element.position(),h=this.element;return this.resizing=!0,/absolute/.test(h.css("position"))?h.css({position:"absolute",top:h.css("top"),left:h.css("left")}):h.is(".ui-draggable")&&h.css({position:"absolute",top:r.top,left:r.left}),this._renderProxy(),s=e(this.helper.css("left")),n=e(this.helper.css("top")),o.containment&&(s+=t(o.containment).scrollLeft()||0,n+=t(o.containment).scrollTop()||0),this.offset=this.helper.offset(),this.position={left:s,top:n},this.size=this._helper?{width:this.helper.width(),height:this.helper.height()}:{width:h.width(),height:h.height()},this.originalSize=this._helper?{width:h.outerWidth(),height:h.outerHeight()}:{width:h.width(),height:h.height()},this.originalPosition={left:s,top:n},this.sizeDiff={width:h.outerWidth()-h.width(),height:h.outerHeight()-h.height()},this.originalMousePosition={left:i.pageX,top:i.pageY},this.aspectRatio="number"==typeof o.aspectRatio?o.aspectRatio:this.originalSize.width/this.originalSize.height||1,a=t(".ui-resizable-"+this.axis).css("cursor"),t("body").css("cursor","auto"===a?this.axis+"-resize":a),h.addClass("ui-resizable-resizing"),this._propagate("start",i),!0},_mouseDrag:function(e){var i,s=this.helper,n={},a=this.originalMousePosition,o=this.axis,r=this.position.top,h=this.position.left,l=this.size.width,c=this.size.height,u=e.pageX-a.left||0,d=e.pageY-a.top||0,p=this._change[o];return p?(i=p.apply(this,[e,u,d]),this._updateVirtualBoundaries(e.shiftKey),(this._aspectRatio||e.shiftKey)&&(i=this._updateRatio(i,e)),i=this._respectSize(i,e),this._updateCache(i),this._propagate("resize",e),this.position.top!==r&&(n.top=this.position.top+"px"),this.position.left!==h&&(n.left=this.position.left+"px"),this.size.width!==l&&(n.width=this.size.width+"px"),this.size.height!==c&&(n.height=this.size.height+"px"),s.css(n),!this._helper&&this._proportionallyResizeElements.length&&this._proportionallyResize(),t.isEmptyObject(n)||this._trigger("resize",e,this.ui()),!1):!1},_mouseStop:function(e){this.resizing=!1;var i,s,n,a,o,r,h,l=this.options,c=this;return this._helper&&(i=this._proportionallyResizeElements,s=i.length&&/textarea/i.test(i[0].nodeName),n=s&&t.ui.hasScroll(i[0],"left")?0:c.sizeDiff.height,a=s?0:c.sizeDiff.width,o={width:c.helper.width()-a,height:c.helper.height()-n},r=parseInt(c.element.css("left"),10)+(c.position.left-c.originalPosition.left)||null,h=parseInt(c.element.css("top"),10)+(c.position.top-c.originalPosition.top)||null,l.animate||this.element.css(t.extend(o,{top:h,left:r})),c.helper.height(c.size.height),c.helper.width(c.size.width),this._helper&&!l.animate&&this._proportionallyResize()),t("body").css("cursor","auto"),this.element.removeClass("ui-resizable-resizing"),this._propagate("stop",e),this._helper&&this.helper.remove(),!1},_updateVirtualBoundaries:function(t){var e,s,n,a,o,r=this.options;o={minWidth:i(r.minWidth)?r.minWidth:0,maxWidth:i(r.maxWidth)?r.maxWidth:1/0,minHeight:i(r.minHeight)?r.minHeight:0,maxHeight:i(r.maxHeight)?r.maxHeight:1/0},(this._aspectRatio||t)&&(e=o.minHeight*this.aspectRatio,n=o.minWidth/this.aspectRatio,s=o.maxHeight*this.aspectRatio,a=o.maxWidth/this.aspectRatio,e>o.minWidth&&(o.minWidth=e),n>o.minHeight&&(o.minHeight=n),o.maxWidth>s&&(o.maxWidth=s),o.maxHeight>a&&(o.maxHeight=a)),this._vBoundaries=o},_updateCache:function(t){this.offset=this.helper.offset(),i(t.left)&&(this.position.left=t.left),i(t.top)&&(this.position.top=t.top),i(t.height)&&(this.size.height=t.height),i(t.width)&&(this.size.width=t.width)},_updateRatio:function(t){var e=this.position,s=this.size,n=this.axis;return i(t.height)?t.width=t.height*this.aspectRatio:i(t.width)&&(t.height=t.width/this.aspectRatio),"sw"===n&&(t.left=e.left+(s.width-t.width),t.top=null),"nw"===n&&(t.top=e.top+(s.height-t.height),t.left=e.left+(s.width-t.width)),t},_respectSize:function(t){var e=this._vBoundaries,s=this.axis,n=i(t.width)&&e.maxWidth&&e.maxWidth<t.width,a=i(t.height)&&e.maxHeight&&e.maxHeight<t.height,o=i(t.width)&&e.minWidth&&e.minWidth>t.width,r=i(t.height)&&e.minHeight&&e.minHeight>t.height,h=this.originalPosition.left+this.originalSize.width,l=this.position.top+this.size.height,c=/sw|nw|w/.test(s),u=/nw|ne|n/.test(s);return o&&(t.width=e.minWidth),r&&(t.height=e.minHeight),n&&(t.width=e.maxWidth),a&&(t.height=e.maxHeight),o&&c&&(t.left=h-e.minWidth),n&&c&&(t.left=h-e.maxWidth),r&&u&&(t.top=l-e.minHeight),a&&u&&(t.top=l-e.maxHeight),t.width||t.height||t.left||!t.top?t.width||t.height||t.top||!t.left||(t.left=null):t.top=null,t},_proportionallyResize:function(){if(this._proportionallyResizeElements.length){var t,e,i,s,n,a=this.helper||this.element;for(t=0;this._proportionallyResizeElements.length>t;t++){if(n=this._proportionallyResizeElements[t],!this.borderDif)for(this.borderDif=[],i=[n.css("borderTopWidth"),n.css("borderRightWidth"),n.css("borderBottomWidth"),n.css("borderLeftWidth")],s=[n.css("paddingTop"),n.css("paddingRight"),n.css("paddingBottom"),n.css("paddingLeft")],e=0;i.length>e;e++)this.borderDif[e]=(parseInt(i[e],10)||0)+(parseInt(s[e],10)||0);n.css({height:a.height()-this.borderDif[0]-this.borderDif[2]||0,width:a.width()-this.borderDif[1]-this.borderDif[3]||0})}}},_renderProxy:function(){var e=this.element,i=this.options;this.elementOffset=e.offset(),this._helper?(this.helper=this.helper||t("<div style='overflow:hidden;'></div>"),this.helper.addClass(this._helper).css({width:this.element.outerWidth()-1,height:this.element.outerHeight()-1,position:"absolute",left:this.elementOffset.left+"px",top:this.elementOffset.top+"px",zIndex:++i.zIndex}),this.helper.appendTo("body").disableSelection()):this.helper=this.element},_change:{e:function(t,e){return{width:this.originalSize.width+e}},w:function(t,e){var i=this.originalSize,s=this.originalPosition;return{left:s.left+e,width:i.width-e}},n:function(t,e,i){var s=this.originalSize,n=this.originalPosition;return{top:n.top+i,height:s.height-i}},s:function(t,e,i){return{height:this.originalSize.height+i}},se:function(e,i,s){return t.extend(this._change.s.apply(this,arguments),this._change.e.apply(this,[e,i,s]))},sw:function(e,i,s){return t.extend(this._change.s.apply(this,arguments),this._change.w.apply(this,[e,i,s]))},ne:function(e,i,s){return t.extend(this._change.n.apply(this,arguments),this._change.e.apply(this,[e,i,s]))},nw:function(e,i,s){return t.extend(this._change.n.apply(this,arguments),this._change.w.apply(this,[e,i,s]))}},_propagate:function(e,i){t.ui.plugin.call(this,e,[i,this.ui()]),"resize"!==e&&this._trigger(e,i,this.ui())},plugins:{},ui:function(){return{originalElement:this.originalElement,element:this.element,helper:this.helper,position:this.position,size:this.size,originalSize:this.originalSize,originalPosition:this.originalPosition}}}),t.ui.plugin.add("resizable","animate",{stop:function(e){var i=t(this).data("ui-resizable"),s=i.options,n=i._proportionallyResizeElements,a=n.length&&/textarea/i.test(n[0].nodeName),o=a&&t.ui.hasScroll(n[0],"left")?0:i.sizeDiff.height,r=a?0:i.sizeDiff.width,h={width:i.size.width-r,height:i.size.height-o},l=parseInt(i.element.css("left"),10)+(i.position.left-i.originalPosition.left)||null,c=parseInt(i.element.css("top"),10)+(i.position.top-i.originalPosition.top)||null;i.element.animate(t.extend(h,c&&l?{top:c,left:l}:{}),{duration:s.animateDuration,easing:s.animateEasing,step:function(){var s={width:parseInt(i.element.css("width"),10),height:parseInt(i.element.css("height"),10),top:parseInt(i.element.css("top"),10),left:parseInt(i.element.css("left"),10)};n&&n.length&&t(n[0]).css({width:s.width,height:s.height}),i._updateCache(s),i._propagate("resize",e)}})}}),t.ui.plugin.add("resizable","containment",{start:function(){var i,s,n,a,o,r,h,l=t(this).data("ui-resizable"),c=l.options,u=l.element,d=c.containment,p=d instanceof t?d.get(0):/parent/.test(d)?u.parent().get(0):d;p&&(l.containerElement=t(p),/document/.test(d)||d===document?(l.containerOffset={left:0,top:0},l.containerPosition={left:0,top:0},l.parentData={element:t(document),left:0,top:0,width:t(document).width(),height:t(document).height()||document.body.parentNode.scrollHeight}):(i=t(p),s=[],t(["Top","Right","Left","Bottom"]).each(function(t,n){s[t]=e(i.css("padding"+n))}),l.containerOffset=i.offset(),l.containerPosition=i.position(),l.containerSize={height:i.innerHeight()-s[3],width:i.innerWidth()-s[1]},n=l.containerOffset,a=l.containerSize.height,o=l.containerSize.width,r=t.ui.hasScroll(p,"left")?p.scrollWidth:o,h=t.ui.hasScroll(p)?p.scrollHeight:a,l.parentData={element:p,left:n.left,top:n.top,width:r,height:h}))},resize:function(e){var i,s,n,a,o=t(this).data("ui-resizable"),r=o.options,h=o.containerOffset,l=o.position,c=o._aspectRatio||e.shiftKey,u={top:0,left:0},d=o.containerElement;d[0]!==document&&/static/.test(d.css("position"))&&(u=h),l.left<(o._helper?h.left:0)&&(o.size.width=o.size.width+(o._helper?o.position.left-h.left:o.position.left-u.left),c&&(o.size.height=o.size.width/o.aspectRatio),o.position.left=r.helper?h.left:0),l.top<(o._helper?h.top:0)&&(o.size.height=o.size.height+(o._helper?o.position.top-h.top:o.position.top),c&&(o.size.width=o.size.height*o.aspectRatio),o.position.top=o._helper?h.top:0),o.offset.left=o.parentData.left+o.position.left,o.offset.top=o.parentData.top+o.position.top,i=Math.abs((o._helper?o.offset.left-u.left:o.offset.left-u.left)+o.sizeDiff.width),s=Math.abs((o._helper?o.offset.top-u.top:o.offset.top-h.top)+o.sizeDiff.height),n=o.containerElement.get(0)===o.element.parent().get(0),a=/relative|absolute/.test(o.containerElement.css("position")),n&&a&&(i-=Math.abs(o.parentData.left)),i+o.size.width>=o.parentData.width&&(o.size.width=o.parentData.width-i,c&&(o.size.height=o.size.width/o.aspectRatio)),s+o.size.height>=o.parentData.height&&(o.size.height=o.parentData.height-s,c&&(o.size.width=o.size.height*o.aspectRatio))},stop:function(){var e=t(this).data("ui-resizable"),i=e.options,s=e.containerOffset,n=e.containerPosition,a=e.containerElement,o=t(e.helper),r=o.offset(),h=o.outerWidth()-e.sizeDiff.width,l=o.outerHeight()-e.sizeDiff.height;e._helper&&!i.animate&&/relative/.test(a.css("position"))&&t(this).css({left:r.left-n.left-s.left,width:h,height:l}),e._helper&&!i.animate&&/static/.test(a.css("position"))&&t(this).css({left:r.left-n.left-s.left,width:h,height:l})}}),t.ui.plugin.add("resizable","alsoResize",{start:function(){var e=t(this).data("ui-resizable"),i=e.options,s=function(e){t(e).each(function(){var e=t(this);e.data("ui-resizable-alsoresize",{width:parseInt(e.width(),10),height:parseInt(e.height(),10),left:parseInt(e.css("left"),10),top:parseInt(e.css("top"),10)})})};"object"!=typeof i.alsoResize||i.alsoResize.parentNode?s(i.alsoResize):i.alsoResize.length?(i.alsoResize=i.alsoResize[0],s(i.alsoResize)):t.each(i.alsoResize,function(t){s(t)})},resize:function(e,i){var s=t(this).data("ui-resizable"),n=s.options,a=s.originalSize,o=s.originalPosition,r={height:s.size.height-a.height||0,width:s.size.width-a.width||0,top:s.position.top-o.top||0,left:s.position.left-o.left||0},h=function(e,s){t(e).each(function(){var e=t(this),n=t(this).data("ui-resizable-alsoresize"),a={},o=s&&s.length?s:e.parents(i.originalElement[0]).length?["width","height"]:["width","height","top","left"];t.each(o,function(t,e){var i=(n[e]||0)+(r[e]||0);i&&i>=0&&(a[e]=i||null)}),e.css(a)})};"object"!=typeof n.alsoResize||n.alsoResize.nodeType?h(n.alsoResize):t.each(n.alsoResize,function(t,e){h(t,e)})},stop:function(){t(this).removeData("resizable-alsoresize")}}),t.ui.plugin.add("resizable","ghost",{start:function(){var e=t(this).data("ui-resizable"),i=e.options,s=e.size;e.ghost=e.originalElement.clone(),e.ghost.css({opacity:.25,display:"block",position:"relative",height:s.height,width:s.width,margin:0,left:0,top:0}).addClass("ui-resizable-ghost").addClass("string"==typeof i.ghost?i.ghost:""),e.ghost.appendTo(e.helper)},resize:function(){var e=t(this).data("ui-resizable");e.ghost&&e.ghost.css({position:"relative",height:e.size.height,width:e.size.width})},stop:function(){var e=t(this).data("ui-resizable");e.ghost&&e.helper&&e.helper.get(0).removeChild(e.ghost.get(0))}}),t.ui.plugin.add("resizable","grid",{resize:function(){var e=t(this).data("ui-resizable"),i=e.options,s=e.size,n=e.originalSize,a=e.originalPosition,o=e.axis,r="number"==typeof i.grid?[i.grid,i.grid]:i.grid,h=r[0]||1,l=r[1]||1,c=Math.round((s.width-n.width)/h)*h,u=Math.round((s.height-n.height)/l)*l,d=n.width+c,p=n.height+u,f=i.maxWidth&&d>i.maxWidth,g=i.maxHeight&&p>i.maxHeight,m=i.minWidth&&i.minWidth>d,v=i.minHeight&&i.minHeight>p;i.grid=r,m&&(d+=h),v&&(p+=l),f&&(d-=h),g&&(p-=l),/^(se|s|e)$/.test(o)?(e.size.width=d,e.size.height=p):/^(ne)$/.test(o)?(e.size.width=d,e.size.height=p,e.position.top=a.top-u):/^(sw)$/.test(o)?(e.size.width=d,e.size.height=p,e.position.left=a.left-c):(p-l>0?(e.size.height=p,e.position.top=a.top-u):(e.size.height=l,e.position.top=a.top+n.height-l),d-h>0?(e.size.width=d,e.position.left=a.left-c):(e.size.width=h,e.position.left=a.left+n.width-h))}})})(jQuery);(function(t){t.widget("ui.selectable",t.ui.mouse,{version:"1.10.4",options:{appendTo:"body",autoRefresh:!0,distance:0,filter:"*",tolerance:"touch",selected:null,selecting:null,start:null,stop:null,unselected:null,unselecting:null},_create:function(){var e,i=this;this.element.addClass("ui-selectable"),this.dragged=!1,this.refresh=function(){e=t(i.options.filter,i.element[0]),e.addClass("ui-selectee"),e.each(function(){var e=t(this),i=e.offset();t.data(this,"selectable-item",{element:this,$element:e,left:i.left,top:i.top,right:i.left+e.outerWidth(),bottom:i.top+e.outerHeight(),startselected:!1,selected:e.hasClass("ui-selected"),selecting:e.hasClass("ui-selecting"),unselecting:e.hasClass("ui-unselecting")})})},this.refresh(),this.selectees=e.addClass("ui-selectee"),this._mouseInit(),this.helper=t("<div class='ui-selectable-helper'></div>")},_destroy:function(){this.selectees.removeClass("ui-selectee").removeData("selectable-item"),this.element.removeClass("ui-selectable ui-selectable-disabled"),this._mouseDestroy()},_mouseStart:function(e){var i=this,s=this.options;this.opos=[e.pageX,e.pageY],this.options.disabled||(this.selectees=t(s.filter,this.element[0]),this._trigger("start",e),t(s.appendTo).append(this.helper),this.helper.css({left:e.pageX,top:e.pageY,width:0,height:0}),s.autoRefresh&&this.refresh(),this.selectees.filter(".ui-selected").each(function(){var s=t.data(this,"selectable-item");s.startselected=!0,e.metaKey||e.ctrlKey||(s.$element.removeClass("ui-selected"),s.selected=!1,s.$element.addClass("ui-unselecting"),s.unselecting=!0,i._trigger("unselecting",e,{unselecting:s.element}))}),t(e.target).parents().addBack().each(function(){var s,n=t.data(this,"selectable-item");return n?(s=!e.metaKey&&!e.ctrlKey||!n.$element.hasClass("ui-selected"),n.$element.removeClass(s?"ui-unselecting":"ui-selected").addClass(s?"ui-selecting":"ui-unselecting"),n.unselecting=!s,n.selecting=s,n.selected=s,s?i._trigger("selecting",e,{selecting:n.element}):i._trigger("unselecting",e,{unselecting:n.element}),!1):undefined}))},_mouseDrag:function(e){if(this.dragged=!0,!this.options.disabled){var i,s=this,n=this.options,a=this.opos[0],o=this.opos[1],r=e.pageX,l=e.pageY;return a>r&&(i=r,r=a,a=i),o>l&&(i=l,l=o,o=i),this.helper.css({left:a,top:o,width:r-a,height:l-o}),this.selectees.each(function(){var i=t.data(this,"selectable-item"),h=!1;i&&i.element!==s.element[0]&&("touch"===n.tolerance?h=!(i.left>r||a>i.right||i.top>l||o>i.bottom):"fit"===n.tolerance&&(h=i.left>a&&r>i.right&&i.top>o&&l>i.bottom),h?(i.selected&&(i.$element.removeClass("ui-selected"),i.selected=!1),i.unselecting&&(i.$element.removeClass("ui-unselecting"),i.unselecting=!1),i.selecting||(i.$element.addClass("ui-selecting"),i.selecting=!0,s._trigger("selecting",e,{selecting:i.element}))):(i.selecting&&((e.metaKey||e.ctrlKey)&&i.startselected?(i.$element.removeClass("ui-selecting"),i.selecting=!1,i.$element.addClass("ui-selected"),i.selected=!0):(i.$element.removeClass("ui-selecting"),i.selecting=!1,i.startselected&&(i.$element.addClass("ui-unselecting"),i.unselecting=!0),s._trigger("unselecting",e,{unselecting:i.element}))),i.selected&&(e.metaKey||e.ctrlKey||i.startselected||(i.$element.removeClass("ui-selected"),i.selected=!1,i.$element.addClass("ui-unselecting"),i.unselecting=!0,s._trigger("unselecting",e,{unselecting:i.element})))))}),!1}},_mouseStop:function(e){var i=this;return this.dragged=!1,t(".ui-unselecting",this.element[0]).each(function(){var s=t.data(this,"selectable-item");s.$element.removeClass("ui-unselecting"),s.unselecting=!1,s.startselected=!1,i._trigger("unselected",e,{unselected:s.element})}),t(".ui-selecting",this.element[0]).each(function(){var s=t.data(this,"selectable-item");s.$element.removeClass("ui-selecting").addClass("ui-selected"),s.selecting=!1,s.selected=!0,s.startselected=!0,i._trigger("selected",e,{selected:s.element})}),this._trigger("stop",e),this.helper.remove(),!1}})})(jQuery);(function(t){function e(t,e,i){return t>e&&e+i>t}function i(t){return/left|right/.test(t.css("float"))||/inline|table-cell/.test(t.css("display"))}t.widget("ui.sortable",t.ui.mouse,{version:"1.10.4",widgetEventPrefix:"sort",ready:!1,options:{appendTo:"parent",axis:!1,connectWith:!1,containment:!1,cursor:"auto",cursorAt:!1,dropOnEmpty:!0,forcePlaceholderSize:!1,forceHelperSize:!1,grid:!1,handle:!1,helper:"original",items:"> *",opacity:!1,placeholder:!1,revert:!1,scroll:!0,scrollSensitivity:20,scrollSpeed:20,scope:"default",tolerance:"intersect",zIndex:1e3,activate:null,beforeStop:null,change:null,deactivate:null,out:null,over:null,receive:null,remove:null,sort:null,start:null,stop:null,update:null},_create:function(){var t=this.options;this.containerCache={},this.element.addClass("ui-sortable"),this.refresh(),this.floating=this.items.length?"x"===t.axis||i(this.items[0].item):!1,this.offset=this.element.offset(),this._mouseInit(),this.ready=!0},_destroy:function(){this.element.removeClass("ui-sortable ui-sortable-disabled"),this._mouseDestroy();for(var t=this.items.length-1;t>=0;t--)this.items[t].item.removeData(this.widgetName+"-item");return this},_setOption:function(e,i){"disabled"===e?(this.options[e]=i,this.widget().toggleClass("ui-sortable-disabled",!!i)):t.Widget.prototype._setOption.apply(this,arguments)},_mouseCapture:function(e,i){var s=null,n=!1,o=this;return this.reverting?!1:this.options.disabled||"static"===this.options.type?!1:(this._refreshItems(e),t(e.target).parents().each(function(){return t.data(this,o.widgetName+"-item")===o?(s=t(this),!1):undefined}),t.data(e.target,o.widgetName+"-item")===o&&(s=t(e.target)),s?!this.options.handle||i||(t(this.options.handle,s).find("*").addBack().each(function(){this===e.target&&(n=!0)}),n)?(this.currentItem=s,this._removeCurrentsFromItems(),!0):!1:!1)},_mouseStart:function(e,i,s){var n,o,a=this.options;if(this.currentContainer=this,this.refreshPositions(),this.helper=this._createHelper(e),this._cacheHelperProportions(),this._cacheMargins(),this.scrollParent=this.helper.scrollParent(),this.offset=this.currentItem.offset(),this.offset={top:this.offset.top-this.margins.top,left:this.offset.left-this.margins.left},t.extend(this.offset,{click:{left:e.pageX-this.offset.left,top:e.pageY-this.offset.top},parent:this._getParentOffset(),relative:this._getRelativeOffset()}),this.helper.css("position","absolute"),this.cssPosition=this.helper.css("position"),this.originalPosition=this._generatePosition(e),this.originalPageX=e.pageX,this.originalPageY=e.pageY,a.cursorAt&&this._adjustOffsetFromHelper(a.cursorAt),this.domPosition={prev:this.currentItem.prev()[0],parent:this.currentItem.parent()[0]},this.helper[0]!==this.currentItem[0]&&this.currentItem.hide(),this._createPlaceholder(),a.containment&&this._setContainment(),a.cursor&&"auto"!==a.cursor&&(o=this.document.find("body"),this.storedCursor=o.css("cursor"),o.css("cursor",a.cursor),this.storedStylesheet=t("<style>*{ cursor: "+a.cursor+" !important; }</style>").appendTo(o)),a.opacity&&(this.helper.css("opacity")&&(this._storedOpacity=this.helper.css("opacity")),this.helper.css("opacity",a.opacity)),a.zIndex&&(this.helper.css("zIndex")&&(this._storedZIndex=this.helper.css("zIndex")),this.helper.css("zIndex",a.zIndex)),this.scrollParent[0]!==document&&"HTML"!==this.scrollParent[0].tagName&&(this.overflowOffset=this.scrollParent.offset()),this._trigger("start",e,this._uiHash()),this._preserveHelperProportions||this._cacheHelperProportions(),!s)for(n=this.containers.length-1;n>=0;n--)this.containers[n]._trigger("activate",e,this._uiHash(this));return t.ui.ddmanager&&(t.ui.ddmanager.current=this),t.ui.ddmanager&&!a.dropBehaviour&&t.ui.ddmanager.prepareOffsets(this,e),this.dragging=!0,this.helper.addClass("ui-sortable-helper"),this._mouseDrag(e),!0},_mouseDrag:function(e){var i,s,n,o,a=this.options,r=!1;for(this.position=this._generatePosition(e),this.positionAbs=this._convertPositionTo("absolute"),this.lastPositionAbs||(this.lastPositionAbs=this.positionAbs),this.options.scroll&&(this.scrollParent[0]!==document&&"HTML"!==this.scrollParent[0].tagName?(this.overflowOffset.top+this.scrollParent[0].offsetHeight-e.pageY<a.scrollSensitivity?this.scrollParent[0].scrollTop=r=this.scrollParent[0].scrollTop+a.scrollSpeed:e.pageY-this.overflowOffset.top<a.scrollSensitivity&&(this.scrollParent[0].scrollTop=r=this.scrollParent[0].scrollTop-a.scrollSpeed),this.overflowOffset.left+this.scrollParent[0].offsetWidth-e.pageX<a.scrollSensitivity?this.scrollParent[0].scrollLeft=r=this.scrollParent[0].scrollLeft+a.scrollSpeed:e.pageX-this.overflowOffset.left<a.scrollSensitivity&&(this.scrollParent[0].scrollLeft=r=this.scrollParent[0].scrollLeft-a.scrollSpeed)):(e.pageY-t(document).scrollTop()<a.scrollSensitivity?r=t(document).scrollTop(t(document).scrollTop()-a.scrollSpeed):t(window).height()-(e.pageY-t(document).scrollTop())<a.scrollSensitivity&&(r=t(document).scrollTop(t(document).scrollTop()+a.scrollSpeed)),e.pageX-t(document).scrollLeft()<a.scrollSensitivity?r=t(document).scrollLeft(t(document).scrollLeft()-a.scrollSpeed):t(window).width()-(e.pageX-t(document).scrollLeft())<a.scrollSensitivity&&(r=t(document).scrollLeft(t(document).scrollLeft()+a.scrollSpeed))),r!==!1&&t.ui.ddmanager&&!a.dropBehaviour&&t.ui.ddmanager.prepareOffsets(this,e)),this.positionAbs=this._convertPositionTo("absolute"),this.options.axis&&"y"===this.options.axis||(this.helper[0].style.left=this.position.left+"px"),this.options.axis&&"x"===this.options.axis||(this.helper[0].style.top=this.position.top+"px"),i=this.items.length-1;i>=0;i--)if(s=this.items[i],n=s.item[0],o=this._intersectsWithPointer(s),o&&s.instance===this.currentContainer&&n!==this.currentItem[0]&&this.placeholder[1===o?"next":"prev"]()[0]!==n&&!t.contains(this.placeholder[0],n)&&("semi-dynamic"===this.options.type?!t.contains(this.element[0],n):!0)){if(this.direction=1===o?"down":"up","pointer"!==this.options.tolerance&&!this._intersectsWithSides(s))break;this._rearrange(e,s),this._trigger("change",e,this._uiHash());break}return this._contactContainers(e),t.ui.ddmanager&&t.ui.ddmanager.drag(this,e),this._trigger("sort",e,this._uiHash()),this.lastPositionAbs=this.positionAbs,!1},_mouseStop:function(e,i){if(e){if(t.ui.ddmanager&&!this.options.dropBehaviour&&t.ui.ddmanager.drop(this,e),this.options.revert){var s=this,n=this.placeholder.offset(),o=this.options.axis,a={};o&&"x"!==o||(a.left=n.left-this.offset.parent.left-this.margins.left+(this.offsetParent[0]===document.body?0:this.offsetParent[0].scrollLeft)),o&&"y"!==o||(a.top=n.top-this.offset.parent.top-this.margins.top+(this.offsetParent[0]===document.body?0:this.offsetParent[0].scrollTop)),this.reverting=!0,t(this.helper).animate(a,parseInt(this.options.revert,10)||500,function(){s._clear(e)})}else this._clear(e,i);return!1}},cancel:function(){if(this.dragging){this._mouseUp({target:null}),"original"===this.options.helper?this.currentItem.css(this._storedCSS).removeClass("ui-sortable-helper"):this.currentItem.show();for(var e=this.containers.length-1;e>=0;e--)this.containers[e]._trigger("deactivate",null,this._uiHash(this)),this.containers[e].containerCache.over&&(this.containers[e]._trigger("out",null,this._uiHash(this)),this.containers[e].containerCache.over=0)}return this.placeholder&&(this.placeholder[0].parentNode&&this.placeholder[0].parentNode.removeChild(this.placeholder[0]),"original"!==this.options.helper&&this.helper&&this.helper[0].parentNode&&this.helper.remove(),t.extend(this,{helper:null,dragging:!1,reverting:!1,_noFinalSort:null}),this.domPosition.prev?t(this.domPosition.prev).after(this.currentItem):t(this.domPosition.parent).prepend(this.currentItem)),this},serialize:function(e){var i=this._getItemsAsjQuery(e&&e.connected),s=[];return e=e||{},t(i).each(function(){var i=(t(e.item||this).attr(e.attribute||"id")||"").match(e.expression||/(.+)[\-=_](.+)/);i&&s.push((e.key||i[1]+"[]")+"="+(e.key&&e.expression?i[1]:i[2]))}),!s.length&&e.key&&s.push(e.key+"="),s.join("&")},toArray:function(e){var i=this._getItemsAsjQuery(e&&e.connected),s=[];return e=e||{},i.each(function(){s.push(t(e.item||this).attr(e.attribute||"id")||"")}),s},_intersectsWith:function(t){var e=this.positionAbs.left,i=e+this.helperProportions.width,s=this.positionAbs.top,n=s+this.helperProportions.height,o=t.left,a=o+t.width,r=t.top,h=r+t.height,l=this.offset.click.top,c=this.offset.click.left,u="x"===this.options.axis||s+l>r&&h>s+l,d="y"===this.options.axis||e+c>o&&a>e+c,p=u&&d;return"pointer"===this.options.tolerance||this.options.forcePointerForContainers||"pointer"!==this.options.tolerance&&this.helperProportions[this.floating?"width":"height"]>t[this.floating?"width":"height"]?p:e+this.helperProportions.width/2>o&&a>i-this.helperProportions.width/2&&s+this.helperProportions.height/2>r&&h>n-this.helperProportions.height/2},_intersectsWithPointer:function(t){var i="x"===this.options.axis||e(this.positionAbs.top+this.offset.click.top,t.top,t.height),s="y"===this.options.axis||e(this.positionAbs.left+this.offset.click.left,t.left,t.width),n=i&&s,o=this._getDragVerticalDirection(),a=this._getDragHorizontalDirection();return n?this.floating?a&&"right"===a||"down"===o?2:1:o&&("down"===o?2:1):!1},_intersectsWithSides:function(t){var i=e(this.positionAbs.top+this.offset.click.top,t.top+t.height/2,t.height),s=e(this.positionAbs.left+this.offset.click.left,t.left+t.width/2,t.width),n=this._getDragVerticalDirection(),o=this._getDragHorizontalDirection();return this.floating&&o?"right"===o&&s||"left"===o&&!s:n&&("down"===n&&i||"up"===n&&!i)},_getDragVerticalDirection:function(){var t=this.positionAbs.top-this.lastPositionAbs.top;return 0!==t&&(t>0?"down":"up")},_getDragHorizontalDirection:function(){var t=this.positionAbs.left-this.lastPositionAbs.left;return 0!==t&&(t>0?"right":"left")},refresh:function(t){return this._refreshItems(t),this.refreshPositions(),this},_connectWith:function(){var t=this.options;return t.connectWith.constructor===String?[t.connectWith]:t.connectWith},_getItemsAsjQuery:function(e){function i(){r.push(this)}var s,n,o,a,r=[],h=[],l=this._connectWith();if(l&&e)for(s=l.length-1;s>=0;s--)for(o=t(l[s]),n=o.length-1;n>=0;n--)a=t.data(o[n],this.widgetFullName),a&&a!==this&&!a.options.disabled&&h.push([t.isFunction(a.options.items)?a.options.items.call(a.element):t(a.options.items,a.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"),a]);for(h.push([t.isFunction(this.options.items)?this.options.items.call(this.element,null,{options:this.options,item:this.currentItem}):t(this.options.items,this.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"),this]),s=h.length-1;s>=0;s--)h[s][0].each(i);return t(r)},_removeCurrentsFromItems:function(){var e=this.currentItem.find(":data("+this.widgetName+"-item)");this.items=t.grep(this.items,function(t){for(var i=0;e.length>i;i++)if(e[i]===t.item[0])return!1;return!0})},_refreshItems:function(e){this.items=[],this.containers=[this];var i,s,n,o,a,r,h,l,c=this.items,u=[[t.isFunction(this.options.items)?this.options.items.call(this.element[0],e,{item:this.currentItem}):t(this.options.items,this.element),this]],d=this._connectWith();if(d&&this.ready)for(i=d.length-1;i>=0;i--)for(n=t(d[i]),s=n.length-1;s>=0;s--)o=t.data(n[s],this.widgetFullName),o&&o!==this&&!o.options.disabled&&(u.push([t.isFunction(o.options.items)?o.options.items.call(o.element[0],e,{item:this.currentItem}):t(o.options.items,o.element),o]),this.containers.push(o));for(i=u.length-1;i>=0;i--)for(a=u[i][1],r=u[i][0],s=0,l=r.length;l>s;s++)h=t(r[s]),h.data(this.widgetName+"-item",a),c.push({item:h,instance:a,width:0,height:0,left:0,top:0})},refreshPositions:function(e){this.offsetParent&&this.helper&&(this.offset.parent=this._getParentOffset());var i,s,n,o;for(i=this.items.length-1;i>=0;i--)s=this.items[i],s.instance!==this.currentContainer&&this.currentContainer&&s.item[0]!==this.currentItem[0]||(n=this.options.toleranceElement?t(this.options.toleranceElement,s.item):s.item,e||(s.width=n.outerWidth(),s.height=n.outerHeight()),o=n.offset(),s.left=o.left,s.top=o.top);if(this.options.custom&&this.options.custom.refreshContainers)this.options.custom.refreshContainers.call(this);else for(i=this.containers.length-1;i>=0;i--)o=this.containers[i].element.offset(),this.containers[i].containerCache.left=o.left,this.containers[i].containerCache.top=o.top,this.containers[i].containerCache.width=this.containers[i].element.outerWidth(),this.containers[i].containerCache.height=this.containers[i].element.outerHeight();return this},_createPlaceholder:function(e){e=e||this;var i,s=e.options;s.placeholder&&s.placeholder.constructor!==String||(i=s.placeholder,s.placeholder={element:function(){var s=e.currentItem[0].nodeName.toLowerCase(),n=t("<"+s+">",e.document[0]).addClass(i||e.currentItem[0].className+" ui-sortable-placeholder").removeClass("ui-sortable-helper");return"tr"===s?e.currentItem.children().each(function(){t("<td>&#160;</td>",e.document[0]).attr("colspan",t(this).attr("colspan")||1).appendTo(n)}):"img"===s&&n.attr("src",e.currentItem.attr("src")),i||n.css("visibility","hidden"),n},update:function(t,n){(!i||s.forcePlaceholderSize)&&(n.height()||n.height(e.currentItem.innerHeight()-parseInt(e.currentItem.css("paddingTop")||0,10)-parseInt(e.currentItem.css("paddingBottom")||0,10)),n.width()||n.width(e.currentItem.innerWidth()-parseInt(e.currentItem.css("paddingLeft")||0,10)-parseInt(e.currentItem.css("paddingRight")||0,10)))}}),e.placeholder=t(s.placeholder.element.call(e.element,e.currentItem)),e.currentItem.after(e.placeholder),s.placeholder.update(e,e.placeholder)},_contactContainers:function(s){var n,o,a,r,h,l,c,u,d,p,f=null,g=null;for(n=this.containers.length-1;n>=0;n--)if(!t.contains(this.currentItem[0],this.containers[n].element[0]))if(this._intersectsWith(this.containers[n].containerCache)){if(f&&t.contains(this.containers[n].element[0],f.element[0]))continue;f=this.containers[n],g=n}else this.containers[n].containerCache.over&&(this.containers[n]._trigger("out",s,this._uiHash(this)),this.containers[n].containerCache.over=0);if(f)if(1===this.containers.length)this.containers[g].containerCache.over||(this.containers[g]._trigger("over",s,this._uiHash(this)),this.containers[g].containerCache.over=1);else{for(a=1e4,r=null,p=f.floating||i(this.currentItem),h=p?"left":"top",l=p?"width":"height",c=this.positionAbs[h]+this.offset.click[h],o=this.items.length-1;o>=0;o--)t.contains(this.containers[g].element[0],this.items[o].item[0])&&this.items[o].item[0]!==this.currentItem[0]&&(!p||e(this.positionAbs.top+this.offset.click.top,this.items[o].top,this.items[o].height))&&(u=this.items[o].item.offset()[h],d=!1,Math.abs(u-c)>Math.abs(u+this.items[o][l]-c)&&(d=!0,u+=this.items[o][l]),a>Math.abs(u-c)&&(a=Math.abs(u-c),r=this.items[o],this.direction=d?"up":"down"));if(!r&&!this.options.dropOnEmpty)return;if(this.currentContainer===this.containers[g])return;r?this._rearrange(s,r,null,!0):this._rearrange(s,null,this.containers[g].element,!0),this._trigger("change",s,this._uiHash()),this.containers[g]._trigger("change",s,this._uiHash(this)),this.currentContainer=this.containers[g],this.options.placeholder.update(this.currentContainer,this.placeholder),this.containers[g]._trigger("over",s,this._uiHash(this)),this.containers[g].containerCache.over=1}},_createHelper:function(e){var i=this.options,s=t.isFunction(i.helper)?t(i.helper.apply(this.element[0],[e,this.currentItem])):"clone"===i.helper?this.currentItem.clone():this.currentItem;return s.parents("body").length||t("parent"!==i.appendTo?i.appendTo:this.currentItem[0].parentNode)[0].appendChild(s[0]),s[0]===this.currentItem[0]&&(this._storedCSS={width:this.currentItem[0].style.width,height:this.currentItem[0].style.height,position:this.currentItem.css("position"),top:this.currentItem.css("top"),left:this.currentItem.css("left")}),(!s[0].style.width||i.forceHelperSize)&&s.width(this.currentItem.width()),(!s[0].style.height||i.forceHelperSize)&&s.height(this.currentItem.height()),s},_adjustOffsetFromHelper:function(e){"string"==typeof e&&(e=e.split(" ")),t.isArray(e)&&(e={left:+e[0],top:+e[1]||0}),"left"in e&&(this.offset.click.left=e.left+this.margins.left),"right"in e&&(this.offset.click.left=this.helperProportions.width-e.right+this.margins.left),"top"in e&&(this.offset.click.top=e.top+this.margins.top),"bottom"in e&&(this.offset.click.top=this.helperProportions.height-e.bottom+this.margins.top)},_getParentOffset:function(){this.offsetParent=this.helper.offsetParent();var e=this.offsetParent.offset();return"absolute"===this.cssPosition&&this.scrollParent[0]!==document&&t.contains(this.scrollParent[0],this.offsetParent[0])&&(e.left+=this.scrollParent.scrollLeft(),e.top+=this.scrollParent.scrollTop()),(this.offsetParent[0]===document.body||this.offsetParent[0].tagName&&"html"===this.offsetParent[0].tagName.toLowerCase()&&t.ui.ie)&&(e={top:0,left:0}),{top:e.top+(parseInt(this.offsetParent.css("borderTopWidth"),10)||0),left:e.left+(parseInt(this.offsetParent.css("borderLeftWidth"),10)||0)}},_getRelativeOffset:function(){if("relative"===this.cssPosition){var t=this.currentItem.position();return{top:t.top-(parseInt(this.helper.css("top"),10)||0)+this.scrollParent.scrollTop(),left:t.left-(parseInt(this.helper.css("left"),10)||0)+this.scrollParent.scrollLeft()}}return{top:0,left:0}},_cacheMargins:function(){this.margins={left:parseInt(this.currentItem.css("marginLeft"),10)||0,top:parseInt(this.currentItem.css("marginTop"),10)||0}},_cacheHelperProportions:function(){this.helperProportions={width:this.helper.outerWidth(),height:this.helper.outerHeight()}},_setContainment:function(){var e,i,s,n=this.options;"parent"===n.containment&&(n.containment=this.helper[0].parentNode),("document"===n.containment||"window"===n.containment)&&(this.containment=[0-this.offset.relative.left-this.offset.parent.left,0-this.offset.relative.top-this.offset.parent.top,t("document"===n.containment?document:window).width()-this.helperProportions.width-this.margins.left,(t("document"===n.containment?document:window).height()||document.body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top]),/^(document|window|parent)$/.test(n.containment)||(e=t(n.containment)[0],i=t(n.containment).offset(),s="hidden"!==t(e).css("overflow"),this.containment=[i.left+(parseInt(t(e).css("borderLeftWidth"),10)||0)+(parseInt(t(e).css("paddingLeft"),10)||0)-this.margins.left,i.top+(parseInt(t(e).css("borderTopWidth"),10)||0)+(parseInt(t(e).css("paddingTop"),10)||0)-this.margins.top,i.left+(s?Math.max(e.scrollWidth,e.offsetWidth):e.offsetWidth)-(parseInt(t(e).css("borderLeftWidth"),10)||0)-(parseInt(t(e).css("paddingRight"),10)||0)-this.helperProportions.width-this.margins.left,i.top+(s?Math.max(e.scrollHeight,e.offsetHeight):e.offsetHeight)-(parseInt(t(e).css("borderTopWidth"),10)||0)-(parseInt(t(e).css("paddingBottom"),10)||0)-this.helperProportions.height-this.margins.top])},_convertPositionTo:function(e,i){i||(i=this.position);var s="absolute"===e?1:-1,n="absolute"!==this.cssPosition||this.scrollParent[0]!==document&&t.contains(this.scrollParent[0],this.offsetParent[0])?this.scrollParent:this.offsetParent,o=/(html|body)/i.test(n[0].tagName);return{top:i.top+this.offset.relative.top*s+this.offset.parent.top*s-("fixed"===this.cssPosition?-this.scrollParent.scrollTop():o?0:n.scrollTop())*s,left:i.left+this.offset.relative.left*s+this.offset.parent.left*s-("fixed"===this.cssPosition?-this.scrollParent.scrollLeft():o?0:n.scrollLeft())*s}},_generatePosition:function(e){var i,s,n=this.options,o=e.pageX,a=e.pageY,r="absolute"!==this.cssPosition||this.scrollParent[0]!==document&&t.contains(this.scrollParent[0],this.offsetParent[0])?this.scrollParent:this.offsetParent,h=/(html|body)/i.test(r[0].tagName);return"relative"!==this.cssPosition||this.scrollParent[0]!==document&&this.scrollParent[0]!==this.offsetParent[0]||(this.offset.relative=this._getRelativeOffset()),this.originalPosition&&(this.containment&&(e.pageX-this.offset.click.left<this.containment[0]&&(o=this.containment[0]+this.offset.click.left),e.pageY-this.offset.click.top<this.containment[1]&&(a=this.containment[1]+this.offset.click.top),e.pageX-this.offset.click.left>this.containment[2]&&(o=this.containment[2]+this.offset.click.left),e.pageY-this.offset.click.top>this.containment[3]&&(a=this.containment[3]+this.offset.click.top)),n.grid&&(i=this.originalPageY+Math.round((a-this.originalPageY)/n.grid[1])*n.grid[1],a=this.containment?i-this.offset.click.top>=this.containment[1]&&i-this.offset.click.top<=this.containment[3]?i:i-this.offset.click.top>=this.containment[1]?i-n.grid[1]:i+n.grid[1]:i,s=this.originalPageX+Math.round((o-this.originalPageX)/n.grid[0])*n.grid[0],o=this.containment?s-this.offset.click.left>=this.containment[0]&&s-this.offset.click.left<=this.containment[2]?s:s-this.offset.click.left>=this.containment[0]?s-n.grid[0]:s+n.grid[0]:s)),{top:a-this.offset.click.top-this.offset.relative.top-this.offset.parent.top+("fixed"===this.cssPosition?-this.scrollParent.scrollTop():h?0:r.scrollTop()),left:o-this.offset.click.left-this.offset.relative.left-this.offset.parent.left+("fixed"===this.cssPosition?-this.scrollParent.scrollLeft():h?0:r.scrollLeft())}},_rearrange:function(t,e,i,s){i?i[0].appendChild(this.placeholder[0]):e.item[0].parentNode.insertBefore(this.placeholder[0],"down"===this.direction?e.item[0]:e.item[0].nextSibling),this.counter=this.counter?++this.counter:1;var n=this.counter;this._delay(function(){n===this.counter&&this.refreshPositions(!s)})},_clear:function(t,e){function i(t,e,i){return function(s){i._trigger(t,s,e._uiHash(e))}}this.reverting=!1;var s,n=[];if(!this._noFinalSort&&this.currentItem.parent().length&&this.placeholder.before(this.currentItem),this._noFinalSort=null,this.helper[0]===this.currentItem[0]){for(s in this._storedCSS)("auto"===this._storedCSS[s]||"static"===this._storedCSS[s])&&(this._storedCSS[s]="");this.currentItem.css(this._storedCSS).removeClass("ui-sortable-helper")}else this.currentItem.show();for(this.fromOutside&&!e&&n.push(function(t){this._trigger("receive",t,this._uiHash(this.fromOutside))}),!this.fromOutside&&this.domPosition.prev===this.currentItem.prev().not(".ui-sortable-helper")[0]&&this.domPosition.parent===this.currentItem.parent()[0]||e||n.push(function(t){this._trigger("update",t,this._uiHash())}),this!==this.currentContainer&&(e||(n.push(function(t){this._trigger("remove",t,this._uiHash())}),n.push(function(t){return function(e){t._trigger("receive",e,this._uiHash(this))}}.call(this,this.currentContainer)),n.push(function(t){return function(e){t._trigger("update",e,this._uiHash(this))}}.call(this,this.currentContainer)))),s=this.containers.length-1;s>=0;s--)e||n.push(i("deactivate",this,this.containers[s])),this.containers[s].containerCache.over&&(n.push(i("out",this,this.containers[s])),this.containers[s].containerCache.over=0);if(this.storedCursor&&(this.document.find("body").css("cursor",this.storedCursor),this.storedStylesheet.remove()),this._storedOpacity&&this.helper.css("opacity",this._storedOpacity),this._storedZIndex&&this.helper.css("zIndex","auto"===this._storedZIndex?"":this._storedZIndex),this.dragging=!1,this.cancelHelperRemoval){if(!e){for(this._trigger("beforeStop",t,this._uiHash()),s=0;n.length>s;s++)n[s].call(this,t);this._trigger("stop",t,this._uiHash())}return this.fromOutside=!1,!1}if(e||this._trigger("beforeStop",t,this._uiHash()),this.placeholder[0].parentNode.removeChild(this.placeholder[0]),this.helper[0]!==this.currentItem[0]&&this.helper.remove(),this.helper=null,!e){for(s=0;n.length>s;s++)n[s].call(this,t);this._trigger("stop",t,this._uiHash())}return this.fromOutside=!1,!0},_trigger:function(){t.Widget.prototype._trigger.apply(this,arguments)===!1&&this.cancel()},_uiHash:function(e){var i=e||this;return{helper:i.helper,placeholder:i.placeholder||t([]),position:i.position,originalPosition:i.originalPosition,offset:i.positionAbs,item:i.currentItem,sender:e?e.element:null}}})})(jQuery);(function(e){var t=0,i={},a={};i.height=i.paddingTop=i.paddingBottom=i.borderTopWidth=i.borderBottomWidth="hide",a.height=a.paddingTop=a.paddingBottom=a.borderTopWidth=a.borderBottomWidth="show",e.widget("ui.accordion",{version:"1.10.4",options:{active:0,animate:{},collapsible:!1,event:"click",header:"> li > :first-child,> :not(li):even",heightStyle:"auto",icons:{activeHeader:"ui-icon-triangle-1-s",header:"ui-icon-triangle-1-e"},activate:null,beforeActivate:null},_create:function(){var t=this.options;this.prevShow=this.prevHide=e(),this.element.addClass("ui-accordion ui-widget ui-helper-reset").attr("role","tablist"),t.collapsible||t.active!==!1&&null!=t.active||(t.active=0),this._processPanels(),0>t.active&&(t.active+=this.headers.length),this._refresh()},_getCreateEventData:function(){return{header:this.active,panel:this.active.length?this.active.next():e(),content:this.active.length?this.active.next():e()}},_createIcons:function(){var t=this.options.icons;t&&(e("<span>").addClass("ui-accordion-header-icon ui-icon "+t.header).prependTo(this.headers),this.active.children(".ui-accordion-header-icon").removeClass(t.header).addClass(t.activeHeader),this.headers.addClass("ui-accordion-icons"))},_destroyIcons:function(){this.headers.removeClass("ui-accordion-icons").children(".ui-accordion-header-icon").remove()},_destroy:function(){var e;this.element.removeClass("ui-accordion ui-widget ui-helper-reset").removeAttr("role"),this.headers.removeClass("ui-accordion-header ui-accordion-header-active ui-helper-reset ui-state-default ui-corner-all ui-state-active ui-state-disabled ui-corner-top").removeAttr("role").removeAttr("aria-expanded").removeAttr("aria-selected").removeAttr("aria-controls").removeAttr("tabIndex").each(function(){/^ui-accordion/.test(this.id)&&this.removeAttribute("id")}),this._destroyIcons(),e=this.headers.next().css("display","").removeAttr("role").removeAttr("aria-hidden").removeAttr("aria-labelledby").removeClass("ui-helper-reset ui-widget-content ui-corner-bottom ui-accordion-content ui-accordion-content-active ui-state-disabled").each(function(){/^ui-accordion/.test(this.id)&&this.removeAttribute("id")}),"content"!==this.options.heightStyle&&e.css("height","")},_setOption:function(e,t){return"active"===e?(this._activate(t),undefined):("event"===e&&(this.options.event&&this._off(this.headers,this.options.event),this._setupEvents(t)),this._super(e,t),"collapsible"!==e||t||this.options.active!==!1||this._activate(0),"icons"===e&&(this._destroyIcons(),t&&this._createIcons()),"disabled"===e&&this.headers.add(this.headers.next()).toggleClass("ui-state-disabled",!!t),undefined)},_keydown:function(t){if(!t.altKey&&!t.ctrlKey){var i=e.ui.keyCode,a=this.headers.length,s=this.headers.index(t.target),n=!1;switch(t.keyCode){case i.RIGHT:case i.DOWN:n=this.headers[(s+1)%a];break;case i.LEFT:case i.UP:n=this.headers[(s-1+a)%a];break;case i.SPACE:case i.ENTER:this._eventHandler(t);break;case i.HOME:n=this.headers[0];break;case i.END:n=this.headers[a-1]}n&&(e(t.target).attr("tabIndex",-1),e(n).attr("tabIndex",0),n.focus(),t.preventDefault())}},_panelKeyDown:function(t){t.keyCode===e.ui.keyCode.UP&&t.ctrlKey&&e(t.currentTarget).prev().focus()},refresh:function(){var t=this.options;this._processPanels(),t.active===!1&&t.collapsible===!0||!this.headers.length?(t.active=!1,this.active=e()):t.active===!1?this._activate(0):this.active.length&&!e.contains(this.element[0],this.active[0])?this.headers.length===this.headers.find(".ui-state-disabled").length?(t.active=!1,this.active=e()):this._activate(Math.max(0,t.active-1)):t.active=this.headers.index(this.active),this._destroyIcons(),this._refresh()},_processPanels:function(){this.headers=this.element.find(this.options.header).addClass("ui-accordion-header ui-helper-reset ui-state-default ui-corner-all"),this.headers.next().addClass("ui-accordion-content ui-helper-reset ui-widget-content ui-corner-bottom").filter(":not(.ui-accordion-content-active)").hide()},_refresh:function(){var i,a=this.options,s=a.heightStyle,n=this.element.parent(),r=this.accordionId="ui-accordion-"+(this.element.attr("id")||++t);this.active=this._findActive(a.active).addClass("ui-accordion-header-active ui-state-active ui-corner-top").removeClass("ui-corner-all"),this.active.next().addClass("ui-accordion-content-active").show(),this.headers.attr("role","tab").each(function(t){var i=e(this),a=i.attr("id"),s=i.next(),n=s.attr("id");a||(a=r+"-header-"+t,i.attr("id",a)),n||(n=r+"-panel-"+t,s.attr("id",n)),i.attr("aria-controls",n),s.attr("aria-labelledby",a)}).next().attr("role","tabpanel"),this.headers.not(this.active).attr({"aria-selected":"false","aria-expanded":"false",tabIndex:-1}).next().attr({"aria-hidden":"true"}).hide(),this.active.length?this.active.attr({"aria-selected":"true","aria-expanded":"true",tabIndex:0}).next().attr({"aria-hidden":"false"}):this.headers.eq(0).attr("tabIndex",0),this._createIcons(),this._setupEvents(a.event),"fill"===s?(i=n.height(),this.element.siblings(":visible").each(function(){var t=e(this),a=t.css("position");"absolute"!==a&&"fixed"!==a&&(i-=t.outerHeight(!0))}),this.headers.each(function(){i-=e(this).outerHeight(!0)}),this.headers.next().each(function(){e(this).height(Math.max(0,i-e(this).innerHeight()+e(this).height()))}).css("overflow","auto")):"auto"===s&&(i=0,this.headers.next().each(function(){i=Math.max(i,e(this).css("height","").height())}).height(i))},_activate:function(t){var i=this._findActive(t)[0];i!==this.active[0]&&(i=i||this.active[0],this._eventHandler({target:i,currentTarget:i,preventDefault:e.noop}))},_findActive:function(t){return"number"==typeof t?this.headers.eq(t):e()},_setupEvents:function(t){var i={keydown:"_keydown"};t&&e.each(t.split(" "),function(e,t){i[t]="_eventHandler"}),this._off(this.headers.add(this.headers.next())),this._on(this.headers,i),this._on(this.headers.next(),{keydown:"_panelKeyDown"}),this._hoverable(this.headers),this._focusable(this.headers)},_eventHandler:function(t){var i=this.options,a=this.active,s=e(t.currentTarget),n=s[0]===a[0],r=n&&i.collapsible,o=r?e():s.next(),h=a.next(),d={oldHeader:a,oldPanel:h,newHeader:r?e():s,newPanel:o};t.preventDefault(),n&&!i.collapsible||this._trigger("beforeActivate",t,d)===!1||(i.active=r?!1:this.headers.index(s),this.active=n?e():s,this._toggle(d),a.removeClass("ui-accordion-header-active ui-state-active"),i.icons&&a.children(".ui-accordion-header-icon").removeClass(i.icons.activeHeader).addClass(i.icons.header),n||(s.removeClass("ui-corner-all").addClass("ui-accordion-header-active ui-state-active ui-corner-top"),i.icons&&s.children(".ui-accordion-header-icon").removeClass(i.icons.header).addClass(i.icons.activeHeader),s.next().addClass("ui-accordion-content-active")))},_toggle:function(t){var i=t.newPanel,a=this.prevShow.length?this.prevShow:t.oldPanel;this.prevShow.add(this.prevHide).stop(!0,!0),this.prevShow=i,this.prevHide=a,this.options.animate?this._animate(i,a,t):(a.hide(),i.show(),this._toggleComplete(t)),a.attr({"aria-hidden":"true"}),a.prev().attr("aria-selected","false"),i.length&&a.length?a.prev().attr({tabIndex:-1,"aria-expanded":"false"}):i.length&&this.headers.filter(function(){return 0===e(this).attr("tabIndex")}).attr("tabIndex",-1),i.attr("aria-hidden","false").prev().attr({"aria-selected":"true",tabIndex:0,"aria-expanded":"true"})},_animate:function(e,t,s){var n,r,o,h=this,d=0,c=e.length&&(!t.length||e.index()<t.index()),l=this.options.animate||{},u=c&&l.down||l,v=function(){h._toggleComplete(s)};return"number"==typeof u&&(o=u),"string"==typeof u&&(r=u),r=r||u.easing||l.easing,o=o||u.duration||l.duration,t.length?e.length?(n=e.show().outerHeight(),t.animate(i,{duration:o,easing:r,step:function(e,t){t.now=Math.round(e)}}),e.hide().animate(a,{duration:o,easing:r,complete:v,step:function(e,i){i.now=Math.round(e),"height"!==i.prop?d+=i.now:"content"!==h.options.heightStyle&&(i.now=Math.round(n-t.outerHeight()-d),d=0)}}),undefined):t.animate(i,o,r,v):e.animate(a,o,r,v)},_toggleComplete:function(e){var t=e.oldPanel;t.removeClass("ui-accordion-content-active").prev().removeClass("ui-corner-top").addClass("ui-corner-all"),t.length&&(t.parent()[0].className=t.parent()[0].className),this._trigger("activate",null,e)}})})(jQuery);(function(e){e.widget("ui.autocomplete",{version:"1.10.4",defaultElement:"<input>",options:{appendTo:null,autoFocus:!1,delay:300,minLength:1,position:{my:"left top",at:"left bottom",collision:"none"},source:null,change:null,close:null,focus:null,open:null,response:null,search:null,select:null},requestIndex:0,pending:0,_create:function(){var t,i,s,n=this.element[0].nodeName.toLowerCase(),a="textarea"===n,o="input"===n;this.isMultiLine=a?!0:o?!1:this.element.prop("isContentEditable"),this.valueMethod=this.element[a||o?"val":"text"],this.isNewMenu=!0,this.element.addClass("ui-autocomplete-input").attr("autocomplete","off"),this._on(this.element,{keydown:function(n){if(this.element.prop("readOnly"))return t=!0,s=!0,i=!0,undefined;t=!1,s=!1,i=!1;var a=e.ui.keyCode;switch(n.keyCode){case a.PAGE_UP:t=!0,this._move("previousPage",n);break;case a.PAGE_DOWN:t=!0,this._move("nextPage",n);break;case a.UP:t=!0,this._keyEvent("previous",n);break;case a.DOWN:t=!0,this._keyEvent("next",n);break;case a.ENTER:case a.NUMPAD_ENTER:this.menu.active&&(t=!0,n.preventDefault(),this.menu.select(n));break;case a.TAB:this.menu.active&&this.menu.select(n);break;case a.ESCAPE:this.menu.element.is(":visible")&&(this._value(this.term),this.close(n),n.preventDefault());break;default:i=!0,this._searchTimeout(n)}},keypress:function(s){if(t)return t=!1,(!this.isMultiLine||this.menu.element.is(":visible"))&&s.preventDefault(),undefined;if(!i){var n=e.ui.keyCode;switch(s.keyCode){case n.PAGE_UP:this._move("previousPage",s);break;case n.PAGE_DOWN:this._move("nextPage",s);break;case n.UP:this._keyEvent("previous",s);break;case n.DOWN:this._keyEvent("next",s)}}},input:function(e){return s?(s=!1,e.preventDefault(),undefined):(this._searchTimeout(e),undefined)},focus:function(){this.selectedItem=null,this.previous=this._value()},blur:function(e){return this.cancelBlur?(delete this.cancelBlur,undefined):(clearTimeout(this.searching),this.close(e),this._change(e),undefined)}}),this._initSource(),this.menu=e("<ul>").addClass("ui-autocomplete ui-front").appendTo(this._appendTo()).menu({role:null}).hide().data("ui-menu"),this._on(this.menu.element,{mousedown:function(t){t.preventDefault(),this.cancelBlur=!0,this._delay(function(){delete this.cancelBlur});var i=this.menu.element[0];e(t.target).closest(".ui-menu-item").length||this._delay(function(){var t=this;this.document.one("mousedown",function(s){s.target===t.element[0]||s.target===i||e.contains(i,s.target)||t.close()})})},menufocus:function(t,i){if(this.isNewMenu&&(this.isNewMenu=!1,t.originalEvent&&/^mouse/.test(t.originalEvent.type)))return this.menu.blur(),this.document.one("mousemove",function(){e(t.target).trigger(t.originalEvent)}),undefined;var s=i.item.data("ui-autocomplete-item");!1!==this._trigger("focus",t,{item:s})?t.originalEvent&&/^key/.test(t.originalEvent.type)&&this._value(s.value):this.liveRegion.text(s.value)},menuselect:function(e,t){var i=t.item.data("ui-autocomplete-item"),s=this.previous;this.element[0]!==this.document[0].activeElement&&(this.element.focus(),this.previous=s,this._delay(function(){this.previous=s,this.selectedItem=i})),!1!==this._trigger("select",e,{item:i})&&this._value(i.value),this.term=this._value(),this.close(e),this.selectedItem=i}}),this.liveRegion=e("<span>",{role:"status","aria-live":"polite"}).addClass("ui-helper-hidden-accessible").insertBefore(this.element),this._on(this.window,{beforeunload:function(){this.element.removeAttr("autocomplete")}})},_destroy:function(){clearTimeout(this.searching),this.element.removeClass("ui-autocomplete-input").removeAttr("autocomplete"),this.menu.element.remove(),this.liveRegion.remove()},_setOption:function(e,t){this._super(e,t),"source"===e&&this._initSource(),"appendTo"===e&&this.menu.element.appendTo(this._appendTo()),"disabled"===e&&t&&this.xhr&&this.xhr.abort()},_appendTo:function(){var t=this.options.appendTo;return t&&(t=t.jquery||t.nodeType?e(t):this.document.find(t).eq(0)),t||(t=this.element.closest(".ui-front")),t.length||(t=this.document[0].body),t},_initSource:function(){var t,i,s=this;e.isArray(this.options.source)?(t=this.options.source,this.source=function(i,s){s(e.ui.autocomplete.filter(t,i.term))}):"string"==typeof this.options.source?(i=this.options.source,this.source=function(t,n){s.xhr&&s.xhr.abort(),s.xhr=e.ajax({url:i,data:t,dataType:"json",success:function(e){n(e)},error:function(){n([])}})}):this.source=this.options.source},_searchTimeout:function(e){clearTimeout(this.searching),this.searching=this._delay(function(){this.term!==this._value()&&(this.selectedItem=null,this.search(null,e))},this.options.delay)},search:function(e,t){return e=null!=e?e:this._value(),this.term=this._value(),e.length<this.options.minLength?this.close(t):this._trigger("search",t)!==!1?this._search(e):undefined},_search:function(e){this.pending++,this.element.addClass("ui-autocomplete-loading"),this.cancelSearch=!1,this.source({term:e},this._response())},_response:function(){var t=++this.requestIndex;return e.proxy(function(e){t===this.requestIndex&&this.__response(e),this.pending--,this.pending||this.element.removeClass("ui-autocomplete-loading")},this)},__response:function(e){e&&(e=this._normalize(e)),this._trigger("response",null,{content:e}),!this.options.disabled&&e&&e.length&&!this.cancelSearch?(this._suggest(e),this._trigger("open")):this._close()},close:function(e){this.cancelSearch=!0,this._close(e)},_close:function(e){this.menu.element.is(":visible")&&(this.menu.element.hide(),this.menu.blur(),this.isNewMenu=!0,this._trigger("close",e))},_change:function(e){this.previous!==this._value()&&this._trigger("change",e,{item:this.selectedItem})},_normalize:function(t){return t.length&&t[0].label&&t[0].value?t:e.map(t,function(t){return"string"==typeof t?{label:t,value:t}:e.extend({label:t.label||t.value,value:t.value||t.label},t)})},_suggest:function(t){var i=this.menu.element.empty();this._renderMenu(i,t),this.isNewMenu=!0,this.menu.refresh(),i.show(),this._resizeMenu(),i.position(e.extend({of:this.element},this.options.position)),this.options.autoFocus&&this.menu.next()},_resizeMenu:function(){var e=this.menu.element;e.outerWidth(Math.max(e.width("").outerWidth()+1,this.element.outerWidth()))},_renderMenu:function(t,i){var s=this;e.each(i,function(e,i){s._renderItemData(t,i)})},_renderItemData:function(e,t){return this._renderItem(e,t).data("ui-autocomplete-item",t)},_renderItem:function(t,i){return e("<li>").append(e("<a>").text(i.label)).appendTo(t)},_move:function(e,t){return this.menu.element.is(":visible")?this.menu.isFirstItem()&&/^previous/.test(e)||this.menu.isLastItem()&&/^next/.test(e)?(this._value(this.term),this.menu.blur(),undefined):(this.menu[e](t),undefined):(this.search(null,t),undefined)},widget:function(){return this.menu.element},_value:function(){return this.valueMethod.apply(this.element,arguments)},_keyEvent:function(e,t){(!this.isMultiLine||this.menu.element.is(":visible"))&&(this._move(e,t),t.preventDefault())}}),e.extend(e.ui.autocomplete,{escapeRegex:function(e){return e.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g,"\\$&")},filter:function(t,i){var s=RegExp(e.ui.autocomplete.escapeRegex(i),"i");return e.grep(t,function(e){return s.test(e.label||e.value||e)})}}),e.widget("ui.autocomplete",e.ui.autocomplete,{options:{messages:{noResults:"No search results.",results:function(e){return e+(e>1?" results are":" result is")+" available, use up and down arrow keys to navigate."}}},__response:function(e){var t;this._superApply(arguments),this.options.disabled||this.cancelSearch||(t=e&&e.length?this.options.messages.results(e.length):this.options.messages.noResults,this.liveRegion.text(t))}})})(jQuery);(function(e){var t,i="ui-button ui-widget ui-state-default ui-corner-all",n="ui-button-icons-only ui-button-icon-only ui-button-text-icons ui-button-text-icon-primary ui-button-text-icon-secondary ui-button-text-only",s=function(){var t=e(this);setTimeout(function(){t.find(":ui-button").button("refresh")},1)},a=function(t){var i=t.name,n=t.form,s=e([]);return i&&(i=i.replace(/'/g,"\\'"),s=n?e(n).find("[name='"+i+"']"):e("[name='"+i+"']",t.ownerDocument).filter(function(){return!this.form})),s};e.widget("ui.button",{version:"1.10.4",defaultElement:"<button>",options:{disabled:null,text:!0,label:null,icons:{primary:null,secondary:null}},_create:function(){this.element.closest("form").unbind("reset"+this.eventNamespace).bind("reset"+this.eventNamespace,s),"boolean"!=typeof this.options.disabled?this.options.disabled=!!this.element.prop("disabled"):this.element.prop("disabled",this.options.disabled),this._determineButtonType(),this.hasTitle=!!this.buttonElement.attr("title");var n=this,o=this.options,r="checkbox"===this.type||"radio"===this.type,h=r?"":"ui-state-active";null===o.label&&(o.label="input"===this.type?this.buttonElement.val():this.buttonElement.html()),this._hoverable(this.buttonElement),this.buttonElement.addClass(i).attr("role","button").bind("mouseenter"+this.eventNamespace,function(){o.disabled||this===t&&e(this).addClass("ui-state-active")}).bind("mouseleave"+this.eventNamespace,function(){o.disabled||e(this).removeClass(h)}).bind("click"+this.eventNamespace,function(e){o.disabled&&(e.preventDefault(),e.stopImmediatePropagation())}),this._on({focus:function(){this.buttonElement.addClass("ui-state-focus")},blur:function(){this.buttonElement.removeClass("ui-state-focus")}}),r&&this.element.bind("change"+this.eventNamespace,function(){n.refresh()}),"checkbox"===this.type?this.buttonElement.bind("click"+this.eventNamespace,function(){return o.disabled?!1:undefined}):"radio"===this.type?this.buttonElement.bind("click"+this.eventNamespace,function(){if(o.disabled)return!1;e(this).addClass("ui-state-active"),n.buttonElement.attr("aria-pressed","true");var t=n.element[0];a(t).not(t).map(function(){return e(this).button("widget")[0]}).removeClass("ui-state-active").attr("aria-pressed","false")}):(this.buttonElement.bind("mousedown"+this.eventNamespace,function(){return o.disabled?!1:(e(this).addClass("ui-state-active"),t=this,n.document.one("mouseup",function(){t=null}),undefined)}).bind("mouseup"+this.eventNamespace,function(){return o.disabled?!1:(e(this).removeClass("ui-state-active"),undefined)}).bind("keydown"+this.eventNamespace,function(t){return o.disabled?!1:((t.keyCode===e.ui.keyCode.SPACE||t.keyCode===e.ui.keyCode.ENTER)&&e(this).addClass("ui-state-active"),undefined)}).bind("keyup"+this.eventNamespace+" blur"+this.eventNamespace,function(){e(this).removeClass("ui-state-active")}),this.buttonElement.is("a")&&this.buttonElement.keyup(function(t){t.keyCode===e.ui.keyCode.SPACE&&e(this).click()})),this._setOption("disabled",o.disabled),this._resetButton()},_determineButtonType:function(){var e,t,i;this.type=this.element.is("[type=checkbox]")?"checkbox":this.element.is("[type=radio]")?"radio":this.element.is("input")?"input":"button","checkbox"===this.type||"radio"===this.type?(e=this.element.parents().last(),t="label[for='"+this.element.attr("id")+"']",this.buttonElement=e.find(t),this.buttonElement.length||(e=e.length?e.siblings():this.element.siblings(),this.buttonElement=e.filter(t),this.buttonElement.length||(this.buttonElement=e.find(t))),this.element.addClass("ui-helper-hidden-accessible"),i=this.element.is(":checked"),i&&this.buttonElement.addClass("ui-state-active"),this.buttonElement.prop("aria-pressed",i)):this.buttonElement=this.element},widget:function(){return this.buttonElement},_destroy:function(){this.element.removeClass("ui-helper-hidden-accessible"),this.buttonElement.removeClass(i+" ui-state-active "+n).removeAttr("role").removeAttr("aria-pressed").html(this.buttonElement.find(".ui-button-text").html()),this.hasTitle||this.buttonElement.removeAttr("title")},_setOption:function(e,t){return this._super(e,t),"disabled"===e?(this.element.prop("disabled",!!t),t&&this.buttonElement.removeClass("ui-state-focus"),undefined):(this._resetButton(),undefined)},refresh:function(){var t=this.element.is("input, button")?this.element.is(":disabled"):this.element.hasClass("ui-button-disabled");t!==this.options.disabled&&this._setOption("disabled",t),"radio"===this.type?a(this.element[0]).each(function(){e(this).is(":checked")?e(this).button("widget").addClass("ui-state-active").attr("aria-pressed","true"):e(this).button("widget").removeClass("ui-state-active").attr("aria-pressed","false")}):"checkbox"===this.type&&(this.element.is(":checked")?this.buttonElement.addClass("ui-state-active").attr("aria-pressed","true"):this.buttonElement.removeClass("ui-state-active").attr("aria-pressed","false"))},_resetButton:function(){if("input"===this.type)return this.options.label&&this.element.val(this.options.label),undefined;var t=this.buttonElement.removeClass(n),i=e("<span></span>",this.document[0]).addClass("ui-button-text").html(this.options.label).appendTo(t.empty()).text(),s=this.options.icons,a=s.primary&&s.secondary,o=[];s.primary||s.secondary?(this.options.text&&o.push("ui-button-text-icon"+(a?"s":s.primary?"-primary":"-secondary")),s.primary&&t.prepend("<span class='ui-button-icon-primary ui-icon "+s.primary+"'></span>"),s.secondary&&t.append("<span class='ui-button-icon-secondary ui-icon "+s.secondary+"'></span>"),this.options.text||(o.push(a?"ui-button-icons-only":"ui-button-icon-only"),this.hasTitle||t.attr("title",e.trim(i)))):o.push("ui-button-text-only"),t.addClass(o.join(" "))}}),e.widget("ui.buttonset",{version:"1.10.4",options:{items:"button, input[type=button], input[type=submit], input[type=reset], input[type=checkbox], input[type=radio], a, :data(ui-button)"},_create:function(){this.element.addClass("ui-buttonset")},_init:function(){this.refresh()},_setOption:function(e,t){"disabled"===e&&this.buttons.button("option",e,t),this._super(e,t)},refresh:function(){var t="rtl"===this.element.css("direction");this.buttons=this.element.find(this.options.items).filter(":ui-button").button("refresh").end().not(":ui-button").button().end().map(function(){return e(this).button("widget")[0]}).removeClass("ui-corner-all ui-corner-left ui-corner-right").filter(":first").addClass(t?"ui-corner-right":"ui-corner-left").end().filter(":last").addClass(t?"ui-corner-left":"ui-corner-right").end().end()},_destroy:function(){this.element.removeClass("ui-buttonset"),this.buttons.map(function(){return e(this).button("widget")[0]}).removeClass("ui-corner-left ui-corner-right").end().button("destroy")}})})(jQuery);(function(e,t){function i(){this._curInst=null,this._keyEvent=!1,this._disabledInputs=[],this._datepickerShowing=!1,this._inDialog=!1,this._mainDivId="ui-datepicker-div",this._inlineClass="ui-datepicker-inline",this._appendClass="ui-datepicker-append",this._triggerClass="ui-datepicker-trigger",this._dialogClass="ui-datepicker-dialog",this._disableClass="ui-datepicker-disabled",this._unselectableClass="ui-datepicker-unselectable",this._currentClass="ui-datepicker-current-day",this._dayOverClass="ui-datepicker-days-cell-over",this.regional=[],this.regional[""]={closeText:"Done",prevText:"Prev",nextText:"Next",currentText:"Today",monthNames:["January","February","March","April","May","June","July","August","September","October","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],dayNames:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],dayNamesShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],dayNamesMin:["Su","Mo","Tu","We","Th","Fr","Sa"],weekHeader:"Wk",dateFormat:"mm/dd/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""},this._defaults={showOn:"focus",showAnim:"fadeIn",showOptions:{},defaultDate:null,appendText:"",buttonText:"...",buttonImage:"",buttonImageOnly:!1,hideIfNoPrevNext:!1,navigationAsDateFormat:!1,gotoCurrent:!1,changeMonth:!1,changeYear:!1,yearRange:"c-10:c+10",showOtherMonths:!1,selectOtherMonths:!1,showWeek:!1,calculateWeek:this.iso8601Week,shortYearCutoff:"+10",minDate:null,maxDate:null,duration:"fast",beforeShowDay:null,beforeShow:null,onSelect:null,onChangeMonthYear:null,onClose:null,numberOfMonths:1,showCurrentAtPos:0,stepMonths:1,stepBigMonths:12,altField:"",altFormat:"",constrainInput:!0,showButtonPanel:!1,autoSize:!1,disabled:!1},e.extend(this._defaults,this.regional[""]),this.dpDiv=a(e("<div id='"+this._mainDivId+"' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>"))}function a(t){var i="button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";return t.delegate(i,"mouseout",function(){e(this).removeClass("ui-state-hover"),-1!==this.className.indexOf("ui-datepicker-prev")&&e(this).removeClass("ui-datepicker-prev-hover"),-1!==this.className.indexOf("ui-datepicker-next")&&e(this).removeClass("ui-datepicker-next-hover")}).delegate(i,"mouseover",function(){e.datepicker._isDisabledDatepicker(n.inline?t.parent()[0]:n.input[0])||(e(this).parents(".ui-datepicker-calendar").find("a").removeClass("ui-state-hover"),e(this).addClass("ui-state-hover"),-1!==this.className.indexOf("ui-datepicker-prev")&&e(this).addClass("ui-datepicker-prev-hover"),-1!==this.className.indexOf("ui-datepicker-next")&&e(this).addClass("ui-datepicker-next-hover"))})}function s(t,i){e.extend(t,i);for(var a in i)null==i[a]&&(t[a]=i[a]);return t}e.extend(e.ui,{datepicker:{version:"1.10.4"}});var n,r="datepicker";e.extend(i.prototype,{markerClassName:"hasDatepicker",maxRows:4,_widgetDatepicker:function(){return this.dpDiv},setDefaults:function(e){return s(this._defaults,e||{}),this},_attachDatepicker:function(t,i){var a,s,n;a=t.nodeName.toLowerCase(),s="div"===a||"span"===a,t.id||(this.uuid+=1,t.id="dp"+this.uuid),n=this._newInst(e(t),s),n.settings=e.extend({},i||{}),"input"===a?this._connectDatepicker(t,n):s&&this._inlineDatepicker(t,n)},_newInst:function(t,i){var s=t[0].id.replace(/([^A-Za-z0-9_\-])/g,"\\\\$1");return{id:s,input:t,selectedDay:0,selectedMonth:0,selectedYear:0,drawMonth:0,drawYear:0,inline:i,dpDiv:i?a(e("<div class='"+this._inlineClass+" ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>")):this.dpDiv}},_connectDatepicker:function(t,i){var a=e(t);i.append=e([]),i.trigger=e([]),a.hasClass(this.markerClassName)||(this._attachments(a,i),a.addClass(this.markerClassName).keydown(this._doKeyDown).keypress(this._doKeyPress).keyup(this._doKeyUp),this._autoSize(i),e.data(t,r,i),i.settings.disabled&&this._disableDatepicker(t))},_attachments:function(t,i){var a,s,n,r=this._get(i,"appendText"),o=this._get(i,"isRTL");i.append&&i.append.remove(),r&&(i.append=e("<span class='"+this._appendClass+"'>"+r+"</span>"),t[o?"before":"after"](i.append)),t.unbind("focus",this._showDatepicker),i.trigger&&i.trigger.remove(),a=this._get(i,"showOn"),("focus"===a||"both"===a)&&t.focus(this._showDatepicker),("button"===a||"both"===a)&&(s=this._get(i,"buttonText"),n=this._get(i,"buttonImage"),i.trigger=e(this._get(i,"buttonImageOnly")?e("<img/>").addClass(this._triggerClass).attr({src:n,alt:s,title:s}):e("<button type='button'></button>").addClass(this._triggerClass).html(n?e("<img/>").attr({src:n,alt:s,title:s}):s)),t[o?"before":"after"](i.trigger),i.trigger.click(function(){return e.datepicker._datepickerShowing&&e.datepicker._lastInput===t[0]?e.datepicker._hideDatepicker():e.datepicker._datepickerShowing&&e.datepicker._lastInput!==t[0]?(e.datepicker._hideDatepicker(),e.datepicker._showDatepicker(t[0])):e.datepicker._showDatepicker(t[0]),!1}))},_autoSize:function(e){if(this._get(e,"autoSize")&&!e.inline){var t,i,a,s,n=new Date(2009,11,20),r=this._get(e,"dateFormat");r.match(/[DM]/)&&(t=function(e){for(i=0,a=0,s=0;e.length>s;s++)e[s].length>i&&(i=e[s].length,a=s);return a},n.setMonth(t(this._get(e,r.match(/MM/)?"monthNames":"monthNamesShort"))),n.setDate(t(this._get(e,r.match(/DD/)?"dayNames":"dayNamesShort"))+20-n.getDay())),e.input.attr("size",this._formatDate(e,n).length)}},_inlineDatepicker:function(t,i){var a=e(t);a.hasClass(this.markerClassName)||(a.addClass(this.markerClassName).append(i.dpDiv),e.data(t,r,i),this._setDate(i,this._getDefaultDate(i),!0),this._updateDatepicker(i),this._updateAlternate(i),i.settings.disabled&&this._disableDatepicker(t),i.dpDiv.css("display","block"))},_dialogDatepicker:function(t,i,a,n,o){var u,c,h,l,d,p=this._dialogInst;return p||(this.uuid+=1,u="dp"+this.uuid,this._dialogInput=e("<input type='text' id='"+u+"' style='position: absolute; top: -100px; width: 0px;'/>"),this._dialogInput.keydown(this._doKeyDown),e("body").append(this._dialogInput),p=this._dialogInst=this._newInst(this._dialogInput,!1),p.settings={},e.data(this._dialogInput[0],r,p)),s(p.settings,n||{}),i=i&&i.constructor===Date?this._formatDate(p,i):i,this._dialogInput.val(i),this._pos=o?o.length?o:[o.pageX,o.pageY]:null,this._pos||(c=document.documentElement.clientWidth,h=document.documentElement.clientHeight,l=document.documentElement.scrollLeft||document.body.scrollLeft,d=document.documentElement.scrollTop||document.body.scrollTop,this._pos=[c/2-100+l,h/2-150+d]),this._dialogInput.css("left",this._pos[0]+20+"px").css("top",this._pos[1]+"px"),p.settings.onSelect=a,this._inDialog=!0,this.dpDiv.addClass(this._dialogClass),this._showDatepicker(this._dialogInput[0]),e.blockUI&&e.blockUI(this.dpDiv),e.data(this._dialogInput[0],r,p),this},_destroyDatepicker:function(t){var i,a=e(t),s=e.data(t,r);a.hasClass(this.markerClassName)&&(i=t.nodeName.toLowerCase(),e.removeData(t,r),"input"===i?(s.append.remove(),s.trigger.remove(),a.removeClass(this.markerClassName).unbind("focus",this._showDatepicker).unbind("keydown",this._doKeyDown).unbind("keypress",this._doKeyPress).unbind("keyup",this._doKeyUp)):("div"===i||"span"===i)&&a.removeClass(this.markerClassName).empty())},_enableDatepicker:function(t){var i,a,s=e(t),n=e.data(t,r);s.hasClass(this.markerClassName)&&(i=t.nodeName.toLowerCase(),"input"===i?(t.disabled=!1,n.trigger.filter("button").each(function(){this.disabled=!1}).end().filter("img").css({opacity:"1.0",cursor:""})):("div"===i||"span"===i)&&(a=s.children("."+this._inlineClass),a.children().removeClass("ui-state-disabled"),a.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled",!1)),this._disabledInputs=e.map(this._disabledInputs,function(e){return e===t?null:e}))},_disableDatepicker:function(t){var i,a,s=e(t),n=e.data(t,r);s.hasClass(this.markerClassName)&&(i=t.nodeName.toLowerCase(),"input"===i?(t.disabled=!0,n.trigger.filter("button").each(function(){this.disabled=!0}).end().filter("img").css({opacity:"0.5",cursor:"default"})):("div"===i||"span"===i)&&(a=s.children("."+this._inlineClass),a.children().addClass("ui-state-disabled"),a.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled",!0)),this._disabledInputs=e.map(this._disabledInputs,function(e){return e===t?null:e}),this._disabledInputs[this._disabledInputs.length]=t)},_isDisabledDatepicker:function(e){if(!e)return!1;for(var t=0;this._disabledInputs.length>t;t++)if(this._disabledInputs[t]===e)return!0;return!1},_getInst:function(t){try{return e.data(t,r)}catch(i){throw"Missing instance data for this datepicker"}},_optionDatepicker:function(i,a,n){var r,o,u,c,h=this._getInst(i);return 2===arguments.length&&"string"==typeof a?"defaults"===a?e.extend({},e.datepicker._defaults):h?"all"===a?e.extend({},h.settings):this._get(h,a):null:(r=a||{},"string"==typeof a&&(r={},r[a]=n),h&&(this._curInst===h&&this._hideDatepicker(),o=this._getDateDatepicker(i,!0),u=this._getMinMaxDate(h,"min"),c=this._getMinMaxDate(h,"max"),s(h.settings,r),null!==u&&r.dateFormat!==t&&r.minDate===t&&(h.settings.minDate=this._formatDate(h,u)),null!==c&&r.dateFormat!==t&&r.maxDate===t&&(h.settings.maxDate=this._formatDate(h,c)),"disabled"in r&&(r.disabled?this._disableDatepicker(i):this._enableDatepicker(i)),this._attachments(e(i),h),this._autoSize(h),this._setDate(h,o),this._updateAlternate(h),this._updateDatepicker(h)),t)},_changeDatepicker:function(e,t,i){this._optionDatepicker(e,t,i)},_refreshDatepicker:function(e){var t=this._getInst(e);t&&this._updateDatepicker(t)},_setDateDatepicker:function(e,t){var i=this._getInst(e);i&&(this._setDate(i,t),this._updateDatepicker(i),this._updateAlternate(i))},_getDateDatepicker:function(e,t){var i=this._getInst(e);return i&&!i.inline&&this._setDateFromField(i,t),i?this._getDate(i):null},_doKeyDown:function(t){var i,a,s,n=e.datepicker._getInst(t.target),r=!0,o=n.dpDiv.is(".ui-datepicker-rtl");if(n._keyEvent=!0,e.datepicker._datepickerShowing)switch(t.keyCode){case 9:e.datepicker._hideDatepicker(),r=!1;break;case 13:return s=e("td."+e.datepicker._dayOverClass+":not(."+e.datepicker._currentClass+")",n.dpDiv),s[0]&&e.datepicker._selectDay(t.target,n.selectedMonth,n.selectedYear,s[0]),i=e.datepicker._get(n,"onSelect"),i?(a=e.datepicker._formatDate(n),i.apply(n.input?n.input[0]:null,[a,n])):e.datepicker._hideDatepicker(),!1;case 27:e.datepicker._hideDatepicker();break;case 33:e.datepicker._adjustDate(t.target,t.ctrlKey?-e.datepicker._get(n,"stepBigMonths"):-e.datepicker._get(n,"stepMonths"),"M");break;case 34:e.datepicker._adjustDate(t.target,t.ctrlKey?+e.datepicker._get(n,"stepBigMonths"):+e.datepicker._get(n,"stepMonths"),"M");break;case 35:(t.ctrlKey||t.metaKey)&&e.datepicker._clearDate(t.target),r=t.ctrlKey||t.metaKey;break;case 36:(t.ctrlKey||t.metaKey)&&e.datepicker._gotoToday(t.target),r=t.ctrlKey||t.metaKey;break;case 37:(t.ctrlKey||t.metaKey)&&e.datepicker._adjustDate(t.target,o?1:-1,"D"),r=t.ctrlKey||t.metaKey,t.originalEvent.altKey&&e.datepicker._adjustDate(t.target,t.ctrlKey?-e.datepicker._get(n,"stepBigMonths"):-e.datepicker._get(n,"stepMonths"),"M");break;case 38:(t.ctrlKey||t.metaKey)&&e.datepicker._adjustDate(t.target,-7,"D"),r=t.ctrlKey||t.metaKey;break;case 39:(t.ctrlKey||t.metaKey)&&e.datepicker._adjustDate(t.target,o?-1:1,"D"),r=t.ctrlKey||t.metaKey,t.originalEvent.altKey&&e.datepicker._adjustDate(t.target,t.ctrlKey?+e.datepicker._get(n,"stepBigMonths"):+e.datepicker._get(n,"stepMonths"),"M");break;case 40:(t.ctrlKey||t.metaKey)&&e.datepicker._adjustDate(t.target,7,"D"),r=t.ctrlKey||t.metaKey;break;default:r=!1}else 36===t.keyCode&&t.ctrlKey?e.datepicker._showDatepicker(this):r=!1;r&&(t.preventDefault(),t.stopPropagation())},_doKeyPress:function(i){var a,s,n=e.datepicker._getInst(i.target);return e.datepicker._get(n,"constrainInput")?(a=e.datepicker._possibleChars(e.datepicker._get(n,"dateFormat")),s=String.fromCharCode(null==i.charCode?i.keyCode:i.charCode),i.ctrlKey||i.metaKey||" ">s||!a||a.indexOf(s)>-1):t},_doKeyUp:function(t){var i,a=e.datepicker._getInst(t.target);if(a.input.val()!==a.lastVal)try{i=e.datepicker.parseDate(e.datepicker._get(a,"dateFormat"),a.input?a.input.val():null,e.datepicker._getFormatConfig(a)),i&&(e.datepicker._setDateFromField(a),e.datepicker._updateAlternate(a),e.datepicker._updateDatepicker(a))}catch(s){}return!0},_showDatepicker:function(t){if(t=t.target||t,"input"!==t.nodeName.toLowerCase()&&(t=e("input",t.parentNode)[0]),!e.datepicker._isDisabledDatepicker(t)&&e.datepicker._lastInput!==t){var i,a,n,r,o,u,c;i=e.datepicker._getInst(t),e.datepicker._curInst&&e.datepicker._curInst!==i&&(e.datepicker._curInst.dpDiv.stop(!0,!0),i&&e.datepicker._datepickerShowing&&e.datepicker._hideDatepicker(e.datepicker._curInst.input[0])),a=e.datepicker._get(i,"beforeShow"),n=a?a.apply(t,[t,i]):{},n!==!1&&(s(i.settings,n),i.lastVal=null,e.datepicker._lastInput=t,e.datepicker._setDateFromField(i),e.datepicker._inDialog&&(t.value=""),e.datepicker._pos||(e.datepicker._pos=e.datepicker._findPos(t),e.datepicker._pos[1]+=t.offsetHeight),r=!1,e(t).parents().each(function(){return r|="fixed"===e(this).css("position"),!r}),o={left:e.datepicker._pos[0],top:e.datepicker._pos[1]},e.datepicker._pos=null,i.dpDiv.empty(),i.dpDiv.css({position:"absolute",display:"block",top:"-1000px"}),e.datepicker._updateDatepicker(i),o=e.datepicker._checkOffset(i,o,r),i.dpDiv.css({position:e.datepicker._inDialog&&e.blockUI?"static":r?"fixed":"absolute",display:"none",left:o.left+"px",top:o.top+"px"}),i.inline||(u=e.datepicker._get(i,"showAnim"),c=e.datepicker._get(i,"duration"),i.dpDiv.zIndex(e(t).zIndex()+1),e.datepicker._datepickerShowing=!0,e.effects&&e.effects.effect[u]?i.dpDiv.show(u,e.datepicker._get(i,"showOptions"),c):i.dpDiv[u||"show"](u?c:null),e.datepicker._shouldFocusInput(i)&&i.input.focus(),e.datepicker._curInst=i))}},_updateDatepicker:function(t){this.maxRows=4,n=t,t.dpDiv.empty().append(this._generateHTML(t)),this._attachHandlers(t),t.dpDiv.find("."+this._dayOverClass+" a").mouseover();var i,a=this._getNumberOfMonths(t),s=a[1],r=17;t.dpDiv.removeClass("ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4").width(""),s>1&&t.dpDiv.addClass("ui-datepicker-multi-"+s).css("width",r*s+"em"),t.dpDiv[(1!==a[0]||1!==a[1]?"add":"remove")+"Class"]("ui-datepicker-multi"),t.dpDiv[(this._get(t,"isRTL")?"add":"remove")+"Class"]("ui-datepicker-rtl"),t===e.datepicker._curInst&&e.datepicker._datepickerShowing&&e.datepicker._shouldFocusInput(t)&&t.input.focus(),t.yearshtml&&(i=t.yearshtml,setTimeout(function(){i===t.yearshtml&&t.yearshtml&&t.dpDiv.find("select.ui-datepicker-year:first").replaceWith(t.yearshtml),i=t.yearshtml=null},0))},_shouldFocusInput:function(e){return e.input&&e.input.is(":visible")&&!e.input.is(":disabled")&&!e.input.is(":focus")},_checkOffset:function(t,i,a){var s=t.dpDiv.outerWidth(),n=t.dpDiv.outerHeight(),r=t.input?t.input.outerWidth():0,o=t.input?t.input.outerHeight():0,u=document.documentElement.clientWidth+(a?0:e(document).scrollLeft()),c=document.documentElement.clientHeight+(a?0:e(document).scrollTop());return i.left-=this._get(t,"isRTL")?s-r:0,i.left-=a&&i.left===t.input.offset().left?e(document).scrollLeft():0,i.top-=a&&i.top===t.input.offset().top+o?e(document).scrollTop():0,i.left-=Math.min(i.left,i.left+s>u&&u>s?Math.abs(i.left+s-u):0),i.top-=Math.min(i.top,i.top+n>c&&c>n?Math.abs(n+o):0),i},_findPos:function(t){for(var i,a=this._getInst(t),s=this._get(a,"isRTL");t&&("hidden"===t.type||1!==t.nodeType||e.expr.filters.hidden(t));)t=t[s?"previousSibling":"nextSibling"];return i=e(t).offset(),[i.left,i.top]},_hideDatepicker:function(t){var i,a,s,n,o=this._curInst;!o||t&&o!==e.data(t,r)||this._datepickerShowing&&(i=this._get(o,"showAnim"),a=this._get(o,"duration"),s=function(){e.datepicker._tidyDialog(o)},e.effects&&(e.effects.effect[i]||e.effects[i])?o.dpDiv.hide(i,e.datepicker._get(o,"showOptions"),a,s):o.dpDiv["slideDown"===i?"slideUp":"fadeIn"===i?"fadeOut":"hide"](i?a:null,s),i||s(),this._datepickerShowing=!1,n=this._get(o,"onClose"),n&&n.apply(o.input?o.input[0]:null,[o.input?o.input.val():"",o]),this._lastInput=null,this._inDialog&&(this._dialogInput.css({position:"absolute",left:"0",top:"-100px"}),e.blockUI&&(e.unblockUI(),e("body").append(this.dpDiv))),this._inDialog=!1)},_tidyDialog:function(e){e.dpDiv.removeClass(this._dialogClass).unbind(".ui-datepicker-calendar")},_checkExternalClick:function(t){if(e.datepicker._curInst){var i=e(t.target),a=e.datepicker._getInst(i[0]);(i[0].id!==e.datepicker._mainDivId&&0===i.parents("#"+e.datepicker._mainDivId).length&&!i.hasClass(e.datepicker.markerClassName)&&!i.closest("."+e.datepicker._triggerClass).length&&e.datepicker._datepickerShowing&&(!e.datepicker._inDialog||!e.blockUI)||i.hasClass(e.datepicker.markerClassName)&&e.datepicker._curInst!==a)&&e.datepicker._hideDatepicker()}},_adjustDate:function(t,i,a){var s=e(t),n=this._getInst(s[0]);this._isDisabledDatepicker(s[0])||(this._adjustInstDate(n,i+("M"===a?this._get(n,"showCurrentAtPos"):0),a),this._updateDatepicker(n))},_gotoToday:function(t){var i,a=e(t),s=this._getInst(a[0]);this._get(s,"gotoCurrent")&&s.currentDay?(s.selectedDay=s.currentDay,s.drawMonth=s.selectedMonth=s.currentMonth,s.drawYear=s.selectedYear=s.currentYear):(i=new Date,s.selectedDay=i.getDate(),s.drawMonth=s.selectedMonth=i.getMonth(),s.drawYear=s.selectedYear=i.getFullYear()),this._notifyChange(s),this._adjustDate(a)},_selectMonthYear:function(t,i,a){var s=e(t),n=this._getInst(s[0]);n["selected"+("M"===a?"Month":"Year")]=n["draw"+("M"===a?"Month":"Year")]=parseInt(i.options[i.selectedIndex].value,10),this._notifyChange(n),this._adjustDate(s)},_selectDay:function(t,i,a,s){var n,r=e(t);e(s).hasClass(this._unselectableClass)||this._isDisabledDatepicker(r[0])||(n=this._getInst(r[0]),n.selectedDay=n.currentDay=e("a",s).html(),n.selectedMonth=n.currentMonth=i,n.selectedYear=n.currentYear=a,this._selectDate(t,this._formatDate(n,n.currentDay,n.currentMonth,n.currentYear)))},_clearDate:function(t){var i=e(t);this._selectDate(i,"")},_selectDate:function(t,i){var a,s=e(t),n=this._getInst(s[0]);i=null!=i?i:this._formatDate(n),n.input&&n.input.val(i),this._updateAlternate(n),a=this._get(n,"onSelect"),a?a.apply(n.input?n.input[0]:null,[i,n]):n.input&&n.input.trigger("change"),n.inline?this._updateDatepicker(n):(this._hideDatepicker(),this._lastInput=n.input[0],"object"!=typeof n.input[0]&&n.input.focus(),this._lastInput=null)},_updateAlternate:function(t){var i,a,s,n=this._get(t,"altField");n&&(i=this._get(t,"altFormat")||this._get(t,"dateFormat"),a=this._getDate(t),s=this.formatDate(i,a,this._getFormatConfig(t)),e(n).each(function(){e(this).val(s)}))},noWeekends:function(e){var t=e.getDay();return[t>0&&6>t,""]},iso8601Week:function(e){var t,i=new Date(e.getTime());return i.setDate(i.getDate()+4-(i.getDay()||7)),t=i.getTime(),i.setMonth(0),i.setDate(1),Math.floor(Math.round((t-i)/864e5)/7)+1},parseDate:function(i,a,s){if(null==i||null==a)throw"Invalid arguments";if(a="object"==typeof a?""+a:a+"",""===a)return null;var n,r,o,u,c=0,h=(s?s.shortYearCutoff:null)||this._defaults.shortYearCutoff,l="string"!=typeof h?h:(new Date).getFullYear()%100+parseInt(h,10),d=(s?s.dayNamesShort:null)||this._defaults.dayNamesShort,p=(s?s.dayNames:null)||this._defaults.dayNames,g=(s?s.monthNamesShort:null)||this._defaults.monthNamesShort,m=(s?s.monthNames:null)||this._defaults.monthNames,f=-1,_=-1,v=-1,k=-1,y=!1,b=function(e){var t=i.length>n+1&&i.charAt(n+1)===e;return t&&n++,t},D=function(e){var t=b(e),i="@"===e?14:"!"===e?20:"y"===e&&t?4:"o"===e?3:2,s=RegExp("^\\d{1,"+i+"}"),n=a.substring(c).match(s);if(!n)throw"Missing number at position "+c;return c+=n[0].length,parseInt(n[0],10)},w=function(i,s,n){var r=-1,o=e.map(b(i)?n:s,function(e,t){return[[t,e]]}).sort(function(e,t){return-(e[1].length-t[1].length)});if(e.each(o,function(e,i){var s=i[1];return a.substr(c,s.length).toLowerCase()===s.toLowerCase()?(r=i[0],c+=s.length,!1):t}),-1!==r)return r+1;throw"Unknown name at position "+c},M=function(){if(a.charAt(c)!==i.charAt(n))throw"Unexpected literal at position "+c;c++};for(n=0;i.length>n;n++)if(y)"'"!==i.charAt(n)||b("'")?M():y=!1;else switch(i.charAt(n)){case"d":v=D("d");break;case"D":w("D",d,p);break;case"o":k=D("o");break;case"m":_=D("m");break;case"M":_=w("M",g,m);break;case"y":f=D("y");break;case"@":u=new Date(D("@")),f=u.getFullYear(),_=u.getMonth()+1,v=u.getDate();break;case"!":u=new Date((D("!")-this._ticksTo1970)/1e4),f=u.getFullYear(),_=u.getMonth()+1,v=u.getDate();break;case"'":b("'")?M():y=!0;break;default:M()}if(a.length>c&&(o=a.substr(c),!/^\s+/.test(o)))throw"Extra/unparsed characters found in date: "+o;if(-1===f?f=(new Date).getFullYear():100>f&&(f+=(new Date).getFullYear()-(new Date).getFullYear()%100+(l>=f?0:-100)),k>-1)for(_=1,v=k;;){if(r=this._getDaysInMonth(f,_-1),r>=v)break;_++,v-=r}if(u=this._daylightSavingAdjust(new Date(f,_-1,v)),u.getFullYear()!==f||u.getMonth()+1!==_||u.getDate()!==v)throw"Invalid date";return u},ATOM:"yy-mm-dd",COOKIE:"D, dd M yy",ISO_8601:"yy-mm-dd",RFC_822:"D, d M y",RFC_850:"DD, dd-M-y",RFC_1036:"D, d M y",RFC_1123:"D, d M yy",RFC_2822:"D, d M yy",RSS:"D, d M y",TICKS:"!",TIMESTAMP:"@",W3C:"yy-mm-dd",_ticksTo1970:1e7*60*60*24*(718685+Math.floor(492.5)-Math.floor(19.7)+Math.floor(4.925)),formatDate:function(e,t,i){if(!t)return"";var a,s=(i?i.dayNamesShort:null)||this._defaults.dayNamesShort,n=(i?i.dayNames:null)||this._defaults.dayNames,r=(i?i.monthNamesShort:null)||this._defaults.monthNamesShort,o=(i?i.monthNames:null)||this._defaults.monthNames,u=function(t){var i=e.length>a+1&&e.charAt(a+1)===t;return i&&a++,i},c=function(e,t,i){var a=""+t;if(u(e))for(;i>a.length;)a="0"+a;return a},h=function(e,t,i,a){return u(e)?a[t]:i[t]},l="",d=!1;if(t)for(a=0;e.length>a;a++)if(d)"'"!==e.charAt(a)||u("'")?l+=e.charAt(a):d=!1;else switch(e.charAt(a)){case"d":l+=c("d",t.getDate(),2);break;case"D":l+=h("D",t.getDay(),s,n);break;case"o":l+=c("o",Math.round((new Date(t.getFullYear(),t.getMonth(),t.getDate()).getTime()-new Date(t.getFullYear(),0,0).getTime())/864e5),3);break;case"m":l+=c("m",t.getMonth()+1,2);break;case"M":l+=h("M",t.getMonth(),r,o);break;case"y":l+=u("y")?t.getFullYear():(10>t.getYear()%100?"0":"")+t.getYear()%100;break;case"@":l+=t.getTime();break;case"!":l+=1e4*t.getTime()+this._ticksTo1970;break;case"'":u("'")?l+="'":d=!0;break;default:l+=e.charAt(a)}return l},_possibleChars:function(e){var t,i="",a=!1,s=function(i){var a=e.length>t+1&&e.charAt(t+1)===i;return a&&t++,a};for(t=0;e.length>t;t++)if(a)"'"!==e.charAt(t)||s("'")?i+=e.charAt(t):a=!1;else switch(e.charAt(t)){case"d":case"m":case"y":case"@":i+="0123456789";break;case"D":case"M":return null;case"'":s("'")?i+="'":a=!0;break;default:i+=e.charAt(t)}return i},_get:function(e,i){return e.settings[i]!==t?e.settings[i]:this._defaults[i]},_setDateFromField:function(e,t){if(e.input.val()!==e.lastVal){var i=this._get(e,"dateFormat"),a=e.lastVal=e.input?e.input.val():null,s=this._getDefaultDate(e),n=s,r=this._getFormatConfig(e);try{n=this.parseDate(i,a,r)||s}catch(o){a=t?"":a}e.selectedDay=n.getDate(),e.drawMonth=e.selectedMonth=n.getMonth(),e.drawYear=e.selectedYear=n.getFullYear(),e.currentDay=a?n.getDate():0,e.currentMonth=a?n.getMonth():0,e.currentYear=a?n.getFullYear():0,this._adjustInstDate(e)}},_getDefaultDate:function(e){return this._restrictMinMax(e,this._determineDate(e,this._get(e,"defaultDate"),new Date))},_determineDate:function(t,i,a){var s=function(e){var t=new Date;return t.setDate(t.getDate()+e),t},n=function(i){try{return e.datepicker.parseDate(e.datepicker._get(t,"dateFormat"),i,e.datepicker._getFormatConfig(t))}catch(a){}for(var s=(i.toLowerCase().match(/^c/)?e.datepicker._getDate(t):null)||new Date,n=s.getFullYear(),r=s.getMonth(),o=s.getDate(),u=/([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g,c=u.exec(i);c;){switch(c[2]||"d"){case"d":case"D":o+=parseInt(c[1],10);break;case"w":case"W":o+=7*parseInt(c[1],10);break;case"m":case"M":r+=parseInt(c[1],10),o=Math.min(o,e.datepicker._getDaysInMonth(n,r));break;case"y":case"Y":n+=parseInt(c[1],10),o=Math.min(o,e.datepicker._getDaysInMonth(n,r))}c=u.exec(i)}return new Date(n,r,o)},r=null==i||""===i?a:"string"==typeof i?n(i):"number"==typeof i?isNaN(i)?a:s(i):new Date(i.getTime());return r=r&&"Invalid Date"==""+r?a:r,r&&(r.setHours(0),r.setMinutes(0),r.setSeconds(0),r.setMilliseconds(0)),this._daylightSavingAdjust(r)},_daylightSavingAdjust:function(e){return e?(e.setHours(e.getHours()>12?e.getHours()+2:0),e):null},_setDate:function(e,t,i){var a=!t,s=e.selectedMonth,n=e.selectedYear,r=this._restrictMinMax(e,this._determineDate(e,t,new Date));e.selectedDay=e.currentDay=r.getDate(),e.drawMonth=e.selectedMonth=e.currentMonth=r.getMonth(),e.drawYear=e.selectedYear=e.currentYear=r.getFullYear(),s===e.selectedMonth&&n===e.selectedYear||i||this._notifyChange(e),this._adjustInstDate(e),e.input&&e.input.val(a?"":this._formatDate(e))},_getDate:function(e){var t=!e.currentYear||e.input&&""===e.input.val()?null:this._daylightSavingAdjust(new Date(e.currentYear,e.currentMonth,e.currentDay));return t},_attachHandlers:function(t){var i=this._get(t,"stepMonths"),a="#"+t.id.replace(/\\\\/g,"\\");t.dpDiv.find("[data-handler]").map(function(){var t={prev:function(){e.datepicker._adjustDate(a,-i,"M")},next:function(){e.datepicker._adjustDate(a,+i,"M")},hide:function(){e.datepicker._hideDatepicker()},today:function(){e.datepicker._gotoToday(a)},selectDay:function(){return e.datepicker._selectDay(a,+this.getAttribute("data-month"),+this.getAttribute("data-year"),this),!1},selectMonth:function(){return e.datepicker._selectMonthYear(a,this,"M"),!1},selectYear:function(){return e.datepicker._selectMonthYear(a,this,"Y"),!1}};e(this).bind(this.getAttribute("data-event"),t[this.getAttribute("data-handler")])})},_generateHTML:function(e){var t,i,a,s,n,r,o,u,c,h,l,d,p,g,m,f,_,v,k,y,b,D,w,M,C,x,I,N,T,A,E,S,Y,F,P,O,j,K,R,H=new Date,W=this._daylightSavingAdjust(new Date(H.getFullYear(),H.getMonth(),H.getDate())),L=this._get(e,"isRTL"),U=this._get(e,"showButtonPanel"),B=this._get(e,"hideIfNoPrevNext"),z=this._get(e,"navigationAsDateFormat"),q=this._getNumberOfMonths(e),G=this._get(e,"showCurrentAtPos"),J=this._get(e,"stepMonths"),Q=1!==q[0]||1!==q[1],V=this._daylightSavingAdjust(e.currentDay?new Date(e.currentYear,e.currentMonth,e.currentDay):new Date(9999,9,9)),$=this._getMinMaxDate(e,"min"),X=this._getMinMaxDate(e,"max"),Z=e.drawMonth-G,et=e.drawYear;if(0>Z&&(Z+=12,et--),X)for(t=this._daylightSavingAdjust(new Date(X.getFullYear(),X.getMonth()-q[0]*q[1]+1,X.getDate())),t=$&&$>t?$:t;this._daylightSavingAdjust(new Date(et,Z,1))>t;)Z--,0>Z&&(Z=11,et--);for(e.drawMonth=Z,e.drawYear=et,i=this._get(e,"prevText"),i=z?this.formatDate(i,this._daylightSavingAdjust(new Date(et,Z-J,1)),this._getFormatConfig(e)):i,a=this._canAdjustMonth(e,-1,et,Z)?"<a class='ui-datepicker-prev ui-corner-all' data-handler='prev' data-event='click' title='"+i+"'><span class='ui-icon ui-icon-circle-triangle-"+(L?"e":"w")+"'>"+i+"</span></a>":B?"":"<a class='ui-datepicker-prev ui-corner-all ui-state-disabled' title='"+i+"'><span class='ui-icon ui-icon-circle-triangle-"+(L?"e":"w")+"'>"+i+"</span></a>",s=this._get(e,"nextText"),s=z?this.formatDate(s,this._daylightSavingAdjust(new Date(et,Z+J,1)),this._getFormatConfig(e)):s,n=this._canAdjustMonth(e,1,et,Z)?"<a class='ui-datepicker-next ui-corner-all' data-handler='next' data-event='click' title='"+s+"'><span class='ui-icon ui-icon-circle-triangle-"+(L?"w":"e")+"'>"+s+"</span></a>":B?"":"<a class='ui-datepicker-next ui-corner-all ui-state-disabled' title='"+s+"'><span class='ui-icon ui-icon-circle-triangle-"+(L?"w":"e")+"'>"+s+"</span></a>",r=this._get(e,"currentText"),o=this._get(e,"gotoCurrent")&&e.currentDay?V:W,r=z?this.formatDate(r,o,this._getFormatConfig(e)):r,u=e.inline?"":"<button type='button' class='ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all' data-handler='hide' data-event='click'>"+this._get(e,"closeText")+"</button>",c=U?"<div class='ui-datepicker-buttonpane ui-widget-content'>"+(L?u:"")+(this._isInRange(e,o)?"<button type='button' class='ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all' data-handler='today' data-event='click'>"+r+"</button>":"")+(L?"":u)+"</div>":"",h=parseInt(this._get(e,"firstDay"),10),h=isNaN(h)?0:h,l=this._get(e,"showWeek"),d=this._get(e,"dayNames"),p=this._get(e,"dayNamesMin"),g=this._get(e,"monthNames"),m=this._get(e,"monthNamesShort"),f=this._get(e,"beforeShowDay"),_=this._get(e,"showOtherMonths"),v=this._get(e,"selectOtherMonths"),k=this._getDefaultDate(e),y="",D=0;q[0]>D;D++){for(w="",this.maxRows=4,M=0;q[1]>M;M++){if(C=this._daylightSavingAdjust(new Date(et,Z,e.selectedDay)),x=" ui-corner-all",I="",Q){if(I+="<div class='ui-datepicker-group",q[1]>1)switch(M){case 0:I+=" ui-datepicker-group-first",x=" ui-corner-"+(L?"right":"left");break;case q[1]-1:I+=" ui-datepicker-group-last",x=" ui-corner-"+(L?"left":"right");break;default:I+=" ui-datepicker-group-middle",x=""}I+="'>"}for(I+="<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix"+x+"'>"+(/all|left/.test(x)&&0===D?L?n:a:"")+(/all|right/.test(x)&&0===D?L?a:n:"")+this._generateMonthYearHeader(e,Z,et,$,X,D>0||M>0,g,m)+"</div><table class='ui-datepicker-calendar'><thead>"+"<tr>",N=l?"<th class='ui-datepicker-week-col'>"+this._get(e,"weekHeader")+"</th>":"",b=0;7>b;b++)T=(b+h)%7,N+="<th"+((b+h+6)%7>=5?" class='ui-datepicker-week-end'":"")+">"+"<span title='"+d[T]+"'>"+p[T]+"</span></th>";for(I+=N+"</tr></thead><tbody>",A=this._getDaysInMonth(et,Z),et===e.selectedYear&&Z===e.selectedMonth&&(e.selectedDay=Math.min(e.selectedDay,A)),E=(this._getFirstDayOfMonth(et,Z)-h+7)%7,S=Math.ceil((E+A)/7),Y=Q?this.maxRows>S?this.maxRows:S:S,this.maxRows=Y,F=this._daylightSavingAdjust(new Date(et,Z,1-E)),P=0;Y>P;P++){for(I+="<tr>",O=l?"<td class='ui-datepicker-week-col'>"+this._get(e,"calculateWeek")(F)+"</td>":"",b=0;7>b;b++)j=f?f.apply(e.input?e.input[0]:null,[F]):[!0,""],K=F.getMonth()!==Z,R=K&&!v||!j[0]||$&&$>F||X&&F>X,O+="<td class='"+((b+h+6)%7>=5?" ui-datepicker-week-end":"")+(K?" ui-datepicker-other-month":"")+(F.getTime()===C.getTime()&&Z===e.selectedMonth&&e._keyEvent||k.getTime()===F.getTime()&&k.getTime()===C.getTime()?" "+this._dayOverClass:"")+(R?" "+this._unselectableClass+" ui-state-disabled":"")+(K&&!_?"":" "+j[1]+(F.getTime()===V.getTime()?" "+this._currentClass:"")+(F.getTime()===W.getTime()?" ui-datepicker-today":""))+"'"+(K&&!_||!j[2]?"":" title='"+j[2].replace(/'/g,"&#39;")+"'")+(R?"":" data-handler='selectDay' data-event='click' data-month='"+F.getMonth()+"' data-year='"+F.getFullYear()+"'")+">"+(K&&!_?"&#xa0;":R?"<span class='ui-state-default'>"+F.getDate()+"</span>":"<a class='ui-state-default"+(F.getTime()===W.getTime()?" ui-state-highlight":"")+(F.getTime()===V.getTime()?" ui-state-active":"")+(K?" ui-priority-secondary":"")+"' href='#'>"+F.getDate()+"</a>")+"</td>",F.setDate(F.getDate()+1),F=this._daylightSavingAdjust(F);I+=O+"</tr>"}Z++,Z>11&&(Z=0,et++),I+="</tbody></table>"+(Q?"</div>"+(q[0]>0&&M===q[1]-1?"<div class='ui-datepicker-row-break'></div>":""):""),w+=I}y+=w}return y+=c,e._keyEvent=!1,y},_generateMonthYearHeader:function(e,t,i,a,s,n,r,o){var u,c,h,l,d,p,g,m,f=this._get(e,"changeMonth"),_=this._get(e,"changeYear"),v=this._get(e,"showMonthAfterYear"),k="<div class='ui-datepicker-title'>",y="";if(n||!f)y+="<span class='ui-datepicker-month'>"+r[t]+"</span>";else{for(u=a&&a.getFullYear()===i,c=s&&s.getFullYear()===i,y+="<select class='ui-datepicker-month' data-handler='selectMonth' data-event='change'>",h=0;12>h;h++)(!u||h>=a.getMonth())&&(!c||s.getMonth()>=h)&&(y+="<option value='"+h+"'"+(h===t?" selected='selected'":"")+">"+o[h]+"</option>");y+="</select>"}if(v||(k+=y+(!n&&f&&_?"":"&#xa0;")),!e.yearshtml)if(e.yearshtml="",n||!_)k+="<span class='ui-datepicker-year'>"+i+"</span>";else{for(l=this._get(e,"yearRange").split(":"),d=(new Date).getFullYear(),p=function(e){var t=e.match(/c[+\-].*/)?i+parseInt(e.substring(1),10):e.match(/[+\-].*/)?d+parseInt(e,10):parseInt(e,10);
return isNaN(t)?d:t},g=p(l[0]),m=Math.max(g,p(l[1]||"")),g=a?Math.max(g,a.getFullYear()):g,m=s?Math.min(m,s.getFullYear()):m,e.yearshtml+="<select class='ui-datepicker-year' data-handler='selectYear' data-event='change'>";m>=g;g++)e.yearshtml+="<option value='"+g+"'"+(g===i?" selected='selected'":"")+">"+g+"</option>";e.yearshtml+="</select>",k+=e.yearshtml,e.yearshtml=null}return k+=this._get(e,"yearSuffix"),v&&(k+=(!n&&f&&_?"":"&#xa0;")+y),k+="</div>"},_adjustInstDate:function(e,t,i){var a=e.drawYear+("Y"===i?t:0),s=e.drawMonth+("M"===i?t:0),n=Math.min(e.selectedDay,this._getDaysInMonth(a,s))+("D"===i?t:0),r=this._restrictMinMax(e,this._daylightSavingAdjust(new Date(a,s,n)));e.selectedDay=r.getDate(),e.drawMonth=e.selectedMonth=r.getMonth(),e.drawYear=e.selectedYear=r.getFullYear(),("M"===i||"Y"===i)&&this._notifyChange(e)},_restrictMinMax:function(e,t){var i=this._getMinMaxDate(e,"min"),a=this._getMinMaxDate(e,"max"),s=i&&i>t?i:t;return a&&s>a?a:s},_notifyChange:function(e){var t=this._get(e,"onChangeMonthYear");t&&t.apply(e.input?e.input[0]:null,[e.selectedYear,e.selectedMonth+1,e])},_getNumberOfMonths:function(e){var t=this._get(e,"numberOfMonths");return null==t?[1,1]:"number"==typeof t?[1,t]:t},_getMinMaxDate:function(e,t){return this._determineDate(e,this._get(e,t+"Date"),null)},_getDaysInMonth:function(e,t){return 32-this._daylightSavingAdjust(new Date(e,t,32)).getDate()},_getFirstDayOfMonth:function(e,t){return new Date(e,t,1).getDay()},_canAdjustMonth:function(e,t,i,a){var s=this._getNumberOfMonths(e),n=this._daylightSavingAdjust(new Date(i,a+(0>t?t:s[0]*s[1]),1));return 0>t&&n.setDate(this._getDaysInMonth(n.getFullYear(),n.getMonth())),this._isInRange(e,n)},_isInRange:function(e,t){var i,a,s=this._getMinMaxDate(e,"min"),n=this._getMinMaxDate(e,"max"),r=null,o=null,u=this._get(e,"yearRange");return u&&(i=u.split(":"),a=(new Date).getFullYear(),r=parseInt(i[0],10),o=parseInt(i[1],10),i[0].match(/[+\-].*/)&&(r+=a),i[1].match(/[+\-].*/)&&(o+=a)),(!s||t.getTime()>=s.getTime())&&(!n||t.getTime()<=n.getTime())&&(!r||t.getFullYear()>=r)&&(!o||o>=t.getFullYear())},_getFormatConfig:function(e){var t=this._get(e,"shortYearCutoff");return t="string"!=typeof t?t:(new Date).getFullYear()%100+parseInt(t,10),{shortYearCutoff:t,dayNamesShort:this._get(e,"dayNamesShort"),dayNames:this._get(e,"dayNames"),monthNamesShort:this._get(e,"monthNamesShort"),monthNames:this._get(e,"monthNames")}},_formatDate:function(e,t,i,a){t||(e.currentDay=e.selectedDay,e.currentMonth=e.selectedMonth,e.currentYear=e.selectedYear);var s=t?"object"==typeof t?t:this._daylightSavingAdjust(new Date(a,i,t)):this._daylightSavingAdjust(new Date(e.currentYear,e.currentMonth,e.currentDay));return this.formatDate(this._get(e,"dateFormat"),s,this._getFormatConfig(e))}}),e.fn.datepicker=function(t){if(!this.length)return this;e.datepicker.initialized||(e(document).mousedown(e.datepicker._checkExternalClick),e.datepicker.initialized=!0),0===e("#"+e.datepicker._mainDivId).length&&e("body").append(e.datepicker.dpDiv);var i=Array.prototype.slice.call(arguments,1);return"string"!=typeof t||"isDisabled"!==t&&"getDate"!==t&&"widget"!==t?"option"===t&&2===arguments.length&&"string"==typeof arguments[1]?e.datepicker["_"+t+"Datepicker"].apply(e.datepicker,[this[0]].concat(i)):this.each(function(){"string"==typeof t?e.datepicker["_"+t+"Datepicker"].apply(e.datepicker,[this].concat(i)):e.datepicker._attachDatepicker(this,t)}):e.datepicker["_"+t+"Datepicker"].apply(e.datepicker,[this[0]].concat(i))},e.datepicker=new i,e.datepicker.initialized=!1,e.datepicker.uuid=(new Date).getTime(),e.datepicker.version="1.10.4"})(jQuery);(function(e){var t={buttons:!0,height:!0,maxHeight:!0,maxWidth:!0,minHeight:!0,minWidth:!0,width:!0},i={maxHeight:!0,maxWidth:!0,minHeight:!0,minWidth:!0};e.widget("ui.dialog",{version:"1.10.4",options:{appendTo:"body",autoOpen:!0,buttons:[],closeOnEscape:!0,closeText:"close",dialogClass:"",draggable:!0,hide:null,height:"auto",maxHeight:null,maxWidth:null,minHeight:150,minWidth:150,modal:!1,position:{my:"center",at:"center",of:window,collision:"fit",using:function(t){var i=e(this).css(t).offset().top;0>i&&e(this).css("top",t.top-i)}},resizable:!0,show:null,title:null,width:300,beforeClose:null,close:null,drag:null,dragStart:null,dragStop:null,focus:null,open:null,resize:null,resizeStart:null,resizeStop:null},_create:function(){this.originalCss={display:this.element[0].style.display,width:this.element[0].style.width,minHeight:this.element[0].style.minHeight,maxHeight:this.element[0].style.maxHeight,height:this.element[0].style.height},this.originalPosition={parent:this.element.parent(),index:this.element.parent().children().index(this.element)},this.originalTitle=this.element.attr("title"),this.options.title=this.options.title||this.originalTitle,this._createWrapper(),this.element.show().removeAttr("title").addClass("ui-dialog-content ui-widget-content").appendTo(this.uiDialog),this._createTitlebar(),this._createButtonPane(),this.options.draggable&&e.fn.draggable&&this._makeDraggable(),this.options.resizable&&e.fn.resizable&&this._makeResizable(),this._isOpen=!1},_init:function(){this.options.autoOpen&&this.open()},_appendTo:function(){var t=this.options.appendTo;return t&&(t.jquery||t.nodeType)?e(t):this.document.find(t||"body").eq(0)},_destroy:function(){var e,t=this.originalPosition;this._destroyOverlay(),this.element.removeUniqueId().removeClass("ui-dialog-content ui-widget-content").css(this.originalCss).detach(),this.uiDialog.stop(!0,!0).remove(),this.originalTitle&&this.element.attr("title",this.originalTitle),e=t.parent.children().eq(t.index),e.length&&e[0]!==this.element[0]?e.before(this.element):t.parent.append(this.element)},widget:function(){return this.uiDialog},disable:e.noop,enable:e.noop,close:function(t){var i,a=this;if(this._isOpen&&this._trigger("beforeClose",t)!==!1){if(this._isOpen=!1,this._destroyOverlay(),!this.opener.filter(":focusable").focus().length)try{i=this.document[0].activeElement,i&&"body"!==i.nodeName.toLowerCase()&&e(i).blur()}catch(s){}this._hide(this.uiDialog,this.options.hide,function(){a._trigger("close",t)})}},isOpen:function(){return this._isOpen},moveToTop:function(){this._moveToTop()},_moveToTop:function(e,t){var i=!!this.uiDialog.nextAll(":visible").insertBefore(this.uiDialog).length;return i&&!t&&this._trigger("focus",e),i},open:function(){var t=this;return this._isOpen?(this._moveToTop()&&this._focusTabbable(),undefined):(this._isOpen=!0,this.opener=e(this.document[0].activeElement),this._size(),this._position(),this._createOverlay(),this._moveToTop(null,!0),this._show(this.uiDialog,this.options.show,function(){t._focusTabbable(),t._trigger("focus")}),this._trigger("open"),undefined)},_focusTabbable:function(){var e=this.element.find("[autofocus]");e.length||(e=this.element.find(":tabbable")),e.length||(e=this.uiDialogButtonPane.find(":tabbable")),e.length||(e=this.uiDialogTitlebarClose.filter(":tabbable")),e.length||(e=this.uiDialog),e.eq(0).focus()},_keepFocus:function(t){function i(){var t=this.document[0].activeElement,i=this.uiDialog[0]===t||e.contains(this.uiDialog[0],t);i||this._focusTabbable()}t.preventDefault(),i.call(this),this._delay(i)},_createWrapper:function(){this.uiDialog=e("<div>").addClass("ui-dialog ui-widget ui-widget-content ui-corner-all ui-front "+this.options.dialogClass).hide().attr({tabIndex:-1,role:"dialog"}).appendTo(this._appendTo()),this._on(this.uiDialog,{keydown:function(t){if(this.options.closeOnEscape&&!t.isDefaultPrevented()&&t.keyCode&&t.keyCode===e.ui.keyCode.ESCAPE)return t.preventDefault(),this.close(t),undefined;if(t.keyCode===e.ui.keyCode.TAB){var i=this.uiDialog.find(":tabbable"),a=i.filter(":first"),s=i.filter(":last");t.target!==s[0]&&t.target!==this.uiDialog[0]||t.shiftKey?t.target!==a[0]&&t.target!==this.uiDialog[0]||!t.shiftKey||(s.focus(1),t.preventDefault()):(a.focus(1),t.preventDefault())}},mousedown:function(e){this._moveToTop(e)&&this._focusTabbable()}}),this.element.find("[aria-describedby]").length||this.uiDialog.attr({"aria-describedby":this.element.uniqueId().attr("id")})},_createTitlebar:function(){var t;this.uiDialogTitlebar=e("<div>").addClass("ui-dialog-titlebar ui-widget-header ui-corner-all ui-helper-clearfix").prependTo(this.uiDialog),this._on(this.uiDialogTitlebar,{mousedown:function(t){e(t.target).closest(".ui-dialog-titlebar-close")||this.uiDialog.focus()}}),this.uiDialogTitlebarClose=e("<button type='button'></button>").button({label:this.options.closeText,icons:{primary:"ui-icon-closethick"},text:!1}).addClass("ui-dialog-titlebar-close").appendTo(this.uiDialogTitlebar),this._on(this.uiDialogTitlebarClose,{click:function(e){e.preventDefault(),this.close(e)}}),t=e("<span>").uniqueId().addClass("ui-dialog-title").prependTo(this.uiDialogTitlebar),this._title(t),this.uiDialog.attr({"aria-labelledby":t.attr("id")})},_title:function(e){this.options.title||e.html("&#160;"),e.text(this.options.title)},_createButtonPane:function(){this.uiDialogButtonPane=e("<div>").addClass("ui-dialog-buttonpane ui-widget-content ui-helper-clearfix"),this.uiButtonSet=e("<div>").addClass("ui-dialog-buttonset").appendTo(this.uiDialogButtonPane),this._createButtons()},_createButtons:function(){var t=this,i=this.options.buttons;return this.uiDialogButtonPane.remove(),this.uiButtonSet.empty(),e.isEmptyObject(i)||e.isArray(i)&&!i.length?(this.uiDialog.removeClass("ui-dialog-buttons"),undefined):(e.each(i,function(i,a){var s,n;a=e.isFunction(a)?{click:a,text:i}:a,a=e.extend({type:"button"},a),s=a.click,a.click=function(){s.apply(t.element[0],arguments)},n={icons:a.icons,text:a.showText},delete a.icons,delete a.showText,e("<button></button>",a).button(n).appendTo(t.uiButtonSet)}),this.uiDialog.addClass("ui-dialog-buttons"),this.uiDialogButtonPane.appendTo(this.uiDialog),undefined)},_makeDraggable:function(){function t(e){return{position:e.position,offset:e.offset}}var i=this,a=this.options;this.uiDialog.draggable({cancel:".ui-dialog-content, .ui-dialog-titlebar-close",handle:".ui-dialog-titlebar",containment:"document",start:function(a,s){e(this).addClass("ui-dialog-dragging"),i._blockFrames(),i._trigger("dragStart",a,t(s))},drag:function(e,a){i._trigger("drag",e,t(a))},stop:function(s,n){a.position=[n.position.left-i.document.scrollLeft(),n.position.top-i.document.scrollTop()],e(this).removeClass("ui-dialog-dragging"),i._unblockFrames(),i._trigger("dragStop",s,t(n))}})},_makeResizable:function(){function t(e){return{originalPosition:e.originalPosition,originalSize:e.originalSize,position:e.position,size:e.size}}var i=this,a=this.options,s=a.resizable,n=this.uiDialog.css("position"),r="string"==typeof s?s:"n,e,s,w,se,sw,ne,nw";this.uiDialog.resizable({cancel:".ui-dialog-content",containment:"document",alsoResize:this.element,maxWidth:a.maxWidth,maxHeight:a.maxHeight,minWidth:a.minWidth,minHeight:this._minHeight(),handles:r,start:function(a,s){e(this).addClass("ui-dialog-resizing"),i._blockFrames(),i._trigger("resizeStart",a,t(s))},resize:function(e,a){i._trigger("resize",e,t(a))},stop:function(s,n){a.height=e(this).height(),a.width=e(this).width(),e(this).removeClass("ui-dialog-resizing"),i._unblockFrames(),i._trigger("resizeStop",s,t(n))}}).css("position",n)},_minHeight:function(){var e=this.options;return"auto"===e.height?e.minHeight:Math.min(e.minHeight,e.height)},_position:function(){var e=this.uiDialog.is(":visible");e||this.uiDialog.show(),this.uiDialog.position(this.options.position),e||this.uiDialog.hide()},_setOptions:function(a){var s=this,n=!1,r={};e.each(a,function(e,a){s._setOption(e,a),e in t&&(n=!0),e in i&&(r[e]=a)}),n&&(this._size(),this._position()),this.uiDialog.is(":data(ui-resizable)")&&this.uiDialog.resizable("option",r)},_setOption:function(e,t){var i,a,s=this.uiDialog;"dialogClass"===e&&s.removeClass(this.options.dialogClass).addClass(t),"disabled"!==e&&(this._super(e,t),"appendTo"===e&&this.uiDialog.appendTo(this._appendTo()),"buttons"===e&&this._createButtons(),"closeText"===e&&this.uiDialogTitlebarClose.button({label:""+t}),"draggable"===e&&(i=s.is(":data(ui-draggable)"),i&&!t&&s.draggable("destroy"),!i&&t&&this._makeDraggable()),"position"===e&&this._position(),"resizable"===e&&(a=s.is(":data(ui-resizable)"),a&&!t&&s.resizable("destroy"),a&&"string"==typeof t&&s.resizable("option","handles",t),a||t===!1||this._makeResizable()),"title"===e&&this._title(this.uiDialogTitlebar.find(".ui-dialog-title")))},_size:function(){var e,t,i,a=this.options;this.element.show().css({width:"auto",minHeight:0,maxHeight:"none",height:0}),a.minWidth>a.width&&(a.width=a.minWidth),e=this.uiDialog.css({height:"auto",width:a.width}).outerHeight(),t=Math.max(0,a.minHeight-e),i="number"==typeof a.maxHeight?Math.max(0,a.maxHeight-e):"none","auto"===a.height?this.element.css({minHeight:t,maxHeight:i,height:"auto"}):this.element.height(Math.max(0,a.height-e)),this.uiDialog.is(":data(ui-resizable)")&&this.uiDialog.resizable("option","minHeight",this._minHeight())},_blockFrames:function(){this.iframeBlocks=this.document.find("iframe").map(function(){var t=e(this);return e("<div>").css({position:"absolute",width:t.outerWidth(),height:t.outerHeight()}).appendTo(t.parent()).offset(t.offset())[0]})},_unblockFrames:function(){this.iframeBlocks&&(this.iframeBlocks.remove(),delete this.iframeBlocks)},_allowInteraction:function(t){return e(t.target).closest(".ui-dialog").length?!0:!!e(t.target).closest(".ui-datepicker").length},_createOverlay:function(){if(this.options.modal){var t=this,i=this.widgetFullName;e.ui.dialog.overlayInstances||this._delay(function(){e.ui.dialog.overlayInstances&&this.document.bind("focusin.dialog",function(a){t._allowInteraction(a)||(a.preventDefault(),e(".ui-dialog:visible:last .ui-dialog-content").data(i)._focusTabbable())})}),this.overlay=e("<div>").addClass("ui-widget-overlay ui-front").appendTo(this._appendTo()),this._on(this.overlay,{mousedown:"_keepFocus"}),e.ui.dialog.overlayInstances++}},_destroyOverlay:function(){this.options.modal&&this.overlay&&(e.ui.dialog.overlayInstances--,e.ui.dialog.overlayInstances||this.document.unbind("focusin.dialog"),this.overlay.remove(),this.overlay=null)}}),e.ui.dialog.overlayInstances=0,e.uiBackCompat!==!1&&e.widget("ui.dialog",e.ui.dialog,{_position:function(){var t,i=this.options.position,a=[],s=[0,0];i?(("string"==typeof i||"object"==typeof i&&"0"in i)&&(a=i.split?i.split(" "):[i[0],i[1]],1===a.length&&(a[1]=a[0]),e.each(["left","top"],function(e,t){+a[e]===a[e]&&(s[e]=a[e],a[e]=t)}),i={my:a[0]+(0>s[0]?s[0]:"+"+s[0])+" "+a[1]+(0>s[1]?s[1]:"+"+s[1]),at:a.join(" ")}),i=e.extend({},e.ui.dialog.prototype.options.position,i)):i=e.ui.dialog.prototype.options.position,t=this.uiDialog.is(":visible"),t||this.uiDialog.show(),this.uiDialog.position(i),t||this.uiDialog.hide()}})})(jQuery);(function(t){t.widget("ui.menu",{version:"1.10.4",defaultElement:"<ul>",delay:300,options:{icons:{submenu:"ui-icon-carat-1-e"},menus:"ul",position:{my:"left top",at:"right top"},role:"menu",blur:null,focus:null,select:null},_create:function(){this.activeMenu=this.element,this.mouseHandled=!1,this.element.uniqueId().addClass("ui-menu ui-widget ui-widget-content ui-corner-all").toggleClass("ui-menu-icons",!!this.element.find(".ui-icon").length).attr({role:this.options.role,tabIndex:0}).bind("click"+this.eventNamespace,t.proxy(function(t){this.options.disabled&&t.preventDefault()},this)),this.options.disabled&&this.element.addClass("ui-state-disabled").attr("aria-disabled","true"),this._on({"mousedown .ui-menu-item > a":function(t){t.preventDefault()},"click .ui-state-disabled > a":function(t){t.preventDefault()},"click .ui-menu-item:has(a)":function(e){var i=t(e.target).closest(".ui-menu-item");!this.mouseHandled&&i.not(".ui-state-disabled").length&&(this.select(e),e.isPropagationStopped()||(this.mouseHandled=!0),i.has(".ui-menu").length?this.expand(e):!this.element.is(":focus")&&t(this.document[0].activeElement).closest(".ui-menu").length&&(this.element.trigger("focus",[!0]),this.active&&1===this.active.parents(".ui-menu").length&&clearTimeout(this.timer)))},"mouseenter .ui-menu-item":function(e){var i=t(e.currentTarget);i.siblings().children(".ui-state-active").removeClass("ui-state-active"),this.focus(e,i)},mouseleave:"collapseAll","mouseleave .ui-menu":"collapseAll",focus:function(t,e){var i=this.active||this.element.children(".ui-menu-item").eq(0);e||this.focus(t,i)},blur:function(e){this._delay(function(){t.contains(this.element[0],this.document[0].activeElement)||this.collapseAll(e)})},keydown:"_keydown"}),this.refresh(),this._on(this.document,{click:function(e){t(e.target).closest(".ui-menu").length||this.collapseAll(e),this.mouseHandled=!1}})},_destroy:function(){this.element.removeAttr("aria-activedescendant").find(".ui-menu").addBack().removeClass("ui-menu ui-widget ui-widget-content ui-corner-all ui-menu-icons").removeAttr("role").removeAttr("tabIndex").removeAttr("aria-labelledby").removeAttr("aria-expanded").removeAttr("aria-hidden").removeAttr("aria-disabled").removeUniqueId().show(),this.element.find(".ui-menu-item").removeClass("ui-menu-item").removeAttr("role").removeAttr("aria-disabled").children("a").removeUniqueId().removeClass("ui-corner-all ui-state-hover").removeAttr("tabIndex").removeAttr("role").removeAttr("aria-haspopup").children().each(function(){var e=t(this);e.data("ui-menu-submenu-carat")&&e.remove()}),this.element.find(".ui-menu-divider").removeClass("ui-menu-divider ui-widget-content")},_keydown:function(e){function i(t){return t.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g,"\\$&")}var s,n,a,o,r,l=!0;switch(e.keyCode){case t.ui.keyCode.PAGE_UP:this.previousPage(e);break;case t.ui.keyCode.PAGE_DOWN:this.nextPage(e);break;case t.ui.keyCode.HOME:this._move("first","first",e);break;case t.ui.keyCode.END:this._move("last","last",e);break;case t.ui.keyCode.UP:this.previous(e);break;case t.ui.keyCode.DOWN:this.next(e);break;case t.ui.keyCode.LEFT:this.collapse(e);break;case t.ui.keyCode.RIGHT:this.active&&!this.active.is(".ui-state-disabled")&&this.expand(e);break;case t.ui.keyCode.ENTER:case t.ui.keyCode.SPACE:this._activate(e);break;case t.ui.keyCode.ESCAPE:this.collapse(e);break;default:l=!1,n=this.previousFilter||"",a=String.fromCharCode(e.keyCode),o=!1,clearTimeout(this.filterTimer),a===n?o=!0:a=n+a,r=RegExp("^"+i(a),"i"),s=this.activeMenu.children(".ui-menu-item").filter(function(){return r.test(t(this).children("a").text())}),s=o&&-1!==s.index(this.active.next())?this.active.nextAll(".ui-menu-item"):s,s.length||(a=String.fromCharCode(e.keyCode),r=RegExp("^"+i(a),"i"),s=this.activeMenu.children(".ui-menu-item").filter(function(){return r.test(t(this).children("a").text())})),s.length?(this.focus(e,s),s.length>1?(this.previousFilter=a,this.filterTimer=this._delay(function(){delete this.previousFilter},1e3)):delete this.previousFilter):delete this.previousFilter}l&&e.preventDefault()},_activate:function(t){this.active.is(".ui-state-disabled")||(this.active.children("a[aria-haspopup='true']").length?this.expand(t):this.select(t))},refresh:function(){var e,i=this.options.icons.submenu,s=this.element.find(this.options.menus);this.element.toggleClass("ui-menu-icons",!!this.element.find(".ui-icon").length),s.filter(":not(.ui-menu)").addClass("ui-menu ui-widget ui-widget-content ui-corner-all").hide().attr({role:this.options.role,"aria-hidden":"true","aria-expanded":"false"}).each(function(){var e=t(this),s=e.prev("a"),n=t("<span>").addClass("ui-menu-icon ui-icon "+i).data("ui-menu-submenu-carat",!0);s.attr("aria-haspopup","true").prepend(n),e.attr("aria-labelledby",s.attr("id"))}),e=s.add(this.element),e.children(":not(.ui-menu-item):has(a)").addClass("ui-menu-item").attr("role","presentation").children("a").uniqueId().addClass("ui-corner-all").attr({tabIndex:-1,role:this._itemRole()}),e.children(":not(.ui-menu-item)").each(function(){var e=t(this);/[^\-\u2014\u2013\s]/.test(e.text())||e.addClass("ui-widget-content ui-menu-divider")}),e.children(".ui-state-disabled").attr("aria-disabled","true"),this.active&&!t.contains(this.element[0],this.active[0])&&this.blur()},_itemRole:function(){return{menu:"menuitem",listbox:"option"}[this.options.role]},_setOption:function(t,e){"icons"===t&&this.element.find(".ui-menu-icon").removeClass(this.options.icons.submenu).addClass(e.submenu),this._super(t,e)},focus:function(t,e){var i,s;this.blur(t,t&&"focus"===t.type),this._scrollIntoView(e),this.active=e.first(),s=this.active.children("a").addClass("ui-state-focus"),this.options.role&&this.element.attr("aria-activedescendant",s.attr("id")),this.active.parent().closest(".ui-menu-item").children("a:first").addClass("ui-state-active"),t&&"keydown"===t.type?this._close():this.timer=this._delay(function(){this._close()},this.delay),i=e.children(".ui-menu"),i.length&&t&&/^mouse/.test(t.type)&&this._startOpening(i),this.activeMenu=e.parent(),this._trigger("focus",t,{item:e})},_scrollIntoView:function(e){var i,s,n,a,o,r;this._hasScroll()&&(i=parseFloat(t.css(this.activeMenu[0],"borderTopWidth"))||0,s=parseFloat(t.css(this.activeMenu[0],"paddingTop"))||0,n=e.offset().top-this.activeMenu.offset().top-i-s,a=this.activeMenu.scrollTop(),o=this.activeMenu.height(),r=e.height(),0>n?this.activeMenu.scrollTop(a+n):n+r>o&&this.activeMenu.scrollTop(a+n-o+r))},blur:function(t,e){e||clearTimeout(this.timer),this.active&&(this.active.children("a").removeClass("ui-state-focus"),this.active=null,this._trigger("blur",t,{item:this.active}))},_startOpening:function(t){clearTimeout(this.timer),"true"===t.attr("aria-hidden")&&(this.timer=this._delay(function(){this._close(),this._open(t)},this.delay))},_open:function(e){var i=t.extend({of:this.active},this.options.position);clearTimeout(this.timer),this.element.find(".ui-menu").not(e.parents(".ui-menu")).hide().attr("aria-hidden","true"),e.show().removeAttr("aria-hidden").attr("aria-expanded","true").position(i)},collapseAll:function(e,i){clearTimeout(this.timer),this.timer=this._delay(function(){var s=i?this.element:t(e&&e.target).closest(this.element.find(".ui-menu"));s.length||(s=this.element),this._close(s),this.blur(e),this.activeMenu=s},this.delay)},_close:function(t){t||(t=this.active?this.active.parent():this.element),t.find(".ui-menu").hide().attr("aria-hidden","true").attr("aria-expanded","false").end().find("a.ui-state-active").removeClass("ui-state-active")},collapse:function(t){var e=this.active&&this.active.parent().closest(".ui-menu-item",this.element);e&&e.length&&(this._close(),this.focus(t,e))},expand:function(t){var e=this.active&&this.active.children(".ui-menu ").children(".ui-menu-item").first();e&&e.length&&(this._open(e.parent()),this._delay(function(){this.focus(t,e)}))},next:function(t){this._move("next","first",t)},previous:function(t){this._move("prev","last",t)},isFirstItem:function(){return this.active&&!this.active.prevAll(".ui-menu-item").length},isLastItem:function(){return this.active&&!this.active.nextAll(".ui-menu-item").length},_move:function(t,e,i){var s;this.active&&(s="first"===t||"last"===t?this.active["first"===t?"prevAll":"nextAll"](".ui-menu-item").eq(-1):this.active[t+"All"](".ui-menu-item").eq(0)),s&&s.length&&this.active||(s=this.activeMenu.children(".ui-menu-item")[e]()),this.focus(i,s)},nextPage:function(e){var i,s,n;return this.active?(this.isLastItem()||(this._hasScroll()?(s=this.active.offset().top,n=this.element.height(),this.active.nextAll(".ui-menu-item").each(function(){return i=t(this),0>i.offset().top-s-n}),this.focus(e,i)):this.focus(e,this.activeMenu.children(".ui-menu-item")[this.active?"last":"first"]())),undefined):(this.next(e),undefined)},previousPage:function(e){var i,s,n;return this.active?(this.isFirstItem()||(this._hasScroll()?(s=this.active.offset().top,n=this.element.height(),this.active.prevAll(".ui-menu-item").each(function(){return i=t(this),i.offset().top-s+n>0}),this.focus(e,i)):this.focus(e,this.activeMenu.children(".ui-menu-item").first())),undefined):(this.next(e),undefined)},_hasScroll:function(){return this.element.outerHeight()<this.element.prop("scrollHeight")},select:function(e){this.active=this.active||t(e.target).closest(".ui-menu-item");var i={item:this.active};this.active.has(".ui-menu").length||this.collapseAll(e,!0),this._trigger("select",e,i)}})})(jQuery);(function(t,e){t.widget("ui.progressbar",{version:"1.10.4",options:{max:100,value:0,change:null,complete:null},min:0,_create:function(){this.oldValue=this.options.value=this._constrainedValue(),this.element.addClass("ui-progressbar ui-widget ui-widget-content ui-corner-all").attr({role:"progressbar","aria-valuemin":this.min}),this.valueDiv=t("<div class='ui-progressbar-value ui-widget-header ui-corner-left'></div>").appendTo(this.element),this._refreshValue()},_destroy:function(){this.element.removeClass("ui-progressbar ui-widget ui-widget-content ui-corner-all").removeAttr("role").removeAttr("aria-valuemin").removeAttr("aria-valuemax").removeAttr("aria-valuenow"),this.valueDiv.remove()},value:function(t){return t===e?this.options.value:(this.options.value=this._constrainedValue(t),this._refreshValue(),e)},_constrainedValue:function(t){return t===e&&(t=this.options.value),this.indeterminate=t===!1,"number"!=typeof t&&(t=0),this.indeterminate?!1:Math.min(this.options.max,Math.max(this.min,t))},_setOptions:function(t){var e=t.value;delete t.value,this._super(t),this.options.value=this._constrainedValue(e),this._refreshValue()},_setOption:function(t,e){"max"===t&&(e=Math.max(this.min,e)),this._super(t,e)},_percentage:function(){return this.indeterminate?100:100*(this.options.value-this.min)/(this.options.max-this.min)},_refreshValue:function(){var e=this.options.value,i=this._percentage();this.valueDiv.toggle(this.indeterminate||e>this.min).toggleClass("ui-corner-right",e===this.options.max).width(i.toFixed(0)+"%"),this.element.toggleClass("ui-progressbar-indeterminate",this.indeterminate),this.indeterminate?(this.element.removeAttr("aria-valuenow"),this.overlayDiv||(this.overlayDiv=t("<div class='ui-progressbar-overlay'></div>").appendTo(this.valueDiv))):(this.element.attr({"aria-valuemax":this.options.max,"aria-valuenow":e}),this.overlayDiv&&(this.overlayDiv.remove(),this.overlayDiv=null)),this.oldValue!==e&&(this.oldValue=e,this._trigger("change")),e===this.options.max&&this._trigger("complete")}})})(jQuery);(function(t){var e=5;t.widget("ui.slider",t.ui.mouse,{version:"1.10.4",widgetEventPrefix:"slide",options:{animate:!1,distance:0,max:100,min:0,orientation:"horizontal",range:!1,step:1,value:0,values:null,change:null,slide:null,start:null,stop:null},_create:function(){this._keySliding=!1,this._mouseSliding=!1,this._animateOff=!0,this._handleIndex=null,this._detectOrientation(),this._mouseInit(),this.element.addClass("ui-slider ui-slider-"+this.orientation+" ui-widget"+" ui-widget-content"+" ui-corner-all"),this._refresh(),this._setOption("disabled",this.options.disabled),this._animateOff=!1},_refresh:function(){this._createRange(),this._createHandles(),this._setupEvents(),this._refreshValue()},_createHandles:function(){var e,i,s=this.options,n=this.element.find(".ui-slider-handle").addClass("ui-state-default ui-corner-all"),a="<a class='ui-slider-handle ui-state-default ui-corner-all' href='#'></a>",o=[];for(i=s.values&&s.values.length||1,n.length>i&&(n.slice(i).remove(),n=n.slice(0,i)),e=n.length;i>e;e++)o.push(a);this.handles=n.add(t(o.join("")).appendTo(this.element)),this.handle=this.handles.eq(0),this.handles.each(function(e){t(this).data("ui-slider-handle-index",e)})},_createRange:function(){var e=this.options,i="";e.range?(e.range===!0&&(e.values?e.values.length&&2!==e.values.length?e.values=[e.values[0],e.values[0]]:t.isArray(e.values)&&(e.values=e.values.slice(0)):e.values=[this._valueMin(),this._valueMin()]),this.range&&this.range.length?this.range.removeClass("ui-slider-range-min ui-slider-range-max").css({left:"",bottom:""}):(this.range=t("<div></div>").appendTo(this.element),i="ui-slider-range ui-widget-header ui-corner-all"),this.range.addClass(i+("min"===e.range||"max"===e.range?" ui-slider-range-"+e.range:""))):(this.range&&this.range.remove(),this.range=null)},_setupEvents:function(){var t=this.handles.add(this.range).filter("a");this._off(t),this._on(t,this._handleEvents),this._hoverable(t),this._focusable(t)},_destroy:function(){this.handles.remove(),this.range&&this.range.remove(),this.element.removeClass("ui-slider ui-slider-horizontal ui-slider-vertical ui-widget ui-widget-content ui-corner-all"),this._mouseDestroy()},_mouseCapture:function(e){var i,s,n,a,o,r,l,h,u=this,c=this.options;return c.disabled?!1:(this.elementSize={width:this.element.outerWidth(),height:this.element.outerHeight()},this.elementOffset=this.element.offset(),i={x:e.pageX,y:e.pageY},s=this._normValueFromMouse(i),n=this._valueMax()-this._valueMin()+1,this.handles.each(function(e){var i=Math.abs(s-u.values(e));(n>i||n===i&&(e===u._lastChangedValue||u.values(e)===c.min))&&(n=i,a=t(this),o=e)}),r=this._start(e,o),r===!1?!1:(this._mouseSliding=!0,this._handleIndex=o,a.addClass("ui-state-active").focus(),l=a.offset(),h=!t(e.target).parents().addBack().is(".ui-slider-handle"),this._clickOffset=h?{left:0,top:0}:{left:e.pageX-l.left-a.width()/2,top:e.pageY-l.top-a.height()/2-(parseInt(a.css("borderTopWidth"),10)||0)-(parseInt(a.css("borderBottomWidth"),10)||0)+(parseInt(a.css("marginTop"),10)||0)},this.handles.hasClass("ui-state-hover")||this._slide(e,o,s),this._animateOff=!0,!0))},_mouseStart:function(){return!0},_mouseDrag:function(t){var e={x:t.pageX,y:t.pageY},i=this._normValueFromMouse(e);return this._slide(t,this._handleIndex,i),!1},_mouseStop:function(t){return this.handles.removeClass("ui-state-active"),this._mouseSliding=!1,this._stop(t,this._handleIndex),this._change(t,this._handleIndex),this._handleIndex=null,this._clickOffset=null,this._animateOff=!1,!1},_detectOrientation:function(){this.orientation="vertical"===this.options.orientation?"vertical":"horizontal"},_normValueFromMouse:function(t){var e,i,s,n,a;return"horizontal"===this.orientation?(e=this.elementSize.width,i=t.x-this.elementOffset.left-(this._clickOffset?this._clickOffset.left:0)):(e=this.elementSize.height,i=t.y-this.elementOffset.top-(this._clickOffset?this._clickOffset.top:0)),s=i/e,s>1&&(s=1),0>s&&(s=0),"vertical"===this.orientation&&(s=1-s),n=this._valueMax()-this._valueMin(),a=this._valueMin()+s*n,this._trimAlignValue(a)},_start:function(t,e){var i={handle:this.handles[e],value:this.value()};return this.options.values&&this.options.values.length&&(i.value=this.values(e),i.values=this.values()),this._trigger("start",t,i)},_slide:function(t,e,i){var s,n,a;this.options.values&&this.options.values.length?(s=this.values(e?0:1),2===this.options.values.length&&this.options.range===!0&&(0===e&&i>s||1===e&&s>i)&&(i=s),i!==this.values(e)&&(n=this.values(),n[e]=i,a=this._trigger("slide",t,{handle:this.handles[e],value:i,values:n}),s=this.values(e?0:1),a!==!1&&this.values(e,i))):i!==this.value()&&(a=this._trigger("slide",t,{handle:this.handles[e],value:i}),a!==!1&&this.value(i))},_stop:function(t,e){var i={handle:this.handles[e],value:this.value()};this.options.values&&this.options.values.length&&(i.value=this.values(e),i.values=this.values()),this._trigger("stop",t,i)},_change:function(t,e){if(!this._keySliding&&!this._mouseSliding){var i={handle:this.handles[e],value:this.value()};this.options.values&&this.options.values.length&&(i.value=this.values(e),i.values=this.values()),this._lastChangedValue=e,this._trigger("change",t,i)}},value:function(t){return arguments.length?(this.options.value=this._trimAlignValue(t),this._refreshValue(),this._change(null,0),undefined):this._value()},values:function(e,i){var s,n,a;if(arguments.length>1)return this.options.values[e]=this._trimAlignValue(i),this._refreshValue(),this._change(null,e),undefined;if(!arguments.length)return this._values();if(!t.isArray(arguments[0]))return this.options.values&&this.options.values.length?this._values(e):this.value();for(s=this.options.values,n=arguments[0],a=0;s.length>a;a+=1)s[a]=this._trimAlignValue(n[a]),this._change(null,a);this._refreshValue()},_setOption:function(e,i){var s,n=0;switch("range"===e&&this.options.range===!0&&("min"===i?(this.options.value=this._values(0),this.options.values=null):"max"===i&&(this.options.value=this._values(this.options.values.length-1),this.options.values=null)),t.isArray(this.options.values)&&(n=this.options.values.length),t.Widget.prototype._setOption.apply(this,arguments),e){case"orientation":this._detectOrientation(),this.element.removeClass("ui-slider-horizontal ui-slider-vertical").addClass("ui-slider-"+this.orientation),this._refreshValue();break;case"value":this._animateOff=!0,this._refreshValue(),this._change(null,0),this._animateOff=!1;break;case"values":for(this._animateOff=!0,this._refreshValue(),s=0;n>s;s+=1)this._change(null,s);this._animateOff=!1;break;case"min":case"max":this._animateOff=!0,this._refreshValue(),this._animateOff=!1;break;case"range":this._animateOff=!0,this._refresh(),this._animateOff=!1}},_value:function(){var t=this.options.value;return t=this._trimAlignValue(t)},_values:function(t){var e,i,s;if(arguments.length)return e=this.options.values[t],e=this._trimAlignValue(e);if(this.options.values&&this.options.values.length){for(i=this.options.values.slice(),s=0;i.length>s;s+=1)i[s]=this._trimAlignValue(i[s]);return i}return[]},_trimAlignValue:function(t){if(this._valueMin()>=t)return this._valueMin();if(t>=this._valueMax())return this._valueMax();var e=this.options.step>0?this.options.step:1,i=(t-this._valueMin())%e,s=t-i;return 2*Math.abs(i)>=e&&(s+=i>0?e:-e),parseFloat(s.toFixed(5))},_valueMin:function(){return this.options.min},_valueMax:function(){return this.options.max},_refreshValue:function(){var e,i,s,n,a,o=this.options.range,r=this.options,l=this,h=this._animateOff?!1:r.animate,u={};this.options.values&&this.options.values.length?this.handles.each(function(s){i=100*((l.values(s)-l._valueMin())/(l._valueMax()-l._valueMin())),u["horizontal"===l.orientation?"left":"bottom"]=i+"%",t(this).stop(1,1)[h?"animate":"css"](u,r.animate),l.options.range===!0&&("horizontal"===l.orientation?(0===s&&l.range.stop(1,1)[h?"animate":"css"]({left:i+"%"},r.animate),1===s&&l.range[h?"animate":"css"]({width:i-e+"%"},{queue:!1,duration:r.animate})):(0===s&&l.range.stop(1,1)[h?"animate":"css"]({bottom:i+"%"},r.animate),1===s&&l.range[h?"animate":"css"]({height:i-e+"%"},{queue:!1,duration:r.animate}))),e=i}):(s=this.value(),n=this._valueMin(),a=this._valueMax(),i=a!==n?100*((s-n)/(a-n)):0,u["horizontal"===this.orientation?"left":"bottom"]=i+"%",this.handle.stop(1,1)[h?"animate":"css"](u,r.animate),"min"===o&&"horizontal"===this.orientation&&this.range.stop(1,1)[h?"animate":"css"]({width:i+"%"},r.animate),"max"===o&&"horizontal"===this.orientation&&this.range[h?"animate":"css"]({width:100-i+"%"},{queue:!1,duration:r.animate}),"min"===o&&"vertical"===this.orientation&&this.range.stop(1,1)[h?"animate":"css"]({height:i+"%"},r.animate),"max"===o&&"vertical"===this.orientation&&this.range[h?"animate":"css"]({height:100-i+"%"},{queue:!1,duration:r.animate}))},_handleEvents:{keydown:function(i){var s,n,a,o,r=t(i.target).data("ui-slider-handle-index");switch(i.keyCode){case t.ui.keyCode.HOME:case t.ui.keyCode.END:case t.ui.keyCode.PAGE_UP:case t.ui.keyCode.PAGE_DOWN:case t.ui.keyCode.UP:case t.ui.keyCode.RIGHT:case t.ui.keyCode.DOWN:case t.ui.keyCode.LEFT:if(i.preventDefault(),!this._keySliding&&(this._keySliding=!0,t(i.target).addClass("ui-state-active"),s=this._start(i,r),s===!1))return}switch(o=this.options.step,n=a=this.options.values&&this.options.values.length?this.values(r):this.value(),i.keyCode){case t.ui.keyCode.HOME:a=this._valueMin();break;case t.ui.keyCode.END:a=this._valueMax();break;case t.ui.keyCode.PAGE_UP:a=this._trimAlignValue(n+(this._valueMax()-this._valueMin())/e);break;case t.ui.keyCode.PAGE_DOWN:a=this._trimAlignValue(n-(this._valueMax()-this._valueMin())/e);break;case t.ui.keyCode.UP:case t.ui.keyCode.RIGHT:if(n===this._valueMax())return;a=this._trimAlignValue(n+o);break;case t.ui.keyCode.DOWN:case t.ui.keyCode.LEFT:if(n===this._valueMin())return;a=this._trimAlignValue(n-o)}this._slide(i,r,a)},click:function(t){t.preventDefault()},keyup:function(e){var i=t(e.target).data("ui-slider-handle-index");this._keySliding&&(this._keySliding=!1,this._stop(e,i),this._change(e,i),t(e.target).removeClass("ui-state-active"))}}})})(jQuery);(function(t){function e(t){return function(){var e=this.element.val();t.apply(this,arguments),this._refresh(),e!==this.element.val()&&this._trigger("change")}}t.widget("ui.spinner",{version:"1.10.4",defaultElement:"<input>",widgetEventPrefix:"spin",options:{culture:null,icons:{down:"ui-icon-triangle-1-s",up:"ui-icon-triangle-1-n"},incremental:!0,max:null,min:null,numberFormat:null,page:10,step:1,change:null,spin:null,start:null,stop:null},_create:function(){this._setOption("max",this.options.max),this._setOption("min",this.options.min),this._setOption("step",this.options.step),""!==this.value()&&this._value(this.element.val(),!0),this._draw(),this._on(this._events),this._refresh(),this._on(this.window,{beforeunload:function(){this.element.removeAttr("autocomplete")}})},_getCreateOptions:function(){var e={},i=this.element;return t.each(["min","max","step"],function(t,s){var n=i.attr(s);void 0!==n&&n.length&&(e[s]=n)}),e},_events:{keydown:function(t){this._start(t)&&this._keydown(t)&&t.preventDefault()},keyup:"_stop",focus:function(){this.previous=this.element.val()},blur:function(t){return this.cancelBlur?(delete this.cancelBlur,void 0):(this._stop(),this._refresh(),this.previous!==this.element.val()&&this._trigger("change",t),void 0)},mousewheel:function(t,e){if(e){if(!this.spinning&&!this._start(t))return!1;this._spin((e>0?1:-1)*this.options.step,t),clearTimeout(this.mousewheelTimer),this.mousewheelTimer=this._delay(function(){this.spinning&&this._stop(t)},100),t.preventDefault()}},"mousedown .ui-spinner-button":function(e){function i(){var t=this.element[0]===this.document[0].activeElement;t||(this.element.focus(),this.previous=s,this._delay(function(){this.previous=s}))}var s;s=this.element[0]===this.document[0].activeElement?this.previous:this.element.val(),e.preventDefault(),i.call(this),this.cancelBlur=!0,this._delay(function(){delete this.cancelBlur,i.call(this)}),this._start(e)!==!1&&this._repeat(null,t(e.currentTarget).hasClass("ui-spinner-up")?1:-1,e)},"mouseup .ui-spinner-button":"_stop","mouseenter .ui-spinner-button":function(e){return t(e.currentTarget).hasClass("ui-state-active")?this._start(e)===!1?!1:(this._repeat(null,t(e.currentTarget).hasClass("ui-spinner-up")?1:-1,e),void 0):void 0},"mouseleave .ui-spinner-button":"_stop"},_draw:function(){var t=this.uiSpinner=this.element.addClass("ui-spinner-input").attr("autocomplete","off").wrap(this._uiSpinnerHtml()).parent().append(this._buttonHtml());this.element.attr("role","spinbutton"),this.buttons=t.find(".ui-spinner-button").attr("tabIndex",-1).button().removeClass("ui-corner-all"),this.buttons.height()>Math.ceil(.5*t.height())&&t.height()>0&&t.height(t.height()),this.options.disabled&&this.disable()},_keydown:function(e){var i=this.options,s=t.ui.keyCode;switch(e.keyCode){case s.UP:return this._repeat(null,1,e),!0;case s.DOWN:return this._repeat(null,-1,e),!0;case s.PAGE_UP:return this._repeat(null,i.page,e),!0;case s.PAGE_DOWN:return this._repeat(null,-i.page,e),!0}return!1},_uiSpinnerHtml:function(){return"<span class='ui-spinner ui-widget ui-widget-content ui-corner-all'></span>"},_buttonHtml:function(){return"<a class='ui-spinner-button ui-spinner-up ui-corner-tr'><span class='ui-icon "+this.options.icons.up+"'>&#9650;</span>"+"</a>"+"<a class='ui-spinner-button ui-spinner-down ui-corner-br'>"+"<span class='ui-icon "+this.options.icons.down+"'>&#9660;</span>"+"</a>"},_start:function(t){return this.spinning||this._trigger("start",t)!==!1?(this.counter||(this.counter=1),this.spinning=!0,!0):!1},_repeat:function(t,e,i){t=t||500,clearTimeout(this.timer),this.timer=this._delay(function(){this._repeat(40,e,i)},t),this._spin(e*this.options.step,i)},_spin:function(t,e){var i=this.value()||0;this.counter||(this.counter=1),i=this._adjustValue(i+t*this._increment(this.counter)),this.spinning&&this._trigger("spin",e,{value:i})===!1||(this._value(i),this.counter++)},_increment:function(e){var i=this.options.incremental;return i?t.isFunction(i)?i(e):Math.floor(e*e*e/5e4-e*e/500+17*e/200+1):1},_precision:function(){var t=this._precisionOf(this.options.step);return null!==this.options.min&&(t=Math.max(t,this._precisionOf(this.options.min))),t},_precisionOf:function(t){var e=""+t,i=e.indexOf(".");return-1===i?0:e.length-i-1},_adjustValue:function(t){var e,i,s=this.options;return e=null!==s.min?s.min:0,i=t-e,i=Math.round(i/s.step)*s.step,t=e+i,t=parseFloat(t.toFixed(this._precision())),null!==s.max&&t>s.max?s.max:null!==s.min&&s.min>t?s.min:t},_stop:function(t){this.spinning&&(clearTimeout(this.timer),clearTimeout(this.mousewheelTimer),this.counter=0,this.spinning=!1,this._trigger("stop",t))},_setOption:function(t,e){if("culture"===t||"numberFormat"===t){var i=this._parse(this.element.val());return this.options[t]=e,this.element.val(this._format(i)),void 0}("max"===t||"min"===t||"step"===t)&&"string"==typeof e&&(e=this._parse(e)),"icons"===t&&(this.buttons.first().find(".ui-icon").removeClass(this.options.icons.up).addClass(e.up),this.buttons.last().find(".ui-icon").removeClass(this.options.icons.down).addClass(e.down)),this._super(t,e),"disabled"===t&&(e?(this.element.prop("disabled",!0),this.buttons.button("disable")):(this.element.prop("disabled",!1),this.buttons.button("enable")))},_setOptions:e(function(t){this._super(t),this._value(this.element.val())}),_parse:function(t){return"string"==typeof t&&""!==t&&(t=window.Globalize&&this.options.numberFormat?Globalize.parseFloat(t,10,this.options.culture):+t),""===t||isNaN(t)?null:t},_format:function(t){return""===t?"":window.Globalize&&this.options.numberFormat?Globalize.format(t,this.options.numberFormat,this.options.culture):t},_refresh:function(){this.element.attr({"aria-valuemin":this.options.min,"aria-valuemax":this.options.max,"aria-valuenow":this._parse(this.element.val())})},_value:function(t,e){var i;""!==t&&(i=this._parse(t),null!==i&&(e||(i=this._adjustValue(i)),t=this._format(i))),this.element.val(t),this._refresh()},_destroy:function(){this.element.removeClass("ui-spinner-input").prop("disabled",!1).removeAttr("autocomplete").removeAttr("role").removeAttr("aria-valuemin").removeAttr("aria-valuemax").removeAttr("aria-valuenow"),this.uiSpinner.replaceWith(this.element)},stepUp:e(function(t){this._stepUp(t)}),_stepUp:function(t){this._start()&&(this._spin((t||1)*this.options.step),this._stop())},stepDown:e(function(t){this._stepDown(t)}),_stepDown:function(t){this._start()&&(this._spin((t||1)*-this.options.step),this._stop())},pageUp:e(function(t){this._stepUp((t||1)*this.options.page)}),pageDown:e(function(t){this._stepDown((t||1)*this.options.page)}),value:function(t){return arguments.length?(e(this._value).call(this,t),void 0):this._parse(this.element.val())},widget:function(){return this.uiSpinner}})})(jQuery);(function(t,e){function i(){return++n}function s(t){return t=t.cloneNode(!1),t.hash.length>1&&decodeURIComponent(t.href.replace(a,""))===decodeURIComponent(location.href.replace(a,""))}var n=0,a=/#.*$/;t.widget("ui.tabs",{version:"1.10.4",delay:300,options:{active:null,collapsible:!1,event:"click",heightStyle:"content",hide:null,show:null,activate:null,beforeActivate:null,beforeLoad:null,load:null},_create:function(){var e=this,i=this.options;this.running=!1,this.element.addClass("ui-tabs ui-widget ui-widget-content ui-corner-all").toggleClass("ui-tabs-collapsible",i.collapsible).delegate(".ui-tabs-nav > li","mousedown"+this.eventNamespace,function(e){t(this).is(".ui-state-disabled")&&e.preventDefault()}).delegate(".ui-tabs-anchor","focus"+this.eventNamespace,function(){t(this).closest("li").is(".ui-state-disabled")&&this.blur()}),this._processTabs(),i.active=this._initialActive(),t.isArray(i.disabled)&&(i.disabled=t.unique(i.disabled.concat(t.map(this.tabs.filter(".ui-state-disabled"),function(t){return e.tabs.index(t)}))).sort()),this.active=this.options.active!==!1&&this.anchors.length?this._findActive(i.active):t(),this._refresh(),this.active.length&&this.load(i.active)},_initialActive:function(){var i=this.options.active,s=this.options.collapsible,n=location.hash.substring(1);return null===i&&(n&&this.tabs.each(function(s,a){return t(a).attr("aria-controls")===n?(i=s,!1):e}),null===i&&(i=this.tabs.index(this.tabs.filter(".ui-tabs-active"))),(null===i||-1===i)&&(i=this.tabs.length?0:!1)),i!==!1&&(i=this.tabs.index(this.tabs.eq(i)),-1===i&&(i=s?!1:0)),!s&&i===!1&&this.anchors.length&&(i=0),i},_getCreateEventData:function(){return{tab:this.active,panel:this.active.length?this._getPanelForTab(this.active):t()}},_tabKeydown:function(i){var s=t(this.document[0].activeElement).closest("li"),n=this.tabs.index(s),a=!0;if(!this._handlePageNav(i)){switch(i.keyCode){case t.ui.keyCode.RIGHT:case t.ui.keyCode.DOWN:n++;break;case t.ui.keyCode.UP:case t.ui.keyCode.LEFT:a=!1,n--;break;case t.ui.keyCode.END:n=this.anchors.length-1;break;case t.ui.keyCode.HOME:n=0;break;case t.ui.keyCode.SPACE:return i.preventDefault(),clearTimeout(this.activating),this._activate(n),e;case t.ui.keyCode.ENTER:return i.preventDefault(),clearTimeout(this.activating),this._activate(n===this.options.active?!1:n),e;default:return}i.preventDefault(),clearTimeout(this.activating),n=this._focusNextTab(n,a),i.ctrlKey||(s.attr("aria-selected","false"),this.tabs.eq(n).attr("aria-selected","true"),this.activating=this._delay(function(){this.option("active",n)},this.delay))}},_panelKeydown:function(e){this._handlePageNav(e)||e.ctrlKey&&e.keyCode===t.ui.keyCode.UP&&(e.preventDefault(),this.active.focus())},_handlePageNav:function(i){return i.altKey&&i.keyCode===t.ui.keyCode.PAGE_UP?(this._activate(this._focusNextTab(this.options.active-1,!1)),!0):i.altKey&&i.keyCode===t.ui.keyCode.PAGE_DOWN?(this._activate(this._focusNextTab(this.options.active+1,!0)),!0):e},_findNextTab:function(e,i){function s(){return e>n&&(e=0),0>e&&(e=n),e}for(var n=this.tabs.length-1;-1!==t.inArray(s(),this.options.disabled);)e=i?e+1:e-1;return e},_focusNextTab:function(t,e){return t=this._findNextTab(t,e),this.tabs.eq(t).focus(),t},_setOption:function(t,i){return"active"===t?(this._activate(i),e):"disabled"===t?(this._setupDisabled(i),e):(this._super(t,i),"collapsible"===t&&(this.element.toggleClass("ui-tabs-collapsible",i),i||this.options.active!==!1||this._activate(0)),"event"===t&&this._setupEvents(i),"heightStyle"===t&&this._setupHeightStyle(i),e)},_tabId:function(t){return t.attr("aria-controls")||"ui-tabs-"+i()},_sanitizeSelector:function(t){return t?t.replace(/[!"$%&'()*+,.\/:;<=>?@\[\]\^`{|}~]/g,"\\$&"):""},refresh:function(){var e=this.options,i=this.tablist.children(":has(a[href])");e.disabled=t.map(i.filter(".ui-state-disabled"),function(t){return i.index(t)}),this._processTabs(),e.active!==!1&&this.anchors.length?this.active.length&&!t.contains(this.tablist[0],this.active[0])?this.tabs.length===e.disabled.length?(e.active=!1,this.active=t()):this._activate(this._findNextTab(Math.max(0,e.active-1),!1)):e.active=this.tabs.index(this.active):(e.active=!1,this.active=t()),this._refresh()},_refresh:function(){this._setupDisabled(this.options.disabled),this._setupEvents(this.options.event),this._setupHeightStyle(this.options.heightStyle),this.tabs.not(this.active).attr({"aria-selected":"false",tabIndex:-1}),this.panels.not(this._getPanelForTab(this.active)).hide().attr({"aria-expanded":"false","aria-hidden":"true"}),this.active.length?(this.active.addClass("ui-tabs-active ui-state-active").attr({"aria-selected":"true",tabIndex:0}),this._getPanelForTab(this.active).show().attr({"aria-expanded":"true","aria-hidden":"false"})):this.tabs.eq(0).attr("tabIndex",0)},_processTabs:function(){var e=this;this.tablist=this._getList().addClass("ui-tabs-nav ui-helper-reset ui-helper-clearfix ui-widget-header ui-corner-all").attr("role","tablist"),this.tabs=this.tablist.find("> li:has(a[href])").addClass("ui-state-default ui-corner-top").attr({role:"tab",tabIndex:-1}),this.anchors=this.tabs.map(function(){return t("a",this)[0]}).addClass("ui-tabs-anchor").attr({role:"presentation",tabIndex:-1}),this.panels=t(),this.anchors.each(function(i,n){var a,o,r,h=t(n).uniqueId().attr("id"),l=t(n).closest("li"),c=l.attr("aria-controls");s(n)?(a=n.hash,o=e.element.find(e._sanitizeSelector(a))):(r=e._tabId(l),a="#"+r,o=e.element.find(a),o.length||(o=e._createPanel(r),o.insertAfter(e.panels[i-1]||e.tablist)),o.attr("aria-live","polite")),o.length&&(e.panels=e.panels.add(o)),c&&l.data("ui-tabs-aria-controls",c),l.attr({"aria-controls":a.substring(1),"aria-labelledby":h}),o.attr("aria-labelledby",h)}),this.panels.addClass("ui-tabs-panel ui-widget-content ui-corner-bottom").attr("role","tabpanel")},_getList:function(){return this.tablist||this.element.find("ol,ul").eq(0)},_createPanel:function(e){return t("<div>").attr("id",e).addClass("ui-tabs-panel ui-widget-content ui-corner-bottom").data("ui-tabs-destroy",!0)},_setupDisabled:function(e){t.isArray(e)&&(e.length?e.length===this.anchors.length&&(e=!0):e=!1);for(var i,s=0;i=this.tabs[s];s++)e===!0||-1!==t.inArray(s,e)?t(i).addClass("ui-state-disabled").attr("aria-disabled","true"):t(i).removeClass("ui-state-disabled").removeAttr("aria-disabled");this.options.disabled=e},_setupEvents:function(e){var i={click:function(t){t.preventDefault()}};e&&t.each(e.split(" "),function(t,e){i[e]="_eventHandler"}),this._off(this.anchors.add(this.tabs).add(this.panels)),this._on(this.anchors,i),this._on(this.tabs,{keydown:"_tabKeydown"}),this._on(this.panels,{keydown:"_panelKeydown"}),this._focusable(this.tabs),this._hoverable(this.tabs)},_setupHeightStyle:function(e){var i,s=this.element.parent();"fill"===e?(i=s.height(),i-=this.element.outerHeight()-this.element.height(),this.element.siblings(":visible").each(function(){var e=t(this),s=e.css("position");"absolute"!==s&&"fixed"!==s&&(i-=e.outerHeight(!0))}),this.element.children().not(this.panels).each(function(){i-=t(this).outerHeight(!0)}),this.panels.each(function(){t(this).height(Math.max(0,i-t(this).innerHeight()+t(this).height()))}).css("overflow","auto")):"auto"===e&&(i=0,this.panels.each(function(){i=Math.max(i,t(this).height("").height())}).height(i))},_eventHandler:function(e){var i=this.options,s=this.active,n=t(e.currentTarget),a=n.closest("li"),o=a[0]===s[0],r=o&&i.collapsible,h=r?t():this._getPanelForTab(a),l=s.length?this._getPanelForTab(s):t(),c={oldTab:s,oldPanel:l,newTab:r?t():a,newPanel:h};e.preventDefault(),a.hasClass("ui-state-disabled")||a.hasClass("ui-tabs-loading")||this.running||o&&!i.collapsible||this._trigger("beforeActivate",e,c)===!1||(i.active=r?!1:this.tabs.index(a),this.active=o?t():a,this.xhr&&this.xhr.abort(),l.length||h.length||t.error("jQuery UI Tabs: Mismatching fragment identifier."),h.length&&this.load(this.tabs.index(a),e),this._toggle(e,c))},_toggle:function(e,i){function s(){a.running=!1,a._trigger("activate",e,i)}function n(){i.newTab.closest("li").addClass("ui-tabs-active ui-state-active"),o.length&&a.options.show?a._show(o,a.options.show,s):(o.show(),s())}var a=this,o=i.newPanel,r=i.oldPanel;this.running=!0,r.length&&this.options.hide?this._hide(r,this.options.hide,function(){i.oldTab.closest("li").removeClass("ui-tabs-active ui-state-active"),n()}):(i.oldTab.closest("li").removeClass("ui-tabs-active ui-state-active"),r.hide(),n()),r.attr({"aria-expanded":"false","aria-hidden":"true"}),i.oldTab.attr("aria-selected","false"),o.length&&r.length?i.oldTab.attr("tabIndex",-1):o.length&&this.tabs.filter(function(){return 0===t(this).attr("tabIndex")}).attr("tabIndex",-1),o.attr({"aria-expanded":"true","aria-hidden":"false"}),i.newTab.attr({"aria-selected":"true",tabIndex:0})},_activate:function(e){var i,s=this._findActive(e);s[0]!==this.active[0]&&(s.length||(s=this.active),i=s.find(".ui-tabs-anchor")[0],this._eventHandler({target:i,currentTarget:i,preventDefault:t.noop}))},_findActive:function(e){return e===!1?t():this.tabs.eq(e)},_getIndex:function(t){return"string"==typeof t&&(t=this.anchors.index(this.anchors.filter("[href$='"+t+"']"))),t},_destroy:function(){this.xhr&&this.xhr.abort(),this.element.removeClass("ui-tabs ui-widget ui-widget-content ui-corner-all ui-tabs-collapsible"),this.tablist.removeClass("ui-tabs-nav ui-helper-reset ui-helper-clearfix ui-widget-header ui-corner-all").removeAttr("role"),this.anchors.removeClass("ui-tabs-anchor").removeAttr("role").removeAttr("tabIndex").removeUniqueId(),this.tabs.add(this.panels).each(function(){t.data(this,"ui-tabs-destroy")?t(this).remove():t(this).removeClass("ui-state-default ui-state-active ui-state-disabled ui-corner-top ui-corner-bottom ui-widget-content ui-tabs-active ui-tabs-panel").removeAttr("tabIndex").removeAttr("aria-live").removeAttr("aria-busy").removeAttr("aria-selected").removeAttr("aria-labelledby").removeAttr("aria-hidden").removeAttr("aria-expanded").removeAttr("role")}),this.tabs.each(function(){var e=t(this),i=e.data("ui-tabs-aria-controls");i?e.attr("aria-controls",i).removeData("ui-tabs-aria-controls"):e.removeAttr("aria-controls")}),this.panels.show(),"content"!==this.options.heightStyle&&this.panels.css("height","")},enable:function(i){var s=this.options.disabled;s!==!1&&(i===e?s=!1:(i=this._getIndex(i),s=t.isArray(s)?t.map(s,function(t){return t!==i?t:null}):t.map(this.tabs,function(t,e){return e!==i?e:null})),this._setupDisabled(s))},disable:function(i){var s=this.options.disabled;if(s!==!0){if(i===e)s=!0;else{if(i=this._getIndex(i),-1!==t.inArray(i,s))return;s=t.isArray(s)?t.merge([i],s).sort():[i]}this._setupDisabled(s)}},load:function(e,i){e=this._getIndex(e);var n=this,a=this.tabs.eq(e),o=a.find(".ui-tabs-anchor"),r=this._getPanelForTab(a),h={tab:a,panel:r};s(o[0])||(this.xhr=t.ajax(this._ajaxSettings(o,i,h)),this.xhr&&"canceled"!==this.xhr.statusText&&(a.addClass("ui-tabs-loading"),r.attr("aria-busy","true"),this.xhr.success(function(t){setTimeout(function(){r.html(t),n._trigger("load",i,h)},1)}).complete(function(t,e){setTimeout(function(){"abort"===e&&n.panels.stop(!1,!0),a.removeClass("ui-tabs-loading"),r.removeAttr("aria-busy"),t===n.xhr&&delete n.xhr},1)})))},_ajaxSettings:function(e,i,s){var n=this;return{url:e.attr("href"),beforeSend:function(e,a){return n._trigger("beforeLoad",i,t.extend({jqXHR:e,ajaxSettings:a},s))}}},_getPanelForTab:function(e){var i=t(e).attr("aria-controls");return this.element.find(this._sanitizeSelector("#"+i))}})})(jQuery);(function(t){function e(e,i){var s=(e.attr("aria-describedby")||"").split(/\s+/);s.push(i),e.data("ui-tooltip-id",i).attr("aria-describedby",t.trim(s.join(" ")))}function i(e){var i=e.data("ui-tooltip-id"),s=(e.attr("aria-describedby")||"").split(/\s+/),n=t.inArray(i,s);-1!==n&&s.splice(n,1),e.removeData("ui-tooltip-id"),s=t.trim(s.join(" ")),s?e.attr("aria-describedby",s):e.removeAttr("aria-describedby")}var s=0;t.widget("ui.tooltip",{version:"1.10.4",options:{content:function(){var e=t(this).attr("title")||"";return t("<a>").text(e).html()},hide:!0,items:"[title]:not([disabled])",position:{my:"left top+15",at:"left bottom",collision:"flipfit flip"},show:!0,tooltipClass:null,track:!1,close:null,open:null},_create:function(){this._on({mouseover:"open",focusin:"open"}),this.tooltips={},this.parents={},this.options.disabled&&this._disable()},_setOption:function(e,i){var s=this;return"disabled"===e?(this[i?"_disable":"_enable"](),this.options[e]=i,void 0):(this._super(e,i),"content"===e&&t.each(this.tooltips,function(t,e){s._updateContent(e)}),void 0)},_disable:function(){var e=this;t.each(this.tooltips,function(i,s){var n=t.Event("blur");n.target=n.currentTarget=s[0],e.close(n,!0)}),this.element.find(this.options.items).addBack().each(function(){var e=t(this);e.is("[title]")&&e.data("ui-tooltip-title",e.attr("title")).attr("title","")})},_enable:function(){this.element.find(this.options.items).addBack().each(function(){var e=t(this);e.data("ui-tooltip-title")&&e.attr("title",e.data("ui-tooltip-title"))})},open:function(e){var i=this,s=t(e?e.target:this.element).closest(this.options.items);s.length&&!s.data("ui-tooltip-id")&&(s.attr("title")&&s.data("ui-tooltip-title",s.attr("title")),s.data("ui-tooltip-open",!0),e&&"mouseover"===e.type&&s.parents().each(function(){var e,s=t(this);s.data("ui-tooltip-open")&&(e=t.Event("blur"),e.target=e.currentTarget=this,i.close(e,!0)),s.attr("title")&&(s.uniqueId(),i.parents[this.id]={element:this,title:s.attr("title")},s.attr("title",""))}),this._updateContent(s,e))},_updateContent:function(t,e){var i,s=this.options.content,n=this,o=e?e.type:null;return"string"==typeof s?this._open(e,t,s):(i=s.call(t[0],function(i){t.data("ui-tooltip-open")&&n._delay(function(){e&&(e.type=o),this._open(e,t,i)})}),i&&this._open(e,t,i),void 0)},_open:function(i,s,n){function o(t){l.of=t,a.is(":hidden")||a.position(l)}var a,r,h,l=t.extend({},this.options.position);if(n){if(a=this._find(s),a.length)return a.find(".ui-tooltip-content").html(n),void 0;s.is("[title]")&&(i&&"mouseover"===i.type?s.attr("title",""):s.removeAttr("title")),a=this._tooltip(s),e(s,a.attr("id")),a.find(".ui-tooltip-content").html(n),this.options.track&&i&&/^mouse/.test(i.type)?(this._on(this.document,{mousemove:o}),o(i)):a.position(t.extend({of:s},this.options.position)),a.hide(),this._show(a,this.options.show),this.options.show&&this.options.show.delay&&(h=this.delayedShow=setInterval(function(){a.is(":visible")&&(o(l.of),clearInterval(h))},t.fx.interval)),this._trigger("open",i,{tooltip:a}),r={keyup:function(e){if(e.keyCode===t.ui.keyCode.ESCAPE){var i=t.Event(e);i.currentTarget=s[0],this.close(i,!0)}},remove:function(){this._removeTooltip(a)}},i&&"mouseover"!==i.type||(r.mouseleave="close"),i&&"focusin"!==i.type||(r.focusout="close"),this._on(!0,s,r)}},close:function(e){var s=this,n=t(e?e.currentTarget:this.element),o=this._find(n);this.closing||(clearInterval(this.delayedShow),n.data("ui-tooltip-title")&&n.attr("title",n.data("ui-tooltip-title")),i(n),o.stop(!0),this._hide(o,this.options.hide,function(){s._removeTooltip(t(this))}),n.removeData("ui-tooltip-open"),this._off(n,"mouseleave focusout keyup"),n[0]!==this.element[0]&&this._off(n,"remove"),this._off(this.document,"mousemove"),e&&"mouseleave"===e.type&&t.each(this.parents,function(e,i){t(i.element).attr("title",i.title),delete s.parents[e]}),this.closing=!0,this._trigger("close",e,{tooltip:o}),this.closing=!1)},_tooltip:function(e){var i="ui-tooltip-"+s++,n=t("<div>").attr({id:i,role:"tooltip"}).addClass("ui-tooltip ui-widget ui-corner-all ui-widget-content "+(this.options.tooltipClass||""));return t("<div>").addClass("ui-tooltip-content").appendTo(n),n.appendTo(this.document[0].body),this.tooltips[i]=e,n},_find:function(e){var i=e.data("ui-tooltip-id");return i?t("#"+i):t()},_removeTooltip:function(t){t.remove(),delete this.tooltips[t.attr("id")]},_destroy:function(){var e=this;t.each(this.tooltips,function(i,s){var n=t.Event("blur");n.target=n.currentTarget=s[0],e.close(n,!0),t("#"+i).remove(),s.data("ui-tooltip-title")&&(s.attr("title",s.data("ui-tooltip-title")),s.removeData("ui-tooltip-title"))})}})})(jQuery);(function(t,e){var i="ui-effects-";t.effects={effect:{}},function(t,e){function i(t,e,i){var s=u[e.type]||{};return null==t?i||!e.def?null:e.def:(t=s.floor?~~t:parseFloat(t),isNaN(t)?e.def:s.mod?(t+s.mod)%s.mod:0>t?0:t>s.max?s.max:t)}function s(i){var s=h(),n=s._rgba=[];return i=i.toLowerCase(),f(l,function(t,a){var o,r=a.re.exec(i),l=r&&a.parse(r),h=a.space||"rgba";return l?(o=s[h](l),s[c[h].cache]=o[c[h].cache],n=s._rgba=o._rgba,!1):e}),n.length?("0,0,0,0"===n.join()&&t.extend(n,a.transparent),s):a[i]}function n(t,e,i){return i=(i+1)%1,1>6*i?t+6*(e-t)*i:1>2*i?e:2>3*i?t+6*(e-t)*(2/3-i):t}var a,o="backgroundColor borderBottomColor borderLeftColor borderRightColor borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor",r=/^([\-+])=\s*(\d+\.?\d*)/,l=[{re:/rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,parse:function(t){return[t[1],t[2],t[3],t[4]]}},{re:/rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,parse:function(t){return[2.55*t[1],2.55*t[2],2.55*t[3],t[4]]}},{re:/#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})/,parse:function(t){return[parseInt(t[1],16),parseInt(t[2],16),parseInt(t[3],16)]}},{re:/#([a-f0-9])([a-f0-9])([a-f0-9])/,parse:function(t){return[parseInt(t[1]+t[1],16),parseInt(t[2]+t[2],16),parseInt(t[3]+t[3],16)]}},{re:/hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,space:"hsla",parse:function(t){return[t[1],t[2]/100,t[3]/100,t[4]]}}],h=t.Color=function(e,i,s,n){return new t.Color.fn.parse(e,i,s,n)},c={rgba:{props:{red:{idx:0,type:"byte"},green:{idx:1,type:"byte"},blue:{idx:2,type:"byte"}}},hsla:{props:{hue:{idx:0,type:"degrees"},saturation:{idx:1,type:"percent"},lightness:{idx:2,type:"percent"}}}},u={"byte":{floor:!0,max:255},percent:{max:1},degrees:{mod:360,floor:!0}},d=h.support={},p=t("<p>")[0],f=t.each;p.style.cssText="background-color:rgba(1,1,1,.5)",d.rgba=p.style.backgroundColor.indexOf("rgba")>-1,f(c,function(t,e){e.cache="_"+t,e.props.alpha={idx:3,type:"percent",def:1}}),h.fn=t.extend(h.prototype,{parse:function(n,o,r,l){if(n===e)return this._rgba=[null,null,null,null],this;(n.jquery||n.nodeType)&&(n=t(n).css(o),o=e);var u=this,d=t.type(n),p=this._rgba=[];return o!==e&&(n=[n,o,r,l],d="array"),"string"===d?this.parse(s(n)||a._default):"array"===d?(f(c.rgba.props,function(t,e){p[e.idx]=i(n[e.idx],e)}),this):"object"===d?(n instanceof h?f(c,function(t,e){n[e.cache]&&(u[e.cache]=n[e.cache].slice())}):f(c,function(e,s){var a=s.cache;f(s.props,function(t,e){if(!u[a]&&s.to){if("alpha"===t||null==n[t])return;u[a]=s.to(u._rgba)}u[a][e.idx]=i(n[t],e,!0)}),u[a]&&0>t.inArray(null,u[a].slice(0,3))&&(u[a][3]=1,s.from&&(u._rgba=s.from(u[a])))}),this):e},is:function(t){var i=h(t),s=!0,n=this;return f(c,function(t,a){var o,r=i[a.cache];return r&&(o=n[a.cache]||a.to&&a.to(n._rgba)||[],f(a.props,function(t,i){return null!=r[i.idx]?s=r[i.idx]===o[i.idx]:e})),s}),s},_space:function(){var t=[],e=this;return f(c,function(i,s){e[s.cache]&&t.push(i)}),t.pop()},transition:function(t,e){var s=h(t),n=s._space(),a=c[n],o=0===this.alpha()?h("transparent"):this,r=o[a.cache]||a.to(o._rgba),l=r.slice();return s=s[a.cache],f(a.props,function(t,n){var a=n.idx,o=r[a],h=s[a],c=u[n.type]||{};null!==h&&(null===o?l[a]=h:(c.mod&&(h-o>c.mod/2?o+=c.mod:o-h>c.mod/2&&(o-=c.mod)),l[a]=i((h-o)*e+o,n)))}),this[n](l)},blend:function(e){if(1===this._rgba[3])return this;var i=this._rgba.slice(),s=i.pop(),n=h(e)._rgba;return h(t.map(i,function(t,e){return(1-s)*n[e]+s*t}))},toRgbaString:function(){var e="rgba(",i=t.map(this._rgba,function(t,e){return null==t?e>2?1:0:t});return 1===i[3]&&(i.pop(),e="rgb("),e+i.join()+")"},toHslaString:function(){var e="hsla(",i=t.map(this.hsla(),function(t,e){return null==t&&(t=e>2?1:0),e&&3>e&&(t=Math.round(100*t)+"%"),t});return 1===i[3]&&(i.pop(),e="hsl("),e+i.join()+")"},toHexString:function(e){var i=this._rgba.slice(),s=i.pop();return e&&i.push(~~(255*s)),"#"+t.map(i,function(t){return t=(t||0).toString(16),1===t.length?"0"+t:t}).join("")},toString:function(){return 0===this._rgba[3]?"transparent":this.toRgbaString()}}),h.fn.parse.prototype=h.fn,c.hsla.to=function(t){if(null==t[0]||null==t[1]||null==t[2])return[null,null,null,t[3]];var e,i,s=t[0]/255,n=t[1]/255,a=t[2]/255,o=t[3],r=Math.max(s,n,a),l=Math.min(s,n,a),h=r-l,c=r+l,u=.5*c;return e=l===r?0:s===r?60*(n-a)/h+360:n===r?60*(a-s)/h+120:60*(s-n)/h+240,i=0===h?0:.5>=u?h/c:h/(2-c),[Math.round(e)%360,i,u,null==o?1:o]},c.hsla.from=function(t){if(null==t[0]||null==t[1]||null==t[2])return[null,null,null,t[3]];var e=t[0]/360,i=t[1],s=t[2],a=t[3],o=.5>=s?s*(1+i):s+i-s*i,r=2*s-o;return[Math.round(255*n(r,o,e+1/3)),Math.round(255*n(r,o,e)),Math.round(255*n(r,o,e-1/3)),a]},f(c,function(s,n){var a=n.props,o=n.cache,l=n.to,c=n.from;h.fn[s]=function(s){if(l&&!this[o]&&(this[o]=l(this._rgba)),s===e)return this[o].slice();var n,r=t.type(s),u="array"===r||"object"===r?s:arguments,d=this[o].slice();return f(a,function(t,e){var s=u["object"===r?t:e.idx];null==s&&(s=d[e.idx]),d[e.idx]=i(s,e)}),c?(n=h(c(d)),n[o]=d,n):h(d)},f(a,function(e,i){h.fn[e]||(h.fn[e]=function(n){var a,o=t.type(n),l="alpha"===e?this._hsla?"hsla":"rgba":s,h=this[l](),c=h[i.idx];return"undefined"===o?c:("function"===o&&(n=n.call(this,c),o=t.type(n)),null==n&&i.empty?this:("string"===o&&(a=r.exec(n),a&&(n=c+parseFloat(a[2])*("+"===a[1]?1:-1))),h[i.idx]=n,this[l](h)))})})}),h.hook=function(e){var i=e.split(" ");f(i,function(e,i){t.cssHooks[i]={set:function(e,n){var a,o,r="";if("transparent"!==n&&("string"!==t.type(n)||(a=s(n)))){if(n=h(a||n),!d.rgba&&1!==n._rgba[3]){for(o="backgroundColor"===i?e.parentNode:e;(""===r||"transparent"===r)&&o&&o.style;)try{r=t.css(o,"backgroundColor"),o=o.parentNode}catch(l){}n=n.blend(r&&"transparent"!==r?r:"_default")}n=n.toRgbaString()}try{e.style[i]=n}catch(l){}}},t.fx.step[i]=function(e){e.colorInit||(e.start=h(e.elem,i),e.end=h(e.end),e.colorInit=!0),t.cssHooks[i].set(e.elem,e.start.transition(e.end,e.pos))}})},h.hook(o),t.cssHooks.borderColor={expand:function(t){var e={};return f(["Top","Right","Bottom","Left"],function(i,s){e["border"+s+"Color"]=t}),e}},a=t.Color.names={aqua:"#00ffff",black:"#000000",blue:"#0000ff",fuchsia:"#ff00ff",gray:"#808080",green:"#008000",lime:"#00ff00",maroon:"#800000",navy:"#000080",olive:"#808000",purple:"#800080",red:"#ff0000",silver:"#c0c0c0",teal:"#008080",white:"#ffffff",yellow:"#ffff00",transparent:[null,null,null,0],_default:"#ffffff"}}(jQuery),function(){function i(e){var i,s,n=e.ownerDocument.defaultView?e.ownerDocument.defaultView.getComputedStyle(e,null):e.currentStyle,a={};if(n&&n.length&&n[0]&&n[n[0]])for(s=n.length;s--;)i=n[s],"string"==typeof n[i]&&(a[t.camelCase(i)]=n[i]);else for(i in n)"string"==typeof n[i]&&(a[i]=n[i]);return a}function s(e,i){var s,n,o={};for(s in i)n=i[s],e[s]!==n&&(a[s]||(t.fx.step[s]||!isNaN(parseFloat(n)))&&(o[s]=n));return o}var n=["add","remove","toggle"],a={border:1,borderBottom:1,borderColor:1,borderLeft:1,borderRight:1,borderTop:1,borderWidth:1,margin:1,padding:1};t.each(["borderLeftStyle","borderRightStyle","borderBottomStyle","borderTopStyle"],function(e,i){t.fx.step[i]=function(t){("none"!==t.end&&!t.setAttr||1===t.pos&&!t.setAttr)&&(jQuery.style(t.elem,i,t.end),t.setAttr=!0)}}),t.fn.addBack||(t.fn.addBack=function(t){return this.add(null==t?this.prevObject:this.prevObject.filter(t))}),t.effects.animateClass=function(e,a,o,r){var l=t.speed(a,o,r);return this.queue(function(){var a,o=t(this),r=o.attr("class")||"",h=l.children?o.find("*").addBack():o;h=h.map(function(){var e=t(this);return{el:e,start:i(this)}}),a=function(){t.each(n,function(t,i){e[i]&&o[i+"Class"](e[i])})},a(),h=h.map(function(){return this.end=i(this.el[0]),this.diff=s(this.start,this.end),this}),o.attr("class",r),h=h.map(function(){var e=this,i=t.Deferred(),s=t.extend({},l,{queue:!1,complete:function(){i.resolve(e)}});return this.el.animate(this.diff,s),i.promise()}),t.when.apply(t,h.get()).done(function(){a(),t.each(arguments,function(){var e=this.el;t.each(this.diff,function(t){e.css(t,"")})}),l.complete.call(o[0])})})},t.fn.extend({addClass:function(e){return function(i,s,n,a){return s?t.effects.animateClass.call(this,{add:i},s,n,a):e.apply(this,arguments)}}(t.fn.addClass),removeClass:function(e){return function(i,s,n,a){return arguments.length>1?t.effects.animateClass.call(this,{remove:i},s,n,a):e.apply(this,arguments)}}(t.fn.removeClass),toggleClass:function(i){return function(s,n,a,o,r){return"boolean"==typeof n||n===e?a?t.effects.animateClass.call(this,n?{add:s}:{remove:s},a,o,r):i.apply(this,arguments):t.effects.animateClass.call(this,{toggle:s},n,a,o)}}(t.fn.toggleClass),switchClass:function(e,i,s,n,a){return t.effects.animateClass.call(this,{add:i,remove:e},s,n,a)}})}(),function(){function s(e,i,s,n){return t.isPlainObject(e)&&(i=e,e=e.effect),e={effect:e},null==i&&(i={}),t.isFunction(i)&&(n=i,s=null,i={}),("number"==typeof i||t.fx.speeds[i])&&(n=s,s=i,i={}),t.isFunction(s)&&(n=s,s=null),i&&t.extend(e,i),s=s||i.duration,e.duration=t.fx.off?0:"number"==typeof s?s:s in t.fx.speeds?t.fx.speeds[s]:t.fx.speeds._default,e.complete=n||i.complete,e}function n(e){return!e||"number"==typeof e||t.fx.speeds[e]?!0:"string"!=typeof e||t.effects.effect[e]?t.isFunction(e)?!0:"object"!=typeof e||e.effect?!1:!0:!0}t.extend(t.effects,{version:"1.10.4",save:function(t,e){for(var s=0;e.length>s;s++)null!==e[s]&&t.data(i+e[s],t[0].style[e[s]])},restore:function(t,s){var n,a;for(a=0;s.length>a;a++)null!==s[a]&&(n=t.data(i+s[a]),n===e&&(n=""),t.css(s[a],n))},setMode:function(t,e){return"toggle"===e&&(e=t.is(":hidden")?"show":"hide"),e},getBaseline:function(t,e){var i,s;switch(t[0]){case"top":i=0;break;case"middle":i=.5;break;case"bottom":i=1;break;default:i=t[0]/e.height}switch(t[1]){case"left":s=0;break;case"center":s=.5;break;case"right":s=1;break;default:s=t[1]/e.width}return{x:s,y:i}},createWrapper:function(e){if(e.parent().is(".ui-effects-wrapper"))return e.parent();var i={width:e.outerWidth(!0),height:e.outerHeight(!0),"float":e.css("float")},s=t("<div></div>").addClass("ui-effects-wrapper").css({fontSize:"100%",background:"transparent",border:"none",margin:0,padding:0}),n={width:e.width(),height:e.height()},a=document.activeElement;try{a.id}catch(o){a=document.body}return e.wrap(s),(e[0]===a||t.contains(e[0],a))&&t(a).focus(),s=e.parent(),"static"===e.css("position")?(s.css({position:"relative"}),e.css({position:"relative"})):(t.extend(i,{position:e.css("position"),zIndex:e.css("z-index")}),t.each(["top","left","bottom","right"],function(t,s){i[s]=e.css(s),isNaN(parseInt(i[s],10))&&(i[s]="auto")}),e.css({position:"relative",top:0,left:0,right:"auto",bottom:"auto"})),e.css(n),s.css(i).show()},removeWrapper:function(e){var i=document.activeElement;return e.parent().is(".ui-effects-wrapper")&&(e.parent().replaceWith(e),(e[0]===i||t.contains(e[0],i))&&t(i).focus()),e},setTransition:function(e,i,s,n){return n=n||{},t.each(i,function(t,i){var a=e.cssUnit(i);a[0]>0&&(n[i]=a[0]*s+a[1])}),n}}),t.fn.extend({effect:function(){function e(e){function s(){t.isFunction(a)&&a.call(n[0]),t.isFunction(e)&&e()}var n=t(this),a=i.complete,r=i.mode;(n.is(":hidden")?"hide"===r:"show"===r)?(n[r](),s()):o.call(n[0],i,s)}var i=s.apply(this,arguments),n=i.mode,a=i.queue,o=t.effects.effect[i.effect];return t.fx.off||!o?n?this[n](i.duration,i.complete):this.each(function(){i.complete&&i.complete.call(this)}):a===!1?this.each(e):this.queue(a||"fx",e)},show:function(t){return function(e){if(n(e))return t.apply(this,arguments);var i=s.apply(this,arguments);return i.mode="show",this.effect.call(this,i)}}(t.fn.show),hide:function(t){return function(e){if(n(e))return t.apply(this,arguments);var i=s.apply(this,arguments);return i.mode="hide",this.effect.call(this,i)}}(t.fn.hide),toggle:function(t){return function(e){if(n(e)||"boolean"==typeof e)return t.apply(this,arguments);var i=s.apply(this,arguments);return i.mode="toggle",this.effect.call(this,i)}}(t.fn.toggle),cssUnit:function(e){var i=this.css(e),s=[];return t.each(["em","px","%","pt"],function(t,e){i.indexOf(e)>0&&(s=[parseFloat(i),e])}),s}})}(),function(){var e={};t.each(["Quad","Cubic","Quart","Quint","Expo"],function(t,i){e[i]=function(e){return Math.pow(e,t+2)}}),t.extend(e,{Sine:function(t){return 1-Math.cos(t*Math.PI/2)},Circ:function(t){return 1-Math.sqrt(1-t*t)},Elastic:function(t){return 0===t||1===t?t:-Math.pow(2,8*(t-1))*Math.sin((80*(t-1)-7.5)*Math.PI/15)},Back:function(t){return t*t*(3*t-2)},Bounce:function(t){for(var e,i=4;((e=Math.pow(2,--i))-1)/11>t;);return 1/Math.pow(4,3-i)-7.5625*Math.pow((3*e-2)/22-t,2)}}),t.each(e,function(e,i){t.easing["easeIn"+e]=i,t.easing["easeOut"+e]=function(t){return 1-i(1-t)},t.easing["easeInOut"+e]=function(t){return.5>t?i(2*t)/2:1-i(-2*t+2)/2}})}()})(jQuery);(function(t){var e=/up|down|vertical/,i=/up|left|vertical|horizontal/;t.effects.effect.blind=function(s,n){var a,o,r,l=t(this),h=["position","top","bottom","left","right","height","width"],c=t.effects.setMode(l,s.mode||"hide"),u=s.direction||"up",d=e.test(u),p=d?"height":"width",f=d?"top":"left",g=i.test(u),m={},v="show"===c;l.parent().is(".ui-effects-wrapper")?t.effects.save(l.parent(),h):t.effects.save(l,h),l.show(),a=t.effects.createWrapper(l).css({overflow:"hidden"}),o=a[p](),r=parseFloat(a.css(f))||0,m[p]=v?o:0,g||(l.css(d?"bottom":"right",0).css(d?"top":"left","auto").css({position:"absolute"}),m[f]=v?r:o+r),v&&(a.css(p,0),g||a.css(f,r+o)),a.animate(m,{duration:s.duration,easing:s.easing,queue:!1,complete:function(){"hide"===c&&l.hide(),t.effects.restore(l,h),t.effects.removeWrapper(l),n()}})}})(jQuery);(function(t){t.effects.effect.bounce=function(e,i){var s,n,a,o=t(this),r=["position","top","bottom","left","right","height","width"],l=t.effects.setMode(o,e.mode||"effect"),h="hide"===l,c="show"===l,u=e.direction||"up",d=e.distance,p=e.times||5,f=2*p+(c||h?1:0),g=e.duration/f,m=e.easing,v="up"===u||"down"===u?"top":"left",_="up"===u||"left"===u,b=o.queue(),y=b.length;for((c||h)&&r.push("opacity"),t.effects.save(o,r),o.show(),t.effects.createWrapper(o),d||(d=o["top"===v?"outerHeight":"outerWidth"]()/3),c&&(a={opacity:1},a[v]=0,o.css("opacity",0).css(v,_?2*-d:2*d).animate(a,g,m)),h&&(d/=Math.pow(2,p-1)),a={},a[v]=0,s=0;p>s;s++)n={},n[v]=(_?"-=":"+=")+d,o.animate(n,g,m).animate(a,g,m),d=h?2*d:d/2;h&&(n={opacity:0},n[v]=(_?"-=":"+=")+d,o.animate(n,g,m)),o.queue(function(){h&&o.hide(),t.effects.restore(o,r),t.effects.removeWrapper(o),i()}),y>1&&b.splice.apply(b,[1,0].concat(b.splice(y,f+1))),o.dequeue()}})(jQuery);(function(t){t.effects.effect.clip=function(e,i){var s,n,a,o=t(this),r=["position","top","bottom","left","right","height","width"],l=t.effects.setMode(o,e.mode||"hide"),h="show"===l,c=e.direction||"vertical",u="vertical"===c,d=u?"height":"width",p=u?"top":"left",f={};t.effects.save(o,r),o.show(),s=t.effects.createWrapper(o).css({overflow:"hidden"}),n="IMG"===o[0].tagName?s:o,a=n[d](),h&&(n.css(d,0),n.css(p,a/2)),f[d]=h?a:0,f[p]=h?0:a/2,n.animate(f,{queue:!1,duration:e.duration,easing:e.easing,complete:function(){h||o.hide(),t.effects.restore(o,r),t.effects.removeWrapper(o),i()}})}})(jQuery);(function(t){t.effects.effect.drop=function(e,i){var s,n=t(this),a=["position","top","bottom","left","right","opacity","height","width"],o=t.effects.setMode(n,e.mode||"hide"),r="show"===o,l=e.direction||"left",h="up"===l||"down"===l?"top":"left",c="up"===l||"left"===l?"pos":"neg",u={opacity:r?1:0};t.effects.save(n,a),n.show(),t.effects.createWrapper(n),s=e.distance||n["top"===h?"outerHeight":"outerWidth"](!0)/2,r&&n.css("opacity",0).css(h,"pos"===c?-s:s),u[h]=(r?"pos"===c?"+=":"-=":"pos"===c?"-=":"+=")+s,n.animate(u,{queue:!1,duration:e.duration,easing:e.easing,complete:function(){"hide"===o&&n.hide(),t.effects.restore(n,a),t.effects.removeWrapper(n),i()}})}})(jQuery);(function(t){t.effects.effect.explode=function(e,i){function s(){b.push(this),b.length===u*d&&n()}function n(){p.css({visibility:"visible"}),t(b).remove(),g||p.hide(),i()}var a,o,r,l,h,c,u=e.pieces?Math.round(Math.sqrt(e.pieces)):3,d=u,p=t(this),f=t.effects.setMode(p,e.mode||"hide"),g="show"===f,m=p.show().css("visibility","hidden").offset(),v=Math.ceil(p.outerWidth()/d),_=Math.ceil(p.outerHeight()/u),b=[];for(a=0;u>a;a++)for(l=m.top+a*_,c=a-(u-1)/2,o=0;d>o;o++)r=m.left+o*v,h=o-(d-1)/2,p.clone().appendTo("body").wrap("<div></div>").css({position:"absolute",visibility:"visible",left:-o*v,top:-a*_}).parent().addClass("ui-effects-explode").css({position:"absolute",overflow:"hidden",width:v,height:_,left:r+(g?h*v:0),top:l+(g?c*_:0),opacity:g?0:1}).animate({left:r+(g?0:h*v),top:l+(g?0:c*_),opacity:g?1:0},e.duration||500,e.easing,s)}})(jQuery);(function(t){t.effects.effect.fade=function(e,i){var s=t(this),n=t.effects.setMode(s,e.mode||"toggle");s.animate({opacity:n},{queue:!1,duration:e.duration,easing:e.easing,complete:i})}})(jQuery);(function(t){t.effects.effect.fold=function(e,i){var s,n,a=t(this),o=["position","top","bottom","left","right","height","width"],r=t.effects.setMode(a,e.mode||"hide"),l="show"===r,h="hide"===r,c=e.size||15,u=/([0-9]+)%/.exec(c),d=!!e.horizFirst,p=l!==d,f=p?["width","height"]:["height","width"],g=e.duration/2,m={},v={};t.effects.save(a,o),a.show(),s=t.effects.createWrapper(a).css({overflow:"hidden"}),n=p?[s.width(),s.height()]:[s.height(),s.width()],u&&(c=parseInt(u[1],10)/100*n[h?0:1]),l&&s.css(d?{height:0,width:c}:{height:c,width:0}),m[f[0]]=l?n[0]:c,v[f[1]]=l?n[1]:0,s.animate(m,g,e.easing).animate(v,g,e.easing,function(){h&&a.hide(),t.effects.restore(a,o),t.effects.removeWrapper(a),i()})}})(jQuery);(function(t){t.effects.effect.highlight=function(e,i){var s=t(this),n=["backgroundImage","backgroundColor","opacity"],a=t.effects.setMode(s,e.mode||"show"),o={backgroundColor:s.css("backgroundColor")};"hide"===a&&(o.opacity=0),t.effects.save(s,n),s.show().css({backgroundImage:"none",backgroundColor:e.color||"#ffff99"}).animate(o,{queue:!1,duration:e.duration,easing:e.easing,complete:function(){"hide"===a&&s.hide(),t.effects.restore(s,n),i()}})}})(jQuery);(function(t){t.effects.effect.pulsate=function(e,i){var s,n=t(this),a=t.effects.setMode(n,e.mode||"show"),o="show"===a,r="hide"===a,l=o||"hide"===a,h=2*(e.times||5)+(l?1:0),c=e.duration/h,u=0,d=n.queue(),p=d.length;for((o||!n.is(":visible"))&&(n.css("opacity",0).show(),u=1),s=1;h>s;s++)n.animate({opacity:u},c,e.easing),u=1-u;n.animate({opacity:u},c,e.easing),n.queue(function(){r&&n.hide(),i()}),p>1&&d.splice.apply(d,[1,0].concat(d.splice(p,h+1))),n.dequeue()}})(jQuery);(function(t){t.effects.effect.puff=function(e,i){var s=t(this),n=t.effects.setMode(s,e.mode||"hide"),a="hide"===n,o=parseInt(e.percent,10)||150,r=o/100,l={height:s.height(),width:s.width(),outerHeight:s.outerHeight(),outerWidth:s.outerWidth()};t.extend(e,{effect:"scale",queue:!1,fade:!0,mode:n,complete:i,percent:a?o:100,from:a?l:{height:l.height*r,width:l.width*r,outerHeight:l.outerHeight*r,outerWidth:l.outerWidth*r}}),s.effect(e)},t.effects.effect.scale=function(e,i){var s=t(this),n=t.extend(!0,{},e),a=t.effects.setMode(s,e.mode||"effect"),o=parseInt(e.percent,10)||(0===parseInt(e.percent,10)?0:"hide"===a?0:100),r=e.direction||"both",l=e.origin,h={height:s.height(),width:s.width(),outerHeight:s.outerHeight(),outerWidth:s.outerWidth()},c={y:"horizontal"!==r?o/100:1,x:"vertical"!==r?o/100:1};n.effect="size",n.queue=!1,n.complete=i,"effect"!==a&&(n.origin=l||["middle","center"],n.restore=!0),n.from=e.from||("show"===a?{height:0,width:0,outerHeight:0,outerWidth:0}:h),n.to={height:h.height*c.y,width:h.width*c.x,outerHeight:h.outerHeight*c.y,outerWidth:h.outerWidth*c.x},n.fade&&("show"===a&&(n.from.opacity=0,n.to.opacity=1),"hide"===a&&(n.from.opacity=1,n.to.opacity=0)),s.effect(n)},t.effects.effect.size=function(e,i){var s,n,a,o=t(this),r=["position","top","bottom","left","right","width","height","overflow","opacity"],l=["position","top","bottom","left","right","overflow","opacity"],h=["width","height","overflow"],c=["fontSize"],u=["borderTopWidth","borderBottomWidth","paddingTop","paddingBottom"],d=["borderLeftWidth","borderRightWidth","paddingLeft","paddingRight"],p=t.effects.setMode(o,e.mode||"effect"),f=e.restore||"effect"!==p,g=e.scale||"both",m=e.origin||["middle","center"],v=o.css("position"),_=f?r:l,b={height:0,width:0,outerHeight:0,outerWidth:0};"show"===p&&o.show(),s={height:o.height(),width:o.width(),outerHeight:o.outerHeight(),outerWidth:o.outerWidth()},"toggle"===e.mode&&"show"===p?(o.from=e.to||b,o.to=e.from||s):(o.from=e.from||("show"===p?b:s),o.to=e.to||("hide"===p?b:s)),a={from:{y:o.from.height/s.height,x:o.from.width/s.width},to:{y:o.to.height/s.height,x:o.to.width/s.width}},("box"===g||"both"===g)&&(a.from.y!==a.to.y&&(_=_.concat(u),o.from=t.effects.setTransition(o,u,a.from.y,o.from),o.to=t.effects.setTransition(o,u,a.to.y,o.to)),a.from.x!==a.to.x&&(_=_.concat(d),o.from=t.effects.setTransition(o,d,a.from.x,o.from),o.to=t.effects.setTransition(o,d,a.to.x,o.to))),("content"===g||"both"===g)&&a.from.y!==a.to.y&&(_=_.concat(c).concat(h),o.from=t.effects.setTransition(o,c,a.from.y,o.from),o.to=t.effects.setTransition(o,c,a.to.y,o.to)),t.effects.save(o,_),o.show(),t.effects.createWrapper(o),o.css("overflow","hidden").css(o.from),m&&(n=t.effects.getBaseline(m,s),o.from.top=(s.outerHeight-o.outerHeight())*n.y,o.from.left=(s.outerWidth-o.outerWidth())*n.x,o.to.top=(s.outerHeight-o.to.outerHeight)*n.y,o.to.left=(s.outerWidth-o.to.outerWidth)*n.x),o.css(o.from),("content"===g||"both"===g)&&(u=u.concat(["marginTop","marginBottom"]).concat(c),d=d.concat(["marginLeft","marginRight"]),h=r.concat(u).concat(d),o.find("*[width]").each(function(){var i=t(this),s={height:i.height(),width:i.width(),outerHeight:i.outerHeight(),outerWidth:i.outerWidth()};f&&t.effects.save(i,h),i.from={height:s.height*a.from.y,width:s.width*a.from.x,outerHeight:s.outerHeight*a.from.y,outerWidth:s.outerWidth*a.from.x},i.to={height:s.height*a.to.y,width:s.width*a.to.x,outerHeight:s.height*a.to.y,outerWidth:s.width*a.to.x},a.from.y!==a.to.y&&(i.from=t.effects.setTransition(i,u,a.from.y,i.from),i.to=t.effects.setTransition(i,u,a.to.y,i.to)),a.from.x!==a.to.x&&(i.from=t.effects.setTransition(i,d,a.from.x,i.from),i.to=t.effects.setTransition(i,d,a.to.x,i.to)),i.css(i.from),i.animate(i.to,e.duration,e.easing,function(){f&&t.effects.restore(i,h)})})),o.animate(o.to,{queue:!1,duration:e.duration,easing:e.easing,complete:function(){0===o.to.opacity&&o.css("opacity",o.from.opacity),"hide"===p&&o.hide(),t.effects.restore(o,_),f||("static"===v?o.css({position:"relative",top:o.to.top,left:o.to.left}):t.each(["top","left"],function(t,e){o.css(e,function(e,i){var s=parseInt(i,10),n=t?o.to.left:o.to.top;return"auto"===i?n+"px":s+n+"px"})})),t.effects.removeWrapper(o),i()}})}})(jQuery);(function(t){t.effects.effect.shake=function(e,i){var s,n=t(this),a=["position","top","bottom","left","right","height","width"],o=t.effects.setMode(n,e.mode||"effect"),r=e.direction||"left",l=e.distance||20,h=e.times||3,c=2*h+1,u=Math.round(e.duration/c),d="up"===r||"down"===r?"top":"left",p="up"===r||"left"===r,f={},g={},m={},v=n.queue(),_=v.length;for(t.effects.save(n,a),n.show(),t.effects.createWrapper(n),f[d]=(p?"-=":"+=")+l,g[d]=(p?"+=":"-=")+2*l,m[d]=(p?"-=":"+=")+2*l,n.animate(f,u,e.easing),s=1;h>s;s++)n.animate(g,u,e.easing).animate(m,u,e.easing);n.animate(g,u,e.easing).animate(f,u/2,e.easing).queue(function(){"hide"===o&&n.hide(),t.effects.restore(n,a),t.effects.removeWrapper(n),i()}),_>1&&v.splice.apply(v,[1,0].concat(v.splice(_,c+1))),n.dequeue()}})(jQuery);(function(t){t.effects.effect.slide=function(e,i){var s,n=t(this),a=["position","top","bottom","left","right","width","height"],o=t.effects.setMode(n,e.mode||"show"),r="show"===o,l=e.direction||"left",h="up"===l||"down"===l?"top":"left",c="up"===l||"left"===l,u={};t.effects.save(n,a),n.show(),s=e.distance||n["top"===h?"outerHeight":"outerWidth"](!0),t.effects.createWrapper(n).css({overflow:"hidden"}),r&&n.css(h,c?isNaN(s)?"-"+s:-s:s),u[h]=(r?c?"+=":"-=":c?"-=":"+=")+s,n.animate(u,{queue:!1,duration:e.duration,easing:e.easing,complete:function(){"hide"===o&&n.hide(),t.effects.restore(n,a),t.effects.removeWrapper(n),i()}})}})(jQuery);(function(t){t.effects.effect.transfer=function(e,i){var s=t(this),n=t(e.to),a="fixed"===n.css("position"),o=t("body"),r=a?o.scrollTop():0,l=a?o.scrollLeft():0,h=n.offset(),c={top:h.top-r,left:h.left-l,height:n.innerHeight(),width:n.innerWidth()},u=s.offset(),d=t("<div class='ui-effects-transfer'></div>").appendTo(document.body).addClass(e.className).css({top:u.top-r,left:u.left-l,height:s.innerHeight(),width:s.innerWidth(),position:a?"fixed":"absolute"}).animate(c,e.duration,e.easing,function(){d.remove(),i()})}})(jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {// Generated by CoffeeScript 1.6.1
// Modified by Swisscom (2017)
(function() {

    (function($, window, document) {
        var Plugin, defaults, pluginName;
        pluginName = "slidesjs";
        defaults = {
            width: 940,
            height: 528,
            start: 1,
            navigation: {
                active: true,
                effect: "slide"
            },
            pagination: {
                active: true,
                effect: "slide"
            },
            play: {
                active: false,
                effect: "slide",
                interval: 5000,
                auto: false,
                swap: true,
                pauseOnHover: false,
                restartDelay: 2500
            },
            effect: {
                slide: {
                    speed: 1000
                },
                fade: {
                    speed: 300,
                    crossfade: true
                }
            },
            callback: {
                loaded: function() {},
                start: function() {},
                complete: function() {}
            }
        };
        Plugin = (function() {

            function Plugin(element, options) {
                this.element = element;
                this.options = $.extend(true, {}, defaults, options);
                this._defaults = defaults;
                this._name = pluginName;
                this.init();
            }

            return Plugin;

        })();
        Plugin.prototype.init = function() {
            var $element, nextButton, pagination, playButton, prevButton, stopButton,
                _this = this;
            $element = $(this.element);
            this.data = $.data(this);
            $.data(this, "animating", false);
            $.data(this, "total", $element.children().not(".slidesjs-navigation", $element).length);
            $.data(this, "current", this.options.start - 1);
            $.data(this, "vendorPrefix", this._getVendorPrefix());
            if (typeof TouchEvent !== "undefined") {
                $.data(this, "touch", true);
                this.options.effect.slide.speed = this.options.effect.slide.speed / 2;
            }
            $element.css({
                overflow: "hidden"
            });
            $element.slidesContainer = $element.children().not(".slidesjs-navigation", $element).wrapAll("<div class='slidesjs-container'>", $element).parent().css({
                overflow: "hidden",
                position: "relative"
            });
            $(".slidesjs-container", $element).wrapInner("<div class='slidesjs-control'>", $element).children();
            $(".slidesjs-control", $element).css({
                position: "relative",
                left: 0
            });
            $(".slidesjs-control", $element).children().addClass("slidesjs-slide").css({
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                zIndex: 0,
                display: "block",
                webkitBackfaceVisibility: "hidden"
            });
            $.each($(".slidesjs-control", $element).children(), function(i) {
                var $slide;
                $slide = $(this);
                return $slide.attr("slidesjs-index", i);
            });
            if (this.data.touch) {
                $($element).delegate(".slidesjs-control", "touchstart", function(e) {
                    return _this._touchstart(e);
                });
                $($element).delegate(".slidesjs-control", "touchmove", function(e) {
                    return _this._touchmove(e);
                });
                $($element).delegate(".slidesjs-control", "touchend", function(e) {
                    return _this._touchend(e);
                });
            }
            $element.fadeIn(0);
            this.update();
            if (this.data.touch) {
                this._setuptouch();
            }
            $(".slidesjs-control", $element).children(":eq(" + this.data.current + ")").eq(0).fadeIn(0, function() {
                return $(this).css({
                    zIndex: 10
                });
            });
            if (this.options.navigation.active) {
                prevButton = $("<a>", {
                    "class": "slidesjs-previous slidesjs-navigation",
                    href: "#",
                    title: "Previous",
                    text: "Previous"
                }).appendTo($element);
                nextButton = $("<a>", {
                    "class": "slidesjs-next slidesjs-navigation",
                    href: "#",
                    title: "Next",
                    text: "Next"
                }).appendTo($element);
            }
            $(".slidesjs-next", $element).click(function(e) {
                e.preventDefault();
                _this.stop(true);
                return _this.next(_this.options.navigation.effect);
            });
            $(".slidesjs-previous", $element).click(function(e) {
                e.preventDefault();
                _this.stop(true);
                return _this.previous(_this.options.navigation.effect);
            });
            if (this.options.play.active) {
                playButton = $("<a>", {
                    "class": "slidesjs-play slidesjs-navigation",
                    href: "#",
                    title: "Play",
                    text: "Play"
                }).appendTo($element);
                stopButton = $("<a>", {
                    "class": "slidesjs-stop slidesjs-navigation",
                    href: "#",
                    title: "Stop",
                    text: "Stop"
                }).appendTo($element);
                playButton.click(function(e) {
                    e.preventDefault();
                    return _this.play(true);
                });
                stopButton.click(function(e) {
                    e.preventDefault();
                    return _this.stop(true);
                });
                if (this.options.play.swap) {
                    stopButton.css({
                        display: "none"
                    });
                }
            }
            if (this.options.pagination.active) {
                pagination = $("<ul>", {
                    "class": "slidesjs-pagination"
                }).appendTo($element);
                $.each(new Array(this.data.total), function(i) {
                    var paginationItem, paginationLink;
                    paginationItem = $("<li>", {
                        "class": "slidesjs-pagination-item"
                    }).appendTo(pagination);
                    paginationLink = $("<a>", {
                        href: "#",
                        "data-slidesjs-item": i,
                        html: i + 1
                    }).appendTo(paginationItem);
                    return paginationLink.click(function(e) {
                        e.preventDefault();
                        _this.stop(true);
                        return _this.gotoCustom(($(e.currentTarget).attr("data-slidesjs-item") * 1) + 1);
                    });
                });
            }
            $(window).bind("resize", function() {
                return _this.update();
            });
            this._setActive();
            if (this.options.play.auto) {
                this.play();
            }
            return this.options.callback.loaded(this.options.start);
        };
        Plugin.prototype._setActive = function(number) {
            var $element, current;
            $element = $(this.element);
            this.data = $.data(this);
            current = number > -1 ? number : this.data.current;
            $(".active", $element).removeClass("active");
            return $(".slidesjs-pagination li:eq(" + current + ") a", $element).addClass("active");
        };
        Plugin.prototype.update = function() {
            var $element, height, width;
            $element = $(this.element);
            this.data = $.data(this);
            $(".slidesjs-control", $element).children(":not(:eq(" + this.data.current + "))").css({
                display: "block",
                left: 0,
                zIndex: 0
            });
            width = $element.width();
            height = (this.options.height / this.options.width) * width;
            this.options.width = width;
            this.options.height = height;
            return $(".slidesjs-control, .slidesjs-container", $element).css({
                width: width,
                height: height
            });
        };
        Plugin.prototype.next = function(effect) {
            var $element;
            $element = $(this.element);
            this.data = $.data(this);
            $.data(this, "direction", "next");
            if (effect === 0) {
                effect = this.options.navigation.effect;
            }
            if (effect === "fade") {
                return this._fade();
            } else {
                return this._slide();
            }
        };
        Plugin.prototype.previous = function(effect) {
            var $element;
            $element = $(this.element);
            this.data = $.data(this);
            $.data(this, "direction", "previous");
            if (effect === 0) {
                effect = this.options.navigation.effect;
            }
            if (effect === "fade") {
                return this._fade();
            } else {
                return this._slide();
            }
        };
        Plugin.prototype.gotoCustom = function(number) {
            var $element, effect;
            $element = $(this.element);
            this.data = $.data(this);
            if (effect === 0) {
                effect = this.options.pagination.effect;
            }
            if (number > this.data.total) {
                number = this.data.total;
            } else if (number < 1) {
                number = 1;
            }
            if (typeof number === "number") {
                if (effect === "fade") {
                    return this._fade(number);
                } else {
                    return this._slide(number);
                }
            } else if (typeof number === "string") {
                if (number === "first") {
                    if (effect === "fade") {
                        return this._fade(0);
                    } else {
                        return this._slide(0);
                    }
                } else if (number === "last") {
                    if (effect === "fade") {
                        return this._fade(this.data.total);
                    } else {
                        return this._slide(this.data.total);
                    }
                }
            }
        };
        Plugin.prototype._setuptouch = function() {
            var $element, next, previous, slidesControl;
            $element = $(this.element);
            this.data = $.data(this);
            slidesControl = $(".slidesjs-control", $element);
            next = this.data.current + 1;
            previous = this.data.current - 1;
            if (previous < 0) {
                previous = this.data.total - 1;
            }
            if (next > this.data.total - 1) {
                next = 0;
            }
            slidesControl.children(":eq(" + next + ")").css({
                display: "block",
                left: this.options.width
            });
            return slidesControl.children(":eq(" + previous + ")").css({
                display: "block",
                left: -this.options.width
            });
        };
        Plugin.prototype._touchstart = function(e) {
            var $element, touches;
            $element = $(this.element);
            this.data = $.data(this);
            touches = e.originalEvent.touches[0];
            this._setuptouch();
            $.data(this, "touchtimer", Number(new Date()));
            $.data(this, "touchstartx", touches.pageX);
            $.data(this, "touchstarty", touches.pageY);
            return e.stopPropagation();
        };
        Plugin.prototype._touchend = function(e) {
            var $element, duration, prefix, slidesControl, timing, touches, transform,
                _this = this;
            $element = $(this.element);
            this.data = $.data(this);
            touches = e.originalEvent.touches[0];
            slidesControl = $(".slidesjs-control", $element);
            if (slidesControl.position().left > this.options.width * 0.5 || slidesControl.position().left > this.options.width * 0.1 && (Number(new Date()) - this.data.touchtimer < 250)) {
                $.data(this, "direction", "previous");
                this._slide();
            } else if (slidesControl.position().left < -(this.options.width * 0.5) || slidesControl.position().left < -(this.options.width * 0.1) && (Number(new Date()) - this.data.touchtimer < 250)) {
                $.data(this, "direction", "next");
                this._slide();
            } else {
                prefix = this.data.vendorPrefix;
                transform = prefix + "Transform";
                duration = prefix + "TransitionDuration";
                timing = prefix + "TransitionTimingFunction";
                slidesControl[0].style[transform] = "translateX(0px)";
                slidesControl[0].style[duration] = this.options.effect.slide.speed * 0.85 + "ms";
            }
            $element.delegate(".slidesjs-control", "transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd", function() {
                prefix = _this.data.vendorPrefix;
                transform = prefix + "Transform";
                duration = prefix + "TransitionDuration";
                timing = prefix + "TransitionTimingFunction";
                slidesControl[0].style[transform] = "";
                slidesControl[0].style[duration] = "";
                return slidesControl[0].style[timing] = "";
            });
            return e.stopPropagation();
        };
        Plugin.prototype._touchmove = function(e) {
            var $element, prefix, slidesControl, touches, transform;
            $element = $(this.element);
            this.data = $.data(this);
            touches = e.originalEvent.touches[0];
            prefix = this.data.vendorPrefix;
            slidesControl = $(".slidesjs-control", $element);
            transform = prefix + "Transform";
            $.data(this, "scrolling", Math.abs(touches.pageX - this.data.touchstartx) < Math.abs(touches.pageY - this.data.touchstarty));
            if (!this.data.animating && !this.data.scrolling) {
                e.preventDefault();
                this._setuptouch();
                slidesControl[0].style[transform] = "translateX(" + (touches.pageX - this.data.touchstartx) + "px)";
            }
            return e.stopPropagation();
        };
        Plugin.prototype.play = function(next) {
            var $element, currentSlide, slidesContainer,
                _this = this;
            $element = $(this.element);
            this.data = $.data(this);
            if (!this.data.playInterval) {
                if (next) {
                    currentSlide = this.data.current;
                    this.data.direction = "next";
                    if (this.options.play.effect === "fade") {
                        this._fade();
                    } else {
                        this._slide();
                    }
                }
                $.data(this, "playInterval", setInterval((function() {
                    currentSlide = _this.data.current;
                    _this.data.direction = "next";
                    if (_this.options.play.effect === "fade") {
                        return _this._fade();
                    } else {
                        return _this._slide();
                    }
                }), this.options.play.interval));
                slidesContainer = $(".slidesjs-container", $element);
                if (this.options.play.pauseOnHover) {
                    slidesContainer.unbind();
                    slidesContainer.bind("mouseenter", function() {
                        return _this.stop();
                    });
                    slidesContainer.bind("mouseleave", function() {
                        if (_this.options.play.restartDelay) {
                            return $.data(_this, "restartDelay", setTimeout((function() {
                                return _this.play(true);
                            }), _this.options.play.restartDelay));
                        } else {
                            return _this.play();
                        }
                    });
                }
                $.data(this, "playing", true);
                $(".slidesjs-play", $element).addClass("slidesjs-playing");
                if (this.options.play.swap) {
                    $(".slidesjs-play", $element).hide();
                    return $(".slidesjs-stop", $element).show();
                }
            }
        };
        Plugin.prototype.stop = function(clicked) {
            var $element;
            $element = $(this.element);
            this.data = $.data(this);
            clearInterval(this.data.playInterval);
            if (this.options.play.pauseOnHover && clicked) {
                $(".slidesjs-container", $element).unbind();
            }
            $.data(this, "playInterval", null);
            $.data(this, "playing", false);
            $(".slidesjs-play", $element).removeClass("slidesjs-playing");
            if (this.options.play.swap) {
                $(".slidesjs-stop", $element).hide();
                return $(".slidesjs-play", $element).show();
            }
        };
        Plugin.prototype._slide = function(number) {
            var $element, currentSlide, direction, duration, next, prefix, slidesControl, timing, transform, value,
                _this = this;
            $element = $(this.element);
            this.data = $.data(this);
            if (!this.data.animating && number !== this.data.current + 1) {
                $.data(this, "animating", true);
                currentSlide = this.data.current;
                if (number > -1) {
                    number = number - 1;
                    value = number > currentSlide ? 1 : -1;
                    direction = number > currentSlide ? -this.options.width : this.options.width;
                    next = number;
                } else {
                    value = this.data.direction === "next" ? 1 : -1;
                    direction = this.data.direction === "next" ? -this.options.width : this.options.width;
                    next = currentSlide + value;
                }
                if (next === -1) {
                    next = this.data.total - 1;
                }
                if (next === this.data.total) {
                    next = 0;
                }
                this._setActive(next);
                slidesControl = $(".slidesjs-control", $element);
                if (number > -1) {
                    slidesControl.children(":not(:eq(" + currentSlide + "))").css({
                        display: "block",
                        left: 0,
                        zIndex: 0
                    });
                }
                slidesControl.children(":eq(" + next + ")").css({
                    display: "block",
                    left: value * this.options.width,
                    zIndex: 10
                });
                this.options.callback.start(currentSlide + 1);
                if (this.data.vendorPrefix) {
                    prefix = this.data.vendorPrefix;
                    transform = prefix + "Transform";
                    duration = prefix + "TransitionDuration";
                    timing = prefix + "TransitionTimingFunction";
                    slidesControl[0].style[transform] = "translateX(" + direction + "px)";
                    slidesControl[0].style[duration] = this.options.effect.slide.speed + "ms";
                    return $element.delegate(".slidesjs-control", "transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd", function() {
                       slidesControl[0].style[transform] = "";
                       slidesControl[0].style[duration] = "";
                       slidesControl.children(":eq(" + next + ")").css({
                           left: 0,
                           zIndex: 10
                       });
                       slidesControl.children(":eq(" + currentSlide + ")").css({
                           display: "block",
                           left: 0,
                           zIndex: 0
                       });
                       $.data(_this, "current", next);
                       $.data(_this, "animating", false);
                       slidesControl.unbind("transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd");
                       slidesControl.children(":not(:eq(" + next + "))").css({
                           display: "block",
                           left: 0,
                           zIndex: 0
                       });
                       if (_this.data.touch) {
                           _this._setuptouch();
                       }
                       return _this.options.callback.complete(next + 1);
                    });
                    } else {
                    return slidesControl.stop().animate({
                       left: direction
                    }, this.options.effect.slide.speed, (function() {
                       slidesControl.css({
                           left: 0
                       });
                       slidesControl.children(":eq(" + next + ")").css({
                           left: 0
                       });
                       return slidesControl.children(":eq(" + currentSlide + ")").css({
                           display: "block",
                           left: 0,
                           zIndex: 0
                       }, $.data(_this, "current", next), $.data(_this, "animating", false), _this.options.callback.complete(next + 1));
                    }));
                }
            }
        };
        Plugin.prototype._fade = function(number) {
            var $element, currentSlide, next, slidesControl, value,
                _this = this;
            $element = $(this.element);
            this.data = $.data(this);
            if (!this.data.animating && number !== this.data.current + 1) {
                $.data(this, "animating", true);
                currentSlide = this.data.current;
                if (number) {
                    number = number - 1;
                    value = number > currentSlide ? 1 : -1;
                    next = number;
                } else {
                    value = this.data.direction === "next" ? 1 : -1;
                    next = currentSlide + value;
                }
                if (next === -1) {
                    next = this.data.total - 1;
                }
                if (next === this.data.total) {
                    next = 0;
                }
                this._setActive(next);
                slidesControl = $(".slidesjs-control", $element);
                slidesControl.children(":eq(" + next + ")").css({
                    display: "block",
                    left: 0,
                    zIndex: 10
                });
                this.options.callback.start(currentSlide + 1);
                if (this.options.effect.fade.crossfade) {
                    slidesControl.children(":eq(" + this.data.current + ")").stop().fadeOut(this.options.effect.fade.speed);
                    return slidesControl.children(":eq(" + next + ")").stop().fadeIn(this.options.effect.fade.speed, (function() {
                        slidesControl.children(":eq(" + next + ")").css({
                            zIndex: 0
                        });
                        $.data(_this, "animating", false);
                        $.data(_this, "current", next);
                        return _this.options.callback.complete(next + 1);
                    }));
                } else {
                    return slidesControl.children(":eq(" + currentSlide + ")").stop().fadeOut(this.options.effect.fade.speed, (function() {
                        slidesControl.children(":eq(" + next + ")").stop().fadeIn(_this.options.effect.fade.speed, (function() {
                            return slidesControl.children(":eq(" + next + ")").css({
                                zIndex: 10
                            });
                        }));
                        $.data(_this, "animating", false);
                        $.data(_this, "current", next);
                        return _this.options.callback.complete(next + 1);
                    }));
                }
            }
        };
        Plugin.prototype._getVendorPrefix = function() {
            var body, i, style, transition, vendor;
            body = document.body || document.documentElement;
            style = body.style;
            transition = "transition";
            vendor = ["Moz", "Webkit", "Khtml", "O", "ms"];
            transition = transition.charAt(0).toUpperCase() + transition.substr(1);
            i = 0;
            while (i < vendor.length) {
                if (typeof style[vendor[i] + transition] === "string") {
                    return vendor[i];
                }
                i++;
            }
            return false;
        };
        return $.fn[pluginName] = function(options) {
            return this.each(function() {
                if (!$.data(this, "plugin_" + pluginName)) {
                    return $.data(this, "plugin_" + pluginName, new Plugin(this, options));
                }
            });
        };
    })(jQuery, window, document);

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {$.namespace = function() {
    var a=arguments, o=null, i, j, d, rt;
    for (i=0; i<a.length; ++i) {
        d=a[i].split(".");
        rt = d[0];
        eval('if (typeof ' + rt + ' == "undefined"){' + rt + ' = {};} o = ' + rt + ';');
        for (j=1; j<d.length; ++j) {
            o[d[j]]=o[d[j]] || {};
            o=o[d[j]];
        }
    }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*!
 Colorbox v1.5.7 - 2014-04-15
 jQuery lightbox and modal window plugin
 (c) 2014 Jack Moore - http://www.jacklmoore.com/colorbox
 license: http://www.opensource.org/licenses/mit-license.php
 */
(function ($, document, window) {
    var
    // Default settings object.
    // See http://jacklmoore.com/colorbox for details.
        defaults = {
            // data sources
            html: false,
            photo: false,
            iframe: false,
            inline: false,

            // behavior and appearance
            transition: "elastic",
            speed: 300,
            fadeOut: 300,
            width: false,
            initialWidth: "600",
            innerWidth: false,
            maxWidth: false,
            height: false,
            initialHeight: "450",
            innerHeight: false,
            maxHeight: false,
            scalePhotos: true,
            scrolling: true,
            opacity: 0.9,
            preloading: true,
            className: false,
            overlayClose: true,
            escKey: true,
            arrowKey: true,
            top: false,
            bottom: false,
            left: false,
            right: false,
            fixed: false,
            data: undefined,
            closeButton: true,
            fastIframe: true,
            open: false,
            reposition: true,
            loop: true,
            slideshow: false,
            slideshowAuto: true,
            slideshowSpeed: 2500,
            slideshowStart: "start slideshow",
            slideshowStop: "stop slideshow",
            photoRegex: /\.(gif|png|jp(e|g|eg)|bmp|ico|webp|jxr|svg)((#|\?).*)?$/i,

            // alternate image paths for high-res displays
            retinaImage: false,
            retinaUrl: false,
            retinaSuffix: '@2x.$1',

            // internationalization
            current: "image {current} of {total}",
            previous: "previous",
            next: "next",
            close: "close",
            xhrError: "This content failed to load.",
            imgError: "This image failed to load.",

            // accessbility
            returnFocus: true,
            trapFocus: true,

            // callbacks
            onOpen: false,
            onLoad: false,
            onComplete: false,
            onCleanup: false,
            onClosed: false,

            rel: function() {
                return this && this.rel ? this.rel : null;
            },
            href: function() {
                // Using .attr() so and href like '#container' can be used as a selector for inline content
                return this && this.href ? $(this).attr('href') : null;
            },
            title: function() {
                return this && this.title ? this.title : null;
            }
        },


    // Abstracting the HTML and event identifiers for easy rebranding
        colorbox = 'colorbox',
        prefix = 'cbox',
        boxElement = prefix + 'Element',

    // Events
        event_open = prefix + '_open',
        event_load = prefix + '_load',
        event_complete = prefix + '_complete',
        event_cleanup = prefix + '_cleanup',
        event_closed = prefix + '_closed',
        event_purge = prefix + '_purge',

    // Cached jQuery Object Variables
        $overlay,
        $box,
        $wrap,
        $content,
        $topBorder,
        $leftBorder,
        $rightBorder,
        $bottomBorder,
        $related,
        $window,
        $loaded,
        $loadingBay,
        $loadingOverlay,
        $title,
        $current,
        $slideshow,
        $next,
        $prev,
        $close,
        $groupControls,
        $events = $('<a/>'), // $({}) would be prefered, but there is an issue with jQuery 1.4.2

    // Variables for cached values or use across multiple functions
        settings,
        interfaceHeight,
        interfaceWidth,
        loadedHeight,
        loadedWidth,
        index,
        photo,
        open,
        active,
        closing,
        loadingTimer,
        publicMethod,
        div = "div",
        requests = 0,
        previousCSS = {},
        init;

    // ****************
    // HELPER FUNCTIONS
    // ****************

    // Convenience function for creating new jQuery objects
    function $tag(tag, id, css) {
        var element = document.createElement(tag);

        if (id) {
            element.id = prefix + id;
        }

        if (css) {
            element.style.cssText = css;
        }

        return $(element);
    }

    // Get the window height using innerHeight when available to avoid an issue with iOS
    // http://bugs.jquery.com/ticket/6724
    function winheight() {
        return window.innerHeight ? window.innerHeight : $(window).height();
    }

    function Settings(element, options) {
        if (options !== Object(options)) {
            options = {};
        }

        this.cache = {};
        this.el = element;

        this.value = function(key) {
            var dataAttr;

            if (this.cache[key] === undefined) {
                dataAttr = $(this.el).attr('data-cbox-'+key);

                if (dataAttr !== undefined) {
                    this.cache[key] = dataAttr;
                } else if (options[key] !== undefined) {
                    this.cache[key] = options[key];
                } else if (defaults[key] !== undefined) {
                    this.cache[key] = defaults[key];
                }
            }

            return this.cache[key];
        };

        this.get = function(key) {
            var value = this.value(key);
            return $.isFunction(value) ? value.call(this.el, this) : value;
        };
    }

    // Determine the next and previous members in a group.
    function getIndex(increment) {
        var
            max = $related.length,
            newIndex = (index + increment) % max;

        return (newIndex < 0) ? max + newIndex : newIndex;
    }

    // Convert '%' and 'px' values to integers
    function setSize(size, dimension) {
        return Math.round((/%/.test(size) ? ((dimension === 'x' ? $window.width() : winheight()) / 100) : 1) * parseInt(size, 10));
    }

    // Checks an href to see if it is a photo.
    // There is a force photo option (photo: true) for hrefs that cannot be matched by the regex.
    function isImage(settings, url) {
        return settings.get('photo') || settings.get('photoRegex').test(url);
    }

    function retinaUrl(settings, url) {
        return settings.get('retinaUrl') && window.devicePixelRatio > 1 ? url.replace(settings.get('photoRegex'), settings.get('retinaSuffix')) : url;
    }

    function trapFocus(e) {
        if ('contains' in $box[0] && !$box[0].contains(e.target) && e.target !== $overlay[0]) {
            e.stopPropagation();
            $box.focus();
        }
    }

    function setClass(str) {
        if (setClass.str !== str) {
            $box.add($overlay).removeClass(setClass.str).addClass(str);
            setClass.str = str;
        }
    }

    function getRelated() {
        index = 0;

        if (rel && rel !== false) {
            $related = $('.' + boxElement).filter(function () {
                var options = $.data(this, colorbox);
                var settings = new Settings(this, options);
                return (settings.get('rel') === rel);
            });
            index = $related.index(settings.el);

            // Check direct calls to Colorbox.
            if (index === -1) {
                $related = $related.add(settings.el);
                index = $related.length - 1;
            }
        } else {
            $related = $(settings.el);
        }
    }

    function trigger(event) {
        // for external use
        $(document).trigger(event);
        // for internal use
        $events.triggerHandler(event);
    }

    var slideshow = (function(){
        var active,
            className = prefix + "Slideshow_",
            click = "click." + prefix,
            timeOut;

        function clear () {
            clearTimeout(timeOut);
        }

        function set() {
            if (settings.get('loop') || $related[index + 1]) {
                clear();
                timeOut = setTimeout(publicMethod.next, settings.get('slideshowSpeed'));
            }
        }

        function start() {
            $slideshow
                .html(settings.get('slideshowStop'))
                .unbind(click)
                .one(click, stop);

            $events
                .bind(event_complete, set)
                .bind(event_load, clear);

            $box.removeClass(className + "off").addClass(className + "on");
        }

        function stop() {
            clear();

            $events
                .unbind(event_complete, set)
                .unbind(event_load, clear);

            $slideshow
                .html(settings.get('slideshowStart'))
                .unbind(click)
                .one(click, function () {
                    publicMethod.next();
                    start();
                });

            $box.removeClass(className + "on").addClass(className + "off");
        }

        function reset() {
            active = false;
            $slideshow.hide();
            clear();
            $events
                .unbind(event_complete, set)
                .unbind(event_load, clear);
            $box.removeClass(className + "off " + className + "on");
        }

        return function(){
            if (active) {
                if (!settings.get('slideshow')) {
                    $events.unbind(event_cleanup, reset);
                    reset();
                }
            } else {
                if (settings.get('slideshow') && $related[1]) {
                    active = true;
                    $events.one(event_cleanup, reset);
                    if (settings.get('slideshowAuto')) {
                        start();
                    } else {
                        stop();
                    }
                    $slideshow.show();
                }
            }
        };

    }());


    function launch(element) {
        var options;

        if (!closing) {

            options = $(element).data('colorbox');

            settings = new Settings(element, options);

            rel = settings.get('rel');

            getRelated();

            if (!open) {
                open = active = true; // Prevents the page-change action from queuing up if the visitor holds down the left or right keys.

                setClass(settings.get('className'));

                // Show colorbox so the sizes can be calculated in older versions of jQuery
                $box.css({visibility:'hidden', display:'block', opacity:''});

                $loaded = $tag(div, 'LoadedContent', 'width:0; height:0; overflow:hidden; visibility:hidden');
                $content.css({width:'', height:''}).append($loaded);

                // Cache values needed for size calculations
                interfaceHeight = $topBorder.height() + $bottomBorder.height() + $content.outerHeight(true) - $content.height();
                interfaceWidth = $leftBorder.width() + $rightBorder.width() + $content.outerWidth(true) - $content.width();
                loadedHeight = $loaded.outerHeight(true);
                loadedWidth = $loaded.outerWidth(true);

                // Opens inital empty Colorbox prior to content being loaded.
                var initialWidth = setSize(settings.get('initialWidth'), 'x');
                var initialHeight = setSize(settings.get('initialHeight'), 'y');
                var maxWidth = settings.get('maxWidth');
                var maxHeight = settings.get('maxHeight');

                settings.w = (maxWidth !== false ? Math.min(initialWidth, setSize(maxWidth, 'x')) : initialWidth) - loadedWidth - interfaceWidth;
                settings.h = (maxHeight !== false ? Math.min(initialHeight, setSize(maxHeight, 'y')) : initialHeight) - loadedHeight - interfaceHeight;

                $loaded.css({width:'', height:settings.h});
                publicMethod.position();

                trigger(event_open);
                settings.get('onOpen');

                $groupControls.add($title).hide();

                $box.focus();

                if (settings.get('trapFocus')) {
                    // Confine focus to the modal
                    // Uses event capturing that is not supported in IE8-
                    if (document.addEventListener) {

                        document.addEventListener('focus', trapFocus, true);

                        $events.one(event_closed, function () {
                            document.removeEventListener('focus', trapFocus, true);
                        });
                    }
                }

                // Return focus on closing
                if (settings.get('returnFocus')) {
                    $events.one(event_closed, function () {
                        $(settings.el).focus();
                    });
                }
            }

            $overlay.css({
                opacity: parseFloat(settings.get('opacity')) || '',
                cursor: settings.get('overlayClose') ? 'pointer' : '',
                visibility: 'visible'
            }).show();

            if (settings.get('closeButton')) {
                $close.html(settings.get('close')).appendTo($content);
            } else {
                $close.appendTo('<div/>'); // replace with .detach() when dropping jQuery < 1.4
            }

            load();
        }
    }

    // Colorbox's markup needs to be added to the DOM prior to being called
    // so that the browser will go ahead and load the CSS background images.
    function appendHTML() {
        if (!$box && document.body) {
            init = false;
            $window = $(window);
            $box = $tag(div).attr({
                id: colorbox,
                role: 'dialog',
                tabindex: '-1'
            }).hide();
            $overlay = $tag(div, "Overlay").hide();
            $loadingOverlay = $([$tag(div, "LoadingOverlay")[0],$tag(div, "LoadingGraphic")[0]]);
            $wrap = $tag(div, "Wrapper");
            $content = $tag(div, "Content").append(
                $title = $tag(div, "Title"),
                $current = $tag(div, "Current"),
                $prev = $('<button type="button"/>').attr({id:prefix+'Previous'}),
                $next = $('<button type="button"/>').attr({id:prefix+'Next'}),
                $slideshow = $tag('button', "Slideshow"),
                $loadingOverlay
            );

            $close = $('<button type="button"/>').attr({id:prefix+'Close'});

            $wrap.append( // The 3x3 Grid that makes up Colorbox
                $tag(div).append(
                    $tag(div, "TopLeft"),
                    $topBorder = $tag(div, "TopCenter"),
                    $tag(div, "TopRight")
                ),
                $tag(div, false, 'clear:left').append(
                    $leftBorder = $tag(div, "MiddleLeft"),
                    $content,
                    $rightBorder = $tag(div, "MiddleRight")
                ),
                $tag(div, false, 'clear:left').append(
                    $tag(div, "BottomLeft"),
                    $bottomBorder = $tag(div, "BottomCenter"),
                    $tag(div, "BottomRight")
                )
            ).find('div div').css({'float': 'left'});

            $loadingBay = $tag(div, false, 'position:absolute; width:9999px; visibility:hidden; display:none; max-width:none;');

            $groupControls = $next.add($prev).add($current).add($slideshow);

            $(document.body).append($overlay, $box.append($wrap, $loadingBay));
        }
    }

    // Add Colorbox's event bindings
    function addBindings() {
        function clickHandler(e) {
            // ignore non-left-mouse-clicks and clicks modified with ctrl / command, shift, or alt.
            // See: http://jacklmoore.com/notes/click-events/
            if (!(e.which > 1 || e.shiftKey || e.altKey || e.metaKey || e.ctrlKey)) {
                e.preventDefault();
                launch(this);
            }
        }

        if ($box) {
            if (!init) {
                init = true;

                // Anonymous functions here keep the public method from being cached, thereby allowing them to be redefined on the fly.
                $next.click(function () {
                    publicMethod.next();
                });
                $prev.click(function () {
                    publicMethod.prev();
                });
                $close.click(function () {
                    publicMethod.close();
                });
                $overlay.click(function () {
                    if (settings.get('overlayClose')) {
                        publicMethod.close();
                    }
                });

                // Key Bindings
                $(document).on('keydown.' + prefix, function (e) {
                    var key = e.keyCode;
                    if (open && settings.get('escKey') && key === 27) {
                        e.preventDefault();
                        publicMethod.close();
                    }
                    if (open && settings.get('arrowKey') && $related[1] && !e.altKey) {
                        if (key === 37) {
                            e.preventDefault();
                            $prev.click();
                        } else if (key === 39) {
                            e.preventDefault();
                            $next.click();
                        }
                    }
                });

                if ($.isFunction($.fn.on)) {
                    // For jQuery 1.7+
                    $(document).on('click.'+prefix, '.'+boxElement, clickHandler);
                } else {
                    // For jQuery 1.3.x -> 1.6.x
                    // This code is never reached in jQuery 1.9, so do not contact me about 'live' being removed.
                    // This is not here for jQuery 1.9, it's here for legacy users.
                    $('.'+boxElement).live('click.'+prefix, clickHandler);
                }
            }
            return true;
        }
        return false;
    }

    // Don't do anything if Colorbox already exists.
    if ($.colorbox) {
        return;
    }

    // Append the HTML when the DOM loads
    $(appendHTML);


    // ****************
    // PUBLIC FUNCTIONS
    // Usage format: $.colorbox.close();
    // Usage from within an iframe: parent.jQuery.colorbox.close();
    // ****************

    publicMethod = $.fn[colorbox] = $[colorbox] = function (options, callback) {
        var settings;
        var $obj = this;

        options = options || {};

        if ($.isFunction($obj)) { // assume a call to $.colorbox
            $obj = $('<a/>');
            options.open = true;
        } else if (!$obj[0]) { // colorbox being applied to empty collection
            return $obj;
        }


        if (!$obj[0]) { // colorbox being applied to empty collection
            return $obj;
        }

        appendHTML();

        if (addBindings()) {

            if (callback) {
                options.onComplete = callback;
            }

            $obj.each(function () {
                var old = $.data(this, colorbox) || {};
                $.data(this, colorbox, $.extend(old, options));
            }).addClass(boxElement);

            settings = new Settings($obj[0], options);

            if (settings.get('open')) {
                launch($obj[0]);
            }
        }

        return $obj;
    };

    publicMethod.position = function (speed, loadedCallback) {
        var
            css,
            top = 0,
            left = 0,
            offset = $box.offset(),
            scrollTop,
            scrollLeft;

        $window.unbind('resize.' + prefix);

        // remove the modal so that it doesn't influence the document width/height
        $box.css({top: -9e4, left: -9e4});

        scrollTop = $window.scrollTop();
        scrollLeft = $window.scrollLeft();

        if (settings.get('fixed')) {
            offset.top -= scrollTop;
            offset.left -= scrollLeft;
            $box.css({position: 'fixed'});
        } else {
            top = scrollTop;
            left = scrollLeft;
            $box.css({position: 'absolute'});
        }

        // keeps the top and left positions within the browser's viewport.
        if (settings.get('right') !== false) {
            left += Math.max($window.width() - settings.w - loadedWidth - interfaceWidth - setSize(settings.get('right'), 'x'), 0);
        } else if (settings.get('left') !== false) {
            left += setSize(settings.get('left'), 'x');
        } else {
            left += Math.round(Math.max($window.width() - settings.w - loadedWidth - interfaceWidth, 0) / 2);
        }

        if (settings.get('bottom') !== false) {
            top += Math.max(winheight() - settings.h - loadedHeight - interfaceHeight - setSize(settings.get('bottom'), 'y'), 0);
        } else if (settings.get('top') !== false) {
            top += setSize(settings.get('top'), 'y');
        } else {
            top += Math.round(Math.max(winheight() - settings.h - loadedHeight - interfaceHeight, 0) / 2);
        }

        $box.css({top: offset.top, left: offset.left, visibility:'visible'});

        // this gives the wrapper plenty of breathing room so it's floated contents can move around smoothly,
        // but it has to be shrank down around the size of div#colorbox when it's done.  If not,
        // it can invoke an obscure IE bug when using iframes.
        $wrap[0].style.width = $wrap[0].style.height = "9999px";

        function modalDimensions() {
            $topBorder[0].style.width = $bottomBorder[0].style.width = $content[0].style.width = (parseInt($box[0].style.width,10) - interfaceWidth)+'px';
            $content[0].style.height = $leftBorder[0].style.height = $rightBorder[0].style.height = (parseInt($box[0].style.height,10) - interfaceHeight)+'px';
        }

        css = {width: settings.w + loadedWidth + interfaceWidth, height: settings.h + loadedHeight + interfaceHeight, top: top, left: left};

        // setting the speed to 0 if the content hasn't changed size or position
        if (speed) {
            var tempSpeed = 0;
            $.each(css, function(i){
                if (css[i] !== previousCSS[i]) {
                    tempSpeed = speed;
                    return;
                }
            });
            speed = tempSpeed;
        }

        previousCSS = css;

        if (!speed) {
            $box.css(css);
        }

        $box.dequeue().animate(css, {
            duration: speed || 0,
            complete: function () {
                modalDimensions();

                active = false;

                // shrink the wrapper down to exactly the size of colorbox to avoid a bug in IE's iframe implementation.
                $wrap[0].style.width = (settings.w + loadedWidth + interfaceWidth) + "px";
                $wrap[0].style.height = (settings.h + loadedHeight + interfaceHeight) + "px";

                if (settings.get('reposition')) {
                    setTimeout(function () {  // small delay before binding onresize due to an IE8 bug.
                        $window.on('resize.' + prefix, publicMethod.position);
                    }, 1);
                }

                if (loadedCallback) {
                    loadedCallback();
                }
            },
            step: modalDimensions
        });
    };

    publicMethod.resize = function (options) {
        var scrolltop;

        if (open) {
            options = options || {};

            if (options.width) {
                settings.w = setSize(options.width, 'x') - loadedWidth - interfaceWidth;
            }

            if (options.innerWidth) {
                settings.w = setSize(options.innerWidth, 'x');
            }

            $loaded.css({width: settings.w});

            if (options.height) {
                settings.h = setSize(options.height, 'y') - loadedHeight - interfaceHeight;
            }

            if (options.innerHeight) {
                settings.h = setSize(options.innerHeight, 'y');
            }

            if (!options.innerHeight && !options.height) {
                scrolltop = $loaded.scrollTop();
                $loaded.css({height: "auto"});
                settings.h = $loaded.height();
            }

            $loaded.css({height: settings.h});

            if(scrolltop) {
                $loaded.scrollTop(scrolltop);
            }

            publicMethod.position(settings.get('transition') === "none" ? 0 : settings.get('speed'));
        }
    };

    publicMethod.prep = function (object) {
        if (!open) {
            return;
        }

        var callback, speed = settings.get('transition') === "none" ? 0 : settings.get('speed');

        $loaded.remove();

        $loaded = $tag(div, 'LoadedContent').append(object);

        function getWidth() {
            settings.w = settings.w || $loaded.width();
            settings.w = settings.mw && settings.mw < settings.w ? settings.mw : settings.w;
            return settings.w;
        }
        function getHeight() {
            settings.h = settings.h || $loaded.height();
            settings.h = settings.mh && settings.mh < settings.h ? settings.mh : settings.h;
            return settings.h;
        }

        $loaded.hide()
            .appendTo($loadingBay.show())// content has to be appended to the DOM for accurate size calculations.
            .css({width: getWidth(), overflow: settings.get('scrolling') ? 'auto' : 'hidden'})
            .css({height: getHeight()})// sets the height independently from the width in case the new width influences the value of height.
            .prependTo($content);

        $loadingBay.hide();

        // floating the IMG removes the bottom line-height and fixed a problem where IE miscalculates the width of the parent element as 100% of the document width.

        $(photo).css({'float': 'none'});

        setClass(settings.get('className'));

        callback = function () {
            var total = $related.length,
                iframe,
                complete;

            if (!open) {
                return;
            }

            complete = function () {
                clearTimeout(loadingTimer);
                $loadingOverlay.hide();
                trigger(event_complete);
                settings.get('onComplete');
            };


            $title.html(settings.get('title')).show();
            $loaded.show();

            if (total > 1) { // handle grouping
                if (typeof settings.get('current') === "string") {
                    $current.html(settings.get('current').replace('{current}', index + 1).replace('{total}', total)).show();
                }

                $next[(settings.get('loop') || index < total - 1) ? "show" : "hide"]().html(settings.get('next'));
                $prev[(settings.get('loop') || index) ? "show" : "hide"]().html(settings.get('previous'));

                slideshow();

                // Preloads images within a rel group
                if (settings.get('preloading')) {
                    $.each([getIndex(-1), getIndex(1)], function(){
                        var img,
                            i = $related[this],
                            settings = new Settings(i, $.data(i, colorbox)),
                            src = settings.get('href');

                        if (src && isImage(settings, src)) {
                            src = retinaUrl(settings, src);
                            img = document.createElement('img');
                            img.src = src;
                        }
                    });
                }
            } else {
                $groupControls.hide();
            }

            if (settings.get('iframe')) {
                iframe = document.createElement('iframe');

                if ('frameBorder' in iframe) {
                    iframe.frameBorder = 0;
                }

                if ('allowTransparency' in iframe) {
                    iframe.allowTransparency = "true";
                }

                if (!settings.get('scrolling')) {
                    iframe.scrolling = "no";
                }

                $(iframe)
                    .attr({
                        src: settings.get('href'),
                        name: (new Date()).getTime(), // give the iframe a unique name to prevent caching
                        'class': prefix + 'Iframe',
                        allowFullScreen : true // allow HTML5 video to go fullscreen
                    })
                    .one('load', complete)
                    .appendTo($loaded);

                $events.one(event_purge, function () {
                    iframe.src = "//about:blank";
                });

                if (settings.get('fastIframe')) {
                    $(iframe).trigger('load');
                }
            } else {
                complete();
            }

            if (settings.get('transition') === 'fade') {
                $box.fadeTo(speed, 1);
            }
        };

        if (settings.get('transition') === 'fade') {
            $box.fadeTo(speed, 0, function () {
                publicMethod.position(0, callback);
            });
        } else {
            publicMethod.position(speed, callback);
        }
    };

    function load () {
        var href, setResize, prep = publicMethod.prep, $inline, request = ++requests;

        active = true;

        photo = false;

        trigger(event_purge);
        trigger(event_load);
        settings.get('onLoad');

        settings.h = settings.get('height') ?
            setSize(settings.get('height'), 'y') - loadedHeight - interfaceHeight :
            settings.get('innerHeight') && setSize(settings.get('innerHeight'), 'y');

        settings.w = settings.get('width') ?
            setSize(settings.get('width'), 'x') - loadedWidth - interfaceWidth :
            settings.get('innerWidth') && setSize(settings.get('innerWidth'), 'x');

        // Sets the minimum dimensions for use in image scaling
        settings.mw = settings.w;
        settings.mh = settings.h;

        // Re-evaluate the minimum width and height based on maxWidth and maxHeight values.
        // If the width or height exceed the maxWidth or maxHeight, use the maximum values instead.
        if (settings.get('maxWidth')) {
            settings.mw = setSize(settings.get('maxWidth'), 'x') - loadedWidth - interfaceWidth;
            settings.mw = settings.w && settings.w < settings.mw ? settings.w : settings.mw;
        }
        if (settings.get('maxHeight')) {
            settings.mh = setSize(settings.get('maxHeight'), 'y') - loadedHeight - interfaceHeight;
            settings.mh = settings.h && settings.h < settings.mh ? settings.h : settings.mh;
        }

        href = settings.get('href');

        loadingTimer = setTimeout(function () {
            $loadingOverlay.show();
        }, 100);

        if (settings.get('inline')) {
            // Inserts an empty placeholder where inline content is being pulled from.
            // An event is bound to put inline content back when Colorbox closes or loads new content.
            $inline = $tag(div).hide().insertBefore($(href)[0]);

            $events.one(event_purge, function () {
                $inline.replaceWith($loaded.children());
            });

            prep($(href));
        } else if (settings.get('iframe')) {
            // IFrame element won't be added to the DOM until it is ready to be displayed,
            // to avoid problems with DOM-ready JS that might be trying to run in that iframe.
            prep(" ");
        } else if (settings.get('html')) {
            prep(settings.get('html'));
        } else if (isImage(settings, href)) {

            href = retinaUrl(settings, href);

            photo = new Image();

            $(photo)
                .addClass(prefix + 'Photo')
                .on('error',function () {
                    prep($tag(div, 'Error').html(settings.get('imgError')));
                })
                .one('load', function () {
                    if (request !== requests) {
                        return;
                    }

                    // A small pause because some browsers will occassionaly report a 
                    // img.width and img.height of zero immediately after the img.onload fires
                    setTimeout(function(){
                        var percent;

                        $.each(['alt', 'longdesc', 'aria-describedby'], function(i,val){
                            var attr = $(settings.el).attr(val) || $(settings.el).attr('data-'+val);
                            if (attr) {
                                photo.setAttribute(val, attr);
                            }
                        });

                        if (settings.get('retinaImage') && window.devicePixelRatio > 1) {
                            photo.height = photo.height / window.devicePixelRatio;
                            photo.width = photo.width / window.devicePixelRatio;
                        }

                        if (settings.get('scalePhotos')) {
                            setResize = function () {
                                photo.height -= photo.height * percent;
                                photo.width -= photo.width * percent;
                            };
                            if (settings.mw && photo.width > settings.mw) {
                                percent = (photo.width - settings.mw) / photo.width;
                                setResize();
                            }
                            if (settings.mh && photo.height > settings.mh) {
                                percent = (photo.height - settings.mh) / photo.height;
                                setResize();
                            }
                        }

                        if (settings.h) {
                            photo.style.marginTop = Math.max(settings.mh - photo.height, 0) / 2 + 'px';
                        }

                        if ($related[1] && (settings.get('loop') || $related[index + 1])) {
                            photo.style.cursor = 'pointer';
                            photo.onclick = function () {
                                publicMethod.next();
                            };
                        }

                        photo.style.width = photo.width + 'px';
                        photo.style.height = photo.height + 'px';
                        prep(photo);
                    }, 1);
                });

            photo.src = href;

        } else if (href) {
            $loadingBay.load(href, settings.get('data'), function (data, status) {
                if (request === requests) {
                    prep(status === 'error' ? $tag(div, 'Error').html(settings.get('xhrError')) : $(this).contents());
                }
            });
        }
    }

    // Navigates to the next page/image in a set.
    publicMethod.next = function () {
        if (!active && $related[1] && (settings.get('loop') || $related[index + 1])) {
            index = getIndex(1);
            launch($related[index]);
        }
    };

    publicMethod.prev = function () {
        if (!active && $related[1] && (settings.get('loop') || index)) {
            index = getIndex(-1);
            launch($related[index]);
        }
    };

    // Note: to use this within an iframe use the following format: parent.jQuery.colorbox.close();
    publicMethod.close = function () {
        if (open && !closing) {

            closing = true;
            open = false;
            trigger(event_cleanup);
            settings.get('onCleanup');
            $window.unbind('.' + prefix);
            $overlay.fadeTo(settings.get('fadeOut') || 0, 0);

            $box.stop().fadeTo(settings.get('fadeOut') || 0, 0, function () {
                $box.hide();
                $overlay.hide();
                trigger(event_purge);
                $loaded.remove();

                setTimeout(function () {
                    closing = false;
                    trigger(event_closed);
                    settings.get('onClosed');
                }, 1);
            });
        }
    };

    // Removes changes Colorbox made to the document, but does not remove the plugin.
    publicMethod.remove = function () {
        if (!$box) { return; }

        $box.stop();
        $.colorbox.close();
        $box.stop().remove();
        $overlay.remove();
        closing = false;
        $box = null;
        $('.' + boxElement)
            .removeData(colorbox)
            .removeClass(boxElement);

        $(document).unbind('click.'+prefix);
    };

    // A method for fetching the current element Colorbox is referencing.
    // returns a jQuery object.
    publicMethod.element = function () {
        return $(settings.el);
    };

    publicMethod.settings = defaults;

}(jQuery, document, window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/*! jquery.selectBoxIt - v3.8.0 - 2013-08-13 
 * http://www.selectboxit.com
 * Copyright (c) 2013 Greg Franko; Licensed MIT*/

// Immediately-Invoked Function Expression (IIFE) [Ben Alman Blog Post](http://benalman.com/news/2010/11/immediately-invoked-function-expression/) that calls another IIFE that contains all of the plugin logic.  I used this pattern so that anyone viewing this code would not have to scroll to the bottom of the page to view the local parameters that were passed to the main IIFE.

;(function (selectBoxIt) {

    //ECMAScript 5 Strict Mode: [John Resig Blog Post](http://ejohn.org/blog/ecmascript-5-strict-mode-json-and-more/)
    "use strict";

    // Calls the second IIFE and locally passes in the global jQuery, window, and document objects
    selectBoxIt(__webpack_provided_window_dot_jQuery, window, document);

}

// Locally passes in `jQuery`, the `window` object, the `document` object, and an `undefined` variable.  The `jQuery`, `window` and `document` objects are passed in locally, to improve performance, since javascript first searches for a variable match within the local variables set before searching the global variables set.  All of the global variables are also passed in locally to be minifier friendly. `undefined` can be passed in locally, because it is not a reserved word in JavaScript.

(function ($, window, document, undefined) {

    // ECMAScript 5 Strict Mode: [John Resig Blog Post](http://ejohn.org/blog/ecmascript-5-strict-mode-json-and-more/)
    "use strict";

    // Calling the jQueryUI Widget Factory Method
    $.widget("selectBox.selectBoxIt", {

        // Plugin version
        VERSION: "3.8.0",

        // These options will be used as defaults
        options: {

            // **showEffect**: Accepts String: "none", "fadeIn", "show", "slideDown", or any of the jQueryUI show effects (i.e. "bounce")
            "showEffect": "none",

            // **showEffectOptions**: Accepts an object literal.  All of the available properties are based on the jqueryUI effect options
            "showEffectOptions": {},

            // **showEffectSpeed**: Accepts Number (milliseconds) or String: "slow", "medium", or "fast"
            "showEffectSpeed": "medium",

            // **hideEffect**: Accepts String: "none", "fadeOut", "hide", "slideUp", or any of the jQueryUI hide effects (i.e. "explode")
            "hideEffect": "none",

            // **hideEffectOptions**: Accepts an object literal.  All of the available properties are based on the jqueryUI effect options
            "hideEffectOptions": {},

            // **hideEffectSpeed**: Accepts Number (milliseconds) or String: "slow", "medium", or "fast"
            "hideEffectSpeed": "medium",

            // **showFirstOption**: Shows the first dropdown list option within the dropdown list options list
            "showFirstOption": true,

            // **defaultText**: Overrides the text used by the dropdown list selected option to allow a user to specify custom text.  Accepts a String.
            "defaultText": "",

            // **defaultIcon**: Overrides the icon used by the dropdown list selected option to allow a user to specify a custom icon.  Accepts a String (CSS class name(s)).
            "defaultIcon": "",

            // **downArrowIcon**: Overrides the default down arrow used by the dropdown list to allow a user to specify a custom image.  Accepts a String (CSS class name(s)).
            "downArrowIcon": "",

            // **theme**: Provides theming support for Twitter Bootstrap and jQueryUI
            "theme": "default",

            // **keydownOpen**: Opens the dropdown if the up or down key is pressed when the dropdown is focused
            "keydownOpen": true,

            // **isMobile**: Function to determine if a user's browser is a mobile browser
            "isMobile": function() {

                // Adapted from http://www.detectmobilebrowsers.com
                var ua = navigator.userAgent || navigator.vendor || window.opera;

                // Checks for iOs, Android, Blackberry, Opera Mini, and Windows mobile devices
                return (/iPhone|iPod|iPad|Silk|Android|BlackBerry|Opera Mini|IEMobile/).test(ua);

            },

            // **native**: Triggers the native select box when a user interacts with the drop down
            "native": false,

            // **aggressiveChange**: Will select a drop down item (and trigger a change event) when a user navigates to the item via the keyboard (up and down arrow or search), before a user selects an option with a click or the enter key
            "aggressiveChange": false,

            // **selectWhenHidden: Will allow a user to select an option using the keyboard when the drop down list is hidden and focused
            "selectWhenHidden": true,

            // **viewport**: Allows for a custom domnode used for the viewport. Accepts a selector.  Default is $(window).
            "viewport": $(window),

            // **similarSearch**: Optimizes the search for lists with many similar values (i.e. State lists) by making it easier to navigate through
            "similarSearch": false,

            // **copyAttributes**: HTML attributes that will be copied over to the new drop down
            "copyAttributes": [

                "title",

                "rel"

            ],

            // **copyClasses**: HTML classes that will be copied over to the new drop down.  The value indicates where the classes should be copied.  The default value is 'button', but you can also use 'container' (recommended) or 'none'.
            "copyClasses": "button",

            // **nativeMousedown**: Mimics native firefox drop down behavior by opening the drop down on mousedown and selecting the currently hovered drop down option on mouseup
            "nativeMousedown": false,

            // **customShowHideEvent**: Prevents the drop down from opening on click or mousedown, which allows a user to open/close the drop down with a custom event handler.
            "customShowHideEvent": false,

            // **autoWidth**: Makes sure the width of the drop down is wide enough to fit all of the drop down options
            "autoWidth": true,

            // **html**: Determines whether or not option text is rendered as html or as text
            "html": true,

            // **populate**: Convenience option that accepts JSON data, an array, a single object, or valid HTML string to add options to the drop down list
            "populate": "",

            // **dynamicPositioning**: Determines whether or not the drop down list should fit inside it's viewport
            "dynamicPositioning": true,

            // **hideCurrent**: Determines whether or not the currently selected drop down option is hidden in the list
            "hideCurrent": false

        },

        // Get Themes
        // ----------
        //      Retrieves the active drop down theme and returns the theme object
        "getThemes": function() {

            var self = this,
                theme = $(self.element).attr("data-theme") || "c";

            return {

                // Twitter Bootstrap Theme
                "bootstrap": {

                    "focus": "active",

                    "hover": "",

                    "enabled": "enabled",

                    "disabled": "disabled",

                    "arrow": "caret",

                    "button": "btn",

                    "list": "dropdown-menu",

                    "container": "bootstrap",

                    "open": "open"

                },

                // jQueryUI Theme
                "jqueryui": {

                    "focus": "ui-state-focus",

                    "hover": "ui-state-hover",

                    "enabled": "ui-state-enabled",

                    "disabled": "ui-state-disabled",

                    "arrow": "ui-icon ui-icon-triangle-1-s",

                    "button": "ui-widget ui-state-default",

                    "list": "ui-widget ui-widget-content",

                    "container": "jqueryui",

                    "open": "selectboxit-open"

                },

                // jQuery Mobile Theme
                "jquerymobile": {

                    "focus": "ui-btn-down-" + theme,

                    "hover": "ui-btn-hover-" + theme,

                    "enabled": "ui-enabled",

                    "disabled": "ui-disabled",

                    "arrow": "ui-icon ui-icon-arrow-d ui-icon-shadow",

                    "button": "ui-btn ui-btn-icon-right ui-btn-corner-all ui-shadow ui-btn-up-" + theme,

                    "list": "ui-btn ui-btn-icon-right ui-btn-corner-all ui-shadow ui-btn-up-" + theme,

                    "container": "jquerymobile",

                    "open": "selectboxit-open"

                },

                "default": {

                    "focus": "selectboxit-focus",

                    "hover": "selectboxit-hover",

                    "enabled": "selectboxit-enabled",

                    "disabled": "selectboxit-disabled",

                    "arrow": "selectboxit-default-arrow",

                    "button": "selectboxit-btn",

                    "list": "selectboxit-list",

                    "container": "selectboxit-container",

                    "open": "selectboxit-open"

                }

            };

        },

        // isDeferred
        // ----------
        //      Checks if parameter is a defered object      
        isDeferred: function(def) {
            return $.isPlainObject(def) && def.promise && def.done;
        },

        // _Create
        // -------
        //      Sets the Plugin Instance variables and
        //      constructs the plugin.  Only called once.
        _create: function(internal) {

            var self = this,
                populateOption = self.options["populate"],
                userTheme = self.options["theme"];

            // If the element calling SelectBoxIt is not a select box or is not visible
            if(!self.element.is("select")) {

                // Exits the plugin
                return;

            }

            // Stores a reference to the parent Widget class
            self.widgetProto = $.Widget.prototype;

            // The original select box DOM element
            self.originalElem = self.element[0];

            // The original select box DOM element wrapped in a jQuery object
            self.selectBox = self.element;

            if(self.options["populate"] && self.add && !internal) {

                self.add(populateOption);

            }

            // All of the original select box options
            self.selectItems = self.element.find("option");

            // The first option in the original select box
            self.firstSelectItem = self.selectItems.slice(0, 1);

            // The html document height
            self.documentHeight = $(document).height();

            self.theme = $.isPlainObject(userTheme) ? $.extend({}, self.getThemes()["default"], userTheme) : self.getThemes()[userTheme] ? self.getThemes()[userTheme] : self.getThemes()["default"];

            // The index of the currently selected dropdown list option
            self.currentFocus = 0;

            // Keeps track of which blur events will hide the dropdown list options
            self.blur = true;

            // Array holding all of the original select box options text
            self.textArray = [];

            // Maintains search order in the `search` method
            self.currentIndex = 0;

            // Maintains the current search text in the `search` method
            self.currentText = "";

            // Whether or not the dropdown list opens up or down (depending on how much room is on the page)
            self.flipped = false;

            // If the create method is not called internally by the plugin
            if(!internal) {

                // Saves the original select box `style` attribute within the `selectBoxStyles` plugin instance property
                self.selectBoxStyles = self.selectBox.attr("style");

            }

            // Creates the dropdown elements that will become the dropdown
            // Creates the ul element that will become the dropdown options list
            // Add's all attributes (excluding id, class names, and unselectable properties) to the drop down and drop down items list
            // Hides the original select box and adds the new plugin DOM elements to the page
            // Adds event handlers to the new dropdown list
            self._createDropdownButton()._createUnorderedList()._copyAttributes()._replaceSelectBox()._addClasses(self.theme)._eventHandlers();

            if(self.originalElem.disabled && self.disable) {

                // Disables the dropdown list if the original dropdown list had the `disabled` attribute
                self.disable();

            }

            // If the Aria Accessibility Module has been included
            if(self._ariaAccessibility) {

                // Adds ARIA accessibillity tags to the dropdown list
                self._ariaAccessibility();

            }

            self.isMobile = self.options["isMobile"]();

            if(self._mobile) {

                // Adds mobile support
                self._mobile();

            }

            // If the native option is set to true
            if(self.options["native"]) {

                // Triggers the native select box when a user is interacting with the drop down
                this._applyNativeSelect();

            }

            // Triggers a custom `create` event on the original dropdown list
            self.triggerEvent("create");

            // Maintains chainability
            return self;

        },

        // _Create dropdown button
        // -----------------------
        //      Creates new dropdown and dropdown elements to replace
        //      the original select box with a dropdown list
        _createDropdownButton: function() {

            var self = this,
                originalElemId = self.originalElemId = self.originalElem.id || "",
                originalElemValue = self.originalElemValue = self.originalElem.value || "",
                originalElemName = self.originalElemName = self.originalElem.name || "",
                copyClasses = self.options["copyClasses"],
                selectboxClasses = self.selectBox.attr("class") || "";

            // Creates a dropdown element that contains the dropdown list text value
            self.dropdownText = $("<span/>", {

                // Dynamically sets the dropdown `id` attribute
                "id": originalElemId && originalElemId + "SelectBoxItText",

                "class": "selectboxit-text",

                // IE specific attribute to not allow the element to be selected
                "unselectable": "on",

                // Sets the dropdown `text` to equal the original select box default value
                "text": self.firstSelectItem.text()

            }).

                // Sets the HTML5 data attribute on the dropdownText `dropdown` element
                attr("data-val", originalElemValue);

            self.dropdownImageContainer = $("<span/>", {

                "class": "selectboxit-option-icon-container"

            });

            // Creates a dropdown element that contains the dropdown list text value
            self.dropdownImage = $("<i/>", {

                // Dynamically sets the dropdown `id` attribute
                "id": originalElemId && originalElemId + "SelectBoxItDefaultIcon",

                "class": "selectboxit-default-icon",

                // IE specific attribute to not allow the element to be selected
                "unselectable": "on"

            });

            // Creates a dropdown to act as the new dropdown list
            self.dropdown = $("<span/>", {

                // Dynamically sets the dropdown `id` attribute
                "id": originalElemId && originalElemId + "SelectBoxIt",

                "class": "selectboxit " + (copyClasses === "button" ? selectboxClasses: "") + " " + (self.selectBox.prop("disabled") ? self.theme["disabled"]: self.theme["enabled"]),

                // Sets the dropdown `name` attribute to be the same name as the original select box
                "name": originalElemName,

                // Sets the dropdown `tabindex` attribute to 0 to allow the dropdown to be focusable
                "tabindex": self.selectBox.attr("tabindex") || "0",

                // IE specific attribute to not allow the element to be selected
                "unselectable": "on"

            }).

                // Appends the default text to the inner dropdown list dropdown element
                append(self.dropdownImageContainer.append(self.dropdownImage)).append(self.dropdownText);

            // Create the dropdown container that will hold all of the dropdown list dom elements
            self.dropdownContainer = $("<span/>", {

                "id": originalElemId && originalElemId + "SelectBoxItContainer",

                "class": 'selectboxit-container ' + self.theme.container + ' ' + (copyClasses === "container" ? selectboxClasses: "")

            }).

                // Appends the inner dropdown list dropdown element to the dropdown list container dropdown element
                append(self.dropdown);

            // Maintains chainability
            return self;

        },

        // _Create Unordered List
        // ----------------------
        //      Creates an unordered list element to hold the
        //        new dropdown list options that directly match
        //        the values of the original select box options
        _createUnorderedList: function() {

            // Storing the context of the widget
            var self = this,

                dataDisabled,

                optgroupClass,

                optgroupElement,

                iconClass,

                iconUrl,

                iconUrlClass,

                iconUrlStyle,

            // Declaring the variable that will hold all of the dropdown list option elements
                currentItem = "",

                originalElemId = self.originalElemId || "",

            // Creates an unordered list element
                createdList = $("<ul/>", {

                    // Sets the unordered list `id` attribute
                    "id": originalElemId && originalElemId + "SelectBoxItOptions",

                    "class": "selectboxit-options",

                    //Sets the unordered list `tabindex` attribute to -1 to prevent the unordered list from being focusable
                    "tabindex": -1

                }),

                currentDataSelectedText,

                currentDataText,

                currentDataSearch,

                currentText,

                currentOption,

                parent;

            // Checks the `showFirstOption` plugin option to determine if the first dropdown list option should be shown in the options list.
            if (!self.options["showFirstOption"]) {

                // Disables the first select box option
                self.selectItems.first().attr("disabled", "disabled");

                // Excludes the first dropdown list option from the options list
                self.selectItems = self.selectBox.find("option").slice(1);

            }

            // Loops through the original select box options list and copies the text of each
            // into new list item elements of the new dropdown list
            self.selectItems.each(function(index) {

                currentOption = $(this);

                optgroupClass = "";

                optgroupElement = "";

                dataDisabled = currentOption.prop("disabled");

                iconClass = currentOption.attr("data-icon") || "";

                iconUrl = currentOption.attr("data-iconurl") || "";

                iconUrlClass = iconUrl ? "selectboxit-option-icon-url": "";

                iconUrlStyle = iconUrl ? 'style="background-image:url(\'' + iconUrl + '\');"': "";

                currentDataSelectedText = currentOption.attr("data-selectedtext");

                currentDataText = currentOption.attr("data-text");

                currentText = currentDataText ? currentDataText: currentOption.text();

                parent = currentOption.parent();

                // If the current option being traversed is within an optgroup

                if(parent.is("optgroup")) {

                    optgroupClass = "selectboxit-optgroup-option";

                    if(currentOption.index() === 0) {

                        optgroupElement = '<span class="selectboxit-optgroup-header ' + parent.first().attr("class") + '"data-disabled="true">' + parent.first().attr("label") + '</span>';

                    }

                }

                // Uses string concatenation for speed (applies HTML attribute encoding)
                currentItem += optgroupElement + '<li data-id="' + index + '" data-val="' + this.value + '" data-disabled="' + dataDisabled + '" class="' + optgroupClass + " selectboxit-option " + ($(this).attr("class") || "") + '"><a class="selectboxit-option-anchor"><span class="selectboxit-option-icon-container"><i class="selectboxit-option-icon ' + iconClass + ' ' + (iconUrlClass || self.theme["container"]) + '"' + iconUrlStyle + '></i></span>' + (self.options["html"] ? currentText: self.htmlEscape(currentText)) + '</a></li>';

                currentDataSearch = currentOption.attr("data-search");

                // Stores all of the original select box options text inside of an array
                // (Used later in the `searchAlgorithm` method)
                self.textArray[index] = dataDisabled ? "": currentDataSearch ? currentDataSearch: currentText;

                // Checks the original select box option for the `selected` attribute
                if (this.selected) {

                    // Replaces the default text with the selected option text
                    self._setText(self.dropdownText, currentDataSelectedText || currentText);

                    //Set the currently selected option
                    self.currentFocus = index;

                }

            });

            // If the `defaultText` option is being used
            if ((self.options["defaultText"] || self.selectBox.attr("data-text"))) {

                var defaultedText = self.options["defaultText"] || self.selectBox.attr("data-text");

                // Overrides the current dropdown default text with the value the user specifies in the `defaultText` option
                self._setText(self.dropdownText, defaultedText);

                self.options["defaultText"] = defaultedText;

            }

            // Append the list item to the unordered list
            createdList.append(currentItem);

            // Stores the dropdown list options list inside of the `list` instance variable
            self.list = createdList;

            // Append the dropdown list options list to the dropdown container element
            self.dropdownContainer.append(self.list);

            // Stores the individual dropdown list options inside of the `listItems` instance variable
            self.listItems = self.list.children("li");

            self.listAnchors = self.list.find("a");

            // Sets the 'selectboxit-option-first' class name on the first drop down option
            self.listItems.first().addClass("selectboxit-option-first");

            // Sets the 'selectboxit-option-last' class name on the last drop down option
            self.listItems.last().addClass("selectboxit-option-last");

            // Set the disabled CSS class for select box options
            self.list.find("li[data-disabled='true']").not(".optgroupHeader").addClass(self.theme["disabled"]);

            self.dropdownImage.addClass(self.selectBox.attr("data-icon") || self.options["defaultIcon"] || self.listItems.eq(self.currentFocus).find("i").attr("class"));

            self.dropdownImage.attr("style", self.listItems.eq(self.currentFocus).find("i").attr("style"));

            //Maintains chainability
            return self;

        },

        // _Replace Select Box
        // -------------------
        //      Hides the original dropdown list and inserts
        //        the new DOM elements
        _replaceSelectBox: function() {

            var self = this,
                height,
                originalElemId = self.originalElem.id || "",
                size = self.selectBox.attr("data-size"),
                listSize = self.listSize = size === undefined ? "auto" : size === "0" || "size" === "auto" ? "auto" : +size,
                downArrowContainerWidth,
                dropdownImageWidth;

            // Hides the original select box
            self.selectBox.css("display", "none").

                // Adds the new dropdown list to the page directly after the hidden original select box element
                after(self.dropdownContainer);

            self.dropdownContainer.appendTo('body').

                addClass('selectboxit-rendering');

            // The height of the dropdown list
            height = self.dropdown.height();

            // The down arrow element of the dropdown list
            self.downArrow = $("<i/>", {

                // Dynamically sets the dropdown `id` attribute of the dropdown list down arrow
                "id": originalElemId && originalElemId + "SelectBoxItArrow",

                "class": "selectboxit-arrow",

                // IE specific attribute to not allow the dropdown list text to be selected
                "unselectable": "on"

            });

            // The down arrow container element of the dropdown list
            self.downArrowContainer = $("<span/>", {

                // Dynamically sets the dropdown `id` attribute for the down arrow container element
                "id": originalElemId && originalElemId + "SelectBoxItArrowContainer",

                "class": "selectboxit-arrow-container",

                // IE specific attribute to not allow the dropdown list text to be selected
                "unselectable": "on"

            }).

                // Inserts the down arrow element inside of the down arrow container element
                append(self.downArrow);

            // Appends the down arrow element to the dropdown list
            self.dropdown.append(self.downArrowContainer);

            // Adds the `selectboxit-selected` class name to the currently selected drop down option
            self.listItems.removeClass("selectboxit-selected").eq(self.currentFocus).addClass("selectboxit-selected");

            // The full outer width of the down arrow container
            downArrowContainerWidth = self.downArrowContainer.outerWidth(true);

            // The full outer width of the dropdown image
            dropdownImageWidth = self.dropdownImage.outerWidth(true);

            // If the `autoWidth` option is true
            if(self.options["autoWidth"]) {

                // Sets the auto width of the drop down
                self.dropdown.css({ "width": "auto" }).css({

                    "width": self.list.outerWidth(true) + downArrowContainerWidth + dropdownImageWidth

                });

                self.list.css({

                    "min-width": self.dropdown.width()

                });

            }

            // Dynamically adds the `max-width` and `line-height` CSS styles of the dropdown list text element
            self.dropdownText.css({

                "max-width": self.dropdownContainer.outerWidth(true) - (downArrowContainerWidth + dropdownImageWidth)

            });

            // Adds the new dropdown list to the page directly after the hidden original select box element
            self.selectBox.after(self.dropdownContainer);

            self.dropdownContainer.removeClass('selectboxit-rendering');

            if($.type(listSize) === "number") {

                // Stores the new `max-height` for later
                self.maxHeight = self.listAnchors.outerHeight(true) * listSize;

            }

            // Maintains chainability
            return self;

        },

        // _Scroll-To-View
        // ---------------
        //      Updates the dropdown list scrollTop value
        _scrollToView: function(type) {

            var self = this,

                currentOption = self.listItems.eq(self.currentFocus),

            // The current scroll positioning of the dropdown list options list
                listScrollTop = self.list.scrollTop(),

            // The height of the currently selected dropdown list option
                currentItemHeight = currentOption.height(),

            // The relative distance from the currently selected dropdown list option to the the top of the dropdown list options list
                currentTopPosition = currentOption.position().top,

                absCurrentTopPosition = Math.abs(currentTopPosition),

            // The height of the dropdown list option list
                listHeight = self.list.height(),

                currentText;

            // Scrolling logic for a text search
            if (type === "search") {

                // Increases the dropdown list options `scrollTop` if a user is searching for an option
                // below the currently selected option that is not visible
                if (listHeight - currentTopPosition < currentItemHeight) {

                    // The selected option will be shown at the very bottom of the visible options list
                    self.list.scrollTop(listScrollTop + (currentTopPosition - (listHeight - currentItemHeight)));

                }

                // Decreases the dropdown list options `scrollTop` if a user is searching for an option above the currently selected option that is not visible
                else if (currentTopPosition < -1) {

                    self.list.scrollTop(currentTopPosition - currentItemHeight);

                }
            }

            // Scrolling logic for the `up` keyboard navigation
            else if (type === "up") {

                // Decreases the dropdown list option list `scrollTop` if a user is navigating to an element that is not visible
                if (currentTopPosition < -1) {

                    self.list.scrollTop(listScrollTop - absCurrentTopPosition);

                }
            }

            // Scrolling logic for the `down` keyboard navigation
            else if (type === "down") {

                // Increases the dropdown list options `scrollTop` if a user is navigating to an element that is not fully visible
                if (listHeight - currentTopPosition < currentItemHeight) {

                    // Increases the dropdown list options `scrollTop` by the height of the current option item.
                    self.list.scrollTop((listScrollTop + (absCurrentTopPosition - listHeight + currentItemHeight)));

                }
            }

            // Maintains chainability
            return self;

        },

        // _Callback
        // ---------
        //      Call the function passed into the method
        _callbackSupport: function(callback) {

            var self = this;

            // Checks to make sure the parameter passed in is a function
            if ($.isFunction(callback)) {

                // Calls the method passed in as a parameter and sets the current `SelectBoxIt` object that is stored in the jQuery data method as the context(allows for `this` to reference the SelectBoxIt API Methods in the callback function. The `dropdown` DOM element that acts as the new dropdown list is also passed as the only parameter to the callback
                callback.call(self, self.dropdown);

            }

            // Maintains chainability
            return self;

        },

        // _setText
        // --------
        //      Set's the text or html for the drop down
        _setText: function(elem, currentText) {

            var self = this;

            if(self.options["html"]) {

                elem.html(currentText);

            }

            else {

                elem.text(currentText);

            }

            return self;

        },

        // Open
        // ----
        //      Opens the dropdown list options list
        open: function(callback) {

            var self = this,
                showEffect = self.options["showEffect"],
                showEffectSpeed = self.options["showEffectSpeed"],
                showEffectOptions = self.options["showEffectOptions"],
                isNative = self.options["native"],
                isMobile = self.isMobile;

            // If there are no select box options, do not try to open the select box
            if(!self.listItems.length || self.dropdown.hasClass(self.theme["disabled"])) {

                return self;

            }

            // If the new drop down is being used and is not visible
            if((!isNative && !isMobile) && !this.list.is(":visible")) {

                // Triggers a custom "open" event on the original select box
                self.triggerEvent("open");

                if (self._dynamicPositioning && self.options["dynamicPositioning"]) {

                    // Dynamically positions the dropdown list options list
                    self._dynamicPositioning();

                }

                // Uses `no effect`
                if(showEffect === "none") {

                    // Does not require a callback function because this animation will complete before the call to `scrollToView`
                    self.list.show();

                }

                // Uses the jQuery `show` special effect
                else if(showEffect === "show" || showEffect === "slideDown" || showEffect === "fadeIn") {

                    // Requires a callback function to determine when the `show` animation is complete
                    self.list[showEffect](showEffectSpeed);

                }

                // If none of the above options were passed, then a `jqueryUI show effect` is expected
                else {

                    // Allows for custom show effects via the [jQueryUI core effects](http://http://jqueryui.com/demos/show/)
                    self.list.show(showEffect, showEffectOptions, showEffectSpeed);

                }

                self.list.promise().done(function() {

                    // Updates the list `scrollTop` attribute
                    self._scrollToView("search");

                });

            }

            // Provide callback function support
            self._callbackSupport(callback);

            // Maintains chainability
            return self;

        },

        // Close
        // -----
        //      Closes the dropdown list options list
        close: function(callback) {

            var self = this,
                hideEffect = self.options["hideEffect"],
                hideEffectSpeed = self.options["hideEffectSpeed"],
                hideEffectOptions = self.options["hideEffectOptions"],
                isNative = self.options["native"],
                isMobile = self.isMobile;

            // If the drop down is being used and is visible
            if((!isNative && !isMobile) && self.list.is(":visible")) {

                // Triggers a custom "close" event on the original select box
                self.triggerEvent("close");

                // Uses `no effect`
                if(hideEffect === "none") {

                    // Does not require a callback function because this animation will complete before the call to `scrollToView`
                    self.list.hide();

                }

                // Uses the jQuery `hide` special effect
                else if(hideEffect === "hide" || hideEffect === "slideUp" || hideEffect === "fadeOut") {

                    self.list[hideEffect](hideEffectSpeed);

                }

                // If none of the above options were passed, then a `jqueryUI hide effect` is expected
                else {

                    // Allows for custom hide effects via the [jQueryUI core effects](http://http://jqueryui.com/demos/hide/)
                    self.list.hide(hideEffect, hideEffectOptions, hideEffectSpeed);

                }

            }

            // Provide callback function support
            self._callbackSupport(callback);

            // Maintains chainability
            return self;

        },

        toggle: function() {

            var self = this,
                listIsVisible = self.list.is(":visible");

            if(listIsVisible) {

                self.close();

            }

            else if(!listIsVisible) {

                self.open();

            }

        },

        // _Key Mappings
        // -------------
        //      Object literal holding the string representation of each key code
        _keyMappings: {

            "38": "up",

            "40": "down",

            "13": "enter",

            "8": "backspace",

            "9": "tab",

            "32": "space",

            "27": "esc"

        },

        // _Key Down Methods
        // -----------------
        //      Methods to use when the keydown event is triggered
        _keydownMethods: function() {

            var self = this,
                moveToOption = self.list.is(":visible") || !self.options["keydownOpen"];

            return {

                "down": function() {

                    // If the plugin options allow keyboard navigation
                    if (self.moveDown && moveToOption) {

                        self.moveDown();

                    }

                },

                "up": function() {

                    // If the plugin options allow keyboard navigation
                    if (self.moveUp && moveToOption) {

                        self.moveUp();

                    }

                },

                "enter": function() {

                    var activeElem = self.listItems.eq(self.currentFocus);

                    // Updates the dropdown list value
                    self._update(activeElem);

                    if (activeElem.attr("data-preventclose") !== "true") {

                        // Closes the drop down list options list
                        self.close();

                    }

                    // Triggers the `enter` events on the original select box
                    self.triggerEvent("enter");

                },

                "tab": function() {

                    // Triggers the custom `tab-blur` event on the original select box
                    self.triggerEvent("tab-blur");

                    // Closes the drop down list
                    self.close();

                },

                "backspace": function() {

                    // Triggers the custom `backspace` event on the original select box
                    self.triggerEvent("backspace");

                },

                "esc": function() {

                    // Closes the dropdown options list
                    self.close();

                }

            };

        },


        // _Event Handlers
        // ---------------
        //      Adds event handlers to the new dropdown and the original select box
        _eventHandlers: function() {

            // LOCAL VARIABLES
            var self = this,
                nativeMousedown = self.options["nativeMousedown"],
                customShowHideEvent = self.options["customShowHideEvent"],
                currentDataText,
                currentText,
                focusClass = self.focusClass,
                hoverClass = self.hoverClass,
                openClass = self.openClass;

            // Select Box events
            this.dropdown.on({

                // `click` event with the `selectBoxIt` namespace
                "click.selectBoxIt": function() {

                    // Used to make sure the dropdown becomes focused (fixes IE issue)
                    self.dropdown.trigger("focus", true);

                    // The `click` handler logic will only be applied if the dropdown list is enabled
                    if (!self.originalElem.disabled) {

                        // Triggers the `click` event on the original select box
                        self.triggerEvent("click");

                        if(!nativeMousedown && !customShowHideEvent) {

                            self.toggle();

                        }

                    }

                },

                // `mousedown` event with the `selectBoxIt` namespace
                "mousedown.selectBoxIt": function() {

                    // Stores data in the jQuery `data` method to help determine if the dropdown list gains focus from a click or tabstop.  The mousedown event fires before the focus event.
                    $(this).data("mdown", true);

                    self.triggerEvent("mousedown");

                    if(nativeMousedown && !customShowHideEvent) {

                        self.toggle();

                    }

                },

                // `mouseup` event with the `selectBoxIt` namespace
                "mouseup.selectBoxIt": function() {

                    self.triggerEvent("mouseup");

                },

                // `blur` event with the `selectBoxIt` namespace.  Uses special blur logic to make sure the dropdown list closes correctly
                "blur.selectBoxIt": function() {

                    // If `self.blur` property is true
                    if (self.blur) {

                        // Triggers both the `blur` and `focusout` events on the original select box.
                        // The `focusout` event is also triggered because the event bubbles
                        // This event has to be used when using event delegation (such as the jQuery `delegate` or `on` methods)
                        // Popular open source projects such as Backbone.js utilize event delegation to bind events, so if you are using Backbone.js, use the `focusout` event instead of the `blur` event
                        self.triggerEvent("blur");

                        // Closes the dropdown list options list
                        self.close();

                        $(this).removeClass(focusClass);

                    }

                },

                "focus.selectBoxIt": function(event, internal) {

                    // Stores the data associated with the mousedown event inside of a local variable
                    var mdown = $(this).data("mdown");

                    // Removes the jQuery data associated with the mousedown event
                    $(this).removeData("mdown");

                    // If a mousedown event did not occur and no data was passed to the focus event (this correctly triggers the focus event), then the dropdown list gained focus from a tabstop
                    if (!mdown && !internal) {

                        setTimeout(function() {

                            // Triggers the `tabFocus` custom event on the original select box
                            self.triggerEvent("tab-focus");

                        }, 0);

                    }

                    // Only trigger the `focus` event on the original select box if the dropdown list is hidden (this verifies that only the correct `focus` events are used to trigger the event on the original select box
                    if(!internal) {

                        if(!$(this).hasClass(self.theme["disabled"])) {

                            $(this).addClass(focusClass);

                        }

                        //Triggers the `focus` default event on the original select box
                        self.triggerEvent("focus");

                    }

                },

                // `keydown` event with the `selectBoxIt` namespace.  Catches all user keyboard navigations
                "keydown.selectBoxIt": function(e) {

                    // Stores the `keycode` value in a local variable
                    var currentKey = self._keyMappings[e.keyCode],

                        keydownMethod = self._keydownMethods()[currentKey];

                    if(keydownMethod) {

                        keydownMethod();

                        if(self.options["keydownOpen"] && (currentKey === "up" || currentKey === "down")) {

                            self.open();

                        }

                    }

                    if(keydownMethod && currentKey !== "tab") {

                        e.preventDefault();

                    }

                },

                // `keypress` event with the `selectBoxIt` namespace.  Catches all user keyboard text searches since you can only reliably get character codes using the `keypress` event
                "keypress.selectBoxIt": function(e) {

                    // Sets the current key to the `keyCode` value if `charCode` does not exist.  Used for cross
                    // browser support since IE uses `keyCode` instead of `charCode`.
                    var currentKey = e.charCode || e.keyCode,

                        key = self._keyMappings[e.charCode || e.keyCode],

                    // Converts unicode values to characters
                        alphaNumericKey = String.fromCharCode(currentKey);

                    // If the plugin options allow text searches
                    if (self.search && (!key || (key && key === "space"))) {

                        // Calls `search` and passes the character value of the user's text search
                        self.search(alphaNumericKey, true, true);

                    }

                    if(key === "space") {

                        e.preventDefault();

                    }

                },

                // `mousenter` event with the `selectBoxIt` namespace .The mouseenter JavaScript event is proprietary to Internet Explorer. Because of the event's general utility, jQuery simulates this event so that it can be used regardless of browser.
                "mouseenter.selectBoxIt": function() {

                    // Trigger the `mouseenter` event on the original select box
                    self.triggerEvent("mouseenter");

                },

                // `mouseleave` event with the `selectBoxIt` namespace. The mouseleave JavaScript event is proprietary to Internet Explorer. Because of the event's general utility, jQuery simulates this event so that it can be used regardless of browser.
                "mouseleave.selectBoxIt": function() {

                    // Trigger the `mouseleave` event on the original select box
                    self.triggerEvent("mouseleave");

                }

            });

            // Select box options events that set the dropdown list blur logic (decides when the dropdown list gets
            // closed)
            self.list.on({

                // `mouseover` event with the `selectBoxIt` namespace
                "mouseover.selectBoxIt": function() {

                    // Prevents the dropdown list options list from closing
                    self.blur = false;

                },

                // `mouseout` event with the `selectBoxIt` namespace
                "mouseout.selectBoxIt": function() {

                    // Allows the dropdown list options list to close
                    self.blur = true;

                },

                // `focusin` event with the `selectBoxIt` namespace
                "focusin.selectBoxIt": function() {

                    // Prevents the default browser outline border to flicker, which results because of the `blur` event
                    self.dropdown.trigger("focus", true);

                }

            });

            // Select box individual options events bound with the jQuery `delegate` method.  `Delegate` was used because binding indropdownidual events to each list item (since we don't know how many there will be) would decrease performance.  Instead, we bind each event to the unordered list, provide the list item context, and allow the list item events to bubble up (`event bubbling`). This greatly increases page performance because we only have to bind an event to one element instead of x number of elements. Delegates the `click` event with the `selectBoxIt` namespace to the list items
            self.list.on({

                "mousedown.selectBoxIt": function() {

                    self._update($(this));

                    self.triggerEvent("option-click");

                    // If the current drop down option is not disabled
                    if ($(this).attr("data-disabled") === "false" && $(this).attr("data-preventclose") !== "true") {

                        // Closes the drop down list
                        self.close();

                    }

                    setTimeout(function() {

                        self.dropdown.trigger('focus', true);

                    }, 0);

                },

                // Delegates the `focusin` event with the `selectBoxIt` namespace to the list items
                "focusin.selectBoxIt": function() {

                    // Removes the hover class from the previous drop down option
                    self.listItems.not($(this)).removeAttr("data-active");

                    $(this).attr("data-active", "");

                    var listIsHidden = self.list.is(":hidden");

                    if((self.options["searchWhenHidden"] && listIsHidden) || self.options["aggressiveChange"] || (listIsHidden && self.options["selectWhenHidden"])) {

                        self._update($(this));

                    }

                    // Adds the focus CSS class to the currently focused dropdown list option
                    $(this).addClass(focusClass);

                },

                // Delegates the `focus` event with the `selectBoxIt` namespace to the list items
                "mouseup.selectBoxIt": function() {

                    if(nativeMousedown && !customShowHideEvent) {

                        self._update($(this));

                        self.triggerEvent("option-mouseup");

                        // If the current drop down option is not disabled
                        if ($(this).attr("data-disabled") === "false" && $(this).attr("data-preventclose") !== "true") {

                            // Closes the drop down list
                            self.close();

                        }

                    }

                },

                // Delegates the `mouseenter` event with the `selectBoxIt` namespace to the list items
                "mouseenter.selectBoxIt": function() {

                    // If the currently moused over drop down option is not disabled
                    if($(this).attr("data-disabled") === "false") {

                        self.listItems.removeAttr("data-active");

                        $(this).addClass(focusClass).attr("data-active", "");

                        // Sets the dropdown list indropdownidual options back to the default state and sets the focus CSS class on the currently hovered option
                        self.listItems.not($(this)).removeClass(focusClass);

                        $(this).addClass(focusClass);

                        self.currentFocus = +$(this).attr("data-id");

                    }

                },

                // Delegates the `mouseleave` event with the `selectBoxIt` namespace to the list items
                "mouseleave.selectBoxIt": function() {

                    // If the currently moused over drop down option is not disabled
                    if($(this).attr("data-disabled") === "false") {

                        // Removes the focus class from the previous drop down option
                        self.listItems.not($(this)).removeClass(focusClass).removeAttr("data-active");

                        $(this).addClass(focusClass);

                        self.currentFocus = +$(this).attr("data-id");

                    }

                },

                // Delegates the `blur` event with the `selectBoxIt` namespace to the list items
                "blur.selectBoxIt": function() {

                    // Removes the focus CSS class from the previously focused dropdown list option
                    $(this).removeClass(focusClass);

                }

            }, ".selectboxit-option");

            // Select box individual option anchor events bound with the jQuery `delegate` method.  `Delegate` was used because binding indropdownidual events to each list item (since we don't know how many there will be) would decrease performance.  Instead, we bind each event to the unordered list, provide the list item context, and allow the list item events to bubble up (`event bubbling`). This greatly increases page performance because we only have to bind an event to one element instead of x number of elements. Delegates the `click` event with the `selectBoxIt` namespace to the list items
            self.list.on({

                "click.selectBoxIt": function(ev) {

                    // Prevents the internal anchor tag from doing anything funny
                    ev.preventDefault();

                }

            }, "a");

            // Original dropdown list events
            self.selectBox.on({

                // `change` event handler with the `selectBoxIt` namespace
                "change.selectBoxIt, internal-change.selectBoxIt": function(event, internal) {

                    var currentOption,
                        currentDataSelectedText;

                    // If the user called the change method
                    if(!internal) {

                        currentOption = self.list.find('li[data-val="' + self.originalElem.value + '"]');

                        // If there is a dropdown option with the same value as the original select box element
                        if(currentOption.length) {

                            self.listItems.eq(self.currentFocus).removeClass(self.focusClass);

                            self.currentFocus = +currentOption.attr("data-id");

                        }

                    }

                    currentOption = self.listItems.eq(self.currentFocus);

                    currentDataSelectedText = currentOption.attr("data-selectedtext");

                    currentDataText = currentOption.attr("data-text");

                    currentText = currentDataText ?  currentDataText: currentOption.find("a").text();

                    // Sets the new dropdown list text to the value of the current option
                    self._setText(self.dropdownText, currentDataSelectedText || currentText);

                    self.dropdownText.attr("data-val", self.originalElem.value);

                    if(currentOption.find("i").attr("class")) {

                        self.dropdownImage.attr("class", currentOption.find("i").attr("class")).addClass("selectboxit-default-icon");

                        self.dropdownImage.attr("style", currentOption.find("i").attr("style"));
                    }

                    // Triggers a custom changed event on the original select box
                    self.triggerEvent("changed");

                },

                // `disable` event with the `selectBoxIt` namespace
                "disable.selectBoxIt": function() {

                    // Adds the `disabled` CSS class to the new dropdown list to visually show that it is disabled
                    self.dropdown.addClass(self.theme["disabled"]);

                },

                // `enable` event with the `selectBoxIt` namespace
                "enable.selectBoxIt": function() {

                    // Removes the `disabled` CSS class from the new dropdown list to visually show that it is enabled
                    self.dropdown.removeClass(self.theme["disabled"]);

                },

                // `open` event with the `selectBoxIt` namespace
                "open.selectBoxIt": function() {

                    var currentElem = self.list.find("li[data-val='" + self.dropdownText.attr("data-val") + "']"),
                        activeElem;

                    // If no current element can be found, then select the first drop down option
                    if(!currentElem.length) {

                        // Sets the default value of the dropdown list to the first option that is not disabled
                        currentElem = self.listItems.not("[data-disabled=true]").first();

                    }

                    self.currentFocus = +currentElem.attr("data-id");

                    activeElem = self.listItems.eq(self.currentFocus);

                    self.dropdown.addClass(openClass).

                        // Removes the focus class from the dropdown list and adds the library focus class for both the dropdown list and the currently selected dropdown list option
                        removeClass(hoverClass).addClass(focusClass);

                    self.listItems.removeClass(self.selectedClass).

                        removeAttr("data-active").not(activeElem).removeClass(focusClass);

                    activeElem.addClass(self.selectedClass).addClass(focusClass);

                    if(self.options.hideCurrent) {

                        self.listItems.show();

                        activeElem.hide();

                    }

                },

                "close.selectBoxIt": function() {

                    // Removes the open class from the dropdown container
                    self.dropdown.removeClass(openClass);

                },

                "blur.selectBoxIt": function() {

                    self.dropdown.removeClass(focusClass);

                },

                // `mousenter` event with the `selectBoxIt` namespace
                "mouseenter.selectBoxIt": function() {

                    if(!$(this).hasClass(self.theme["disabled"])) {
                        self.dropdown.addClass(hoverClass);
                    }

                },

                // `mouseleave` event with the `selectBoxIt` namespace
                "mouseleave.selectBoxIt": function() {

                    // Removes the hover CSS class on the previously hovered dropdown list option
                    self.dropdown.removeClass(hoverClass);

                },

                // `destroy` event
                "destroy": function(ev) {

                    // Prevents the default action from happening
                    ev.preventDefault();

                    // Prevents the destroy event from propagating
                    ev.stopPropagation();

                }

            });

            // Maintains chainability
            return self;

        },

        // _update
        // -------
        //      Updates the drop down and select box with the current value
        _update: function(elem) {

            var self = this,
                currentDataSelectedText,
                currentDataText,
                currentText,
                defaultText = self.options["defaultText"] || self.selectBox.attr("data-text"),
                currentElem = self.listItems.eq(self.currentFocus);

            if (elem.attr("data-disabled") === "false") {

                currentDataSelectedText = self.listItems.eq(self.currentFocus).attr("data-selectedtext");

                currentDataText = currentElem.attr("data-text");

                currentText = currentDataText ? currentDataText: currentElem.text();

                // If the default text option is set and the current drop down option is not disabled
                if ((defaultText && self.options["html"] ? self.dropdownText.html() === defaultText: self.dropdownText.text() === defaultText) && self.selectBox.val() === elem.attr("data-val")) {

                    self.triggerEvent("change");

                }

                else {

                    // Sets the original dropdown list value and triggers the `change` event on the original select box
                    self.selectBox.val(elem.attr("data-val"));

                    // Sets `currentFocus` to the currently focused dropdown list option.
                    // The unary `+` operator casts the string to a number
                    // [James Padolsey Blog Post](http://james.padolsey.com/javascript/terse-javascript-101-part-2/)
                    self.currentFocus = +elem.attr("data-id");

                    // Triggers the dropdown list `change` event if a value change occurs
                    if (self.originalElem.value !== self.dropdownText.attr("data-val")) {

                        self.triggerEvent("change");

                    }

                }

            }

        },

        // _addClasses
        // -----------
        //      Adds SelectBoxIt CSS classes
        _addClasses: function(obj) {

            var self = this,

                focusClass = self.focusClass = obj.focus,

                hoverClass = self.hoverClass = obj.hover,

                buttonClass = obj.button,

                listClass = obj.list,

                arrowClass = obj.arrow,

                containerClass = obj.container,

                openClass = self.openClass = obj.open;

            self.selectedClass = "selectboxit-selected";

            self.downArrow.addClass(self.selectBox.attr("data-downarrow") || self.options["downArrowIcon"] || arrowClass);

            // Adds the correct container class to the dropdown list
            self.dropdownContainer.addClass(containerClass);

            // Adds the correct class to the dropdown list
            self.dropdown.addClass(buttonClass);

            // Adds the default class to the dropdown list options
            self.list.addClass(listClass);

            // Maintains chainability
            return self;

        },

        // Refresh
        // -------
        //    The dropdown will rebuild itself.  Useful for dynamic content.
        refresh: function(callback, internal) {

            var self = this;

            // Destroys the plugin and then recreates the plugin
            self._destroySelectBoxIt()._create(true);

            if(!internal) {
                self.triggerEvent("refresh");
            }

            self._callbackSupport(callback);

            //Maintains chainability
            return self;

        },

        // HTML Escape
        // -----------
        //      HTML encodes a string
        htmlEscape: function(str) {

            return String(str)
                .replace(/&/g, "&amp;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#39;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;");

        },

        // triggerEvent
        // ------------
        //      Trigger's an external event on the original select box element
        triggerEvent: function(eventName) {

            var self = this,
            // Finds the currently option index
                currentIndex = self.options["showFirstOption"] ? self.currentFocus : ((self.currentFocus - 1) >= 0 ? self.currentFocus: 0);

            // Triggers the custom option-click event on the original select box and passes the select box option
            self.selectBox.trigger(eventName, { "selectbox": self.selectBox, "selectboxOption": self.selectItems.eq(currentIndex), "dropdown": self.dropdown, "dropdownOption": self.listItems.eq(self.currentFocus) });

            // Maintains chainability
            return self;

        },

        // _copyAttributes
        // ---------------
        //      Copies HTML attributes from the original select box to the new drop down 
        _copyAttributes: function() {

            var self = this;

            if(self._addSelectBoxAttributes) {

                self._addSelectBoxAttributes();

            }

            return self;

        },

        // _realOuterWidth
        // ---------------
        //      Retrieves the true outerWidth dimensions of a hidden DOM element
        _realOuterWidth: function(elem) {

            if(elem.is(":visible")) {

                return elem.outerWidth(true);

            }

            var self = this,
                clonedElem = elem.clone(),
                outerWidth;

            clonedElem.css({

                "visibility": "hidden",

                "display": "block",

                "position": "absolute"

            }).appendTo("body");

            outerWidth = clonedElem.outerWidth(true);

            clonedElem.remove();

            return outerWidth;
        }

    });

    // Stores the plugin prototype object in a local variable
    var selectBoxIt = $.selectBox.selectBoxIt.prototype;

    // Add Options Module
    // ==================

    // add
    // ---
    //    Adds drop down options
    //    using JSON data, an array,
    //    a single object, or valid HTML string

    selectBoxIt.add = function(data, callback) {

        this._populate(data, function(data) {

            var self = this,
                dataType = $.type(data),
                value,
                x = 0,
                dataLength,
                elems = [],
                isJSON = self._isJSON(data),
                parsedJSON = isJSON && self._parseJSON(data);

            // If the passed data is a local or JSON array
            if(data && (dataType === "array" || (isJSON && parsedJSON.data && $.type(parsedJSON.data) === "array")) || (dataType === "object" && data.data && $.type(data.data) === "array")) {

                // If the data is JSON
                if(self._isJSON(data)) {

                    // Parses the JSON and stores it in the data local variable
                    data = parsedJSON;

                }

                // If there is an inner `data` property stored in the first level of the JSON array
                if(data.data) {

                    // Set's the data to the inner `data` property
                    data = data.data;

                }

                // Loops through the array
                for(dataLength = data.length; x <= dataLength - 1; x += 1) {

                    // Stores the currently traversed array item in the local `value` variable
                    value = data[x];

                    // If the currently traversed array item is an object literal
                    if($.isPlainObject(value)) {

                        // Adds an option to the elems array
                        elems.push($("<option/>", value));

                    }

                    // If the currently traversed array item is a string
                    else if($.type(value) === "string") {

                        // Adds an option to the elems array
                        elems.push($("<option/>", { text: value, value: value }));

                    }

                }

                // Appends all options to the drop down (with the correct object configurations)
                self.selectBox.append(elems);

            }

            // if the passed data is an html string and not a JSON string
            else if(data && dataType === "string" && !self._isJSON(data)) {

                // Appends the html string options to the original select box
                self.selectBox.append(data);

            }

            else if(data && dataType === "object") {

                // Appends an option to the original select box (with the object configurations)
                self.selectBox.append($("<option/>", data));

            }

            else if(data && self._isJSON(data) && $.isPlainObject(self._parseJSON(data))) {

                // Appends an option to the original select box (with the object configurations)
                self.selectBox.append($("<option/>", self._parseJSON(data)));

            }

            // If the dropdown property exists
            if(self.dropdown) {

                // Rebuilds the dropdown
                self.refresh(function() {

                    // Provide callback function support
                    self._callbackSupport(callback);

                }, true);

            } else {

                // Provide callback function support
                self._callbackSupport(callback);

            }

            // Maintains chainability
            return self;

        });

    };

    // parseJSON
    // ---------
    //      Detects JSON support and parses JSON data
    selectBoxIt._parseJSON = function(data) {

        return (JSON && JSON.parse && JSON.parse(data)) || $.parseJSON(data);

    };

    // isjSON
    // ------
    //    Determines if a string is valid JSON

    selectBoxIt._isJSON = function(data) {

        var self = this,
            json;

        try {

            json = self._parseJSON(data);

            // Valid JSON
            return true;

        } catch (e) {

            // Invalid JSON
            return false;

        }

    };

    // _populate
    // --------
    //    Handles asynchronous and synchronous data
    //    to populate the select box

    selectBoxIt._populate = function(data, callback) {

        var self = this;

        data = $.isFunction(data) ? data.call() : data;

        if(self.isDeferred(data)) {

            data.done(function(returnedData) {

                callback.call(self, returnedData);

            });

        }

        else {

            callback.call(self, data);

        }

        // Maintains chainability
        return self;

    };

    // Accessibility Module
    // ====================

    // _ARIA Accessibility
    // ------------------
    //      Adds ARIA (Accessible Rich Internet Applications)
    //      Accessibility Tags to the Select Box

    selectBoxIt._ariaAccessibility = function() {

        var self = this,
            dropdownLabel = $("label[for='" + self.originalElem.id + "']");

        // Adds `ARIA attributes` to the dropdown list
        self.dropdownContainer.attr({

            // W3C `combobox` description: A presentation of a select; usually similar to a textbox where users can type ahead to select an option.
            "role": "combobox",

            //W3C `aria-autocomplete` description: Indicates whether user input completion suggestions are provided.
            "aria-autocomplete": "list",

            "aria-haspopup": "true",

            // W3C `aria-expanded` description: Indicates whether the element, or another grouping element it controls, is currently expanded or collapsed.
            "aria-expanded": "false",

            // W3C `aria-owns` description: The value of the aria-owns attribute is a space-separated list of IDREFS that reference one or more elements in the document by ID. The reason for adding aria-owns is to expose a parent/child contextual relationship to assistive technologies that is otherwise impossible to infer from the DOM.
            "aria-owns": self.list[0].id

        });

        self.dropdownText.attr({

            "aria-live": "polite"

        });

        // Dynamically adds `ARIA attributes` if the new dropdown list is enabled or disabled
        self.dropdown.on({

            //Select box custom `disable` event with the `selectBoxIt` namespace
            "disable.selectBoxIt" : function() {

                // W3C `aria-disabled` description: Indicates that the element is perceivable but disabled, so it is not editable or otherwise operable.
                self.dropdownContainer.attr("aria-disabled", "true");

            },

            // Select box custom `enable` event with the `selectBoxIt` namespace
            "enable.selectBoxIt" : function() {

                // W3C `aria-disabled` description: Indicates that the element is perceivable but disabled, so it is not editable or otherwise operable.
                self.dropdownContainer.attr("aria-disabled", "false");

            }

        });

        if(dropdownLabel.length) {

            // MDN `aria-labelledby` description:  Indicates the IDs of the elements that are the labels for the object.
            self.dropdownContainer.attr("aria-labelledby", dropdownLabel[0].id);

        }

        // Adds ARIA attributes to the dropdown list options list
        self.list.attr({

            // W3C `listbox` description: A widget that allows the user to select one or more items from a list of choices.
            "role": "listbox",

            // Indicates that the dropdown list options list is currently hidden
            "aria-hidden": "true"

        });

        // Adds `ARIA attributes` to the dropdown list options
        self.listItems.attr({

            // This must be set for each element when the container element role is set to `listbox`
            "role": "option"

        });

        // Dynamically updates the new dropdown list `aria-label` attribute after the original dropdown list value changes
        self.selectBox.on({

            // Custom `open` event with the `selectBoxIt` namespace
            "open.selectBoxIt": function() {

                // Indicates that the dropdown list options list is currently visible
                self.list.attr("aria-hidden", "false");

                // Indicates that the dropdown list is currently expanded
                self.dropdownContainer.attr("aria-expanded", "true");

            },

            // Custom `close` event with the `selectBoxIt` namespace
            "close.selectBoxIt": function() {

                // Indicates that the dropdown list options list is currently hidden
                self.list.attr("aria-hidden", "true");

                // Indicates that the dropdown list is currently collapsed
                self.dropdownContainer.attr("aria-expanded", "false");

            }

        });

        // Maintains chainability
        return self;

    };

    // Copy Attributes Module
    // ======================

    // addSelectBoxAttributes
    // ----------------------
    //      Add's all attributes (excluding id, class names, and the style attribute) from the default select box to the new drop down

    selectBoxIt._addSelectBoxAttributes = function() {

        // Stores the plugin context inside of the self variable
        var self = this;

        // Add's all attributes to the currently traversed drop down option
        self._addAttributes(self.selectBox.prop("attributes"), self.dropdown);

        // Add's all attributes to the drop down items list
        self.selectItems.each(function(iterator) {

            // Add's all attributes to the currently traversed drop down option
            self._addAttributes($(this).prop("attributes"), self.listItems.eq(iterator));

        });

        // Maintains chainability
        return self;

    };

    // addAttributes
    // -------------
    //  Add's attributes to a DOM element
    selectBoxIt._addAttributes = function(arr, elem) {

        // Stores the plugin context inside of the self variable
        var self = this,
            whitelist = self.options["copyAttributes"];

        // If there are array properties
        if(arr.length) {

            // Iterates over all of array properties
            $.each(arr, function(iterator, property) {

                // Get's the property name and property value of each property
                var propName = (property.name).toLowerCase(), propValue = property.value;

                // If the currently traversed property value is not "null", is on the whitelist, or is an HTML 5 data attribute
                if(propValue !== "null" && ($.inArray(propName, whitelist) !== -1 || propName.indexOf("data") !== -1)) {

                    // Set's the currently traversed property on element
                    elem.attr(propName, propValue);

                }

            });

        }

        // Maintains chainability
        return self;

    };
// Destroy Module
// ==============

// Destroy
// -------
//    Removes the plugin from the page

    selectBoxIt.destroy = function(callback) {

        // Stores the plugin context inside of the self variable
        var self = this;

        self._destroySelectBoxIt();

        // Calls the jQueryUI Widget Factory destroy method
        self.widgetProto.destroy.call(self);

        // Provides callback function support
        self._callbackSupport(callback);

        // Maintains chainability
        return self;

    };

// Internal Destroy Method
// -----------------------
//    Removes the plugin from the page

    selectBoxIt._destroySelectBoxIt = function() {

        // Stores the plugin context inside of the self variable
        var self = this;

        // Unbinds all of the dropdown list event handlers with the `selectBoxIt` namespace
        self.dropdown.off(".selectBoxIt");

        // If the original select box has been placed inside of the new drop down container
        if ($.contains(self.dropdownContainer[0], self.originalElem)) {

            // Moves the original select box before the drop down container
            self.dropdownContainer.before(self.selectBox);

        }

        // Remove all of the `selectBoxIt` DOM elements from the page
        self.dropdownContainer.remove();

        // Resets the style attributes for the original select box
        self.selectBox.removeAttr("style").attr("style", self.selectBoxStyles);

        // Shows the original dropdown list
        self.selectBox.show();

        // Triggers the custom `destroy` event on the original select box
        self.triggerEvent("destroy");

        // Maintains chainability
        return self;

    };

    // Disable Module
    // ==============

    // Disable
    // -------
    //      Disables the new dropdown list

    selectBoxIt.disable = function(callback) {

        var self = this;

        if(!self.options["disabled"]) {

            // Makes sure the dropdown list is closed
            self.close();

            // Sets the `disabled` attribute on the original select box
            self.selectBox.attr("disabled", "disabled");

            // Makes the dropdown list not focusable by removing the `tabindex` attribute
            self.dropdown.removeAttr("tabindex").

                // Disables styling for enabled state
                removeClass(self.theme["enabled"]).

                // Enabled styling for disabled state
                addClass(self.theme["disabled"]);

            self.setOption("disabled", true);

            // Triggers a `disable` custom event on the original select box
            self.triggerEvent("disable");

        }

        // Provides callback function support
        self._callbackSupport(callback);

        // Maintains chainability
        return self;

    };

    // Disable Option
    // --------------
    //      Disables a single drop down option

    selectBoxIt.disableOption = function(index, callback) {

        var self = this, currentSelectBoxOption, hasNextEnabled, hasPreviousEnabled, type = $.type(index);

        // If an index is passed to target an indropdownidual drop down option
        if(type === "number") {

            // Makes sure the dropdown list is closed
            self.close();

            // The select box option being targeted
            currentSelectBoxOption = self.selectBox.find("option").eq(index);

            // Triggers a `disable-option` custom event on the original select box and passes the disabled option
            self.triggerEvent("disable-option");

            // Disables the targeted select box option
            currentSelectBoxOption.attr("disabled", "disabled");

            // Disables the drop down option
            self.listItems.eq(index).attr("data-disabled", "true").

                // Applies disabled styling for the drop down option
                addClass(self.theme["disabled"]);

            // If the currently selected drop down option is the item being disabled
            if(self.currentFocus === index) {

                hasNextEnabled = self.listItems.eq(self.currentFocus).nextAll("li").not("[data-disabled='true']").first().length;

                hasPreviousEnabled = self.listItems.eq(self.currentFocus).prevAll("li").not("[data-disabled='true']").first().length;

                // If there is a currently enabled option beneath the currently selected option
                if(hasNextEnabled) {

                    // Selects the option beneath the currently selected option
                    self.moveDown();

                }

                // If there is a currently enabled option above the currently selected option
                else if(hasPreviousEnabled) {

                    // Selects the option above the currently selected option
                    self.moveUp();

                }

                // If there is not a currently enabled option
                else {

                    // Disables the entire drop down list
                    self.disable();

                }

            }

        }

        // Provides callback function support
        self._callbackSupport(callback);

        // Maintains chainability
        return self;

    };

    // _Is Disabled
    // -----------
    //      Checks the original select box for the
    //    disabled attribute

    selectBoxIt._isDisabled = function(callback) {

        var self = this;

        // If the original select box is disabled
        if (self.originalElem.disabled) {

            // Disables the dropdown list
            self.disable();

        }

        // Maintains chainability
        return self;

    };

    // Dynamic Positioning Module
    // ==========================

    // _Dynamic positioning
    // --------------------
    //      Dynamically positions the dropdown list options list

    selectBoxIt._dynamicPositioning = function() {

        var self = this;

        // If the `size` option is a number
        if($.type(self.listSize) === "number") {

            // Set's the max-height of the drop down list
            self.list.css("max-height", self.maxHeight || "none");

        }

        // If the `size` option is not a number
        else {

            // Returns the x and y coordinates of the dropdown list options list relative to the document
            var listOffsetTop = self.dropdown.offset().top,

            // The height of the dropdown list options list
                listHeight = self.list.data("max-height") || self.list.outerHeight(),

            // The height of the dropdown list DOM element
                selectBoxHeight = self.dropdown.outerHeight(),

                viewport = self.options["viewport"],

                viewportHeight = viewport.height(),

                viewportScrollTop = $.isWindow(viewport.get(0)) ? viewport.scrollTop() : viewport.offset().top,

                topToBottom = (listOffsetTop + selectBoxHeight + listHeight <= viewportHeight + viewportScrollTop),

                bottomReached = !topToBottom;

            if(!self.list.data("max-height")) {

                self.list.data("max-height", self.list.outerHeight());

            }

            // If there is room on the bottom of the viewport to display the drop down options
            if (!bottomReached) {

                self.list.css("max-height", listHeight);

                // Sets custom CSS properties to place the dropdown list options directly below the dropdown list
                self.list.css("top", "auto");

            }

            // If there is room on the top of the viewport
            else if((self.dropdown.offset().top - viewportScrollTop) >= listHeight) {

                self.list.css("max-height", listHeight);

                // Sets custom CSS properties to place the dropdown list options directly above the dropdown list
                self.list.css("top", (self.dropdown.position().top - self.list.outerHeight()));

            }

            // If there is not enough room on the top or the bottom
            else {

                var outsideBottomViewport = Math.abs((listOffsetTop + selectBoxHeight + listHeight) - (viewportHeight + viewportScrollTop)),

                    outsideTopViewport = Math.abs((self.dropdown.offset().top - viewportScrollTop) - listHeight);

                // If there is more room on the bottom
                if(outsideBottomViewport < outsideTopViewport) {

                    self.list.css("max-height", listHeight - outsideBottomViewport - (selectBoxHeight/2));

                    self.list.css("top", "auto");

                }

                // If there is more room on the top
                else {

                    self.list.css("max-height", listHeight - outsideTopViewport - (selectBoxHeight/2));

                    // Sets custom CSS properties to place the dropdown list options directly above the dropdown list
                    self.list.css("top", (self.dropdown.position().top - self.list.outerHeight()));

                }

            }

        }

        // Maintains chainability
        return self;

    };

    // Enable Module
    // =============

    // Enable
    // ------
    //      Enables the new dropdown list

    selectBoxIt.enable = function(callback) {

        var self = this;

        if(self.options["disabled"]) {

            // Triggers a `enable` custom event on the original select box
            self.triggerEvent("enable");

            // Removes the `disabled` attribute from the original dropdown list
            self.selectBox.removeAttr("disabled");

            // Make the dropdown list focusable
            self.dropdown.attr("tabindex", 0).

                // Disable styling for disabled state
                removeClass(self.theme["disabled"]).

                // Enables styling for enabled state
                addClass(self.theme["enabled"]);

            self.setOption("disabled", false);

            // Provide callback function support
            self._callbackSupport(callback);

        }

        // Maintains chainability
        return self;

    };

    // Enable Option
    // -------------
    //      Disables a single drop down option

    selectBoxIt.enableOption = function(index, callback) {

        var self = this, currentSelectBoxOption, currentIndex = 0, hasNextEnabled, hasPreviousEnabled, type = $.type(index);

        // If an index is passed to target an indropdownidual drop down option
        if(type === "number") {

            // The select box option being targeted
            currentSelectBoxOption = self.selectBox.find("option").eq(index);

            // Triggers a `enable-option` custom event on the original select box and passes the enabled option
            self.triggerEvent("enable-option");

            // Disables the targeted select box option
            currentSelectBoxOption.removeAttr("disabled");

            // Disables the drop down option
            self.listItems.eq(index).attr("data-disabled", "false").

                // Applies disabled styling for the drop down option
                removeClass(self.theme["disabled"]);

        }

        // Provides callback function support
        self._callbackSupport(callback);

        // Maintains chainability
        return self;

    };

    // Keyboard Navigation Module
    // ==========================

    // Move Down
    // ---------
    //      Handles the down keyboard navigation logic

    selectBoxIt.moveDown = function(callback) {

        var self = this;

        // Increments `currentFocus`, which represents the currently focused list item `id` attribute.
        self.currentFocus += 1;

        // Determines whether the dropdown option the user is trying to go to is currently disabled
        var disabled = self.listItems.eq(self.currentFocus).attr("data-disabled") === "true" ? true: false,

            hasNextEnabled = self.listItems.eq(self.currentFocus).nextAll("li").not("[data-disabled='true']").first().length;

        // If the user has reached the top of the list
        if (self.currentFocus === self.listItems.length) {

            // Does not allow the user to continue to go up the list
            self.currentFocus -= 1;

        }

        // If the option the user is trying to go to is disabled, but there is another enabled option
        else if (disabled && hasNextEnabled) {

            // Blur the previously selected option
            self.listItems.eq(self.currentFocus - 1).blur();

            // Call the `moveDown` method again
            self.moveDown();

            // Exit the method
            return;

        }

        // If the option the user is trying to go to is disabled, but there is not another enabled option
        else if (disabled && !hasNextEnabled) {

            self.currentFocus -= 1;

        }

        // If the user has not reached the bottom of the unordered list
        else {

            // Blurs the previously focused list item
            // The jQuery `end()` method allows you to continue chaining while also using a different selector
            self.listItems.eq(self.currentFocus - 1).blur().end().

                // Focuses the currently focused list item
                eq(self.currentFocus).focusin();

            // Calls `scrollToView` to make sure the `scrollTop` is correctly updated. The `down` user action
            self._scrollToView("down");

            // Triggers the custom `moveDown` event on the original select box
            self.triggerEvent("moveDown");

        }

        // Provide callback function support
        self._callbackSupport(callback);

        // Maintains chainability
        return self;

    };

    // Move Up
    // ------
    //      Handles the up keyboard navigation logic
    selectBoxIt.moveUp = function(callback) {

        var self = this;

        // Increments `currentFocus`, which represents the currently focused list item `id` attribute.
        self.currentFocus -= 1;

        // Determines whether the dropdown option the user is trying to go to is currently disabled
        var disabled = self.listItems.eq(self.currentFocus).attr("data-disabled") === "true" ? true: false,

            hasPreviousEnabled = self.listItems.eq(self.currentFocus).prevAll("li").not("[data-disabled='true']").first().length;

        // If the user has reached the top of the list
        if (self.currentFocus === -1) {

            // Does not allow the user to continue to go up the list
            self.currentFocus += 1;

        }

        // If the option the user is trying to go to is disabled and the user is not trying to go up after the user has reached the top of the list
        else if (disabled && hasPreviousEnabled) {

            // Blur the previously selected option
            self.listItems.eq(self.currentFocus + 1).blur();

            // Call the `moveUp` method again
            self.moveUp();

            // Exits the method
            return;

        }

        else if (disabled && !hasPreviousEnabled) {

            self.currentFocus += 1;

        }

        // If the user has not reached the top of the unordered list
        else {

            // Blurs the previously focused list item
            // The jQuery `end()` method allows you to continue chaining while also using a different selector
            self.listItems.eq(this.currentFocus + 1).blur().end().

                // Focuses the currently focused list item
                eq(self.currentFocus).focusin();

            // Calls `scrollToView` to make sure the `scrollTop` is correctly updated. The `down` user action
            self._scrollToView("up");

            // Triggers the custom `moveDown` event on the original select box
            self.triggerEvent("moveUp");

        }

        // Provide callback function support
        self._callbackSupport(callback);

        // Maintains chainability
        return self;

    };

    // Keyboard Search Module
    // ======================

    // _Set Current Search Option
    // -------------------------
    //      Sets the currently selected dropdown list search option

    selectBoxIt._setCurrentSearchOption = function(currentOption) {

        var self = this;

        // Does not change the current option if `showFirstOption` is false and the matched search item is the hidden first option.
        // Otherwise, the current option value is updated
        if ((self.options["aggressiveChange"] || self.options["selectWhenHidden"] || self.listItems.eq(currentOption).is(":visible")) && self.listItems.eq(currentOption).data("disabled") !== true) {

            // Calls the `blur` event of the currently selected dropdown list option
            self.listItems.eq(self.currentFocus).blur();

            // Sets `currentIndex` to the currently selected dropdown list option
            self.currentIndex = currentOption;

            // Sets `currentFocus` to the currently selected dropdown list option
            self.currentFocus = currentOption;

            // Focuses the currently selected dropdown list option
            self.listItems.eq(self.currentFocus).focusin();

            // Updates the scrollTop so that the currently selected dropdown list option is visible to the user
            self._scrollToView("search");

            // Triggers the custom `search` event on the original select box
            self.triggerEvent("search");

        }

        // Maintains chainability
        return self;

    };

    // _Search Algorithm
    // -----------------
    //      Uses regular expressions to find text matches
    selectBoxIt._searchAlgorithm = function(currentIndex, alphaNumeric) {

        var self = this,

        // Boolean to determine if a pattern match exists
            matchExists = false,

        // Iteration variable used in the outermost for loop
            x,

        // Iteration variable used in the nested for loop
            y,

        // Variable used to cache the length of the text array (Small enhancement to speed up traversing)
            arrayLength,

        // Variable storing the current search
            currentSearch,

        // Variable storing the textArray property
            textArray = self.textArray,

        // Variable storing the current text property
            currentText = self.currentText;

        // Loops through the text array to find a pattern match
        for (x = currentIndex, arrayLength = textArray.length; x < arrayLength; x += 1) {

            currentSearch = textArray[x];

            // Nested for loop to help search for a pattern match with the currently traversed array item
            for (y = 0; y < arrayLength; y += 1) {

                // Searches for a match
                if (textArray[y].search(alphaNumeric) !== -1) {

                    // `matchExists` is set to true if there is a match
                    matchExists = true;

                    // Exits the nested for loop
                    y = arrayLength;

                }

            } // End nested for loop

            // If a match does not exist
            if (!matchExists) {

                // Sets the current text to the last entered character
                self.currentText = self.currentText.charAt(self.currentText.length - 1).

                    // Escapes the regular expression to make sure special characters are seen as literal characters instead of special commands
                    replace(/[|()\[{.+*?$\\]/g, "\\$0");

                currentText = self.currentText;

            }

            // Resets the regular expression with the new value of `self.currentText`
            alphaNumeric = new RegExp(currentText, "gi");

            // Searches based on the first letter of the dropdown list options text if the currentText < 3 characters
            if (currentText.length < 3) {

                alphaNumeric = new RegExp(currentText.charAt(0), "gi");

                // If there is a match based on the first character
                if ((currentSearch.charAt(0).search(alphaNumeric) !== -1)) {

                    // Sets properties of that dropdown list option to make it the currently selected option
                    self._setCurrentSearchOption(x);

                    if((currentSearch.substring(0, currentText.length).toLowerCase() !== currentText.toLowerCase()) || self.options["similarSearch"]) {

                        // Increments the current index by one
                        self.currentIndex += 1;

                    }

                    // Exits the search
                    return false;

                }

            }

            // If `self.currentText` > 1 character
            else {

                // If there is a match based on the entire string
                if ((currentSearch.search(alphaNumeric) !== -1)) {

                    // Sets properties of that dropdown list option to make it the currently selected option
                    self._setCurrentSearchOption(x);

                    // Exits the search
                    return false;

                }

            }

            // If the current text search is an exact match
            if (currentSearch.toLowerCase() === self.currentText.toLowerCase()) {

                // Sets properties of that dropdown list option to make it the currently selected option
                self._setCurrentSearchOption(x);

                // Resets the current text search to a blank string to start fresh again
                self.currentText = "";

                // Exits the search
                return false;

            }

        }

        // Returns true if there is not a match at all
        return true;

    };

    // Search
    // ------
    //      Calls searchAlgorithm()
    selectBoxIt.search = function(alphaNumericKey, callback, rememberPreviousSearch) {

        var self = this;

        // If the search method is being called internally by the plugin, and not externally as a method by a user
        if (rememberPreviousSearch) {

            // Continued search with history from past searches.  Properly escapes the regular expression
            self.currentText += alphaNumericKey.replace(/[|()\[{.+*?$\\]/g, "\\$0");

        }

        else {

            // Brand new search.  Properly escapes the regular expression
            self.currentText = alphaNumericKey.replace(/[|()\[{.+*?$\\]/g, "\\$0");

        }

        // Searches globally
        var searchResults = self._searchAlgorithm(self.currentIndex, new RegExp(self.currentText, "gi"));

        // Searches the list again if a match is not found.  This is needed, because the first search started at the array indece of the currently selected dropdown list option, and does not search the options before the current array indece.
        // If there are many similar dropdown list options, starting the search at the indece of the currently selected dropdown list option is needed to properly traverse the text array.
        if (searchResults) {

            // Searches the dropdown list values starting from the beginning of the text array
            self._searchAlgorithm(0, self.currentText);

        }

        // Provide callback function support
        self._callbackSupport(callback);

        // Maintains chainability
        return self;

    };

    // Mobile Module
    // =============

    // Set Mobile Text
    // ---------------
    //      Updates the text of the drop down
    selectBoxIt._updateMobileText = function() {

        var self = this,
            currentOption,
            currentDataText,
            currentText;

        currentOption = self.selectBox.find("option").filter(":selected");

        currentDataText = currentOption.attr("data-text");

        currentText = currentDataText ? currentDataText: currentOption.text();

        // Sets the new dropdown list text to the value of the original dropdown list
        self._setText(self.dropdownText, currentText);

        if(self.list.find('li[data-val="' + currentOption.val() + '"]').find("i").attr("class")) {

            self.dropdownImage.attr("class", self.list.find('li[data-val="' + currentOption.val() + '"]').find("i").attr("class")).addClass("selectboxit-default-icon");

        }

    };

    // Apply Native Select
    // -------------------
    //      Applies the original select box directly over the new drop down

    selectBoxIt._applyNativeSelect = function() {

        // Stores the plugin context inside of the self variable
        var self = this;

        // Appends the native select box to the drop down (allows for relative positioning using the position() method)
        self.dropdownContainer.append(self.selectBox);

        self.dropdown.attr("tabindex", "-1");

        // Positions the original select box directly over top the new dropdown list using position absolute and "hides" the original select box using an opacity of 0.  This allows the mobile browser "wheel" interface for better usability.
        self.selectBox.css({

            "display": "block",

            "visibility": "visible",

            "width": self._realOuterWidth(self.dropdown),

            "height": self.dropdown.outerHeight(),

            "opacity": "0",

            "position": "absolute",

            "top": "0",

            "left": "0",

            "cursor": "pointer",

            "z-index": "999999",

            "margin": self.dropdown.css("margin"),

            "padding": "0",

            "-webkit-appearance": "menulist-button"

        });

        if(self.originalElem.disabled) {

            self.triggerEvent("disable");

        }

        return this;

    };

    // Mobile Events
    // -------------
    //      Listens to mobile-specific events
    selectBoxIt._mobileEvents = function() {

        var self = this;

        self.selectBox.on({

            "changed.selectBoxIt": function() {

                self.hasChanged = true;

                self._updateMobileText();

                // Triggers the `option-click` event on mobile
                self.triggerEvent("option-click");

            },

            "mousedown.selectBoxIt": function() {

                // If the select box has not been changed, the defaultText option is being used
                if(!self.hasChanged && self.options.defaultText && !self.originalElem.disabled) {

                    self._updateMobileText();

                    self.triggerEvent("option-click");

                }

            },

            "enable.selectBoxIt": function() {

                // Moves SelectBoxIt onto the page
                self.selectBox.removeClass('selectboxit-rendering');

            },

            "disable.selectBoxIt": function() {

                // Moves SelectBoxIt off the page
                self.selectBox.addClass('selectboxit-rendering');

            }

        });

    };

    // Mobile
    // ------
    //      Applies the native "wheel" interface when a mobile user is interacting with the dropdown

    selectBoxIt._mobile = function(callback) {

        // Stores the plugin context inside of the self variable
        var self = this;

        if(self.isMobile) {

            self._applyNativeSelect();

            self._mobileEvents();

        }

        // Maintains chainability
        return this;

    };

    // Remove Options Module
    // =====================

    // remove
    // ------
    //    Removes drop down list options
    //    using an index

    selectBoxIt.remove = function(indexes, callback) {

        var self = this,
            dataType = $.type(indexes),
            value,
            x = 0,
            dataLength,
            elems = "";

        // If an array is passed in
        if(dataType === "array") {

            // Loops through the array
            for(dataLength = indexes.length; x <= dataLength - 1; x += 1) {

                // Stores the currently traversed array item in the local `value` variable
                value = indexes[x];

                // If the currently traversed array item is an object literal
                if($.type(value) === "number") {

                    if(elems.length) {

                        // Adds an element to the removal string
                        elems += ", option:eq(" + value + ")";

                    }

                    else {

                        // Adds an element to the removal string
                        elems += "option:eq(" + value + ")";

                    }

                }

            }

            // Removes all of the appropriate options from the select box
            self.selectBox.find(elems).remove();

        }

        // If a number is passed in
        else if(dataType === "number") {

            self.selectBox.find("option").eq(indexes).remove();

        }

        // If anything besides a number or array is passed in
        else {

            // Removes all of the options from the original select box
            self.selectBox.find("option").remove();

        }

        // If the dropdown property exists
        if(self.dropdown) {

            // Rebuilds the dropdown
            self.refresh(function() {

                // Provide callback function support
                self._callbackSupport(callback);

            }, true);

        } else {

            // Provide callback function support
            self._callbackSupport(callback);

        }

        // Maintains chainability
        return self;

    };

    // Select Option Module
    // ====================

    // Select Option
    // -------------
    //      Programatically selects a drop down option by either index or value

    selectBoxIt.selectOption = function(val, callback) {

        // Stores the plugin context inside of the self variable
        var self = this,
            type = $.type(val);

        // Makes sure the passed in position is a number
        if(type === "number") {

            // Set's the original select box value and triggers the change event (which SelectBoxIt listens for)
            self.selectBox.val(self.selectItems.eq(val).val()).change();

        }

        else if(type === "string") {

            // Set's the original select box value and triggers the change event (which SelectBoxIt listens for)
            self.selectBox.val(val).change();

        }

        // Calls the callback function
        self._callbackSupport(callback);

        // Maintains chainability
        return self;

    };

    // Set Option Module
    // =================

    // Set Option
    // ----------
    //      Accepts an string key, a value, and a callback function to replace a single
    //      property of the plugin options object

    selectBoxIt.setOption = function(key, value, callback) {

        var self = this;

        //Makes sure a string is passed in
        if($.type(key) === "string") {

            // Sets the plugin option to the new value provided by the user
            self.options[key] = value;

        }

        // Rebuilds the dropdown
        self.refresh(function() {

            // Provide callback function support
            self._callbackSupport(callback);

        }, true);

        // Maintains chainability
        return self;

    };

    // Set Options Module
    // ==================

    // Set Options
    // ----------
    //      Accepts an object to replace plugin options
    //      properties of the plugin options object

    selectBoxIt.setOptions = function(newOptions, callback) {

        var self = this;

        // If the passed in parameter is an object literal
        if($.isPlainObject(newOptions)) {

            self.options = $.extend({}, self.options, newOptions);

        }

        // Rebuilds the dropdown
        self.refresh(function() {

            // Provide callback function support
            self._callbackSupport(callback);

        }, true);

        // Maintains chainability
        return self;

    };

    // Wait Module
    // ===========

    // Wait
    // ----
    //    Delays execution by the amount of time
    //    specified by the parameter

    selectBoxIt.wait = function(time, callback) {

        var self = this;

        self.widgetProto._delay.call(self, callback, time);

        // Maintains chainability
        return self;

    };
})); // End of all modules
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*
	Breakpoints.js
	version 1.0
	
	Creates handy events for your responsive design breakpoints
	
	Copyright 2011 XOXCO, Inc
	http://xoxco.com/

	Documentation for this plugin lives here:
	http://xoxco.com/projects/code/breakpoints
	
	Licensed under the MIT license:
	http://www.opensource.org/licenses/mit-license.php

*/
(function($) {

	var lastSize = 0;
	var interval = null;

	$.fn.resetBreakpoints = function() {
		$(window).off('resize');
		if (interval) {
			clearInterval(interval);
		}
		lastSize = 0;
	};
	
	$.fn.setBreakpoints = function(settings) {
		var options = jQuery.extend({
							distinct: true,
							breakpoints: new Array(320,480,768,1024)
				    	},settings);


		interval = setInterval(function() {
	
			var w = $(window).width();
			var done = false;
			
			for (var bp in options.breakpoints.sort(function(a,b) { return (b-a) })) {
			
				// fire onEnter when a browser expands into a new breakpoint
				// if in distinct mode, remove all other breakpoints first.
				if (!done && w >= options.breakpoints[bp] && lastSize < options.breakpoints[bp]) {
					if (options.distinct) {
						for (var x in options.breakpoints.sort(function(a,b) { return (b-a) })) {
							if ($('body').hasClass('breakpoint-' + options.breakpoints[x])) {
								$('body').removeClass('breakpoint-' + options.breakpoints[x]);
								$(window).trigger('exitBreakpoint' + options.breakpoints[x]);
							}
						}
						done = true;
					}
					$('body').addClass('breakpoint-' + options.breakpoints[bp]);
					$(window).trigger('enterBreakpoint' + options.breakpoints[bp]);

				}				

				// fire onExit when browser contracts out of a larger breakpoint
				if (w < options.breakpoints[bp] && lastSize >= options.breakpoints[bp]) {
					$('body').removeClass('breakpoint-' + options.breakpoints[bp]);
					$(window).trigger('exitBreakpoint' + options.breakpoints[bp]);

				}
				
				// if in distinct mode, fire onEnter when browser contracts into a smaller breakpoint
				if (
					options.distinct && // only one breakpoint at a time
					w >= options.breakpoints[bp] && // and we are in this one
					w < options.breakpoints[bp-1] && // and smaller than the bigger one
					lastSize > w && // and we contracted
					lastSize >0 &&  // and this is not the first time
					!$('body').hasClass('breakpoint-' + options.breakpoints[bp]) // and we aren't already in this breakpoint
					) {					
					$('body').addClass('breakpoint-' + options.breakpoints[bp]);
					$(window).trigger('enterBreakpoint' + options.breakpoints[bp]);

				}						
			}
			
			// set up for next call
			if (lastSize != w) {
				lastSize = w;
			}
		},250);
	};
	
})(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/**
 * User: konstantin
 * Date: 4/24/14
 */
$.namespace('scent');

scent.global = {
    isMobile: function() {
        return $(window).width() < 768;
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_Tc_dot_$, jQuery) {var application;

(function ($) {

	$(document).ready(function () {

		$(window).setBreakpoints({
			distinct: true,
			breakpoints: [
				768
			]
		});

		var mobileLoaded = false;
		if(scent.global.isMobile()) {
			mobileLoaded = true;
		}

		viewportDetection();

		$('img.hide-on-desktop').lazyload({
			threshold:200,
			load : function() {
				imageCenteringTeaserbox();
			}
		});
		$('img:not(.hide-on-desktop)').lazyload({
			threshold:600
		});


		$('.js-bottom .textbox .content h2').dotdotdot({
			watch: "window"
		});
		imageCentering();
		imageCenteringTeaserbox();
		articlenumberMargin();
		parallax();
		articleTitle();
		menuAnimation();
		editionNavLink();
		initQtip();

		setTimeout(function() {
			$('.js-bottom .textbox .content h2').trigger("update");
			imageCentering();
			imagecaption();
		}, 200);

		var $page = $('html');
		application = new Tc.Application($page);
		application.registerModules();
		application.start();

	});

	$(window).resize(function() {
		menuToggling();
		imageCentering();
		imageCenteringTeaserbox();
		parallax();
		articleTitle();
		viewportDetection();
	});

	function editionNavLink(){
		$('.header').on('click', '.link-editionnav, .menu-icon-dialog', function(e){
			var $this = $(this),
				$header= $('.header-edition-title'),
				$edition = $('.header-edition-title .het-edition'),
				$year = $('.header-edition-title .het-year');

			e.preventDefault();

			if ($this.hasClass('link-editionnav') && $this.hasClass('active')) {
				debug.log('editionNavLink > link0editionnav is used only for opening');
				return;
			}

			scrollToContent();

			$('.link-editionnav, .menu-icon-dialog').toggleClass('active');
			$('.mod-editionnavigation').toggleClass('hide', !$this.hasClass('active'));
			$('.mod-content, .mod-article, .mod-articleswitcher').toggleClass('hide', $this.hasClass('active'));
			if(!$this.hasClass('active')){
				$edition.html($header.data('edition'));
				$year.html($header.data('year'));
				scrollToContent();
				$('.mod-footer').css("margin-top", "0px");
			} else {
				$('.mod-footer').css("margin-top", "55px");
			}
		});
	}

	function scrollToContent() {

		var
			menuSize = 50,
			$navigation = $(".mod-editionnavigation"),
			$content = $('.mod-content'),
			scrollTo = $content.length > 0 ? $content.offset().top : 0;

		// consider weird top margin of navigation
		if($navigation.position().top <= menuSize ) {
			scrollTo -= menuSize; // assume we deduct a fixed size for the top menu
		}

		$('html, body').scrollTop(scrollTo);
	}

	function viewportDetection() {
		var viewport = document.getElementById('viewport') || $('meta[name=viewport]')[0];
		if(!viewport) {
			return;
		}
		if ( navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPod/i)) {
			viewport.setAttribute("content", "width=device-width, initial-scale=1.0");
		} else if ( navigator.userAgent.match(/iPad/i) ) {
			if($(window).width() < $(window).height()) {
				viewport.setAttribute("content", "width=device-width, initial-scale=0.75");
			} else {
				viewport.setAttribute("content", "width=device-width, initial-scale=1.0");
			}
		}
	}

	function menuToggling() {
		var $mainmenuitem = $('.mainmenu > li').find('ul');
		if (scent.global.isMobile()) {
			$mainmenuitem.css("height", "");
			if($mainmenuitem.find('li').is(":visible")) {
				$mainmenuitem.find('li').hide();
			}
		} else {
			if(!$mainmenuitem.find('li').is(":visible")) {
				$mainmenuitem.find('li').show();
			}
		}
	}

	function imageCenteringTeaserbox() {
		var minors = $('.mod-newsitem.minor .imagewrapper');
		$('.col-1-3, .col-2-3, .col-4-12, .col-8-12, .col-1-2, .col-5-12, .col-7-12').find('.mod-newsitem:not(.main) .imagewrapper').add(minors).each(function imageCenteringTeaserbox() {
			if (scent.global.isMobile()) {
				var $image = $(this).find('img.hide-on-desktop');
				var height = $(this).height();
				var width = $(this).width();
				if(height > width) {
					$image.width(100);
					$image.css('height','auto');
					var margin = ($image.outerHeight()-100)/2;
					$image.css('margin-top', '-'+margin+'px');
				} else {
					$image.height(100);
					$image.css('width','auto');
					var margin = ($image.outerWidth()-100)/2;
					$image.css('margin-left', '-'+margin+'px');
				}
			}
		});
	}

	function imageCentering() {
		$('.mod-tagsearchresult').find('.imagewrapper').each(function imageCentering() {
			if (!scent.global.isMobile()) {
				var image = $(this).find('img.hide-on-mobile');
				image.removeAttr('style');
				var height = $(this).height();
				var width = $(this).width();
				if((height/width) < 0.9333) {
					image.width(300);
					image.css('height','auto');
					var margin = (image.outerHeight()-280)/2;
					image.css('margin-top', '-'+margin+'px');
				} else {
					image.height(280);
					image.css('width','auto');
					var margin = (image.outerWidth()-300)/2;
					image.css('margin-left', '-'+margin+'px');
				}
			} else {
				var image = $(this).find('img.hide-on-desktop');
				image.removeAttr('style');
				var height = $(this).height();
				var width = $(this).width();
				var wrapperratio = 220/$(window).width();
				var imageratio = image.outerHeight()/image.outerWidth();
				if(imageratio > wrapperratio) {
					image.css('width',$(window).width());
					image.css('height','auto');
					var margin = (image.outerHeight()-220)/2;
					image.css('margin-top', '-'+margin+'px');
				} else {
					image.css('height','220px');
					image.css('width','auto');
					var margin = (image.outerWidth()-$(window).width())/2;
					image.css('margin-left', '-'+margin+'px');
				}
			}
		});

		$('.mod-meta > .stagemedia .videocontainer').each(function imageCentering() {
			if (!scent.global.isMobile()) {
				var image = $(this).find('img.head');
				image.removeAttr('style');
				var height = $(this).height();
				var width = $(this).width();
				if((height/width) > 0.39) {
					image.width(940);
					image.css('height','auto');
					var margin = (image.outerHeight()-370)/2;
					image.css('margin-top', '-'+margin+'px');
				} else {
					image.height(370);
					image.css('width','auto');
					var margin = (image.outerWidth()-940)/2;
					image.css('margin-left', '-'+margin+'px');
				}
			} else {
				var image = $(this).find('img.head');
				image.removeAttr('style');
				var height = $(this).height();
				var width = $(this).width();
				var wrapperratio = 120/$(window).width();
				var imageratio = image.outerHeight()/image.outerWidth();
				if(imageratio > wrapperratio) {
					image.css('width',$(window).width());
					image.css('height','auto');
					var margin = (image.outerHeight()-120)/2;
					image.css('margin-top', '-'+margin+'px');
				} else {
					image.css('height','120px');
					image.css('width','auto');
					var margin = (image.outerWidth()-$(window).width())/2;
					image.css('margin-left', '-'+margin+'px');
				}
			}
		});

		$('.mod-article > .stagemedia .videocontainer').each(function imageCentering() {
			if (!scent.global.isMobile()) {
				var image = $(this).find('img.head');
				image.removeAttr('style');
				var height = $(this).height();
				var width = $(this).width();
				if((height/width) > 0.47) {
					image.width(940);
					image.css('height','auto');
					var margin = (image.outerHeight()-440)/2;
					image.css('margin-top', '-'+margin+'px');
				} else {
					image.height(440);
					image.css('width','auto');
					var margin = (image.outerWidth()-940)/2;
					image.css('margin-left', '-'+margin+'px');
				}
			} else {
				var image = $(this).find('img.head');
				image.removeAttr('style');
				var height = $(this).height();
				var width = $(this).width();
				var wrapperratio = 200/$(window).width();
				var imageratio = image.outerHeight()/image.outerWidth();
				if(imageratio > wrapperratio) {
					image.css('width',$(window).width());
					image.css('height','auto');
					var margin = (image.outerHeight()-200)/4;
					image.css('margin-top', '-'+margin+'px');
				} else {
					image.css('height','200px');
					image.css('width','auto');
					var margin = (image.outerWidth()-$(window).width())/2;
					image.css('margin-left', '-'+margin+'px');
				}
			}
		});
	}

	function articlenumberMargin() {
		$("[class*='col-']").each(function articlenumberMargin() {
			$(this).find('div.articlenumber-spacer:first').css('height','0px');
		});
	}

	function imagecaption() {
		$('.imageleft, .imageright, .imagecenter').each(function imagecaption() {
			var img = $(this).find('img');
			var caption = $(this).find('.bildlegende');
			caption.outerWidth(img.width());
		});
	}

	function parallax() {
		$(window).scroll(function() {
			if (!scent.global.isMobile() && !(/iPhone|iPod|iPad/.test(navigator.userAgent))) {
				s = $(document).scrollTop();
				transformSlower = 'translateY('+(s/3)+'px)';
				$('.parallax img').css({
					'-webkit-transform':transformSlower,
					'-moz-transform':transformSlower,
					'-ms-transform':transformSlower,
					'-o-transform':transformSlower
				});
				moveUp = '-'+(s/3)+'px';
				$('.mod-article .col-5-12').css({
					'margin-top':moveUp
				});
			} else {
				$('.parallax img').css({
					'-webkit-transform':'',
					'-moz-transform':'',
					'-ms-transform':'',
					'-o-transform':''
				});
				$('.col-5-12').css({
					'margin-top':''
				});
			}
		});
	}

	function articleTitle() {
		$('.mod-article h1.fullwidth').each(function() {
			if (!scent.global.isMobile()) {
				if($(this).outerHeight() < 60) {
					$(this).css({'margin-top':'-117px'});
					$('.mod-article .spitzmarke.fullwidth').css({'margin-top':'-143px'});
				}
			} else {
				$(this).css({'margin-top':''});
				$('.mod-article .spitzmarke.fullwidth').css({'margin-top':''});
			}
		});
	}

	function initQtip() {

		var mod = this,
			$ctx = mod.$ctx;

		// module vars
		var QTIP_CONFIG = {
			position: {
				my: 'bottom center',
				at: 'top center',
				viewport: $(window), // Keep it on-screen at all times if possible
				adjust: {
					x: 0,
					y: -2
				}
			},
			hide: {
				fixed: true // Helps to prevent the tooltip from hiding occasionally when tracking!
				//,event : 'click' // Uncomment for styling and debugging
			},
			content: {
				title: false,
				text: function () {
					return $(this).data('hint');
				}
			},
			show: {
				event: 'click mouseenter'
			},
			style: {
				classes: ($.fn.qtip.defaults.style.classes || '') + ' scs-callout qtip-shadow qtip-rounded scs-form-qtip'
			}
		};

		$('form button.field-hint', $ctx).each(function () {
			var $buttonFieldHint = $(this);

			if ($buttonFieldHint.length !== 1 || typeof($buttonFieldHint.data('hint')) === 'undefined') {
				throw('Trying to create qtip instance on element without hint');
			}

			if (typeof($buttonFieldHint.data('qtip')) === 'undefined') {
				debug.log('Emagazine main.js > initialized Tooltip');
				$buttonFieldHint.qtip(QTIP_CONFIG);
			}

		});

	}

	function menuAnimation() {
		if($('.mod-splashscreen').length !== 0) {
			var menu = $('.mod-menu');
			if($(this).scrollTop() >= $(window).height()) {
				menu.css({
					'opacity' : 1.0,
					'margin-top' : 0 + 'px'
				});
			} else {
				menu.css({
					'opacity' : 0.0,
					'margin-top' : -40 + 'px'
				});
			}
			$(window).scroll(function() {
				var scrolltop = $(this).scrollTop();
				var startpoint = $(window).height()/2;
				if(scrolltop >= startpoint && scrolltop < $(window).height()) {
					menu.css({
						'opacity' : (scrolltop/startpoint - 1),
						'margin-top' : 40*(scrolltop/startpoint - 1)-40 + 'px'
					});
				} else if(scrolltop >= $(window).height()) {
					menu.css({
						'opacity' : 1.0,
						'margin-top' : 0 + 'px'
					});
				} else {
					menu.css({
						'opacity' : 0.0,
						'margin-top' : -40 + 'px'
					});
				}

			});
		} else {
			$('.mod-menu').css({
				'opacity' : 1.0,
				'margin-top' : 0 + 'px'
			});
		}
	}

	/*! Backstretch - v2.0.4 - 2013-06-19
	 * http://srobbin.com/jquery-plugins/backstretch/
	 * Copyright (c) 2013 Scott Robbin; Licensed MIT */
	(function(a,d,p){a.fn.backstretch=function(c,b){(c===p||0===c.length)&&a.error("No images were supplied for Backstretch");0===a(d).scrollTop()&&d.scrollTo(0,0);return this.each(function(){var d=a(this),g=d.data("backstretch");if(g){if("string"==typeof c&&"function"==typeof g[c]){g[c](b);return}b=a.extend(g.options,b);g.destroy(!0)}g=new q(this,c,b);d.data("backstretch",g)})};a.backstretch=function(c,b){return a("body").backstretch(c,b).data("backstretch")};a.expr[":"].backstretch=function(c){return a(c).data("backstretch")!==p};a.fn.backstretch.defaults={centeredX:!0,centeredY:!0,duration:5E3,fade:0};var r={left:0,top:0,overflow:"hidden",margin:0,padding:0,height:"100%",width:"100%",zIndex:-999999},s={position:"absolute",display:"none",margin:0,padding:0,border:"none",width:"auto",height:"auto",maxHeight:"none",maxWidth:"none",zIndex:-999999},q=function(c,b,e){this.options=a.extend({},a.fn.backstretch.defaults,e||{});this.images=a.isArray(b)?b:[b];a.each(this.images,function(){a("<img />")[0].src=this});this.isBody=c===document.body;this.$container=a(c);this.$root=this.isBody?l?a(d):a(document):this.$container;c=this.$container.children(".backstretch").first();this.$wrap=c.length?c:a('<div class="backstretch"></div>').css(r).appendTo(this.$container);this.isBody||(c=this.$container.css("position"),b=this.$container.css("zIndex"),this.$container.css({position:"static"===c?"relative":c,zIndex:"auto"===b?0:b,background:"none"}),this.$wrap.css({zIndex:-999998}));this.$wrap.css({position:this.isBody&&l?"fixed":"absolute"});this.index=0;this.show(this.index);a(d).on("resize.backstretch",a.proxy(this.resize,this)).on("orientationchange.backstretch",a.proxy(function(){this.isBody&&0===d.pageYOffset&&(d.scrollTo(0,1),this.resize())},this))};q.prototype={resize:function(){try{var a={left:0,top:0},b=this.isBody?this.$root.width():this.$root.innerWidth(),e=b,g=this.isBody?d.innerHeight?d.innerHeight:this.$root.height():this.$root.innerHeight(),j=e/this.$img.data("ratio"),f;j>=g?(f=(j-g)/2,this.options.centeredY&&(a.top="-"+f+"px")):(j=g,e=j*this.$img.data("ratio"),f=(e-b)/2,this.options.centeredX&&(a.left="-"+f+"px"));this.$wrap.css({width:b,height:g}).find("img:not(.deleteable)").css({width:e,height:j}).css(a)}catch(h){}return this},show:function(c){if(!(Math.abs(c)>this.images.length-1)){var b=this,e=b.$wrap.find("img").addClass("deleteable"),d={relatedTarget:b.$container[0]};b.$container.trigger(a.Event("backstretch.before",d),[b,c]);this.index=c;clearInterval(b.interval);b.$img=a("<img />").css(s).bind("load",function(f){var h=this.width||a(f.target).width();f=this.height||a(f.target).height();a(this).data("ratio",h/f);a(this).fadeIn(b.options.speed||b.options.fade,function(){e.remove();b.paused||b.cycle();a(["after","show"]).each(function(){b.$container.trigger(a.Event("backstretch."+this,d),[b,c])})});b.resize()}).appendTo(b.$wrap);b.$img.attr("src",b.images[c]);return b}},next:function(){return this.show(this.index<this.images.length-1?this.index+1:0)},prev:function(){return this.show(0===this.index?this.images.length-1:this.index-1)},pause:function(){this.paused=!0;return this},resume:function(){this.paused=!1;this.next();return this},cycle:function(){1<this.images.length&&(clearInterval(this.interval),this.interval=setInterval(a.proxy(function(){this.paused||this.next()},this),this.options.duration));return this},destroy:function(c){a(d).off("resize.backstretch orientationchange.backstretch");clearInterval(this.interval);c||this.$wrap.remove();this.$container.removeData("backstretch")}};var l,f=navigator.userAgent,m=navigator.platform,e=f.match(/AppleWebKit\/([0-9]+)/),e=!!e&&e[1],h=f.match(/Fennec\/([0-9]+)/),h=!!h&&h[1],n=f.match(/Opera Mobi\/([0-9]+)/),t=!!n&&n[1],k=f.match(/MSIE ([0-9]+)/),k=!!k&&k[1];l=!((-1<m.indexOf("iPhone")||-1<m.indexOf("iPad")||-1<m.indexOf("iPod"))&&e&&534>e||d.operamini&&"[object OperaMini]"==={}.toString.call(d.operamini)||n&&7458>t||-1<f.indexOf("Android")&&e&&533>e||h&&6>h||"palmGetResource"in d&&e&&534>e||-1<f.indexOf("MeeGo")&&-1<f.indexOf("NokiaBrowser/8.5.0")||k&&6>=k)})(jQuery,window);

})(__webpack_provided_Tc_dot_$);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(0)))

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_$, __webpack_provided_window_dot_Tc_dot_$) {/* globals JSON, window, document */
/* exported JSON, window, document */
__webpack_require__(3);


(function ($, SCS) {
	'use strict';

	/**
	 * Global utilities for all Swisscom projects
	 *
	 * @author Thomas Junghans
	 * @namespace SCS
	 * @class utils
	 */
	SCS.utils = SCS.utils || {};

	var zeroFill = __webpack_require__(3).zeroFill;

	/**
	 * Override jQuery.fn.load to call SCS.utils.initNewModules on updated elements.
	 */
	var oldLoad = $.fn.load;
	$.fn.load = function (url, data, callback) {
		var element = this;
		callback = callback || data;
		if (!$.isFunction(callback)) {
			callback = $.noop;
		} else if ($.isFunction(data)) {
			data = null;
		}
		return oldLoad.call(element, url, data, function () {
			SCS.utils.initNewModules(element);
			callback.apply(this, arguments);
		});
	};

	/**
	 * Returns LESS variables that were previously stored in the "font-family" property of a hidden element
	 *
	 * You have to define the values in LESS like this:
	 *	// bring less variables to javascript
	 *	myElement > .less-vars {
	 *		// local variables to prevent calculation in the JSON object
	 *		@smallLogoSize: @logoSpace - @logoSmallDifference;
	 *
	 *		// generate JSON out of a object via LESS-Javascript
	 *		font-family: ~`"'" +
	 *			JSON.stringify({
	 *				mobile: {
	 *					breakpoint: '@{ResponsiveMaxMobile}'.replace('px', '')
	 *				},
	 *				desktop: {
	 *					logoTotalWidth: {
	 *						big: '@{logoSpace}'.replace('px', ''),
	 *						small: '@{smallLogoSize}'.replace('px', '')
	 *					}
	 *				}
	 *			})
	 *			+ "'"
	 *		` !important;
	 *
	 *		display: none;
	 *	}
	 *
	 * @method getLessVars
	 * @param {HTMLElement|jQuery} element - must either be the element (with less vars) itself or must contain a child element with class "less-vars"
	 * @returns Object|String
	 */
	SCS.utils.getLessVars = function (element) {
		var $el = $(element),
			$lessVars = $el.is('.less-vars') ? $el : $el.children('.less-vars'),
			fontFamily = $lessVars.css('font-family') || '',
			contentValue = fontFamily.replace(/\\"/g, '"').replace(/(^")|("$)|(^')|('$)/g, '');

		try {
			return JSON.parse(contentValue);
		} catch (e) {
			return contentValue;
		}
	};

	/**
	 * Remove CSS classes that match a substring.
	 *
	 * If cssClassAttriube = "cssClassFoo cssClassBar cssClassBaz cssClassBarBaz" and
	 * cssClassesToRemove = "Bar" then the return value will be "cssClassFoo cssClassBaz"
	 *
	 * @param cssClassAttribute {string}
	 * @param cssClassesToRemove {string}
	 * @returns {string}
	 */
	SCS.utils.removeCssClasses = function (cssClassAttribute, cssClassesToRemove) {
		var classes = cssClassAttribute.split(/\s+/);

		for (var i = 0; i < classes.length;) {

			if (classes[i].indexOf(cssClassesToRemove) > -1) {
				classes.splice(i, 1);
			} else {
				i += 1;
			}
		}
		return classes.join(' ');
	};

	/**
	 * Expects the value of a css class attribute and the prefix of a css class eg. scs-. An array with all prefixed
	 * css classes is returned
	 *
	 * @method getClassNamesWithPrefix
	 * @param {string} classAttribute
	 * @param {string} prefix
	 * @returns {Array<string>}
	 */
	SCS.utils.getClassNamesWithPrefix = function (classAttribute, prefix) {
		var cssClasses = classAttribute.split(/\s+/),
			customClasses = [],
			i = 0,
			ii = cssClasses.length;

		if (typeof(prefix) === 'string') {
			for (; i < ii; i += 1) {
				if (cssClasses[i].indexOf(prefix) >= 0) {
					customClasses.push(cssClasses[i]);
				}
			}
		} else {
			customClasses = cssClasses;
		}

		return customClasses;
	};

	/**
	 * Checks if the path suffix is either jpeg, jpg, png or gif
	 *
	 * @method isImagePath
	 * @namespace SCS.utils
	 * @param path
	 * @returns {boolean} true on success
	 */
	SCS.utils.isImagePath = __webpack_require__(4).isImagePath;

	SCS.utils.isMobilePage = __webpack_require__(3).isMobilePage;

	/**
	 * Returns true if obj is string and not ''.
	 *
	 * @method isNonEmptyString
	 * @param obj
	 * @returns {boolean}
	 */
	SCS.utils.isNonEmptyString = function (obj) {
		return this.isString(obj) && obj.length > 0;
	};

	SCS.utils.isString = function (obj) {
		return typeof obj === 'string' || (obj !== null && typeof obj === 'object' && obj.constructor === String);
	};

	/**
	 * @method parseNumber
	 * @namespace SCS.utils
	 * @param numericValue
	 * @return {Number}
	 */
	SCS.utils.parseNumber = function (numericValue) {
		if (!numericValue) {
			return 0;
		}
		var result = Number($.trim(numericValue.toString()));
		return isNaN(result) ? 0 : result;
	};

	/**
	 * Short cut for getElementId including the conversion into a jQuery object. It is faster than $('#' + id).
	 * @method $id
	 * @param id {string}
	 * @returns {jQuery}
	 */
	SCS.utils.$id = function (id) {
		return $(document.getElementById(id));
	};

	/**
	 * Returns a unique id for the given DOM element. This id does not change if it is set once.
	 * @method getUniqueIdOfElement
	 * @param {HTMLElement|jQuery} element
	 * @returns {String}
	 */
	SCS.utils.getUniqueIdOfElement = __webpack_require__(3).getUniqueIdOfElement;

	/**
	 * Checks if a url is external - can be used to check if a url can be loaded via ajax (same domain policy)
	 * @method isExternalUrl
	 * @param url {string}
	 * @returns boolean
	 */
	SCS.utils.isExternalUrl = __webpack_require__(4).isExternalUrl;

	SCS.utils.isIE11 = __webpack_require__(34).isIE11;

	/**
	 * Converts kbit/s, MBit/s and GBit/s to bits per second (integer)
	 * @method convertToBits
	 * @param {String} s For example '15 MBit/s'
	 * @returns {Integer} Bits per second.
	 */
	SCS.utils.convertToBits = function (s) {
		var i = parseInt(s, 10);
		// kilobit per second (symbol kbit/s or kb/s, often abbreviated "kbps")
		if (s.match(/[kK][bB](it)?[\/p]s/)) {
			return i * 1000;
		}
		// megabit per second (symbol Mbit/s or Mb/s, often abbreviated "Mbps")
		if (s.match(/M[bB](it)?[\/p]s/)) {
			return i * 1000 * 1000;
		}
		// gigabit per second (symbol Gbit/s or Gb/s, often abbreviated "Gbps")
		if (s.match(/G[bB](it)?[\/p]s/)) {
			return i * 1000 * 1000 * 1000;
		}
		return i;
	};

	/**
	 * Formats a given price to a "0.00" format
	 * @method formatPrice
	 * @param {number} price
	 * @returns {string}
	 */
	SCS.utils.formatPrice = function (price) {
		var cents = Math.round(price * 100 || 0) + '';
		while (cents.length < 3) {
			cents = '0' + cents;
		}
		return cents.substr(0, cents.length - 2) + '.' + cents.substr(-2, 2);
	};

	/**
	 * Formats a price/number of format "12.00" or "12" to "12.–", and "12.50" to "12.50"
	 * @param price {(number|string)}
	 * @returns {string}
	 */
	SCS.utils.formatPriceWithDash = function(price) {
		price = String(price);
		if (/[.][0-9]?[1-9]/.test(price)) {
			return SCS.utils.formatPrice(price);
		}
		return price.replace(/^(-?\d+)($|\.0*$|\.00.*$)/, '$1.–');
	};

	/**
	 * Formats time (hours) to "00:00" format
	 * @method formatTime
	 * @param {float} hours
	 * @param {string} delimiter
	 * @returns {string}
	 */
	SCS.utils.formatTime = function (hours, delimiter) {
		return zeroFill(Math.floor(hours), 2) +
			(delimiter ? delimiter : ':') +
			zeroFill(Math.floor((hours % 1) * 60), 2);
	};

	/**
	 * Returns a date object containing the actual server time.
	 * IMPORTANT:
	 * - at the moment this doesn not work until SC ads a "data-server-timestamp" attribute to its body
	 * - if your timezone is different to the servers the minutes can be inaccurate (max as many as the servers caching time - 3 mins at the time)
	 *
	 * @method getServerTime
	 * @returns {Date}
	 */
	SCS.utils.getServerTime = function () {
		var serverTimeStamp = $('body').data('server-timestamp'),
			serverTime,
			browserTime = new Date(),
			acceptableOffset = 1000 * 60 * 10; // 10 minutes

		// fix for swisscom IF there is an element on the page with attribute "data-now"
		if (!serverTimeStamp) {
			serverTimeStamp = $('[data-now]:first').data('now');
		}

		serverTime = new Date(Number(serverTimeStamp));

		/*
		 * The servers timestamp is "old" because of caching. This means we don't have an accurate time and events cannot be started at the exact time.
		 * Therefore if the offset between servertime and browsertime is lower than 10 minutes we assume that both have the same timezone.
		 * Then browsertime is taken. Otherwise the user has a different timezone and then servertime is taken with the above mentioned drawbacks.
		 * The caching time of the server is 3 minutes at the time (mrz. 2015)
		 */
		return (browserTime - serverTime <= acceptableOffset ? browserTime : serverTime);
	};


	SCS.utils.ajaxCache = {

		/**
		 * @private
		 */
		cachedPromises: {},

		/**
		 * Caches ajax calls
		 * @method ajax
		 * @param {object} settings - Settings object required by jQuery.ajax, containing at minimum the url
		 * @param {function} callback
		 * @returns {jQuery.promise}
		 */
		ajax: function (settings, callback) {
			if (!this.cachedPromises[settings.url]) {
				this.cachedPromises[settings.url] = $.Deferred(function (defer) {
					$.ajax(settings).then(defer.resolve, defer.reject);
				}).promise();
			}

			return this.cachedPromises[settings.url].done(callback);
		},

		/**
		 * Caches ajax JSON calls
		 * @method getJSON
		 * @param {string} url
		 * @param {function} callback
		 * @param {number} [timeout] - in milliseconds
		 * @returns {jQuery.promise}
		 */
		getJSON: function (url, callback, timeout) {
			return this.ajax({url: url, dataType: 'json', timeout: timeout}, callback);
		}

	};


	/**
	 * Converts a date string (with or without time) into a native date object
	 * @method fromString
	 * @param {string} dateString - For example '2014-12-31 12:15', '31.12.2014' or '1364560948000+0100'
	 * @returns {Date}
	 */
	function fromString(dateString) {
		var parts,
			date;

		if (!dateString || !dateString.match) {
			return null;
		}

		// dates in english format (2014-12-31 12:15:00) with or without time
		parts = dateString.match(/^(\d+)-(\d+)-(\d+)\s?(\d*):?(\d*):?(\d*)$/);
		if (parts) {
			return new Date(parts[1], parts[2] - 1, parts[3], parts[4] || '0', parts[5] || '0', parts[6] || '0');
		}

		// dates in german format (31.12.2014 12:15:00) with or without time
		parts = dateString.match(/^(\d+)\.(\d+)\.(\d+)\s?(\d*):?(\d*):?(\d*)$/);
		if (parts) {
			return new Date(parts[3], parts[2] - 1, parts[1], parts[4] || '0', parts[5] || '0', parts[6] || '0');
		}

		// dates in eCommerce format (1364560948000+0100)
		parts = dateString.match(/^(\d+)\+\d+$/);
		if (parts) {
			return new Date(parseInt(parts[1], 10));
		}

		// no match found -> try converting it to an integer
		date = new Date(parseInt(dateString, 10));
		if (date && !isNaN(date.getTime())) {
			return date;
		}

		return null;
	}

	/**
	 * Converts a date object into a formatted date (and optional time) string
	 * @method format
	 *
	 * @param {Date} date
	 *
	 * @param {object} [options] - Configure the format
	 * @param {bool} [options.english=false] - Formats the date in english format if TRUE ('2014-12-31' instead of '31.12.2014')
	 * @param {bool} [options.utc=false] - Converts the date to UTC if true
	 * @param {bool} [options.shortYear=false] - Formats the year as two digit value if TRUE ('14' instead of '2014')
	 * @param {bool} [options.time=false] - Includes the time if TRUE - only date is included by default
	 * @param {bool} [options.seconds=false] - Includes the seconds time if TRUE and TIME option is set - only hours and minutes are included by default
	 *
	 * @returns {string} - For example '31.12.2014', '31.12.14' or '2014-12-31 15:13:00'
	 */
	function format(date, options) {
		if (!date || !date.getTime || isNaN(date.getTime())) {
			return null;
		}

		options = $.extend({
			english: false,
			utc: false,
			shortYear: false,
			time: false,
			seconds: false
		}, options);

		var day = zeroFill(options.utc ? date.getUTCDate() : date.getDate()),
			month = zeroFill((options.utc ? date.getUTCMonth() : date.getMonth()) + 1),
			year = (options.utc ? date.getUTCFullYear() : date.getFullYear()).toString().substr(options.shortYear ? 2 : 0),
			hours = zeroFill(options.utc ? date.getUTCHours() : date.getHours()),
			minutes = zeroFill(options.utc ? date.getUTCMinutes() : date.getMinutes()),
			seconds = zeroFill(options.utc ? date.getUTCSeconds() : date.getSeconds()),
			time = (options.time ? (' ' + hours + ':' + minutes + (options.seconds ? (':' + seconds) : '')) : '');

		return (options.english ? (year + '-' + month + '-' + day) : (day + '.' + month + '.' + year)) + time;
	}

	/**
	 * Resets the time of a given date to zero (eg. 31.12.2014 00:00:00)
	 * @method resetTime
	 * @param {Date} date
	 * @returns {Date} - new date instance (original date is left as it is - pass by value)
	 */
	function resetTime(date) {
		var startOfDay = new Date(date);
		startOfDay.setHours(0);
		startOfDay.setMinutes(0);
		startOfDay.setSeconds(0);
		startOfDay.setMilliseconds(0);
		return startOfDay;
	}

	/**
	 * Resets the time of a given date to midnight (eg. 31.12.2014 23:59:59)
	 * @method endOfDay
	 * @param {Date} date
	 * @returns {Date} - new date instance (original date is left as it is - pass by value)
	 */
	function endOfDay(date) {
		var endOfDay = new Date(date);
		endOfDay.setHours(23);
		endOfDay.setMinutes(59);
		endOfDay.setSeconds(59);
		endOfDay.setMilliseconds(999);
		return endOfDay;
	}


	/**
	 * Render opening hours (blocks of work time)
	 *
	 * @method formatDailyHours
	 * @param {int} hours - the time in hours (9.5 => 9:30)
	 * @param {boolean} pad - should numbers be padded (unclear)
	 * @param {Object} locales - hash-map of localization labels
	 * @returns {String} ex. `09.00-11.30 Uhr & 13.00-16.30 Uhr`
	 */
	function formatDailyHours(hours, pad, locales) {
		var pairs = [];
		pad = pad ? 2 : 1;
		locales = locales || {};
		var timeDelim = locales.timeDelim;
		var hourDelim = locales.hourDelim;
		if (typeof timeDelim !== 'string') { timeDelim = '.'; }
		if (typeof hourDelim !== 'string') { hourDelim = ' & '; }
		if (!hours) { return locales.closed; }
		for (var i = 0; i < hours.length; i += 2) {
			var start = hours[i+0], end = hours[i+1];
			if (Math.abs(start - end) > 0) {
				var parts = [ SCS.utils.formatTime(start, timeDelim, pad) ];
				if (start !== end) { parts.push(SCS.utils.formatTime(end, timeDelim, pad)); }
				pairs.push(parts.join(locales.timeSeqDelim || '-') + ' ' + locales.clock);
			}
		}
		if (pairs.length) {
			return pairs.join(hourDelim);
		} else {
			return locales.closed;
		}
	}

	// upgrade alternative config to internaly used config
	// accepts one or multiple input arguments (varargs)
	function parseOpeningHours(openingHours) {

		var i;

		// assert for at least one argument
		if (!openingHours) { return false; }

		// return if input argument is already a valid constraints data object
		if (typeof openingHours === 'object' && openingHours.week) { return openingHours; }

		// create new config
		// closed all day long
		var config = {
			day: {}, // daily exceptions
			week: [
				true, // monday (true = inherit)
				true, // tuesday (true = inherit)
				true, // wednesday (true = inherit)
				true, // thursday (true = inherit)
				true, // friday (true = inherit)
				false,// saturday (false = closed)
				false // sunday (false = closed)
			],
			hours: false,
			time: true
		};

		var rules = [];
		// aggregate input from varargs
		for (i = 0; i < arguments.length; i += 1) {
			if (typeof arguments[i] === 'string') {
				rules.push(arguments[i]);
			} else if (arguments[i].length) {
				rules = rules.concat(arguments[i]);
			}
		}

		// weekdays are needed to create mapping from parsed to index
		var weekdays = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

		// parse all rules into constraints data
		for (i = 0; i < rules.length; i += 1) {
			// split rule into fragments (hope I got it right)
			var fragments = rules[i].split(/(?:\s*,\s*|\s+)/);
			// assert for minimal parsed fragments
			if (fragments.length < 3) { continue; }
			// get last two items for opening hours block
			var to = fragments.pop(), from = fragments.pop();
			for (var n = 0; n < fragments.length; n += 1) {
				// get fragment to check if it is a weekday
				var fragment = fragments[n].toLowerCase();
				var weekday = weekdays.indexOf(fragment);
				// found a rule that includes a date
				if (fragments[n].match(/^0*(\d+)\.0*(\d+)\.?$/)) {
					var sel = [RegExp.$1, RegExp.$2].join('.');
					config.day[sel] = updateOpeningHours(config.day[sel], toHours(from), toHours(to));
				}
				// found a rule for weekday
				else if (weekday !== -1) {
					config.week[weekday] = updateOpeningHours(config.week[weekday], toHours(from), toHours(to));
				}
			}
		}
		return config;
	}
	// EO parseOpeningHours

	// add opening hours properly to a week config, evne if there are already other opening hours definied previously
	function updateOpeningHours(config, from, to) {
		// when we need to update the values already in that config
		if(!config || !config.length) {
			return [from, to];
		} else {
			var addedToExisting = false;
			var niceConfig = [];
			for(var i = 0; i < config.length; i+=2) {
				niceConfig.push([config[i*2+0], config[i*2+1]]);
			}
			$.each(niceConfig, function(i, span) {
				// new span total before old or
				// new span is total after old
				if(to < span[0] || from > span[1]) {
					return;
				}
				if(from < span[0] && to > span[0] && to < span[1]) {
					// new span starts before and ends within
					niceConfig[i][0] = from;
				} else if(from > span[0] && from < span[1] && to > span[1]) {
					// new span starts within and ends after
					niceConfig[i][1] = to;
				} else if(from < span[0] && to > span[1]) {
					// new span widens the old on both sides
					niceConfig[i][0] = from;
					niceConfig[i][1] = to;
				}
				addedToExisting = true;
			});
			if(!addedToExisting) {
				// if its a span before
				if(to < config[0]) {
					niceConfig.unshift([from, to]);
				// if its a span after
				} else {
					niceConfig.push([from, to]);
				}
			}
			config = [];
			$.each(niceConfig, function(i, span) {
				config.push(span[0]);
				config.push(span[1]);
			});
			return config;
		}
	}
	// EO updateOpeningHours



	/**
	 * Parse a date string into date object
	 * Main support for date-picker, but also suited
	 * for all date inputs from desktop browsers and
	 * inputs from mobile browser with input type date.
	 *
	 * Dektop: 'D.M.YYYY'
	 * Mobile: 'YYYY-M-D'
	 *
	 * @method parseDay
	 * @param {String} daystr - date string in compatible form
	 * @param {Boolean} strict - disable overflow (default true)
	 * @returns {Date} date object (zero time) or null/false
	 */
	function parseDateDay(daystr, strict) {

		var fragments;
		// use object prototype to check if we have already a real date object
		if (Object.prototype.toString.call(daystr) === '[object Date]') { return daystr; }
		// defaults to true if argument is omitted
		if (arguments.length < 2) { strict = true; }
		// base validate assertion
		if (!daystr) { return null; }
		// match default desktop format: `D.M.YYYY`
		else if (daystr.match(/^\d{1,2}\.\d{1,2}\.\d{4}$/)) {
			fragments = daystr.split('.');
		}
		// match default mobile format: `YYYY-M-D`
		else if (daystr.match(/^\d{4}\-\d{1,2}\-\d{1,2}$/)) {
			fragments = daystr.split('-').reverse();
		}
		// incompatible format?
		if (!fragments) { return null; }
		// convert each part to integer
		var day = parseInt(fragments[0], 10),
			month = parseInt(fragments[1], 10),
			year = parseInt(fragments[2], 10);
		// create date object (some parts could overflow)
		var date = new Date(year, month - 1, day);
		// adjust for local timezone (if it was utc)
		// var tzoff = date.getTimezoneOffset() * 60;
		// date.setTime(date.getTime() - tzoff * 1000);

		// is overflow is allowed?
		if (!strict) { return date; }
		// check if no overflow occurred
		return (date.getDate() === day) &&
			(date.getFullYear() === year) &&
			(date.getMonth() + 1 === month) &&
			date; // returns date if all true
	}

	/**
	 * compare two dates if the are on the same day
	 * can be used to sort arrays of date objects
	 *
	 * @method compareDays
	 * @param {Date} a - first date object to compare
	 * @param {Date} b - second date object to compare
	 * @returns {int} 0 for same day, -1 if a < b, 1 if b > a;
	 */
	function compareDays(a, b) {
		// check if date are the same days
		if (a.getFullYear() === b.getFullYear() &&
			a.getMonth() === b.getMonth() &&
			a.getDate() === b.getDate()
		) {
			return 0;
		}
		// or compare dates
		return a < b ? -1 : 1;
	}

	/**
	 * get opening hours for specific day
	 * returns false if the day is closed
	 * but may also return an empty array
	 *
	 * @method getOpeningHours
	 * @param {Date} date - date object (time not used)
	 * @param {Object} config - business hours settings
	 * @returns {Array} list of opening blocks
	 */
	function getOpeningHours(date, config) {
		/* jslint maxdepth: 4 */
		// create on demand
		if (!config.day) {
			config.day = {};
		}
		// dereferenced variable access
		var oDay = config.day,
			oWeek = config.week,
			oHours = config.hours,
			oSpecial = config.special;
		// relevant date parts
		var day = date.getDate(),
			month = date.getMonth(),
			year = date.getFullYear();
		// inflate special days and add to normal day
		// we need to do this once for every year we see
		// use a flag to indicate which years are done
		if (oSpecial && !oSpecial[year]) {
			oSpecial[year] = true;
			for (var sday in oSpecial) {
				if (oSpecial.hasOwnProperty(sday)) {
					if (sday.match(/^easter([\+\-]\d+)?/)) {
						// get the easter date for the given year
						var edate = easterDate(date.getFullYear());
						// add optional offset to easter date (days)
						edate.setDate(edate.getDate() + parseInt(RegExp.$1 || 0, 10));
						// create the key for the working hours day (oDay) settings
						var ekey = [edate.getDate(), edate.getMonth() + 1, year].join('.');
						// attach easter config to day config now
						oDay[ekey] = oSpecial[sday];
					}
				}
			}
		}
		// create keys for day exception
		var mDay = day + '.' + (month + 1);
		var yDay = mDay + '.' + year;
		// check if date is a special year day
		// check if we have settings for day of year
		var yDayHours = oDay ? oDay[ yDay ] : undefined;
		if (yDayHours !== undefined) { return yDayHours; }
		// check if we have settings for day of month
		var mDayHours = oDay ? oDay[ mDay ] : undefined;
		if (mDayHours !== undefined) { return mDayHours; }
		// check if we have settings for day of week
		var wDayHours = oWeek ? oWeek[ date.getDay() ] : undefined;
		// if the value is true we want to let it "bubble" through
		if (wDayHours !== undefined && wDayHours !== true) { return wDayHours; }
		// fallback to the general opening hours
		return oHours || !config.time && [ 8, 17 ];
	}

	/**
	 * Get date of easter the given year
	 * ToDo: need to check for source attribution
	 * ToDo: might be hard to find out real origin
	 * ToDo: seems to be out in the wild for a while
	 * http://www.irt.org/articles/js052/index.htm
	 * http://stackoverflow.com/questions/1284314/easter-date-in-javascript
	 * http://coderzone.org/library/Get-Easter-Date-for-any-year-in-Javascript_1059.htm
	 *
	 * @method easterDate
	 * @param {int} year - full year (ie 2015)
	 * @returns {Date} easter date (with UTC time 12:00)
	 */
	function easterDate(Y) {
		var C = Math.floor(Y/100);
		var N = Y - 19*Math.floor(Y/19);
		var K = Math.floor((C - 17)/25);
		var I = C - Math.floor(C/4) - Math.floor((C - K)/3) + 19*N + 15;
		I = I - 30*Math.floor((I/30));
		I = I - Math.floor(I/28)*(1 - Math.floor(I/28)*Math.floor(29/(I + 1))*Math.floor((21 - N)/11));
		var J = Y + Math.floor(Y/4) + I + 2 - C + Math.floor(C/4);
		J = J - 7*Math.floor(J/7);
		var L = I - J;
		var M = 3 + Math.floor((L + 40)/44);
		var D = L + 28 - 31*Math.floor(M/4);
		return new Date(Date.UTC(Y, M - 1, D, 12));
	}

	/**
	 * Get minimum date given by constraints
	 *
	 * @method getMinDate
	 * @param {Date} date - date object (time is used)
	 * @param {Object} config - date constraint data
	 * @returns {Date} min date for the given constraint
	 */
	function getMinDate(date, config) {
		// relative date from config
		var minDate = config.minDate;
		// normalize invalid passed argument
		// this needs to be fixed in some jsp
		if (minDate === -1) { minDate = null; }
		// we either accept a date object or an offset from current date
		if (Object.prototype.toString.call(minDate) !== '[object Date]') {
			if (minDate !== null && typeof minDate !== 'undefined') {
				minDate = addWorkDays(date, config, minDate || 0);
			}
		}
		// handle waiting period
		if (config.wPeriod) {
			// wait period is applied to either minDate or date
			// we never allow any past dates if the option is set
			minDate = nextAvailableDate(minDate || date, config);
		}
		// return if date is false or time preserved
		if (!minDate || config.time) { return minDate; }
		// reset date to first possible time of day
		return resetTime(minDate);
	}

	/**
	 * Get maximum date given by constraints
	 *
	 * @method getMaxDate
	 * @param {Date} date - date object (time is used)
	 * @param {Object} config - date constraint data
	 * @returns {Date} max date for the given constraint
	 */
	function getMaxDate(date, config) {
		// relative date from config
		var maxDate = config.maxDate;
		// normalize invalid passed argument
		// this needs to be fixed in some jsp
		if (maxDate === -1) { maxDate = null; }
		// we either accept a date object or an offset from current date
		if (Object.prototype.toString.call(maxDate) !== '[object Date]') {
			if (maxDate !== null && typeof maxDate !== 'undefined') {
				maxDate = addWorkDays(date, config, maxDate || 0);
			}
		}
		// return if date is false or time preserved
		if (!maxDate || config.time) { return maxDate; }
		// reset date to last possible time of day
		return endOfDay(maxDate);
	}

	/**
	 * Check if date is in range constraint
	 * Tests for `minDate` and `maxDate`
	 * Both ends are optional, so if nothing
	 * is given on config, always return true.
	 *
	 * @method isInDayRange
	 * @param {Date} date - date object (time not used)
	 * @param {Object} config - uses `minDate` and `maxDate`
	 * @returns {Boolean} true if between minDate and maxDate
	 */
	function isInDayRange(date, config) {

		// optional argument from config
		// mostly used for unit testing
		var now = config.now || new Date();

		// absolute or relative min/max dates
		var minDate = getMinDate(now, config),
			maxDate = getMaxDate(now, config);
		// finally check the min/max constraints
		return (!minDate || date >= minDate) && (!maxDate || date <= maxDate);
	}

	/**
	 * Check if given date is a work day
	 * Meaning we have some opening hours
	 *
	 * @method isWorkDay
	 * @param {Date} date - date object (time not used)
	 * @param {Object} config - constraint data
	 * @returns {Boolean} true if it open that day
	 */
	function isWorkDay(date, config) {
		// get opening hours for day from config
		var hours = getOpeningHours(date, config);
		// compatibility for old option
		if (config.dateNoWeekends) {
			var dayOfWeek = date.getDay();
			if (dayOfWeek === 0) { return false; } // sun
			if (dayOfWeek === 6) { return false; } // sat
		}
		// check if day has opening hours (returns them)
		return hours && hours.length > 0 ? hours : false;
	}

	/**
	 * Check if given day is a valid day
	 * Meaning we have some opening hours
	 * And we can still book appointments
	 * Basically this returns true only if
	 * there is at least one valid date for
	 * that day (determined by isValidDate).
	 *
	 * @method isValidDay
	 * @param {Date} date - date object (time not used)
	 * @param {Object} config - constraint data
	 * @returns {Boolean} true if day has valid times
	 */
	function isValidDay(date, config) {
		// get opening hours via work day check
		var hours = isWorkDay(date, config);
		// return early if no workday
		if (!hours) { return false; }
		// no time checks if option not set
		// if (!config.time) { return hours; }
		// make sure we have a valid time
		var now = config.now || new Date();
		// check further constraints for current day
		// we may have some min date constraints, which
		// means we need to check if minDate can have
		// some time which satisfies the constraints.
		var minDate = getMinDate(now, config),
			maxDate = getMaxDate(now, config);

		// we may not have a min date constraint
		if (!minDate) { minDate = new Date('Jan 1 1900 00:00:00'); }
		if (!maxDate) { maxDate = new Date('Jan 1 2900 23:59:59'); }

		if (config.maxDate >= 0 && !config.time) {
			maxDate = endOfDay(maxDate);
		}
		// compare days of min date and date to test
		var cmpMinDays = compareDays(date, minDate),
			cmpMaxDays = compareDays(date, maxDate);
		// check min date constraint
		if (cmpMinDays === 0) {
			// get time of date to be checked
			var time = toHours(minDate);
			// get last possible valid time (closing)
			var closing = hours[hours.length-1];
			// normaly we exclude closing time
			if (!config.includeClosingTime) {
				if (time === closing) { return false; }
				closing -= config.interval || 0;
			}
			// store may already be closed up
			if (closing < time) { return false; }
		}
		// obey date range conditions
		if (cmpMinDays < 0) {
			return false;
		}
		if (cmpMaxDays > 0) {
			return false;
		}
		// must be upcoming work day
		return hours;
	}

	/**
	 * Check if given date and time are valid
	 * Constraints can be simple min/max or more
	 * complex checkings as for a valid appointment
	 * within opening hours (with a waiting period)
	 *
	 * @method isValidDate
	 * @param {Date} date - date object (time not used)
	 * @param {Object} config - constraint data
	 * @returns {Boolean} true if date is valid
	 */
	function isValidDate(date, config) {
		// run cheapest tests (workday and range check)
		// if (!isWorkDay(date, config)) { return false; }
		if (!isValidDay(date, config)) { return false; }
		if (!isInDayRange(date, config)) { return false; }
		// get opening hours for day from config
		var hours = getOpeningHours(date, config);
		// with disabled time a simple `isWorkDay`check is enough
		if (!config.time) { return hours && hours.length > 0; }
		// then check if the time is insisde opening hours
		var time = toHours(date);
		// check all opening hour blocks
		for (var n = 0; n < hours.length; n += 2) {
			// just to be sure we do good math
			// could be disabled for performance
			var opening = Math.min(hours[n+0], hours[n+1]),
				closing = Math.max(hours[n+1], hours[n+0]);
			// return success if time was found to be open
			// the closing time itself is not valid
			if (opening <= time && time <= closing) {
				// obey special option to include closing time (inline check)
				if (!config.includeClosingTime && time === closing) { return false; }
				// optionally check if time obeys interval
				var interval = (config.interval || 0);
				return !interval || (time - opening) % interval === 0;
			}
		}
		// store closed
		return false;
	}

	/**
	 * Convert date object, string ('11:30', '9.5') or number (9.5)
	 * to floating number representing the time denominated in hours
	 *
	 * @method toHours
	 * @param {Date|string} date - input
	 * @returns {float} time in hours (0-24+)
	 */
	function toHours(date) {
		// use object prototype to reveal sepecific type
		var type = Object.prototype.toString.call(date);
		// convert from date object
		if (type === '[object Date]') {
			return date.getHours() +
				date.getMinutes() / 60 +
				date.getSeconds() / 3600 +
				date.getMilliseconds() / 360000;
		}
		// convert from a string (ie '11:30')
		// all parts optional and can be floats
		else if (type === '[object String]') {
			var part = date.split(':');
			return parseFloat(part[0] || 0, 10) +
				parseFloat(part[1] || 0, 10) / 60 +
				parseFloat(part[2] || 0, 10) / 3600;
		}
		// otherwise try to convert to float
		else { return parseFloat(date || 0, 10); }
	}

	/**
	 * Add days to a date object (return copy)
	 * This also works for negative offsets
	 *
	 * @method addDays
	 * @param {Date} date - input date to be offset
	 * @param {Date} offset - number of days to offset
	 * @returns {Date} date plus offset (might be negative)
	 */
	function addDays(date, offset) {
		var cpy = new Date(date);
		cpy.setDate(cpy.getDate() + offset);
		return cpy;
	}

	/**
	 * Add work days to date object (return copy)
	 * Holidays are not counted when skipped
	 * This also works for negative offsets
	 *
	 * @method addDays
	 * @param {Date} date - input date to be offset
	 * @param {Date} offset - number of days to offset
	 * @returns {Date} date plus offset (might be negative)
	 */
	function addWorkDays(date, config, offset) {
		var cpy = new Date(date);
		var sign = offset < 0 ? -1 : 1;
		var wDays = Math.round(Math.abs(offset));
		// using `-1` is same as `0` but instead
		// of going forward, it goes backwards
		if (sign < 0) {
			wDays -= 1;
		}
		// loop with abort condition
		while (true) {
			// just skip over any holidays
			while (!isWorkDay(cpy, config)) {
				cpy.setDate(cpy.getDate() + sign);
			}
			// have a workday now
			// decrease days to go
				wDays -= 1;
			// check abort condition
			if (wDays <= -0.5) {
				break;
			}
			// move the date iteration object
			cpy.setDate(cpy.getDate() + sign);
		}
		return cpy;
	}

	/**
	 * Calculate next available appointment from date
	 * Employees may need time to prepare appointment
	 * Waiting Period can also be set directly on config
	 *
	 * @method nextAvailableDate
	 * @param {Date} date - date object (time not used)
	 * @param {Object} config - business hours settings
	 * @param {int} wPeriod - waiting period (hours)
	 * @returns {Date} next available appointment
	 */
	function nextAvailableDate(date, config, wPeriod) {

		/* jslint maxdepth: 5 */

		// get a new date object copy
		// also main return object
		var slot = new Date(date);

		// ensure valid number from optional arg or config
		wPeriod = parseFloat(wPeriod || config.wPeriod || 0, 10);

		// need fine grained loop control
		// easier to handle edge cases
		while (true) {
			// get opening hour blocks for the slot day
			var hours = getOpeningHours(slot, config);

			// get hours from date object as float
			var start = toHours(slot);

			// don't need the time part anymore on slot
			// re-calculated from wPeriod and work blocks
			// we just increment the day in the loop below
			slot = resetTime(slot);

			// are there some opening hours?
			if (hours && hours.length > 0) {

				// increment for next available timeslot
				// during the loop we deduct from wPeriod
				for (var n = 0; n < hours.length; n += 2) {

					// just to be sure we do good math
					// could be disabled for performance
					var opening = Math.min(hours[n+0], hours[n+1]),
						closing = Math.max(hours[n+1], hours[n+0]);

					// store is not closed
					if (start <= closing) {
						// start is before opening
						if (start < opening) {
							// move start to opening
							start = opening;
						}
						// deduct time spent in block
						wPeriod -= closing - start;
						// check stop condition
						if (wPeriod <= 0) {
							// calculate final time
							var time = closing + wPeriod;
							// set the time for the slot
							slot.setSeconds(time * 3600 + 0.5);
							// return date object
							return slot;
						}

					}
					// EO if not closed

				}
				// EO for hours loop

			}
			// EO if opening hours

			// move date slot to the next day
			slot.setDate(slot.getDate() + 1);
			start = 0; // reset start time

		}
		// EO while true

		// return date object
		return slot;

	}
	// EO nextAvailableDate

	SCS.utils.date = {
		fromString: fromString,
		format: format,
		resetTime: resetTime,
		endOfDay: endOfDay,
		formatDailyHours: formatDailyHours,
		parseOpeningHours: parseOpeningHours,
		updateOpeningHours: updateOpeningHours,
		parseDateDay: parseDateDay,
		compareDays: compareDays,
		getOpeningHours: getOpeningHours,
		easterDate: easterDate,
		getMinDate: getMinDate,
		getMaxDate: getMaxDate,
		isInDayRange: isInDayRange,
		isWorkDay: isWorkDay,
		isValidDay: isValidDay,
		isValidDate: isValidDate,
		toHours: toHours,
		addDays: addDays,
		addWorkDays: addWorkDays,
		nextAvailableDate: nextAvailableDate
	};
	// EO SCS.utils.date

	/**
	 * Compares two version strings of the format '1.8.3'
	 *
	 * Returns
	 * -1	if the first string is newer/higher
	 *	0	if the strings are equal
	 *	1	if the second string is newer/higher
	 *
	 * @param versionStringOne
	 * @param versionStringTwo
	 * @returns {number}
	 */
	SCS.utils.compareVersions = function(versionStringOne, versionStringTwo) {
		var versionValuesOne = SCS.utils.getVersionNumberArray(versionStringOne),
			versionValuesTwo = SCS.utils.getVersionNumberArray(versionStringTwo),
			maxValuesToCompare = Math.min(versionValuesOne.length, versionValuesTwo.length),
			compareStatus = 0;

		for(var i = 0; i < maxValuesToCompare && compareStatus === 0; i += 1){
			if(versionValuesOne[i] > versionValuesTwo[i]) {
				compareStatus = -1;
			}
			else if(versionValuesOne[i] < versionValuesTwo[i]) {
				compareStatus = 1;
			}
		}

		return compareStatus;
	};

	/**
	 * Turns a version string of format '1.2.3' into an array of int values
	 * @param versionString
	 * @returns {Array}
	 */
	SCS.utils.getVersionNumberArray = function(versionString) {
		var versionValues = versionString && versionString.split('.') || [];
		for(var i = 0; i < versionValues.length; i += 1){
			versionValues[i] = parseInt(versionValues[i], 10);
		}

		return versionValues;
	};

	// FIXME: Remove once unused
	SCS.utils.formatString = __webpack_require__(35).format;

	/**
	 * Frontend caching system functions
	 *
	 * @namespace SCS.utils.cache
	 */
	SCS.utils.cache =  {
		/**
		 * This function caches given data to the browser localstorage and adds the
		 * timestamp that indicates untill the cached data are valid.
		 *
		 * @method cacheData
		 * @memberof SCS.utils.cache
		 * @param {JSON} data Data to be cached
		 * @param {String} dataId localstorage key under which the given data are
		 * stored
		 * @param {Number} validCachePeriod Time in milliseconds that indicates how
		 * long the cached data is considered to be valid.
		 * @returns void
		 */
		cacheData: function (data, dataId, validCachePeriod) {
			var storeData = {
				data: data,
				expireTime: (new Date()).getTime() + (validCachePeriod || 0)
			};
			localStorage.setItem(dataId, JSON.stringify(storeData));
		},
		/**
		 * This function returns cached data for the given key value. If data does
		 * not exists or cache timestamp is expired this function returns null.
		 *
		 * @method getCacheData
		 * @memberof SCS.utils.cache
		 * @param {String} dataId localstorage key under which the given data are
		 * stored
		 * @returns Cached data or null
		 */
		getCacheData: function (dataId) {
			var cachedData = localStorage.getItem(dataId);
			if(cachedData) {
				cachedData = JSON.parse(cachedData);
				if(cachedData.expireTime && (cachedData.expireTime - (new Date()).getTime()) >= 0) {
					return cachedData.data;
				} else {
					localStorage.removeItem(dataId);
				}
			}
			return null;
		}
	};
}(__webpack_provided_window_dot_$ || __webpack_provided_window_dot_Tc_dot_$, window.SCS = window.SCS || {}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(0)))

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["isIE11"] = isIE11;
/**
 * Detect Internet Explorer 11
 */
function isIE11() {
    return !!window.MSInputMethodContext && !!document.documentMode;
}


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["format"] = format;
/* harmony export (immutable) */ __webpack_exports__["truncate"] = truncate;
/* harmony export (immutable) */ __webpack_exports__["plainTextFromHtml"] = plainTextFromHtml;
/**
 * Replaces format string tokens like "{0} in {1}", which are often used in i18n.
 * @param subject - The string to format
 * @param args - the partial strings to fill into string
 * @returns String
 */
function format(subject) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return (subject || '').replace(/\{(\d+)\}/g, function (_str, i) {
        var result = args[parseInt(i, 10)];
        return typeof result === 'number' ? result : result || '';
    });
}
/**
 * Truncate a string to "roughly" the given length.
 * Appending an elipsis if sentence is not finished.
 * @param text - The string to truncate
 * @param length - Length of desired string
 * @returns String
 */
function truncate(text, length, elipsis, overshootAllowance) {
    if (elipsis === void 0) { elipsis = '…'; }
    if (overshootAllowance === void 0) { overshootAllowance = 3; }
    if (text && text.length > length + overshootAllowance) {
        // Shorten the lead text and ...
        text = text.substr(0, length)
            // Remove trailing partial word
            .replace(/\s+[^\s\.]+$/, '')
            // Remove trailing interpunction
            .replace(/\s*[(:;,_-]?\s*$/, '');
        // If sentence is not finished
        if (!text.match(/\.$/)) {
            text += elipsis || '';
        }
    }
    return text;
}
function plainTextFromHtml(text) {
    var dummyTag = document.createElement('div');
    dummyTag.innerHTML = text;
    return dummyTag.textContent;
}


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_$) {(function ($, SCS) {
	'use strict';

	/**
	 *  use by forms/components/form/capthca
	 *  defined Callback function for https://www.google.com/recaptcha/api.js
	 *  Synchronize call createCaptcha from Tc.Module.Captcha and google API
	 */
	SCS.captcha = SCS.captcha || {};

	$.extend(SCS.captcha, {

		onloadCaptchaCallback: function () {

			/*
			 * apply wrapper
			 *
			 * @param array parameterArray An array comprising either:
			 *      [ ctx, functionObject, optional_parameters ]
			 */
			function apply () {
				var parameterArray, f, ctx, form, ajaxCaptcha;

				if(arguments.length>0){
					parameterArray = arguments[0];
					ctx = parameterArray.shift();
					f = parameterArray.shift();
					f.apply(ctx, parameterArray);

					//detach ajaxCaptcha if exists, only one Captcha field is allow.
					form = ctx.$ctx.closest('form');
					if(form && form.length > 0){
						ajaxCaptcha = form.find('.modAjaxCaptcha');
						if(ajaxCaptcha && ajaxCaptcha.length >0){
							ajaxCaptcha.detach();
						}
					}

				}

			}

			if (SCS.captcha.captchaHandler && $.isArray(SCS.captcha.captchaHandler) && $('#captcha').length) {
				//SCS.captchaHandler with handlers

				for (var iterator = 0; iterator < SCS.captcha.captchaHandler.length; iterator++) {
					if (SCS.captcha.captchaHandler[iterator]) {
						apply(SCS.captcha.captchaHandler[iterator]);
					}
				}

			}

			function CaptchaHandlerProxy () {
				return {
					push: apply
				};
			}

			// replace initialization array with proxy object
			SCS.captcha.captchaHandler = new CaptchaHandlerProxy();

		}
	});

	// asynchronous (or proxy)
	if (!SCS.captcha.captchaHandler || typeof SCS.captcha.captchaHandler !== 'object') {
		SCS.captcha.captchaHandler = [];
	}

}(__webpack_provided_window_dot_$, window.SCS = window.SCS || {}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Module, $) {
	'use strict';

	/**
	 * Background Container
	 *
	 * @author Matthias Inauen
	 * @namespace Tc.Module
	 * @class BackgroundContainer
	 * @extends Tc.Module
	 */
	Module.BackgroundContainer = Module.extend({

		CHANNEL_INTERACTIVE_MODE: 'BCInteractiveMode',
		isEditMode: false,

		/**
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			this.isEditMode = window.CQ && window.CQ.WCM && window.CQ.WCM.isEditMode(true);
			this.interactiveMode = this.$ctx.hasClass('interactivemode');
			this.noDeactivate = this.$ctx.hasClass('no-deactivate');
			this.mobileGallery = this.$ctx.closest('.modMobileGallery');
			this.tabNavigationContent = this.$ctx.closest('.modTabNavigationContent');
			this.slideChangeHandlerFunction = this.handleCarouselSlideChanged.bind(this);

			if(this.interactiveMode) {
				this.sandbox.subscribe(this.CHANNEL_INTERACTIVE_MODE, this);
				this.interactiveElementName = this.$ctx.data('interactive-name');
				this.interactiveElementValue = this.$ctx.data('interactive-value');
			}

			this.tailBackgroundColor();

			callback();
		},

		after: function() {
			if(this.interactiveMode) {
				this.addEvents();
			}
		},

		/**
		 * Add Event Listeners
		 * @param skipNextSlideChangedEvent
		 */
		addEvents: function(skipNextSlideChangedEvent){
			this.$ctx.on('click', $.proxy(this.handleBackgroundClicked, this));
			// scCarouselSlideChanged triggers after an animation time passed. Sometimes you need to skip one event
			// but listen to the following events. (i.e. when onUpdateInteractiveState is called)
			if(skipNextSlideChangedEvent){
				this.mobileGallery.one('scCarouselSlideChanged', this.handleSkipNextEvent.bind(this));
			}
			else {
				this.handleSkipNextEvent();
			}
		},

		removeEvents: function() {
			this.$ctx.off('click');
			this.mobileGallery.off('scCarouselSlideChanged', this.slideChangeHandlerFunction);
		},

		handleSkipNextEvent: function() {
			this.mobileGallery.on('scCarouselSlideChanged', this.slideChangeHandlerFunction);
		},

		handleCarouselSlideChanged: function(event, carouselListItem) {
			if($.contains(carouselListItem[0], this.$ctx[0])) {
				this.interactiveStateActivate();
				this.broadcastInteractiveState();
			}
			else {
				this.interactiveStateDeactivate();
			}
		},

		handleBackgroundClicked: function(event){
			var currentTime = new Date().getTime();
			var $eventTarget = $(event.currentTarget);

			if (!$eventTarget.is(this.$ctx)) {
				return;
			}
			// prevent double-clicks
			if(this.lastClickTime && (currentTime - this.lastClickTime) < 100) {
				return;
			}

			this.lastClickTime = currentTime;

			if (this.isActive) {
				this.interactiveStateDeactivate(true);
			} else {
				this.interactiveStateActivate();
				this.broadcastInteractiveState();
			}
		},

		interactiveStateActivate: function () {
			if (this.isActive) {
				return;
			}

			this.isActive = true;
			this.$ctx.addClass('active');
		},

		updateTabNavigation: function() {
			this.tabNavigationContent.triggerHandler('activate');
		},

		updateMobileCarousel: function(){
			this.mobileGallery.trigger('scCarouselSlideToElement', [this.$ctx]);
		},

		broadcastInteractiveState: function() {
			this.fire('interactiveStateChanged', {
				name: this.interactiveElementName,
				value: this.interactiveElementValue
			}, [this.CHANNEL_INTERACTIVE_MODE]);
		},

		interactiveStateDeactivate: function (userInteraction) {
			if(userInteraction && this.noDeactivate) {
				return;
			}

			this.isActive = false;
			this.$ctx.removeClass('active');
		},

		onUpdateInteractiveState: function (data) {
			if(data.name !== this.interactiveElementName) {
				return;
			}

			if(data.value === this.interactiveElementValue) {
				this.removeEvents();
				this.interactiveStateActivate();
				this.updateTabNavigation();
				this.updateMobileCarousel();
				this.addEvents(true);
			} else {
				this.interactiveStateDeactivate();
			}
		},

		tailBackgroundColor: function() {
			var $backgroundColor = this.$ctx.css('backgroundColor');
			var $tail = this.$ctx.find('.tail');

			$tail.css('borderColor', $backgroundColor);
		}
	});
}(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Sandbox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Module__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_string__ = __webpack_require__(7);


var Sandbox = /** @class */ (function () {
    /**
     * Initializes the Sandbox.
     *
     * @method init
     * @constructor
     * @param {Applicaton} application
     *      The application reference
     * @param {Object} config
     *      The configuration
     */
    function Sandbox(application, config) {
        this.hooks = {
            after: [],
            end: [],
        };
        this.doneAfterHooks = 0;
        this.application = application;
        this.config = config;
    }
    /**
     * Adds (register and start) all modules in the given context scope.
     *
     * @method addModules
     * @param {jQuery} $ctx
     *      The jQuery context
     * @return {Array}
     *      A list containing the references of the registered modules
     */
    Sandbox.prototype.addModules = function ($ctx) {
        var modules = [];
        var application = this.application;
        if ($ctx) {
            // Register modules
            modules = application.registerModules($ctx);
            // Start modules
            application.start(modules);
        }
        return modules;
    };
    /**
     * Removes a module by module instances.
     * This stops and unregisters a module through a module instance.
     *
     * @method removeModules
     * @param {mixed} modules
     *      A list containing the module instances to remove or the jQuery context to look for registered modules in.
     */
    Sandbox.prototype.removeModules = function (modules) {
        var _this = this;
        var application = this.application;
        if (!$.isArray(modules)) {
            var $ctx = modules;
            // Get modules
            var tmpModules_1 = [];
            var $candidates = $ctx.find('.mod').add($ctx.hasClass('mod') ? $ctx : $());
            $candidates.each(function (_, elem) {
                // Check for instance
                // Modified by Raphael Schweikert (taascraa): add ability to have multiple modules on a single element
                var ids = $(elem).data('terrific-ids') || {};
                for (var modName in ids) {
                    var module = _this.getModuleById(ids[modName]);
                    if (module) {
                        tmpModules_1.push(module);
                    }
                }
            });
            modules = tmpModules_1;
        }
        if (modules) {
            // Stop modules
            application.stop(modules);
            // Unregister modules
            application.unregisterModules(modules);
        }
    };
    /**
     * Subscribes a module to a connector.
     *
     * @method subscribe
     * @param {String} connector The full connector name (e.g. MasterSlave-Navigation)
     * @param {Module} module The module instance
     */
    Sandbox.prototype.subscribe = function (connector, module) {
        // Explicitly cast connector to string (e.g. to handle 0 case)
        connector = String(connector);
        // Guards
        if (!module || !connector) {
            throw new Error('subscribe is expecting 2 parameters (connector, module)');
        }
        if (!(module instanceof __WEBPACK_IMPORTED_MODULE_0__Module__["a" /* Module */])) {
            throw new Error('the module param must be an instance of Tc.Module');
        }
        this.application.registerConnection(connector, module);
    };
    /**
     * Unsubscribes a module from a connector.
     *
     * @method unsubscribe
     * @param {String} connectorId The connector channel id (e.g. 2 or Navigation)
     * @param {Module} module The module instance
     */
    Sandbox.prototype.unsubscribe = function (connectorId, module) {
        if (module instanceof __WEBPACK_IMPORTED_MODULE_0__Module__["a" /* Module */] && connectorId) {
            // Explicitly cast connector id to string
            this.application.unregisterConnection(String(connectorId), module);
        }
    };
    /**
     * Gets the appropriate module for the given ID.
     *
     * @method getModuleById
     * @param {int} id
     *      The module ID
     * @return {Module}
     *      The appropriate module
     */
    Sandbox.prototype.getModuleById = function (id) {
        var application = this.application;
        if (application.modules[id]) {
            return application.modules[id];
        }
        throw new Error("the module with the id " + id + " does not exist");
    };
    /**
     * Gets the appropriate module for the given DOM element
     *
     * @method getModuleInstance
     * @param {HTMLElement} element
     *      The module DOM element
     * @param {String} [modName]
     *      The module name (relevant if multiple Modules are defined on the same DOM element)
     *      Schema: Classname without "Tc.Module." - eg. "BrightcoveVideo"
     * @return {Module}
     *      The appropriate module
     */
    // Added by Swisscom (Dave Talamona, tzhtada2):
    // Prevent modules from using other modules internal "terrific-ids" for getting their module instance
    Sandbox.prototype.getModuleInstance = function (element, moduleName) {
        var application = this.application;
        var ids = $(element).data('terrific-ids') || {};
        var id;
        if (moduleName) {
            var modName = moduleName;
            if (modName.indexOf('-') > -1) {
                modName = Object(__WEBPACK_IMPORTED_MODULE_1__utils_string__["b" /* toCamel */])(modName);
            }
            modName = modName.substr(0, 1).toUpperCase() + modName.substr(1);
            if (!(modName in ids)) {
                return null;
            }
            id = ids[modName];
        }
        else {
            // If no modName is given, return the first module found
            for (var name in ids) {
                id = ids[name];
                break;
            }
        }
        if (id === undefined) {
            return null;
        }
        return application.modules[id] || null;
    };
    /**
     * Gets all modules for the given DOM element
     *
     * @method getModuleInstances
     * @param {HTMLElement} element
     *      The module DOM element
     * @return {Module}[]
     *      The appropriate modules
     */
    // Added by Swisscom (Raphael Schweikert, taascraa)
    Sandbox.prototype.getModuleInstances = function (element) {
        var ids = $(element).data('terrific-ids') || {};
        var results = [];
        for (var modName in ids) {
            var module = this.getModuleInstance(element, modName);
            if (module) {
                results.push(module);
            }
        }
        return results;
    };
    /**
     * Gets the application config.
     *
     * @method getConfig
     * @return {Object}
     *      The configuration object
     */
    Sandbox.prototype.getConfig = function () {
        return this.config;
    };
    /**
     * Gets an application config param.
     *
     * @method getConfigParam
     * @param {String} name
     *      The param name
     * @return {mixed}
     *      The appropriate configuration param
     */
    Sandbox.prototype.getConfigParam = function (name) {
        var config = this.config;
        if (config[name] !== undefined) {
            return config[name];
        }
        throw new Error("the config param " + name + " does not exist");
    };
    Sandbox.prototype.addCallback = function (phase, callback) {
        if (typeof phase === 'function') {
            // Only 1 param
            callback = phase;
            phase = 'end';
        }
        if (!callback) {
            return;
        }
        var callbacks = this.hooks[phase];
        callbacks.push(callback);
    };
    /**
     * Collects the module status messages and handles the callbacks.
     * This means that it is ready for the 'after' hook.
     *
     * @method ready
     * @param {Function} callback
     *      The 'after' hook module callback
     */
    Sandbox.prototype.ready = function (callback) {
        var afterHooks = this.hooks.after;
        // Add the callback to the stack
        afterHooks.push(callback);
        // Check whether all modules are ready for the 'after' hook
        if (this.application.modules.length !== (afterHooks.length + this.doneAfterHooks)) {
            return;
        }
        for (var i = 0; i < afterHooks.length; i++) {
            // Make sure the callback is only executed once (and is not called during addModules)
            var afterCallback = afterHooks.splice(i, 1)[0];
            i--;
            afterCallback();
            this.doneAfterHooks++;
        }
        // Execute the end hooks
        var endHooks = this.hooks.end;
        for (var _i = 0, endHooks_1 = endHooks; _i < endHooks_1.length; _i++) {
            var hook = endHooks_1[_i];
            hook();
        }
    };
    return Sandbox;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, SCS) {
	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.7 or greater,
	 */

	'use strict';
	/*globals Tc */

	/**
	 * Captcha module implementation.
	 *
	 * @author Dimitri Sebeschuk
	 * @namespace Tc.Module
	 * @class Captcha
	 * @extends Tc.Module
	 */
	Tc.Module.Captcha = Tc.Module.extend({


		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			SCS.captcha = SCS.captcha || {};

			if (!SCS.captcha.captchaHandler || typeof SCS.captcha.captchaHandler !== 'object') {
				SCS.captcha.captchaHandler = [];
			}

			SCS.captcha.captchaHandler.push([this, this.createCaptcha]);

			callback();
		},


		createCaptcha: function () {
			var mod = this,
				sitekey = mod.$ctx.data('sitekey'),
				theme = mod.$ctx.data('theme'),
				id = 'captchaContainer_' + mod.$ctx.data('uid');

			if (typeof grecaptcha === 'undefined') {
				//Show Exception
				debug.log('Tc.Module.Captcha -> createCaptcha: grecaptcha is not exists!');
				return;
			}

			grecaptcha.render(id, {
				'sitekey': sitekey,
				'theme': theme
			});

		}


	});

}(Tc.$, window.SCS));

}.call(window));

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

var imageLoaded = __webpack_require__(3).imageLoaded;

/**
 * User: konstantin
 * Date: 4/8/14
 */
(function ($) {
	'use strict';
	/*globals Tc, scent*/
	/*jshint smarttabs:false */

	Tc.Module.ImagesSlider = Tc.Module.extend({
		config: {
			fullWidthWrapperClass: '.fullwidthwrapper',
			normalWidthWrapperClass: '.normalwidthwrapper',
			imagefullwidthClass: '.imagefullwidth',
			slider: '.slider',
			slide: '.slidesjs-slide',
			image: '.slider img',
			prevLinkClass: '.sjs-prev',
			nextLinkClass: '.sjs-next',
			bildlegendeSpan: '.bildlegende > span',
			bildlegendeClass: '.bildlegende',
			facebookShare: 'a.facebook',
			twitterShare: 'a.twitter',
			mail: 'a.mail'
		},

		on: function (callback) {
			var mod = this,
				$ctx = mod.$ctx;

			setTimeout(function() {
				mod.checkWidth(0);
				mod.initSlider();
				mod.sliderButtons();
				mod.initCaptionText();
				mod.centerCaptionText();
				mod.captionHovering();
				mod.centerImages();
			}, 200);

			$(window).resize(function () {
				setTimeout(function() {
					mod.checkWidth(0);
					mod.initCaptionText();
					mod.centerCaptionText();
					mod.centerImages();
				}, 200);
			});


			Promise.all(mod.$ctx.find('img').get().map(imageLoaded)).then(function() {
				setTimeout(function () {
					mod.checkWidth(0);
					mod.initCaptionText();
					mod.centerCaptionText();
					mod.centerImages();
				}, 200);
			});

			mod.shareImages();

			callback();
		},
		centerImages: function () {
			var mod = this,
				$ctx = mod.$ctx,
				config = mod.config;

			var maxHeight = mod.getSlideMaxHeight();
			if(scent.global.isMobile()) {
				maxHeight = maxHeight + mod.getCaptionMaxHeight();
			}

			$(config.normalWidthWrapperClass, $ctx).css({height: maxHeight});
			$('.normalwidthwrapper .imagefullwidth', $ctx).height($(config.normalWidthWrapperClass, $ctx).height());

			$(config.fullWidthWrapperClass, $ctx).css({height: maxHeight});
			$(config.imagefullwidthClass, $ctx).css({height: maxHeight});
			$('.slidesjs-container', $ctx).css({height: maxHeight});
			$('.slidesjs-control', $ctx).css({height: maxHeight});

			$(config.fullWidthWrapperClass + ' ' + config.slider, $ctx).height($(config.fullWidthWrapperClass, $ctx).height());

			$(config.slide, $ctx).css({height: maxHeight});

			$(config.image, $ctx).each(function () {
				var $this = $(this);

				if($this.width() > $this.parent().width()){
					$this.css({'float': 'left', 'width': '100%'});
				}

				var height = $this.height();
				if(scent.global.isMobile()) {
					height = height + mod.getCaptionMaxHeight();
				}
				var heightHalf = -1 * Math.round(height / 2);
				$this.css({'margin-top': heightHalf + 'px'});
			});
		},

		shareImages: function () {
			var mod = this,
				$ctx = mod.$ctx,
				config = mod.config;

			$ctx.on('click', config.facebookShare, function () {
				var $this = $(this);
				mod.shareImage('http://www.facebook.com/share.php?u=' + $this.closest(config.slide).find('img').prop('src') + '&amp;title=' + $this.parent().data('share-text'));
				return false;
			});
			$ctx.on('click', config.twitterShare, function () {
				var $this = $(this);
				mod.shareImage('http://twitter.com/home?status=' + $this.parent().data('share-text') + '+' + $this.closest(config.slide).find('img').attr('src'));
				return false;
			});
			$ctx.on('click', config.mail, function () {
				var $this = $(this);
				document.location.href = 'mailto:?body=' + $this.closest(config.slide).find('img').attr('src') + '&subject=' + $this.data('share-text').replace(/&/g, '%26');
				return false;
			});
		},

		shareImage: function (url) {
			var w = 500;
			var h = 500;
			var left = (screen.width/2)-(w/2);
			var top = (screen.height/2)-(h/2);

			window.open(url,"_blank", "toolbar=no, location=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=" + w + ", height=" + h + ", top=" + top + ", left=" + left);
		},

		initSlider: function () {
			var mod = this;
			var $ctx = mod.$ctx;
			var config = mod.config;

			// do not init slidesjs if only one image because of a known bug in the plugin
			// see https://groups.google.com/forum/#!msg/slidesjs/Q61KaOBzV4w/J_moJx0TxnMJ

			if (!mod.oneImage()) {

				if(scent.global.isMobile()) {
					$('.fullwidthwrapper', $ctx).height(($(config.fullWidthWrapperClass + ' .imagefullwidth img', $ctx).height() + mod.getCaptionMaxHeight()));

					$(config.fullWidthWrapperClass + ' ' + config.slider, $ctx).slidesjs({
						width: $(window).width(),
						height: ($(config.fullWidthWrapperClass + ' .imagefullwidth img', $ctx).height() + mod.getCaptionMaxHeight()),
						navigation: {
							active: false,
							effect: "slide"
						},
						pagination: {
							active: false
						}
					});
				} else {
					$(config.fullWidthWrapperClass + ' ' + config.slider, $ctx).slidesjs({
						width: $(window).width(),
						height: ($(config.fullWidthWrapperClass, $ctx).height() + mod.getCaptionMaxHeight()),
						navigation: {
							active: false,
							effect: "slide"
						},
						pagination: {
							active: false
						}
					});
				}

				$(config.normalWidthWrapperClass + ' ' + config.slider, $ctx).slidesjs({
					width: 100,
					height: $(config.normalWidthWrapperClass, $ctx).height(),
					navigation: {
						active: false,
						effect: "slide"
					},
					pagination: {
						active: false
					}
				});

			}

			$('.normalwidthwrapper .imagefullwidth', $ctx).height($(config.normalWidthWrapperClass, $ctx).height());

		},

		sliderButtons: function () {
			var mod = this;
			var $ctx = mod.$ctx;
			var config = mod.config;

			if (!mod.oneImage()) {
				var sjs = $(config.slider, $ctx).data('plugin_slidesjs');
				$(config.nextLinkClass, $ctx).click(function (clickevent) {
					clickevent.preventDefault();
					sjs.next();
				});
				$(config.prevLinkClass, $ctx).click(function (clickevent) {
					clickevent.preventDefault();
					sjs.previous();
				});
			} else {
				$(config.nextLinkClass, $ctx).hide();
				$(config.prevLinkClass, $ctx).hide();
				$(config.bildlegendeSpan, $ctx).css('padding','10px');
				$(config.fullWidthWrapperClass + ' ' + config.bildlegendeSpan, $ctx).css('width','515px');
			}
		},
		initCaptionText: function () {
			var mod = this;
			var $ctx = mod.$ctx;
			var config = mod.config;

			$(config.slider + ' p.bildlegende', $ctx).each(function () {
				$(this).height(mod.getCaptionMaxHeight());
			});

		},

		captionHovering: function () {
			var mod = this;
			var $ctx = mod.$ctx;
			var config = mod.config;

			$(config.slider, $ctx).hover(
				function () {
					if (!scent.global.isMobile()) {
						$ctx.find('p.bildlegende').animate({
							height: mod.getCaptionMaxHeight()
						}, 500);
					}
				},
				function () {
					if (!scent.global.isMobile()) {
						$ctx.find('p.bildlegende').animate({
							height: 0
						}, 500);
					}
				}
			);
		},

		centerCaptionText: function () {
			var mod = this;
			var $ctx = mod.$ctx;
			var config = mod.config;

			$(config.slider + ' p.bildlegende', $ctx).each(function () {
				$(this).height(mod.getCaptionMaxHeight());
			});
		},

		checkWidth: function (index) {
			var mod = this;
			var $ctx = this.$ctx;
			var config = this.config;

			if (scent.global.isMobile()) {
				$(config.bildlegendeClass, $ctx).removeAttr('style');

				var heightNormal = $('.normalwidthwrapper > .imagefullwidth div[slidesjs-index='+index+'] img', $ctx).height();
				if(heightNormal == null){
					heightNormal = $('.normalwidthwrapper > .imagefullwidth img', $ctx).height();
				}

				if(heightNormal != null){
					$(config.normalWidthWrapperClass, $ctx).css({height: (heightNormal + $('.normalwidthwrapper > .imagefullwidth div[slidesjs-index='+index+'] p.bildlegende', $ctx).height())});
					$('.normalwidthwrapper .imagefullwidth', $ctx).height($(config.normalWidthWrapperClass, $ctx).height());
					$('.slidesjs-container', $ctx).css({height: $(config.normalWidthWrapperClass, $ctx).height()});
					$('.slidesjs-control', $ctx).css({height: $(config.normalWidthWrapperClass, $ctx).height()});
				}

				var heightFull = $('.fullwidthwrapper > .imagefullwidth div[slidesjs-index='+index+'] img', $ctx).height();
				if(heightFull == null){
					heightFull = $('.fullwidthwrapper > .imagefullwidth img', $ctx).height();
				}

				if(heightFull != null){
					$(config.fullWidthWrapperClass, $ctx).css({height: heightFull + $('.fullwidthwrapper > .imagefullwidth div[slidesjs-index='+index+'] p.bildlegende', $ctx).height()});

					$(config.fullWidthWrapperClass + ' ' + config.slider, $ctx).height($(config.fullWidthWrapperClass, $ctx).height());
					$(config.fullWidthWrapperClass + ' .slidesjs-container', $ctx).height($(config.fullWidthWrapperClass, $ctx).height());
					$(config.fullWidthWrapperClass + ' .slidesjs-control', $ctx).height($(config.fullWidthWrapperClass, $ctx).height());
				}

			} else {
				var heightNormal = $('.normalwidthwrapper > .imagefullwidth div[slidesjs-index='+index+'] img', $ctx).height();
				if(heightNormal == null){
					heightNormal = $('.normalwidthwrapper > .imagefullwidth img', $ctx).height();
				}

				if(heightNormal != null){
					$(config.normalWidthWrapperClass, $ctx).css({height: heightNormal});
					$('.normalwidthwrapper .imagefullwidth', $ctx).height($(config.normalWidthWrapperClass, $ctx).height());
				}

				var heightFull = $('.fullwidthwrapper > .imagefullwidth div[slidesjs-index='+index+'] img', $ctx).height();
				if(heightFull == null){
					heightFull = $('.fullwidthwrapper > .imagefullwidth img', $ctx).height();
				}

				if(heightFull != null){
					$(config.fullWidthWrapperClass, $ctx).css({height: heightFull});
					$(config.imagefullwidthClass, $ctx).css({height: heightFull});
					$('.slidesjs-container', $ctx).css({height: heightFull});
					$('.slidesjs-control', $ctx).css({height: heightFull});
				}

				$(config.fullWidthWrapperClass + ' ' + config.slider, $ctx).height($(config.fullWidthWrapperClass, $ctx).height());
			}
		},

		getCaptionMaxHeight: function () {
			var mod = this;
			var $ctx = mod.$ctx;
			var config = mod.config;

			var maxheight = 55;

			$(config.slider + ' p.bildlegende span', $ctx).each(function () {
				var height = $(this).outerHeight();
				if (height > maxheight) {
					maxheight = height;
				}
			});
			if($ctx.data('share-enabled')){
				if(scent.global.isMobile()) {
					maxheight = maxheight + 43;
				} else {
					maxheight = maxheight + 20;
				}
			}

			return maxheight;
		},

		getSlideMaxHeight: function() {
			var mod = this;
			var $ctx = mod.$ctx;
			var config = mod.config;

			var maxheight = -1;

			$(config.image, $ctx).each(function () {
				var $this = $(this);

				var heightReal = $this.height();
				$this.css({'width': '100%'});
				var height100 = $this.height();

				var height = height100;
				if(height100 > heightReal){
					height = heightReal;
				}

				if (height > maxheight) {
					maxheight = height;
				}

				$this.css({'width': 'auto'});
			});

			return mod.oneImage() ? $(this).height() : maxheight;
		},

		oneImage: function () {
			return $(this.config.slider + " img", this.$ctx).length < 2;
		}

	});
}(Tc.$));

}.call(window));

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

/**
 * User: marc
 */
(function ($) {
    "use strict";

    Tc.Module.Linklist = Tc.Module.extend({

        config: {},

        on: function (callback) {
            var mod = this;

            mod.handleDropdownSelect();

            callback();
        },

        handleDropdownSelect: function () {
            var $ctx = this.$ctx;
            $('#archiveddl', $ctx).change(function (e) {
                window.location = $(this).val();
            });
        }

    });
}(Tc.$));
}.call(window));

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

/**
 * User: risto
 * Date: 4/8/14
 */
(function ($) {
    "use strict";
    /*globals Tc, doT, SCS, debug */
    /*jshint smarttabs:false */

    Tc.Module.Newsitem = Tc.Module.extend({

        on: function (callback) {

            var mod = this,
                $ctx = mod.$ctx;

            $('.js-side .textbox', $ctx).hover(
                function () {
                    var imgWidth = $ctx.find('img').width();
                    var width = Math.min(180, imgWidth);
                    if (!scent.global.isMobile()) {
                        $(this).animate({
                            marginLeft: "-=" + width + "px",
                            width: "+=" + width + "px"
                        }, 500);
                        $(this).find('div.lauftext').fadeIn();
                    }
                },
                function () {
                    if (!scent.global.isMobile()) {
                        var imgWidth = $ctx.find('img').width();
                        var width = Math.min(180, imgWidth);
                        $(this).animate({
                            marginLeft: "+=" + width + "px",
                            width: "-=" + width + "px"
                        }, 500);
                        $(this).find('div.lauftext').fadeOut();
                    }
                }
            );

            $('.js-bottom .textbox', $ctx).hover(
                function () {
                    var imgHeight = $ctx.find('img').height();
                    var height = Math.min(180, imgHeight);
                    if (!scent.global.isMobile()) {
                        $(this).stop().animate({
                            marginTop: "-" + (height + 5) + "px",
                            height: (height + 140) + "px"
                        }, 500);
                        $(this).find('div.lauftext').fadeIn();
                    }
                    $('.js-bottom .textbox .content h2').trigger("update");
                },
                function () {
                    var imgHeight = $ctx.find('img').height();
                    var height = Math.min(180, imgHeight);
                    if (!scent.global.isMobile()) {
                        $(this).stop().animate({
                            marginTop: "-" + 5 + "px",
                            height: 140 + "px"
                        }, 500, function () {
                            $(this).clearQueue()
                        });
                        $(this).find('div.lauftext').fadeOut();
                    }
                    $('.js-bottom .textbox .content h2').trigger("update");
                }
            );

    		callback();
        }
    });
}(Tc.$));

}.call(window));

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($) {
	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.7 or greater,
	 */

	'use strict';
	/*globals Tc */

	/**
	 * FileUpload module implementation copied from forms/ui
	 *
	 * @author Renaldas Szentiks
	 * @namespace Tc.Module
	 * @class FileUpload
	 * @extends Tc.Module
	 */
	Tc.Module.FileUpload = Tc.Module.extend({
		/**
		 * Initializes the module.
		 *
		 * @method init
		 * @constructor
		 * @param {jQuery} $ctx the jquery context
		 * @param {Sandbox} sandbox the sandbox to get the resources from
		 * @param {String} modId the unique module id
		 */
		init: function ($ctx, sandbox, modId) {
			this._super($ctx, sandbox, modId);
			this.fileList = $('.fileList', this.$ctx);
			this.name = this.getUploadField().data('name');
			this.url = this.$ctx.data('url');
			this.SizeCalculator.init(this.$ctx.data('size-limit'), this.$ctx.data('file-size-limit'));
			this.generateLinks = this.$ctx.data('generate-links') === true || this.$ctx.data('generate-links') === 'true';
			this.actionProvider = this.$ctx.data('action-provider');
		},

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			this.sandbox.subscribe('randomFormToken', this);
			this.getUploadField().on('change', $.proxy(this.changeHandler, this));
			this.getUploadField().on('prefill', $.proxy(this.prefillHandler, this));
			this.getUploadField().on('resetFiles', $.proxy(this.removeAllFilesHandler, this));
			this.populateUploadedFiles();
			callback();
		},

		after: function () {
			this.generateRandomFormToken();
		},

		populateUploadedFiles: function() {

			var mod = this,
				$ctx = mod.$ctx;

			var json = $ctx.data('uploaded-attachment-info-json');
			if (json.length > 0) {
				for (var i in json) {
					var data = json[i];
					mod.appendFileEntry(data);
				}
			}
		},

		generateRandomFormToken: function () {
			if (this.$ctx.data('random-token')) {
				this.randomFormToken = this.$ctx.data('random-token');
			}
			else {
				this.randomFormToken = Math.round(Math.random() * 100000) + '' + new Date().getTime();
			}
			var formTokenFieldGen = $('<input>').attr('type', 'hidden').attr('name', 'randomToken').val(this.randomFormToken);
			this.$ctx.closest('form').attr('novalidate', true).append(formTokenFieldGen);
		},

		getName: function () {
			return this.name;
		},

		getUrl: function () {
			return this.url;
		},

		getUploadField: function () {
			return $('input[type="file"]', this.$ctx);
		},

		showDialog: function (title, text) {
			$('<div/>').attr('title', title).append(text).dialog();
		},

		changeHandler: function (event) {
			if (event) {
				event.preventDefault();
			}
			if (this.getUploadField().val()) {
				this.uploadFile(this.getUploadField());
			}
		},

		prefillHandler: function (event, data) {
			if (data) {
				if (data.items instanceof Array) { // array of attachments
					for (var i = 0; i < data.items.length; i++) {
						this.appendFileEntry(data.items[i]);
					}
				} else { // single attachment
					this.appendFileEntry(data);
				}
			}
		},

		uploadResponseHandler: function (response) {
			if (response.success === true || response.success === 'true') {
				this.appendFileEntry(response.item);
			} else {
				if (response.errorMessage) { // unknown error
					this.showDialog('Error', response.errorMessage);
				} else if (response.errorCode === '1' || response.errorCode === 1) { // file size too big
					this.showDialog('Error', this.$ctx.data('error-file-size-limit').replace('{0}', this.formatSize(this.SizeCalculator.getFileSizeLimit())));
				}
			}
		},

		appendFileEntry: function (data) {
			/* Creates the following markup:
				<div>
				<a class="fileDescription" href="..." target="_blank"> or <span class="fileDescription">
				<span class="text">{file name}</span>
				<span class="size">({size})</span>
				</a> or </span>
				<span class="remove-icon"></span>
				<input type="hidden" data-type="file" name="{input field name}" value="{file id}"/>
				</div>
				*/
			if (data && typeof data.uuid !== 'undefined') {
				var sizeStatus = this.SizeCalculator.add(data.size);
				if (sizeStatus.ok && sizeStatus.fileOk) {
					var name = data.fileName ? data.fileName : data.uuid,
						listEntry = $('<div/>'),
						fileLink = $('<a>').addClass('fileDescription').attr('href', this.getUrl() + '?uuid=' + data.uuid).attr('target', '_blank'),
						linkText = $('<span>').attr('class', 'text').text(name),
						sizeValue = $('<span>').attr('class', 'size').text('(' + this.formatSize(data.size) + ')'),
						removeIcon = $('<span>').attr('class', 'remove-icon'),
						hiddenField = $('<input>').attr('type', 'hidden').attr('name', this.getName());
					if (!this.generateLinks) {
						fileLink = $('<span>').addClass('fileDescription');
					}

					removeIcon.on('click', { uuid: data.uuid, entry: listEntry }, $.proxy(this.removeFileHandler, this));
					hiddenField.val(data.uuid);
					hiddenField.data('type', 'file'); // required to mark this field for the summary

					this.fileList.append(listEntry.append(fileLink.append(linkText).append(sizeValue)).append(removeIcon).append(hiddenField));
				} else {
					this.SizeCalculator.remove(data.size);
					if (!sizeStatus.ok) {
						this.showDialog('Error', this.$ctx.data('error-size-limit').replace('{0}', this.formatSize(this.SizeCalculator.getSizeLimit())));
					} else {
						this.showDialog('Error', this.$ctx.data('error-file-size-limit').replace('{0}', this.formatSize(this.SizeCalculator.getFileSizeLimit())));
					}
				}
			}
		},

		formatSize: function (size) {
			if (size) {
				size = parseInt(size);
				if (!isNaN(size) && size > 1024) {
					var suffix = 'kB';
					size = size / 1024;
					if (size >= 1024) {
						size = size / 1024;
						suffix = 'mB';
					}
					size = Math.round(size * 10) / 10;
					return size + suffix;
				} else {
					return '1kB';
				}
			}
			return '0kB';
		},

		removeAllFilesHandler: function() {
			this.fileList.empty();
		},

		removeFileHandler: function (event) {
			if (event) {
				event.preventDefault();
			}
			var $this = this,
				uuid = event.data.uuid,
				listEntry = event.data.entry;

			listEntry.remove();

			// response does not matter, since the hidden parameter is already
			// removed ant the attachment won't be connected to the form anymore
			$.ajax({
				type: 'POST',
				url: $this.getUrl(),
				cache: false,
				data: {
					uuid: uuid,
					randomToken: $this.randomFormToken
				}
			});
		},

		getFrameName: function () {
			return 'UploadFrame' + this.getName();
		},

		uploadFile: function (field) {
			this.prepareField(field);

			// create iframe:
			if (this.frame) {
				this.frame.remove();
				this.frame = null;
			}
			this.frame = $('<iframe id="' + this.getFrameName() + '" name="' + this.getFrameName() + '" style="display: none">');
			$('body').append(this.frame);
			this.frame.on('load', $.proxy(this.loadHandler, this));

			var inputFieldName = $('<input>').attr('type', 'hidden').attr('name', 'fieldName').val(this.getName()),
				formTokenField = $('<input>').attr('type', 'hidden').attr('name', 'randomToken').val(this.randomFormToken),
				actionProviderField = $('<input>').attr('type', 'hidden').attr('name', 'actionProvider').val(this.actionProvider),
				charsetField = $('<input>').attr('type', 'hidden').attr('name', '_charset_').val('UTF-8'),
				formPathField = $('<input>').attr('type', 'hidden').attr('name', 'formPath').val(this.getFormParameter(':formstart'));

			// create form:
			if (this.form) {
				this.form.remove();
				this.form = null;
			}
			this.form = $('<form method="post" action="' + this.getUrl() + '" enctype="multipart/form-data" target="' + this.getFrameName() + '" style="display: none">');
			this.form.append(field);
			if (!this.form.html()) { // for IE8 and lower
				this.form = $('<form>').attr('method', 'post').attr('action', this.getUrl()).attr('enctype', 'multipart/form-data').attr('target', this.getFrameName()).attr('style', 'display: none');
				this.form.append(field);
			}
			this.form.append(inputFieldName).append(formTokenField).append(actionProviderField).append(formPathField).append(charsetField);

			$('body').append(this.form);

			this.form.submit();
		},

		getFormParameter: function(parameterName) {
			if (!this.currentForm) {
				this.currentForm = this.$ctx.parents('form');
			}
			return $('input[name="' + parameterName + '"]', this.currentForm).val();
		},

		prepareField: function (field) {
			this.originalFieldName = field.attr('name');
			if (!this.originalFieldPlaceholder) {
				this.originalFieldPlaceholder = $('<span style="display: none"/>');
				this.originalFieldPlaceholder.insertBefore(field);
			}
			this.originalField = field.attr('name', 'file').detach();
			this.showLoadingIndicator();
		},

		resetField: function () {
			this.originalField.attr('name', this.originalFieldName);
			this.showLoadingIndicator(false);
			this.originalField.clone(true).insertAfter(this.originalFieldPlaceholder);
		},

		showLoadingIndicator: function (show) {
			if (!this.loadingIndicator) {
				this.loadingIndicator = $('.js-loading-indicator', this.$ctx);
			}
			if (show === false) {
				this.loadingIndicator.hide();
			} else {
				this.loadingIndicator.show();
			}

		},

		loadHandler: function () {
			this.resetField();
			var content = this.frame.contents().find('#content');
			if (content.length > 0) {
				this.uploadResponseHandler(content.data('response'));
			}
		},

		/**
		 * Singleton for size limit for attachments in the whole form/page
		 */
		SizeCalculator: {
			init: function (limit, fileLimit) {
				if (!this.initialized) {
					this.initialized = true;
					this.sizeLimit = limit;
					if (!this.sizeLimit) {
						this.sizeLimit = -1;
					}
					this.fileSizeLimit = fileLimit;
					if (!this.fileSizeLimit) {
						this.fileSizeLimit = -1;
					}
					this.size = 0;
				}
			},

			getSizeLimit: function () {
				return this.sizeLimit;
			},

			getFileSizeLimit: function () {
				return this.fileSizeLimit;
			},

			add: function (size) {
				this.size += size;
				if (this.fileSizeLimit >= 0 && this.fileSizeLimit < size) {
					return this.getStatus(false, size - this.fileSizeLimit);
				}
				return this.getStatus();
			},

			remove: function (size) {
				this.size -= size;
				return this.getStatus();
			},

			getStatus: function (fileSizeStatusOk, fileOverhead) {
				var overhead = this.size - this.sizeLimit;
				fileOverhead = typeof fileOverhead === 'undefined' ? 0 : fileOverhead;
				fileSizeStatusOk = fileSizeStatusOk !== false ? true : false;
				if (this.sizeLimit >= 0 && overhead > 0) {
					return {
						ok: false,
						fileOk: fileSizeStatusOk,
						overhead: overhead,
						fileOverhead: fileOverhead
					};
				}
				return {
					ok: true,
					fileOk: fileSizeStatusOk,
					overhead: 0,
					fileOverhead: fileOverhead
				};
			}
		}
	});
}(Tc.$));
}.call(window));

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($) {
	var socialMedia = __webpack_require__(13).getController();
	var encodeCount = __webpack_require__(13).encodeCount;


	'use strict';
	/*globals Tc, debug */

	/**
	 * Social Share Button Implementation
	 *
	 * @author Matthias Inauen, Marc Althoff
	 * @namespace Tc.Module
	 * @class SocialShare
	 * @extends Tc.Module
	 */
	Tc.Module.SocialShare = Tc.Module.extend({
		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this;
			mod.displayAggregatedShareCount = mod.$ctx.hasClass('skinSocialShareTeaser') ? true : false;
			mod.displayShareCount = mod.$ctx.hasClass('showShareCount');
			mod.attachEvents();

			// init share count if enabled on the module
			if (mod.displayShareCount) {
				if (mod.displayAggregatedShareCount) {
					// init aggregated share count on the teaser
					mod.initAggregatedShareCountBadges();
				} else {
					// init individual button share count on a series of buttons
					mod.initButtonShareCountBadges();
				}
			}

			callback();
		},

		/**
		 * Returns a list of active social media services in this module
		 *
		 * @method getActiveServices
		 * @returns {Array}
		 */
		getActiveServices: function () {
			var mod = this,
				services = [],
				service;
			// run through all share-buttons. Stored on the <a> descendant
			// is a data property called service, which contains the name of the
			// service this button represents.
			mod.$ctx.find('.share-button').each(function () {
				service = $(this).find('> a').data('service');
				if (service) {
					services.push(service);
				}
			});

			return services;
		},

		/**
		 * Attach click events to buttons:
		 * Show popups instead of direct links
		 *
		 * @method attachEvents
		 * @return void
		 */
		attachEvents: function () {
			var mod = this;

			// Print triggers a simple window.print
			mod.$ctx.find('.share-button.print > a').on('click', $.proxy(mod.printPage, mod));

			// Anything else gets sent to track & trigger
			mod.$ctx.find('.share-button:not(".print") > a').on('click', $.proxy(mod.shareThisPage, mod));
		},

		/**
		 * Print the page
		 *
		 * @method printPage
		 */
		printPage: function () {
			window.print();
		},

		shareThisPage: function(event) {
			var mod = this,
				urlToTrackInRoamingTool,
				clickedShareButton = $(event.target).closest('.share-button'), // get the share button in which the <a> was clicked
				serviceName = clickedShareButton.find('a').data('service');

			// for some services we can not read the share count back from the external service
			// hence, we track it in a swisscom internal database
			if((serviceName === 'mail' ||
				serviceName === 'xing' ||
				serviceName === 'linkedin' ||
				serviceName === 'facebook' ||
				serviceName === 'whatsapp' ||
				serviceName === 'twitter') &&
				!clickedShareButton.data('alreadySharedOnce')) {
				urlToTrackInRoamingTool = SCS.Url.stripProtocolFromUrl($('link[rel=canonical]').attr('href')) || window.SCS.Url.stripPathPrefixFromUrl(document.location.hostname + document.location.pathname);
				mod.trackClickCountInternally(urlToTrackInRoamingTool, serviceName);
			}

			// open the share dialog to allow the user to post the url to their stream on
			// the according profile
			if( serviceName !== 'mail' ){
				event.preventDefault();
				mod.displayShareDialog(event.currentTarget.href);
			}

			// add the click count to the button
			mod.addClickCount(clickedShareButton);
		},


		/**
		 * trackClickCountInternally - write the click count to a swisscom database
		 *
		 * @method trackClickCountInternally
		 * @param url - the url to track
		 * @param serviceName - the name of the service
		 */
		trackClickCountInternally: function (url, serviceName) {
			$.ajax({
				method: 'POST',
				type: 'POST',
				url: '/portal-app/roamingtool/public/social-media-statistics',
				data: JSON.stringify({url: encodeURI(url), service: serviceName}),
				contentType: 'application/json; charset=utf-8',
				dataType: 'json'
			});
		},

		displayShareDialog: function(dialogUrl) {
			var w = 500,
				h = 500,
				left = (screen.width / 2) - (w / 2),
				top = (screen.height / 2) - (h / 2);

			window.open(dialogUrl, 'socialShareWindow', 'toolbar§=no, location=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
		},

		/**
		 * Fakes the share count increase on the client side, without provoking a page reload.
		 * @param shareButton
		 */
		addClickCount: function (shareButton) {
			if (!shareButton.data('alreadySharedOnce')) {
				// update the badge
				this.addShareCountToShareButton(shareButton, 1, shareButton.find('.shareWithCount'));
				// Lock the element from adding further share counts
				shareButton.data('alreadySharedOnce', 'true');
			}
		},

		/**
		 * Update the share count on the button, if displaying of button is configured
		 * If there is already a button with a share count, the new share count will be added.
		 *
		 * @param button - jquery object. Expected to be of type '.share-button'
		 * @param newShareCount - Number - the new share count to add to the button
		 * @param shareCountParent - jquery object - The parent where to append the share Count Badge to.
		 */
		addShareCountToShareButton: function (button, newShareCount, shareCountParent) {
			if (this.displayShareCount) {
				var badge, shareCount;

				if (newShareCount > 0) {
					// get the current badge or create a new one.
					badge = (button.find('.badge').length) ? button.find('.badge') : $('<span class="badge"/>');
					shareCount = (badge.data('actualShareCount')) ? badge.data('actualShareCount') : 0;
					shareCount += newShareCount;
					badge.text(encodeCount(shareCount));
					// store the actual share count so 2999 + 1 will result in the display of 3K
					badge.data('actualShareCount', shareCount);
					// if it's a new badge. append it to the right place
					if (!badge.parent().length && shareCountParent) {
						shareCountParent.append(badge);
					}
				}
			}
		},

		/**
		 * Initialize Share Count Badges on the share buttons
		 */
		initButtonShareCountBadges: function () {
			var mod = this, button;
			$.each(mod.getActiveServices(), function (index, service) {
				socialMedia.shareCount(service)
					.then(function (rv) {
						button = mod.$ctx.find('.share-button').has('a[data-service=' + service + ']');
						mod.addShareCountToShareButton(button, rv.count, button.find('.shareWithCount'));
					}, function () {
						debug.log('Tc.Module.SocialShare.js >> promise rejected >> service: ', service);
					});
			});
		},

		initAggregatedShareCountBadges: function () {
			var mod = this,
				shareCount = mod.$ctx.find('.shareCount'),
				commentCount = mod.$ctx.find('.commentCount');
			// separate call for all social media
			socialMedia.shareCount(socialMedia.servicesByCategory('shareCount'), shareCount.data('fullurl'))
				.then(function (rv) {
					if (rv.counts) {
						shareCount.removeClass('hidden');
					}
					mod.addShareCountToShareButton(shareCount, rv.counts, shareCount);
				}, function () {
					mod.log('aggregate share count rejected. Services aggregated ', socialMedia.servicesByCategory('shareCount'));
				});

			// separate call for disqus
			socialMedia.shareCount('disqus', commentCount.data('disqusUrl'))
				.then(function (rv) {
					if (rv.count) {
						commentCount.removeClass('hidden');
					}
					mod.addShareCountToShareButton(commentCount, rv.count, commentCount);
				}, function () {
					mod.log('Tc.Module.SocialShare.js >> disques count rejected.');
				});
		}
	});
}(Tc.$, window, window.SCS));
}.call(window));

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

/**
 * User: konstantin
 * Date: 4/24/14
 */
(function ($) {
    "use strict";
    /*globals Tc, doT, SCS, debug */
    /*jshint smarttabs:false */

    Tc.Module.Splashscreen = Tc.Module.extend({

        on: function (callback) {
            var $ctx = this.$ctx;

            $(window).resize(function() {
                $ctx.height($(window).height());
            });
            
            $ctx.height($(window).height());

            $('.js-splashscreen-close', $ctx).on('click', function() {
                $("html, body").animate({ scrollTop: $(window).height() }, 800);
                $ctx.css('z-index','4000');
            });

            callback();
        }
    });
}(Tc.$));
}.call(window));

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, Tc) {
	'use strict';

	Tc.Module.VideoContainer = Tc.Module.extend({

		// Offset required to prevent scrollbars
		paddingOffset: 7,

		config: {
			dataVideoFileReference: 'fileReference',
			dataTargetDivId: 'videoContainerId',
			dataVideoHeight: 'videoHeight',
			dataVideoWidth: 'videoWidth',
			dataIsS7Video: 'iss7video'
		},

        autostart : false,

		videoSizeInit: function() {
			var videoWidth = 0,
			videoHeight = 0;
			
			var apsWidth = Math.round($(window).width() * 0.95 - 5);
			var apsHight = Math.round($(window).height() * 0.95 - 5);
			
			debug.log('Tc.Module.VideoContainer > APS > apsWidth, apsHight', apsWidth, apsHight);
			
			if ((apsWidth / apsHight ) > 16/9) {
				videoHeight = apsHight - 70;				
				videoWidth = videoHeight * (16/9);
			} 
			else {
				videoHeight = apsWidth / (16/9);
				videoWidth = apsWidth;
			}
			
			videoWidth = Math.round(videoWidth);
			videoHeight = Math.round(videoHeight);
			$('#s7ViewerContainer').width((videoWidth) + 'px');
			$('#s7ViewerContainer').height((videoHeight)  + 'px');

			debug.log('Tc.Module.VideoContainer > Calculated > videoWidth, videoHeight', videoWidth, videoHeight);

			// do not start brightcove player when page loads, it should start when overlay load is done.
            this.autostart = $('#s7ViewerContainer').find('.modBrightcoveVideo').data('autostart');
            debug.log('Tc.Module.VideoContainer > ', this.autostart);
			$('#s7ViewerContainer').find('.modBrightcoveVideo').data('autostart', false);
		},

		on: function (callback) {
			var mod = this,
				$ctx = mod.$ctx,
				config = mod.config,
				resizeRatio = 1.00,
				videoWidth = '100%',
				videoHeight = '100%';

			mod.videoSizeInit();

			if ($ctx.data(config.dataVideoWidth.toLowerCase())) {
				var width = $ctx.data(config.dataVideoWidth.toLowerCase());
				if (width > $(window).width()) {
					resizeRatio = $(window).width() / width;
					width = $(window).width();
				}
				$('#s7ViewerContainer').width((width) + 'px');
				videoWidth = (width + mod.paddingOffset) + 'px';
			}

			if ($ctx.data(config.dataVideoHeight.toLowerCase())) {
				var height = $ctx.data(config.dataVideoHeight.toLowerCase());
				height = height * resizeRatio;
				$('#s7ViewerContainer').height((height) + 'px');
				videoHeight = (height + mod.paddingOffset) + 'px';
			}

			// responsive fix for colorbox from here
			// http://stackoverflow.com/questions/12182668/how-to-make-colorbox-responsive
			var cboxOptions = {
				maxWidth: videoWidth + 5,
				maxHeight: videoHeight + 5
			};

			$(window).resize(function () {
				$.colorbox.resize({
					width: window.innerWidth > parseInt(cboxOptions.maxWidth, 10) ? cboxOptions.maxWidth : cboxOptions.width,
					height: window.innerHeight > parseInt(cboxOptions.maxHeight, 10) ? cboxOptions.maxHeight : cboxOptions.height
				});
				mod.videoSizeInit();
			});

			$('.links7ViewerContainer').colorbox({
				width: '95%',
				height: '95%',
				inline: true,
//				maxWidth: cboxOptions.maxWidth,
//				maxHeight: cboxOptions.maxHeight,
				opacity: 0.6,
				href: function () {
					return '#s7ViewerContainer';
				},
				onClosed: function () {
                    if ($ctx.data(config.dataIsS7Video)) {
                    // scene7 viewer needs to be removed, otherwise it will start running in background.
						var child = $($('#s7ViewerContainer').children()[0]);
                    	child.remove();
					 } else {
						var origId = $('#s7ViewerContainer .video-player-wrapper div').attr('id');
                        if(window.videojs && origId && origId.toString) {
                            var playerO = window.videojs(origId.toString());
                            playerO.pause();
                        }
					}
				},
				onComplete: function () {
					// TODO test in IE
                    if ($ctx.data(config.dataIsS7Video)) {
						mod.s7EmbedOverlay();
					 } else {
                        setTimeout(function() {
						// player should start immediately when the colorboxy is opened
							var origId = $('#s7ViewerContainer .video-player-wrapper div').attr('id');
							if(window.videojs && mod.autostart && origId && origId.toString) {
                                var playerO = window.videojs(origId.toString());
								playerO.play();
                            }
						}, 250);
					};
				}
			});

			callback();
		},

		s7EmbedOverlay: function () {
			var mod = this,
				$ctx = mod.$ctx,
				config = mod.config,
				s7ViewerConfig = {
					flyoutLibraryPath: '',
					flyoutInitFilePath: '',
					assetContext: 'is/content/',
					locale: 'de',
					company: 'Swisscomvbc',
					useDivSize: true,
					roots: ['/skins/', '/s7viewers/'],
					cssRoot: '/skins/',
					codeUrl: '/s7viewers/',
					//contentUrl: '/skins/',
					contentUrl: 'is/content/',
					serverurl: 'http://swisscomvbc.scene7.com/is/image/',
					isr: 'https://swisscomvbc.scene7.com/',
					streamingRoot: 'rtmp://s7strmg2.scene7.com/s7strmg2/e2',
					progressiveRoot: 'http://swisscomvbc.scene7.com/e2/',
					streamingVideoUrl: 'rtmp://s7strmg2.scene7.com/s7strmg2/e2',
					progressiveVideoUrl: 'http://swisscomvbc.scene7.com/e2/',
					// type of embedded asset
					//	UNIVERSAL_VIDEO: 'VIDEO',
					//	UNIVERSAL_ZOOM: 'ZOOM',
					//	UNIVERSAL_IMAGE_SET: 'IMAGE_SET',
					//	UNIVERSAL_SWATCH_SET: 'RENDER_SET',
					//	UNIVERSAL_SPIN_SET: 'SPIN_SET_2D',
					//	UNIVERSAL_E_CAT: 'ECATALOG'
					assetType: 'VIDEO',
					// universal preset
					config: 'Swisscomvbc/Universal_Video1',
					asset: 'Swisscomvbc/' + $ctx.data(config.dataVideoFileReference.toLowerCase()),
					// container
					containerId: 's7ViewerContainer',
					flashMode: 'transparent',
					modifiers: {
						all: 'videoPlayer.autoPlay=1'
					}
				};

			mod.videoView = new window.s7uev.EmbeddedViewer(s7ViewerConfig);
		}
	});
}(__webpack_provided_window_dot_Tc_dot_$, window.Tc));
}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

/**
 * User: ristekochev
 * Date: 5/6/14
 */
(function ($) {
    "use strict";
    /*globals Tc, doT, SCS, debug */
    /*jshint smarttabs:false */

    Tc.Module.Selectbox = Tc.Module.extend({

        on: function (callback) {
            var $ctx = this.$ctx;

            if(this.isEngagement()) {
                $ctx.find(".customDropDown").sSelect();

                callback();

                return;
            }

            $('select', $ctx).selectBoxIt({
                showFirstOption: false,
                autoWidth: false,
                downArrowIcon: "select_down"
            });

            $('select', $ctx).bind({
                "open": function() {
                    $(this).data("selectBox-selectBoxIt").setOptions({ downArrowIcon: "select_up" });
                },
                "close": function() {
                    $(this).data("selectBox-selectBoxIt").setOptions({ downArrowIcon: "select_down" });
                }

            });

            // PLACEHOLDER REPLACEMENT FOR BROWSERS <IE10
            $('[placeholder]').focus(function() {
                var input = $(this);
                if (input.val() == input.attr('placeholder')) {
                    input.val('');
                    input.removeClass('placeholder');
                }
            }).blur(function() {
                    var input = $(this);
                    if (input.val() == '' || input.val() == input.attr('placeholder')) {
                        input.addClass('placeholder');
                        input.val(input.attr('placeholder'));
                    }
                }).blur().parents('form').submit(function() {
                    $(this).find('[placeholder]').each(function() {
                        var input = $(this);
                        if (input.val() == input.attr('placeholder')) {
                            input.val('');
                        }
                    })
                });

            callback();
        },

        /**
         * Check if page is engagement
         * @method isEngagement
         * @return {Boolean}
         */
        isEngagement: function() {
            return $('body').hasClass("engagement");
        }

    });
}(Tc.$));

}.call(window));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_load_qtip__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_util_helpers__ = __webpack_require__(3);




var CallOut = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(CallOut, _super);
    function CallOut() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.content = '';
        _this.overwriteClass = '';
        _this.overwriteIconClass = '';
        _this.offsetOverrideX = 0;
        _this.offsetOverrideY = 2;
        _this.isMobile = false;
        _this.isMobileOnly = false;
        _this.isSDX = true;
        _this.$tip = null;
        return _this;
    }
    CallOut.prototype.on = function (callback) {
        var $ctx = this.$ctx;
        // Configuration
        this.content = $ctx.html();
        // <div data-class-overwrite="myPEXSpecialStyleInGrau"…
        this.overwriteClass = $ctx.data('class-overwrite') || '';
        this.overwriteIconClass = $ctx.data('icon-class-overwrite') || '';
        this.offsetOverrideX = $ctx.data('offset-override-x') || 0;
        this.offsetOverrideY = $ctx.data('offset-override-y') || 2;
        this.isMobileOnly = $ctx.is('.isMobileOnly');
        this.isMobile = Object(__WEBPACK_IMPORTED_MODULE_3_lib_util_helpers__["isMobilePage"])();
        this.isSDX = $ctx.is('.sdx');
        this.log.debug('content', this.content);
        $ctx.hide();
        callback();
    };
    CallOut.prototype.after = function () {
        var $ctx = this.$ctx;
        if (this.isMobileOnly && !this.isMobile) {
            // Render as text on desktop
            $ctx.removeClass('mod modCallOut isMobileOnly').attr('style', '');
            return;
        }
        if (this.isMobile) {
            var $tabNav = this.$ctx.closest('.modTabNavigation');
            var tabNav = this.sandbox.getModuleInstance($tabNav, 'TabNavigation');
            if (tabNav) {
                this.sandbox.subscribe(tabNav.channel, this);
            }
        }
        if (!this.isSDX) {
            this.$tip = $('<span/>');
            this.$tip.addClass('scs-icon info-callout');
        }
        else {
            this.$tip = $('<i/>');
            this.$tip.addClass('sdx icon icon-046-information-circle');
        }
        this.$tip
            .attr('title', this.content)
            .addClass(this.overwriteClass)
            .addClass(this.overwriteIconClass)
            .insertBefore(this.$ctx)
            .before(' ')
            .after(' ');
        var configuration = this.isMobile ? this.mobileConfiguration() : this.desktopConfiguration();
        this.$tip.qtip(configuration);
    };
    CallOut.prototype.stop = function () {
        if (this.$tip) {
            this.$tip.qtip('destroy', true);
            this.$tip.remove();
            this.$tip = null;
        }
        Object.getPrototypeOf(Object.getPrototypeOf(this)).stop.apply(this, arguments);
    };
    /**
     * This function returns configuration object for jQuery tooltip plug-in
     * qTip. This configuration object is used on mobile.
     *
     * @method mobileConfiguration
     * @return Configuration object for jQuery tooltip plug-in qTip.
     */
    CallOut.prototype.mobileConfiguration = function () {
        var _this = this;
        var config = {
            content: {
                button: 'close',
                title: {
                    text: ' ',
                },
            },
            events: {
                hide: function () {
                    _this.$tip.removeClass('mobile-active');
                },
                show: function () {
                    _this.$tip.addClass('mobile-active');
                },
            },
            hide: {
                event: 'click',
            },
            show: {
                event: 'click',
                solo: true,
            },
            style: {
                classes: 'ui-tooltip-mobile',
            },
        };
        var $modalParent = this.$ctx.closest('.modal');
        if ($modalParent.length) {
            config.position = {
                container: $modalParent.find('.modal__content'),
            };
            config.content.title.button = $('<i class="icon icon-022-close icon--s2 font--semi-bold sc-navy" aria-hidden="true"></i>');
        }
        return config;
    };
    /**
     * This function returns configuration object for jQuery tooltip plug-in
     * qTip. This configuration object is used on desktop.
     *
     * @method desktopConfiguration
     * @return Configuration object for jQuery tooltip plug-in qTip.
     */
    CallOut.prototype.desktopConfiguration = function () {
        var config = {
            position: {
                adjust: {
                    x: this.offsetOverrideX,
                    y: this.offsetOverrideY,
                },
                at: 'top center',
                my: 'bottom center',
                viewport: $(document.documentElement),
            },
            style: {
                classes: this.overwriteClass + " scs-callout " + (this.isSDX ? ' sdx' : ''),
                tip: {
                    corner: true,
                    height: 6,
                    width: 8,
                },
            },
        };
        var $modalParent = this.$ctx.closest('.modal');
        if ($modalParent.length) {
            config.position.container = $modalParent;
        }
        return config;
    };
    /**
     * This function hides callout when tab is changed.
     *
     * @method onActivateTab
     * @return void
     */
    CallOut.prototype.onActivateTab = function () {
        this.$tip.qtip('hide');
    };
    return CallOut;
}(__WEBPACK_IMPORTED_MODULE_1_lib_vendor_terrific_Module__["a" /* Module */]));
/* harmony default export */ __webpack_exports__["a"] = (CallOut);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

(function(SCS) {
	'use strict';

	var slice = Array.prototype.slice;
	var search = SCS.search = SCS.search || {};
	var util = search.util = search.util || {};

	/**
	 * Creates an instance that processes search requests.
	 * @argument backend The backend function.
	 *           Gets passed the config URL and a callback which it calls with the response data.
	 *           Also gets passed the config object and the processor.
	 *           These should only be used for debugging as the backend may be used to service several requests from different processors and using different configs (as long as the URL stays the same) when behind a deduplicatedBackend or cachingBackend wrapper (or both).
	 *           To respond to config options, use pre- or post-plugins instead.
	 * @argument logger A logger. Should conform to the console interface (methods that may be used are: log, debug, info, error).
	 */
	function SearchProcessor(backend, logger) {
		this.backend = backend || search.backend.defaultBackend();
		this.responders = [];
		this.preFilters = [];
		this.postFilters = [];
		this.logger = logger || window.debug || window.console || null;
		this.running = null;
	}

	var proto = SearchProcessor.prototype;

	proto.responder = function(responder) {
		this.responders.push(responder);
		return responder;
	};

	proto.removeResponder = function(responder) {
		var res = this.responders;
		var index = util.inArray(responder, res);
		if(index > -1) {
			return res.splice(index, 1)[0];
		}
		return null;
	};

	function addToFilterList(filter, list, weight) {
		for(var i=0;i<list.length;i+=1) {
			if(list[i].weight > weight) {
				break;
			}
		}
		list.splice(i, 0, {filter: filter, weight: weight});
	}
	proto.use = function(preFilter, postFilter, weight) {
		weight = weight || 0;
		if(preFilter) {
			addToFilterList(preFilter, this.preFilters, weight);
		}
		if(postFilter) {
			addToFilterList(postFilter, this.postFilters, weight);
		}
	};

	// Syntactic sugar aliases
	proto.usePre = function(filter, weight) { this.use(filter, null, weight); };
	proto.usePost = function(filter, weight) { this.use(null, filter, weight); };

	/**
	* Calls each of the filters in the given filter chain.
	* Expects to be passed the same amount of additional arguments (after context) that:
	* 	1. The filter takes (excluding the callback)
	*		2. The filter passes its callback
	*		3. The done method takes
	* Guarantees the done function be called asynchronously even if none of the filters are asynchronous
	* Each callback (and done) is run in context of the filter chain API, which allows the filter chain to be prematurely aborted.
	*/
	function processAsyncFilterChain(filterChain, done, processor) {
		var args = slice.call(arguments, processAsyncFilterChain.length);
		filterChain = filterChain.slice();

		var running = true;
		var currentFilterAPI = null;

		// Stops the filter chain and ignores the current value (does not call any methods)
		// Called from the outside (the search processor instance)
		function abort() {
			running = false;
			if(currentFilterAPI) {
				currentFilterAPI.abort();
			}
		}
		// Public API for controlling this chain.
		var result = {
			abort: abort,
			processor: processor,
			isRunning: function() {
				return running;
			},
			args: args
		};
		
		// API for controlling this chain from within (calls the processor instance to abort)
		var context = util.extend({}, result, {
			abort: function(silent) {
				abort();
				processor.aborted.apply(processor, [result].concat(args, [silent]));
			}
		});

		var allFiltersSync = true;
		// Called by the filters when they are done processing.
		// Can be synchronously or asynchronously called.
		function nextFilter() {
			// Use the arguments from the last invocation if the filter didn’t pass them.
			for(var i=0;i<args.length;i+=1) {
				args[i] = arguments[i] || args[i];
			}

			if(!running) {
				// Do nothing if already responded or aborted
				// If filters up till now were asynchronous, don’t return a valid controller result;
				result = null;
				return;
			}

			var filter = filterChain.shift();
			if(filter) {
				filter = filter.filter;
			}

			if(!filter && allFiltersSync) {
				// Add a special “async” filter that delays the execution to make filter chains always predictably asynchronous
				filter = function async() {
					var handle = window.setTimeout(function() {
						nextFilter();
					}, 0);
					return {
						abort: function() {
							window.clearTimeout(handle);
						}
					};
				};
			}

			// Filters finished
			if(!filter) {
				// Mark the filter chain as finished (no more callbacks allowed)
				running = false;
				// Clear the API of the current filter
				currentFilterAPI = null;
				// Call the done callback after all filters are done
				done.apply(context, args);

				return;
			}
			// We still have filters to work on, call the next one
			var isSync = false;
			var callback = function() {
				isSync = true;
				return nextFilter.apply(this, arguments);
			};
			// Add the callback as last argument
			currentFilterAPI = filter.apply(context, args.concat([callback]));
			if(!isSync && !running) {
				// Filter aborted before calling a callback
				result = null;
				return;
			}
			if(!isSync && (!currentFilterAPI || !('abort' in currentFilterAPI))) {
				throw new Error('Filter ' + filter.name + ' did not return an API and isn’t synchronous');
			}
		}
		nextFilter();
		// If we got here, something in nextFilter was asynchronous.
		allFiltersSync = false;

		return result;
	}

	proto.process = function(configuration) {
		var _this = this;
		// Called when all filters are done
		function callBackend(configuration) {
			var isSync = false;
			var running = _this.backend.call(_this, configuration.url, function(data) {
				isSync = true;
				_this.running = null;
				_this.processingDone(data, configuration);
			}, _this, configuration);
			 _this.running = _this.running || running; // _this.running may be set in _this.processingDone (for sync backends). Don’t overwrite it!
			if(!isSync && (!_this.running || !('abort' in _this.running))) {
				throw new Error('Backend ' + _this.backend.name + ' did not return an API and isn’t synchronous');
			}
		}

		this.abort();

		this.running = processAsyncFilterChain(this.preFilters, callBackend, this, configuration);
	};

	proto.processingDone = function(data, configuration) {
		var _this = this;
		if(data instanceof Error) {
			return _this.send('error', data, configuration);
		}
		function callResponder(data, configuration) {
			_this.running = null;
			_this.data(data, configuration);
		}
		_this.running = processAsyncFilterChain(this.postFilters, callResponder, this, data, configuration);
	};

	// Aborts the currently active filter queue/backend request
	proto.abort = function() {
		var running = this.running;
		if(running) {
			this.running = null;
			// Abort currently running
			running.abort();
			// Emit the “abort” event
			var args = running.args || [];
			this.aborted(running, args[0], args[1]);
		}
	};
	
	// If this is called, the filter chain was already aborted, either from the outside or the inside
	// Use the “silent” argument when you immediately follow the abort with a new processing phase
	proto.aborted = function aborted(filterChain, data, configuration, silent) {
		if(arguments.length < aborted.length) {
			// No data given (abort was in pre-filter chain)
			silent = configuration;
			configuration = data;
			data = undefined;
		}
		if(filterChain === this.running) {
			this.running = null;
		}
		var eventName = silent ? 'silent-abort' : 'abort';
		this.send(eventName, filterChain, data, configuration);
	};

	// Sends the `data` event with the given data and configuration to all responders
	proto.data = function(data, configuration) {
		this.send('data', data, configuration);
	};

	// Sends an event to all responders
	proto.send = function(event, data) {
		// jshint unused: false
		var args = slice.call(arguments);
		args.splice(1, 0, this);
		// Copy responders so concurrent mutations do not affect the iteration
		var responders = this.responders.slice();
		for(var i=0;i<responders.length;i+=1) {
			// Don’t let an exception in one responder cancel the execution of others
			try {
				this.log('debug', 'sending event', event, 'with data', args);
				responders[i].apply(null, args);
			} catch(e) {
				this.log('error', 'responder', responders[i].displayName || responders[i].name, 'threw', e);
			}
		}
	};

	// Track various events.
	// See https://wiki.swisscom.com/display/PD/Tracking+interface
	proto.track = function(event, data) {
		// jshint unused: false
		var args = slice.call(arguments, 1);

		var trackedBy = [];

		var nav = window.navigator;
		if(util.inArray((nav.mockDoNotTrack || nav.doNotTrack || nav.msDoNotTrack), ['1', 'yes']) > -1) {
			return trackedBy;
		}

		// Find eligible trackers and call them
		var trackers = search.trackers || {};
		for(var name in trackers) {
			// jshint forin: false
			var tracker = trackers[name];
			if(!tracker || !tracker[event] || !tracker.hasOwnProperty(event)) {
				// Event not tracked
				continue;
			}
			try {
				tracker[event].apply(null, args);
				trackedBy.push(name);
			} catch(e) {
				this.log('error', 'Tracker', name, 'threw', e);
			}
		}
		return trackedBy;
	};

	proto.log = function log(level) {
		if(!this.logger) {
			return;
		}
		var messages = slice.call(arguments);
		messages.splice(0, log.length, 'SearchProcessor >');
		level = level || 'log';
		if(!(level in this.logger)) {
			// Prepend level if default, otherwise use real level
			messages.splice(0, 0, level.toUpperCase());
			level = 'log';
		}
		this.logger[level].apply(this.logger, messages);
	};

	search.Processor = SearchProcessor;
	if(false) {
		// Visible for testing
		search.internals = search.internals || {};
		search.internals.processAsyncFilterChain = processAsyncFilterChain;
	}

})(window.SCS = window.SCS || {});

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$, __webpack_provided_window_dot_$) {(function(SCS, $) {
	'use strict';

	var search = SCS.search = SCS.search || {};

	function deduplicatedBackend(backend) {
		var pending = {};
		function backendDeduplicator(url, callback, processor, config) {
			// jshint validthis: true
			var duplicate = url in pending;

			var current = pending[url] = pending[url] || {callbacks: [], result: null};
			current.callbacks.push(callback);

			var handle = {
				abort: function() {
					var index = search.util.inArray(callback, current.callbacks);
					if(index !== -1) {
						current.callbacks.splice(index, 1);
					}
					if(!current.callbacks.length) {
						current.result.abort();
					}
				}
			};

			if(duplicate) {
				return handle;
			}

			current.result = backend.call(this, url, function() {
				delete pending[url];
				for(var i=0;i<current.callbacks.length;i+=1) {
					current.callbacks[i].apply(this, arguments);
				}
			}, processor, config);

			return handle;
		}
		backendDeduplicator.displayName = deduplicatedBackend.name + ': ' + (backend.displayName || backend.name);
		return backendDeduplicator;
	}

	var DEFAULT_CACHE_SIZE = 20;
	var DEFAULT_CACHE_TOLERANCE = 0.5;
	function cachedBackend(backend, cacheSize, tolerance) {
		cacheSize = cacheSize || DEFAULT_CACHE_SIZE;
		tolerance = tolerance || DEFAULT_CACHE_TOLERANCE;

		var maxSize = Math.ceil(cacheSize * (1 + tolerance));

		var cache = {};
		var currentSize = 0;

		function cleanCache() {
			// Clean up stale cache entries
			if(currentSize <= maxSize) {
				return;
			}
			var toRemove = Math.max(currentSize - cacheSize, 0);
			var ordered = [];
			for(var k in cache) {
				// jshint forin: false
				ordered.push(k);
			}
			ordered.sort(function(a, b) {
				return cache[a].ts - cache[b].ts;
			});
			for(var i=0;i<toRemove;i+=1) {
				delete cache[ordered[i]];
				currentSize -= 1;
			}
		}

		function purgeCache() {
			cache = {};
		}

		function backendCacher(url, callback, processor, config) {
			// jshint validthis: true
			if(url in cache) {
				cache[url].ts = +new Date();
				// Cannot abort cached requests because they are synchronous
				return callback.apply(this, cache[url].data);
			}
			return backend.call(this, url, function() {
				if(!(arguments[0] instanceof Error)) {
					cache[url] = {data: arguments, ts: +new Date()};
					currentSize += 1;
					cleanCache();
				}
				callback.apply(this, arguments);
			}, processor, config);
		}

		backendCacher.purgeCache = purgeCache;
		backendCacher.displayName = cachedBackend.name + ': ' + (backend.displayName || backend.name);

		return backendCacher;
	}

	function ajaxBackend(ajaxOptions) {
		// A backend function that does a real XMLHttpRequest using a jQuery.ajax GET request
		ajaxOptions = ajaxOptions || {};
		return function jQueryBackend(url, callback) {
			var match = url.match(/^\[(\w+)\](.*)$/) || [];
			url = match[2] || url;
			var method = match[1] || 'GET';
			var opts = search.util.extend({}, ajaxOptions, {
				url: url,
				type: method
			});
			var request = $.ajax(opts).done(callback).fail(function(xhr, textStatus, errorThrown) {
				if(!errorThrown || !(errorThrown instanceof Error)) {
					errorThrown = new Error(errorThrown || textStatus);
				}
				callback(errorThrown);
			});
			return {
				abort: function() {
					request.abort();
				}
			};
		};
	}

	var backend = search.backend = search.backend || {};
	backend.deduplicatedBackend = deduplicatedBackend;
	backend.cachedBackend = cachedBackend;
	backend.ajaxBackend = ajaxBackend;

	backend.defaultBackend = function defaultBackend() {
		if(!defaultBackend.instance) {
			var defaultAjaxBackend = ajaxBackend({
				dataType: 'json',
				timeout: 1800
			});
			// Caching must be done after deduplication to not cache concurrent requests
			defaultBackend.instance = deduplicatedBackend(cachedBackend(defaultAjaxBackend));
		}
		return defaultBackend.instance;
	};

})(window.SCS = window.SCS || {}, 'Tc' in window ? __webpack_provided_window_dot_Tc_dot_$ : __webpack_provided_window_dot_$);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(0)))

/***/ }),
/* 51 */
/***/ (function(module, exports) {

(function(SCS) {
	'use strict';

	SCS.search = SCS.search || {};
	SCS.search.util = SCS.search.util || {};

	var util = SCS.search.util;

	var slice = Array.prototype.slice;

	function respondOnce(targetEvents, callback, context) {
		if(!util.isArray(targetEvents)) {
			targetEvents = [targetEvents];
		}
		var result = function onceResponder(event, processor) {
			if(util.inArray(event, targetEvents) === -1) {
				return;
			}
			processor.removeResponder(onceResponder);
			callback.apply(context||this, arguments);
		};
		result.displayName = result.name + ' (' + targetEvents + '): ' + callback.name;
		return result;
	}

	function respondTo(events, context) {
		var result = function toResponder(event) {
			if(event in events) {
				var args = slice.call(arguments, toResponder.length);
				events[event].apply(context||this, args);
			}
		};
		result.displayName = result.name + ': ' + (Object.keys ? Object.keys(events) : 'events');
		return result;
	}

	util.respondOnce = respondOnce;
	util.respondTo = respondTo;

})(window.SCS = window.SCS || {});

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$, __webpack_provided_window_dot_$) {(function(SCS, $) {
	'use strict';

	var arrayProto = Array.prototype;
	
	var isArray = Array.isArray || function(object) {
		return Object.prototype.toString.call(object) === '[object Array]';
	};

	var inArray = ('indexOf' in arrayProto && function inArray(item, array) {
		return arrayProto.indexOf.call(array, item);
	}) || $.inArray;

	var extend = ($ && $.extend) || function extend(base) {
		var extendWith = arrayProto.slice.call(arguments, extend.length);
		for(var i=0;i<extendWith.length;i+=1) {
			for(var name in extendWith[i]) {
				// jshint forin: false
				base[name] = extendWith[i][name];
			}
		}
		return base;
	};

	/**
	 * Flattens an object/array in to a single array where the nth item is the key path and the n+1th item is the value
	 */
	function flatten(object, result, prefix) {
		result = result || [];
		prefix = prefix || '';
		if(isArray(object)) {
			for(var i=0;i<object.length;i+=1) {
				flatten(object[i], result, prefix+'[]');
			}
		} else if(typeof(object) === 'object' && object !== null) {
			for(var k in object) {
				// jshint forin: false
				var p = prefix ? prefix+'['+k+']' : k;
				flatten(object[k], result, p);
			}
		} else {
			result.push(prefix, String(object));
		}
		return result;
	}

	function urlEncode(string) {
		return window.encodeURIComponent(string).replace(/%20/g, '+');
	}

	function param(object) {
		var items = flatten(object);
		var result = [];
		for(var i=0;i<items.length;i+=2) {
			result.push(urlEncode(items[i])+'='+urlEncode(items[i+1]));
		}
		return result.sort().join('&');
	}

	function parallel(operations, callback) {
		if(!operations.length) {
			return callback();
		}
		var pending = operations.length;
		function done() {
			pending -= 1;
			if(pending === 0) {
				callback();
			}
		}
		var apis = [];
		for(var i=0;i<operations.length;i+=1) {
			apis.push(operations[i](done));
		}
		return {
			abort: function() {
				for(var i=0;i<apis.length;i+=1) {
					if(apis[i]) {
						apis[i].abort();
					}
				}
			}
		};
	}

	var search = SCS.search = SCS.search || {};
	var util = search.util = search.util || {};

	if(false) {
		// Visible for testing
		util.internals = util.internals || {};
		util.internals = {
			urlEncode: urlEncode
		};
	}


	util.isArray = isArray;
	util.inArray = inArray;
	util.extend = extend;
	util.param = param;
	util.parallel = parallel;

})(window.SCS = window.SCS || {}, 'Tc' in window ? __webpack_provided_window_dot_Tc_dot_$ : __webpack_provided_window_dot_$);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(0)))

/***/ }),
/* 53 */
/***/ (function(module, exports) {

(function(SCS) {
	'use strict';

	var search = SCS.search = SCS.search || {};
	var util = search.util = search.util || {};

	function retrieveKeymatchesFromSuggestions(keymatchProcessor) {
		var running;
		function abortRunning() {
			if(running) {
				running.abort();
			}
		}
		return function keymatchRetriever(data, configuration, callback) {
			abortRunning();

			// Build search string for keymatch from the suggestions we got
			var results = data.results || [];
			var query = '';
			for(var i=0;i<results.length;i+=1) {
				query += results[i].name + ' ';
			}
			if(query) {
				query = query.slice(0, -1);
			} else {
				// No autosuggest results, use the original query for keymatches
				query = configuration.query;
			}

			var autosuggestProcessor = this.processor;

			// Unregister after the first result form the autosuggest processor and abort
			// the current loading of keymatches if the autosuggest was aborted
			autosuggestProcessor.responder(util.respondOnce(['abort', 'data'], util.respondTo({
				abort: abortRunning
			})));

			function keymatchQueryDone(event, keymatchProcessor, data, config) {
				running = null;
				if(event === 'data') {
					autosuggestProcessor.send('keymatch-data', data, config);
				}
			}

			keymatchProcessor.responder(util.respondOnce(['data', 'error', 'abort'], keymatchQueryDone));
			keymatchProcessor.process({query: query, userQuery: configuration.query});
			running = keymatchProcessor;

			// FIXME: Should we wait with processing suggestions until keymatches are loaded?
			callback();
		};
	}

	function abortShortQueries(limit) {
		limit = limit || 3;
		return function shortQueriesAborter(configuration, callback) {
			if(String(configuration.query).length >= limit) {
				// All OK
				return callback();
			}
			this.abort();
			callback();
		};
	}

	function setUp(processor, keymatchRetriever, shortQueriesAborter) {
		if(keymatchRetriever) {
			processor.usePost(keymatchRetriever, 200);
		}
		processor.usePre(shortQueriesAborter||abortShortQueries(), -10000);
	}

	var plugins = search.plugins = search.plugins || {};
	var autosuggest = plugins.autosuggest = plugins.autosuggest || {};

	autosuggest.retrieveKeymatchesFromSuggestions = retrieveKeymatchesFromSuggestions;
	autosuggest.setUp = setUp;

})(window.SCS = window.SCS || {});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

(function(SCS) {
	'use strict';

	var search = SCS.search = SCS.search || {};

	function handleAutounfilter() {
		// Stops the query if no results were found and creates a new query where the filters are removed.
		// Should be added after spellchecking (because autocorrections should be applied first).
		return function autounfilterHandler(data, configuration, callback) {
			// Only unfilter automatically if no results
			if(data.resultCount) {
				return callback();
			}

			// No filters set to begin with. Abort.
			if(!configuration.requiredfields) {
				return callback();
			}

			var processor = this.processor;
			// Clear filters and re-trigger search
			var update = {
				filter: {},
				subsearch: true,
				previousFilter: configuration.filter
			};
			var config = search.util.extend({}, configuration.inputConfig, update);
			processor.track('automaticFilterRemoval', search.util.extend({}, configuration, update));

			this.abort(true);
			processor.process(config);
		};
	}

	function setUp(processor, autounfilterHandler, weight) {
		weight = weight || 110;
		processor.usePost(autounfilterHandler||handleAutounfilter(), weight);
	}

	var plugins = search.plugins = search.plugins || {};
	var filtering = plugins.filtering = plugins.filtering || {};

	filtering.handleAutounfilter = handleAutounfilter;
	filtering.setUp = setUp;

})(window.SCS = window.SCS || {});

/***/ }),
/* 55 */
/***/ (function(module, exports) {

(function(SCS) {
	'use strict';

	var search = SCS.search = SCS.search || {};

	var GSA_AND_DELIMITER = '.';
	var GSA_EQUAL_DELIMITER = ':';
	var GSA_FACET_PREFIX = 'gsaentity_GSA_';

	function addFilterParams(defaultFilter) {
		// A pre-filter that transforms the filter config property into a “requiredfields” facet filtering string readable by the GSA.
		// Must be added before paramsTransposer from url-handling.js
		defaultFilter = defaultFilter || {};
		return function filterParamsAdder(config, callback) {
			if(!('filter' in config)) {
				// Create a copy of the default filter
				config.filter = search.util.extend({}, defaultFilter);
			}
			var filterString = '';
			for(var name in config.filter) {
				// jshint forin: false
				filterString += GSA_FACET_PREFIX+name + GSA_EQUAL_DELIMITER + config.filter[name] + GSA_AND_DELIMITER;
			}
			if(filterString) {
				// Cut off the last GSA_AND_DELIMITER
				config.requiredfields = filterString.slice(0, -1);
				config.gsaFilter = 'duplicateSnippet';
			}
			callback();
		};
	}

	function split(sites) {
		if(typeof sites === 'string') {
			return sites.split(/\|+/);
		}
		return sites || [];
	}

	function addSiteParams(defaultSites) {
		defaultSites = split(defaultSites);
		// Makes it easy to pass sites as an array and converts it into a pipe-separated string as necessary
		return function siteParamsAdder(config, callback) {
			if('site' in config) {
				config.sites = split(config.site);
				return callback();
			}
			if('sites' in config) {
				config.sites = split(config.sites);
			} else {
				config.sites = defaultSites;
			}
			if(config.sites && config.sites.length) {
				config.site = config.sites.join('|');
			}
			
			callback();
		};
	}

	function handlePaging() {
		// Adjusts the offset to the current page number (if given)
		return function pagingHandler(config, callback) {
			if(!config.inputConfig || 'offset' in config.inputConfig || !('offset' in config) || !('page' in config)) {
				// Explicit offset given, ignore
				// Or no page given, ignore
				return callback();
			}
			config.offset = config.page * config.resultLimit;
			callback();
		};
	}

	function aggregateMetaTags() {
		// Converts the metaTags attribute of each result to an object format
		return function metaTagsAggregator(data, config, callback) {
			var results = data.results || [];

			for(var i=0;i<results.length;i+=1) {
				var result = results[i];
				var metaTags = result.metaTags || [];
				var meta = result.meta = {};
				for(var j=0;j<metaTags.length;j+=1) {
					var metaTag = metaTags[j];
					meta[metaTag.name] = metaTag.value;
				}
			}

			callback();
		};
	}

	function aggregateDynNavFacets() {
		// Converts the dynNav facets attribute of the data to an object format
		return function dynNavFacetsAggregator(data, config, callback) {
			var facets = (data.dynNav && data.dynNav.facets) || [];
			config.facets = {};
			for(var i=0;i<facets.length;i+=1) {
				var facet = facets[i];
				var name = facet.name;
				if(name.indexOf(GSA_FACET_PREFIX) === 0) {
					name = name.substring(GSA_FACET_PREFIX.length);
				}
				facet = config.facets[name] = search.util.extend({}, facet);
				var values = facet.values || [];
				facet.values = {};
				for(var j=0;j<values.length;j+=1) {
					var value = values[j];
					facet.values[value.value] = value;
				}
			}
			callback();
		};
	}

	function setUp(processor, filterParamsAdder, siteParamsAdder, pagingHandler, metaTagsAggregator, dynNavFacetsAggregator) {
		processor.usePre(filterParamsAdder||addFilterParams());
		processor.usePre(siteParamsAdder||addSiteParams());
		processor.usePre(pagingHandler||handlePaging(), 50000);
		processor.usePost(metaTagsAggregator||aggregateMetaTags(), 500);
		processor.usePost(dynNavFacetsAggregator||aggregateDynNavFacets(), 510);
	}

	var plugins = search.plugins = search.plugins || {};
	var gsa = plugins.gsa = plugins.gsa || {};

	gsa.addFilterParams = addFilterParams;
	gsa.addSiteParams = addSiteParams;
	gsa.handlePaging = handlePaging;
	gsa.aggregateMetaTags = aggregateMetaTags;
	gsa.aggregateDynNavFacets = aggregateDynNavFacets;
	gsa.setUp = setUp;

})(window.SCS = window.SCS || {});

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

(function(SCS) {
	'use strict';

	var search = SCS.search = SCS.search || {};

	function getEcommerceURL(ecommerceBaseURL, language, segment, productId) {
		var eCommerceURL = ecommerceBaseURL;
		eCommerceURL = eCommerceURL.replace('%LANG%', language);
		eCommerceURL = eCommerceURL.replace('%SEGMENT%', segment);
		eCommerceURL = eCommerceURL + productId;
		return eCommerceURL;
	}
	var DATA_EXTRACTORS = {
		ecommerceproduct: function(keymatch, data, ecommerceBaseURL) {
			keymatch.segment = data[2];
			keymatch.language = data[3];
			keymatch.productId = data[4];
			keymatch.eCommerceURL = getEcommerceURL(ecommerceBaseURL, keymatch.language, keymatch.segment, keymatch.productId);
			keymatch.display = 'product';
			// Fill in title and subtitle generically
			this.generic(keymatch, data);
		},
		product: function(keymatch, data) {
			keymatch.brand = data[0];
			keymatch.product = data[1];
			keymatch.image = data[2];
			keymatch.rating = data[3];
			keymatch.ratingCount = data[4];
			// Fill in title and subtitle generically
			this.generic(keymatch, data);
		},
		webcode: function(keymatch) {
			keymatch.redirectTo = keymatch.url;
		},
		generic: function(keymatch, data) {
			keymatch.title = data[0];
			keymatch.subtitle = data[1];
		},
		selfcare: function(keymatch, data) {
			keymatch.isSelfcare = true;
			this.generic(keymatch, data);
		}
	};
	function splitKeymatchData(dataExtractors, ecommerceBaseURL) {
		ecommerceBaseURL = ecommerceBaseURL || '/portalshop-api/%LANG%/%SEGMENT%/Product/GetFamilyData/';
		dataExtractors = dataExtractors || DATA_EXTRACTORS;

		return function keymatchDataSplitter(data, config, callback) {
			var keymatches = data.keymatches;
			if(!keymatches || !keymatches.length) {
				return callback();
			}
			config.keymatches = [];
			for(var i=0;i<keymatches.length;i+=1) {
				var keymatch = search.util.extend({}, keymatches[i]);
				keymatch.data = keymatch.data.split(/\|/);
				keymatch.type = keymatch.data.pop().toLowerCase();
				keymatch.display = keymatch.type;
				if(keymatch.type in dataExtractors) {
					dataExtractors[keymatch.type](keymatch, keymatch.data, ecommerceBaseURL);
				}
				config.keymatches.push(keymatch);
			}
			callback();
		};
	}

	function redirectToKeymatch(redirector) {
		redirector = redirector || function(url) {
			window.location = url;
		};

		return function keymatchRedirector(data, config, callback) {
			var keymatches = config.keymatches;
			if(!keymatches || !keymatches.length) {
				return callback();
			}

			for(var i=0;i<keymatches.length;i+=1) {
				var keymatch = keymatches[i];
				if(keymatch.redirectTo) {
					redirector(keymatch.redirectTo);
					this.abort();
					return callback();
				}
			}
			callback();
		};
	}

	var DATA_AGGREGATORS = {
		ecommerceproduct: function(keymatch, backend, callback) {
			return backend(keymatch.eCommerceURL, function(response) {
				keymatch.error = response instanceof Error ? response : null;
				if (!response || !response.ProductDataFamily || response instanceof Error) {
					return callback();
				}

				var family = response.ProductDataFamily;
				keymatch.brand = family.ProductBrand;
				keymatch.product = family.ProductName;
				keymatch.tagline = family.ProductSlogan;

				keymatch.title = (keymatch.brand || keymatch.title) + ' ' + (keymatch.product || keymatch.subtitle);
				keymatch.subtitle = keymatch.tagline || '';

				var familyRating = family.AggregatedFamilyRatingSummary;
				if(familyRating) {
					keymatch.ratingCount = familyRating.NumberOfRatings;
					keymatch.rating = familyRating.Rating;
				}

				var familyProductData = family.FamilyProductData;
				if (familyProductData && familyProductData.length > 0) {
					keymatch.image = familyProductData[0].ProductImageSmall;
				}

				callback();
			});
		}
	};
	var DEFAULT_AGGREGATOR = function(keymatch, backend, callback) {
		callback({});
	};
	function aggregateKeymatchContents(backend, dataAggregators) {
		dataAggregators = dataAggregators || DATA_AGGREGATORS;

		return function keymatchContentsAggregator(data, config, callback) {
			var keymatches = config.keymatches;
			if(!keymatches || !keymatches.length) {
				return callback();
			}
			// Use the current backend to request data from ecommerce
			var aggregateBackend = backend || this.processor.backend;
			var aggregators = [];
			function aggregator(keymatch) {
				return function(callback) {
					var aggregator = keymatch.type in dataAggregators ? dataAggregators[keymatch.type] : DEFAULT_AGGREGATOR;
					aggregator(keymatch, aggregateBackend, callback);
				};
			}
			for(var i=0;i<keymatches.length;i+=1) {
				aggregators.push(aggregator(keymatches[i]));
			}
			// Delay results until keymatches are loaded from ecommerce.
			// FIXME: Is this a good idea?
			return search.util.parallel(aggregators, callback);
		};
	}

	function setUp(processor, keymatchDataSplitter, keymatchContentsAggregator, keymatchRedirector, weight) {
		weight = weight || 300;
		processor.usePost(keymatchDataSplitter||splitKeymatchData(), weight);
		processor.usePost(keymatchContentsAggregator||aggregateKeymatchContents(), weight+20);
		if(keymatchRedirector) {
			// Only use if explicitly passed
			processor.usePost(keymatchRedirector, weight+10);
		}
	}

	var plugins = search.plugins = search.plugins || {};
	var keymatch = plugins.keymatch = plugins.keymatch || {};

	keymatch.splitKeymatchData = splitKeymatchData;
	keymatch.aggregateKeymatchContents = aggregateKeymatchContents;
	keymatch.redirectToKeymatch = redirectToKeymatch;
	keymatch.setUp = setUp;

	if(false) {
		// Visible for testing
		search.internals = search.internals || {};
		search.internals.keymatch = {
			getEcommerceURL: getEcommerceURL
		};
	}

})(window.SCS = window.SCS || {});

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$, __webpack_provided_window_dot_$) {/* Search Sessions - v0.1.0 - 2016-01-04
 * Copyright (c) 2016 Contexity AG; Licensed
 * exported SearchSessions
 *
 # Search Sessions

 Support for search sessions as a JS "module".

 ## Getting Started

 General form:
 ```javascript
 var session = window.scsSiteSearch.SearchSessions([options]).getSession(query[,action]);
 ```
 where the parameters are as follows:
 - **options**: an optional configuration object, which supports the following parameters
 -	*timeout*: the numbers of milliseconds after which a search session expires
 - *min_shared_terms*: the minimum number of terms two subsequent queries must have in common in order to be considered to belong to the same search session
 -	*max_distance*: the maximum edit distance two subsequent queries must have in common in order to be considered to belong to the same search session
 - **query**: the query text entered by the user (**Note!** Not satinized internally!)
 - **action**: an optional forced session-update action with the following possible values:
 -	*"new"*: causes a new session to be created, reseting sequences if necessary
 -	*"next"*: forces an update of the session, even if the session continuation criteria are met
 -	*"same"*: forces the session to remain the same, even if the session continuation criteria are not met

 The default options if none are specified are as follows:
 ```javascript
 {
 timeout: 180000,
 min_shared_terms: 1,
 max_distance: 3,
 }
 ```

 The session objects returned have the following attributes:
 -  **created**: timestamp of the time at which the session was created
 -  **accessed**: timestamp of the time at which the session was last retrieved
 -  **ssid**: the session's ID
 -  **query**: the query text entered by the user (**Note!** Not sanitized internally!)

 */
(function(SCS, JSON, $) {
	'use strict';

	var search = SCS.search = SCS.search || {};
	var noop = function() {};

	var currentTS = Date.now || function() { return +new Date(); };

	// original Levenshtein distance code: Copyright (c) 2011 Andrei Mackenzie (https://gist.github.com/andrei-m/982927)
	// transposition ammendment by Contexity
	function editDistance(a, b) {
		if (a.length === 0) {
			return b.length;
		}
		if (b.length === 0) {
			return a.length;
		}

		var matrix = [];

		// increment along the first column of each row
		var i;
		for (i = 0; i <= b.length; i+=1) {
			matrix[i] = [i];
		}

		// increment each column in the first row
		var j;
		for (j = 0; j <= a.length; j+=1) {
			matrix[0][j] = j;
		}

		// Fill in the rest of the matrix
		for (i = 1; i <= b.length; i+=1) {
			for (j = 1; j <= a.length; j+=1) {
				if (b.charAt(i - 1) === a.charAt(j - 1)) {
					matrix[i][j] = matrix[i - 1][j - 1];
					continue;
				}
				matrix[i][j] = Math.min(matrix[i - 1][j - 1] + 1,   // substitution
					Math.min(matrix[i][j - 1] + 1,                  // insertion
						matrix[i - 1][j] + 1));                     // deletion
				if (i > 1 && j > 1 && a.charAt(i - 1) === b.charAt(j - 2) &&
					a.charAt(i - 2) === b.charAt(j - 1)) {
					matrix[i][j] = Math.min(matrix[i][j],
						matrix[i - 2][j - 2] + 1);                  // transposition
				}
			}
		}

		return matrix[b.length][a.length];
	}

	// compares the terms in two query strings and returns the number of terms that occur in both
	var TERM_SEPARATOR = /\s+/;
	function commonTerms(q1, q2) {

		if (!q1 || !q2) {
			return 0;
		}
		var t1 = q1.split(TERM_SEPARATOR), t2 = q2.split(TERM_SEPARATOR), d = {}, count = 0;
		for (var i = 0; i < t1.length; i+=1) {
			d[t1[i]] = true;
		}
		for (var j = 0; j < t2.length; j+=1) {
			if (d[t2[j]]) {
				count+=1;
			}
		}
		return count;
	}

	// RFC4122 v.4 compatible UUIDs
	// (http://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript/2117523#2117523)
	function uuid() {
		// jshint bitwise: false
		var uuid =
			'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
				// var r = crypto.getRandomValues(new Uint8Array(1))[0] % 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
				var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
				return v.toString(16);
			});
		return uuid;
	}

	// Loads/sets session data
	var sessionStorage = null;
	try {
		sessionStorage = window.sessionStorage;
	} catch(e) {}
	var writer = (sessionStorage && function(name, value) {
		sessionStorage.setItem(name, value);
	}) || ($ && $.cookie && function(name, value) {
		__webpack_provided_window_dot_$.cookie(name).set(value);
	}) || noop;
	var loader = (sessionStorage && function(name) {
		return sessionStorage.getItem(name);
	}) || ($ && $.cookie && function(name) {
		return $.cookie(name).get();
	}) || noop;

	// Encapsulates session data load/storage
	var defaultStorageHandler = {
		get: loader,
		set: writer
	};

	function defaultIDSequence(previous) {
		if (typeof(previous) === 'number') {
			return previous + 1;
		} else {
			return 1;
		}
	}
	
	var SESSION_SESSION_KEY = 'sc-search-session';

	function createSessionFactory(options, logger, idSequence, idGenerator, storageHandler) {
		logger = logger || window.debug;
		idSequence = idSequence || defaultIDSequence;
		idGenerator = idGenerator || uuid;
		storageHandler = storageHandler || defaultStorageHandler;

		// conditional console logging, may be replaced with pre-existing logging infrastructure
		function _log() {
			if(logger) {
				logger.log.apply(logger, arguments);
			}
		}

		// defaults...
		var _defaults = {
			timeout: 180000,
			min_shared_terms: 1,
			max_distance: 3,
			session_key: SESSION_SESSION_KEY
		};
		// ... extended by any options passed in
		var _options = search.util.extend({}, _defaults, options || {});

		// create a new search session with the given query text
		function _newSession(query, prevSession) {
			var now = currentTS();
			var sequence = idSequence(prevSession ? prevSession.sequence : null);
			var id = idGenerator();
			return {created: now, accessed: now, ssid: id, sequence: sequence, query: query};
		}

		// create a "successor" session to the one passed in as parameter
		function _nextSession(session, query) {
			if(!session) {
				_log('Invalid session passed to _nextSession:', session);
			}
			return _newSession(query, session);
		}

		// "touch" a session, updating its last accessed time, but leaving the ssid the same
		function _touchSession(session, query) {
			if(!session) {
				_log('Invalid session passed to _touchSession:', session);
			}
			session.accessed = currentTS();
			session.query = query || session.query || '';
			return session;
		}

		function queryDemandsNewSession(currentSession, query) {
			// we have the same session if:
			// 1. the queries have the minimum of common terms
			return (commonTerms(currentSession.query, query) < _options.min_shared_terms) &&
					// 2. have the maximum allowed edit distance
				(editDistance(currentSession.query, query) > _options.max_distance);
		}

		function timeDistanceDemandsNewSession(currentSession) {
			return (currentTS() - currentSession.accessed) >= _options.timeout;
		}

		function _needNextSession(currentSession, query) {
			return timeDistanceDemandsNewSession(currentSession) && queryDemandsNewSession(currentSession, query);
		}

		var currentSession = null;
		return function getSession(query, force) {
			if(currentSession === null) {
				// retrieve the current session if any
				currentSession = storageHandler.get(_options.session_key);
				if(currentSession) {
					currentSession = JSON.parse(currentSession);
				}
			}
			if (!currentSession) {
				currentSession = false;
				force = 'new';
			}

			if (!query) {
				// return previous session from cache
				return currentSession;
			}

			if(!force) {
				force = _needNextSession(currentSession, query) ? 'next' : 'current';
			}

			// force session behaviour
			if (force === 'new') {
				// always return a new session
				currentSession = _newSession(query);
			} else if (force === 'next') {
				// always return the next session
				currentSession = _nextSession(currentSession, query);
			} else if (force === 'current') {
				// always return the existing version, if there is one
				currentSession = _touchSession(currentSession, query);
			}

			// store the new session
			storageHandler.set(_options.session_key, JSON.stringify(currentSession));
			return currentSession;
		};

	}

	function defaultSessionFactory() {
		if(!defaultSessionFactory.instance) {
			defaultSessionFactory.instance = createSessionFactory();
		}
		return defaultSessionFactory.instance;
	}

	function addSession(sessionGetter) {
		sessionGetter = sessionGetter || defaultSessionFactory();
		// Generates a session for the query.
		// Can be added as soon as the query is known.
		function sessionAdder(config, callback) {
			var sessionOptions = config.sessionOptions || {};
			var force = sessionOptions.forceOnce || sessionOptions.force || null;
			config.forceSession = force;
			// Next request, even if derived, should not force the session again
			delete sessionOptions.forceOnce;
			var session = sessionGetter(config.query, force);
			config.session = session;
			config.ssid = session.ssid;
			config.sessionSequence = session.sequence;
			callback();
		}

		sessionAdder.sessionGetter = sessionGetter;

		return sessionAdder;
	}

	function setUp(processor, sessionAdder) {
		processor.usePre(sessionAdder||addSession(), -10000);
	}

	var plugins = search.plugins = search.plugins || {};
	var session = plugins.session = plugins.session || {};

	if(false) {
		// Visible for testing
		var internals = session.internals = session.internals || {};
		internals.defaultStorageHandler = defaultStorageHandler;
		internals.defaultSessionFactory = defaultSessionFactory;
		internals.defaultIDSequence = defaultIDSequence;
		internals.uuid = uuid;
		internals.editDistance = editDistance;
		internals.commonTerms = commonTerms;
		internals.resetDefaultSession = function() {
			defaultSessionFactory.instance = null;
			defaultStorageHandler.set(SESSION_SESSION_KEY, '');
		};
	}

	session.createSessionFactory = createSessionFactory;
	session.addSession = addSession;
	session.setUp = setUp;

})(window.SCS = window.SCS || {}, window.JSON, 'Tc' in window ? __webpack_provided_window_dot_Tc_dot_$ : __webpack_provided_window_dot_$);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(0)))

/***/ }),
/* 58 */
/***/ (function(module, exports) {

(function(SCS) {
	'use strict';

	var search = SCS.search = SCS.search || {};

	function handleAutocorrect() {
		// Handles the cases where we automatically cancel the current search and do a new search because we had no results
		// See flow-chart at https://wiki.swisscom.com/display/PD/Workflow
		return function autocorrectHandler(data, configuration, callback) {
			// Only correct automatically if no results
			if(data.resultCount) {
				return callback();
			}

			// Don’t do automatic corrections after first iteration
			if('autoCorrectedFrom' in configuration) {
				return callback();
			}

			var suggestions = data.spellingSuggestions || [];

			// Don’t do anything if no suggestions found
			if(!suggestions || !suggestions.length) {
				return callback();
			}

			var processor = this.processor;
			var firstSuggestion = suggestions[0];
			// Send a new query with the same config but the autocorrected query
			var config = search.util.extend({}, configuration.inputConfig, {
				autoCorrectedFrom: configuration.query,
				nextSuggestion: suggestions.length > 1 ? suggestions[1].plain : null,
				subsearch: true,
				query: firstSuggestion.plain
			});
			processor.track('automaticSpellingCorrection', search.util.extend({}, configuration, {
				query: firstSuggestion.plain,
				previousQuery: configuration.query
			}));

			this.abort(true);
			processor.process(config);
		};
	}

	function addManualCorrection() {
		// Adds a property manualCorrectionSuggestion to the returned configuration.
		// Should be added after the handleAutocorrect filter.
		return function manualCorrectionAdder(data, configuration, callback) {
			var suggestions = data.spellingSuggestions || [];

			// Don’t do anything if no suggestions found
			if(!suggestions.length && !configuration.nextSuggestion) {
				return callback();
			}

			// Take the nextSuggestion (2nd place before) from a previous, auto-corrected search
			// or, alternatively, the current top suggestion
			var suggestionText = configuration.nextSuggestion;
			if(!suggestionText) {
				suggestionText = suggestions[0].plain;
			}
			configuration.manualCorrectionSuggestion = suggestionText;

			callback();
		};
	}

	function setUp(processor, autocorrectHandler, manualCorrectionAdder, weight) {
		weight = weight || 100;
		processor.usePost(autocorrectHandler||handleAutocorrect(), weight);
		processor.usePost(manualCorrectionAdder||addManualCorrection(), weight+20);
	}

	var plugins = search.plugins = search.plugins || {};
	var spellchecking = plugins.spellchecking = plugins.spellchecking || {};

	spellchecking.handleAutocorrect = handleAutocorrect;
	spellchecking.addManualCorrection = addManualCorrection;
	spellchecking.setUp = setUp;

})(window.SCS = window.SCS || {});

/***/ }),
/* 59 */
/***/ (function(module, exports) {

(function(SCS) {
	'use strict';

	var search = SCS.search = SCS.search || {};

	function trackQueries() {
		return function queriesTracker(data, config, callback) {
			var params = search.util.extend({}, config, {resultCount: data.resultCount});
			config.queryTrackedBy = this.processor.track('searchQuery', params);
			callback();
		};
	}

	function trackNoResults() {
		// Tracks a query that returned no results
		// Add before spellchecking handling so we only get the no-results cases that are displayed to the user
		return function noResultsTracker(data, config, callback) {
			// Do nothing if results were found
			if(data.resultCount) {
				return callback();
			}

			var params = search.util.extend({}, config, {resultCount: 0});
			config.noResultsTrackedBy = this.processor.track('noResults', params);
			callback();
		};
	}

	function setUp(processor) {
		processor.usePost(trackQueries(), 1000);
		processor.usePost(trackNoResults(), 1000);
	}

	var plugins = search.plugins = search.plugins || {};
	var tracking = plugins.tracking = plugins.tracking || {};

	tracking.trackQueries = trackQueries;
	tracking.trackNoResults = trackNoResults;
	tracking.setUp = setUp;

})(window.SCS = window.SCS || {});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

(function(SCS) {
	'use strict';

	var search = SCS.search || {};
	var extend = search.util.extend;

	function saveInputConfig(blacklist) {
		blacklist = blacklist || {};
		// Saves the config that was input initially (rather than what all the later plugins modified)
		// so that when re-sending or modifying old queries we don’t have to set all the auto-generated config attributes
		// (we can use this to de-duplicate running queries from a responder instead of stopping and re-starting them)
		return function inputConfigSaver(config, callback) {
			config.inputConfig = extend({}, config);
			for(var k in blacklist) {
				// jshint forin: false
				delete config.inputConfig[k];
			}
			callback();
		};
	}

	function setBaseURL(baseURL, suffix, backendType) {
		backendType = backendType || 'gsa';
		// Sets the given baseURL as the URL to use for a request.
		// Should be added very early (low weight) in the pre-filter chain.
		return function baseURLSetter(config, callback) {
			config.url = baseURL + (config.url || suffix || '');
			config.endpointURL = config.url;
			config.baseURL = baseURL;
			config.backendType = backendType;
			callback();
		};
	}

	var DEFAULT_CONFIG = {requester: 'user', origin: null};
	function addDefaultConfig(defaultConfig, customConfig) {
		defaultConfig = extend({}, defaultConfig || DEFAULT_CONFIG, customConfig || {});
		// If a param exists in defaultConfig but not in config, it is taken from there.
		// Should be added just before transposeParams.
		return function defaultConfigAdder(config, callback) {
			config = extend({}, defaultConfig, config);
			callback(config);
		};
	}
	addDefaultConfig.DEFAULT_QUERY = extend({}, DEFAULT_CONFIG, {
		page: 0,
		offset: 0
	});
	
	// FIXME: Move to orchestration or gsa-handling
	var GSA_BASE = {
		client: '', // e.g. sc_v2_f_res_de
		query: '',
		site: '',
		getfields: '*'
	};
	var GSA_QUERY = extend({}, GSA_BASE, {
		proxystylesheet: 'sc_v2b_p_json_default',
		language: 'de' // e.g. lang_de
	});
	addDefaultConfig.GSA_SEARCH_CONFIG = extend({}, addDefaultConfig.DEFAULT_QUERY, GSA_QUERY, {
		resultLimit: 10,
		keyMatchLimit: 0,
		gsaFilter: 'both'
	});
	addDefaultConfig.GSA_SUGGEST_CONFIG = extend({}, DEFAULT_CONFIG, GSA_BASE, {
		format: 'rich',
		suggestionLimit: 5,
		gsaFilter: 'duplicateSnippet'
	});
	addDefaultConfig.GSA_CLUSTER_CONFIG = extend({}, DEFAULT_CONFIG, GSA_QUERY, {
		gsaFilter: 'duplicateSnippet'
	});


	function transposeParams(map) {
		map = map || {};
		// Transposes config.params according to the given map (from => to)
		// Used so we can have unified names of params that work for all backends (e.g. “query”)
		// And then have them transposed into backend-specific names (e.g. “q” for GSA)
		// Should be added before flattenParams but after all the param mingling is done (including addDefaultConfig).
		return function paramsTransposer(config, callback) {
			config.params = config.params || {};
			config.untransposedParams = extend({}, config.params);
			for(var name in map) {
				// jshint forin: false
				if(name in config) {
					config.untransposedParams[name] = config[name];
					if(map[name].constructor === Function) {
						map[name](config[name], config.params);
					} else {
						var newName = map[name] === true ? name : map[name];
						config.params[newName] = config[name];
					}
				}
			}
			callback();
		};
	}
	
	// FIXME: Move to orchestration
	transposeParams.GSA_MAP = {
		query: 'q',
		language: function transposeLanguage(language, params) {
			params.lr = 'lang_' + language;
		},
		client: true,
		site: true, // e.g. sc_v2_c_res_de_live
		getfields: true,
		gsaFilter: function transposeGsaFilter(gsaFilter, params) {
			if(gsaFilter === 'duplicateSnippet') {
				gsaFilter = 'p';
			} else if(gsaFilter === 'duplicateDirectory') {
				gsaFilter = 's';
			} else if(gsaFilter === 'none') {
				gsaFilter = '0';
			} else if(gsaFilter === 'both' || !gsaFilter) {
				// This is the default, don’t add the param
				// gsaFilter = '1'
				return;
			}
			params.filter = gsaFilter;
		},
		proxystylesheet: true,
		requiredfields: true, // gsaentity_GSA_Area:2_business
		format: true, // rich
		resultLimit: 'num',
		keyMatchLimit: 'numgm',
		suggestionLimit: 'max',
		offset: 'start'
	};
	transposeParams.GSA_TITLE_MAP = extend({}, {
		query: 't'
	}, transposeParams.GSA_MAP);

	function flattenParams(paramizeFunction) {
		paramizeFunction = paramizeFunction || search.util.param;
		// Generates the final URL by addind config.params as GET params to the URL.
		// Should be added very late (high weight) in the pre-filter chain of a SearchProcessor.
		return function paramsFlattener(config, callback) {
			config.params = config.params || {};
			config.url = typeof(config.url) === 'string' ? config.url : '/';
			config.baseURL = config.baseURL || config.url;
			config.rootURL = config.url;
			config.urlParams = paramizeFunction(config.params);
			var separator = config.url.indexOf('?') > -1 ? '&' : '?';
			config.url = config.url + separator + config.urlParams;
			callback();
		};
	}

	function prependRequestMethod(defaultMethod) {
		defaultMethod = defaultMethod || 'GET';
		// Prepend the request method to the URL for the ajax backend (but to still have nice cache keys)
		return function requestMethodPrepender(config, callback) {
			config.method = String(config.method || defaultMethod).toUpperCase();
			config.requestUrl = config.url;
			config.url = '['+config.method+']'+config.requestUrl;
			callback();
		};
	}

	function setUp(processor, inputConfigSaver, baseURLSetter, defaultConfigAdder, paramsTransposer, paramsFlattener, requestMethodPrepender) {
		processor.usePre(inputConfigSaver||saveInputConfig(), -2000000);
		processor.usePre(baseURLSetter, -1000000);
		if(defaultConfigAdder) {
			processor.usePre(defaultConfigAdder, 1000);
		}
		processor.usePre(paramsTransposer||transposeParams(), 1000000);
		processor.usePre(paramsFlattener||flattenParams(), 2000000);
		processor.usePre(requestMethodPrepender||prependRequestMethod(), 3000000);
	}

	var plugins = search.plugins = search.plugins || {};
	var url = plugins.url = plugins.url || {};

	url.saveInputConfig = saveInputConfig;
	url.setBaseURL = setBaseURL;
	url.addDefaultConfig = addDefaultConfig;
	url.transposeParams = transposeParams;
	url.flattenParams = flattenParams;
	url.prependRequestMethod = prependRequestMethod;
	url.setUp = setUp;

})(window.SCS = window.SCS || {});

/***/ }),
/* 61 */
/***/ (function(module, exports) {

(function(SCS) {
	'use strict';

	var search = SCS.search = SCS.search || {};

	function fixupStartValue() {
		// Fix up start value offset for Web vs. GSA (Web starts at 1, GSA at 0)
		return function startValueFixerUpper(config, callback) {
			if('start' in config.params) {
				config.params.start = config.params.start + 1;
			}
			callback();
		};
	}

	function fixupResult() {
		// Unify the data structure to be mostly compatible with what we get from the GSA
		return function resultFixerUpper(data, config, callback) {
			data = search.util.extend({}, data);
			var results = data.results = data.items || data.results || [];
			data.resultCount = (data.searchInformation && parseInt(data.searchInformation.totalResults, 10)) || data.resultCount || results.length || 0;
			callback(data);
		};
	}

	function setUp(processor, startValueFixerUpper, resultFixerUpper) {
		processor.usePre(startValueFixerUpper||fixupStartValue(), 1000500);
		processor.usePost(resultFixerUpper||fixupResult());
	}

	var plugins = search.plugins = search.plugins || {};
	var web = plugins.web = plugins.web || {};

	web.fixupStartValue = fixupStartValue;
	web.fixupResult = fixupResult;
	web.setUp = setUp;

})(window.SCS = window.SCS || {});

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

(function(SCS) {
	'use strict';
	var search = SCS.search = SCS.search || {};
	search.trackers = search.trackers || {};
	// Define track logic as functions that can be called from the listeners

	var PARAM_MAPPING = {
		// mapping from internal => gsa param names
		href: 'url',
		query: 'q',
		start: 's',
		ctype: 'ct',
		cdata: 'cd',
		score: 'r'
	};

	function getTrackURL(props) {
		// jshint forin: false
		var name;
		var parameters = {
			ctype: 'OTHER',
			query: '',
			site: '',
			cdata: '{}',
			href: '',
			cq_ck: +new Date(),
			start: 0,
			score: 0
		};
		// Calculate cdata
		var cdata = {ssid: props.ssid, score: props.score};
		cdata.filters = [];
		for(name in (props.filter||{})) {
			cdata.filters.push(name+':'+props.filter[name]);
		}
		props.cdata = window.JSON.stringify(cdata);
		// Use params from props (if in whitelist)
		for(name in parameters) {
			if(name in props && props[name]) {
				parameters[name] = props[name];
			}
		}
		// Map parameters to GSA names
		for(name in PARAM_MAPPING) {
			if(name in parameters) {
				parameters[PARAM_MAPPING[name]] = parameters[name];
			}
			delete parameters[name];
		}
		// Convert params to query string
		parameters = search.util.param(parameters);
		return props.baseURL + '/click?' + parameters;
	}

	if(false) {
		// Visible for testing
		search.internals = search.internals || {};
		search.internals.gsa = {
			getTrackURL: getTrackURL
		};
	}

	var listeners = {
		// Listeners here
		generalClick: function(props) {
			if(props.backendType && props.backendType !== 'gsa') {
				return;
			}
			if(!props.baseURL) {
				// No URL, no tracking
				return;
			}

			var img = document.createElement('img');
			img.src = getTrackURL(props);
		}
	};
	search.trackers.gsa = listeners;
})(window.SCS = window.SCS || {});


/***/ }),
/* 63 */
/***/ (function(module, exports) {

// Add SCs_one.search.trackers_one.* tracking code here…
(function(SCS, debug) {
    'use strict';

    // jshint camelcase: false
    /* GetValOnce */
    function scGetValOnce(value, fieldname) {
        if (window.sessionStorage.getItem(fieldname) && String(value) === window.sessionStorage.getItem(fieldname)) return '';
        else {
            window.sessionStorage.setItem(fieldname, value);
            return value;
        }
    }

    // hotplugs for s_one functions
    var hotplug = {
        // apply item to list of not exists
        apl: function(array, item) {
            var narray = array;
            if (array.indexOf(item) < 0) narray.push(item); // push item if not in array
            return narray;
        },
        // cookie read
        c_r: function(a) {
            var b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
            return b ? b.pop() : 'undefined';
        }
    };

    var search = SCS.search = SCS.search || {};
    search.trackers = search.trackers || {};
    // Define track logic as functions that can be called from the listeners

    function querySearch(object) {
        window.SCS.tiq.trackingReadyCallbacks.push((function(object) {
            if (object.requester !== 'user' || object.origin !== 'serp' || object.page > 0 || object.fromFilterChange) return;

            var trackObj = SCS.datalayer.cloneMandatoryData();
            trackObj.apps = trackObj.apps || {};
            trackObj.apps.search = {};
            trackObj.apps.search.context = {};
            trackObj.apps.search.events = [];

            trackObj.apps.search.context['SERP'] = 'SERP_resultpage'; // this eVar should be present in all SERP pages, total seconds spent / instances = average
            trackObj.apps.search.events = ['searchQuery'];
            if (object.query) {
                trackObj.apps.search.context['SERP.query'] = object.query;
                if (scGetValOnce(object.query, 'SERP_query') !== '') trackObj.apps.search.events = hotplug.apl(trackObj.apps.search.events, 'newQueryTerm'); // every new query fires event
            }
            if (object.baseURL) trackObj.apps.search.context['SERP.baseURL'] = object.baseURL;
            if (object.endpointURL) trackObj.apps.search.context['SERP.endpointURL'] = object.endpointURL;
            if (object.backendType) trackObj.apps.search.context['SERP.backendType'] = object.backendType;
            if (object.resultCount) trackObj.apps.search.context['SERP.resultCount'] = object.resultCount;
            if (object.site) trackObj.apps.search.context['SERP.site'] = object.site;
            if (object.client) trackObj.apps.search.context['SERP.client'] = object.client;
            if (object.language) trackObj.apps.search.context['SERP.language'] = object.language;
            if (object.filter.Area) trackObj.apps.search.context['SERP.filter.Area'] = object.filter.Area;
            if (object.filter.Category) trackObj.apps.search.context['SERP.filter.Category'] = object.filter.Category;

            var sViCookie = hotplug.c_r('s_vi');
            if (sViCookie !== 'undefined') trackObj.apps.search.context['SERP.s_vi'] = sViCookie.replace('[CS]v1|', '').replace('[CE]', '');

            if (object.ssid && object.site) {
                trackObj.apps.search.context['SERP.ssid'] = object.ssid;
                var tmp3 = scGetValOnce(object.ssid, 'SERP_ssid');
                debug.log('value cookievalues:' + tmp3);
                debug.log(object);
                if (tmp3 !== '') trackObj.apps.search.events = hotplug.apl(trackObj.apps.search.events, 'firstQueryInSession'); // only the first search is been counted
            }

            SCS.datalayer.track(trackObj);
        })(object));
    }

    function resultlinktracking(object) {
        window.SCS.tiq.trackingReadyCallbacks.push((function(object) {
            var trackObj = SCS.datalayer.cloneMandatoryData();
            trackObj.apps = trackObj.apps || {};
            trackObj.apps.search = {};
            trackObj.apps.search.context = {};
            trackObj.apps.search.events = [];

            trackObj.apps.search.events = ['resultPageClick'];
            trackObj.apps.search.context['SERP'] = 'SERP_resultclick';

            if (object.ssid) trackObj.apps.search.context['SERP.ssid'] = object.ssid;
            if (object.sessionSequence) trackObj.apps.search.context['SERP.sessionSequence'] = object.sessionSequence;
            if (object.origin) trackObj.apps.search.context['SERP.origin'] = object.origin;
            if (object.ctype) {
                trackObj.apps.search.context['SERP.ctype'] = object.ctype;
                if (object.ctype === 'c' || object.ctype === 'ac' || object.ctype === 'keymatch') {
                    trackObj.apps.search.events = hotplug.apl(trackObj.apps.search.events, 'searchResultEntryClick'); // every click on a result in the middle (ctype c) is counted
                }
            }
            if (object.endpointURL) trackObj.apps.search.context['SERP.endpointURL'] = object.endpointURL;

            var sViCookie = hotplug.c_r('s_vi');
            if (sViCookie !== 'undefined') trackObj.apps.search.context['SERP.s_vi'] = sViCookie.replace('[CS]v1|', '').replace('[CE]', '');

            var tmp4;
            debug.log('object.site:' + object.site + ' object.ssid:' + object.ssid);
            if (object.ssid && object.site) {
                if (object.ctype === 'c' || object.ctype === 'ac' || object.ctype === 'keymatch') {
                    if (scGetValOnce(object.query, 'SERP_query_result') !== '') trackObj.apps.search.events = hotplug.apl(trackObj.apps.search.events, 'firstClickOnNewQueryTerm'); // only the first click for the query is been counted
                    tmp4 = scGetValOnce(object.ssid, 'SERP_ssid_result');
                    if (object.query && scGetValOnce(object.query, 'SERP_query') !== '') trackObj.apps.search.events = hotplug.apl(trackObj.apps.search.events, 'newQueryTerm'); // every new query fires event
                    debug.log('value cookievalues: ' + tmp4);
                    if (tmp4 !== '') trackObj.apps.search.events = hotplug.apl(trackObj.apps.search.events, 'firstClickOnSearchResult'); // only the first click on a result (ctype c or ac) is counted
                }
                if (object.ctype === 'ac' || object.ctype === 'keymatch') {
                    trackObj.apps.search.events = hotplug.apl(trackObj.apps.search.events, 'searchQuery'); //every query is tracked
                    trackObj.apps.search.context['SERP'] = 'SERP_query_resultpage'; // this eVar should be present in all SERP pages, total seconds spent / instances = average; override original value because of autocomplete detection
                    if (object.query) trackObj.apps.search.context['SERP.query'] = bject.query;
                    if (object.userQuery) trackObj.apps.search.context['SERP.userQuery'] = object.userQuery;
                    if (object.baseURL) trackObj.apps.search.context['SERP.baseURL'] = object.baseURL;
                    if (object.endpointURL) trackObj.apps.search.context['SERP.endpointURL'] = object.endpointURL;
                    if (object.backendType) trackObj.apps.search.context['SERP.backendType'] = object.backendType;
                    if (object.resultCount) trackObj.apps.search.context['SERP.resultCount'] = object.resultCount;
                    if (object.site) trackObj.apps.search.context['SERP.site'] = object.site;
                    if (object.client) trackObj.apps.search.context['SERP.client'] = object.client;
                    if (object.language) trackObj.apps.search.context['SERP.language'] = object.language;
                    if (object.filter.Area) trackObj.apps.search.context['SERP.filter.Area'] = object.filter.Area;
                    if (object.filter.Category) trackObj.apps.search.context['SERP.filter.Category'] = object.filter.Category;

                    tmp4 = scGetValOnce(object.ssid, 'SERP_ssid');
                    debug.log('value cookievalues:' + tmp4);
                    debug.log(object);
                    if (tmp4 !== '') trackObj.apps.search.events = hotplug.apl(trackObj.apps.search.events, 'firstQueryInSession'); // only the first search is been counted
                }
            }
            SCS.datalayer.track(trackObj);
            debug.log(object);
        })(object));
    }

    function noResultsFound(object) {
        window.SCS.tiq.trackingReadyCallbacks.push((function(object) {
            if (object.requester !== 'user' || object.origin === 'header') return;

            var trackObj = SCS.datalayer.cloneMandatoryData();
            trackObj.apps = trackObj.apps || {};
            trackObj.apps.search = {};
            trackObj.apps.search.context = {};
            trackObj.apps.search.events = [];

            trackObj.apps.search.events = ['noResults'];
            trackObj.apps.search.context['SERP'] = 'SERP_noresult';

            if (object.ssid) trackObj.apps.search.context['SERP.ssid'] = object.ssid;
            if (object.sessionSequence) trackObj.apps.search.context['SERP.sessionSequence'] = object.sessionSequence;
            if (object.origin) trackObj.apps.search.context['SERP.origin'] = object.origin;
            if (object.query) trackObj.apps.search.context['SERP.query'] = object.query;
            if (object.endpointURL) trackObj.apps.search.context['SERP.endpointURL'] = object.endpointURL;

            SCS.datalayer.track(trackObj);
            debug.log(object);
        })(object));
    }

    function automaticSpellingCor(object) {
        window.SCS.tiq.trackingReadyCallbacks.push((function(object) {
            var trackObj = SCS.datalayer.cloneMandatoryData();
            trackObj.apps = trackObj.apps || {};
            trackObj.apps.search = {};
            trackObj.apps.search.context = {};
            trackObj.apps.search.events = [];

            trackObj.apps.search.context['SERP'] = 'SERP_autoSpellingCorrection';
            if (object.ssid) trackObj.apps.search.context['SERP.ssid'] = object.ssid;
            if (object.sessionSequence) trackObj.apps.search.context['SERP.sessionSequence'] = object.sessionSequence;
            if (object.origin) trackObj.apps.search.context['SERP.origin'] = object.origin;
            if (object.endpointURL) trackObj.apps.search.context['SERP.endpointURL'] = object.endpointURL;
            if (object.previousQuery) trackObj.apps.search.context['SERP.autoCorrection.previousQuery'] = object.previousQuery;
            if (object.query) trackObj.apps.search.context['SERP.autoCorrection.newQuery'] = object.query;

            SCS.datalayer.track(trackObj);
            debug.log(object);
        })(object));
    }

    search.trackers.sc = {
        generalClick: resultlinktracking,
        searchQuery: querySearch,
        noResults: noResultsFound,
        automaticSpellingCorrection: automaticSpellingCor
    };
})
(window.SCS = window.SCS || {}, window.debug);

/***/ }),
/* 64 */
/***/ (function(module, exports) {

(function(SCS) {
	'use strict';

	// jshint maxparams: 10

	var search = SCS.search = SCS.search || {};
	var plugins = search.plugins = search.plugins || {};

	function baseSetup(urlPrefix, suffix, backendType, defaultConfig, customConfig) {
		urlPrefix = urlPrefix || '';
		// Create processor (use global backend)
		var processor = new search.Processor();

		var url = plugins.url;
		// Add URL handling
		url.setUp(
			processor,
			null,
			url.setBaseURL(urlPrefix, '/' + suffix, backendType),
			url.addDefaultConfig(
				defaultConfig,
				customConfig
			),
			url.transposeParams(url.transposeParams.GSA_MAP)
		);

		return processor;
	}

	function gsaSetup(urlPrefix, type, customConfig, sites) {
		var url = plugins.url;
		var gsa = plugins.gsa;

		var defaultConfig = url.addDefaultConfig['GSA_' + type.toUpperCase() + '_CONFIG'] || {};
		var processor = baseSetup(urlPrefix, type, 'gsa', defaultConfig,  customConfig);

		// Add GSA handling (use global session)
		gsa.setUp(processor, gsa.addFilterParams(), gsa.addSiteParams(sites));
		// Add Session handling (use global session)
		plugins.session.setUp(processor);

		return processor;
	}

	function webSetup(urlPrefix, customConfig) {
		var url = plugins.url;
		var gsa = plugins.gsa;
		var web = plugins.web;

		var processor = baseSetup(urlPrefix, 'web/', 'google', url.addDefaultConfig.DEFAULT_QUERY,  customConfig);

		// We use the paging from gsa plugin but not the whole set-up
		processor.usePre(gsa.handlePaging(), 50000);

		web.setUp(processor);

		return processor;
	}

	function forSerp(urlPrefix, site, client, language, customConfig) {
		customConfig = search.util.extend({}, {
			language: language,
			client: client,
			origin: 'serp'
		}, customConfig||{});
		var processor = gsaSetup(urlPrefix, 'search', customConfig, site);

		// Add spell-checking
		plugins.spellchecking.setUp(processor);
		// Add filtering
		plugins.filtering.setUp(processor);
		// Add tracking
		plugins.tracking.setUp(processor);

		return processor;
	}

	function forWebSearch(urlPrefix, language, customConfig) {
		customConfig = search.util.extend({}, {
			language: language,
			origin: 'serp'
		}, customConfig||{});
		var processor = webSetup(urlPrefix, customConfig);

		return processor;
	}

	function split(sites) {
		if(typeof sites === 'string') {
			return sites.split(/\|+/);
		}
		return sites || [];
	}

	function keymatchSetup(urlPrefix, site, client, keyMatchLimit, language, instantCollectionSuffix, customConfig) {
		site = split(site);
		instantCollectionSuffix = instantCollectionSuffix || '';
		for(var i=0;i<site.length;i+=1) {
			site[i] = site[i] + instantCollectionSuffix;
		}
		var config = search.util.extend({
			client: client,
			keyMatchLimit: keyMatchLimit||2,
			language: language,
			resultLimit: 0
		}, customConfig||{});

		return gsaSetup(urlPrefix, 'search', config, site);
	}

	function forKeymatches(urlPrefix, site, client, keyMatchLimit, language, instantCollectionSuffix, customConfig) {
		var processor = keymatchSetup(urlPrefix, site, client, keyMatchLimit, language, instantCollectionSuffix, customConfig);
		// On SERP, do redirect to webcodes
		plugins.keymatch.setUp(processor, null, null, plugins.keymatch.redirectToKeymatch());
		return processor;
	}

	function forAutosuggest(urlPrefix, site, client, suggestionLimit, keyMatchLimit, language, instantCollectionSuffix) {
		language = language || 'de';
		keyMatchLimit = parseInt(keyMatchLimit, 10);

		var processor = gsaSetup(urlPrefix, 'suggest', {
			language: language,
			suggestionLimit: suggestionLimit,
			origin: 'header',
			client: client,
			site: site
		});

		var keymatchProcessor;
		// Only load keymatches if explicitly configured with limit > 0
		if(keyMatchLimit) {
			keymatchProcessor = keymatchSetup(urlPrefix, site, client, keyMatchLimit, language, instantCollectionSuffix, {
				origin: 'header'
			});

			// Don’t redirect to webcodes
			plugins.keymatch.setUp(keymatchProcessor);
		}
		var keymatchRetriever = keymatchProcessor ? plugins.autosuggest.retrieveKeymatchesFromSuggestions(keymatchProcessor) : null;
		plugins.autosuggest.setUp(processor, keymatchRetriever);

		return processor;
	}

	function forClusterSuggestions(urlPrefix, site, client, language) {
		urlPrefix = urlPrefix || '';
		var processor = gsaSetup(urlPrefix, 'cluster', {
			language: language,
			method: 'POST',
			client: client
		}, site);
		return processor;
	}

	function forResultCount(urlPrefix, site, client, language) {
		var processor = gsaSetup(urlPrefix, 'search', {
			language: language,
			client: client,
			proxystylesheet: 'sc_v2_p_json_count',
			gsaFilter: 'duplicateSnippet'
		}, site);

		return processor;
	}

	var orchestration = search.orchestration = search.orchestration || {};

	orchestration.forSerp = forSerp;
	orchestration.forWebSearch = forWebSearch;
	orchestration.forKeymatches = forKeymatches;
	orchestration.forAutosuggest = forAutosuggest;
	orchestration.forClusterSuggestions = forClusterSuggestions;
	orchestration.forResultCount = forResultCount;

})(window.SCS = window.SCS || {});

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module, $, SCS) {
	'use strict';

	var KEYS = {
		ESCAPE: 27,
		DOWN: 40,
		UP: 38,
		ENTER: 13
	};
	var PROCESS_WAIT_TIMEOUT = 200;

	function stop(event) {
		event.preventDefault();
	}

	function getSelectedSuggestion(mod) {
		if(mod.selectedIndex in mod.suggestions) {
			return mod.suggestions[mod.selectedIndex];
		}
		return null;
	}

	// Click handler for a suggest item
	function activateSuggestion(mod, suggestion) {
		// Tracking
		Module.SearchResultContainer.trackClick('suggestion', mod.suggestConfig, suggestion, mod.searchProcessor);
		// Set the form value and let the submit handle the rest
		mod.$field.val(suggestion.name);
		mod.$form.submit();
	}

	function updateSelectedIndex(mod, index) {
		mod.selectedIndex = index;
		updateDom(mod);
	}

	function selectionChanged(mod, delta) {
		var newSelectedIndex = mod.selectedIndex + delta;
		if(newSelectedIndex < -1) {
			// On arrow-up, if nothing is selected, select the last item available
			newSelectedIndex = mod.suggestions.length + newSelectedIndex + 1;
		}
		if(newSelectedIndex >= mod.suggestions.length) {
			// On arrow-down at the last item, begin again with being unselected
			newSelectedIndex = -1;
		}
		updateSelectedIndex(mod, newSelectedIndex);
	}

	function updateDom(mod) {
		var selectedSuggestion = getSelectedSuggestion(mod);
		var results = mod.suggestions;
		var snabbdom = window.snabbdom;
		var h = snabbdom.h;
		var contents = [];
		for(var i=0;i<results.length;i+=1) {
			var result = results[i];
			contents.push(h(
				'li.scs-sitesearch-autosuggest-li',
				{
					'class': {
						'scs-sitesearch-searchfield-hoveractive': result === selectedSuggestion
					},
					on: {
						click: [activateSuggestion, mod, result],
						// Don’t let the mousedown trigger a blur of the input field (otherwise we don’t get a click)
						mousedown: stop
					}
				},
				result.name
			));
		}

		var suggestions = h('ul.suggestions', contents);
		mod.suggestResultContent = snabbdom.patch(mod.suggestResultContent, suggestions);
		mod.$instantResultContainer.toggleClass('has-results', !!results.length);

		if(selectedSuggestion) {
			mod.$field.val(selectedSuggestion.name);
		} else {
			mod.$field.val(mod.prevFieldVal);
		}
	}

	function suggestData(processor, data, config) {
		// jshint validthis: true
		this.selectedIndex = -1;
		this.suggestions = data.results || [];
		this.suggestConfig = config;
		updateDom(this);
	}

	function suggestError() {
		// jshint validthis: true
		this.selectedIndex = -1;
		this.suggestions = [];
		updateDom(this);
	}

	function setupSuggestions(mod, $field, $form) {
		var numberOfSuggestions = parseInt($field.attr('data-sitesearch-gsanumberofresults'), 10);
		if(!numberOfSuggestions) {
			return;
		}
		mod.$instantResultContainer = mod.$ctx.find('.scs-sitesearch-searchfield-autosuggest');
		if(!mod.$instantResultContainer.length) {
			return;
		}

		$field.attr('autocomplete', 'off');
		mod.$field = $field;
		mod.$form = $form;

		mod.searchProcessor = SCS.search.orchestration.forAutosuggest(
			$field.attr('data-sitesearch-gsahostname'),
			$field.attr('data-sitesearch-sites'),
			$field.attr('data-sitesearch-client'),
			$field.attr('gsanumberofresults'),
			0, // No keymatches
			$('html').attr('lang') || 'de'
		);
		mod.searchProcessor.responder(SCS.search.util.respondTo({
			'data': $.proxy(suggestData, mod),
			'error': $.proxy(suggestError, mod)
		}, mod));


		$field.on('keydown', function(event) {
			if(event.keyCode === KEYS.UP) {
				selectionChanged(mod, -1);
			} else if(event.keyCode === KEYS.DOWN) {
				selectionChanged(mod, +1);
			} else {
				return;
			}
			// Do not further process the key press:
			// * Do not trigger a new search
			// * Do not move the cursor the beginning or end when navigating suggestions or keymatches
			event.stopImmediatePropagation();
			return false;
		});
		var processKeyPressTimeout = null;

		$field.on('input keypress', function(event) {
			if(event.which === KEYS.ENTER) {
				// Selected suggestions already updated the field value with the suggestion
				// and normal searches can just trigger the regular form submit
				return;
			}
			var value = $field.val();
			if(value === mod.prevFieldVal) {
				return;
			}

			mod.prevFieldVal = value;

			clearTimeout(processKeyPressTimeout);
			processKeyPressTimeout = setTimeout(function() {
				processKeyPressTimeout = null;
				mod.searchProcessor.process({query: value});
			}, PROCESS_WAIT_TIMEOUT);
		});

		$field.on('focus', function() {
			mod.$instantResultContainer.addClass('focused');
		}).on('blur', function() {
			mod.$instantResultContainer.removeClass('focused');
		});

		mod.suggestResultContent = $('<ul/>').appendTo(mod.$instantResultContainer)[0];
	}

	// For the legacy header
	var HeaderSearchQueryForm = Module.extend({
		// The currently-selected suggestion
		selectedIndex: -1,
		// The list of suggestions
		suggestions: [],
		// The configuration for the suggest request
		suggestConfig: {},
		// The previous search value (before overwriting the search field with the text from the selected suggestion)
		prevFieldVal: '',

		on: function(callback) {
			callback();
		},

		after: function() {
			this.attachListeners();
		},

		attachListeners: function() {
			var $form = this.$ctx;
			var $field = $form.find('input[name="q"]');
			$form.on('submit', function(event) {
				event.preventDefault();
				var target = $form.attr('action');
				var pivot = '#'; // RESOLVE: Do we need to use query params at one point or is the hash always ok?
				var separator = target.indexOf(pivot) > -1 ? '&' : pivot;
				var query = {query: $field.val()};
				target = target + separator + SCS.search.util.param(query);
				window.location.href = target;
			});

			var $toggleIcon = $form.closest('.modMobileHeader').find('.scs-sitesearch-icon');
			$toggleIcon.click(function() {
				$toggleIcon.toggleClass('scs-sitesearch-active-icon');
				if($toggleIcon.hasClass('scs-sitesearch-active-icon')) {
					$form.slideDown('fast');
				} else {
					$form.slideUp('fast');
				}
			});

			// custom event fired by scsSiteSearch.Serp.init()
			$(document).on('scsSiteSearch-serp-query', function (event, q) {
				// we are on a search result page (SERP)

				$toggleIcon.removeClass('scs-sitesearch-active-icon').click();
				$field.val(q);
			});

			setupSuggestions(this, $field, $form);
		}
	});

	Module.HeaderSearchQueryForm = HeaderSearchQueryForm;

})(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$, window.SCS = window.SCS || {});

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module, $, SCS) {
	'use strict';

	var OftenSearchedLinkBox = Module.extend({
		// The container module instance (for setting config changes and the like)
		searchContainer: null,

		on: function(callback) {
			callback();
		},

		after: function() {
			this.findElements();
		},

		initSearch: function(searchContainer) {
			this.searchContainer = searchContainer;
		},

		findElements: function() {
			var mod = this;
			mod.$links = this.$ctx.find('.scs-sitesearch-oftensearchedbox-list-item > a');
			mod.$links.each(function() {
				var $link = $(this);
				$link.click(function() {
					// Force the session to increase for the next request
					mod.searchContainer.sessionOptions.forceOnce = 'next';
					// Track clicks.
					Module.SearchResultContainer.trackClick(
						'often',
						{},
						{
							url: $link.prop('href'),
							query: $link.attr('data-sitesearch-query')
						},
						// We don’t have a search processor instance so just use the prototype as it has the same methods.
						SCS.search.Processor.prototype
					);
				});
			});
		}

	});

	Module.OftenSearchedLinkBox = OftenSearchedLinkBox;

})(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$, window.SCS = window.SCS || {});

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module, $, SCS) {
	'use strict';

	var SearchClusterSuggestions = Module.extend({
		// The container module instance (for setting config changes and the like)
		searchContainer: null,
		// The search processor instance for getting the cluster suggestions
		searchProcessor: null,

		on: function(callback) {
			callback();
		},

		after: function() {
			this.findElements();
			this.attachListeners();
		},

		initSearch: function(searchContainer) {
			var mod = this;

			mod.searchContainer = searchContainer;

			var $config = mod.$ctx.closest('.search-configuration');
			if(!$config.length) {
				// Configuration on search field could also be outside
				$config = searchContainer.$config;
			}

			mod.searchProcessor = SCS.search.orchestration.forClusterSuggestions(
				$config.attr('data-sitesearch-gsahostname'),
				$config.attr('data-sitesearch-sites'),
				$config.attr('data-sitesearch-client'),
				$('html').attr('lang') || 'de'
			);
			mod.searchProcessor.responder(SCS.search.util.respondTo({
				data: mod.clusterData
			}, mod));
			mod.searchProcessor.responder(SCS.search.util.respondTo({
				data: searchContainer.stopLoading,
				error: searchContainer.stopLoading,
				abort: searchContainer.stopLoading
			}, searchContainer));
		},

		searchConfigChanged: function(searchConfig) {
			this.searchContainer.startLoading();
			this.searchProcessor.process(searchConfig);
		},

		clusterData: function(processor, data, config) {
			var clusters = data.clusters || [];
			clusters = clusters[0] || {};
			clusters = clusters.clusters || [];
			if(clusters.length < this.minSearchResults) {
				clusters = [];
			}
			clusters = clusters.slice(0, this.maxSearchResults);

			this.$ctx.toggleClass('active', !!clusters.length);
			this.$title.text(SCS.utils.formatString(
				this.titleFormat,
				config.query
			));

			var snabbdom = window.snabbdom;
			var h = snabbdom.h;

			var listSize = Math.ceil(this.maxSearchResults/2);
			var lists = [];
			while(clusters.length) {
				lists.push(this.renderList(clusters.splice(0, listSize), processor, config, h));
			}

			this.resultContainer = snabbdom.patch(this.resultContainer, h('div.scs-sitesearch-cluster-suggestions-results', lists));
		},

		renderList: function(clusters, processor, config, h) {
			var items = [];
			for(var i=0;i<clusters.length;i+=1) {
				var cluster = clusters[i];
				items.push(h(
					'li',
					[
						h(
							'a',
							{
								props: {
									href: '#'+SCS.search.util.param({q: cluster.label})
								},
								on: {
									click: [this.trackClick, cluster, processor, config]
								}
							},
							[cluster.label]
						)
					]
				));
			}
			return h(
				'ul',
				items
			);
		},

		trackClick: function(cluster, processor, config) {
			Module.SearchResultContainer.trackClick(
				'cluster',
				config,
				{
					previousQuery: config.query,
					query: cluster.label,
					url: document.location.href
				},
				processor
			);
		},

		findElements: function() {
			this.minSearchResults = Math.max(1, this.$ctx.data('minSearchResults') || 0);
			this.maxSearchResults = this.$ctx.data('maxSearchResults') || 8;
			this.titleFormat = this.$ctx.attr('data-title');
			this.$title = this.$ctx.find('div.title h3');
			this.resultContainer = this.$ctx.find('.scs-sitesearch-cluster-suggestions-results')[0];
		},

		attachListeners: function() {
		}

	});

	Module.SearchClusterSuggestions = SearchClusterSuggestions;

})(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$, window.SCS = window.SCS || {});

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module, $, SCS) {
	'use strict';

	var SearchPreviewLink = Module.extend({
		// The container module instance (for setting config changes and the like)
		searchContainer: null,
		// The search processor instance for retrieving the result count
		searchProcessor: null,
		// The search config that was previosly used, for sending the correct click event
		previousConfig: null,

		on: function(callback) {
			callback();
		},

		after: function() {
			var mod = this;
			mod.contentsContainer = mod.$ctx.find('> .contents')[0];
			mod.translations = {
				titleFormat: mod.$ctx.attr('data-translation-title-format')
			};
			mod.linkTitle = mod.$ctx.attr('data-sitesearch-linkTitle');

			// Set the href (except the query)
			var redirectTarget = mod.$ctx.attr('data-sitesearch-redirectTarget');
			var useGetParam = mod.$ctx.data('sitesearchUsegetparam');
			var pivot = useGetParam ? '?' : '#';
			var separator = redirectTarget.indexOf(pivot) > -1 ? '&' : pivot;
			mod.url = redirectTarget + separator;

			mod.$title = mod.$ctx.find('.title-container');
			mod.$container = mod.$ctx.closest('.scs-sitesearch-link-list');

			mod.$ctx.on('click', function() {
				if(!mod.previousConfig) {
					return;
				}
				Module.SearchResultContainer.trackClick('search_other', mod.previousConfig, {
					url: mod.$ctx.prop('href')
				}, mod.searchProcessor);
			});
		},

		initSearch: function(searchContainer) {
			var mod = this;
			mod.searchContainer = searchContainer;
			mod.searchProcessor = SCS.search.orchestration.forResultCount(
				mod.$ctx.attr('data-sitesearch-gsahostname'),
				mod.$ctx.attr('data-sitesearch-sites'),
				mod.$ctx.attr('data-sitesearch-client'),
				$('html').attr('lang') || 'de'
			);
			mod.searchProcessor.responder(SCS.search.util.respondTo({
				data: mod.countReceived
			}, mod));
			mod.searchProcessor.responder(SCS.search.util.respondTo({
				data: searchContainer.stopLoading,
				error: searchContainer.stopLoading,
				abort: searchContainer.stopLoading
			}, searchContainer));
		},

		searchConfigChanged: function(searchConfig) {
			// Hide the container (every item will do this)
			this.$container.hide().removeClass('');
			this.process({query: searchConfig.query});
		},

		process: function(config) {
			this.searchContainer.startLoading();
			this.searchProcessor.process(config);
		},

		countReceived: function(processor, data, config) {
			this.previousConfig = config;
			this.$ctx.prop('href', this.url + SCS.search.util.param({q: config.query}));
			this.$title.text(
				SCS.utils.formatString(
					this.translations.titleFormat,
					this.linkTitle,
					data.resultCount
				)
			);
			if(data.resultCount > 0) {
				this.$ctx.show();
				// Show the container if at least one item had results
				this.$container.show();
			} else {
				this.$ctx.hide();
			}
		}

	});

	Module.SearchPreviewLink = SearchPreviewLink;

})(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$, window.SCS = window.SCS || {});

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module) {
	'use strict';

	var SearchPromoBox = Module.extend({
		on: function(callback) {
			callback();
		},

		after: function() {
			this.findElements();
		},

		// Mark us a search-dependent module
		initSearch: function() {},

		findElements: function() {
			this.data = this.$ctx.data();
			this.$content = this.$ctx.children('div:eq(0)');
			this.id = this.$content.attr('id');
		},

		getAdConfig: function() {
			// FIXME: Implement hiding when keymatches are present (if this.data.hideIfKeymatches)
			return {
				container: this.id,
				number: this.data.sitesearchNumberOfAds,
				width: 'auto',
				lines: this.data.sitesearchNumberOfLines,
				fontFamily: 'Trebuchet MS',
				fontSizeTitle: 15,
				fontSizeDescription: 13,
				fontSizeDomainLink: 13,
				colorTitleLink: '#' + this.data.sitesearchColorTitleLink,
				colorText: '#' + this.data.sitesearchColorLink,
				colorDomainLink: '#' + this.data.sitesearchColorDomainLink,
				colorBackground: '#' + this.data.sitesearchColorBackground,
				noTitleUnderline: true
			};
		}
	});

	Module.SearchPromoBox = SearchPromoBox;

})(window.Tc.Module);

}.call(window));

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module, $) {
	'use strict';

	var SearchPromoContainer = Module.extend({
		on: function(callback) {
			callback();
		},

		after: function() {
			this.data = this.$ctx.data();
		},

		// Mark us a search-dependent module
		initSearch: function() {},

		searchConfigChanged: function(searchConfig, searchContainer) {
			if(!window.google || !window.google.ads || !window.google.ads.search || !window.google.ads.search.Ads) {
				return;
			}
			var promoBoxes = searchContainer.internalModulesByName('SearchPromoBox');
			var configs = [];
			$.each(promoBoxes, function(i, promoBox) {
				var config = promoBox.getAdConfig();
				if(config) {
					configs.push(config);
				}
			});
			if(!configs.length) {
				return;
			}
			var pageConfig = this.getPageConfig(searchConfig.query);
			try {
				window.google.ads.search.Ads(pageConfig, configs);
			} catch(e) {}
		},

		getPageConfig: function(query) {
			return {
        pubId: this.data.sitesearchSwisscomAdsenseID,
        query: query,
        hl: $('html').attr('lang') || 'de',
        adtest: 'off',
        siteLinks: false,
        oe: 'UTF-8',
        ie: 'UTF-8',
        domainLinkAboveDescription: false
			};
		}
	});

	Module.SearchPromoContainer = SearchPromoContainer;

})(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$);

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module, $, SCS) {
	'use strict';

	var deparam = __webpack_require__(10).default;

	// Handles:
	//  • getting/setting query and filters
	//  • notifying search-related internal modules (SearchResultDisplay, SearchResultFilter, SearchResultClusterSuggestions, SearchResultQueryBox) of changed config (query/filters).
	//      Note: all of these need a class “searchInternal”.
	//  • communication with outside (NPE header search field, URL-Hash)
	var SearchResultContainer = Module.extend({
		// The current query
		query: null,
		// The current filters in the following form:
		// {
		// 		Area: '1_residential1_residential'
		// }
		filter: {},
		// Force the session to change (or remain) on the next request
		sessionOptions: null,
		// Keep track of search queries that were triggered by changed filters (relevant for tracking)
		fromFilterChange: false,
		// Array of all internal search modules that need be notified if the config changes
		internals: null,
		// How many result displays are currently loading
		loading: 0,

		on: function(callback) {
			if(this.debug) {
				window.searchResultContainer = this;
			}
			// Create a long-lasting options object
			this.sessionOptions = {};
			callback();
		},

		after: function() {
			var mod = this;
			mod.findElements();
			// Use a timeout to guarantee that the dependent modules’ “after” initializers have run
			window.setTimeout(function() {
				mod.queryFromHash();
			}, 0);
		},

		findElements: function() {
			var mod = this;
			this.internals = [];

			// Find the element where the search params are configured. Prefer the main modSearchResultDisplay accordion
			mod.$config = mod.$ctx.find('.modSearchResultDisplay.search-configuration');
			if(mod.$config.length !== 1) {
				// Find the config that is first in the DOM (from the search field)
				mod.$config = mod.$ctx.find('.search-configuration:eq(0)');
			}

			this.$ctx.find('.mod.searchInternal').each(function() {
				var modules = mod.sandbox.getModuleInstances(this);
				$.each(modules, function(i, module) {
					if('initSearch' in module) {
						mod.internals.push(module);
					}
				});
			});
			
			$.each(this.internals, function(i, module) {
				module.initSearch(mod);
			});
			
			$(window).on('hashchange', function() {
				mod.queryFromHash();
			});
		},

		currentConfig: function() {
			return {
				query: this.query,
				filter: this.filter,
				sessionOptions: this.sessionOptions,
				fromFilterChange: this.fromFilterChange
			};
		},

		internalModulesByName: function(modName) {
			var result = [];
			$.each(this.internals, function(i, module) {
				if(module.modName === modName) {
					result.push(module);
				}
			});
			return result;
		},

		configChanged: function(fromFilterChange) {
			var mod = this;

			mod.configUpdated();

			// Keep track of search queries that were triggered by changed filters
			mod.fromFilterChange = !!fromFilterChange;

			$.each(this.internals, function(i, module) {
				if('searchConfigChanged' in module) {
					module.searchConfigChanged(mod.currentConfig(), mod);
				}
			});
			
		},

		// Called when the search logic has changed the configuration but a new search should not immediately be triggered.
		configUpdated: function() {
			var mod = this;

			// fire custom event so header search fields can update themselves
			$(document).trigger('scsSiteSearch-serp-query', [mod.query, mod.filter]);

			$.each(this.internals, function(i, module) {
				if('searchConfigUpdated' in module) {
					module.searchConfigUpdated(mod.currentConfig(), mod);
				}
			});

			mod.updateHash();
		},

		updateHash: function() {
			var param = SCS.search.util.param;

			var params = {};
			if(this.query) {
				params.q = this.query;
			}
			// Paramizing empty objects yields the empty string.
			// When leaving the filter as an object, there would be no way to distinguish
			// between the explicit and the implicit case for no filters set.
			params.filter = param(this.filter);
			
			// TODO: if the query or filter wasn’t previously represented in the hash, use location.replace so that arrow navigation is still correct
			window.location.hash = '#' + param(params);
		},

		queryFromHash: function() {
			var hash = window.location.href;
			var index = hash.indexOf('#');
			if(index > -1) {
				hash = hash.substring(index + 1);
			} else {
				hash = '';
			}
			hash = deparam(hash);
			var changed = false;
			if(hash.q && hash.q !== this.query) {
				changed = true;
				this.query = hash.q;
			}
			if('filter' in hash && hash.filter !== SCS.search.util.param(this.filter)) {
				changed = true;
				this.filter = deparam(hash.filter);
			}
			if(changed) {
				this.configChanged();
			}
		},

		startLoading: function() {
			this.loading += 1;
			this.updateLoading();
		},

		stopLoading: function() {
			this.loading -= 1;
			this.updateLoading();
		},

		updateLoading: function() {
			var mod = this;

			if(mod.loading < 0) {
				mod.log.warn('Loading indicator counter below 0', mod.loading);
			}
			mod.$ctx.toggleClass('loading', mod.loading > 0);

			if(mod.loading === 0) {
				$.each(mod.internals, function(i, module) {
					if('searchProcessingDone' in module) {
						module.searchProcessingDone(mod.currentConfig(), mod);
					}
				});
			}
		}

	});

	SearchResultContainer.ellipsis = function ellipsis(elements) {
		elements.each(function () {
			var element = $(this),
				previousMaxHeight = this.style.maxHeight || 'none',
				previousHeight = this.style.height || 'auto',
				targetHeight = element.height(),
				lineHeight = parseInt(element.css('line-height'), 10),
				maxLines = Math.max( (targetHeight / lineHeight), 1),
				maxCutCharacters = 400,
				text = element.text();

			if (targetHeight > 0) {
				element.css({
					'max-height': 'none',
					'height': 'auto'
				});
				var currentLines = Math.round(element.height() / lineHeight);
				// jshint plusplus: false
				while (text.length > 0 && currentLines > maxLines && maxCutCharacters-- > 0) {
					text = text.substr(0, text.length - 1);
					element.text(text + '\u2026');
					currentLines = Math.round(element.height() / lineHeight);
				}

				element.css({
					'max-height': previousMaxHeight,
					'height': previousHeight
				});
			}
		});
	};

	// Strips HTML (from safe sources like the GSA), flattens tags and unescapes entities
	SearchResultContainer.unsafelyStripHTML = function(html) {
		return $('<div/>').html(html).text();
	};

	// Make the hightlights in the snippets survive the HTML stripping (as snabbdom VDom elements)
	SearchResultContainer.snippetToVDomElements = function(html, h) {
		html = html.split(/<\/?b>/g);
		return $.map(html, function(text, i) {
			text = SearchResultContainer.unsafelyStripHTML(text);
			var plain = i%2 === 0;
			if(plain) {
				return text;
			}
			return h('em.highlight', [text]);
		});
	};

	// Prepares a data object for click tracking, sends it off to the processor
	SearchResultContainer.trackClick = function(cType, config, item, processor) {
		var data = SCS.search.util.extend({}, config, item, {
			ctype: cType || 'c',
			start: config.offset,
			href: item.url || item.link
		});
		processor.track('generalClick', data);
	};



	Module.SearchResultContainer = SearchResultContainer;

})(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$, window.SCS = window.SCS || {});

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module, $, SCS) {
	'use strict';

	var MIME_SUFFIXES = {
		'application/pdf': 'PDF',
		'application/msword': 'DOC',
		'application/excel': 'XLS',
		'application/vnd.ms-excel': 'XLS',
		'application/x-excel': 'XLS',
		'application/x-msexcel': 'XLS',
		'application/mspowerpoint': 'PPT',
		'application/powerpoint': 'PPT',
		'application/vnd.ms-powerpoint': 'PPT',
		'application/x-mspowerpoint': 'PPT',
		'text/plain': 'TXT',
		'application/rtf': 'RTF',
		'application/x-rtf': 'RTF',
		'text/richtext': 'RTF',
		'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCX',
		'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'XLSX',
		'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'PPTX'
	};

	var STAR = '★';

	// Normalizes URLs from search results for the purposes of de-duplication:
	// • Remove selectors
	// • Remove query params and hash params
	// • Remove product specifiers for family pages
	function normalizeURL(url) {
		var index;

		index = url.indexOf('#');
		if(index > -1) {
			url = url.substring(0, index);
		}
		index = url.indexOf('?');
		if(index > -1) {
			url = url.substring(0, index);
		}
		url = url.split('/');

		var lastPart = url.pop();
		// Remove product family item specifier (e.g. `(N_NATEL RES 2.0 XL,24,000000000010247106)`)
		lastPart = lastPart.replace(/\([^()]+\)/, '');
		// Remove selectors
		lastPart = lastPart.split('.');
		var extension = lastPart.pop();
		lastPart = lastPart.slice(0, 1);
		lastPart.push(extension);
		url.push(lastPart.join('.'));

		return url.join('/');
	}

	var SearchResultDisplay = Module.extend({
		// The container module instance (for setting config changes and the like)
		searchContainer: null,
		// The search processor instance for this specific search result accordion with its GSA sites and client
		searchProcessor: null,
		// The current page we’re on
		pageNumber: 0,
		// The previous results
		prevResults: [],
		// Mapping from categoru names to iconfont characters
		iconMap: null,
		// If this is the only SearchResultDisplay in the current SearchResultContainer
		isSingle: false,
		// The SearchResultTitle component to display titles in (if isSingle is true)
		titleModule: null,
		// The last-recently loaded data
		currentData: {},
		// The last-recently loaded config
		currentConfig: {},
		// URLs of all last-recently loaded keymatches (for deduplication)
		currentDisplayedKeymatchURLs: {},
		// The element the search config is on
		$config: null,
		// Display the search results with images and ratings 
		enhancedResults: false,
		// True when findelements got called before
		foundElements : false,

		on: function(callback) {
			callback();
		},

		after: function() {
			this.findElements();
			this.attachListeners();

			var $accordionTitle = this.$ctx.find('.scs-sitesearch-accordion-title');
			if(!$accordionTitle.text().trim()) {
				$accordionTitle.hide();
			}			
		},

		initSearch: function(searchContainer) {
			var mod = this;
		
			this.findElements();
			mod.searchContainer = searchContainer;

			// Do communication
			var siblings = searchContainer.internalModulesByName('SearchResultDisplay');

			mod.isSingle = siblings.length === 1 && siblings[0] === mod;
			if(mod.isSingle) {
				mod.titleModule = searchContainer.internalModulesByName('SearchResultTitle')[0];
			}

			if(mod.isSingle && mod.enhancedResults) {
				searchContainer.$ctx.addClass('scs-sitesearch-enhanced-results');
			}

			mod.$config = mod.$ctx.closest('.search-configuration');
			if(!mod.$config.length) {
				// Configuration on search field could also be outside
				mod.$config = searchContainer.$config;
			}

			mod.initSearchProcessor();
		},

		searchConfigChanged: function(searchConfig) {
			this.pageNumber = 0;
			this.process(searchConfig);
		},

		process: function(config) {
			config.page = this.pageNumber;
			this.searchContainer.startLoading();
			this.searchProcessor.process(config);
		},

		findElements: function() {
			// only do that once
			if(this.foundElements) {
				return;
			}
			this.foundElements = true;
			this.resultContainer = this.$ctx.find('.scs-sitesearch-accordion-content-first-results')[0];
			this.additionalResultsContainer = this.$ctx.find('.scs-sitesearch-accordion-content-more-results')[0];
			this.$titleContainer = this.$ctx.find('.title-container');
			this.title = this.$titleContainer.text();
			this.titleFormat = this.$ctx.attr('data-sitesearch-title-format');
			this.enhancedResults = this.$ctx.data('sitesearch-enable-enhanced-results');

			this.iconMap = {};
			try {
				var icons = this.$ctx.attr('data-sitesearch-category-icons');
				if(icons) {
					this.iconMap = window.JSON.parse(icons);
				}
			} catch(e) {}

			var $textContainer = this.$ctx.closest('.scs-sitesearch-accordion-box');
			this.translations = $textContainer.data();
		},

		initSearchProcessor: function() {
			var mod = this;
			var defaults = {};
			var resultLimit = parseInt(mod.$ctx.attr('data-sitesearch-shownResults'), 10);
			if(!isNaN(resultLimit)) {
				defaults.resultLimit = resultLimit;
			}
			mod.searchProcessor = mod.createSearchProcessor(defaults);
			mod.searchProcessor.responder(SCS.search.util.respondTo({
				data: mod.searchData
			}, mod));
			mod.searchProcessor.responder(SCS.search.util.respondTo({
				data: mod.searchContainer.stopLoading,
				error: mod.searchContainer.stopLoading,
				abort: mod.searchContainer.stopLoading
			}, mod.searchContainer));
		},

		createSearchProcessor: function(defaults) {
			return SCS.search.orchestration.forSerp(
				this.$config.attr('data-sitesearch-gsahostname'),
				this.$config.attr('data-sitesearch-sites'),
				this.$config.attr('data-sitesearch-client'),
				$('html').attr('lang') || 'de',
				defaults
			);
		},

		// Got search data
		searchData: function(processor, data, config) {
			var mod = this;

			// Update the query and filter if they changed (when auto-unfiltering)
			mod.searchContainer.query = config.query;
			mod.searchContainer.filter = config.filter;
			mod.searchContainer.configUpdated();

			mod.currentConfig = config;

			// Update the title
			if(mod.titleModule) {
				mod.titleModule.searchDataAvailable(processor, data, config);
			}

			// Update resultDisplay
			mod.dataUpdated(data);
		},

		dataUpdated: function(data, displayedKeymatchURLs) {
			if(data) {
				this.currentData = data;
			}
			if(displayedKeymatchURLs) {
				this.currentDisplayedKeymatchURLs = displayedKeymatchURLs;
			}

			this.display();
		},

		attachListeners: function() {
			var mod = this;
			// Legacy accordion handling
			if(mod.$ctx.is('.scs-sitesearch-accordion-closed, .scs-sitesearch-accordion-opened')) {
				mod.$ctx.find('.scs-sitesearch-accordion-title').on('click', function() {
					mod.$ctx.toggleClass('scs-sitesearch-accordion-closed').toggleClass('scs-sitesearch-accordion-opened');
				});
			}
		},

		display: function() {
			var mod = this;

			var data = mod.currentData;
			var config = mod.currentConfig;

			var results = data.results || data.items || [];
			if(config.page > 0) {
				results = mod.prevResults.concat(results);
			}
			mod.prevResults = results;

			var snabbdom = window.snabbdom;
			var h = snabbdom.h;
			var SearchResultContainer = Module.SearchResultContainer;

			// Result container is initially hidden (before the first search was performed)
			mod.$ctx.removeClass('hidden');

			var resultCount = data.resultCount || 0;

			mod.$titleContainer.text(SCS.utils.formatString(
				mod.titleFormat,
				config.query,
				resultCount,
				mod.title
			));

			var content;
			var hasResults = resultCount > 0;
			mod.$ctx.toggleClass('scs-sitesearch-has-results', hasResults).toggleClass('has-results', hasResults).toggleClass('scs-sitesearch-no-results', !hasResults);

			if(hasResults) {
				content = mod.renderResults(results, config, h, SearchResultContainer);
			} else {
				content = mod.renderNoResultsMessage(config.query, h);
			}
			mod.resultContainer = snabbdom.patch(mod.resultContainer, h('div.scs-sitesearch-accordion-content-first-results', content));

			mod.renderPaging(data, config, resultCount, results, snabbdom, SearchResultContainer);
		},

		renderResults: function(results, config, h, SearchResultContainer) {
			var mod = this;

			// Start with spellcheck messages (if any)
			var result = mod.renderSpellcheckMessage(config, h, SearchResultContainer);

			for(var i=0;i<results.length;i+=1) {
				var item = mod.renderItem(results[i], config, h, SearchResultContainer);
				if(item) {
					result.push(item);
				}
			}
			return result;
		},

		renderSpellcheckMessage: function(config, h, SearchResultContainer) {
			var mod = this;

			var messages = [];

			if(mod.titleModule) {
				// Let the title module render these messages
				return messages;
			}

			if(config.autoCorrectedFrom) {
				messages.push(h('div.scs-sitesearch-misspelled-link', [SCS.utils.formatString(
					mod.translations.sitesearchNoresultsformisspelled,
					config.autoCorrectedFrom
				)]));
			}

			if(config.manualCorrectionSuggestion) {
				var newQuery = config.manualCorrectionSuggestion;
				messages.push(h(
					'a.scs-sitesearch-misspelled-link',
					{
						props: {
							href: window.location.pathname + '#q=' + encodeURIComponent(newQuery)
						},
						on: {
							click: function(event) {
								SearchResultContainer.trackClick('spell', config, {query: newQuery, previousQuery: config.query}, mod.searchProcessor);
								event.preventDefault();
								if(mod.isSingle) {
									// Update the whole container if we are the only module displaying search results
									mod.searchContainer.query = newQuery;
									mod.searchContainer.configChanged();
								} else {
									// Otherwise, only update this result display module
									mod.pageNumber = 0;
									mod.process(SCS.search.util.extend({}, config.inputConfig, {query: newQuery}));
								}
							}
						}
					},
					[SCS.utils.formatString(
						mod.translations.sitesearchDidyoumean,
						newQuery
					)]
				));
			}

			return messages;
		},

		renderItem: function(result, config, h, SearchResultContainer) {
			var mod = this;

			var displayedKeymatchURLs = mod.currentDisplayedKeymatchURLs;
			var url = result.url || result.link || '#';
			// Deduplicate search results that already appear as keymatches
			if(normalizeURL(url) in displayedKeymatchURLs) {
				return null;
			}

			var isEnhanced = mod.enhancedResults;
			var title = 'htmlTitle' in result ? result.title : SearchResultContainer.unsafelyStripHTML(result.title);
			var mime = String(result.mimeType || '').toLowerCase();
			if(mime in MIME_SUFFIXES) {
				title += ' ['+MIME_SUFFIXES[result.mimeType]+']';
			}
			var content = [
				h(
					'a.scs-sitesearch-accordion-searchlink',
					{
						props: {
							href: url
						},
						on: {
							click: function() {
								// Track click
								SearchResultContainer.trackClick('c', config, result, mod.searchProcessor);
							}
						}
					},
					title
				),
				h(
					'div',
					SearchResultContainer.snippetToVDomElements(result.htmlSnippet || result.snippet, h)
				)
			];
			if(isEnhanced) {
				var reviews = mod.renderReviews(result, h);
				if(reviews) {
					content.push(reviews);
				}

				// Wrap enhanced results in a group
				content = h('div.scs-result-item-content', content);
				var icon = mod.getIcon(result);
				if(icon && icon.src) {
					icon = h('img', {props: {src: icon.src}});
				} else if(icon && icon.icon && icon.icon in mod.iconMap) {
					icon = h('span.iconfont.glyph', [mod.iconMap[icon.icon]]);
				} else {
					icon = null;
				}
				if(icon) {
					// Prepend icon to group
					content = [h('div.scs-result-item-icon', [icon]), content];
				} else {
					content = [content];
				}
			}
			return h(
				'div.scs-result-item',
				content
			);
		},

		renderReviews: function(result, h) {
			if(!result.meta) {
				return;
			}
			// FIXME NEC: Is there a spec for this? Rating seems to be an integer [10..50]
			var rating = Math.max(0, Math.min(5, parseFloat(result.meta.ratingValue) / 10));
			var count = parseInt(result.meta.ratingCount, 10);
			if(!rating || !count) {
				return;
			}

			var fullStars = Math.floor(rating);
			var halfStar = rating - fullStars;
			var emptyStars = 5 - fullStars - Math.ceil(halfStar);

			var stars = [], i;

			for(i=0;i<fullStars;i+=1) {
				stars.push(h('div.star.iconfont.glyph', [STAR]));
			}
			if(halfStar) {
				stars.push(h(
					'div.star.gray.iconfont.glyph',
					[
						STAR,
						h(
							'div.star.halfFilled.iconfont.glyph',
							{
								style:
								{
									width: (18*halfStar)+'px'
									// FIXME: Test with em and get rid of magic 18px = 100%
									// width: halfStar+'em'
								}
							},
							[STAR]
						)
					]
				));
			}
			for(i=0;i<emptyStars;i+=1) {
				stars.push(h('div.star.gray.iconfont.glyph', [STAR]));
			}

			return h(
				'div.scs-result-item-review',
				[
					h(
						'div.scs-result-item-review-stars',
						stars
					),
					h(
						'div.starstext',
						[SCS.utils.formatString(
							this.translations.sitesearchRatingsTitle,
							count
						)]
					)
				]
			);
		},

		renderNoResultsMessage: function(query, h) {
			if(this.titleModule) {
				// Let the title module render these messages
				return [];
			}
			return [
				h('span.scs-noresults-icon'),
				h('span.scs-sitesearch-no-results-content', [SCS.utils.formatString(
					this.translations.sitesearchNoresultsglobal,
					query,
					this.title
				)])
			];
		},

		renderPaging: function(data, config, resultCount, results, snabbdom, SearchResultContainer) {
			var mod = this;
			var h = snabbdom.h;
			// Add more results button and info
			var remaining = resultCount - (config.offset + results.length);

			var pagingControls = [];

			if(remaining > 0) {
				var nextPageStart = config.offset + config.resultLimit + 1;
				var nextPageEnd = Math.min(nextPageStart + config.resultLimit - 1, resultCount);
				pagingControls = [
					h(
						'div.scs-sitesearch-moreresults.secondary-button.button-secondary',
						{
							on: {
								click: function() {
									// Track click
									SearchResultContainer.trackClick('nav.next', config, {url: document.location.href, page: config.page + 1, previousPage: config.page}, mod.searchProcessor);
									// Load next page
									mod.pageNumber = config.page + 1;
									mod.process(SCS.search.util.extend({}, config.inputConfig));
								}
							}
						},
						[mod.translations.sitesearchMorebuttontext]
					),
					h(
						'div.scs-sitesearch-moreresults-info',
						[
							SCS.utils.formatString(
								mod.translations.sitesearchMorebuttontextInfo,
								nextPageStart,
								nextPageEnd,
								resultCount
							)
						]
					),
					h('hr')
				];
			}

			mod.additionalResultsContainer = snabbdom.patch(mod.additionalResultsContainer, h('div.scs-sitesearch-accordion-content-more-results', pagingControls));
		},

		getIcon: function(result) {
			// jshint camelcase: false
			var meta = result.meta;
			if(!meta) {
				return;
			}
			if(meta.thumbnail) {
				return {src: result.meta.thumbnail};
			} else if(meta.gsaentity_GSA_Category) {
				return {icon: meta.gsaentity_GSA_Category};
			}
		}

	});

	SearchResultDisplay.normalizeURL = normalizeURL;

	Module.SearchResultDisplay = SearchResultDisplay;

})(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$, window.SCS = window.SCS || {});

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module, $, SCS) {
	'use strict';

	// Skin for what used to be called a Web-Accordion
	Module.SearchResultDisplay.Web = function(parent) {

		this.createSearchProcessor = function(defaults) {
			return SCS.search.orchestration.forWebSearch(
				this.$ctx.attr('data-sitesearch-gsahostname'),
				$('html').attr('lang') || 'de',
				defaults
			);
		};

		this.getIcon = function(result) {
			// jshint camelcase: false
			if(result.pagemap && result.pagemap.cse_thumbnail && result.pagemap.cse_thumbnail[0]) {
				return {src: result.pagemap.cse_thumbnail[0].src};
			}
		};

	};

})(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$, window.SCS = window.SCS || {});

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module, $, SCS) {
	'use strict';

	var FILTER_VALUE_UNSELECTED = '0_no_filter';

	var SearchResultFilter = Module.extend({
		// The container module instance (for setting config changes and the like)
		searchContainer: null,
		// The search processor instance (for counting results in filters)
		searchProcessors: null,
		// Available fitlers
		filters: null,

		on: function(callback) {
			callback();
		},

		after: function() {},

		initSearch: function(searchContainer) {
			this.searchContainer = searchContainer;

			this.findElements();
			this.attachListeners();

			// Don’t trigger a search, just set the initial filter
			searchContainer.filter = this.currentFilter();
		},

		searchConfigUpdated: function(searchConfig) {
			var mod = this;

			mod.$filterContainer.addClass('active');
			mod.$title.removeClass('hidden');

			// jshint forin: false
			var filter = searchConfig.filter || {};
			for(var filterName in mod.filters) {
				var filterConfig = mod.filters[filterName];
				var filterValueConfig = null;

				// Search the selected filter. If not found, assume no filter was to be used.
				if(filterName in filter && filter[filterName] in filterConfig) {
					filterValueConfig = filterConfig[filter[filterName]];
				} else {
					filterValueConfig = filterConfig[FILTER_VALUE_UNSELECTED] || filterConfig[''];
				}
				if(filterValueConfig) {
					// Update the filter DOM
					mod.activateFilter(null, filterValueConfig);
				}

				// Trigger queries for the result counts
				var filterExceptCurrent = SCS.search.util.extend({}, filter);
				if(filterName in filterExceptCurrent) {
					delete filterExceptCurrent[filterName];
				}
				var configForSubquery = SCS.search.util.extend({}, searchConfig, {filter: filterExceptCurrent});
				mod.searchProcessors[filterName].process(configForSubquery);
			}
		},

		findElements: function() {
			var mod = this;

			mod.$filterContainer = mod.$ctx.find('.scs-sitesearch-searchfilter');
			mod.$title = mod.$ctx.find('.scs-sitesearchfilter-title');

			var $config = mod.$ctx.closest('.search-configuration');
			if(!$config.length) {
				// Configuration on search field could also be outside
				$config = mod.searchContainer.$config;
			}

			var filters = mod.filters = {};
			var searchProcessors = mod.searchProcessors = {};

			var $filters = mod.$filterContainer.find('.scs-sitesearch-filter-menu');
			$filters.each(function() {
				var $filter = $(this);

				var filter = $filter.attr('data-gsa-filter');

				var filterConfig = filters[filter] = {};
				var $filterValues = $filter.find('.scs-sitesearch-filter-menu-item');

				// Initialize the search processor that count how many times the current search term appears in the filter values
				searchProcessors[filter] = mod.initSearchProcessor($config, filter);

				$filterValues.each(function() {
					var $filterValue = $(this);
					var filterValue = $filterValue.attr('data-gsa-filter-value');
					if(!filterValue || filterValue === FILTER_VALUE_UNSELECTED) {
						// Always show the “Show All” filter
						$filterValue.addClass('is-reset-button');
					}
					filterConfig[filterValue] = {
						$filter: $filter,
						$filterValue: $filterValue,
						$otherFilterValues: $filterValues.not($filterValue),
						filter: filter,
						filterValue: filterValue
					};
				});
			});

			// Add mobile-only toggle element
			var $toggler = mod.$ctx.find('.scs-sitesearch-searchfilter-mobile-button');
			if($toggler.length) {
				$toggler.click(function() {
					mod.$filterContainer.toggle();
					$toggler.toggleClass('active');
				});
				mod.$filterContainer.hide();
			}
		},

		// Initialize processors that count the unfiltered queries for us
		initSearchProcessor: function($config, filter) {
			var mod = this;

			var defaults = {
				requester: 'logic'
			};
			// Use the same config as for the search itself so the queries can be consolidated by deduplicatedBackend
			var resultLimit = parseInt($config.attr('data-sitesearch-shownResults'), 10);
			if(!isNaN(resultLimit)) {
				defaults.resultLimit = resultLimit;
			}
			var processor = SCS.search.orchestration.forSerp(
				$config.attr('data-sitesearch-gsahostname'),
				$config.attr('data-sitesearch-sites'),
				$config.attr('data-sitesearch-client'),
				$('html').attr('lang') || 'de',
				defaults
			);
			processor.responder(SCS.search.util.respondTo({
				data: $.proxy(mod.updateFilterCounts, mod, filter)
			}, mod));

			return processor;
		},

		updateFilterCounts: function(filter, processor, data, config) {
			var facets = config.facets || {};

			var facet = (facets[filter] || {}).values || {};
			var filterConfig = this.filters[filter];
			for(var filterValue in filterConfig) {
				// jshint forin: false
				var filterValueConfig = filterConfig[filterValue];
				if(filterValue in facet) {
					filterValueConfig.$filterValue.attr('data-result-count', facet[filterValue].count);
				} else {
					filterValueConfig.$filterValue.attr('data-result-count', 0);
				}
			}
		},

		attachListeners: function() {
			var mod = this;

			// jshint forin: false
			for(var filter in mod.filters) {
				var filterConfig = mod.filters[filter];
				for(var filterValue in filterConfig) {
					var filterValueConfig = filterConfig[filterValue];
					filterValueConfig.$filterValue.click(filterValueConfig, $.proxy(mod.activateFilter, mod));
				}
			}
		},

		activateFilter: function(event, filterValueConfig) {
			filterValueConfig = filterValueConfig || event.data;
			var $filterValue = filterValueConfig.$filterValue;
			if($filterValue.is('.active')) {
				// Filter already active, do nothing
				return;
			}
			if(event) {
				event.preventDefault();
			}

			filterValueConfig.$otherFilterValues.removeClass('active');
			filterValueConfig.$filterValue.addClass('active');

			if(event) {
				var previousFilter = this.searchContainer.currentConfig().filter;

				// Change came from a click event, not to just update filter display
				this.searchContainer.filter = this.currentFilter();
				this.searchContainer.configChanged(true);

				Module.SearchResultContainer.trackClick(
					'dynnav.'+filterValueConfig.filter+'.'+filterValueConfig.filterValue,
					this.searchContainer.currentConfig(),
					{
						previousFilter: previousFilter,
						filterName: filterValueConfig.filter,
						filterValue: filterValueConfig.filter,
						url: document.location.href
					},
					this.searchProcessors[filterValueConfig.filter]
				);
			}
		},

		// Calculates the current filter (as applicatble for Tc.Module.SearchResultContainer) from the current DOM state
		currentFilter: function() {
			var mod = this;

			var currentFilter = {};

			// jshint forin: false
			for(var filter in mod.filters) {
				var filterConfig = mod.filters[filter];
				for(var filterValue in filterConfig) {
					var filterValueConfig = filterConfig[filterValue];
					if(!filterValueConfig.$filterValue.is('.active')) {
						// Find next 
						continue;
					}
					if(filterValueConfig.filterValue && filterValueConfig.filterValue !== FILTER_VALUE_UNSELECTED) {
						// This sets the filter properties
						currentFilter[filter] = filterValueConfig.filterValue;
					}
					break;
				}
			}

			return currentFilter;
		},

		getFilterTitles: function() {
			var result = {};

			// jshint forin: false
			for(var filter in this.filters) {
				var filterConfig = this.filters[filter];
				result[filter] = {};
				for(var filterValue in filterConfig) {
					var filterValueConfig = filterConfig[filterValue];
					result[filter][filterValue] = $.trim(filterValueConfig.$filterValue.text());
				}
			}

			return result;
		}

	});

	Module.SearchResultFilter = SearchResultFilter;

})(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$, window.SCS = window.SCS || {});

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module, $, SCS) {
	'use strict';

	var SearchResultQueryBox = Module.extend({
		// The container module instance (for setting config changes and the like)
		searchContainer: null,
		// The search processor instance for autosuggest and keymatches
		// FIXME: Implement (or remove)
		searchProcessor: null,

		on: function(callback) {
			callback();
		},

		after: function() {
			this.findElements();
			this.attachListeners();
		},

		initSearch: function(searchContainer) {
			this.searchContainer = searchContainer;
		},

		searchConfigUpdated: function(searchConfig) {
			this.$field.val(searchConfig.query);
		},

		findElements: function() {
			this.$field = this.$ctx.find('.scs-sitesearch-searchfield-input');
		},

		attachListeners: function() {
			var mod = this;
			mod.$ctx.on('submit', function(event) {
				event.preventDefault();
				var query = mod.$field.val();
				mod.searchContainer.query = query;
				mod.searchContainer.configChanged();
			});
		}

	});

	Module.SearchResultQueryBox = SearchResultQueryBox;

})(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$, window.SCS = window.SCS || {});

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module, $, SCS) {
	'use strict';

	var SearchResultTitle = Module.extend({
		// The container module instance (for setting config changes and the like)
		searchContainer: null,
		// The human-readable names of the filter options
		filterTitles: {},

		on: function(callback) {
			callback();
		},

		after: function() {
			this.findElements();
		},

		initSearch: function(searchContainer) {
			this.searchContainer = searchContainer;

		},

		searchConfigChanged: function() {
			this.$ctx.removeClass('active');
		},

		searchDataAvailable: function(processor, data, config) {
			var mod = this;
			var SearchResultContainer = Module.SearchResultContainer;
			var snabbdom = window.snabbdom;
			var h = snabbdom.h;

			mod.$ctx.addClass('active');

			// Fill in title
			var title = [];
			var resultCount = data.resultCount || 0;
			if(resultCount < 1) {
				title = [
					h('span.scs-noresults-icon'),
					h('span.scs-sitesearch-no-results-content', [SCS.utils.formatString(mod.translations.resultTitleTextNoresults, config.query)])
				];
			} else {
				var translationKey = 'resultTitleText' + (resultCount === 1 ? 'S' : 'P');
				var filterTitles = [];
				for(var filterArea in config.filter) {
					var filterValue = config.filter[filterArea];
					// jshint forin: false
					var titles = mod.filterTitles[filterArea] || {};
					filterTitles.push(titles[filterValue] || filterValue);
				}
				if(!filterTitles.length) {
					translationKey = translationKey + 'NoFilter';
				}
				var suffix = '';
				if(config.previousFilter) {
					suffix = mod.translations.resultTitleTextWithoutFilter;
				}
				var text = mod.translations[translationKey];
				title.push(SCS.utils.formatString(
					text,
					resultCount,
					config.query,
					filterTitles.join(', '),
					suffix
				));
			}
			mod.title = snabbdom.patch(mod.title, h('div.scs-sitesearch-result-title-count.active', title));

			// Handle autocorrection
			var misspelled = [];
			if(config.autoCorrectedFrom) {
				misspelled.push(SCS.utils.formatString(
					mod.translations.resultTitleTextNoresultsForMisspelled,
					config.autoCorrectedFrom
				));
			}
			mod.misspelled = snabbdom.patch(mod.misspelled, h('div.scs-sitesearch-result-title-misspelled', {
				'class': {
					active: !!config.autoCorrectedFrom
				}
			}, misspelled));

			// Handle manual correction
			var suggestion = [];
			if(config.manualCorrectionSuggestion) {
				var newQuery = config.manualCorrectionSuggestion;
				// Don’t use format here because we want to replace the placeholder with a DOM element
				var contents = this.translations.resultTitleTextDidYouMean.split('{0}');
				contents.splice(1, 0, h(
					'span',
					[newQuery]
				));
				suggestion.push(h(
					'a.scs-sitesearch-misspelled-link',
					{
						props: {
							href: '#'+SCS.search.util.param({q: newQuery})
						},
						on: {
							click: function(event) {
								event.preventDefault();
								SearchResultContainer.trackClick('spell', config, {query: newQuery, previousQuery: config.query}, processor);
								mod.searchContainer.query = newQuery;
								mod.searchContainer.configChanged();
							}
						}
					},
					contents
				));
			}
			this.suggestion = snabbdom.patch(this.suggestion, h('div.scs-sitesearch-result-title-suggestion', {
				'class': {
					active: !!config.manualCorrectionSuggestion
				}
			}, suggestion));
		},

		findElements: function() {
			this.translations = this.$ctx.data();

			this.title = this.$ctx.find('.scs-sitesearch-result-title-count')[0];
			this.misspelled = this.$ctx.find('.scs-sitesearch-result-title-misspelled')[0];
			this.suggestion = this.$ctx.find('.scs-sitesearch-result-title-suggestion')[0];

			var filterModule = this.searchContainer.internalModulesByName('SearchResultFilter')[0];
			if(filterModule) {
				this.filterTitles = filterModule.getFilterTitles();
			}
		}

	});

	Module.SearchResultTitle = SearchResultTitle;

})(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$, window.SCS = window.SCS || {});

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module, $, SCS) {
	'use strict';

	function trackKeymatchClick(mod, keymatch, config) {
		// Store URL so the referenced page knows where we came from
		if ('localStorage' in window) {
			window.localStorage.setItem('sitesearch-keymatch-origin-url', window.location.href);
		}
		// Tracking
		Module.SearchResultContainer.trackClick('keymatch', config, keymatch, mod.searchProcessor);
	}


	var SearchTopResults = Module.extend({
		// The container module instance (for setting config changes and the like)
		searchContainer: null,
		// The search processor instance for retrieving keymatches
		searchProcessor: null,
		// The DOM/vDOM element for displaying keymatches
		contentsContainer: null,
		// Search result display modules. These should filter out results if they point to the same URL as the keymatches we display
		searchDisplayModules: [],

		on: function(callback) {
			callback();
		},

		after: function() {
			this.contentsContainer = this.$ctx.find('> .contents')[0];
			this.translations = {
				detailsText: this.$ctx.attr('data-details-text'),
				ratingCount: this.$ctx.attr('data-sitesearch-numberOfReviews')
			};
		},

		initSearch: function(searchContainer) {
			var mod = this;
			var $config = mod.$ctx.closest('.search-configuration');
			if(!$config.length) {
				// Configuration on search field could also be outside
				$config = searchContainer.$config;
			}
			mod.searchDisplayModules = searchContainer.internalModulesByName('SearchResultDisplay');
			mod.searchContainer = searchContainer;
			mod.searchProcessor = SCS.search.orchestration.forKeymatches(
				mod.$ctx.attr('data-sitesearch-gsahostname'),
				$config.attr('data-sitesearch-sites'),
				$config.attr('data-sitesearch-client'),
				$config.attr('data-sitesearch-gsainstantsearchresults'),
				$('html').attr('lang') || 'de',
				mod.$ctx.attr('data-sitesearch-instantsearchcollectionsuffix')
			);
			mod.searchProcessor.responder(SCS.search.util.respondTo({
				data: mod.keymatchData
			}, mod));
			mod.searchProcessor.responder(SCS.search.util.respondTo({
				data: searchContainer.stopLoading,
				error: searchContainer.stopLoading,
				abort: searchContainer.stopLoading
			}, searchContainer));
		},

		searchConfigChanged: function(searchConfig) {
			this.process({query: searchConfig.query});
		},

		process: function(config) {
			this.searchContainer.startLoading();
			this.searchProcessor.process(config);
		},

		keymatchData: function(processor, data, config) {
			var mod = this;

			var snabbdom = window.snabbdom;
			var h = snabbdom.h;

			var keymatch, i;

			var keymatches = $.grep(config.keymatches || [], function(el) {
				return !el.error;
			});

			if(mod.searchDisplayModules.length) {
				var keymatchURLs = {};
				for(i=0;i<keymatches.length;i+=1) {
					keymatch = keymatches[i];
					keymatchURLs[Module.SearchResultDisplay.normalizeURL(keymatch.url)] = true;
				}
				for(i=0;i<mod.searchDisplayModules.length;i+=1) {
					mod.searchDisplayModules[i].dataUpdated(null, keymatchURLs);
				}
			}
			var hasKeymatches = keymatches.length > 0;
			mod.$ctx.toggleClass('active', hasKeymatches);

			var keymatchElements = [];
			for(i=0;i<keymatches.length;i+=1) {
				keymatch = keymatches[i];
				var display = keymatch.display;
				display = 'render' + display[0].toUpperCase()+display.substring(1).toLowerCase() + 'Keymatch';
				if(!(display in mod)) {
					display = 'renderGenericKeymatch';
				}
				var vnode = mod[display](keymatch, h, config);
				if(vnode) {
					keymatchElements.push(vnode);
				}
			}

			mod.contentsContainer = snabbdom.patch(mod.contentsContainer, h('div', keymatchElements));

		},

		renderGenericKeymatch: function(keymatch, h, config) {
			return h(
				'div.scs-sitesearch-keymatch.scs-sitesearch-selfcare.scs-sitesearch-'+keymatch.display,
				[
					h('div.scs-sitesearch-'+keymatch.display+'-tag'),
					h(
						'div.scs-sitesearch-selfcare-box',
						[h(
							'a',
							{
								props: {
									href: keymatch.url
								},
								on: {
									click: [trackKeymatchClick, this, keymatch, config]
								}
							},
							[
								h(
									'div.scs-sitesearch-selfcare-title',
									[keymatch.title]
								)
							]
						), h(
							'div.scs-sitesearch-selfcare-box-text',
							[keymatch.subtitle]
						)]
					)
				]
			);
		},

		// Don’t display webcodes
		renderWebcodeKeymatch: function() {
			return null;
		},

		renderProductKeymatch: function(keymatch, h, config) {
			var image = [];
			if(keymatch.image) {
				image = [h(
					'img',
					{
						props: {
							src: keymatch.image
						}
					}
				)];
			}
			var rating = h('div');
			if(typeof keymatch.rating === 'number' && keymatch.ratingCount > 0) {
				rating = h(
					'div.scs-sitesearch-product-teaser-rating',
					[
						h('div.scs-sitesearch-product-teaser-stars', {
							attrs: {
								'data-rating': keymatch.rating
							}
						}),
						h('div.scs-sitesearch-rating-txt', [
							SCS.utils.formatString(
								this.translations.ratingCount,
								keymatch.ratingCount
							)
						])
					]
				);
			}
			return h(
				'div.scs-sitesearch-product-teaser',
				[
					h(
						'div.scs-sitesearch-product-teaser-image',
						{
							'class': {
								'default-product': !keymatch.image
							}
						},
						image
					),
					h(
						'div.scs-sitesearch-product-teaser-content',
						[
							h(
								'a',
								{
									props: {
										href: keymatch.url
									},
									on: {
										click: [trackKeymatchClick, this, keymatch, config]
									}
								}, 
								[
									h('div.scs-sitesearch-product-teaser-title', 
										[keymatch.title]
									)
								]
							),
							h('div.scs-sitesearch-product-teaser-intro', [keymatch.subtitle]),
							rating,
							h('div.scs-sitesearch-clear'),
							h(
								'div.scs-sitesearch-product-teaser-details',
								[
									h('div.scs-sitesearch-details-txt', [this.translations.detailsText])
								]
							)
						]
					)
				]
				
			);
		}

	});

	Module.SearchTopResults = SearchTopResults;

})(window.Tc.Module, __webpack_provided_window_dot_Tc_dot_$, window.SCS = window.SCS || {});

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        var flags = null,
            parsedParts = false,
            isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            isNowValid =
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidEra &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));
            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        } else {
            return isNowValid;
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year',
    };

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1,
    };

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
        match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        if (!mom.isValid()) {
            return NaN;
        }

        var d = mom._d,
            isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }

    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;

        if (!mom.isValid() || isNaN(value)) {
            return;
        }

        d = mom._d;
        isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return void (isUTC
                    ? d.setUTCMilliseconds(value)
                    : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }

        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        void (isUTC
            ? d.setUTCFullYear(year, month, date)
            : d.setFullYear(year, month, date));
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // PARSING

    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        var month = value,
            date = mom.date();

        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        void (mom._isUTC
            ? mom._d.setUTCMonth(month, date)
            : mom._d.setMonth(month, date));
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            shortP,
            longP;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // PARSING

    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
              ? weekdays[m.day()]
              : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
              ? this._weekdaysShort[m.day()]
              : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
              ? this._weekdaysMin[m.day()]
              : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                      ? DATE
                      : a[HOUR] < 0 ||
                          a[HOUR] > 24 ||
                          (a[HOUR] === 24 &&
                              (a[MINUTE] !== 0 ||
                                  a[SECOND] !== 0 ||
                                  a[MILLISECOND] !== 0))
                        ? HOUR
                        : a[MINUTE] < 0 || a[MINUTE] > 59
                          ? MINUTE
                          : a[SECOND] < 0 || a[SECOND] > 59
                            ? SECOND
                            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                              ? MILLISECOND
                              : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
              ? 'lastWeek'
              : diff < 0
                ? 'lastDay'
                : diff < 1
                  ? 'sameDay'
                  : diff < 2
                    ? 'nextDay'
                    : diff < 7
                      ? 'nextWeek'
                      : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            erasName,
            erasAbbr,
            erasNarrow,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);

            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday() + this.localeData()._week.dow,
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // PARSING

    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // PARSING

    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // PARSING

    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y'),
        valueOf$1 = asMilliseconds;

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.30.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(79)(module)))

/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_scsHeaderJQuery, __webpack_provided_window_dot_jQuery, jQuery) {/**
 * WARNING - Two small changes by Swisscom: look for "scsHeaderJQuery"
 *
 * Copyright (c) 2005 - 2010, James Auldridge
 * All rights reserved.
 *
 * Licensed under the BSD, MIT, and GPL (your choice!) Licenses:
 * http://code.google.com/p/cookies/wiki/License
 *
 */
var jaaulde=window.jaaulde||{};jaaulde.utils=jaaulde.utils||{};jaaulde.utils.cookies=(function(){var resolveOptions,assembleOptionsString,parseCookies,constructor,defaultOptions={expiresAt:null,path:'/',domain:null,secure:false};resolveOptions=function(options){var returnValue,expireDate;if(typeof options!=='object'||options===null){returnValue=defaultOptions;}else
{returnValue={expiresAt:defaultOptions.expiresAt,path:defaultOptions.path,domain:defaultOptions.domain,secure:defaultOptions.secure};if(typeof options.expiresAt==='object'&&options.expiresAt instanceof Date){returnValue.expiresAt=options.expiresAt;}else if(typeof options.hoursToLive==='number'&&options.hoursToLive!==0){expireDate=new Date();expireDate.setTime(expireDate.getTime()+(options.hoursToLive*60*60*1000));returnValue.expiresAt=expireDate;}if(typeof options.path==='string'&&options.path!==''){returnValue.path=options.path;}if(typeof options.domain==='string'&&options.domain!==''){returnValue.domain=options.domain;}if(options.secure===true){returnValue.secure=options.secure;}}return returnValue;};assembleOptionsString=function(options){options=resolveOptions(options);return((typeof options.expiresAt==='object'&&options.expiresAt instanceof Date?'; expires='+options.expiresAt.toGMTString():'')+'; path='+options.path+(typeof options.domain==='string'?'; domain='+options.domain:'')+(options.secure===true?'; secure':''));};parseCookies=function(){var cookies={},i,pair,name,value,separated=document.cookie.split(';'),unparsedValue;for(i=0;i<separated.length;i=i+1){pair=separated[i].split('=');name=pair[0].replace(/^\s*/,'').replace(/\s*$/,'');try
{value=decodeURIComponent(pair[1]);}catch(e1){value=pair[1];}if(typeof JSON==='object'&&JSON!==null&&typeof JSON.parse==='function'){try
{unparsedValue=value;value=JSON.parse(value);}catch(e2){value=unparsedValue;}}cookies[name]=value;}return cookies;};constructor=function(){};constructor.prototype.get=function(cookieName){var returnValue,item,cookies=parseCookies();if(typeof cookieName==='string'){returnValue=(typeof cookies[cookieName]!=='undefined')?cookies[cookieName]:null;}else if(typeof cookieName==='object'&&cookieName!==null){returnValue={};for(item in cookieName){if(typeof cookies[cookieName[item]]!=='undefined'){returnValue[cookieName[item]]=cookies[cookieName[item]];}else
{returnValue[cookieName[item]]=null;}}}else
{returnValue=cookies;}return returnValue;};constructor.prototype.filter=function(cookieNameRegExp){var cookieName,returnValue={},cookies=parseCookies();if(typeof cookieNameRegExp==='string'){cookieNameRegExp=new RegExp(cookieNameRegExp);}for(cookieName in cookies){if(cookieName.match(cookieNameRegExp)){returnValue[cookieName]=cookies[cookieName];}}return returnValue;};constructor.prototype.set=function(cookieName,value,options){if(typeof options!=='object'||options===null){options={};}if(typeof value==='undefined'||value===null){value='';options.hoursToLive=-8760;}else if(typeof value!=='string'){if(typeof JSON==='object'&&JSON!==null&&typeof JSON.stringify==='function'){value=JSON.stringify(value);}else
{throw new Error('cookies.set() received non-string value and could not serialize.');}}var optionsString=assembleOptionsString(options);document.cookie=cookieName+'='+encodeURIComponent(value)+optionsString;};constructor.prototype.del=function(cookieName,options){var allCookies={},name;if(typeof options!=='object'||options===null){options={};}if(typeof cookieName==='boolean'&&cookieName===true){allCookies=this.get();}else if(typeof cookieName==='string'){allCookies[cookieName]=true;}for(name in allCookies){if(typeof name==='string'&&name!==''){this.set(name,null,options);}}};constructor.prototype.test=function(){var returnValue=false,testName='cT',testValue='data';this.set(testName,testValue);if(this.get(testName)===testValue){this.del(testName);returnValue=true;}return returnValue;};constructor.prototype.setOptions=function(options){if(typeof options!=='object'){options=null;}defaultOptions=resolveOptions(options);};return new constructor();})();(function(){if(__webpack_provided_window_dot_scsHeaderJQuery || __webpack_provided_window_dot_jQuery){(function($){$.cookies=jaaulde.utils.cookies;var extensions={cookify:function(options){return this.each(function(){var i,nameAttrs=['name','id'],name,$this=$(this),value;for(i in nameAttrs){if(!isNaN(i)){name=$this.attr(nameAttrs[i]);if(typeof name==='string'&&name!==''){if($this.is(':checkbox, :radio')){if($this.attr('checked')){value=$this.val();}}else if($this.is(':input')){value=$this.val();}else
{value=$this.html();}if(typeof value!=='string'||value===''){value=null;}$.cookies.set(name,value,options);break;}}}});},cookieFill:function(){return this.each(function(){var n,getN,nameAttrs=['name','id'],name,$this=$(this),value;getN=function(){n=nameAttrs.pop();return!!n;};while(getN()){name=$this.attr(n);if(typeof name==='string'&&name!==''){value=$.cookies.get(name);if(value!==null){if($this.is(':checkbox, :radio')){if($this.val()===value){$this.attr('checked','checked');}else
{$this.removeAttr('checked');}}else if($this.is(':input')){$this.val(value);}else
{$this.html(value);}}break;}}});},cookieBind:function(options){return this.each(function(){var $this=$(this);$this.cookieFill().change(function(){$this.cookify(options);});});}};$.each(extensions,function(i){$.fn[i]=this;});})(__webpack_provided_window_dot_scsHeaderJQuery || jQuery);}})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(0), __webpack_require__(0)))

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/**
 * bxSlider v4.2.1d
 * Copyright 2013-2017 Steven Wanderski
 * Written while drinking Belgian ales and listening to jazz
 * Licensed under MIT (http://opensource.org/licenses/MIT)
 */

;(function($) {

  var defaults = {

    // GENERAL
    mode: 'horizontal',
    slideSelector: '',
    infiniteLoop: true,
    hideControlOnEnd: false,
    speed: 500,
    easing: null,
    slideMargin: 0,
    startSlide: 0,
    randomStart: false,
    captions: false,
    ticker: false,
    tickerHover: false,
    adaptiveHeight: false,
    adaptiveHeightSpeed: 500,
    video: false,
    useCSS: true,
    preloadImages: 'visible',
    responsive: true,
    slideZIndex: 50,
    wrapperClass: 'bx-wrapper',

    // TOUCH
    touchEnabled: true,
    swipeThreshold: 50,
    oneToOneTouch: true,
    preventDefaultSwipeX: true,
    preventDefaultSwipeY: false,

    // ACCESSIBILITY
    ariaLive: true,
    ariaHidden: true,

    // KEYBOARD
    keyboardEnabled: false,

    // PAGER
    pager: true,
    pagerType: 'full',
    pagerShortSeparator: ' / ',
    pagerSelector: null,
    buildPager: null,
    pagerCustom: null,

    // CONTROLS
    controls: true,
    nextText: 'Next',
    prevText: 'Prev',
    nextSelector: null,
    prevSelector: null,
    autoControls: false,
    startText: 'Start',
    stopText: 'Stop',
    autoControlsCombine: false,
    autoControlsSelector: null,

    // AUTO
    auto: false,
    pause: 4000,
    autoStart: true,
    autoDirection: 'next',
    stopAutoOnClick: false,
    autoHover: false,
    autoDelay: 0,
    autoSlideForOnePage: false,

    // CAROUSEL
    minSlides: 1,
    maxSlides: 1,
    moveSlides: 0,
    slideWidth: 0,
    shrinkItems: false,

    // CALLBACKS
    onSliderLoad: function() { return true; },
    onSlideBefore: function() { return true; },
    onSlideAfter: function() { return true; },
    onSlideNext: function() { return true; },
    onSlidePrev: function() { return true; },
    onSliderResize: function() { return true; },
	onAutoChange: function() { return true; } //calls when auto slides starts and stops
  };

  $.fn.bxSlider = function(options) {

    if (this.length === 0) {
      return this;
    }

    // support multiple elements
    if (this.length > 1) {
      this.each(function() {
        $(this).bxSlider(options);
      });
      return this;
    }

    // create a namespace to be used throughout the plugin
    var slider = {},
    // set a reference to our slider element
    el = this,
    // get the original window dimens (thanks a lot IE)
    windowWidth = $(window).width(),
    windowHeight = $(window).height();

    // Return if slider is already initialized
    if ($(el).data('bxSlider')) { return; }

    /**
     * ===================================================================================
     * = PRIVATE FUNCTIONS
     * ===================================================================================
     */

    /**
     * Initializes namespace settings to be used throughout plugin
     */
    var init = function() {
      // Return if slider is already initialized
      if ($(el).data('bxSlider')) { return; }
      // merge user-supplied options with the defaults
      slider.settings = $.extend({}, defaults, options);
      // parse slideWidth setting
      slider.settings.slideWidth = parseInt(slider.settings.slideWidth);
      // store the original children
      slider.children = el.children(slider.settings.slideSelector);
      // check if actual number of slides is less than minSlides / maxSlides
      if (slider.children.length < slider.settings.minSlides) { slider.settings.minSlides = slider.children.length; }
      if (slider.children.length < slider.settings.maxSlides) { slider.settings.maxSlides = slider.children.length; }
      // if random start, set the startSlide setting to random number
      if (slider.settings.randomStart) { slider.settings.startSlide = Math.floor(Math.random() * slider.children.length); }
      // store active slide information
      slider.active = { index: slider.settings.startSlide };
      // store if the slider is in carousel mode (displaying / moving multiple slides)
      slider.carousel = slider.settings.minSlides > 1 || slider.settings.maxSlides > 1;
      // if carousel, force preloadImages = 'all'
      if (slider.carousel) { slider.settings.preloadImages = 'all'; }
      // calculate the min / max width thresholds based on min / max number of slides
      // used to setup and update carousel slides dimensions
      slider.minThreshold = (slider.settings.minSlides * slider.settings.slideWidth) + ((slider.settings.minSlides - 1) * slider.settings.slideMargin);
      slider.maxThreshold = (slider.settings.maxSlides * slider.settings.slideWidth) + ((slider.settings.maxSlides - 1) * slider.settings.slideMargin);
      // store the current state of the slider (if currently animating, working is true)
      slider.working = false;
      // initialize the controls object
      slider.controls = {};
      // initialize an auto interval
      slider.interval = null;
      // determine which property to use for transitions
      slider.animProp = slider.settings.mode === 'vertical' ? 'top' : 'left';
      // determine if hardware acceleration can be used
      slider.usingCSS = slider.settings.useCSS && slider.settings.mode !== 'fade' && (function() {
        // create our test div element
        var div = document.createElement('div'),
        // css transition properties
        props = ['WebkitPerspective', 'MozPerspective', 'OPerspective', 'msPerspective'];
        // test for each property
        for (var i = 0; i < props.length; i++) {
          if (div.style[props[i]] !== undefined) {
            slider.cssPrefix = props[i].replace('Perspective', '').toLowerCase();
            slider.animProp = '-' + slider.cssPrefix + '-transform';
            return true;
          }
        }
        return false;
      }());
      // if vertical mode always make maxSlides and minSlides equal
      if (slider.settings.mode === 'vertical') { slider.settings.maxSlides = slider.settings.minSlides; }
      // save original style data
      el.data('origStyle', el.attr('style'));
      el.children(slider.settings.slideSelector).each(function() {
        $(this).data('origStyle', $(this).attr('style'));
      });

      // perform all DOM / CSS modifications
      setup();
    };

    /**
     * Performs all DOM and CSS modifications
     */
    var setup = function() {
      var preloadSelector = slider.children.eq(slider.settings.startSlide); // set the default preload selector (visible)

      // wrap el in a wrapper
      el.wrap('<div class="' + slider.settings.wrapperClass + '"><div class="bx-viewport"></div></div>');
      // store a namespace reference to .bx-viewport
      slider.viewport = el.parent();

      // add aria-live if the setting is enabled and ticker mode is disabled
      if (slider.settings.ariaLive && !slider.settings.ticker) {
        slider.viewport.attr('aria-live', 'polite');
      }
      // add a loading div to display while images are loading
      slider.loader = $('<div class="bx-loading" />');
      slider.viewport.prepend(slider.loader);
      // set el to a massive width, to hold any needed slides
      // also strip any margin and padding from el
      el.css({
        width: slider.settings.mode === 'horizontal' ? (slider.children.length * 1000 + 215) + '%' : 'auto',
        position: 'relative'
      });
      // if using CSS, add the easing property
      if (slider.usingCSS && slider.settings.easing) {
        el.css('-' + slider.cssPrefix + '-transition-timing-function', slider.settings.easing);
      // if not using CSS and no easing value was supplied, use the default JS animation easing (swing)
      } else if (!slider.settings.easing) {
        slider.settings.easing = 'swing';
      }
      // make modifications to the viewport (.bx-viewport)
      slider.viewport.css({
        width: '100%',
        overflow: 'hidden',
        position: 'relative'
      });
      slider.viewport.parent().css({
        maxWidth: getViewportMaxWidth()
      });
      // apply css to all slider children
      slider.children.css({
        // the float attribute is a reserved word in compressors like YUI compressor and need to be quoted #48
        'float': slider.settings.mode === 'horizontal' ? 'left' : 'none',
        listStyle: 'none',
        position: 'relative'
      });
      // apply the calculated width after the float is applied to prevent scrollbar interference
      slider.children.css('width', getSlideWidth());
      // if slideMargin is supplied, add the css
      if (slider.settings.mode === 'horizontal' && slider.settings.slideMargin > 0) { slider.children.css('marginRight', slider.settings.slideMargin); }
      if (slider.settings.mode === 'vertical' && slider.settings.slideMargin > 0) { slider.children.css('marginBottom', slider.settings.slideMargin); }
      // if "fade" mode, add positioning and z-index CSS
      if (slider.settings.mode === 'fade') {
        slider.children.css({
          position: 'absolute',
          zIndex: 0,
          display: 'none'
        });
        // prepare the z-index on the showing element
        slider.children.eq(slider.settings.startSlide).css({zIndex: slider.settings.slideZIndex, display: 'block'});
      }
      // create an element to contain all slider controls (pager, start / stop, etc)
      slider.controls.el = $('<div class="bx-controls" />');
      // if captions are requested, add them
      if (slider.settings.captions) { appendCaptions(); }
      // check if startSlide is last slide
      slider.active.last = slider.settings.startSlide === getPagerQty() - 1;
      // if video is true, set up the fitVids plugin
      if (slider.settings.video) { el.fitVids(); }
	  //preloadImages
	  if (slider.settings.preloadImages === 'none') { 
		  preloadSelector = null; 
	  }
      else if (slider.settings.preloadImages === 'all' || slider.settings.ticker) { 
		  preloadSelector = slider.children; 
	  }
      // only check for control addition if not in "ticker" mode
      if (!slider.settings.ticker) {
        // if controls are requested, add them
        if (slider.settings.controls) { appendControls(); }
        // if auto is true, and auto controls are requested, add them
        if (slider.settings.auto && slider.settings.autoControls) { appendControlsAuto(); }
        // if pager is requested, add it
        if (slider.settings.pager) { appendPager(); }
        // if any control option is requested, add the controls wrapper
        if (slider.settings.controls || slider.settings.autoControls || slider.settings.pager) { slider.viewport.after(slider.controls.el); }
      // if ticker mode, do not allow a pager
      } else {
        slider.settings.pager = false;
      }
	  if (preloadSelector === null) {
        start();
      } else {
        loadElements(preloadSelector, start);
      }
    };

    var loadElements = function(selector, callback) {
      var total = selector.find('img:not([src=""]), iframe').length,
      count = 0;
      if (total === 0) {
        callback();
        return;
      }
      selector.find('img:not([src=""]), iframe').each(function() {
        $(this).one('load error', function() {
          if (++count === total) { callback(); }
        }).each(function() {
          if (this.complete || this.src == '') { $(this).trigger('load'); }
        });
      });
    };

    /**
     * Start the slider
     */
    var start = function() {
      // if infinite loop, prepare additional slides
      if (slider.settings.infiniteLoop && slider.settings.mode !== 'fade' && !slider.settings.ticker) {
        var slice    = slider.settings.mode === 'vertical' ? slider.settings.minSlides : slider.settings.maxSlides,
        sliceAppend  = slider.children.slice(0, slice).clone(true).addClass('bx-clone'),
        slicePrepend = slider.children.slice(-slice).clone(true).addClass('bx-clone');
        if (slider.settings.ariaHidden) {
          sliceAppend.attr('aria-hidden', true);
          slicePrepend.attr('aria-hidden', true);
        }
        el.append(sliceAppend).prepend(slicePrepend);
      }
      // remove the loading DOM element
      slider.loader.remove();
      // set the left / top position of "el"
      setSlidePosition();
      // if "vertical" mode, always use adaptiveHeight to prevent odd behavior
      if (slider.settings.mode === 'vertical') { slider.settings.adaptiveHeight = true; }
      // set the viewport height
      slider.viewport.height(getViewportHeight());
      // make sure everything is positioned just right (same as a window resize)
      el.redrawSlider();
      // onSliderLoad callback
      slider.settings.onSliderLoad.call(el, slider.active.index);
      // slider has been fully initialized
      slider.initialized = true;
      // add the resize call to the window
      if (slider.settings.responsive) { $(window).on('resize', resizeWindow); }
      // if auto is true and has more than 1 page, start the show
      if (slider.settings.auto && slider.settings.autoStart && (getPagerQty() > 1 || slider.settings.autoSlideForOnePage)) { initAuto(); }
      // if ticker is true, start the ticker
      if (slider.settings.ticker) { initTicker(); }
      // if pager is requested, make the appropriate pager link active
      if (slider.settings.pager) { updatePagerActive(slider.settings.startSlide); }
      // check for any updates to the controls (like hideControlOnEnd updates)
      if (slider.settings.controls) { updateDirectionControls(); }
      // if touchEnabled is true, setup the touch events
      if (slider.settings.touchEnabled && !slider.settings.ticker) { initTouch(); }
      // if keyboardEnabled is true, setup the keyboard events
      if (slider.settings.keyboardEnabled && !slider.settings.ticker) {
        $(document).keydown(keyPress);
      }
    };

    /**
     * Returns the calculated height of the viewport, used to determine either adaptiveHeight or the maxHeight value
     */
    var getViewportHeight = function() {
      var height = 0;
      // first determine which children (slides) should be used in our height calculation
      var children = $();
      // if mode is not "vertical" and adaptiveHeight is false, include all children
      if (slider.settings.mode !== 'vertical' && !slider.settings.adaptiveHeight) {
        children = slider.children;
      } else {
        // if not carousel, return the single active child
        if (!slider.carousel) {
          children = slider.children.eq(slider.active.index);
        // if carousel, return a slice of children
        } else {
          // get the individual slide index
          var currentIndex = slider.settings.moveSlides === 1 ? slider.active.index : slider.active.index * getMoveBy();
          // add the current slide to the children
          children = slider.children.eq(currentIndex);
          // cycle through the remaining "showing" slides
          for (i = 1; i <= slider.settings.maxSlides - 1; i++) {
            // if looped back to the start
            if (currentIndex + i >= slider.children.length) {
              children = children.add(slider.children.eq(i - 1));
            } else {
              children = children.add(slider.children.eq(currentIndex + i));
            }
          }
        }
      }
      // if "vertical" mode, calculate the sum of the heights of the children
      if (slider.settings.mode === 'vertical') {
        children.each(function(index) {
          height += $(this).outerHeight();
        });
        // add user-supplied margins
        if (slider.settings.slideMargin > 0) {
          height += slider.settings.slideMargin * (slider.settings.minSlides - 1);
        }
      // if not "vertical" mode, calculate the max height of the children
      } else {
        height = Math.max.apply(Math, children.map(function() {
          return $(this).outerHeight(false);
        }).get());
      }

      if (slider.viewport.css('box-sizing') === 'border-box') {
        height += parseFloat(slider.viewport.css('padding-top')) + parseFloat(slider.viewport.css('padding-bottom')) +
              parseFloat(slider.viewport.css('border-top-width')) + parseFloat(slider.viewport.css('border-bottom-width'));
      } else if (slider.viewport.css('box-sizing') === 'padding-box') {
        height += parseFloat(slider.viewport.css('padding-top')) + parseFloat(slider.viewport.css('padding-bottom'));
      }

      return height;
    };

    /**
     * Returns the calculated width to be used for the outer wrapper / viewport
     */
    var getViewportMaxWidth = function() {
      var width = '100%';
      if (slider.settings.slideWidth > 0) {
        if (slider.settings.mode === 'horizontal') {
          width = (slider.settings.maxSlides * slider.settings.slideWidth) + ((slider.settings.maxSlides - 1) * slider.settings.slideMargin);
        } else {
          width = slider.settings.slideWidth;
        }
      }
      return width;
    };

    /**
     * Returns the calculated width to be applied to each slide
     */
    var getSlideWidth = function() {
      var newElWidth = slider.settings.slideWidth, // start with any user-supplied slide width
      wrapWidth      = slider.viewport.width();    // get the current viewport width
      // if slide width was not supplied, or is larger than the viewport use the viewport width
      if (slider.settings.slideWidth === 0 ||
        (slider.settings.slideWidth > wrapWidth && !slider.carousel) ||
        slider.settings.mode === 'vertical') {
        newElWidth = wrapWidth;
      // if carousel, use the thresholds to determine the width
      } else if (slider.settings.maxSlides > 1 && slider.settings.mode === 'horizontal') {
        if (wrapWidth > slider.maxThreshold) {
          return newElWidth;
        } else if (wrapWidth < slider.minThreshold) {
          newElWidth = (wrapWidth - (slider.settings.slideMargin * (slider.settings.minSlides - 1))) / slider.settings.minSlides;
        } else if (slider.settings.shrinkItems) {
          newElWidth = Math.floor((wrapWidth + slider.settings.slideMargin) / (Math.ceil((wrapWidth + slider.settings.slideMargin) / (newElWidth + slider.settings.slideMargin))) - slider.settings.slideMargin);
        }
      }
      return newElWidth;
    };

    /**
     * Returns the number of slides currently visible in the viewport (includes partially visible slides)
     */
    var getNumberSlidesShowing = function() {
      var slidesShowing = 1,
      childWidth = null;
      if (slider.settings.mode === 'horizontal' && slider.settings.slideWidth > 0) {
        // if viewport is smaller than minThreshold, return minSlides
        if (slider.viewport.width() < slider.minThreshold) {
          slidesShowing = slider.settings.minSlides;
        // if viewport is larger than maxThreshold, return maxSlides
        } else if (slider.viewport.width() > slider.maxThreshold) {
          slidesShowing = slider.settings.maxSlides;
        // if viewport is between min / max thresholds, divide viewport width by first child width
        } else {
          childWidth = slider.children.first().width() + slider.settings.slideMargin;
          slidesShowing = Math.floor((slider.viewport.width() +
            slider.settings.slideMargin) / childWidth) || 1;
        }
      // if "vertical" mode, slides showing will always be minSlides
      } else if (slider.settings.mode === 'vertical') {
        slidesShowing = slider.settings.minSlides;
      }
      return slidesShowing;
    };

    /**
     * Returns the number of pages (one full viewport of slides is one "page")
     */
    var getPagerQty = function() {
      var pagerQty = 0,
      breakPoint = 0,
      counter = 0;
      // if moveSlides is specified by the user
      if (slider.settings.moveSlides > 0) {
        if (slider.settings.infiniteLoop) {
          pagerQty = Math.ceil(slider.children.length / getMoveBy());
        } else {
          // when breakpoint goes above children length, counter is the number of pages
          while (breakPoint < slider.children.length) {
            ++pagerQty;
            breakPoint = counter + getNumberSlidesShowing();
            counter += slider.settings.moveSlides <= getNumberSlidesShowing() ? slider.settings.moveSlides : getNumberSlidesShowing();
          }
		  return counter;
        }
      // if moveSlides is 0 (auto) divide children length by sides showing, then round up
      } else {
        pagerQty = Math.ceil(slider.children.length / getNumberSlidesShowing());
      }
      return pagerQty;
    };

    /**
     * Returns the number of individual slides by which to shift the slider
     */
    var getMoveBy = function() {
      // if moveSlides was set by the user and moveSlides is less than number of slides showing
      if (slider.settings.moveSlides > 0 && slider.settings.moveSlides <= getNumberSlidesShowing()) {
        return slider.settings.moveSlides;
      }
      // if moveSlides is 0 (auto)
      return getNumberSlidesShowing();
    };

    /**
     * Sets the slider's (el) left or top position
     */
    var setSlidePosition = function() {
      var position, lastChild, lastShowingIndex;
      // if last slide, not infinite loop, and number of children is larger than specified maxSlides
      if (slider.children.length > slider.settings.maxSlides && slider.active.last && !slider.settings.infiniteLoop) {
        if (slider.settings.mode === 'horizontal') {
          // get the last child's position
          lastChild = slider.children.last();
          position = lastChild.position();
          // set the left position
          setPositionProperty(-(position.left - (slider.viewport.width() - lastChild.outerWidth())), 'reset', 0);
        } else if (slider.settings.mode === 'vertical') {
          // get the last showing index's position
          lastShowingIndex = slider.children.length - slider.settings.minSlides;
          position = slider.children.eq(lastShowingIndex).position();
          // set the top position
          setPositionProperty(-position.top, 'reset', 0);
        }
      // if not last slide
      } else {
        // get the position of the first showing slide
        position = slider.children.eq(slider.active.index * getMoveBy()).position();
        // check for last slide
        if (slider.active.index === getPagerQty() - 1) { slider.active.last = true; }
        // set the respective position
        if (position !== undefined) {
          if (slider.settings.mode === 'horizontal') { setPositionProperty(-position.left, 'reset', 0); }
          else if (slider.settings.mode === 'vertical') { setPositionProperty(-position.top, 'reset', 0); }
        }
      }
    };

    /**
     * Sets the el's animating property position (which in turn will sometimes animate el).
     * If using CSS, sets the transform property. If not using CSS, sets the top / left property.
     *
     * @param value (int)
     *  - the animating property's value
     *
     * @param type (string) 'slide', 'reset', 'ticker'
     *  - the type of instance for which the function is being
     *
     * @param duration (int)
     *  - the amount of time (in ms) the transition should occupy
     *
     * @param params (array) optional
     *  - an optional parameter containing any variables that need to be passed in
     */
    var setPositionProperty = function(value, type, duration, params) {
      var animateObj, propValue;
      // use CSS transform
      if (slider.usingCSS) {
        // determine the translate3d value
        propValue = slider.settings.mode === 'vertical' ? 'translate3d(0, ' + value + 'px, 0)' : 'translate3d(' + value + 'px, 0, 0)';
        // add the CSS transition-duration
        el.css('-' + slider.cssPrefix + '-transition-duration', duration / 1000 + 's');
        if (type === 'slide') {
          // set the property value
          el.css(slider.animProp, propValue);
          if (duration !== 0) {
            // add a callback method - executes when CSS transition completes
            el.on('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function(e) {
              //make sure it's the correct one
              if (!$(e.target).is(el)) { return; }
              // remove the callback
              el.off('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd');
              updateAfterSlideTransition();
            });
          } else { //duration = 0
            updateAfterSlideTransition();
          }
        } else if (type === 'reset') {
          el.css(slider.animProp, propValue);
        } else if (type === 'ticker') {
          // make the transition use 'linear'
          el.css('-' + slider.cssPrefix + '-transition-timing-function', 'linear');
          el.css(slider.animProp, propValue);
          if (duration !== 0) {
            el.on('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function(e) {
              //make sure it's the correct one
              if (!$(e.target).is(el)) { return; }
              // remove the callback
              el.off('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd');
              // reset the position
              setPositionProperty(params.resetValue, 'reset', 0);
              // start the loop again
              tickerLoop();
            });
          } else { //duration = 0
            setPositionProperty(params.resetValue, 'reset', 0);
            tickerLoop();
          }
        }
      // use JS animate
      } else {
        animateObj = {};
        animateObj[slider.animProp] = value;
        if (type === 'slide') {
          el.animate(animateObj, duration, slider.settings.easing, function() {
            updateAfterSlideTransition();
          });
        } else if (type === 'reset') {
          el.css(slider.animProp, value);
        } else if (type === 'ticker') {
          el.animate(animateObj, duration, 'linear', function() {
            setPositionProperty(params.resetValue, 'reset', 0);
            // run the recursive loop after animation
            tickerLoop();
          });
        }
      }
    };

    /**
     * Populates the pager with proper amount of pages
     */
    var populatePager = function() {
      var pagerHtml = '',
      linkContent = '',
      pagerQty = getPagerQty();
      // loop through each pager item
      for (var i = 0; i < pagerQty; i++) {
        linkContent = '';
        // if a buildPager function is supplied, use it to get pager link value, else use index + 1
        if (slider.settings.buildPager && $.isFunction(slider.settings.buildPager) || slider.settings.pagerCustom) {
          linkContent = slider.settings.buildPager(i);
          slider.pagerEl.addClass('bx-custom-pager');
        } else {
          linkContent = i + 1;
          slider.pagerEl.addClass('bx-default-pager');
        }
        // var linkContent = slider.settings.buildPager && $.isFunction(slider.settings.buildPager) ? slider.settings.buildPager(i) : i + 1;
        // add the markup to the string
        pagerHtml += '<div class="bx-pager-item"><a href="" data-slide-index="' + i + '" class="bx-pager-link">' + linkContent + '</a></div>';
      }
      // populate the pager element with pager links
      slider.pagerEl.html(pagerHtml);
    };

    /**
     * Appends the pager to the controls element
     */
    var appendPager = function() {
      if (!slider.settings.pagerCustom) {
        // create the pager DOM element
        slider.pagerEl = $('<div class="bx-pager" />');
        // if a pager selector was supplied, populate it with the pager
        if (slider.settings.pagerSelector) {
          $(slider.settings.pagerSelector).html(slider.pagerEl);
        // if no pager selector was supplied, add it after the wrapper
        } else {
          slider.controls.el.addClass('bx-has-pager').append(slider.pagerEl);
        }
        // populate the pager
        populatePager();
      } else {
        slider.pagerEl = $(slider.settings.pagerCustom);
      }
      // assign the pager click binding
      slider.pagerEl.on('click touchend', 'a', clickPagerBind);
    };

    /**
     * Appends prev / next controls to the controls element
     */
    var appendControls = function() {
      slider.controls.next = $('<a class="bx-next" href="">' + slider.settings.nextText + '</a>');
      slider.controls.prev = $('<a class="bx-prev" href="">' + slider.settings.prevText + '</a>');
      // add click actions to the controls
      slider.controls.next.on('click touchend', clickNextBind);
      slider.controls.prev.on('click touchend', clickPrevBind);
      // if nextSelector was supplied, populate it
      if (slider.settings.nextSelector) {
        $(slider.settings.nextSelector).append(slider.controls.next);
      }
      // if prevSelector was supplied, populate it
      if (slider.settings.prevSelector) {
        $(slider.settings.prevSelector).append(slider.controls.prev);
      }
      // if no custom selectors were supplied
      if (!slider.settings.nextSelector && !slider.settings.prevSelector) {
        // add the controls to the DOM
        slider.controls.directionEl = $('<div class="bx-controls-direction" />');
        // add the control elements to the directionEl
        slider.controls.directionEl.append(slider.controls.prev).append(slider.controls.next);
        // slider.viewport.append(slider.controls.directionEl);
        slider.controls.el.addClass('bx-has-controls-direction').append(slider.controls.directionEl);
      }
    };

    /**
     * Appends start / stop auto controls to the controls element
     */
    var appendControlsAuto = function() {
      slider.controls.start = $('<div class="bx-controls-auto-item"><a class="bx-start" href="">' + slider.settings.startText + '</a></div>');
      slider.controls.stop = $('<div class="bx-controls-auto-item"><a class="bx-stop" href="">' + slider.settings.stopText + '</a></div>');
      // add the controls to the DOM
      slider.controls.autoEl = $('<div class="bx-controls-auto" />');
      // on click actions to the controls
      slider.controls.autoEl.on('click', '.bx-start', clickStartBind);
      slider.controls.autoEl.on('click', '.bx-stop', clickStopBind);
      // if autoControlsCombine, insert only the "start" control
      if (slider.settings.autoControlsCombine) {
        slider.controls.autoEl.append(slider.controls.start);
      // if autoControlsCombine is false, insert both controls
      } else {
        slider.controls.autoEl.append(slider.controls.start).append(slider.controls.stop);
      }
      // if auto controls selector was supplied, populate it with the controls
      if (slider.settings.autoControlsSelector) {
        $(slider.settings.autoControlsSelector).html(slider.controls.autoEl);
      // if auto controls selector was not supplied, add it after the wrapper
      } else {
        slider.controls.el.addClass('bx-has-controls-auto').append(slider.controls.autoEl);
      }
      // update the auto controls
      updateAutoControls(slider.settings.autoStart ? 'stop' : 'start');
    };

    /**
     * Appends image captions to the DOM
     */
    var appendCaptions = function() {
      // cycle through each child
      slider.children.each(function(index) {
        // get the image title attribute
        var title = $(this).find('img:first').attr('title');
        // append the caption
        if (title !== undefined && ('' + title).length) {
          $(this).append('<div class="bx-caption"><span>' + title + '</span></div>');
        }
      });
    };

    /**
     * Click next binding
     *
     * @param e (event)
     *  - DOM event object
     */
    var clickNextBind = function(e) {
      e.preventDefault();
      if (slider.controls.el.hasClass('disabled')) { return; }
      // if auto show is running, stop it
      if (slider.settings.auto && slider.settings.stopAutoOnClick) { el.stopAuto(); }
      el.goToNextSlide();
    };

    /**
     * Click prev binding
     *
     * @param e (event)
     *  - DOM event object
     */
    var clickPrevBind = function(e) {
      e.preventDefault();
      if (slider.controls.el.hasClass('disabled')) { return; }
      // if auto show is running, stop it
      if (slider.settings.auto && slider.settings.stopAutoOnClick) { el.stopAuto(); }
      el.goToPrevSlide();
    };

    /**
     * Click start binding
     *
     * @param e (event)
     *  - DOM event object
     */
    var clickStartBind = function(e) {
      el.startAuto();
      e.preventDefault();
    };

    /**
     * Click stop binding
     *
     * @param e (event)
     *  - DOM event object
     */
    var clickStopBind = function(e) {
      el.stopAuto();
      e.preventDefault();
    };

    /**
     * Click pager binding
     *
     * @param e (event)
     *  - DOM event object
     */
    var clickPagerBind = function(e) {
      var pagerLink, pagerIndex;
      e.preventDefault();
      if (slider.controls.el.hasClass('disabled')) {
        return;
      }
      // if auto show is running, stop it
      if (slider.settings.auto  && slider.settings.stopAutoOnClick) { el.stopAuto(); }
      pagerLink = $(e.currentTarget);
      if (pagerLink.attr('data-slide-index') !== undefined) {
        pagerIndex = parseInt(pagerLink.attr('data-slide-index'));
        // if clicked pager link is not active, continue with the goToSlide call
        if (pagerIndex !== slider.active.index) { el.goToSlide(pagerIndex); }
      }
    };

    /**
     * Updates the pager links with an active class
     *
     * @param slideIndex (int)
     *  - index of slide to make active
     */
    var updatePagerActive = function(slideIndex) {
      // if "short" pager type
      var len = slider.children.length; // nb of children
      if (slider.settings.pagerType === 'short') {
        if (slider.settings.maxSlides > 1) {
          len = Math.ceil(slider.children.length / slider.settings.maxSlides);
        }
        slider.pagerEl.html((slideIndex + 1) + slider.settings.pagerShortSeparator + len);
        return;
      }
      // remove all pager active classes
      slider.pagerEl.find('a').removeClass('active');
      // apply the active class for all pagers
      slider.pagerEl.each(function(i, el) { $(el).find('a').eq(slideIndex).addClass('active'); });
    };

    /**
     * Performs needed actions after a slide transition
     */
    var updateAfterSlideTransition = function() {
      // if infinite loop is true
      if (slider.settings.infiniteLoop) {
        var position = '';
        // first slide
        if (slider.active.index === 0) {
          // set the new position
          position = slider.children.eq(0).position();
        // carousel, last slide
        } else if (slider.active.index === getPagerQty() - 1 && slider.carousel) {
          position = slider.children.eq((getPagerQty() - 1) * getMoveBy()).position();
        // last slide
        } else if (slider.active.index === slider.children.length - 1) {
          position = slider.children.eq(slider.children.length - 1).position();
        }
        if (position) {
          if (slider.settings.mode === 'horizontal') { setPositionProperty(-position.left, 'reset', 0); }
          else if (slider.settings.mode === 'vertical') { setPositionProperty(-position.top, 'reset', 0); }
        }
      }
      // declare that the transition is complete
      slider.working = false;
      // onSlideAfter callback
      slider.settings.onSlideAfter.call(el, slider.children.eq(slider.active.index), slider.oldIndex, slider.active.index);
    };

    /**
     * Updates the auto controls state (either active, or combined switch)
     *
     * @param state (string) "start", "stop"
     *  - the new state of the auto show
     */
    var updateAutoControls = function(state) {
      // if autoControlsCombine is true, replace the current control with the new state
      if (slider.settings.autoControlsCombine) {
        slider.controls.autoEl.html(slider.controls[state]);
      // if autoControlsCombine is false, apply the "active" class to the appropriate control
      } else {
        slider.controls.autoEl.find('a').removeClass('active');
        slider.controls.autoEl.find('a:not(.bx-' + state + ')').addClass('active');
      }
    };

    /**
     * Updates the direction controls (checks if either should be hidden)
     */
    var updateDirectionControls = function() {
      if (getPagerQty() === 1) {
        slider.controls.prev.addClass('disabled');
        slider.controls.next.addClass('disabled');
      } else if (!slider.settings.infiniteLoop && slider.settings.hideControlOnEnd) {
        // if first slide
        if (slider.active.index === 0) {
          slider.controls.prev.addClass('disabled');
          slider.controls.next.removeClass('disabled');
        // if last slide
        } else if (slider.active.index === getPagerQty() - 1) {
          slider.controls.next.addClass('disabled');
          slider.controls.prev.removeClass('disabled');
        // if any slide in the middle
        } else {
          slider.controls.prev.removeClass('disabled');
          slider.controls.next.removeClass('disabled');
        }
      }
    };
	/* auto start and stop functions */
	var windowFocusHandler = function() { el.startAuto(); };
	var windowBlurHandler = function() { el.stopAuto(); };
    /**
     * Initializes the auto process
     */
    var initAuto = function() {
      // if autoDelay was supplied, launch the auto show using a setTimeout() call
      if (slider.settings.autoDelay > 0) {
        setTimeout(el.startAuto, slider.settings.autoDelay);
      // if autoDelay was not supplied, start the auto show normally
      } else {
        el.startAuto();

        //add focus and blur events to ensure its running if timeout gets paused
        $(window).focus(windowFocusHandler).blur(windowBlurHandler);
      }
      // if autoHover is requested
      if (slider.settings.autoHover) {
        // on el hover
        el.hover(function() {
          // if the auto show is currently playing (has an active interval)
          if (slider.interval) {
            // stop the auto show and pass true argument which will prevent control update
            el.stopAuto(true);
            // create a new autoPaused value which will be used by the relative "mouseout" event
            slider.autoPaused = true;
          }
        }, function() {
          // if the autoPaused value was created be the prior "mouseover" event
          if (slider.autoPaused) {
            // start the auto show and pass true argument which will prevent control update
            el.startAuto(true);
            // reset the autoPaused value
            slider.autoPaused = null;
          }
        });
      }
    };

    /**
     * Initializes the ticker process
     */
    var initTicker = function() {
      var startPosition = 0,
      position, transform, value, idx, ratio, property, newSpeed, totalDimens;
      // if autoDirection is "next", append a clone of the entire slider
      if (slider.settings.autoDirection === 'next') {
        el.append(slider.children.clone().addClass('bx-clone'));
      // if autoDirection is "prev", prepend a clone of the entire slider, and set the left position
      } else {
        el.prepend(slider.children.clone().addClass('bx-clone'));
        position = slider.children.first().position();
        startPosition = slider.settings.mode === 'horizontal' ? -position.left : -position.top;
      }
      setPositionProperty(startPosition, 'reset', 0);
      // do not allow controls in ticker mode
      slider.settings.pager = false;
      slider.settings.controls = false;
      slider.settings.autoControls = false;
      // if autoHover is requested
      if (slider.settings.tickerHover) {
        if (slider.usingCSS) {
          idx = slider.settings.mode === 'horizontal' ? 4 : 5;
          slider.viewport.hover(function() {
            transform = el.css('-' + slider.cssPrefix + '-transform');
            value = parseFloat(transform.split(',')[idx]);
            setPositionProperty(value, 'reset', 0);
          }, function() {
            totalDimens = 0;
            slider.children.each(function(index) {
              totalDimens += slider.settings.mode === 'horizontal' ? $(this).outerWidth(true) : $(this).outerHeight(true);
            });
            // calculate the speed ratio (used to determine the new speed to finish the paused animation)
            ratio = slider.settings.speed / totalDimens;
            // determine which property to use
            property = slider.settings.mode === 'horizontal' ? 'left' : 'top';
            // calculate the new speed
            newSpeed = ratio * (totalDimens - (Math.abs(parseInt(value))));
            tickerLoop(newSpeed);
          });
        } else {
          // on el hover
          slider.viewport.hover(function() {
            el.stop();
          }, function() {
            // calculate the total width of children (used to calculate the speed ratio)
            totalDimens = 0;
            slider.children.each(function(index) {
              totalDimens += slider.settings.mode === 'horizontal' ? $(this).outerWidth(true) : $(this).outerHeight(true);
            });
            // calculate the speed ratio (used to determine the new speed to finish the paused animation)
            ratio = slider.settings.speed / totalDimens;
            // determine which property to use
            property = slider.settings.mode === 'horizontal' ? 'left' : 'top';
            // calculate the new speed
            newSpeed = ratio * (totalDimens - (Math.abs(parseInt(el.css(property)))));
            tickerLoop(newSpeed);
          });
        }
      }
      // start the ticker loop
      tickerLoop();
    };

    /**
     * Runs a continuous loop, news ticker-style
     */
    var tickerLoop = function(resumeSpeed) {
      var speed = resumeSpeed ? resumeSpeed : slider.settings.speed,
      position = {left: 0, top: 0},
      reset = {left: 0, top: 0},
      animateProperty, resetValue, params;

      // if "next" animate left position to last child, then reset left to 0
      if (slider.settings.autoDirection === 'next') {
        position = el.find('.bx-clone').first().position();
      // if "prev" animate left position to 0, then reset left to first non-clone child
      } else {
        reset = slider.children.first().position();
      }
      animateProperty = slider.settings.mode === 'horizontal' ? -position.left : -position.top;
      resetValue = slider.settings.mode === 'horizontal' ? -reset.left : -reset.top;
      params = {resetValue: resetValue};
      setPositionProperty(animateProperty, 'ticker', speed, params);
    };

    /**
     * Check if el is on screen
     */
    var isOnScreen = function(el) {
      var win = $(window),
      viewport = {
        top: win.scrollTop(),
        left: win.scrollLeft()
      },
      bounds = el.offset();

      viewport.right = viewport.left + win.width();
      viewport.bottom = viewport.top + win.height();
      bounds.right = bounds.left + el.outerWidth();
      bounds.bottom = bounds.top + el.outerHeight();

      return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
    };

    /**
     * Initializes keyboard events
     */
    var keyPress = function(e) {
      var activeElementTag = document.activeElement.tagName.toLowerCase(),
      tagFilters = 'input|textarea',
      p = new RegExp(activeElementTag,['i']),
      result = p.exec(tagFilters);

      if (result == null && isOnScreen(el)) {
        if (e.keyCode === 39) {
          clickNextBind(e);
          return false;
        } else if (e.keyCode === 37) {
          clickPrevBind(e);
          return false;
        }
      }
    };

    /**
     * Initializes touch events
     */
    var initTouch = function() {
      // initialize object to contain all touch values
      slider.touch = {
        start: {x: 0, y: 0},
        end: {x: 0, y: 0}
      };
      slider.viewport.on('touchstart MSPointerDown pointerdown', onTouchStart);

      //for browsers that have implemented pointer events and fire a click after
      //every pointerup regardless of whether pointerup is on same screen location as pointerdown or not
      slider.viewport.on('click', '.bxslider a', function(e) {
        if (slider.viewport.hasClass('click-disabled')) {
          e.preventDefault();
          slider.viewport.removeClass('click-disabled');
        }
      });
    };

    /**
     * Event handler for "touchstart"
     *
     * @param e (event)
     *  - DOM event object
     */
    var onTouchStart = function(e) {
      // watch only for left mouse, touch contact and pen contact
      // touchstart event object doesn`t have button property
      if (e.type !== 'touchstart' && e.button !== 0) {
        return;
      }
      //disable slider controls while user is interacting with slides to avoid slider freeze that happens on touch devices when a slide swipe happens immediately after interacting with slider controls
      slider.controls.el.addClass('disabled');

      if (slider.working) {
        slider.controls.el.removeClass('disabled');
      } else {
        // record the original position when touch starts
        slider.touch.originalPos = el.position();
        var orig = e.originalEvent,
        touchPoints = (typeof orig.changedTouches !== 'undefined') ? orig.changedTouches : [orig];
		var chromePointerEvents = typeof PointerEvent === 'function'; 
		if (chromePointerEvents) { 
			if (orig.pointerId === undefined) { 
				return;
			} 
		}
        // record the starting touch x, y coordinates
        slider.touch.start.x = touchPoints[0].pageX;
        slider.touch.start.y = touchPoints[0].pageY;

        if (slider.viewport.get(0).setPointerCapture) {
          slider.pointerId = orig.pointerId;
          slider.viewport.get(0).setPointerCapture(slider.pointerId);
        }
        // store original event data for click fixation
        slider.originalClickTarget = orig.originalTarget || orig.target;
        slider.originalClickButton = orig.button;
        slider.originalClickButtons = orig.buttons;
        slider.originalEventType = orig.type;
        // at this moment we don`t know what it is click or swipe
        slider.hasMove = false;
        // on a "touchmove" event to the viewport
        slider.viewport.on('touchmove MSPointerMove pointermove', onTouchMove);
        // on a "touchend" event to the viewport
        slider.viewport.on('touchend MSPointerUp pointerup', onTouchEnd);
        slider.viewport.on('MSPointerCancel pointercancel', onPointerCancel);
      }
    };

    /**
     * Cancel Pointer for Windows Phone
     *
     * @param e (event)
     *  - DOM event object
     */
    var onPointerCancel = function(e) {
      e.preventDefault();
      /* onPointerCancel handler is needed to deal with situations when a touchend
      doesn't fire after a touchstart (this happens on windows phones only) */
      setPositionProperty(slider.touch.originalPos.left, 'reset', 0);

      //remove handlers
      slider.controls.el.removeClass('disabled');
      slider.viewport.off('MSPointerCancel pointercancel', onPointerCancel);
      slider.viewport.off('touchmove MSPointerMove pointermove', onTouchMove);
      slider.viewport.off('touchend MSPointerUp pointerup', onTouchEnd);
      if (slider.viewport.get(0).releasePointerCapture) {
        slider.viewport.get(0).releasePointerCapture(slider.pointerId);
      }
    };

    /**
     * Event handler for "touchmove"
     *
     * @param e (event)
     *  - DOM event object
     */
    var onTouchMove = function(e) {
      var orig = e.originalEvent,
      touchPoints = (typeof orig.changedTouches !== 'undefined') ? orig.changedTouches : [orig],
      // if scrolling on y axis, do not prevent default
      xMovement = Math.abs(touchPoints[0].pageX - slider.touch.start.x),
      yMovement = Math.abs(touchPoints[0].pageY - slider.touch.start.y),
      value = 0,
      change = 0;
      // this is swipe
      slider.hasMove = true;

      // x axis swipe
      if ((xMovement * 3) > yMovement && slider.settings.preventDefaultSwipeX) {
        e.preventDefault();
      // y axis swipe
      } else if ((yMovement * 3) > xMovement && slider.settings.preventDefaultSwipeY) {
        e.preventDefault();
      }
      if (e.type !== 'touchmove') {
        e.preventDefault();
      }

      if (slider.settings.mode !== 'fade' && slider.settings.oneToOneTouch) {
        // if horizontal, drag along x axis
        if (slider.settings.mode === 'horizontal') {
          change = touchPoints[0].pageX - slider.touch.start.x;
          value = slider.touch.originalPos.left + change;
        // if vertical, drag along y axis
        } else {
          change = touchPoints[0].pageY - slider.touch.start.y;
          value = slider.touch.originalPos.top + change;
        }
        setPositionProperty(value, 'reset', 0);
      }
    };

    /**
     * Event handler for "touchend"
     *
     * @param e (event)
     *  - DOM event object
     */
    var onTouchEnd = function(e) {
      e.preventDefault();
      slider.viewport.off('touchmove MSPointerMove pointermove', onTouchMove);
      //enable slider controls as soon as user stops interacing with slides
      slider.controls.el.removeClass('disabled');
      var orig    = e.originalEvent,
      touchPoints = (typeof orig.changedTouches !== 'undefined') ? orig.changedTouches : [orig],
      value       = 0,
      distance    = 0;
      // record end x, y positions
      slider.touch.end.x = touchPoints[0].pageX;
      slider.touch.end.y = touchPoints[0].pageY;
      // if fade mode, check if absolute x distance clears the threshold
      if (slider.settings.mode === 'fade') {
        distance = Math.abs(slider.touch.start.x - slider.touch.end.x);
        if (distance >= slider.settings.swipeThreshold) {
          if (slider.touch.start.x > slider.touch.end.x) {
            el.goToNextSlide();
          } else {
            el.goToPrevSlide();
          }
          el.stopAuto();
        }
      // not fade mode
      } else {
        // calculate distance and el's animate property
        if (slider.settings.mode === 'horizontal') {
          distance = slider.touch.end.x - slider.touch.start.x;
          value = slider.touch.originalPos.left;
        } else {
          distance = slider.touch.end.y - slider.touch.start.y;
          value = slider.touch.originalPos.top;
        }
        // if not infinite loop and first / last slide, do not attempt a slide transition
        if (!slider.settings.infiniteLoop && ((slider.active.index === 0 && distance > 0) || (slider.active.last && distance < 0))) {
          setPositionProperty(value, 'reset', 200);
        } else {
          // check if distance clears threshold
          if (Math.abs(distance) >= slider.settings.swipeThreshold) {
            if (distance < 0) {
              el.goToNextSlide();
            } else {
              el.goToPrevSlide();
            }
            el.stopAuto();
          } else {
            // el.animate(property, 200);
            setPositionProperty(value, 'reset', 200);
          }
        }
      }
      slider.viewport.off('touchend MSPointerUp pointerup', onTouchEnd);

      if (slider.viewport.get(0).releasePointerCapture) {
        slider.viewport.get(0).releasePointerCapture(slider.pointerId);
      }
      // if slider had swipe with left mouse, touch contact and pen contact
      if (slider.hasMove === false && (slider.originalClickButton === 0 || slider.originalEventType === 'touchstart')) {
        // trigger click event (fix for Firefox59 and PointerEvent standard compatibility)
        $(slider.originalClickTarget).trigger({
          type: 'click',
          button: slider.originalClickButton,
          buttons: slider.originalClickButtons
        });
      }
    };

    /**
     * Window resize event callback
     */
    var resizeWindow = function(e) {
      // don't do anything if slider isn't initialized.
      if (!slider.initialized) { return; }
      // Delay if slider working.
      if (slider.working) {
        window.setTimeout(resizeWindow, 10);
      } else {
        // get the new window dimens (again, thank you IE)
        var windowWidthNew = $(window).width(),
        windowHeightNew = $(window).height();
        // make sure that it is a true window resize
        // *we must check this because our dinosaur friend IE fires a window resize event when certain DOM elements
        // are resized. Can you just die already?*
        if (windowWidth !== windowWidthNew || windowHeight !== windowHeightNew) {
          // set the new window dimens
          windowWidth = windowWidthNew;
          windowHeight = windowHeightNew;
          // update all dynamic elements
          el.redrawSlider();
          // Call user resize handler
          slider.settings.onSliderResize.call(el, slider.active.index);
        }
      }
    };

    /**
     * Adds an aria-hidden=true attribute to each element
     *
     * @param startVisibleIndex (int)
     *  - the first visible element's index
     */
    var applyAriaHiddenAttributes = function(startVisibleIndex) {
      var numberOfSlidesShowing = getNumberSlidesShowing();
      // only apply attributes if the setting is enabled and not in ticker mode
      if (slider.settings.ariaHidden && !slider.settings.ticker) {
        // add aria-hidden=true to all elements
        slider.children.attr('aria-hidden', 'true');
        // get the visible elements and change to aria-hidden=false
        slider.children.slice(startVisibleIndex, startVisibleIndex + numberOfSlidesShowing).attr('aria-hidden', 'false');
      }
    };

    /**
     * Returns index according to present page range
     *
     * @param slideOndex (int)
     *  - the desired slide index
     */
    var setSlideIndex = function(slideIndex) {
      if (slideIndex < 0) {
        if (slider.settings.infiniteLoop) {
          return getPagerQty() - 1;
        }else {
          //we don't go to undefined slides
          return slider.active.index;
        }
      // if slideIndex is greater than children length, set active index to 0 (this happens during infinite loop)
      } else if (slideIndex >= getPagerQty()) {
        if (slider.settings.infiniteLoop) {
          return 0;
        } else {
          //we don't move to undefined pages
          return slider.active.index;
        }
      // set active index to requested slide
      } else {
        return slideIndex;
      }
    };

    /**
     * ===================================================================================
     * = PUBLIC FUNCTIONS
     * ===================================================================================
     */

    /**
     * Performs slide transition to the specified slide
     *
     * @param slideIndex (int)
     *  - the destination slide's index (zero-based)
     *
     * @param direction (string)
     *  - INTERNAL USE ONLY - the direction of travel ("prev" / "next")
     */
    el.goToSlide = function(slideIndex, direction) {
      // onSlideBefore, onSlideNext, onSlidePrev callbacks
      // Allow transition canceling based on returned value
      var performTransition = true,
      moveBy = 0,
      position = {left: 0, top: 0},
      lastChild = null,
      lastShowingIndex, eq, value, requestEl;
      // store the old index
      slider.oldIndex = slider.active.index;
      //set new index
      slider.active.index = setSlideIndex(slideIndex);

      // if plugin is currently in motion, ignore request
      if (slider.working || slider.active.index === slider.oldIndex) { return; }
      // declare that plugin is in motion
      slider.working = true;

      performTransition = slider.settings.onSlideBefore.call(el, slider.children.eq(slider.active.index), slider.oldIndex, slider.active.index);

      // If transitions canceled, reset and return
      if (typeof (performTransition) !== 'undefined' && !performTransition) {
        slider.active.index = slider.oldIndex; // restore old index
        slider.working = false; // is not in motion
        return;
      }

      if (direction === 'next') {
        // Prevent canceling in future functions or lack there-of from negating previous commands to cancel
        if (!slider.settings.onSlideNext.call(el, slider.children.eq(slider.active.index), slider.oldIndex, slider.active.index)) {
          performTransition = false;
        }
      } else if (direction === 'prev') {
        // Prevent canceling in future functions or lack there-of from negating previous commands to cancel
        if (!slider.settings.onSlidePrev.call(el, slider.children.eq(slider.active.index), slider.oldIndex, slider.active.index)) {
          performTransition = false;
        }
      }

      // check if last slide
      slider.active.last = slider.active.index >= getPagerQty() - 1;
      // update the pager with active class
      if (slider.settings.pager || slider.settings.pagerCustom) { updatePagerActive(slider.active.index); }
      // // check for direction control update
      if (slider.settings.controls) { updateDirectionControls(); }
      // if slider is set to mode: "fade"
      if (slider.settings.mode === 'fade') {
        // if adaptiveHeight is true and next height is different from current height, animate to the new height
        if (slider.settings.adaptiveHeight && slider.viewport.height() !== getViewportHeight()) {
          slider.viewport.animate({height: getViewportHeight()}, slider.settings.adaptiveHeightSpeed);
        }
        // fade out the visible child and reset its z-index value
        slider.children.filter(':visible').fadeOut(slider.settings.speed).css({zIndex: 0});
        // fade in the newly requested slide
        slider.children.eq(slider.active.index).css('zIndex', slider.settings.slideZIndex + 1).fadeIn(slider.settings.speed, function() {
          $(this).css('zIndex', slider.settings.slideZIndex);
          updateAfterSlideTransition();
        });
      // slider mode is not "fade"
      } else {
        // if adaptiveHeight is true and next height is different from current height, animate to the new height
        if (slider.settings.adaptiveHeight && slider.viewport.height() !== getViewportHeight()) {
          slider.viewport.animate({height: getViewportHeight()}, slider.settings.adaptiveHeightSpeed);
        }
        // if carousel and not infinite loop
        if (!slider.settings.infiniteLoop && slider.carousel && slider.active.last) {
          if (slider.settings.mode === 'horizontal') {
            // get the last child position
            lastChild = slider.children.eq(slider.children.length - 1);
            position = lastChild.position();
            // calculate the position of the last slide
            moveBy = slider.viewport.width() - lastChild.outerWidth();
          } else {
            // get last showing index position
            lastShowingIndex = slider.children.length - slider.settings.minSlides;
            position = slider.children.eq(lastShowingIndex).position();
          }
          // horizontal carousel, going previous while on first slide (infiniteLoop mode)
        } else if (slider.carousel && slider.active.last && direction === 'prev') {
          // get the last child position
          eq = slider.settings.moveSlides === 1 ? slider.settings.maxSlides - getMoveBy() : ((getPagerQty() - 1) * getMoveBy()) - (slider.children.length - slider.settings.maxSlides);
          lastChild = el.children('.bx-clone').eq(eq);
          position = lastChild.position();
        // if infinite loop and "Next" is clicked on the last slide
        } else if (direction === 'next' && slider.active.index === 0) {
          // get the last clone position
          position = el.find('> .bx-clone').eq(slider.settings.maxSlides).position();
          slider.active.last = false;
        // normal non-zero requests
        } else if (slideIndex >= 0) {
          //parseInt is applied to allow floats for slides/page
          requestEl = slideIndex * parseInt(getMoveBy());
          position = slider.children.eq(requestEl).position();
        }

        /* If the position doesn't exist
         * (e.g. if you destroy the slider on a next click),
         * it doesn't throw an error.
         */
        if (typeof (position) !== 'undefined') {
          value = slider.settings.mode === 'horizontal' ? -(position.left - moveBy) : -position.top;
          // plugin values to be animated
          setPositionProperty(value, 'slide', slider.settings.speed);
        }
        slider.working = false;
      }
      if (slider.settings.ariaHidden) { applyAriaHiddenAttributes(slider.active.index * getMoveBy()); }
    };

    /**
     * Transitions to the next slide in the show
     */
    el.goToNextSlide = function() {
      // if infiniteLoop is false and last page is showing, disregard call
      if (!slider.settings.infiniteLoop && slider.active.last) { return; }
	  if (slider.working === true){ return ;}
      var pagerIndex = parseInt(slider.active.index) + 1;
      el.goToSlide(pagerIndex, 'next');
    };

    /**
     * Transitions to the prev slide in the show
     */
    el.goToPrevSlide = function() {
      // if infiniteLoop is false and last page is showing, disregard call
      if (!slider.settings.infiniteLoop && slider.active.index === 0) { return; }
	  if (slider.working === true){ return ;}
      var pagerIndex = parseInt(slider.active.index) - 1;
      el.goToSlide(pagerIndex, 'prev');
    };

    /**
     * Starts the auto show
     *
     * @param preventControlUpdate (boolean)
     *  - if true, auto controls state will not be updated
     */
    el.startAuto = function(preventControlUpdate) {
      // if an interval already exists, disregard call
      if (slider.interval) { return; }
      // create an interval
      slider.interval = setInterval(function() {
        if (slider.settings.autoDirection === 'next') {
          el.goToNextSlide();
        } else {
          el.goToPrevSlide();
        }
      }, slider.settings.pause);
	  //allback for when the auto rotate status changes
	  slider.settings.onAutoChange.call(el, true);
      // if auto controls are displayed and preventControlUpdate is not true
      if (slider.settings.autoControls && preventControlUpdate !== true) { updateAutoControls('stop'); }
    };

    /**
     * Stops the auto show
     *
     * @param preventControlUpdate (boolean)
     *  - if true, auto controls state will not be updated
     */
    el.stopAuto = function(preventControlUpdate) {
      // if slider is auto paused, just clear that state
      if (slider.autoPaused) slider.autoPaused = false;
      // if no interval exists, disregard call
      if (!slider.interval) { return; }
      // clear the interval
      clearInterval(slider.interval);
      slider.interval = null;
	  //allback for when the auto rotate status changes
	  slider.settings.onAutoChange.call(el, false);
      // if auto controls are displayed and preventControlUpdate is not true
      if (slider.settings.autoControls && preventControlUpdate !== true) { updateAutoControls('start'); }
    };

    /**
     * Returns current slide index (zero-based)
     */
    el.getCurrentSlide = function() {
      return slider.active.index;
    };

    /**
     * Returns current slide element
     */
    el.getCurrentSlideElement = function() {
      return slider.children.eq(slider.active.index);
    };

    /**
     * Returns a slide element
     * @param index (int)
     *  - The index (zero-based) of the element you want returned.
     */
    el.getSlideElement = function(index) {
      return slider.children.eq(index);
    };

    /**
     * Returns number of slides in show
     */
    el.getSlideCount = function() {
      return slider.children.length;
    };

    /**
     * Return slider.working variable
     */
    el.isWorking = function() {
      return slider.working;
    };

    /**
     * Update all dynamic slider elements
     */
    el.redrawSlider = function() {
      // resize all children in ratio to new screen size
      slider.children.add(el.find('.bx-clone')).outerWidth(getSlideWidth());
      // adjust the height
      slider.viewport.css('height', getViewportHeight());
      // update the slide position
      if (!slider.settings.ticker) { setSlidePosition(); }
      // if active.last was true before the screen resize, we want
      // to keep it last no matter what screen size we end on
      if (slider.active.last) { slider.active.index = getPagerQty() - 1; }
      // if the active index (page) no longer exists due to the resize, simply set the index as last
      if (slider.active.index >= getPagerQty()) { slider.active.last = true; }
      // if a pager is being displayed and a custom pager is not being used, update it
      if (slider.settings.pager && !slider.settings.pagerCustom) {
        populatePager();
        updatePagerActive(slider.active.index);
      }
      if (slider.settings.ariaHidden) { applyAriaHiddenAttributes(slider.active.index * getMoveBy()); }
    };

    /**
     * Destroy the current instance of the slider (revert everything back to original state)
     */
    el.destroySlider = function() {
      // don't do anything if slider has already been destroyed
      if (!slider.initialized) { return; }
      slider.initialized = false;
      $('.bx-clone', this).remove();
      slider.children.each(function() {
        if ($(this).data('origStyle') !== undefined) {
          $(this).attr('style', $(this).data('origStyle'));
        } else {
          $(this).removeAttr('style');
        }
      });
      if ($(this).data('origStyle') !== undefined) {
        this.attr('style', $(this).data('origStyle'));
      } else {
        $(this).removeAttr('style');
      }
      $(this).unwrap().unwrap();
      if (slider.controls.el) { slider.controls.el.remove(); }
      if (slider.controls.next) { slider.controls.next.remove(); }
      if (slider.controls.prev) { slider.controls.prev.remove(); }
      if (slider.pagerEl && slider.settings.controls && !slider.settings.pagerCustom) { slider.pagerEl.remove(); }
      $('.bx-caption', this).remove();
      if (slider.controls.autoEl) { slider.controls.autoEl.remove(); }
      clearInterval(slider.interval);
      if (slider.settings.responsive) { $(window).off('resize', resizeWindow); }
      if (slider.settings.keyboardEnabled) { $(document).off('keydown', keyPress); }
      //remove self reference in data
      $(this).removeData('bxSlider');
	  // remove global window handlers
	  $(window).off('blur', windowBlurHandler).off('focus', windowFocusHandler);
    };

    /**
     * Reload the slider (revert all DOM changes, and re-initialize)
     */
    el.reloadSlider = function(settings) {
      if (settings !== undefined) { options = settings; }
      el.destroySlider();
      init();
      //store reference to self in order to access public functions later
      $(el).data('bxSlider', this);
    };

    init();

    $(el).data('bxSlider', this);

    // returns the current jQuery object
    return this;
  };

})(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 82 */
/***/ (function(module, exports) {

/*yepnope1.5.x|WTFPL*/
(function(a,b,c){function d(a){return"[object Function]"==o.call(a)}function e(a){return"string"==typeof a}function f(){}function g(a){return!a||"loaded"==a||"complete"==a||"uninitialized"==a}function h(){var a=p.shift();q=1,a?a.t?m(function(){("c"==a.t?B.injectCss:B.injectJs)(a.s,0,a.a,a.x,a.e,1)},0):(a(),h()):q=0}function i(a,c,d,e,f,i,j){function k(b){if(!o&&g(l.readyState)&&(u.r=o=1,!q&&h(),l.onload=l.onreadystatechange=null,b)){"img"!=a&&m(function(){t.removeChild(l)},50);for(var d in y[c])y[c].hasOwnProperty(d)&&y[c][d].onload()}}var j=j||B.errorTimeout,l=b.createElement(a),o=0,r=0,u={t:d,s:c,e:f,a:i,x:j};1===y[c]&&(r=1,y[c]=[]),"object"==a?l.data=c:(l.src=c,l.type=a),l.width=l.height="0",l.onerror=l.onload=l.onreadystatechange=function(){k.call(this,r)},p.splice(e,0,u),"img"!=a&&(r||2===y[c]?(t.insertBefore(l,s?null:n),m(k,j)):y[c].push(l))}function j(a,b,c,d,f){return q=0,b=b||"j",e(a)?i("c"==b?v:u,a,b,this.i++,c,d,f):(p.splice(this.i++,0,a),1==p.length&&h()),this}function k(){var a=B;return a.loader={load:j,i:0},a}var l=b.documentElement,m=a.setTimeout,n=b.getElementsByTagName("script")[0],o={}.toString,p=[],q=0,r="MozAppearance"in l.style,s=r&&!!b.createRange().compareNode,t=s?l:n.parentNode,l=a.opera&&"[object Opera]"==o.call(a.opera),l=!!b.attachEvent&&!l,u=r?"object":l?"script":"img",v=l?"script":u,w=Array.isArray||function(a){return"[object Array]"==o.call(a)},x=[],y={},z={timeout:function(a,b){return b.length&&(a.timeout=b[0]),a}},A,B;B=function(a){function b(a){var a=a.split("!"),b=x.length,c=a.pop(),d=a.length,c={url:c,origUrl:c,prefixes:a},e,f,g;for(f=0;f<d;f++)g=a[f].split("="),(e=z[g.shift()])&&(c=e(c,g));for(f=0;f<b;f++)c=x[f](c);return c}function g(a,e,f,g,h){var i=b(a),j=i.autoCallback;i.url.split(".").pop().split("?").shift(),i.bypass||(e&&(e=d(e)?e:e[a]||e[g]||e[a.split("/").pop().split("?")[0]]),i.instead?i.instead(a,e,f,g,h):(y[i.url]?i.noexec=!0:y[i.url]=1,f.load(i.url,i.forceCSS||!i.forceJS&&"css"==i.url.split(".").pop().split("?").shift()?"c":c,i.noexec,i.attrs,i.timeout),(d(e)||d(j))&&f.load(function(){k(),e&&e(i.origUrl,h,g),j&&j(i.origUrl,h,g),y[i.url]=2})))}function h(a,b){function c(a,c){if(a){if(e(a))c||(j=function(){var a=[].slice.call(arguments);k.apply(this,a),l()}),g(a,j,b,0,h);else if(Object(a)===a)for(n in m=function(){var b=0,c;for(c in a)a.hasOwnProperty(c)&&b++;return b}(),a)a.hasOwnProperty(n)&&(!c&&!--m&&(d(j)?j=function(){var a=[].slice.call(arguments);k.apply(this,a),l()}:j[n]=function(a){return function(){var b=[].slice.call(arguments);a&&a.apply(this,b),l()}}(k[n])),g(a[n],j,b,n,h))}else!c&&l()}var h=!!a.test,i=a.load||a.both,j=a.callback||f,k=j,l=a.complete||f,m,n;c(h?a.yep:a.nope,!!i),i&&c(i)}var i,j,l=this.yepnope.loader;if(e(a))g(a,0,l,0);else if(w(a))for(i=0;i<a.length;i++)j=a[i],e(j)?g(j,0,l,0):w(j)?B(j):Object(j)===j&&h(j,l);else Object(a)===a&&h(a,l)},B.addPrefix=function(a,b){z[a]=b},B.addFilter=function(a){x.push(a)},B.errorTimeout=1e4,null==b.readyState&&b.addEventListener&&(b.readyState="loading",b.addEventListener("DOMContentLoaded",A=function(){b.removeEventListener("DOMContentLoaded",A,0),b.readyState="complete"},0)),a.yepnope=k(),a.yepnope.executeStack=h,a.yepnope.injectJs=function(a,c,d,e,i,j){var k=b.createElement("script"),l,o,e=e||B.errorTimeout;k.src=a;for(o in d)k.setAttribute(o,d[o]);c=j?h:c||f,k.onreadystatechange=k.onload=function(){!l&&g(k.readyState)&&(l=1,c(),k.onload=k.onreadystatechange=null)},m(function(){l||(l=1,c(1))},e),i?k.onload():n.parentNode.insertBefore(k,n)},a.yepnope.injectCss=function(a,c,d,e,g,i){var e=b.createElement("link"),j,c=i?h:c||f;e.href=a,e.rel="stylesheet",e.type="text/css";for(j in d)e.setAttribute(j,d[j]);g||(n.parentNode.insertBefore(e,n),m(c,0))}})(this,document);

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var xlinkNS = 'http://www.w3.org/1999/xlink';
var xmlNS = 'http://www.w3.org/XML/1998/namespace';
var colonChar = 58;
var xChar = 120;
function updateAttrs(oldVnode, vnode) {
    var key, elm = vnode.elm, oldAttrs = oldVnode.data.attrs, attrs = vnode.data.attrs;
    if (!oldAttrs && !attrs)
        return;
    if (oldAttrs === attrs)
        return;
    oldAttrs = oldAttrs || {};
    attrs = attrs || {};
    // update modified attributes, add new attributes
    for (key in attrs) {
        var cur = attrs[key];
        var old = oldAttrs[key];
        if (old !== cur) {
            if (cur === true) {
                elm.setAttribute(key, "");
            }
            else if (cur === false) {
                elm.removeAttribute(key);
            }
            else {
                if (key.charCodeAt(0) !== xChar) {
                    elm.setAttribute(key, cur);
                }
                else if (key.charCodeAt(3) === colonChar) {
                    // Assume xml namespace
                    elm.setAttributeNS(xmlNS, key, cur);
                }
                else if (key.charCodeAt(5) === colonChar) {
                    // Assume xlink namespace
                    elm.setAttributeNS(xlinkNS, key, cur);
                }
                else {
                    elm.setAttribute(key, cur);
                }
            }
        }
    }
    // remove removed attributes
    // use `in` operator since the previous `for` iteration uses it (.i.e. add even attributes with undefined value)
    // the other option is to remove all attributes with value == undefined
    for (key in oldAttrs) {
        if (!(key in attrs)) {
            elm.removeAttribute(key);
        }
    }
}
exports.attributesModule = { create: updateAttrs, update: updateAttrs };
exports.default = exports.attributesModule;
//# sourceMappingURL=attributes.js.map

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function updateProps(oldVnode, vnode) {
    var key, cur, old, elm = vnode.elm, oldProps = oldVnode.data.props, props = vnode.data.props;
    if (!oldProps && !props)
        return;
    if (oldProps === props)
        return;
    oldProps = oldProps || {};
    props = props || {};
    for (key in oldProps) {
        if (!props[key]) {
            delete elm[key];
        }
    }
    for (key in props) {
        cur = props[key];
        old = oldProps[key];
        if (old !== cur && (key !== 'value' || elm[key] !== cur)) {
            elm[key] = cur;
        }
    }
}
exports.propsModule = { create: updateProps, update: updateProps };
exports.default = exports.propsModule;
//# sourceMappingURL=props.js.map

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// Bindig `requestAnimationFrame` like this fixes a bug in IE/Edge. See #360 and #409.
var raf = (typeof window !== 'undefined' && (window.requestAnimationFrame).bind(window)) || setTimeout;
var nextFrame = function (fn) { raf(function () { raf(fn); }); };
var reflowForced = false;
function setNextFrame(obj, prop, val) {
    nextFrame(function () { obj[prop] = val; });
}
function updateStyle(oldVnode, vnode) {
    var cur, name, elm = vnode.elm, oldStyle = oldVnode.data.style, style = vnode.data.style;
    if (!oldStyle && !style)
        return;
    if (oldStyle === style)
        return;
    oldStyle = oldStyle || {};
    style = style || {};
    var oldHasDel = 'delayed' in oldStyle;
    for (name in oldStyle) {
        if (!style[name]) {
            if (name[0] === '-' && name[1] === '-') {
                elm.style.removeProperty(name);
            }
            else {
                elm.style[name] = '';
            }
        }
    }
    for (name in style) {
        cur = style[name];
        if (name === 'delayed' && style.delayed) {
            for (var name2 in style.delayed) {
                cur = style.delayed[name2];
                if (!oldHasDel || cur !== oldStyle.delayed[name2]) {
                    setNextFrame(elm.style, name2, cur);
                }
            }
        }
        else if (name !== 'remove' && cur !== oldStyle[name]) {
            if (name[0] === '-' && name[1] === '-') {
                elm.style.setProperty(name, cur);
            }
            else {
                elm.style[name] = cur;
            }
        }
    }
}
function applyDestroyStyle(vnode) {
    var style, name, elm = vnode.elm, s = vnode.data.style;
    if (!s || !(style = s.destroy))
        return;
    for (name in style) {
        elm.style[name] = style[name];
    }
}
function applyRemoveStyle(vnode, rm) {
    var s = vnode.data.style;
    if (!s || !s.remove) {
        rm();
        return;
    }
    if (!reflowForced) {
        getComputedStyle(document.body).transform;
        reflowForced = true;
    }
    var name, elm = vnode.elm, i = 0, compStyle, style = s.remove, amount = 0, applied = [];
    for (name in style) {
        applied.push(name);
        elm.style[name] = style[name];
    }
    compStyle = getComputedStyle(elm);
    var props = compStyle['transition-property'].split(', ');
    for (; i < props.length; ++i) {
        if (applied.indexOf(props[i]) !== -1)
            amount++;
    }
    elm.addEventListener('transitionend', function (ev) {
        if (ev.target === elm)
            --amount;
        if (amount === 0)
            rm();
    });
}
function forceReflow() {
    reflowForced = false;
}
exports.styleModule = {
    pre: forceReflow,
    create: updateStyle,
    update: updateStyle,
    destroy: applyDestroyStyle,
    remove: applyRemoveStyle
};
exports.default = exports.styleModule;
//# sourceMappingURL=style.js.map

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function invokeHandler(handler, vnode, event) {
    if (typeof handler === "function") {
        // call function handler
        handler.call(vnode, event, vnode);
    }
    else if (typeof handler === "object") {
        // call handler with arguments
        if (typeof handler[0] === "function") {
            // special case for single argument for performance
            if (handler.length === 2) {
                handler[0].call(vnode, handler[1], event, vnode);
            }
            else {
                var args = handler.slice(1);
                args.push(event);
                args.push(vnode);
                handler[0].apply(vnode, args);
            }
        }
        else {
            // call multiple handlers
            for (var i = 0; i < handler.length; i++) {
                invokeHandler(handler[i], vnode, event);
            }
        }
    }
}
function handleEvent(event, vnode) {
    var name = event.type, on = vnode.data.on;
    // call event handler(s) if exists
    if (on && on[name]) {
        invokeHandler(on[name], vnode, event);
    }
}
function createListener() {
    return function handler(event) {
        handleEvent(event, handler.vnode);
    };
}
function updateEventListeners(oldVnode, vnode) {
    var oldOn = oldVnode.data.on, oldListener = oldVnode.listener, oldElm = oldVnode.elm, on = vnode && vnode.data.on, elm = (vnode && vnode.elm), name;
    // optimization for reused immutable handlers
    if (oldOn === on) {
        return;
    }
    // remove existing listeners which no longer used
    if (oldOn && oldListener) {
        // if element changed or deleted we remove all existing listeners unconditionally
        if (!on) {
            for (name in oldOn) {
                // remove listener if element was changed or existing listeners removed
                oldElm.removeEventListener(name, oldListener, false);
            }
        }
        else {
            for (name in oldOn) {
                // remove listener if existing listener removed
                if (!on[name]) {
                    oldElm.removeEventListener(name, oldListener, false);
                }
            }
        }
    }
    // add new listeners which has not already attached
    if (on) {
        // reuse existing listener or create new
        var listener = vnode.listener = oldVnode.listener || createListener();
        // update vnode for listener
        listener.vnode = vnode;
        // if element changed or added we add all needed listeners unconditionally
        if (!oldOn) {
            for (name in on) {
                // add listener if element was changed or new listeners added
                elm.addEventListener(name, listener, false);
            }
        }
        else {
            for (name in on) {
                // add listener if new listener added
                if (!oldOn[name]) {
                    elm.addEventListener(name, listener, false);
                }
            }
        }
    }
}
exports.eventListenersModule = {
    create: updateEventListeners,
    update: updateEventListeners,
    destroy: updateEventListeners
};
exports.default = exports.eventListenersModule;
//# sourceMappingURL=eventlisteners.js.map

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function updateClass(oldVnode, vnode) {
    var cur, name, elm = vnode.elm, oldClass = oldVnode.data.class, klass = vnode.data.class;
    if (!oldClass && !klass)
        return;
    if (oldClass === klass)
        return;
    oldClass = oldClass || {};
    klass = klass || {};
    for (name in oldClass) {
        if (!klass[name]) {
            elm.classList.remove(name);
        }
    }
    for (name in klass) {
        cur = klass[name];
        if (cur !== oldClass[name]) {
            elm.classList[cur ? 'add' : 'remove'](name);
        }
    }
}
exports.classModule = { create: updateClass, update: updateClass };
exports.default = exports.classModule;
//# sourceMappingURL=class.js.map

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_$) {(function ($) {
	/**
	 * Swisscom Cookies
	 *
	 * Wrapper for $.cookies (jquery.cookies.2.2.0.min.js)
	 * See documentation on http://code.google.com/p/cookies/wiki/Documentation
	 *
	 * @author Juliane Huber, Thomas Junghans
	 * @namespace $
	 * @class setCookie, getCookie, removeCookie
	 */

	'use strict';

	/**
	 * setCookie
	 *
	 * @param {String} name
	 * @param {*} value
	 * @param {Number} days (optional)
	 * @param {String} path (optional)
	 * @param {String} domain (optional)
	 * @return {*}
	 */
	$.setCookie = function (name, value, days, path, domain) {
		var date;
		if (days && !isNaN(days)) {
			date = new Date();
			date.setTime(date.getTime() + (days*24*60*60*1000));
		}
		$.cookies.set(name, value, {
			secure: location.protocol.indexOf('https') >= 0,
			path: path || '/',
			expiresAt: date || '',
			domain: domain || null
		});
		return value;
	};

	/**
	 * getCookie
	 *
	 * @param {String} name
	 * @return {*}
	 */
	$.getCookie = function (name) {
		return $.cookies.get(name);
	};

	/**
	 * removeCookie
	 *
	 * @param {String} name
	 * @param {String} path
	 * @param {String} domain
	 */
	$.removeCookie = function (name, path, domain) {
		$.cookies.del(name, {
			secure: location.protocol.indexOf('https') >= 0,
			path: path || '/',
			domain: domain || null
		});
	};

})(__webpack_provided_window_dot_$);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

(function () {
	/**
	 * Global hash deeplinks
	 *
	 * @author Matthias Inauen
	 * @namespace SCS
	 * @class HashDeepLink
	 */

	'use strict';
	window.SCS = window.SCS || {};

	window.SCS.HashDeepLink = __webpack_require__(4).hashDeepLink;

}());


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($) {
	'use strict';
	/*globals Tc, debug, google */

	/**
	 * @author Matthias Inauen
	 * @namespace Tc.Module
	 * @class Google Maps
	 * @extends Tc.Module
	 *
	 */
	Tc.Module.GoogleMaps = Tc.Module.extend({

		channelId: 'googleMaps',
		statusMapLoaded: 'googleMapLoaded',
		drawMapLocations: 'googleMapDrawLocations',
		statusShowMap: 'googleMapShowMap',
		markerPinImageHeight: 30,
		DEFAULT_LAT: 47.378388,
		DEFAULT_LNG: 8.539193,
		DEFAULT_ZOOM: 16,

		init: function($ctx, sandbox, modId) {
			this.$ctx = $ctx;
			this.mapCenterLat = (this.$ctx.data('centerlat')) ? parseFloat(this.$ctx.data('centerlat')) : this.DEFAULT_LAT;
			this.mapCenterLng = (this.$ctx.data('centerlng')) ? parseFloat(this.$ctx.data('centerlng')) : this.DEFAULT_LNG;
			this.mapZoom = (this.$ctx.data('mapzoom')) ? parseInt(this.$ctx.data('mapzoom')) : this.DEFAULT_ZOOM;
			this.markerPinImage = this.$ctx.data('pinurl');
			this.mapmarkers = [];
			this.locations = this.$ctx.data('locations');
			this.lazyLoad = this.$ctx.data('lazyload') ? true : false;
			if(this.markerPinImage){
				$('<img>').on('load', $.proxy(this.setPinImageHeight, this)).attr('src', this.markerPinImage);
			}

			this.initialiazed = false;
			this._super($ctx, sandbox, modId);
		},

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {

			if( !this.lazyLoad ) {
				this.initGoolgeMapModule();
			}
			callback();
		},

		setPinImageHeight: function(event){
			this.markerPinImageHeight = event.target.height;
		},

		loadMap: function() {
			Tc.Module.GoogleMaps.globalMapLoaded = $.proxy(this.mapLoaded, this);
			var script = document.createElement('script');
			script.type = 'text/javascript';
			script.src = 'https://maps.googleapis.com/maps/api/js?v=3.exp&' +
				'key=AIzaSyCZ7XcxAZ9vixukf6fm5EaUvAAfjzdw7Zw&' + // pragma: allowlist-secret
				'callback=Tc.Module.GoogleMaps.globalMapLoaded';
			document.body.appendChild(script);
		},

		mapLoaded: function(){
			var mod = this;

			mod.fire(mod.statusMapLoaded, {}, [mod.channelId]);

			mod.initializeMap();
		},

		initializeMap: function(){
			var mod = this;

			mod.mapOptions = {
				center: new google.maps.LatLng(mod.mapCenterLat, mod.mapCenterLng),
				zoom: mod.mapZoom
			};

			mod.map = new google.maps.Map(document.getElementById(mod.$ctx.attr('id')), mod.mapOptions);
			mod.geocoder = new google.maps.Geocoder();
			mod.mapInfoWindow = new google.maps.InfoWindow({pixelOffset: new google.maps.Size(0, -this.markerPinImageHeight) });
			this.drawMapMarkers();
		},

		drawMapMarkers: function() {
			var i,
				locationData,
				length,
				latlng,
				mod = this;
			this.createGoogleCnt = this.createGoogleCnt || 0;

			if( typeof google !== "undefined" ) {
				mod.clearMapMarkers();
				if(mod.locations){
					for(i = 0, length = mod.locations.length; i < length; i++){
						locationData = mod.locations[i];
						if( locationData.locationlat !== '' && locationData.locationlng !== '' ) {
							latlng = new google.maps.LatLng( parseFloat(locationData.locationlat), parseFloat(locationData.locationlng) );
							mod.drawLocation( latlng, locationData.title, locationData.description );
						}
						else if( locationData.address && locationData.address !== '' ) {
							mod.geolockup( locationData );
						}

					}
				}
			} else {
				if (this.createGoogleCnt < 10) {
					this.createGoogleCnt++;
					setTimeout($.proxy(this.drawMapMarkers, this), 500);
				}
			}
		},

		drawLocation: function( latlng, title, description ){

			var marker = new google.maps.Marker({
				position: latlng,
				title: title,
				icon: this.markerPinImage,
				map: this.map
			});

			this.mapBounds.extend(marker.position);
			google.maps.event.addListener(marker, 'click', $.proxy(this.handleMarkerClicked, this));
			this.mapmarkers.push({ marker: marker, infoWindowContent: description.replace(new RegExp('\r?\n','g'), '<br />') });
			// you have to do this everytime, cause geolockups are asynchronous
			this.map.fitBounds(this.mapBounds);
		},

		clearMapMarkers: function(){
			var markerItem;
			if( this.map && this.mapmarkers.length ){
				while(this.mapmarkers.length){
					markerItem = this.mapmarkers.pop();
					google.maps.event.clearInstanceListeners(markerItem.marker);
					markerItem.marker.setMap(null);
				}
			}

			this.mapBounds = new google.maps.LatLngBounds();
			this.mapmarkers = [];
		},

		geolockup: function( locationData ){
			var mod = this;
			mod.geocoder.geocode( { 'address': locationData.address }, function(results, status) {
				if (status == google.maps.GeocoderStatus.OK) {
					mod.drawLocation(results[0].geometry.location, locationData.title, locationData.description);
				}
			});
		},

		handleMarkerClicked: function(event){
			this.mapInfoWindow.close();
			this.mapInfoWindow.setOptions({
				content: this.getDescriptionFromLatLng(event.latLng),
				pixelOffset: new google.maps.Size(0, -(this.markerPinImageHeight + 5))
			});
			this.mapInfoWindow.setPosition(event.latLng);
			this.mapInfoWindow.open(this.map);
		},

		getDescriptionFromLatLng: function( latlng ){
			var i, length, markerItem, description = '';
			for( i = 0, length = this.mapmarkers.length; i < length; i++){
				markerItem = this.mapmarkers[i];
				if(latlng.equals(markerItem.marker.position)) {
					description = "<div class=\"googleMapsInfoWindowContentWrapper\">"+markerItem.infoWindowContent+"</div>";
					break;
				}
			}

			return description;
		},

		getMarkerFromLatLng: function( lat, lng ){
			var i, length,
				latlng = new google.maps.LatLng(lat, lng),
				markerItem = null;

			for( i = 0, length = this.mapmarkers.length; i < length; i++){
				markerItem = this.mapmarkers[i];
				if(latlng.equals(markerItem.marker.position)) {
					break;
				}
			}

			return markerItem;
		},

		onGoogleMapLoaded: function(){
			this.initializeMap();
		},

		/**
		 * Channel Call Handler.
		 * Expects an Array with location Objects in data.locations as follows:
		 *
		 * data.locations = [
		 *						{title: (String), locationlat: (Float), locationlng: (Float), description: (String), address: (String)},
		 *						...
		 * 					]
		 *
		 * @param data
		 */
		onGoogleMapDrawLocations: function(data){
			this.initGoolgeMapModule();
			this.locations = data.locations;
			this.drawMapMarkers();
		},

		/**
		 * Resizes the google map container to the parent container with potentially changed dimensions.
		 * The data attribute may have a new mapcenter position. (which should be an object of {lat: (float), lng: (float) }
		 * @param data
		 */
		onGoogleMapShowMap: function(data) {
			this.initGoolgeMapModule();
			google.maps.event.trigger(this.map, 'resize');
			this.map.fitBounds(this.mapBounds);

			if( data.mapcenter ) {
				this.map.setCenter(data.mapcenter);
				var marker = this.getMarkerFromLatLng( data.mapcenter.lat, data.mapcenter.lng );

				if( marker.marker ){
					google.maps.event.trigger(marker.marker, 'click', { latLng: marker.marker.position });
				}
			}
		},

		initGoolgeMapModule: function() {
			if ( this.initialiazed == false ) {
				if((typeof(window.google) === 'undefined' || typeof(window.google.maps) === 'undefined')) {
					if(!Tc.Module.GoogleMaps.globalMapsLibIsLoading){
						Tc.Module.GoogleMaps.globalMapsLibIsLoading = true;
						this.loadMap();
					}
					else {
						// do nothing and wait for a call on the channel.
					}
				}
				else {
					this.initializeMap();
				}
				this.initialiazed = true;
			}
		}
	});
}(__webpack_provided_window_dot_Tc_dot_$));

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

var imageLoaded = __webpack_require__(3).imageLoaded;

(function ($, Tc, SCS) {
	'use strict';

	var TRACKING_EVENT_ACTION = 'view';
	var TRACKING_EVENT_CATEGORY = 'slider';

	/**
	 * Wrapper for BxSlider2
	 *
	 * @author Matthias Inauen
	 * @namespace Tc.Module
	 * @class Slider
	 * @extends Tc.Module
	 */
	Tc.Module.Slider = Tc.Module.extend({
		/**
		 * Initialize Slider - only if more than one element is present
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this;

			mod.animationInterval = mod.$ctx.data('animationInterval') ? mod.$ctx.data('animationInterval') : 0;
			mod.loopAround = mod.$ctx.data('loopAround') ? true : false;
			mod.startIndex = mod.$ctx.data('startIndex') ? (parseInt(mod.$ctx.data('startIndex'), 10) - 1) : 0;
			mod.deepLinking = mod.$ctx.data('deepLinking') ? true : false;
			mod.sliderId = mod.$ctx.data('sliderId');
			mod.isMobile = $(document.body).hasClass('is-mobile');
			mod.videoVolume = mod.$ctx.find('.video-volume');
			mod.slides = mod.$ctx.find('ul.bx-slider .modSlide');
			mod.disableTracking = mod.$ctx.data('disable-tracking');
			mod.trackingLocation = mod.$ctx.data('event-location');
			mod.trackingStarted = false;
			mod.noControlsFadeout = mod.$ctx.data('no-controls-fadeout');
			mod.controls = {};
			mod.componentInitialized = false;
			mod.redrawDebounceTimer = 0;

			if (mod.slides.length <= 1) {
				mod.$ctx.addClass('no-controls');
			}

			mod.controlsEnabled = !mod.$ctx.hasClass('no-controls');

			if (mod.deepLinking && mod.sliderId) {
				var deepLinkValue = parseInt(SCS.HashDeepLink.get(mod.sliderId), 10) - 1; // make base 0
				mod.startIndex = (deepLinkValue) ? parseInt(deepLinkValue, 10) : mod.startIndex;
				// make sure start index is not larger than amount of slides available
				mod.startIndex = (mod.startIndex >= mod.$ctx.find('.modSlide').length) ? 0 : mod.startIndex;
			}

			// subscribe to my own channel, so others can communicate back
			this.sandbox.subscribe('SLIDER', this);
			var uuid = Math.floor((Math.random() * 100000000000)) + '-' + Math.floor((Math.random() * 100000000000));
			this.$ctx.attr('data-id', uuid);
			if(this.$ctx.hasClass('sdx') && !this.$ctx.hasClass('fullbleed')) {
				var elemWidth = this.$ctx.parent().width();
				var $customStyle = $('<style>[data-id="' + uuid + '"] .bx-wrapper { width: ' + elemWidth + 'px; } </style>');
				this.$ctx.prepend($customStyle);
			}

			this.initSlider();
			// controls only exist after slider is initialized.
			mod.controls = mod.$ctx.find('.bx-controls');
			mod.addEventListeners();

			mod.$ctx.removeClass('not-initialized');

			callback();
		},

		initSlider: function () {
			var options = {
				pause: (this.animationInterval * 1000),
				speed: 300,
				startSlide: this.startIndex,
				infiniteLoop: this.loopAround,
				auto: (this.animationInterval > 0),
				preloadImages: 'visible',
				hideControlOnEnd: true,
				nextText: '',
				prevText: '',
				touchEnabled: this.controlsEnabled && this.isMobile,
				useCSS: false, // true will kill the loop around feature.
				responsive: true,
				adaptiveHeight: false,
				onSlideBefore: $.proxy(this.handleBeforeSlide, this),
				onSliderLoad: $.proxy(this.lazyLoadFirstItem, this)
			};

			if (this.deepLinking && this.sliderId) {
				options.onSlideAfter = $.proxy(this.setDeepLink, this);
			}

			this.slider = $('ul.bx-slider', this.$ctx).bxSlider(options);
		},

		lazyLoadFirstItem: function () {
			var index = this.startIndex,
				mod = this;
			// bx slider in infinite loop mode, will clone the first and last item
			if (mod.loopAround) {
				// let's preload the cloned elements to allow for smooth looping transition.
				mod.$ctx.find('.bx-clone').each(function () {
					mod.handleBeforeSlide($(this));
				});
			}

			mod.handleBeforeSlide(mod.slides.eq(index));
			// make sure the initialization ends first.
			this.componentInitialized = true;
			setTimeout(function () {
				mod.fire('sliderSlideInitialized', {index: mod.startIndex, sliderId: mod.sliderId, slideId: mod.slides.eq(index).data('id')}, ['SLIDER']);
				if (!mod.disableTracking && !mod.animationInterval && mod.slides.length > 1) {
					mod.trackingStarted = true;
					if (SCS && SCS.portal && SCS.portal.datalayer) {
						SCS.portal.datalayer.trackEvent(TRACKING_EVENT_ACTION, mod.slides.eq(index).data('event-label'), mod.trackingLocation, TRACKING_EVENT_CATEGORY);
					}
				}
			}, 0);
		},

		/**
		 * Lazy load all images just before switching to new slide.
		 * @param $slideElement
		 * @param oldIndex
		 * @param newIndex
		 */
		handleBeforeSlide: function ($slideElement, oldIndex, newIndex) {
			var image = $slideElement.find('img');

			if (image.length) {
				if (!this.isMobile) {
					this.stopAllVideos();
					this.loadVideo(image);
				}

				this.loadImage(image);
			}

			this.fireSliderSlideChanged($slideElement.data('id'), newIndex);
		},

		/**
		 * lazy load the image if the image does not have a src set yet.
		 * @param image
		 */
		loadImage: function (image) {
			var url;

			if (image.attr('src').length === 0) {
				if (this.isMobile) {
					url = image.data('m-image') ? image.data('m-image') : image.data('d-image');
				} else {
					url = image.data('d-image');
				}

				image.attr('src', url).one('load', $.proxy(this.handleResize, this));
			}
		},

		loadVideo: function (image) {
			var videoUrl = image.data('video'),
				mod = this,
				disableLoop = image.data('disable-loop'),
				showPoster = image.data('show-poster');

			if (image.parent().is('video')) {
				this.unPauseVideo(image.parent().get(0));
			}
			else if (videoUrl && videoUrl.length > 0) {
				var url;
				if (showPoster) {
					if (this.isMobile) {
						url = image.data('m-image') ? image.data('m-image') : image.data('d-image');
					} else {
						url = image.data('d-image');
					}
				}
				image.wrap('<video muted="muted" ' + (disableLoop ? '' : 'loop="true"') +
					(showPoster ? ' poster="' + url + '"' : '') +
					' src="' + videoUrl + '"></video>');
				// loop = true, for browser that support that attribute, like safari iPad
				// for browsers that don't support the loop attribute, wait for the ended event and restart.
				// loop = true will loop before calling the ended event, hence this will never be called in that case.
				if(!disableLoop) {
					image.parent('video').on('ended', function () {
						mod.playVideoFromStart(this);
					});
				}
				// update video list
				this.videos = this.$ctx.find('video');

				this.playVideoFromStart(image.parent().get(0));
			}
		},

		stopAllVideos: function () {
			if (this.videos) {
				this.videos.each(function () {
					this.pause();
				});
			}
		},

		playVideoFromStart: function (videoDomEl) {
			videoDomEl.load();
			videoDomEl.play();
		},

		unPauseVideo: function (videoDomEl) {
			videoDomEl.play();
		},

		handleResize: function () {
			this.redraw();
		},

		handleOrientationChange: function () {
			if (this.slider) {
				this.slider.parent().css('height', 'auto');
				this.redraw();
			}
		},

		handleMouseEnter: function () {
			this.showHideControl(0, 300, 1);
			this.startStopAutoPlay(false);
		},

		handleMouseLeave: function () {
			this.showHideControl(750, 500, 0);
			this.startStopAutoPlay(true);
		},

		handleTouchStart: function () {
			this.showHideControl(0, 100, 1, 150);
			this.startStopAutoPlay(false);
		},

		handleTouchEnd: function () {
			this.showHideControl(500, 350, 0, 150);
			this.startStopAutoPlay(true);
		},

		handleVideoVolume: function (event) {
			var button = $(event.currentTarget),
				slide = button.closest('.modSlide'),
				video = slide.find('video').eq(0).get(0);

			if (button.is('.video-volume-off') || button.is('.video-volume-on')) {
				video.muted = !video.muted;
				button.addClass('hidden');
				button.siblings('button').removeClass('hidden');
			}
		},

		startStopAutoPlay: function (startAuto) {
			if (!this.animationInterval || this.animationInterval <= 0) {
				return;
			}

			if (startAuto) {
				this.slider.startAuto();
			}
			else {
				this.slider.stopAuto();
			}
		},

		setDeepLink: function ($sliderItem, oldIndex, newIndex) {
			SCS.HashDeepLink.set(this.sliderId, (newIndex + 1));
		},

		/**
		 * Does the show hide animation of the controls ui.
		 * @param delay - in ms
		 * @param duration - in ms
		 * @param alpha - from 0 - 1
		 * @param startDelay - in ms
		 */
		showHideControl: function (delay, duration, alpha, startDelay) {
			var mod = this;
			startDelay = startDelay || 0;
			if (this.controlsEnabled) {
				setTimeout(function () {
					mod.controls.stop(true).delay(delay).fadeTo(duration, alpha);
				}, startDelay);
			}
		},

		addEventListeners: function () {
			if (!this.noControlsFadeout) {
				this.$ctx.on('mouseenter', $.proxy(this.handleMouseEnter, this));
				this.$ctx.on('mouseleave', $.proxy(this.handleMouseLeave, this));

				$(document.body).on('touchstart', $.proxy(this.handleTouchStart, this));
				$(document.body).on('touchend', $.proxy(this.handleTouchEnd, this));
			}

			if (!this.isMobile) {
				$(window).on('resize', $.proxy(this.handleResize, this));
			} else {
				$(window).on('orientationchanged', $.proxy(this.handleOrientationChange, this));
			}


			// Redraw slider after all slider images are (lazy)loaded
			Promise.all(this.$ctx.find('img').get().map(imageLoaded)).then(this.redraw.bind(this, true));

			this.videoVolume.on('click', '.video-volume-on, .video-volume-off', $.proxy(this.handleVideoVolume, this));
		},

		/**
		 * Find the slide with slideId and make it the active slide
		 * @param slideId
		 */
		gotoSlideWithId: function (slideId) {
			var mod = this;
			if (slideId) {
				mod.slides.each(function (index, slide) {
					if ($(slide).data('id') === slideId) {
						mod.slider.goToSlide(index);
						mod.fireSliderSlideChanged(slideId, index);
						return false;
					}
				});
			}
		},

		/**
		 * Fires Terrific event sliderSlideChanged
		 *
		 * @param slideId string
		 * @param newIndex number
		 */
		fireSliderSlideChanged: function (slideId, newIndex) {
			this.fire('sliderSlideChanged', {index: newIndex, sliderId: this.sliderId, slideId: slideId}, ['SLIDER']);
			if (this.trackingStarted) {
				if (SCS && SCS.portal && SCS.portal.datalayer) {
					SCS.portal.datalayer.trackEvent(TRACKING_EVENT_ACTION, this.slides.eq(newIndex).data('event-label'), this.trackingLocation, TRACKING_EVENT_CATEGORY);
				}
			}
		},

		/**
		 * Terrific message handler to auto scroll to slide
		 * @param data      requires a slideId attribute, that is either e single slideId or an array of slideIds
		 */
		onSliderGotoSlide: function (data) {
			var mod = this;
			var slideId = data.slideId;

			if (slideId) {
				if ($.isArray(slideId)) {
					for (var i = 0; i < slideId.length; i += 1) {
						mod.gotoSlideWithId(slideId[i]);
					}
				}
				else if ($.type(slideId) === 'string') {
					mod.gotoSlideWithId(slideId);
				}
			}
		},

		redraw: function(lazy) {
			var mod = this;
			if (this.slider) {
				var redraw = function() {
					mod.$ctx.addClass('redrawing');
					mod.$ctx.find('.bx-viewport').css('height', '');
					mod.slider.parent().css('height', 'auto');
					mod.slider.redrawSlider();
					mod.$ctx.removeClass('redrawing');
				}
				if (lazy) {
					// Clear pending timer
					if (this.redrawDebounceTimer) {
						clearTimeout(this.redrawDebounceTimer);
					}
					this.redrawDebounceTimer = setTimeout(redraw, 50);
				} else {
					redraw();
				}
			}
		}
	});
})(__webpack_provided_window_dot_Tc_dot_$, window.Tc, window.SCS = window.SCS || {});

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, Tc) {
	'use strict';
	/**
	 * Skin for rotating teaser theme of the slider.
	 * Implemented as part of the new story project
	 *
	 * @author Matthias Inauen
	 * @namespace Tc.Module.Slider
	 * @class RotatingTeaser
	 * @extends Tc.Module
	 * @constructor
	 */
	Tc.Module.Slider.RotatingTeaser = function(parent) {

		this.on = function(callback) {
			parent.on.call(this, callback);
		};

		/**
		 * Find the closest sibling slide that is not disabled
		 * and activate that slide instead.
		 * @param $slide
		 */
		this.activateNextEnabledSibling = function($slide){
			var mod = this;
			var siblingVicinity;
			var $sibling;

			$slide.siblings(':not(.disabled)').each(function(index, sibling){
				var vicinity = Math.abs(mod.slides.index($(sibling)) - mod.slides.index($slide));
				if(!siblingVicinity || vicinity < siblingVicinity) {
					siblingVicinity = vicinity;
					$sibling = $(sibling);
				}
			});

			if($sibling && $sibling.length){
				mod.gotoSlideWithId($sibling.data('id'));
			}
			else {
				// disable whole slider
			}
		};

		this.after = function(){
			var delayTime = this.isMobile ? 1500 : 150;

			setTimeout($.proxy( this.setSliderHeight, this), delayTime);

			if(this.isMobile){
				$(window).on('load', $.proxy(this.setSliderHeight, this));
			}
		};

		this.initSlider = function () {
			this.controlsEnabled = this.isMobile;
			this.$ctx.toggleClass('no-controls', !this.controlsEnabled);

			var options = {
				pause: (this.animationInterval * 1000),
				speed: 240,
				startSlide: this.startIndex,
				infiniteLoop: this.loopAround,
				auto: (this.animationInterval > 0),
				preloadImages: 'visible',
				hideControlOnEnd: false,
				nextText: '',
				prevText: '',
				touchEnabled: this.isMobile,
				swipeThreshold: 50,
				useCSS: false, // has to be off, bx slider can not handle end-off animation in transitions, which will break the slider
				responsive: true,
				adaptiveHeight: false,
				onSlideBefore: $.proxy(this.handleBeforeSlide, this),
				onSlideAfter: this.handleAfterSlide.bind(this),
				onSliderLoad: $.proxy(this.cleanupSliderOnLoad, this),
				slideWidth: this.isMobile ? 280 : 300
			};

			if(this.deepLinking && this.sliderId) {
				options.onSlideAfter = $.proxy(this.setDeepLink, this);
			}

			this.slider = $('ul.bx-slider', this.$ctx).bxSlider(options);

			// Fix width 100% -> 100px problem
			if(this.slider.getCurrentSlideElement().width() < options.slideWidth){
				this.slider.children().css('width', options.slideWidth);

				// Fix slider position
				this.slider.css('left', -(options.startSlide*options.slideWidth));
			}
		};

		this.handleAfterSlide = function($slideElement) {
			if($slideElement.hasClass('disabled') && $slideElement.hasClass('active')) {
				this.activateNextEnabledSibling($slideElement);
			}
		}

		this.handleBeforeSlide = function($slideElement) {
			var activeSlideIndex = $slideElement.index();
			var $slideContent = $slideElement.find('.slideContent');
			var paddingTotal = parseInt($slideContent.css('padding-left'), 10) + parseInt($slideContent.css('padding-right'), 10);


			this.slides.removeClass('active leftOfActive');
			$slideElement.addClass('active');

			$.each(this.slides, function(index, slide){
				var $slide = $(slide);
				var slideIndex = $slide.index();
				var stepsAway = (activeSlideIndex >= slideIndex) ? (activeSlideIndex - slideIndex) : (activeSlideIndex + 1 - slideIndex);

				$slide.find('.slideContent').css('margin-left', stepsAway * paddingTotal);
			});

			parent.handleBeforeSlide.call(this, $slideElement);
		};

		this.handleSlideClicked = function(event){
			var $slide = $(event.currentTarget);

			if(!$slide.hasClass('disabled')) {
				var slideIndex = this.slides.index($slide);
				this.slider.goToSlide(slideIndex);
			}
		};

		this.showHideControl = $.noop;

		this.cleanupSliderOnLoad = function () {
			var mod = this;
			// enable transitions
			mod.$ctx.find('.bx-viewport').addClass('cf').prop('style', '');
			mod.lazyLoadFirstItem();
			mod.$ctx.removeClass('not-initialized');
			setTimeout(function(){
				mod.$ctx.addClass('transitionsEnabled');
			}, 0);
		};

		this.addEventListeners = function(){
			this.enable();
			parent.addEventListeners.call(this);
		};

		this.disable = function() {
			this.slides.off('click', $.proxy(this.handleSlideClicked, this));
			this.$ctx.addClass('disabled');
		};

		this.enable = function() {
			if(!this.isMobile){
				this.slides.on('click', $.proxy(this.handleSlideClicked, this));
			}
			this.$ctx.removeClass('disabled');
		};

		this.setSliderHeight = function(){
			var biggestSlideHeight = 0;

			this.slides.each(function(index, slide){
				var $slide = $(slide);
				var $slideContent = $slide.find('.slideContent');

				biggestSlideHeight = Math.max($slideContent.height(), biggestSlideHeight);
			});

			this.slides.find('.slideContent').css('min-height', biggestSlideHeight);

			// set the height of the viewport, so the controls wont move around when changing slides.
			this.$ctx.find('.bx-wrapper').css('height', biggestSlideHeight);
			this.$ctx.css('height', biggestSlideHeight);
		};

		// fired by Tc.Module.LegoContainer
		this.onSliderToggleEnable = function(data) {
			if (this.sliderId === data.sliderId) {
				if (data.enable) {
					this.enable();
				}
				else {
					this.disable();
				}
			}
		};

		/**
		 * Message handler to enable/disable individual slides.
		 * @param data
		 */
		this.onSetSlideState = function(data) {
			var $slide = this.slides.filter('[data-id='+data.slideId+']');

			if(!$slide.length || !this.componentInitialized || ($slide.hasClass('disabled') && data.disable === true)) {
				return;
			}

			$slide.toggleClass('disabled', data.disable);
			// if this is the currently active slide, that we are disabling
			// it can't stay active anymore.
			if($slide.hasClass('active') && data.disable === true) {
				this.activateNextEnabledSibling($slide);
			}
		};
	};
})(__webpack_provided_window_dot_Tc_dot_$, window.Tc);

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
	"use strict";
	/*globals Tc, SCS */

	/**
	 * Page module implementation.
	 *
	 * @author Bozo Jovicic
	 * @namespace Tc.Module
	 * @class Twitter
	 * @extends Tc.Module
	 */

	Tc.Module.Twitter = Tc.Module.extend({

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this;

			callback();
		},

		after : function() {
			var mod = this;

			var tweetId = mod.$ctx.data('tweet-id');
			if(tweetId){
				var url = 'https://api.twitter.com/1/statuses/oembed.json?id=' + tweetId;
				var width = mod.$ctx.data('width');
				if(width){
					url += '&maxwidth=' + width;
				}

				$.getJSON(url + "&callback=?", null, function(res) {
					if(res && typeof(res.html) != "undefined") {
						mod.$ctx.find('.tweet').html(res.html);

						var tweetUrl = null;
						var resHtmlArray = res.html.split('\"');
						for (var i=0;i < resHtmlArray.length; i+=1) {
							if(resHtmlArray[i].indexOf('https://twitter.com/') > -1){
								tweetUrl = resHtmlArray[i];
							}
						}
						mod.$ctx.find('.tweet').closest('.image-post').data('url', tweetUrl);
					}
				});
			}
		}
	});

}(Tc.$));
}.call(window));

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Tc_dot_$) {/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, Tc) {
	'use strict';

	/**
	 * Add hash & querystring to link url
	 *
	 * @author Dimitri Sebeschuk
	 * @namespace Tc.Module
	 * @class LinkForwarder
	 * @extends Tc.Module
	 */
	Tc.Module.LinkForwarder = Tc.Module.extend({

		on: function (callback) {
			var mod = this;

			if (mod.$ctx.prop('tagName') === 'A') {
				mod.enhanceUrl(mod.$ctx);
			} else {
				mod.$ctx.find('a').each(function () {
					mod.enhanceUrl($(this));
				})
			}
			callback();
		},

		enhanceUrl: function (a) {
			var href = a ? a.attr('href') : '',
				url = href.split('?')[0],
				origSearch = a ? a.prop('search').substring(1) : '',
				origHash = a ? a.prop('hash') : '',
				query = window.location.search.length ? window.location.search : '';

			//add search
			query = query ? (origSearch ? query + '&' + origSearch : query) : (origSearch ? '?' + origSearch : '');
			//add hash
			query = query + (window.location.hash ? ( origHash ? window.location.hash + '&' + origHash : window.location.hash ) : ( origHash ? '#' + origHash : '' ));

			if (url && query) {
				a.attr('href', url + query);
			}
		}
	});

})(__webpack_provided_window_dot_Tc_dot_$, window.Tc);

}.call(window));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, SnabbdomPragma) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_load_snabbdom__ = __webpack_require__(14);

var TIMEOUT = 300;
var observer = new MutationObserver(mutationHandler);
var BROCKEN_NODES = ['body', 'blockquote', 'figure', 'td', 'details', 'dialog', 'fieldset', 'section', 'article', 'nav', 'aside'];
var warningTimeout;
var container;
var currentH1s;
var currentH1Count = -1;
function getContainer() {
    if (container) {
        return container;
    }
    container = document.createElement('div');
    container.setAttribute('class', 'sdx-container');
    $('body').prepend(container);
    return container;
}
function getH1() {
    var h1s = new Map();
    $('h1').each(function (_i, el) {
        var closest = getClosestBrockenNode(el);
        if (closest) {
            if (h1s.has(closest)) {
                h1s.get(closest).push(el);
            }
            else {
                h1s.set(closest, [el]);
            }
        }
    });
    return h1s;
}
function getClosestBrockenNode(el) {
    if (!el || !el.parentElement) {
        return null;
    }
    return BROCKEN_NODES.includes(el.parentElement.tagName.toLowerCase()) ? el.parentElement :
        getClosestBrockenNode(el.parentElement);
}
function getH1Count() {
    var count = 0;
    if (currentH1s.size === 0) {
        return count;
    }
    // Value is Array
    for (var _a = 0, _b = Array.from(currentH1s.values()); _a < _b.length; _a++) {
        var value = _b[_a];
        count = Array.isArray(value) && value.length > count ? value.length : count;
    }
    return count;
}
function getBody() {
    if (!getH1Count()) {
        return 'Attention, you forgot to define an H1 title.';
    }
    if (getH1Count() > 1) {
        return SnabbdomPragma.createElement("span", null,
            "Attention, you are not allowed to use more then one H1 title on this page, ",
            getH1Count(),
            " H1s were found",
            SnabbdomPragma.createElement("span", { className: "checkbox" },
                SnabbdomPragma.createElement("input", { type: "checkbox", name: "h1-highlight", id: "h1-highlight", value: "1", "data-role": "none" }),
                SnabbdomPragma.createElement("label", { for: "h1-highlight" }, "Highlight")));
    }
    return '';
}
function startObserve() {
    // Create an observer instance linked to the callback function
    observer.observe($('body')[0], { attributes: false, childList: true, subtree: true });
}
function closeWarning() {
    container = Object(__WEBPACK_IMPORTED_MODULE_0_bootstrap_load_snabbdom__["a" /* patch */])(getContainer(), SnabbdomPragma.createElement("div", null));
}
function toggleWarning() {
    currentH1s = getH1();
    if (currentH1Count === getH1Count()) {
        return;
    }
    currentH1Count = getH1Count();
    // Stop observer before update warning message
    observer.disconnect();
    if (currentH1Count !== 1) {
        $(document).trigger('h1-warning-show');
        container = Object(__WEBPACK_IMPORTED_MODULE_0_bootstrap_load_snabbdom__["a" /* patch */])(getContainer(), SnabbdomPragma.createElement("div", { className: "sdx-container h1-warning-container" },
            SnabbdomPragma.createElement("div", { className: "notification-header notification--alert notification--open" },
                SnabbdomPragma.createElement("div", { className: "notification__content" },
                    SnabbdomPragma.createElement("div", { className: "notification__body" }, getBody()),
                    SnabbdomPragma.createElement("button", { className: "notification__close notification-cancel", ariaLabel: "Close", "on-click": closeWarning },
                        SnabbdomPragma.createElement("i", { className: "icon icon-022-close", ariaHidden: "true" }))))));
        $('.h1-warning-container').on('click', '#h1-highlight', highlightHandler);
    }
    else {
        container = Object(__WEBPACK_IMPORTED_MODULE_0_bootstrap_load_snabbdom__["a" /* patch */])(getContainer(), SnabbdomPragma.createElement("div", { className: "sdx-container h1-warning-container" }));
        $(document).trigger('h1-warning-hide');
    }
    // Start observer after update warning message
    startObserve();
}
function highlightHandler(e) {
    var el = e.target;
    if (el.checked) {
        // Value is Array
        for (var _a = 0, _b = Array.from(currentH1s.values()); _a < _b.length; _a++) {
            var value = _b[_a];
            if (Array.isArray(value) && value.length > 1) {
                value.forEach(function (h1El) { return h1El.className += ' h1-warning-highlight'; });
            }
        }
    }
    else {
        $('h1').removeClass('h1-warning-highlight');
    }
}
function mutationHandler() {
    if (warningTimeout) {
        clearTimeout(warningTimeout);
    }
    warningTimeout = setTimeout(toggleWarning, TIMEOUT);
}
$(function () {
    if ($('body.h1Warning').length) {
        mutationHandler();
        startObserve();
    }
});

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(96)))

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElementWithModules", function() { return createElementWithModules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElement", function() { return createElement; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_extend__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_extend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_extend__);


var undefinedv = function (v) { return v === undefined; };

var number = function (v) { return typeof v === 'number'; };

var string = function (v) { return typeof v === 'string'; };

var text = function (v) { return string(v) || number(v); };

var array = function (v) { return Array.isArray(v); };

var object = function (v) { return typeof v === 'object' && v !== null; };

var fun = function (v) { return typeof v === 'function'; };

var vnode = function (v) { return object(v) && 'sel' in v && 'data' in v && 'children' in v && 'text' in v; };

var svgPropsMap = { svg: 1, circle: 1, ellipse: 1, line: 1, polygon: 1,
  polyline: 1, rect: 1, g: 1, path: 1, text: 1 };

var svg = function (v) { return v.sel in svgPropsMap; };

// TODO: stop using extend here
var extend = function () {
  var objs = [], len = arguments.length;
  while ( len-- ) objs[ len ] = arguments[ len ];

  return __WEBPACK_IMPORTED_MODULE_0_extend___default.a.apply(void 0, [ true ].concat( objs ));
};

var assign = function () {
  var objs = [], len = arguments.length;
  while ( len-- ) objs[ len ] = arguments[ len ];

  return __WEBPACK_IMPORTED_MODULE_0_extend___default.a.apply(void 0, [ false ].concat( objs ));
};

var reduceDeep = function (arr, fn, initial) {
  var result = initial;
  for (var i = 0; i < arr.length; i++) {
    var value = arr[i];
    if (array(value)) {
      result = reduceDeep(value, fn, result);
    } else {
      result = fn(result, value);
    }
  }
  return result
};

var mapObject = function (obj, fn) { return Object.keys(obj).map(
  function (key) { return fn(key, obj[key]); }
).reduce(
  function (acc, curr) { return extend(acc, curr); },
  {}
); };

var deepifyKeys = function (obj, modules) { return mapObject(obj,
  function (key, val) {
    var dashIndex = key.indexOf('-');
    if (dashIndex > -1 && modules[key.slice(0, dashIndex)] !== undefined) {
      var moduleData = {};
      moduleData[key.slice(dashIndex + 1)] = val;
      return ( obj = {}, obj[key.slice(0, dashIndex)] = moduleData, obj )
      var obj;
    }
    return ( obj$1 = {}, obj$1[key] = val, obj$1 )
    var obj$1;
  }
); };



var omit = function (key, obj) { return mapObject(obj,
  function (mod, data) { return mod !== key ? (( obj = {}, obj[mod] = data, obj )) : {}
    var obj; }
); };

// Const fnName = (...params) => guard ? default : ...

var createTextElement = function (text$$1) { return !text(text$$1) ? undefined : {
  text: text$$1,
  sel: undefined,
  data: undefined,
  children: undefined,
  elm: undefined,
  key: undefined
}; };

var considerSvg = function (vnode$$1) { return !svg(vnode$$1) ? vnode$$1 :
  assign(vnode$$1,
    { data: omit('props', extend(vnode$$1.data,
      { ns: 'http://www.w3.org/2000/svg', attrs: omit('className', extend(vnode$$1.data.props,
        { class: vnode$$1.data.props ? vnode$$1.data.props.className : undefined }
      )) }
    )) },
    { children: undefinedv(vnode$$1.children) ? undefined :
      vnode$$1.children.map(function (child) { return considerSvg(child); })
    }
  ); };

var rewrites = {
  for: 'attrs',
  role: 'attrs',
  tabindex: 'attrs',
  'aria-*': 'attrs',
  key: null
};

var rewriteModules = function (data, modules) { return mapObject(data, function (key, val) {
  var inner = {};
  inner[key] = val;
  if (rewrites[key] && modules[rewrites[key]] !== undefined) {
    return ( obj = {}, obj[rewrites[key]] = inner, obj )
    var obj;
  }
  if (rewrites[key] === null) {
    return {}
  }
  var keys = Object.keys(rewrites);
  for (var i = 0; i < keys.length; i++) {
    var k = keys[i];
    if (k.charAt(k.length - 1) === '*' && key.indexOf(k.slice(0, -1)) === 0 && modules[rewrites[k]] !== undefined) {
      return ( obj$1 = {}, obj$1[rewrites[k]] = inner, obj$1 )
      var obj$1;
    }
  }
  if (modules[key] !== undefined) {
    return ( obj$2 = {}, obj$2[modules[key] ? modules[key] : key] = val, obj$2 )
    var obj$2;
  }
  if (modules.props !== undefined) {
    return { props: inner }
  }
  return inner
}); };

var sanitizeData = function (data, modules) { return considerSvg(rewriteModules(deepifyKeys(data, modules), modules)); };

var sanitizeText = function (children) { return children.length > 1 || !text(children[0]) ? undefined : children[0]; };

var sanitizeChildren = function (children) { return reduceDeep(children, function (acc, child) {
  var vnode$$1 = vnode(child) ? child : createTextElement(child);
  acc.push(vnode$$1);
  return acc
}
, []); };

var defaultModules = {
  attrs: '',
  props: '',
  class: '',
  data: 'dataset',
  style: '',
  hook: '',
  on: ''
};

var createElementWithModules = function (modules) {
  return function (sel, data) {
    var children = [], len = arguments.length - 2;
    while ( len-- > 0 ) children[ len ] = arguments[ len + 2 ];

    if (fun(sel)) {
      return sel(data || {}, children)
    }
    var text$$1 = sanitizeText(children, modules);
    return considerSvg({
      sel: sel,
      data: data ? sanitizeData(data, modules) : {},
      children: text$$1 ? undefined : sanitizeChildren(children),
      text: text$$1,
      elm: undefined,
      key: data ? data.key : undefined
    })
  }
};

var createElement = createElementWithModules(defaultModules);

var index = {
  createElement: createElement,
  createElementWithModules: createElementWithModules
};

/* harmony default export */ __webpack_exports__["default"] = (index);


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasOwn = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var defineProperty = Object.defineProperty;
var gOPD = Object.getOwnPropertyDescriptor;

var isArray = function isArray(arr) {
	if (typeof Array.isArray === 'function') {
		return Array.isArray(arr);
	}

	return toStr.call(arr) === '[object Array]';
};

var isPlainObject = function isPlainObject(obj) {
	if (!obj || toStr.call(obj) !== '[object Object]') {
		return false;
	}

	var hasOwnConstructor = hasOwn.call(obj, 'constructor');
	var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
	// Not own constructor property must be Object
	if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
		return false;
	}

	// Own properties are enumerated firstly, so to speed up,
	// if last one is own, then all properties are own.
	var key;
	for (key in obj) { /**/ }

	return typeof key === 'undefined' || hasOwn.call(obj, key);
};

// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var setProperty = function setProperty(target, options) {
	if (defineProperty && options.name === '__proto__') {
		defineProperty(target, options.name, {
			enumerable: true,
			configurable: true,
			value: options.newValue,
			writable: true
		});
	} else {
		target[options.name] = options.newValue;
	}
};

// Return undefined instead of __proto__ if '__proto__' is not an own property
var getProperty = function getProperty(obj, name) {
	if (name === '__proto__') {
		if (!hasOwn.call(obj, name)) {
			return void 0;
		} else if (gOPD) {
			// In early versions of node, obj['__proto__'] is buggy when obj has
			// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
			return gOPD(obj, name).value;
		}
	}

	return obj[name];
};

module.exports = function extend() {
	var options, name, src, copy, copyIsArray, clone;
	var target = arguments[0];
	var i = 1;
	var length = arguments.length;
	var deep = false;

	// Handle a deep copy situation
	if (typeof target === 'boolean') {
		deep = target;
		target = arguments[1] || {};
		// skip the boolean and the target
		i = 2;
	}
	if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
		target = {};
	}

	for (; i < length; ++i) {
		options = arguments[i];
		// Only deal with non-null/undefined values
		if (options != null) {
			// Extend the base object
			for (name in options) {
				src = getProperty(target, name);
				copy = getProperty(options, name);

				// Prevent never-ending loop
				if (target !== copy) {
					// Recurse if we're merging plain objects or arrays
					if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
						if (copyIsArray) {
							copyIsArray = false;
							clone = src && isArray(src) ? src : [];
						} else {
							clone = src && isPlainObject(src) ? src : {};
						}

						// Never move original objects, clone them
						setProperty(target, { name: name, newValue: extend(deep, clone, copy) });

					// Don't bring in undefined values
					} else if (typeof copy !== 'undefined') {
						setProperty(target, { name: name, newValue: copy });
					}
				}
			}
		}
	}

	// Return the modified object
	return target;
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_$) {(function ($, SCS, debug) {
	"use strict";
	// jshint camelcase: false

	var getPagePath = __webpack_require__(99).getPagePath;

	/**
	 * The page object according to the specifications
	 * @returns {Page}
	 * @constructor
	 */
	var Page = function () {
		$.extend(this, {
			init: function (path, language, cfu, viewtype, template) {
				SCS.portal.datalayer.originalPagePath = this.path = path || "";
				this.language = language || "";
				this.cfu = cfu || "";
				this.charset = "utf-8";
				this.viewtype = viewtype || "";
				this.template = template || "";
				this.pagetype = ""; // intentionally left empty
			}
		});
		//noinspection JSUnresolvedVariable
		this.init.apply(this, arguments);
		return this;
	};

	/**
	 * The platform object according to the specifications
	 * @returns {Platform}
	 * @constructor
	 */
	var Platform = function () {
		$.extend(this, {
			init: function (platform, environment) {
				this.platform = platform || "";
				this.environment = environment || "";
				this.context = "online";
			}
		});
		//noinspection JSUnresolvedVariable
		this.init.apply(this, arguments);
		return this;
	};

	/**
	 * The product object according to the specifications
	 * @returns {Product}
	 * @constructor
	 */
	var Product = function () {
		$.extend(this, {
			init: function (id, key, name) {
				this.id = id || "";
				this.key = key || "";
				this.name = name || "";
			}
		});
		//noinspection JSUnresolvedVariable
		this.init.apply(this, arguments);
		return this;
	};

	/**
	 * The product object according to the specifications
	 * @returns {Category}
	 * @constructor
	 */
	var Category = function () {
		$.extend(this, {
			init: function (name, value) {
				this.name = name || "";
				this.value = value || "";
			}
		});
		//noinspection JSUnresolvedVariable
		this.init.apply(this, arguments);
		return this;
	};

	/**
	 * Adds a product category to the currently(!) viewed product's Category list
	 */
	Product.prototype.withCategory = function (key, value) {
		if (key && value) {
			this.productCategory_list = this.productCategory_list || [];
			this.productCategory_list.push(new Category(key, value));
		}
		return this;
	};

	/**
	 * The Conversion object according to the specifications
	 * @see https://wiki.swisscom.com/pages/viewpage.action?spaceKey=TAG&title=Online+Data+Layer+Platform+Integration#OnlineDataLayerPlatformIntegration-Conversion
	 * @returns {Conversion}
	 * @constructor
	 */
	var Conversion = function () {
		$.extend(this, {
			init: function (category, detail, _class) {
				this.category = category || "";
				this.detail = detail || "";
				this['class'] = _class;
			}
		});
		//noinspection JSUnresolvedVariable
		this.init.apply(this, arguments);
		return this;
	};

	/**
	 * The link and conversion tracking event.
	 * @returns {Event}
	 * @constructor
	 */
	var Event = function () {
		$.extend(this, {
			init: function (action, label, location, category, linkName) {
				this.action = action || "";
				this.label = label || "";
				this.location = location || "";
				this.category = category || "";
				if (linkName) {
					this.linkName = linkName;
				}
			}
		});
		//noinspection JSUnresolvedVariable
		this.init.apply(this, arguments);
		return this;
	};

	/**
	 * The link and conversion tracking event.
	 * @returns {Interaction}
	 * @constructor
	 */
	var Interaction = function () {
		$.extend(this, {
			init: function () {
			}
		});
		//noinspection JSUnresolvedVariable
		this.init.apply(this, arguments);
		return this;
	};

	/**
	 * Set event information. Either conversion information OR event information can be set
	 * @param action
	 * @param label
	 * @param location
	 * @param category
	 * @param linkName
	 * @returns {Interaction}
	 */
	Interaction.prototype.withEvent = function (action, label, location, category, linkName) {
		this.event = new Event(action, label, location, category, linkName);
		return this;
	};

	/**
	 * Set conversion information. Either conversion information OR event information can be set
	 * @param conversionCategory
	 * @param conversionDetail
	 * @param conversionClass
	 * @returns {Interaction}
	 */
	Interaction.prototype.withConversion = function (conversionCategory, conversionDetail, conversionClass) {
		if (conversionCategory && conversionDetail) {
			this.conversion = new Conversion(conversionCategory, conversionDetail, conversionClass || "");
		} else {
			debug.log("SCS.portal.datalayer.js > withConversion > conversionCategory and Detail are mandatory in Conversion objects");
		}
		return this;
	};

	/**
	 *
	 * @param rawdata
	 * @returns {Interaction}
	 * Make sure event is set before calling this
	 */
	Interaction.prototype.withRawData = function (rawdata) {
		if (typeof this.event !== "undefined") {
			this.event.rawdata = rawdata;
		}
		return this;
	};

	Interaction.prototype.withProfile = function (profile) {
		this.profile = profile;
		return this;
	};

	Interaction.prototype.withProduct = function (product) {
		this.product = product;
		return this;
	};

	/**
	 * Fires the click Interaction. The action/label/location/category must always be set, even for the conversion tracking
	 */
	Interaction.prototype.track = function () {
		if (!SCS.datalayer || !SCS.datalayer.track) {
			debug.log("Cannot track event, SCS Datalayer not available at this time. Please check whether utag.sync.js has been loaded");
			return;
		}

		if (this.event && this.conversion) {
			debug.log("SCS.portal.datalayer.js > track > Warning: event and conversion set at the same time!");
		}

		// in order to not permanently add the event and avoid side effects on multiple
		// user interactions, we clone the existing trackObj to not modify it
		var dataObj = $.extend(true, {}, SCS.portal.datalayer.trackObj);

		// transfer all set props in data object
		for (var prop in this) {
			if (this.hasOwnProperty(prop) && typeof this[prop] !== "function") {
				dataObj[prop] = this[prop];
			}
		}

		// delegating tracking call to Tealium
		debug.log('SCS.portal.datalayer.js > Interaction > track', dataObj);
		SCS.datalayer.track(dataObj);
	};

	/**
	 * User information (currently only login status)
	 * @returns {Profile}
	 * @constructor
	 */
	var Profile = function (user) {
		$.extend(this, {
			init: function () {
				this.loggedIn = user ? "login" : "";
				if (user.getSegment()) {
					this.cfu = user.getSegment();
				}
			}
		});

		//noinspection JSUnresolvedVariable
		this.init.apply(this, arguments);
		return this;
	};

	/**
	 * The product object according to the specifications
	 * @returns {Cart}
	 * @constructor
	 */
	var Cart = function () {
		$.extend(this, {
			init: function (ordertotal) {
				this.ordertotal = new Number(parseFloat(ordertotal)).valueOf() || 0.0;
			}
		});
		//noinspection JSUnresolvedVariable
		this.init.apply(this, arguments);
		return this;
	};



	/**
	 * Namespace for Tealium related functionality
	 */
	SCS.portal = SCS.portal || {};
	SCS.portal.datalayer = {

		// This ist the basic data to be sent to Tealium. Will be enriched with various sub-objects, e.g. page and platform which are mandatory.
		// Whenever there is event tracking, e.g. click tracking using the Interaction.track function this data will be cloned as template
		trackObj: {},

		// flag indicating whether the page should track automatically or an explicit SCS.portal.datalayer.trackPageView has to be called.
		// e.g. true on product detail pages that first need to load product data from the ecommerce backend
		// may become obsolete with the new Hybris implementation
		isDeferred: false,

		//Set as soon as the initialize method has been called
		initialized: false,

		// stores the original trackObj.page.path value before it's extended e.g. used for click tracking tabs when the current tab
		// name shall be appended to page path
		originalPagePath: "",

		// used together with aforementioned originalPagePath for temporarily adding new page.path elements
		appendedPagePaths: [],

		/**
		 * Initialization function
		 *
		 * Depending on the 'deferred' parameter tracking data object is instantiated in the datalayer.
		 * If the page shall manage its own page view tracking, call the function with 'deferred' set to true
		 * but be aware that you will need to fire SCS.portal.datalayer.trackPageView when the page is ready loaded.
		 * A sample use case for this behavior are e.g. the product detail pages with the datahub where further product
		 * information needs assembled first before explicitly firing the tracking call
		 */
		initializeTrackingData: function (path, lang, cfu, viewtype, template, platform, environment, deferred) {
			var mod = this;
			debug.log("SCS.portal.datalayer.initializeTrackingData", arguments);
			this.isDeferred = deferred;
			this.initialized = true;

			// initialize mandatory page and platform data
			this.trackObj = {
				page: new Page(path, lang, cfu, viewtype, template),
				platform: new Platform(platform, environment)
			};

			__webpack_require__(15).getProfile().then(function(profile) {
				var user = profile.getUser();
				if(user) {
					mod.trackObj.profile = new Profile(user);
				}
			});
		},

		/**
		 * Check if the user is logged in
		 * @returns {string} "" or "login"
		 * @deprecated use lib/personalization/profile.ts
		 */
		isLoggedIn: function () {
			return (this.trackObj.profile && this.trackObj.profile.loggedIn) || "";
		},

		/**
		 * Set the optional page type
		 * @param pageType value from the pageType dropdown in page properties
		 */
		setPageType: function (pageType) {
			if (pageType) {
				this.trackObj.page.type = pageType;
			}
		},

		/**
		 * Sets the product in the tracking object. This contains the initially viewed product when opening the page
		 */
		setProduct: function (id, key, name, CategoryMaster, Category2, productBrand) {
			this.trackObj.product = this.createProduct(id, key, name, CategoryMaster, Category2, productBrand);
		},

		/**
		 * ODL Getter for the current product
		 * @return {SCS.}
		 */
		getProduct: function () {
			return this.trackObj.product || {};
		},

		/**
		 * ODL Getter for the template
		 * @returns {string|*}
		 */
		getTemplate: function () {
			return this.trackObj.page.template || '';
		},

		/**
		 * Sets the conversion information in the tracking object.
		 */
		setConversion: function (category, detail, _class) {
			this.trackObj.conversion = new Conversion(category, detail, _class);
		},

		/**
		 * ODL Getter for the template
		 * @returns {string|*}
		 */
		setCart: function (ordertotal) {
			this.trackObj.cart = new Cart(ordertotal);
		},

		/**
		 * Sets a custom UDO parameter in the datalayer
		 * @param name
		 * @param value
		 */
		addUdoProperty: function (name, value) {
			this.trackObj.udo = this.trackObj.udo || {};
			this.trackObj.udo[name] = value;
		},

		/**
		 * Creates a Product
		 */
		createProduct: function (id, key, name, CategoryMaster, Category2, productBrand) {
			return new Product(id, key, name)
				.withCategory("ProductCategoryMaster", CategoryMaster)
				.withCategory("ProductCategory2", Category2)
				.withCategory("Brand", productBrand);
		},

		/**
		 * Empties the current product_list
		 */
		resetProductList: function () {
			this.trackObj.product_list = [];
		},

		/**
		 * Adds an InOne product to the product_list.
		 * @param siebelName aka siebelId when it is actually the siebelName we're working with since the siebelId is environment dependent, like a primary database key
		 * @param {String} price the price
		 * @param {String} type can be either "bundle" or "flavour"
		 */
		addInOneProduct: function (siebelName, price, type) {
			if (!siebelName || !type || !/^(bundle|flavour)$/.test(type)) {
				debug.log("SCS.portal.datalayer.js > addInOneProduct > invalid type", type);
			} else {
				this.trackObj.product_list = this.trackObj.product_list || [];
				var product = new Product(siebelName, siebelName).withCategory("inOne", type);
				product.quantity = 1;
				product.priceRecurring = price || 0;
				this.trackObj.product_list.push(product);
			}
		},

		/**
		 * Queues a page view event to track a page view.
		 * Note that there will be an automatic implicit call on page load
		 */
		trackPageView: function () {
			var mod = this;
			// Wait until profile is available
			__webpack_require__(15).getProfile().then(function(profile) {
				if (window.SCS && window.SCS.datalayer && window.SCS.datalayer.page) {
					// delegate tracking call to Tealium
					SCS.datalayer.page(mod.trackObj, mod.isDeferred);
				} else {
					debug.log('SCS.datalayer.page not available, utag.sync.js not loaded?');
				}
			});
		},

		/**
		 * Fires a standard click Interaction with the default parameter set.
		 * If you wish to add more information like product or profile information,
		 * create a new Interaction and use the appropriate chaining methods, e.g.
		 * .withRawData(...) in combination with .track() to send the event manually.
		 * @param action the event action
		 * @param label the event label
		 * @param location the event location
		 * @param category the event category
		 * @param linkName the friendly name of the event/link (appears in SiteCatalyst link tracking reports)
		 */
		trackEvent: function (action, label, location, category, linkName) {
			if (action && label && location && category) {
				var interaction = new Interaction()
					.withEvent(action, label, location, category, linkName);
				interaction.track();
			}
		},

		/**
		 * Track a user conversion
		 * @param conversionCategory
		 * @param conversionDetail
		 * @param conversionClass
		 */
		trackConversion: function (conversionCategory, conversionDetail, conversionClass) {
			if (conversionCategory && conversionDetail) {
				var interaction = new Interaction()
					.withConversion(conversionCategory, conversionDetail, conversionClass);
				interaction.track();
			}
		},

		/**
		 * Appends an override to the current page page
		 * @param {string} value new path part to push on the stack
		 * @param {boolean} [popPreviousValue] whether to first remove the previous value on the stack. Defaults to false
		 * @param {boolean} [resetCompletely] whether to remove all items from the stack first. Defaults to false
		 * @param {string} [separator] optional separator when joining the path parts. Defaults to "/"
		 */
		pushPagePath: function (value, popPreviousValue, resetCompletely, separator) {

			// Check whether the previously added stack value is the same and if so abort. This may happen every once in a
			// while if components fire multiple times.
			if (this.appendedPagePaths.length > 0 && this.appendedPagePaths[this.appendedPagePaths.length - 1] === getPagePath(value)) {
				return false;
			}

			// Remove previous stack value
			if (popPreviousValue) {
				this.popPagePath();
			}

			// Remove all previous values from the stack
			if (resetCompletely) {
				this.appendedPagePaths = [];
			}

			this.appendedPagePaths.push(getPagePath(value));
			this.applyPagePath(separator);
			debug.log("SCS.portal.datalayer.js > pushPagePath > path is now ", this.trackObj.page.path);
			return true;
		},

		/**
		 * Removes an override from the current page path (last in, last out)
		 */
		popPagePath: function () {
			this.appendedPagePaths.pop();
			this.applyPagePath();
			debug.log("SCS.portal.datalayer.js > popPagePath > path is now ", this.trackObj.page.path);
		},

		/**
		 * Applys the page path overrides. This should not be called directly, but always using
		 * implicitly by calling pushPagePath and popPagePath
		 * @param {string} [separator] optional separator when joining the path parts. Defaults to "/"
		 */
		applyPagePath: function (separator) {
			separator = separator || '/';
			this.trackObj.page.path = this.originalPagePath;
			if (this.appendedPagePaths.length > 0) {
				this.trackObj.page.path += separator + this.appendedPagePaths.join(separator);
			}
		},

		/**
		 * Enable UX tracking (e.g. Clicktale) on Tealium side
		 * @param {boolean} value
		 */
		setUxTracking: function (value) {
			this.trackObj.apps = this.trackObj.apps || {};
			this.trackObj.apps.uxTracking = this.trackObj.apps.uxTracking || {};
			this.trackObj.apps.uxTracking.active = value;
		}

	};

	// export library classes
	SCS.portal.datalayer.Interaction = Interaction;

})(__webpack_provided_window_dot_$, window.SCS = window.SCS || {}, window.debug);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getPagePath"] = getPagePath;
/**
 * Making sure path is always a string and never undefined.
 * SCS.datalayer handels sanitization internally by
 * implicitly calling SCS.tealium.sanitizeString.
 *
 * @returns string
 */
function getPagePath(path) {
    if (typeof path === 'string') {
        return path;
    }
    if (path === undefined) {
        return window.location.pathname;
    }
    // Ok now we do the best we can...
    return String(path);
}


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_$) {/**
 * Created by Dimitri Sebeschuk on 04.05.17.
 *
 * Wrapper for CQ_Analytics.TestTarget
 * see: /etc/clientlibs/foundation/testandtarget/util/js.txt
 *
 * Fix "targetoffer" selector
 */
// jshint camelcase: false
(function (CQ_Analytics, CQ, SCS, $, debug) {
	'use strict';

	if (!CQ_Analytics || !CQ_Analytics.TestTarget || !CQ) {
		return;
	}

	var obj = CQ_Analytics.TestTarget;

	var origGet = CQ.shared.HTTP.get,
		origPull = obj.pull;

	SCS.TestTarget = SCS.TestTarget || {};

	SCS.TestTarget.transformProxyUrl = function (url) {
		var suffixIndex = url.indexOf('.html/'),
			baseUlr = suffixIndex > -1 ? url.substring(0, suffixIndex) : url,
			selectors = baseUlr.substring(baseUlr.indexOf('.'), baseUlr.lastIndexOf('.') + 1).split('.'),
			//support mobile selector in Browser
			mobile = $.inArray('mobile', selectors) !== -1 ? '.mobile' : '',
			basePath = baseUlr.indexOf('.') > -1 ? baseUlr.substring(0, baseUlr.indexOf('.')) : baseUlr,
			suffixUrl = suffixIndex > -1 ? url.substring(suffixIndex + 5) : '',
			suffixPath = suffixUrl.substring(0, suffixUrl.indexOf('.')),
			suffixSelectors = suffixUrl.substring(suffixUrl.indexOf('.'), suffixUrl.lastIndexOf('.') + 1).split('.'),
			query = window.location.search.indexOf('wcmmode=disabled') > 0 ? '?wcmmode=disabled' : '';

		if (suffixUrl.length === 0) {
			return basePath + mobile + '.scstargetoffer.html' + query;
		}

		selectors = selectors.filter(function (it) {
			return it !== 'mobile' && it !== 'targetoffer' && it.length > 0;
		});
		selectors = selectors.length > 0 ? '.' + selectors.join('.') : '';

		suffixSelectors = suffixSelectors.filter(function (it) {
			return it.length > 0;
		});
		//tandt selector or empty
		suffixSelectors = suffixSelectors.length > 0 ? '.' + suffixSelectors.join('.') : '';

		//sling on selectors to the suffix url
		return basePath + mobile + '.scstargetoffer.html' + suffixPath + suffixSelectors + selectors + '.html' + query;
	};

	/**
	 * Fetches the resource from provided path and writes the
	 * response to the document or the mbox Element if
	 *
	 * <ul>
	 * <li>response status code is 200</li>
	 * <li>response has a body with length > 0</li>
	 * </ul>
	 *
	 * Uses a synchronous call for requesting the resource. If a WCM mode is defined this
	 * call forces the resource to be rendered with WCM mode disabled.
	 *
	 * @static
	 * @param {String} path Path to document/node to request.
	 * @param {String} mboxName The name of the mbox that issued the request
	 */
	obj.pull = function (path, mboxName) {

		CQ.shared.HTTP.get = function (proxyUrl) {
			CQ.shared.HTTP.get = origGet;
			// pull in the content
			var output = origGet.call(this, SCS.TestTarget.transformProxyUrl(proxyUrl)),
				isOk = (output && output.status && output.status === 200),
				hasBody = (output && output.body && output.body.length > 0);

			if (isOk && !hasBody) {
				//try to get default content
				debug.warn('SCS Target -> pull(): The offer is not found, try to get default content.');
				if (typeof obj.defaults[mboxName] === 'undefined') {
					debug.error('SCS Target -> pull(): The default offer path was not found in the internal map for mbox ' + mboxName);
					return output;
				}
				var defaultContentPath = obj.defaults[mboxName],
					url = document.location.pathname,
					defaultProxyUrl = url + defaultContentPath;
				output = origGet.call(this, SCS.TestTarget.transformProxyUrl(defaultProxyUrl));
			}

			return output;
		};
		var result = origPull.apply(this, arguments);
		return result;
	};

	function onTargetDomLoaded(e) {
		if (!SCS || !SCS.utils || !SCS.utils.initNewModules) {
			return;
		}
		SCS.utils.initNewModules(e.target);
	}

	$('body').on('target-dom-loaded', onTargetDomLoaded);

})(window.CQ_Analytics, window.CQ, window.SCS = window.SCS || {}, __webpack_provided_window_dot_$, window.debug || window.console);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*!
 * jCarouselLite - v1.1 - 2014-09-28
 * http://www.gmarwaha.com/jquery/jcarousellite/
 * Copyright (c) 2014 Ganeshji Marwaha
 * Licensed MIT (https://github.com/ganeshmax/jcarousellite/blob/master/LICENSE)
 */

(function($) {                                          // Compliant with jquery.noConflict()
    $.jCarouselLite = {
        version: '1.1'
    };

    $.fn.jCarouselLite = function(options) {

        options = $.extend({}, $.fn.jCarouselLite.options, options || {});

        return this.each(function() {   // Returns the element collection. Chainable.

            var running,
                animCss, sizeCss,
                div = $(this), ul, initialLi, li,
                liSize, ulSize, divSize,
                numVisible, initialItemLength, itemLength, calculatedTo, autoTimeout;

            initVariables();                    // Set the above variables after initial calculations
            initStyles();                       // Set the appropriate styles for the carousel div, ul and li
            initSizes();                        // Set appropriate sizes for the carousel div, ul and li
            attachEventHandlers();              // Attach event handlers for carousel to respond

            function go(to) {
                if(!running) {
                    clearTimeout(autoTimeout);  // Prevents multiple clicks while auto-scrolling - edge case
                    calculatedTo = to;

                    if(options.beforeStart) {   // Call the beforeStart() callback
                        options.beforeStart.call(this, visibleItems());
                    }

                    if(options.circular) {      // If circular, and "to" is going OOB, adjust it
                        adjustOobForCircular(to);
                    } else {                    // If non-circular and "to" is going OOB, adjust it.
                        adjustOobForNonCircular(to);
                    }                           // If neither overrides "calculatedTo", we are not in edge cases.

                    animateToPosition({         // Animate carousel item to position based on calculated values.
                        start: function() {
                            running = true;
                        },
                        done: function() {
                            if(options.afterEnd) {
                                options.afterEnd.call(this, visibleItems());
                            }
                            if(options.auto) {
                                setupAutoScroll();
                            }
                            running = false;
                        }
                    });

                    if(!options.circular) {     // Enabling / Disabling buttons is applicable in non-circular mode only.
                        disableOrEnableButtons();
                    }

                }
                return false;
            }

            function initVariables() {
                running = false;
                animCss = options.vertical ? "top" : "left";
                sizeCss = options.vertical ? "height" : "width";
                ul = div.find(">ul");
                initialLi = ul.find(">li");
                initialItemLength = initialLi.length;

                // To avoid a scenario where number of items is just 1 and visible is 3 for example.
                numVisible = initialItemLength < options.visible ? initialItemLength : options.visible;

                if(options.circular) {
                    var $lastItemSet = initialLi.slice(initialItemLength-numVisible).clone();
                    var $firstItemSet = initialLi.slice(0,numVisible).clone();

                    ul.prepend($lastItemSet)        // Prepend the lis with final items so that the user can click the back button to start with
                        .append($firstItemSet);     // Append the lis with first items so that the user can click the next button even after reaching the end

                    options.start += numVisible;    // Since we have a few artificial lis in the front, we will have to move the pointer to point to the real first item
                }

                li = $("li", ul);
                itemLength = li.length;
                calculatedTo = options.start;
            }

            function initStyles() {
                div.css("visibility", "visible");   // If the div was set to hidden in CSS, make it visible now

                li.css({
                    overflow: "hidden",
                    "float": options.vertical ? "none" : "left" // Some minification tools fail if "" is not used
                });

                ul.css({
                    margin: "0",
                    padding: "0",
                    position: "relative",
                    "list-style": "none",
                    "z-index": "1"
                });

                div.css({
                    overflow: "hidden",
                    position: "relative",
                    "z-index": "2",
                    left: "0px"
                });

                // For a non-circular carousel, if the start is 0 and btnPrev is supplied, disable the prev button
                if(!options.circular && options.btnPrev && options.start == 0) {
                    $(options.btnPrev).addClass("disabled");
                }
            }

            function initSizes() {

                liSize = options.vertical ?         // Full li size(incl margin)-Used for animation and to set ulSize
                    li.outerHeight(true) :
                    li.outerWidth(true);
                ulSize = liSize * itemLength;       // size of full ul(total length, not just for the visible items)
                divSize = liSize * numVisible;      // size of entire div(total length for just the visible items)

                // Generally, LI's dimensions should be specified explicitly in a style-sheet
                // But in the case of img (with width and height attr), we can derive LI's dimensions and set here
                // May be applicable for other types of LI children if their dimensions are explicitly specified
                // Individual LI dimensions
                li.css({
                    width: li.width(),
                    height: li.height()
                });

                // Size of the entire UL. Including hidden and visible elements
                // Will include LI's (width + padding + border + margin) * itemLength - Using outerwidth(true)
                ul.css(sizeCss, ulSize+"px")
                    .css(animCss, -(calculatedTo * liSize));

                // Width of the DIV. Only the width of the visible elements
                // Will include LI's (width + padding + border + margin) * numVisible - Using outerwidth(true)
                div.css(sizeCss, divSize+"px");

            }

            function attachEventHandlers() {
                if(options.btnPrev) {
                    $(options.btnPrev).click(function() {
                        return go(calculatedTo - options.scroll);
                    });
                }

                if(options.btnNext) {
                    $(options.btnNext).click(function() {
                        return go(calculatedTo + options.scroll);
                    });
                }

                if(options.btnGo) {
                    $.each(options.btnGo, function(i, val) {
                        $(val).click(function() {
                            return go(options.circular ? numVisible + i : i);
                        });
                    });
                }

                if(options.mouseWheel && div.mousewheel) {
                    div.mousewheel(function(e, d) {
                        return d > 0 ?
                            go(calculatedTo - options.scroll) :
                            go(calculatedTo + options.scroll);
                    });
                }

                if(options.auto) {
                    setupAutoScroll();
                }
            }

            function setupAutoScroll() {
                autoTimeout = setTimeout(function() {
                    go(calculatedTo + options.scroll);
                }, options.auto);
            }

            function visibleItems() {
                return li.slice(calculatedTo).slice(0,numVisible);
            }

            function adjustOobForCircular(to) {
                var newPosition;

                // If first, then goto last
                if(to <= options.start - numVisible - 1) {
                    newPosition = to + initialItemLength + options.scroll;
                    ul.css(animCss, -(newPosition * liSize) + "px");
                    calculatedTo = newPosition - options.scroll;

                    console.log("Before - Positioned at: " + newPosition + " and Moving to: " + calculatedTo);
                }

                // If last, then goto first
                else if(to >= itemLength - numVisible + 1) {
                    newPosition = to - initialItemLength - options.scroll;
                    ul.css(animCss, -(newPosition * liSize) + "px");
                    calculatedTo = newPosition + options.scroll;

                    console.log("After - Positioned at: " + newPosition + " and Moving to: " + calculatedTo);
                }
            }

            function adjustOobForNonCircular(to) {
                // If user clicks "prev" and tries to go before the first element, reset it to first element.
                if(to < 0) {
                    calculatedTo = 0;
                }
                // If "to" is greater than the max index that we can use to show another set of elements
                // it means that we will have to reset "to" to a smallest possible index that can show it
                else if(to > itemLength - numVisible) {
                    calculatedTo = itemLength - numVisible;
                }

                console.log("Item Length: " + itemLength + "; " +
                    "To: " + to + "; " +
                    "CalculatedTo: " + calculatedTo + "; " +
                    "Num Visible: " + numVisible);
            }

            function disableOrEnableButtons() {
                $(options.btnPrev + "," + options.btnNext).removeClass("disabled");
                $( (calculatedTo-options.scroll<0 && options.btnPrev)
                    ||
                    (calculatedTo+options.scroll > itemLength-numVisible && options.btnNext)
                    ||
                    []
                ).addClass("disabled");
            }

            function animateToPosition(animationOptions) {
                running = true;

                ul.animate(
                    animCss == "left" ?
                    { left: -(calculatedTo*liSize) } :
                    { top: -(calculatedTo*liSize) },

                    $.extend({
                        duration: options.speed,
                        easing: options.easing
                    }, animationOptions)
                );
            }
        });
    };

    $.fn.jCarouselLite.options = {
        btnPrev: null,              // CSS Selector for the previous button
        btnNext: null,              // CSS Selector for the next button
        btnGo: null,                // CSS Selector for the go button
        mouseWheel: false,          // Set "true" if you want the carousel scrolled using mouse wheel
        auto: null,                 // Set to a numeric value (800) in millis. Time period between auto scrolls

        speed: 200,                 // Set to a numeric value in millis. Speed of scroll
        easing: null,               // Set to easing (bounceout) to specify the animation easing

        vertical: false,            // Set to "true" to make the carousel scroll vertically
        circular: true,             // Set to "true" to make it an infinite carousel
        visible: 3,                 // Set to a numeric value to specify the number of visible elements at a time
        start: 0,                   // Set to a numeric value to specify which item to start from
        scroll: 1,                  // Set to a numeric value to specify how many items to scroll for one scroll event

        beforeStart: null,          // Set to a function to receive a callback before every scroll start
        afterEnd: null              // Set to a function to receive a callback after every scroll end
    };

})(jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

/**
 * User: konstantin
 * Date: 4/23/14
 */
(function ($) {
    "use strict";
    /*globals Tc, doT, SCS, debug */
    /*jshint smarttabs:false */

    Tc.Module.Menu = Tc.Module.extend({

        config: {},

        on: function (callback) {
            var mod = this;

            mod.handleMenuIcon();

            callback();
        },

        handleMenuIcon: function () {
            var $ctx = this.$ctx;
            $('.menu_icon', $ctx).click(function () {
                if (scent.global.isMobile()) {
                    $('.mod-mainmenu').slideToggle("slow");
                }
            });
        },

        onEditionChange: function(data){
            this.$ctx.find('.het-edition').html(data.edition);
            this.$ctx.find('.het-year').html(data.year);
        }

    });
}(Tc.$));
}.call(window));

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

/**
 * User: konstantin
 * Date: 4/23/14
 */
(function ($) {
    "use strict";
    /*globals Tc, doT, SCS, debug */
    /*jshint smarttabs:false */

    Tc.Module.Mainmenu = Tc.Module.extend({

        config: {},

        on: function (callback) {
            var mod = this;

            mod.handleMainMenuLi();

            callback();
        },

        handleMainMenuLi: function () {
            var $ctx = this.$ctx;
            $('.mainmenu > li', $ctx).hover(
                function () {
                    if (!scent.global.isMobile()) {
                        $(this).find('ul').stop().animate({
                            height: "120px"
                        }, 200);
                    }
                },
                function () {
                    if (!scent.global.isMobile()) {
                        $(this).find('ul').stop().animate({
                            height: "0px"
                        }, 200);
                    }
                }
            );

            $('.mainmenu > li', $ctx).click(function () {
                if (scent.global.isMobile()) {
                    $(this).find('ul li').slideToggle("slow");
                    $(this).siblings().find('ul li').slideUp("slow");
                    $(this).find('a[href^="http"]').on('click', handler);
                    return false;
                }
            });
        }

    });
}(Tc.$));
}.call(window));

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

/**
 * User: konstantin
 * Date: 4/23/14
 */
(function ($) {
    "use strict";
    /*globals Tc, doT, SCS, debug */
    /*jshint smarttabs:false */

    Tc.Module.Metamenu = Tc.Module.extend({

        config: {},

        on: function (callback) {
            var mod = this;

            mod.handleSearch();
            mod.languageMenu();

            callback();
        },

        handleSearch: function () {
            var $ctx = this.$ctx;
            $('.js-searchico', $ctx).click(function (e) {
                e.preventDefault();
                if(!scent.global.isMobile()) {
                    $(this).hide();
                    $('.js-searchbox').slideToggle("slow");
                } else {
                    $('.search_ico').toggleClass('active');
                    $('.inputwrapper').slideToggle("slow");
                }
            });

            $('.quicksearch').keypress(function (e) {
                var code = e.keyCode ? e.keyCode : e.which;
                if (code.toString() == 13) {
                    var searchquery;
                    if(scent.global.isMobile()) {
                        searchquery = $('.searchquery').last().val();
                    } else {
                        searchquery = $('.searchquery').val();
                    }
                    window.location.hash = encodeURI(searchquery);
                    window.location = $('.searchurl').attr('value') + $('.suffix').attr('value') + '#q=' + encodeURI(searchquery);
                    if(window.location.href.indexOf("#q=") > -1){
                        window.location.reload();
                    }
                    return false;
                }
            });
        },

        languageMenu: function () {
            var $ctx = this.$ctx;
            $('.mod-menulanguage > .langswitch > a', $ctx).click(function (e) {
                if (scent.global.isMobile()) {
					e.preventDefault();
                    $('.mod-menulanguage .language_switch_dropdown').slideToggle("slow");
                }
            });
        }

    });
}(Tc.$));
}.call(window));

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var loadTerrific = __webpack_require__(1);
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($) {
    'use strict';
    /*globals Tc*/

    /**
     * Edition Navigation
     *
     * @author Zeljko Curcic
     * @namespace Tc.Module
     * @class Editionnavigation
     * @extends Tc.Module
     */
    Tc.Module.Editionnavigation = Tc.Module.extend({

        on: function (callback) {
            var mod = this;

            mod.$ctx.attr('id','EditionNav' + mod.id);
            mod.listItems = mod.$ctx.find('.carousel-list > li');
            mod.prevButtonSelector = '#' + mod.$ctx.attr('id') + ' .carousel-prev';
            mod.nextButtonSelector = '#' + mod.$ctx.attr('id') + ' .carousel-next';
            mod.carouselHeight = 0;
            mod.currentIndex = (mod.$ctx.data('current-index') > -1) ? mod.$ctx.data('current-index') : mod.listItems.length-1;
            mod.initiallyHidden = mod.$ctx.hasClass('hide');

            mod.initCarousel();

            mod.$ctx.on('click', '.close-button', function(e){
                e.preventDefault();
                mod.$ctx.addClass('hide');
                $('.link-editionnav').removeClass('active');
                $('.mod-content, .mod-article').removeClass('hide');
                mod.fire('editionChange', {'edition' : $('.header-edition-title').data('edition'), 'year' : $('.header-edition-title').data('year')}, ['editionnav']);
            });

            callback();
        },

        initCarousel: function(){
            var mod = this;

            if (mod.initiallyHidden) mod.$ctx.removeClass('hide');

            mod.$ctx.find('.carousel-clip').jCarouselLite({
                btnNext: mod.nextButtonSelector,
                btnPrev: mod.prevButtonSelector,
                visible: 1,
                circular: false,
                start: mod.currentIndex,
                afterEnd: function($current) {
                    mod.fire('editionChange', {'edition' : $current.data('issue'), 'year' : $current.data('year')}, ['editionnav']);
                }
            });

            if (mod.initiallyHidden) mod.$ctx.addClass('hide');
            if(mod.currentIndex >= mod.listItems.length -1 ) {
                $(mod.nextButtonSelector).addClass('disabled');
            }
        }
    });
}(Tc.$));
}.call(window));

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// apps/emagazine/ui/build/clientlibs/js/jcr_root/etc/designs/emagazine/clientlibs/xtra.min.js